(function() {
  'use strict';

  angular
    .module('inspinia', 
      [
        'ngAnimate', 
        'ngCookies', 
        'ngTouch', 
        'ngSanitize', 
        'ngMessages', 
        'ngAria', 
        'ngResource', 
        'ui.router',           
        'ui.bootstrap',
        'ngStorage',
        'ngMask',
        'toastr',
        'ui-leaflet',
        'summernote',
        'chart.js',
        'ui.select',
        'datePicker',
        'cgBusy',
        'ui.utils.masks'
      ]);
})();

'use strict';

angular.module('inspinia')
  .controller('ConsultarDetalhesTituloController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'titulo', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, titulo, $http, APP_MNP)
  {
    var vm = this;

    vm.init = function()
    {
      vm.consultarPromise = $http.get(APP_MNP + "/fatura/consultartitulo/" + titulo.viewId)
      .then(function(response)
      { 
          vm.titulo = response.data;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('FaturasDisponiveisAnteciparController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'registros', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, registros, $http, APP_MNP)
  {
    var vm = this;
    vm.registros = registros;
    vm.total = {
      valorTotal : 0,
      quantidade : 0
    };

    vm.init = function()
    {
      vm.calcularTotal();
      vm.listarClientes();
    }

    vm.enviar = function()
    {
      var antecipacao = {
        itens: vm.registros,
        clienteViewId: vm.clienteViewId
      }; 

      vm.inserirPessoa = $http.post(APP_MNP + "/antecipacao/antecipar", antecipacao).success(function(response){
          vm.fechar();
          toastr.info('Operação enviada com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.listarClientes = function()
    {
        vm.clientes = null;
        
        return $http.get(APP_MNP + "/ic/pesquisar")
        .then(function(response)
        { 
            vm.clientes = response.data;
            vm.clienteViewId = vm.clientes[0].viewId;
        });
    }

    vm.calcularTotal = function()
    {
        var total = 0;
        var quantidade = 0;

        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.registros[i].selecionadoAntecipar)
            {
                total += vm.registros[i].valor;
                quantidade++;
            }
        }

        vm.total.valorTotal = total;
        vm.total.quantidade = quantidade;
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('IntermediadorCadastrarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'intermediador', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, intermediador, $http, APP_MNP)
  {
    var vm = this;
    vm.intermediador = intermediador;

    vm.init = function()
    {
    }

    vm.incluir = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.login == null || vm.usuario.login == '')
        {
            toastr.error('Favor informar o Login.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.intermediadorViewId = vm.intermediador.viewId;

        $http.post(APP_MNP + "/intermediador/incluirUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário cadastrado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('IntermediadorConsultarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'intermediador', '$http', 'APP_MNP', 'usuario',
      function($scope, $state, toastr, $uibModalInstance, intermediador, $http, APP_MNP, usuario)
  {
    var vm = this;
    vm.intermediador = intermediador;
    vm.usuarioParam = usuario;

    vm.init = function()
    {
        vm.consultar();
    }

    vm.consultar = function()
    {
        return $http.get(APP_MNP + "/intermediador/consultarUsuario/" + vm.usuarioParam.viewId)
        .then(function(response)
        { 
            vm.usuario = response.data;
        }); 
    }

    vm.atualizar = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.login == null || vm.usuario.login == '')
        {
            toastr.error('Favor informar o Login.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.intermediadorViewId = vm.intermediador.viewId;

        $http.post(APP_MNP + "/intermediador/alterarUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário atualizado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoConsultarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'sacado', '$http', 'APP_MNP', 'usuario',
      function($scope, $state, toastr, $uibModalInstance, sacado, $http, APP_MNP, usuario)
  {
    var vm = this;
    vm.sacado = sacado;
    vm.usuarioParam = usuario;

    vm.init = function()
    {
        vm.consultar();
    }

    vm.consultar = function()
    {
        return $http.get(APP_MNP + "/sacado/consultarUsuario/" + vm.usuarioParam.viewId)
        .then(function(response)
        { 
            vm.usuario = response.data;
        }); 
    }

    vm.atualizar = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.login == null || vm.usuario.login == '')
        {
            toastr.error('Favor informar o Login.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.sacadoViewId = vm.sacado.viewId;

        $http.post(APP_MNP + "/sacado/alterarUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário atualizado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorConsultarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'fornecedor', '$http', 'APP_MNP', 'usuario',
      function($scope, $state, toastr, $uibModalInstance, fornecedor, $http, APP_MNP, usuario)
  {
    var vm = this;
    vm.fornecedor = fornecedor;
    vm.usuarioParam = usuario;

    vm.init = function()
    {
        vm.consultar();
    }

    vm.consultar = function()
    {
        return $http.get(APP_MNP + "/fornecedor/consultarUsuario/" + vm.usuarioParam.viewId)
        .then(function(response)
        { 
            vm.usuario = response.data;
        }); 
    }

    vm.atualizar = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.login == null || vm.usuario.login == '')
        {
            toastr.error('Favor informar o Login.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.fornecedorViewId = vm.fornecedor.viewId;

        $http.post(APP_MNP + "/fornecedor/alterarUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário atualizado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoCadastrarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'sacado', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, sacado, $http, APP_MNP)
  {
    var vm = this;
    vm.sacado = sacado;

    vm.init = function()
    {
    }

    vm.incluir = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.login == null || vm.usuario.login == '')
        {
            toastr.error('Favor informar o Login.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.sacadoViewId = vm.sacado.viewId;

        $http.post(APP_MNP + "/sacado/incluirUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário cadastrado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorCadastrarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'fornecedor', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, fornecedor, $http, APP_MNP)
  {
    var vm = this;
    vm.fornecedor = fornecedor;

    vm.init = function()
    {
    }

    vm.incluir = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.login == null || vm.usuario.login == '')
        {
            toastr.error('Favor informar o Login.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.fornecedorViewId = vm.fornecedor.viewId;

        $http.post(APP_MNP + "/fornecedor/incluirUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário cadastrado com sucesso.', 'Alerta');
            
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
.controller('FornecedorConsultarContaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'fornecedor', '$http', 'APP_MNP', 'conta',
    function($scope, $state, toastr, $uibModalInstance, fornecedor, $http, APP_MNP, conta)
  {
    var vm = this;    
    vm.fornecedor = fornecedor;
    vm.conta = {};
    vm.contaParam = conta;

    vm.init = function()
    {        
        vm.consultar();
    }

    vm.consultar = function()
    {
        return $http.get(APP_MNP + "/fornecedor/consultarConta/" + vm.contaParam.viewId)
        .then(function(response)
        { 
            vm.conta = response.data;
            vm.conta.bancoCodigo = vm.conta.banco.toString();
            vm.conta.statusCadastralCodigo = vm.conta.statusCadastral.toString();
            vm.conta.statusOperacionalCodigo = vm.conta.statusOperacional.toString();
            vm.conta.sacadoDesc = vm.conta.sacadoRazaoSocial;
        }); 
    }

    vm.incluir = function()
    {
        if (vm.conta.bancoCodigo == null || vm.conta.bancoCodigo == '')
        {
            alert('Favor informar a instituição bancária.');
            return;
        }

        if (vm.conta.agencia == null || vm.conta.agencia == '')
        {
            alert('Favor informar a agência.');
            return;
        }

        if (vm.conta.conta == null || vm.conta.conta == '')
        {
            alert('Favor informar o número da conta.');
            return;
        }

        if (vm.conta.statusCadastralCodigo == null || vm.conta.statusCadastralCodigo == '')
        {
            alert('Selecione o status cadastral.');
            return;
        }

        if (vm.conta.statusOperacionalCodigo == null || vm.conta.statusOperacionalCodigo == '')
        {
            alert('Selecione o status operacional.');
            return;
        }

        vm.conta.banco = parseInt(vm.conta.bancoCodigo);
        vm.conta.statusCadastral = parseInt(vm.conta.statusCadastralCodigo);
        vm.conta.statusOperacional = parseInt(vm.conta.statusOperacionalCodigo);

        $http.post(APP_MNP + "/fornecedor/alterarConta", vm.conta).success(function(response){
            toastr.info('Conta atualizada com sucesso.', 'Alerta');
            
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });

        /*
        vm.inserirPromise = CedenteService.incluirContaBancaria(vm.conta);

        vm.inserirPromise.then(function(result) {  
            if (result.data.status)
            {
                toastr.info('Conta cadastrada com sucesso.', 'Conta');

                $uibModalInstance.close();
            }
            else
            {
                alert(result.data.exception);
            }
        });
        */
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
.controller('FornecedorCadastrarContaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'fornecedor', '$http', 'APP_MNP', 'conta',
    function($scope, $state, toastr, $uibModalInstance, fornecedor, $http, APP_MNP, conta)
  {
    var vm = this;    
    vm.fornecedor = fornecedor;
    vm.conta = {
        statusCadastralCodigo : "1",
        statusOperacionalCodigo : "1",
        tipoConta: "1",
        isContaEscrow: "0",        
        isDomicilioBancario: "0",
    };
    vm.isNovo = true;
    vm.contaParam = conta;

    vm.init = function()
    {
        //vm.consultarBancos();        

        if (conta != null)
        {
            vm.isNovo = false;
            vm.consultar();
        }
        else
        {
            vm.consultarSacados();
        }
    }

    vm.consultar = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/fornecedor/consultarConta/" + vm.contaParam.viewId)
        .then(function(response)
        { 
            vm.conta = response.data;
            vm.conta.bancoCodigo = vm.conta.banco.toString();
            vm.conta.statusCadastralCodigo = vm.conta.statusCadastral.toString();
            vm.conta.statusOperacionalCodigo = vm.conta.statusOperacional.toString();
            vm.conta.isContaEscrow = vm.conta.isContaEscrow ? "1" : "0";
            vm.conta.isDomicilioBancario = vm.conta.isDomicilioBancario ? "1" : "0";
            vm.conta.tipoConta = vm.conta.tipoConta.toString();
            vm.conta.sacadoDesc = vm.conta.sacadoRazaoSocial;
            vm.conta.sacado = vm.conta.sacadoViewId;
            
            vm.consultarSacados();
        }); 
    }

    vm.consultarBancos = function()
    {
        /*
        vm.bancosPromise = BancoService.get();

        vm.bancosPromise.then(function(result) {  
            vm.bancos = result;
        });
        */
    }

    vm.consultarSacados = function()
    {
        return $http.get(APP_MNP + "/sacado/pesquisar")
        .then(function(response)
        { 
            vm.sacados = response.data;
        });
    }

    vm.incluir = function()
    {
        if (vm.conta.sacado == null || vm.conta.sacado == '')
        {
            alert('Favor selecionar o Sacado.');
            return;
        }

        if (vm.conta.bancoCodigo == null || vm.conta.bancoCodigo == '')
        {
            alert('Favor informar a instituição bancária.');
            return;
        }

        if (vm.conta.agencia == null || vm.conta.agencia == '')
        {
            alert('Favor informar a agência.');
            return;
        }

        if (vm.conta.conta == null || vm.conta.conta == '')
        {
            alert('Favor informar o número da conta.');
            return;
        }

        if (vm.conta.statusCadastralCodigo == null || vm.conta.statusCadastralCodigo == '')
        {
            alert('Selecione o status cadastral.');
            return;
        }

        if (vm.conta.statusOperacionalCodigo == null || vm.conta.statusOperacionalCodigo == '')
        {
            alert('Selecione o status operacional.');
            return;
        }

        var contaPost = vm.conta;
        contaPost.fornecedorViewId = vm.fornecedor.viewId;
        contaPost.sacadoViewId = vm.conta.sacado;        
        contaPost.banco = parseInt(vm.conta.bancoCodigo);
        contaPost.statusCadastral = parseInt(vm.conta.statusCadastralCodigo);
        contaPost.statusOperacional = parseInt(vm.conta.statusOperacionalCodigo);
        contaPost.tipoConta = parseInt(vm.conta.tipoConta);
        contaPost.isContaEscrow = (vm.conta.isContaEscrow == '0');
        contaPost.isDomicilioBancario = (vm.conta.isDomicilioBancario == '0');

        $http.post(APP_MNP + "/fornecedor/incluirConta", contaPost).success(function(response){
            toastr.info('Conta cadastrada com sucesso.', 'Alerta');
            
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.alterar = function()
    {
        if (vm.conta.bancoCodigo == null || vm.conta.bancoCodigo == '')
        {
            alert('Favor informar a instituição bancária.');
            return;
        }

        if (vm.conta.agencia == null || vm.conta.agencia == '')
        {
            alert('Favor informar a agência.');
            return;
        }

        if (vm.conta.conta == null || vm.conta.conta == '')
        {
            alert('Favor informar o número da conta.');
            return;
        }

        if (vm.conta.statusCadastralCodigo == null || vm.conta.statusCadastralCodigo == '')
        {
            alert('Selecione o status cadastral.');
            return;
        }

        if (vm.conta.statusOperacionalCodigo == null || vm.conta.statusOperacionalCodigo == '')
        {
            alert('Selecione o status operacional.');
            return;
        }

        var contaPost = vm.conta;        
        contaPost.sacadoViewId = vm.conta.sacado;
        contaPost.banco = parseInt(vm.conta.bancoCodigo);
        contaPost.statusCadastral = parseInt(vm.conta.statusCadastralCodigo);
        contaPost.statusOperacional = parseInt(vm.conta.statusOperacionalCodigo);
        contaPost.tipoConta = parseInt(vm.conta.tipoConta);
        contaPost.isContaEscrow = (vm.conta.isContaEscrow == '0');
        contaPost.isDomicilioBancario = (vm.conta.isDomicilioBancario == '0');

        $http.post(APP_MNP + "/fornecedor/alterarConta", vm.conta).success(function(response){
            toastr.info('Conta atualizada com sucesso.', 'Alerta');
            
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('CartaComunicacaoAlteracaoContaFornecedorController', ['$scope', '$state', 'toastr', '$http','APP_MNP','$sce','$uibModal', 'conta', '$uibModalInstance',
      function($scope, $state, toastr, $http, APP_MNP, $sce, $uibModal, conta, $uibModalInstance)
{
    var vm = this;    
    vm.conta = conta;
    vm.fileFichaCadastralPDF = null;

    vm.init = function()
    {
        vm.consultarFichaCadastral();
    }
    
    vm.consultarFichaCadastral = function()
    {
        vm.fichaCadastralPromise = $http.post(APP_MNP + "/fornecedor/gerarcartacomunicacaoalteracaoconta", vm.conta).success(function(response){
            
            var fileContratoMae = vm.b64toBlob(response, "application/pdf");
            vm.fileFichaCadastralPDF = $sce.trustAsResourceUrl(URL.createObjectURL(fileContratoMae)); 

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.b64toBlob = function (b64Data, contentType) {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        var sliceSize = 512
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
        
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
        
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('CartaExtratoSeguradoraFornecedorController', ['$scope', '$state', 'toastr', '$http','APP_MNP','$sce','$uibModal', 'conta', '$uibModalInstance',
      function($scope, $state, toastr, $http, APP_MNP, $sce, $uibModal, conta, $uibModalInstance)
{
    var vm = this;    
    vm.conta = conta;
    vm.fileFichaCadastralPDF = null;

    vm.init = function()
    {
        vm.consultarFichaCadastral();
    }
    
    vm.consultarFichaCadastral = function()
    {
        vm.fichaCadastralPromise = $http.post(APP_MNP + "/fornecedor/gerarcartaextratoseguradora", vm.conta).success(function(response){
            
            var fileContratoMae = vm.b64toBlob(response, "application/pdf");
            vm.fileFichaCadastralPDF = $sce.trustAsResourceUrl(URL.createObjectURL(fileContratoMae)); 

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.b64toBlob = function (b64Data, contentType) {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        var sliceSize = 512
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
        
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
        
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceOperacaoTitulosLoteController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'registros', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, registros, $http, APP_MNP)
  {
    var vm = this;
    vm.registros = registros;
    vm.total = {
      valorTotal : 0,
      quantidade : 0
    };

    vm.init = function()
    {
      vm.listarOriginadores();
      vm.calcularTotal();
      vm.listarClientes();
    }

    vm.listarOriginadores = function()
    {
        vm.consultarOriginadoresPromise = $http.get(APP_MNP + "/empresaoriginador/lista");
        
        vm.consultarOriginadoresPromise.then(function(response)
        { 
            vm.originadores = response.data;

            if (vm.originadores.length > 0)
            {
                vm.originador = vm.originadores[0];

                //vm.listarContasOriginador();
            }
        });
    }

    vm.enviar = function()
    {
      var antecipacao = {
        itens: vm.registros,
        clienteViewId: vm.clienteViewId
      };

      vm.inserirPessoa = $http.post(APP_MNP + "/invoice/antecipacao/antecipar", antecipacao).success(function(response){
          vm.fechar();
          toastr.info('Operação enviada com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.listarClientes = function()
    {
        vm.clientes = null;
        
        return $http.get(APP_MNP + "/ic/pesquisar")
        .then(function(response)
        { 
            vm.clientes = response.data;
            vm.clienteViewId = vm.clientes[0].viewId;
        });
    }

    vm.calcularTotal = function()
    {
        var total = 0;
        var quantidade = 0;

        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.registros[i].selecionadoAntecipar)
            {
                total += vm.registros[i].valor;
                quantidade++;
            }
        }

        vm.total.valorTotal = total;
        vm.total.quantidade = quantidade;
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceOperacaoNegociacaoContaGraficaController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', '$uibModal', 'operacao',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, $uibModal, operacao)
  {
    var vm = this;
    vm.operacao = operacao;
    vm.totalDebito = 0;
    vm.totalCredito = 0;
    vm.totalSaldo = 0;

    vm.init = function()
    { 
      if (vm.operacao.contaGrafica == null) {
        vm.operacao.contaGrafica = [];
      }
      
      vm.listarExtratoGrupo();
    }

    vm.listarExtratoGrupo = function() {
      vm.cedenteContaGraficaItens = [];

      var request = {
          cedenteViewId: vm.operacao.cedente.viewId,
          data: new Date(),
      };

      vm.listarExtratoPromise = $http.post(APP_MNP + "/TituloContaCorrente/extratocedente", request)
      .then(function(response)
      { 
          vm.cedenteContaGraficaItens = response.data;

          vm.cedenteContaGraficaGrupos = [];

          for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {

            // Marcar itens
            vm.cedenteContaGraficaItens[i].selecionado = false;
            for (var j=0; j < vm.operacao.contaGrafica.length; j++) {
              if (vm.operacao.contaGrafica[j].id == vm.cedenteContaGraficaItens[i].id) {
                vm.cedenteContaGraficaItens[i].selecionado = true;
                break;
              }
            }

            var grupoId = vm.cedenteContaGraficaItens[i].grupoTituloContaCorrenteEnum;
            var grupoIndex = -1;

            // localizar grupo
            for (var j=0; j < vm.cedenteContaGraficaGrupos.length; j++) {
              if (vm.cedenteContaGraficaGrupos[j].grupoId == grupoId) {
                grupoIndex = j;
              }
            }

            // Criar grupo
            if (grupoIndex == -1) {
              var novoGrupo = {
                  grupoId: grupoId,
                  descricao: vm.cedenteContaGraficaItens[i].grupoTexto,
                  quantidade: 1,
                  presenteDebito: vm.cedenteContaGraficaItens[i].isCredito ? 0 : vm.cedenteContaGraficaItens[i].valorPresente,
                  presenteCredito: vm.cedenteContaGraficaItens[i].isCredito ? vm.cedenteContaGraficaItens[i].valorPresente : 0,
                  selecionados: vm.cedenteContaGraficaItens[i].selecionado ? 1 : 0,
                  selecionadosTotal: vm.cedenteContaGraficaItens[i].selecionado ? (vm.cedenteContaGraficaItens[i].isCredito ? vm.cedenteContaGraficaItens[i].valorPresente : (vm.cedenteContaGraficaItens[i].valorPresente * -1)) : 0,
                  selecionado: vm.cedenteContaGraficaItens[i].selecionado
              };
              vm.cedenteContaGraficaGrupos.push(novoGrupo);
            }
            else {
              if (vm.cedenteContaGraficaItens[i].selecionado) {
                vm.cedenteContaGraficaGrupos[grupoIndex].selecionados = vm.cedenteContaGraficaGrupos[grupoIndex].selecionados + 1;
                if (vm.cedenteContaGraficaItens[i].isCredito) {
                  vm.cedenteContaGraficaGrupos[grupoIndex].selecionadosTotal = vm.cedenteContaGraficaGrupos[grupoIndex].selecionadosTotal + vm.cedenteContaGraficaItens[i].valorPresente;
                }
                else {
                  vm.cedenteContaGraficaGrupos[grupoIndex].selecionadosTotal = vm.cedenteContaGraficaGrupos[grupoIndex].selecionadosTotal - vm.cedenteContaGraficaItens[i].valorPresente;
                }
              }

              vm.cedenteContaGraficaGrupos[grupoIndex].quantidade = vm.cedenteContaGraficaGrupos[grupoIndex].quantidade + 1;
              
              if (vm.cedenteContaGraficaItens[i].isCredito) {
                  vm.cedenteContaGraficaGrupos[grupoIndex].presenteCredito = vm.cedenteContaGraficaGrupos[grupoIndex].presenteCredito + vm.cedenteContaGraficaItens[i].valorPresente;
              }
              else {
                  vm.cedenteContaGraficaGrupos[grupoIndex].presenteDebito = vm.cedenteContaGraficaGrupos[grupoIndex].presenteDebito + vm.cedenteContaGraficaItens[i].valorPresente;
              }
                
            }    
          }

          vm.calcularTotal();

      });
    } 

    vm.detalharItem = function(grupo)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/contagrafica/acerto/detalhe/index.html',
            controller: 'ContaGraficaAcertoManualDetalheController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                titulos: function () {
                    return vm.cedenteContaGraficaItens;
                },
                grupo: function () {
                    return grupo;
                },
            }
        }).closed.then(function(){
            vm.calcularTotal();
        });
    }

    vm.adicionar = function()
    {
      /*
      var valor = parseFloat(vm.totalDebito.toString());
      if (valor <= 0) {
        toastr.error('Selecione um registro.', 'Alerta');
        return;
      }
      */

      vm.operacao.contaGrafica = [];
      for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
        if (vm.cedenteContaGraficaItens[i].selecionado == true) {
          vm.operacao.contaGrafica.push(vm.cedenteContaGraficaItens[i]);
        }
      }

      vm.operacao.debitoCreditoTotal = vm.totalSaldo;

      $uibModalInstance.close();
    }

    vm.calcularTotal = function() {
      vm.totalDebito = 0;
      vm.totalCredito = 0;
      vm.totalSaldo = 0;

      // Credito
      for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
          if (vm.cedenteContaGraficaItens[i].selecionado && vm.cedenteContaGraficaItens[i].isCredito) {
              vm.totalCredito = vm.totalCredito + vm.cedenteContaGraficaItens[i].valorPresente;
          }
      }

      // Debito
      for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
          if (vm.cedenteContaGraficaItens[i].selecionado && vm.cedenteContaGraficaItens[i].isCredito == false) {
              vm.totalDebito = vm.totalDebito + vm.cedenteContaGraficaItens[i].valorPresente;
          }
      }

      vm.totalSaldo = vm.totalCredito - vm.totalDebito;
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceOperacaoNegociacaoFormaCreditoController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'operacao', 'formasCredito',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, operacao, formasCredito)
  {
    var vm = this;
    vm.operacao = operacao;
    vm.formasCredito = formasCredito;
    vm.tipoFormaCredito = 1;
    vm.valorTotal = 0;
    vm.cedenteContaGraficaItens = [];
    vm.bloquarSaldoContaGrafica = false;
    vm.contaSelecionada = null;

    vm.init = function()
    {
      if (vm.formasCredito != null && vm.formasCredito.length > 0) {
        for(var i=0; i < vm.formasCredito.length; i++) {
          if (vm.formasCredito[i].tipo == 3) {
            vm.bloquarSaldoContaGrafica = true;
          }
        }
      }

      vm.valorTotal = vm.operacao.totalLiquidoCalculado.toFixed(2).replaceAll(',','').replaceAll('.',',');
      vm.listarContas();
      vm.listarCedenteContaGrafica();
    }

    vm.listarCedenteContaGrafica = function() {
      vm.cedenteContaGraficaItens = [];

      $http.get(APP_MNP + "/invoice/operacao/negociacao/acertoCedenteContaGrafica/" + vm.operacao.cedente.viewId)
      .then(function(response)
      { 
        vm.cedenteContaGraficaItens = response.data;
        for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
          vm.cedenteContaGraficaItens[i].status = false;
        }
      });
    }

    vm.adicionar = function()
    {
      var valor = parseFloat(vm.valorTotal.toString().replaceAll('R$ ','0').replaceAll('.','').replaceAll(',','.'));

      if (valor <= 0) {
        toastr.error('Informe um valor de crédito.', 'Alerta');
        return;
      }

      var itemFormaCredito = {
        tipo: parseInt(vm.tipoFormaCredito),
        detalhe: '',
        valor: valor,
      };
      switch (itemFormaCredito.tipo) {
        case 1:
          itemFormaCredito.tipoTexto = 'TED';
          if (vm.contaSelecionada == null) {
            toastr.error('Selecione uma conta.', 'Alerta');
            return;
          }
          itemFormaCredito.cedenteDomicilioBancario = vm.contaSelecionada;
          itemFormaCredito.detalhe = vm.contaSelecionada.bancoTexto + " - " + "Ag: " + vm.contaSelecionada.agencia + " Conta: " + vm.contaSelecionada.numero;
          break;
        case 2:
          itemFormaCredito.tipoTexto = 'PIX';
          if (vm.contaSelecionada == null) {
            toastr.error('Selecione uma conta.', 'Alerta');
            return;
          }
          itemFormaCredito.cedenteDomicilioBancario = vm.contaSelecionada;
          itemFormaCredito.detalhe = vm.contaSelecionada.bancoTexto + " - " + "Ag: " + vm.contaSelecionada.agencia + " Conta: " + vm.contaSelecionada.numero;
          break;
        case 3:
          itemFormaCredito.tipoTexto = 'Saldo Conta Gráfica';
          itemFormaCredito.contaGrafica = [];
          for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
            if (vm.cedenteContaGraficaItens[i].status == true) {
              itemFormaCredito.contaGrafica.push(vm.cedenteContaGraficaItens[i]);
            }
          }
          itemFormaCredito.detalhe = itemFormaCredito.contaGrafica.length + ' selecionados';
          break;
        case 4:
          itemFormaCredito.tipoTexto = 'Cheque';
          break;
        case 5:
          itemFormaCredito.tipoTexto = 'Dinheiro';
          break;
      }

      vm.formasCredito.push(itemFormaCredito);

      $uibModalInstance.close();
    }

    vm.calcularSaldo = function() {
      vm.valorTotal = 0;

      for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
        if(vm.cedenteContaGraficaItens[i].status) {
          vm.valorTotal = vm.valorTotal + vm.cedenteContaGraficaItens[i].valorPresente;
        }
      }

      vm.valorTotal = vm.valorTotal.toFixed(2).replaceAll(',','').replaceAll('.',',');
    }

    vm.listarContas = function()
    {
      vm.listarContasPromise = $http.get(APP_MNP + "/cedente/listarContas/" + vm.operacao.cedente.viewId)
      .then(function(response)
      { 
          vm.contas = response.data;

          if (vm.contas.length > 0) {
            vm.contaSelecionada = vm.contas[0];
          }
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('BoletoVencidoItauGerarController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'codigo', 'antecipacao', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, codigo, antecipacao, $http, APP_MNP)
  {
    var vm = this;
    vm.codigo = codigo;
    vm.antecipacao = antecipacao;

    vm.init = function()
    {
      /*
      vm.consultaPromise = $http.get(APP_MNP + "/ccb/antecipacaodetalhe/" + antecipacao.viewId)
      .then(function(response)
      { 
        vm.registro = response.data;
      });
      */
    }

    vm.visualizarBoleto = function() {
      vm.consultaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", antecipacao).success(function(response){
          
          vm.download(response, 'application/pdf', 'boleto.pdf');

          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoCadastrarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'sacado', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, sacado, $http, APP_MNP)
  {
    var vm = this;
    vm.sacado = sacado;

    vm.init = function()
    {
    }

    vm.incluir = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }
        
        if (vm.usuario.email == null || vm.usuario.email == '')
        {
            toastr.error('Favor informar o E-mail.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.sacadoViewId = vm.sacado.viewId;

        $http.post(APP_MNP + "/sacado/incluirUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário cadastrado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoConsultarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'sacado', '$http', 'APP_MNP', 'usuario',
      function($scope, $state, toastr, $uibModalInstance, sacado, $http, APP_MNP, usuario)
  {
    var vm = this;
    vm.sacado = sacado;
    vm.usuarioParam = usuario;

    vm.init = function()
    {
        vm.consultar();
    }

    vm.consultar = function()
    {
        return $http.get(APP_MNP + "/sacado/consultarUsuario/" + vm.usuarioParam.viewId)
        .then(function(response)
        { 
            vm.usuario = response.data;
        }); 
    }

    vm.atualizar = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.login == null || vm.usuario.login == '')
        {
            toastr.error('Favor informar o Login.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.sacadoViewId = vm.sacado.viewId;

        $http.post(APP_MNP + "/sacado/alterarUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário atualizado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorConsultarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'fornecedor', '$http', 'APP_MNP', 'usuario',
      function($scope, $state, toastr, $uibModalInstance, fornecedor, $http, APP_MNP, usuario)
  {
    var vm = this;
    vm.cedenteViewId = fornecedor;
    vm.usuarioParam = usuario;

    vm.init = function()
    {
        vm.consultar();
    }

    vm.consultar = function()
    {
        return $http.get(APP_MNP + "/cedente/consultarUsuario/" + vm.usuarioParam.viewId)
        .then(function(response)
        { 
            vm.usuario = response.data;
        }); 
    }

    vm.atualizar = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.email == null || vm.usuario.email == '')
        {
            toastr.error('Favor informar o E-mail.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.cedenteViewId = vm.cedenteViewId;

        $http.post(APP_MNP + "/cedente/alterarUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário atualizado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.excluir = function() {

        if (confirm('Deseja realmente excluir este usuário?'))
        {
            $http.post(APP_MNP + "/cedente/excluirUsuario", vm.usuario).success(function(response){
                toastr.info('Usuário excluído com sucesso.', 'Alerta');
                $uibModalInstance.close();
                return response;
            }).error(function(error){
                toastr.error(error, 'Erro no processamento');
                return error;
            });
        }
      }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorCadastrarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'fornecedor', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, fornecedor, $http, APP_MNP)
  {
    var vm = this;
    vm.cedenteViewId = fornecedor;

    vm.init = function()
    {
    }

    vm.incluir = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.email == null || vm.usuario.email == '')
        {
            toastr.error('Favor informar o E-mail.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.cedenteViewId = vm.cedenteViewId;

        $http.post(APP_MNP + "/cedente/incluirUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário cadastrado com sucesso.', 'Alerta');
            
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            toastr.error(error);
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
.controller('FornecedorCadastrarContaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'fornecedor', '$http', 'APP_MNP', 'conta',
    function($scope, $state, toastr, $uibModalInstance, fornecedor, $http, APP_MNP, conta)
  {
    var vm = this;    
    vm.fornecedor = fornecedor;
    vm.conta = {
        statusCadastralCodigo : "1",
        statusOperacionalCodigo : "1",
        tipoConta: "1",
        isContaEscrow: "0",        
        isDomicilioBancario: "0",
        bancoCodigo: "237",
        isPadraoOperacaoNum: '1',
    };
    vm.isNovo = true;
    vm.contaParam = conta;

    vm.init = function()
    {
        //vm.consultarBancos();        

        if (conta != null)
        {
            vm.isNovo = false;
            vm.consultar();
        }
        else
        {
            //vm.consultarSacados();
        }
    }

    vm.consultar = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/cedente/consultarConta/" + vm.contaParam.viewId)
        .then(function(response)
        { 
            vm.conta = response.data;
            vm.conta.bancoCodigo = vm.conta.codigoBanco.toString();
            vm.conta.conta = vm.conta.numero;
            vm.conta.contaDigito = vm.conta.digitoConta;
            vm.conta.agencia = vm.conta.agencia;
            vm.conta.agenciaDigito = vm.conta.digitoAgencia;
            vm.conta.isPadraoOperacaoNum = vm.conta.isPadraoOperacao ? '1' : '0';
            //vm.conta.statusCadastralCodigo = vm.conta.statusCadastral.toString();
            //vm.conta.statusOperacionalCodigo = vm.conta.statusOperacional.toString();
            //vm.conta.isContaEscrow = vm.conta.isContaEscrow ? "1" : "0";
            //vm.conta.isDomicilioBancario = vm.conta.isDomicilioBancario ? "1" : "0";
            //vm.conta.tipoConta = vm.conta.tipoConta.toString();
            //vm.conta.sacadoDesc = vm.conta.sacadoRazaoSocial;
            //vm.conta.sacado = vm.conta.sacadoViewId;
            
            //vm.consultarSacados();
        }); 
    }

    vm.consultarBancos = function()
    {
        /*
        vm.bancosPromise = BancoService.get();

        vm.bancosPromise.then(function(result) {  
            vm.bancos = result;
        });
        */
    }

    vm.consultarSacados = function()
    {
        return $http.get(APP_MNP + "/sacado/pesquisar")
        .then(function(response)
        { 
            vm.sacados = response.data;
        });
    }

    vm.incluir = function()
    {
        /*
        if (vm.conta.sacado == null || vm.conta.sacado == '')
        {
            alert('Favor selecionar o Sacado.');
            return;
        }
        */

        if (vm.conta.bancoCodigo == null || vm.conta.bancoCodigo == '')
        {
            alert('Favor informar a instituição bancária.');
            return;
        }

        if (vm.conta.agencia == null || vm.conta.agencia == '')
        {
            alert('Favor informar a agência.');
            return;
        }

        if (vm.conta.conta == null || vm.conta.conta == '')
        {
            alert('Favor informar o número da conta.');
            return;
        }

        /*
        if (vm.conta.statusCadastralCodigo == null || vm.conta.statusCadastralCodigo == '')
        {
            alert('Selecione o status cadastral.');
            return;
        }

        if (vm.conta.statusOperacionalCodigo == null || vm.conta.statusOperacionalCodigo == '')
        {
            alert('Selecione o status operacional.');
            return;
        }
        */

        var contaPost = vm.conta;
        contaPost.cedente = {
            viewId: vm.fornecedor,
        };
        //contaPost.fornecedorViewId = vm.fornecedor.viewId;
        //contaPost.sacadoViewId = vm.conta.sacado;        
        contaPost.codigoBanco = parseInt(vm.conta.bancoCodigo);
        //contaPost.statusCadastral = parseInt(vm.conta.statusCadastralCodigo);
        //contaPost.statusOperacional = parseInt(vm.conta.statusOperacionalCodigo);
        contaPost.tipoConta = parseInt(vm.conta.tipoConta);
        //contaPost.isContaEscrow = (vm.conta.isContaEscrow == '0');
        //contaPost.isDomicilioBancario = (vm.conta.isDomicilioBancario == '0');
        contaPost.numero = vm.conta.conta;
        contaPost.digitoConta = vm.conta.contaDigito;
        contaPost.agencia = vm.conta.agencia;
        contaPost.digitoAgencia = vm.conta.agenciaDigito;
        contaPost.isPadraoOperacao = vm.conta.isPadraoOperacaoNum == '1' ? true : false;

        $http.post(APP_MNP + "/cedente/adicionarconta", contaPost).success(function(response){
            toastr.info('Conta cadastrada com sucesso.', 'Alerta');
            
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.alterar = function()
    {
        if (vm.conta.bancoCodigo == null || vm.conta.bancoCodigo == '')
        {
            alert('Favor informar a instituição bancária.');
            return;
        }

        if (vm.conta.agencia == null || vm.conta.agencia == '')
        {
            alert('Favor informar a agência.');
            return;
        }

        if (vm.conta.conta == null || vm.conta.conta == '')
        {
            alert('Favor informar o número da conta.');
            return;
        }

        /*
        if (vm.conta.statusCadastralCodigo == null || vm.conta.statusCadastralCodigo == '')
        {
            alert('Selecione o status cadastral.');
            return;
        }

        if (vm.conta.statusOperacionalCodigo == null || vm.conta.statusOperacionalCodigo == '')
        {
            alert('Selecione o status operacional.');
            return;
        }
        */

        var contaPost = vm.conta;        
        //contaPost.sacadoViewId = vm.conta.sacado;
        contaPost.codigoBanco = parseInt(vm.conta.bancoCodigo);
        //contaPost.statusCadastral = parseInt(vm.conta.statusCadastralCodigo);
        //contaPost.statusOperacional = parseInt(vm.conta.statusOperacionalCodigo);
        contaPost.tipoConta = parseInt(vm.conta.tipoConta);
        //contaPost.isContaEscrow = (vm.conta.isContaEscrow == '0');
        //contaPost.isDomicilioBancario = (vm.conta.isDomicilioBancario == '0');
        contaPost.numero = vm.conta.conta;
        contaPost.digitoConta = vm.conta.contaDigito;
        contaPost.agencia = vm.conta.agencia;
        contaPost.digitoAgencia = vm.conta.agenciaDigito;
        contaPost.isPadraoOperacao = vm.conta.isPadraoOperacaoNum == '1' ? true : false;

        $http.put(APP_MNP + "/cedente/atualizarconta", contaPost).success(function(response){
            toastr.info('Conta atualizada com sucesso.', 'Alerta');
            
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro');
            return error;
        });
    }

    vm.excluir = function() {
        if (confirm('Deseja realmente excluir este registro?')) {
            $http.delete(APP_MNP + "/cedente/excluirConta/" + vm.contaParam.viewId).success(function(response){
                toastr.info('Conta excluída com sucesso.', 'Alerta');
                
                $uibModalInstance.close();
                return response;
            }).error(function(error){
                toastr.error(error, 'Erro');
                return error;
            });
        }
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
.controller('FornecedorConsultarContaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'fornecedor', '$http', 'APP_API_AGFN', 'conta',
    function($scope, $state, toastr, $uibModalInstance, fornecedor, $http, APP_API_AGFN, conta)
  {
    var vm = this;    
    vm.fornecedor = fornecedor;
    vm.conta = {};
    vm.contaParam = conta;

    vm.init = function()
    {        
        vm.consultar();
    }

    vm.consultar = function()
    {
        return $http.get(APP_API_AGFN + "/fornecedor/consultarConta/" + vm.contaParam.viewId)
        .then(function(response)
        { 
            vm.conta = response.data;
            vm.conta.bancoCodigo = vm.conta.banco.toString();
            vm.conta.statusCadastralCodigo = vm.conta.statusCadastral.toString();
            vm.conta.statusOperacionalCodigo = vm.conta.statusOperacional.toString();
            vm.conta.sacadoDesc = vm.conta.sacadoRazaoSocial;
        }); 
    }

    vm.incluir = function()
    {
        if (vm.conta.bancoCodigo == null || vm.conta.bancoCodigo == '')
        {
            alert('Favor informar a instituição bancária.');
            return;
        }

        if (vm.conta.agencia == null || vm.conta.agencia == '')
        {
            alert('Favor informar a agência.');
            return;
        }

        if (vm.conta.conta == null || vm.conta.conta == '')
        {
            alert('Favor informar o número da conta.');
            return;
        }

        if (vm.conta.statusCadastralCodigo == null || vm.conta.statusCadastralCodigo == '')
        {
            alert('Selecione o status cadastral.');
            return;
        }

        if (vm.conta.statusOperacionalCodigo == null || vm.conta.statusOperacionalCodigo == '')
        {
            alert('Selecione o status operacional.');
            return;
        }

        vm.conta.banco = parseInt(vm.conta.bancoCodigo);
        vm.conta.statusCadastral = parseInt(vm.conta.statusCadastralCodigo);
        vm.conta.statusOperacional = parseInt(vm.conta.statusOperacionalCodigo);

        $http.post(APP_API_AGFN + "/fornecedor/alterarConta", vm.conta).success(function(response){
            toastr.info('Conta atualizada com sucesso.', 'Alerta');
            
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });

        /*
        vm.inserirPromise = CedenteService.incluirContaBancaria(vm.conta);

        vm.inserirPromise.then(function(result) {  
            if (result.data.status)
            {
                toastr.info('Conta cadastrada com sucesso.', 'Conta');

                $uibModalInstance.close();
            }
            else
            {
                alert(result.data.exception);
            }
        });
        */
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('FaturasDisponiveisController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, PagerService, $uibModal, $http, APP_MNP)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.total = {
        valorTotal : 0,
        quantidade : 0
    };
    vm.filtro = {};
    vm.registrosOriginal = [];
    vm.lastOrder = '';
    vm.orderSelected = '';
    vm.filtro = {
        status: 1
    };

    vm.init = function()
    {
        vm.listar();
    }

    vm.listar = function()
    {
        vm.registros = null;
        vm.items = null;

        vm.listarPromise = $http.get(APP_MNP + "/fatura/disponiveis");
        /*
        .then(function(response)
        { 
            return response.data;
        });
        */

        vm.listarPromise.then(function(result) {  
            vm.registrosOriginal = result.data;
            vm.registros = result.data;
            vm.calcularTotal();
            vm.filtrarPesquisa();
        });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nfe != null && vm.filtro.nfe != '')
            {
                if (!vm.registrosOriginal[i].numero.includes(vm.filtro.nfe))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.titulo != null && vm.filtro.titulo != '')
            {
                if (!vm.registrosOriginal[i].titulo.includes(vm.filtro.titulo))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.sacado != null && vm.filtro.sacado != '')
            {
                if (!vm.registrosOriginal[i].sacado.toUpperCase().includes(vm.filtro.sacado.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '')
            {
                if (!vm.registrosOriginal[i].fornecedor.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
            {
                if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].dataVencimentoDate))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '')
            {
                if (vm.filtro.vencimentoAte < new Date(vm.registrosOriginal[i].dataVencimentoDate))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorDe != null && vm.filtro.valorDe != '')
            {
                if (vm.filtro.valorDe > vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorAte != null && vm.filtro.valorAte != '')
            {
                if (vm.filtro.valorAte < vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.desmarcarTodos();
        vm.pager.totalPages = 1;
        vm.setPage(1);
        vm.calcularTotal();
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'nfe':
                    vm.registros.reverse(function(a, b){
                        if(a.numero < b.numero) { return -1; }
                        if(a.numero > b.numero) { return 1; }
                        return 0;
                    })
                    break;
                case 'titulo':
                    vm.registros.reverse(function(a, b){
                        if(a.titulo < b.titulo) { return -1; }
                        if(a.titulo > b.titulo) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.reverse(function(a, b){
                        if(a.sacado < b.sacado) { return -1; }
                        if(a.sacado > b.sacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'fornecedor':
                    vm.registros.reverse(function(a, b){
                        if(a.fornecedor < b.fornecedor) { return -1; }
                        if(a.fornecedor > b.fornecedor) { return 1; }
                        return 0;
                    })
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimentoDate);
                        var dateB = new Date(b.dataVencimentoDate);
                        return dateA - dateB;
                    });
                    break;
                case 'valor':
                    vm.registros.reverse(function(a, b){
                        if(a.valor < b.valor) { return -1; }
                        if(a.valor > b.valor) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'nfe':
                    vm.registros.sort(function(a, b){
                        if(a.numero < b.numero) { return -1; }
                        if(a.numero > b.numero) { return 1; }
                        return 0;
                    })
                    break;
                case 'titulo':
                    vm.registros.sort(function(a, b){
                        if(a.titulo < b.titulo) { return -1; }
                        if(a.titulo > b.titulo) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.sort(function(a, b){
                        if(a.sacado < b.sacado) { return -1; }
                        if(a.sacado > b.sacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'fornecedor':
                    vm.registros.sort(function(a, b){
                        if(a.fornecedor < b.fornecedor) { return -1; }
                        if(a.fornecedor > b.fornecedor) { return 1; }
                        return 0;
                    })
                    break;
                case 'vencimento':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataVencimentoDate);
                        var dateB = new Date(b.dataVencimentoDate);
                        return dateA - dateB;
                    });
                    break;
                case 'valor':
                    vm.registros.sort(function(a, b){
                        if(a.valor < b.valor) { return -1; }
                        if(a.valor > b.valor) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }
        
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.anteciparRegistros = function()
    {
        if (vm.registros != null)
        {
            var selecionados = [];
            for (var i = 0; i < vm.registros.length; i++)
            {
                if (vm.registros[i].selecionadoAntecipar)
                {
                    selecionados.push(vm.registros[i]);
                }
            }

            if (selecionados.length == 0)
            {
                alert('Selecione pelo menos um registro.');
                return;
            }

            var modalInstance = $uibModal.open({
                templateUrl: 'app/nfe/recebiveis/faturas/modal/antecipar/index.html',
                controller: 'FaturasDisponiveisAnteciparController',
                controllerAs: 'controller',
                windowClass: 'inmodal',
                size: 'lg',
                resolve: {
                    registros: function () {
                        return selecionados;
                    },
                }
            }).closed.then(function(){
                vm.listar();
            });
        }
    }

    vm.marcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.filtro.status == vm.registros[i].status)
            {
                if (vm.registros[i].status == 1)
                {
                    vm.registros[i].selecionadoAntecipar = true;
                }
            }
        }
        vm.calcularTotal();
    }

    vm.desmarcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            vm.registros[i].selecionadoAntecipar = false;
        }
        vm.calcularTotal();
    }

    vm.calcularTotal = function()
    {
        var total = 0;
        var quantidade = 0;

        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.registros[i].selecionadoAntecipar)
            {
                total += vm.registros[i].valor;
                quantidade++;
            }
        }

        vm.total.valorTotal = total;
        vm.total.quantidade = quantidade;
    }

    vm.consultarTitulo = function(p)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/nfe/recebiveis/faturas/modal/detalhar_titulo/index.html',
            controller: 'ConsultarDetalhesTituloController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                titulo: function () {
                    return p;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });
    }
    
    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorIncluirSocioController', ['$scope', '$state', 'fornecedor', 'toastr', 'tipopessoa', '$uibModalInstance', '$http', 'pessoa', 'APP_MNP', 'indice',
      function($scope, $state, fornecedor, toastr, tipopessoa, $uibModalInstance, $http, pessoa, APP_MNP, indice)
{
    var vm = this;
    vm.tipoPessoa = tipopessoa;
    vm.fornecedor = fornecedor;

    vm.pessoa = {};

    vm.arquivos = {
      arq1: '',
      arq2: '',
      arq3: '',
      arq4: '',
      arq5: '',
      arq6: '',
      arq7: '',
    };

    vm.init = function()
    {
      if (pessoa != null)
      {
        vm.pessoa = pessoa;
        vm.loadDocumentos();
      }
    }

    vm.loadDocumentos = function()
    {
      if (vm.pessoa.documentos != null)
      {
        for (var i = 0; i <= vm.pessoa.documentos.length; i++)
        {
          if (vm.pessoa.documentos[i] != null)
          {
            switch (vm.pessoa.documentos[i].tipo)
            {
              case 1:
                vm.arquivos.arq1 = vm.pessoa.documentos[i];
                break;
              case 2:
                vm.arquivos.arq2 = vm.pessoa.documentos[i];
                break;
              case 3:
                vm.arquivos.arq3 = vm.pessoa.documentos[i];
                break;
              case 4:
                vm.arquivos.arq4 = vm.pessoa.documentos[i];
                break;  
              case 5:
                vm.arquivos.arq5 = vm.pessoa.documentos[i];
                break;
              case 6:
                vm.arquivos.arq6 = vm.pessoa.documentos[i];
                break;
              case 7:
                vm.arquivos.arq7 = vm.pessoa.documentos[i];
                break;
            }
          }
        }
      }
    }

    vm.incluir = function()
    {
      var api = 'adicionarsocio';

      if (vm.tipoPessoa == 'Procurador')
      {
        api = 'adicionarprocurador';
      }

      if (vm.pessoa.assinaPelaEmpresaText != null && vm.pessoa.assinaPelaEmpresaText != '')
      {
        vm.pessoa.assinaPelaEmpresa = parseInt(vm.pessoa.assinaPelaEmpresaText);
      }

      vm.pessoa.fornecedorViewId = vm.fornecedor.viewId;

      vm.incluirPromise = $http.post(APP_MNP + "/fornecedor/" + api, vm.pessoa).success(function(response){
        //$state.go('confirmar_cadastro.finalizar');
        vm.pessoa.viewId = response;

        if (vm.tipoPessoa == 'Procurador')
        {
          vm.fornecedor.procuradores.push(vm.pessoa);
        }
        else
        {
          vm.fornecedor.socios.push(vm.pessoa);
        }

        //toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        vm.fechar();
        //vm.etapa = 2;

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.atualizar = function()
    {
      var api = 'atualizarsocio';

      if (vm.tipoPessoa == 'Procurador')
      {
        api = 'atualizarprocurador';
      }

      if (vm.pessoa.assinaPelaEmpresaText != null && vm.pessoa.assinaPelaEmpresaText != '')
      {
        vm.pessoa.assinaPelaEmpresa = parseInt(vm.pessoa.assinaPelaEmpresaText);
      }

      vm.pessoa.fornecedorViewId = vm.fornecedor.viewId;

      vm.incluirPromise = $http.post(APP_MNP + "/fornecedor/" + api, vm.pessoa).success(function(response){
        //$state.go('confirmar_cadastro.finalizar');
        vm.pessoa.viewId = response;

        if (vm.tipoPessoa == 'Procurador')
        {
          vm.fornecedor.procuradores.splice(indice, 1);
          vm.fornecedor.procuradores.push(vm.pessoa);
        }
        else
        {
          vm.fornecedor.socios.splice(indice, 1);
          vm.fornecedor.socios.push(vm.pessoa);
        }

        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.adicionarDocumento = function(tipo)
    {
      var cnab = {};      
      vm.file = {};
      vm.file.nome = vm.selectedTempFile[0].name;
      vm.file.tipo = tipo;
      
      var reader = new FileReader();
      reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
      reader.onload = function (evt) {          
          vm.file.base64 = evt.target.result;          

          var pessoa = vm.pessoa;
          pessoa.documentos = [];
          pessoa.documentos.push(vm.file);
          pessoa.fornecedorViewId = vm.fornecedor.viewId;

          var api = 'adicionardocumentosocio';

          if (vm.tipoPessoa == 'Procurador')
          {
            api = 'adicionardocumentoprocurador';
          }

          vm.validarPromise = $http.post(APP_MNP + "/fornecedor/" + api, pessoa).success(function(response){
            toastr.info('Arquivo enviado com sucesso.', 'Alerta');

            if (vm.pessoa.documentos != null)
            {
              for (var i = 0; i < vm.pessoa.documentos.length; i++)
              {
                if (vm.pessoa.documentos[i].tipo == vm.file.tipo)
                {
                  vm.pessoa.documentos.splice(i, 1);
                }
              }
            }
            vm.file.viewId = response;
            vm.file.base64 = null;
            vm.pessoa.documentos.push(vm.file);

            vm.loadDocumentos();

            vm.file = {};
            return response;
          }).error(function(error){
            vm.file = {};
            toastr.error(error, 'Alerta');
            return error;
          });
      };
      
      vm.selectedTempFile = [];
      angular.element("input[type='file']").val(null);      
    }

    vm.getDocumento = function(arq)
    {
        var api = 'consultardocumentosocio/';

        if (vm.tipoPessoa == 'Procurador')
        {
          var api = 'consultardocumentoprocurador/';
        }

        return $http.get(APP_MNP + "/fornecedor/" + api + arq.viewId)
        .then(function(response)
        { 
            vm.download(response.data.base64, response.data.tipoDesc, arq.nome);
        }).catch(function (data) {
            toastr.error(data, 'Alerta');
        });
    }

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
  }

}]);

'use strict';

angular.module('inspinia')
  .controller('FornecedorIncluirEmpresaControllerOld2', ['$scope', '$state', 'fornecedor', 'toastr', '$uibModalInstance', '$http', 'empresa', 'APP_MNP', 'indice',
      function($scope, $state, fornecedor, toastr, $uibModalInstance, $http, empresa, APP_MNP, indice)
{
    var vm = this;

    vm.empresa = {};
    vm.fornecedor = fornecedor;

    vm.init = function()
    {
      if (empresa != null)
      {
        vm.empresa = empresa;
      }
    }

    vm.incluir = function()
    {
      vm.empresa.fornecedorViewId = vm.fornecedor.viewId;
      
      vm.incluirPromise = $http.post(APP_MNP + "/fornecedor/adicionarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.atualizar = function()
    {
      vm.empresa.fornecedorViewId = vm.fornecedor.viewId;

      vm.incluirPromise = $http.post(APP_MNP + "/fornecedor/atualizarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.splice(indice, 1);
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('FinanceiroGestaoContasAnalisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.registroParam = $state.params.obj;
    vm.total = {
        valorTotal : 0        
    };

    vm.init = function()
    {        
        if (vm.registroParam == null || vm.registroParam == '')
        {
            $state.go('index.financeiro_gestaocontas_listar');
        }
        else
        {
            vm.pesquisar();        
        }
    }

    vm.pesquisar = function()
    {
        return $http.get(APP_MNP + "/gestaocontas/analisar/" + vm.registroParam.viewId)
        .then(function(response)
        {
            vm.registro = response.data.recebimento;
            vm.titulos = response.data.titulos;
            vm.extrato = response.data.extratoBancario;
            vm.totalTitulos = response.data.totalTitulos;
            vm.saldoDisponivel = response.data.saldoDisponivel;
            vm.saldoBloqueado = response.data.saldoBloqueado;
            vm.filtro = {
                dataExtratoDe: new Date(response.data.dataExtratoDe),
                dataExtratoAte: new Date(response.data.dataExtratoAte + ' 23:59:59')
            };
        });
    }

    vm.pesquisarExtrato = function()
    {
        var filtro = {
            viewId : vm.registro.viewId,
            dataInicio : vm.filtro.dataExtratoDe,
            dataFim : vm.filtro.dataExtratoAte
        };

        return $http.post(APP_MNP + "/gestaocontas/extratobancario", filtro)
        .success(function(response)
        {
            vm.extrato = response;
        }).error(function(error){
            alert(error);
            return error;
        });
    }

    vm.confirmar = function(item)
    {
        var r = confirm("Deseja realmente confirmar a operação?");

        if (!r)
        {
            return;
        }

        var selecionados = [];
        for (var i = 0; i < vm.titulos.length; i++)
        {
            if (vm.titulos[i].selecionado)
            {
                selecionados.push(vm.titulos[i]);
            }
        }

        /*
        if (selecionados.length == 0)
        {
            alert('Selecione pelo menos um registro.');
            return;
        }
        */

        item.titulos = selecionados;
        
        $http.post(APP_MNP + "/gestaocontas/confirmarcredito", item).success(function(response){            
            toastr.info('Operação enviada com sucesso.', 'Alerta');
            $state.go('index.financeiro_gestaocontas_listar');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.calcularTotal = function()
    {
        var total = 0;

        for (var i = 0; i < vm.titulos.length; i++)
        {
            if (vm.titulos[i].selecionado)
            {
                total += vm.titulos[i].amount;
            }
        }

        vm.total.valorTotal = total;
    }
    
    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('IntermediadorConsultaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.intermediadorParam = $state.params.obj;

    vm.init = function()
    {
        if (vm.intermediadorParam == null || vm.intermediadorParam == '')
        {
            $state.go('index.cadastro_intermediador_pesquisa');
        }
        else
        {
            vm.pesquisar();        
        }
    }

    vm.pesquisar = function()
    {
        return $http.get(APP_MNP + "/intermediador/consultar/" + vm.intermediadorParam.viewId)
        .then(function(response)
        { 
            vm.intermediador = response.data;
            
            vm.listarUsuarios();
        });
    }

    vm.atualizar = function()
    {
        if (vm.intermediador.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Alerta');
            return;
        }

        if (vm.intermediador.cnpj.toString().length != 18)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }

        if (vm.intermediador.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        $http.post(APP_MNP + "/intermediador/alterar", vm.intermediador).success(function(response){
            toastr.info('Intermediador atualizado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.adicionarUsuario = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/intermediador/consulta/usuario/cadastro/index.html',
            controller: 'IntermediadorCadastrarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                intermediador: function () {
                    return vm.intermediadorParam;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }

    vm.editarUsuario = function(usuario)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/intermediador/consulta/usuario/consulta/index.html',
            controller: 'IntermediadorConsultarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                intermediador: function () {
                    return vm.intermediadorParam;
                },
                usuario: function () {
                    return usuario;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }
    
    vm.listarUsuarios = function()
    {
        return $http.get(APP_MNP + "/intermediador/listarUsuarios/" + vm.intermediador.viewId)
        .then(function(response)
        { 
            vm.usuarios = response.data;
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('AntecipacaoRealizarPropostaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_MNP)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.proposta = {
      antecipacaoViewId: antecipacao.viewId
    };

    vm.init = function()
    {

    }

    vm.enviar = function()
    {
      if (vm.proposta.antecipacaoViewId == null)
      {
        alert('Antecipacao não selecionada.');
        return;
      }

      if (vm.proposta.valor == null || vm.proposta.valor == '')
      {
        alert('Valor não informado.');
        return;
      }

      if (vm.proposta.fator == null || vm.proposta.fator == '')
      {
        alert('Fator não informado.');
        return;
      }

      if (vm.proposta.banco == null || vm.proposta.banco == '')
      {
        alert('Banco não informado.');
        return;
      }

      if (vm.proposta.agencia == null || vm.proposta.agencia == '')
      {
        alert('Agência não informada.');
        return;
      }

      if (vm.proposta.conta == null || vm.proposta.conta == '')
      {
        alert('Conta não informada.');
        return;
      }

      $http.post(APP_MNP + "/proposta/enviar", vm.proposta).success(function(response){
          vm.fechar();
          toastr.info('Proposta enviada com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ConsultarTitulosPropostaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_MNP)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.propostas = [];

    vm.init = function()
    {
      return $http.get(APP_MNP + "/antecipacao/consultartitulos/" + antecipacao.viewId)
      .then(function(response)
      { 
          vm.titulos = response.data;
          //vm.registros = response.data;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceTituloDetalheController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'titulo', '$http', 'APP_MNP',
    function ($scope, $state, toastr, $uibModalInstance, titulo, $http, APP_MNP) {
      var vm = this;


      vm.init = function () {

        vm.consultarPromise = $http.get(APP_MNP + "/invoice/titulo/consultar/" + titulo.viewId)
          .then(function (response) {
            vm.titulo = response.data;
            vm.liberarSemAlteracoes = false;

            vm.titulo.dataVencimentoDate = new Date(vm.titulo.dataVencimento); // Converter para Date object para o input type=date se necessario, mas o html usa text com filter date.

            // Verificar evento 110110
            if (vm.titulo.nfeValidacao != null && vm.titulo.nfeValidacao.documentoDTO != null && vm.titulo.nfeValidacao.documentoDTO.documentos != null) {
              for (var i = 0; i < vm.titulo.nfeValidacao.documentoDTO.documentos.length; i++) {
                var doc = vm.titulo.nfeValidacao.documentoDTO.documentos[i];
                if (doc.eventos != null) {
                  for (var j = 0; j < doc.eventos.length; j++) {
                    if (doc.eventos[j].tipoEvento == '110110') {
                      vm.podeAlterarCartaCorrecao = true;
                      break;
                    }
                  }
                }
                if (vm.podeAlterarCartaCorrecao) break;
              }
            }

            if (vm.podeAlterarCartaCorrecao) {
              vm.tituloOriginal = angular.copy(vm.titulo);
            }
          });
      }

      vm.verificarAlteracoes = function () {
        if (!vm.podeAlterarCartaCorrecao) return false;

        // Atualizar Data Vencimento do model principal a partir da data do input
        if (vm.titulo.dataVencimentoDate) {
          // Ajustar fuso horario ou usar toISOString().split('T')[0] se for date only, 
          // mas DateTime no C# espera hora. Vamos manter o objeto Date se o angular lidar, 
          // ou converter string. 
          // O backend espera DateTime. O angular envia Date como string ISO por padrao.
          vm.titulo.dataVencimento = vm.titulo.dataVencimentoDate;
        }

        var dateOriginal = new Date(vm.tituloOriginal.dataVencimento);
        var dateNew = new Date(vm.titulo.dataVencimento);

        // Comparacao simples de tempo
        if (dateOriginal.getTime() != dateNew.getTime()) return true;
        if (vm.titulo.valor != vm.tituloOriginal.valor) return true;
        if (vm.titulo.numeroNfe != vm.tituloOriginal.numeroNfe) return true;
        if (vm.titulo.numero != vm.tituloOriginal.numero) return true;

        return false;
      }

      vm.verificarAlteracoesCustom = function () {
        if (vm.liberarSemAlteracoes) return true;
        return vm.verificarAlteracoes();
      }

      vm.gravar = function () {
        var statusCartaCorrecao = "";

        if (vm.liberarSemAlteracoes) {
          statusCartaCorrecao = "9";
        } else {
          // Garantir que dataVencimento esta atualizada
          if (vm.titulo.dataVencimentoDate) {
            vm.titulo.dataVencimento = vm.titulo.dataVencimentoDate;
          }

          var dateOriginal = new Date(vm.tituloOriginal.dataVencimento);
          var dateNew = new Date(vm.titulo.dataVencimento);

          if (dateOriginal.getTime() != dateNew.getTime()) {
            statusCartaCorrecao += "1";
          }

          if (vm.titulo.valor != vm.tituloOriginal.valor) {
            statusCartaCorrecao += "2";
          }

          if (vm.titulo.numeroNfe != vm.tituloOriginal.numeroNfe || vm.titulo.numero != vm.tituloOriginal.numero) {
            statusCartaCorrecao += "3";
          }

          // Concatenar com status existente
          if (vm.titulo.statusCartaCorrecao) {
            statusCartaCorrecao += vm.titulo.statusCartaCorrecao.toString();
          }
        }

        if (statusCartaCorrecao != "") {
          // Remover duplicados e ordenar
          var uniqueStatus = statusCartaCorrecao.split('').filter(function (item, i, ar) { return ar.indexOf(item) === i; }).sort().join('');

          var dto = {
            viewId: vm.titulo.viewId,
            numeroNfe: vm.titulo.numeroNfe,
            numero: vm.titulo.numero,
            dataVencimento: vm.titulo.dataVencimento,
            valor: vm.titulo.valor,
            statusCartaCorrecao: uniqueStatus
          };

          $http.post(APP_MNP + "/invoice/titulo/alterar", dto).success(function (response) {
            toastr.success('Título atualizado com sucesso.', 'Sucesso');
            vm.tituloOriginal = angular.copy(vm.titulo); // Atualiza original para esconder o botao gravar
            vm.titulo.statusCartaCorrecao = parseInt(uniqueStatus);
            vm.liberarSemAlteracoes = false;
            vm.alterado = true;
          }).error(function (error) {
            var msg = (typeof error === 'string') ? error : (error.message || JSON.stringify(error));
            toastr.error(msg, 'Erro ao atualizar título');
          });
        }
      }

      vm.fechar = function () {
        if (vm.alterado) {
          $uibModalInstance.close('atualizado');
        } else {
          $uibModalInstance.close();
        }
      }

      vm.excluir = function () {
        if (confirm('Deseja realmente excluir este registro?')) {
          vm.inserirPessoa = $http.delete(APP_MNP + "/invoice/titulo/delete/" + vm.titulo.viewId).success(function (response) {
            $uibModalInstance.close('excluido');
            toastr.info('Registro excluído com sucesso.', 'Alerta');
            return response;
          }).error(function (error) {
            toastr.error(error, 'Erro no processamento');
            return error;
          });
        }
      }

      vm.init();

    }]);
'use strict';

angular.module('inspinia')
  .controller('SacadoConsultaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.sacadoParam = $state.params.obj;

    vm.init = function()
    {
        if (vm.sacadoParam == null || vm.sacadoParam == '')
        {
            $state.go('index.cadastro_sacado_pesquisa');
        }
        else
        {
            vm.pesquisar();        
        }
    }

    vm.pesquisar = function()
    {
        return $http.get(APP_MNP + "/sacado/consultar/" + vm.sacadoParam.viewId)
        .then(function(response)
        { 
            vm.sacado = response.data;
            vm.listarUsuarios();
        });
    }

    vm.atualizar = function()
    {
        if (vm.sacado.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Alerta');
            return;
        }

        if (vm.sacado.cnpj.toString().length != 18)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }

        if (vm.sacado.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        $http.post(APP_MNP + "/sacado/alterar", vm.sacado).success(function(response){
            toastr.info('Sacado atualizado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.init();

    vm.adicionarUsuario = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/sacado/consulta/usuario/cadastro/index.html',
            controller: 'SacadoCadastrarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                sacado: function () {
                    return vm.sacadoParam;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }

    vm.editarUsuario = function(usuario)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/sacado/consulta/usuario/consulta/index.html',
            controller: 'SacadoConsultarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                sacado: function () {
                    return vm.sacadoParam;
                },
                usuario: function () {
                    return usuario;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }
    
    vm.listarUsuarios = function()
    {
        return $http.get(APP_MNP + "/sacado/listarUsuarios/" + vm.sacado.viewId)
        .then(function(response)
        { 
            vm.usuarios = response.data;
        });
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceTitulosAnteciparController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'registros', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, registros, $http, APP_MNP)
  {
    var vm = this;
    vm.registros = registros;
    vm.total = {
      valorTotal : 0,
      quantidade : 0
    };

    vm.init = function()
    {
      vm.calcularTotal();
      vm.listarClientes();
    }

    vm.enviar = function()
    {
      //console.log("Registros: ",vm.registros);
      var antecipacao = {

        itens: vm.registros,
        clienteViewId: vm.clienteViewId
      };


      if (vm.registros[0].codigoVmoney == '' || vm.registros[0].codigoVmoney == null)
        {
            toastr.error('Cedente não Possui Codigo do Vmoney, Solicite ao ADM que o insira antes de Continuar', 'AÇÃO BLOQUEADA');
            return;
        };

      vm.inserirPessoa = $http.post(APP_MNP + "/invoice/antecipacao/antecipar", antecipacao).success(function(response){
          vm.fechar();
          toastr.info('Operação enviada com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.listarClientes = function()
    {
        vm.clientes = null;

        return $http.get(APP_MNP + "/ic/pesquisar")
        .then(function(response)
        {
            vm.clientes = response.data;
            vm.clienteViewId = vm.clientes[0].viewId;
        });
    }

    vm.calcularTotal = function()
    {
        var total = 0;
        var quantidade = 0;

        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.registros[i].selecionadoAntecipar)
            {
                total += vm.registros[i].valor;
                quantidade++;
            }
        }

        vm.total.valorTotal = total;
        vm.total.quantidade = quantidade;
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('IntermediadorCadastroController', ['$scope', '$state', 'toastr', '$http','APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.intermediador = {
        endereco: {}
    };

    vm.init = function()
    {

    }

    vm.salvar = function()
    {
        if (vm.intermediador.cnpj == null || vm.intermediador.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Alerta');
            return;
        }

        if (vm.intermediador.cnpj.toString().length != 18)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }

        if (vm.intermediador.razaoSocial == null || vm.intermediador.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        $http.post(APP_MNP + "/intermediador/incluir", vm.intermediador).success(function(response){
            toastr.info('Intermediador cadastrado com sucesso.', 'Alerta');
            $state.go('index.cadastro_intermediador_pesquisa');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.init();

    /*
    function validarCNPJ(s) {
        let cnpj = s.replace(/[^\d]+/g, '')
    
        // Valida a quantidade de caracteres
        if (cnpj.length !== 14)
            return false
    
        // Elimina inválidos com todos os caracteres iguais
        if (/^(\d)\1+$/.test(cnpj))
            return false
    
        // Cáculo de validação
        let t = cnpj.length - 2,
            d = cnpj.substring(t),
            d1 = parseInt(d.charAt(0)),
            d2 = parseInt(d.charAt(1)),
            calc = x => {
                let n = cnpj.substring(0, x),
                    y = x - 7,
                    s = 0,
                    r = 0
    
                    for (let i = x; i >= 1; i--) {
                        s += n.charAt(x - i) * y--;
                        if (y < 2)
                            y = 9
                    }
    
                    r = 11 - s % 11
                    return r > 9 ? 0 : r
            }
    
        return calc(t) === d1 && calc(t + 1) === d2
    }
    */

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoCadastroController', ['$scope', '$state', 'toastr', '$http','APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.sacado = {
        endereco: {}
    };

    vm.init = function()
    {

    }

    vm.salvar = function()
    {
        if (vm.sacado.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.cnpj == null || vm.sacado.cnpj.toString().length != 18)
        {
            toastr.error('CNPJ inválido.', 'Cliente');
            return;
        }

        if (vm.sacado.razaoSocial == null || vm.sacado.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Cliente');
            return;
        }

        $http.post(APP_MNP + "/sacado/incluir", vm.sacado).success(function(response){
            toastr.info('Sacado cadastrado com sucesso.', 'Alerta');
            $state.go('index.cadastro_sacado_pesquisa');
            return response;
        }).error(function(error){
            return error;
        });

        /*
        vm.salvarPromise = CedenteService.cadastrar(vm.cedente);

        vm.salvarPromise.then(function(result) {  
            if (result.status)
            {
                toastr.info('Cedente cadastrada com sucesso!', 'Cedente');
                $state.go('index.pesquisar_cedente');
            }
            else
            {
                alert('Ocorreu um erro na solicitação.');
            }
        });
        */
    }

    vm.init();

    /*
    function validarCNPJ(s) {
        let cnpj = s.replace(/[^\d]+/g, '')
    
        // Valida a quantidade de caracteres
        if (cnpj.length !== 14)
            return false
    
        // Elimina inválidos com todos os caracteres iguais
        if (/^(\d)\1+$/.test(cnpj))
            return false
    
        // Cáculo de validação
        let t = cnpj.length - 2,
            d = cnpj.substring(t),
            d1 = parseInt(d.charAt(0)),
            d2 = parseInt(d.charAt(1)),
            calc = x => {
                let n = cnpj.substring(0, x),
                    y = x - 7,
                    s = 0,
                    r = 0
    
                    for (let i = x; i >= 1; i--) {
                        s += n.charAt(x - i) * y--;
                        if (y < 2)
                            y = 9
                    }
    
                    r = 11 - s % 11
                    return r > 9 ? 0 : r
            }
    
        return calc(t) === d1 && calc(t + 1) === d2
    }
    */

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorConsultaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.fornecedorParam = $state.params.obj;

    vm.init = function()
    {
        if (vm.fornecedorParam == null || vm.fornecedorParam == '')
        {
            $state.go('index.cadastro_fornecedor_pesquisa');
        }
        else
        {
            vm.pesquisar();        
        }
    }

    vm.pesquisar = function()
    {
        return $http.get(APP_MNP + "/fornecedor/consultar/" + vm.fornecedorParam.viewId)
        .then(function(response)
        { 
            vm.fornecedor = response.data;

            vm.fornecedor.integracaoCodigoCedenteVMoney = parseInt(vm.fornecedor.complemento.codigoCedenteIntegracao);

            vm.listarUsuarios();
            vm.listarContas();
        });
    }

    vm.atualizar = function()
    {
        if (vm.fornecedor.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Alerta');
            return;
        }

        if (vm.fornecedor.cnpj.toString().length != 18)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }

        if (vm.fornecedor.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        $http.post(APP_MNP + "/fornecedor/alterar", vm.fornecedor).success(function(response){
            toastr.info('Fornecedor atualizado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.adicionarUsuario = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/fornecedor/consulta/usuario/cadastro/index.html',
            controller: 'FornecedorCadastrarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.fornecedorParam;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }

    vm.editarUsuario = function(usuario)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/fornecedor/consulta/usuario/consulta/index.html',
            controller: 'FornecedorConsultarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.fornecedorParam;
                },
                usuario: function () {
                    return usuario;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }
    
    vm.listarUsuarios = function()
    {
        return $http.get(APP_MNP + "/fornecedor/listarUsuarios/" + vm.fornecedor.viewId)
        .then(function(response)
        { 
            vm.usuarios = response.data;
        });
    }

    vm.adicionarConta = function()
    {
      var modalInstance = $uibModal.open({
          templateUrl: 'app/cadastro/fornecedor/consulta/conta/cadastro/index.html',
          controller: 'FornecedorCadastrarContaController',
          controllerAs: 'controller',
          windowClass: 'inmodal',
          size: 'lg',
          resolve: {
            fornecedor: function () {
                return vm.fornecedorParam;
            },
            conta: function () {
                return null;
            },
        }
      }).closed.then(function(){
          vm.listarContas();
      });
    }    

    vm.listarContas = function()
    {
        vm.listarContasPromise = $http.get(APP_MNP + "/fornecedor/listarContas/" + vm.fornecedor.viewId)
        .then(function(response)
        { 
            vm.contas = response.data;
        });
    }

    vm.editarConta = function(conta)
    {
        var modalInstance = $uibModal.open({
            //templateUrl: 'app/cadastro/fornecedor/consulta/conta/consulta/index.html',
            //controller: 'FornecedorConsultarContaController',
            templateUrl: 'app/cadastro/fornecedor/consulta/conta/cadastro/index.html',
            controller: 'FornecedorCadastrarContaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.fornecedorParam;
                },
                conta: function () {
                    return conta;
                },
            }
        }).closed.then(function(){
            vm.listarContas();
        });
    }

    vm.gerarCarta = function(p)
    {
        p.fornecedorRazaoSocial = vm.fornecedor.razaoSocial;

        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/fornecedor/modal/carta_comunicacao_alteracao_conta/index.html',
            controller: 'CartaComunicacaoAlteracaoContaFornecedorController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            //backdrop: 'static',
            size: 'lg',
            resolve: {
                conta: function () {
                    return p;
                },
            }
            }).closed.then(function(){
                vm.listarContas();
            });
    }

    vm.gerarCartaExtrato = function(p)
    {
        p.fornecedorRazaoSocial = vm.fornecedor.razaoSocial;

        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/fornecedor/modal/carta_extrato_seguradora/index.html',
            controller: 'CartaExtratoSeguradoraFornecedorController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            //backdrop: 'static',
            size: 'lg',
            resolve: {
                conta: function () {
                    return p;
                },
            }
            }).closed.then(function(){
                //vm.listarContas();
            });
    }

    vm.incluirSocio = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_socio/index.html',
        controller: 'FornecedorIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          tipopessoa: function () {
            return 'Sócio';
          },
          pessoa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
          //vm.consultar();
      });
    }
    vm.visualizarSocio = function(pessoa, index)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/fornecedor/modal/cadastrar_socio/index.html',
            controller: 'FornecedorIncluirSocioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            //backdrop: 'static',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.fornecedor;
                },
                tipopessoa: function () {
                    return 'Sócio';
                },
                pessoa: function () {
                    return pessoa;
                },
                indice: function () {
                    return index;
                },
            }
            }).closed.then(function(){
                //vm.consultar();
            });
    }

    vm.incluirProcurador = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_socio/index.html',
        controller: 'FornecedorIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          tipopessoa: function () {
            return 'Procurador';
          },
          pessoa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }
    vm.visualizarProcurador = function(pessoa)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/fornecedor/modal/cadastrar_socio/index.html',
            controller: 'FornecedorIncluirSocioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            //backdrop: 'static',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.fornecedor;
                },
                tipopessoa: function () {
                    return 'Procurador';
                },
                pessoa: function () {
                    return pessoa;
                },
            }
            }).closed.then(function(){
                //vm.consultar();
            });
    }

    vm.incluirEmpresa = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_empresa/index.html',
        controller: 'FornecedorIncluirEmpresaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          empresa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }
    vm.visualizarEmpresa = function(empresa)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_empresa/index.html',
        controller: 'FornecedorIncluirEmpresaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        //backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          empresa: function () {
            return empresa;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }

    vm.getDocumento = function(viewId, nome)
    {
        return $http.get(APP_MNP + "/fornecedor/consultardocumento/" + viewId)
        .then(function(response)
        { 
            vm.download(response.data.base64, response.data.tipo, nome);
        }).catch(function (data) {
            toastr.error(data, 'Alerta');
        });
    }

    vm.solicitarAberturaConta = function()
    {
        var r = confirm("Confirma a operação?");

        if (!r)
        {
            return;
        }
        
        vm.aberturaContaPromise = $http.post(APP_MNP + "/fornecedor/solicitaraberturaconta", vm.fornecedor).success(function(response){
            toastr.info('Solicitação enviada com sucesso.', 'Alerta');   
            $state.go('index.cadastro_fornecedor_pesquisa');      
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        var sliceSize = 512
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
        
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
        
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceFluxoAnaliseEtapaController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP', '$window',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP, $window)
  {
    var vm = this;
    vm.etapaViewId = $state.params.obj;
    vm.registro = {};

    vm.init = function()
    {        
        vm.consultar();
    }

    vm.consultar = function(operacao) 
    {
        
    }

    vm.consultar = function()
    {
        vm.registro = null;

        return $http.get(APP_MNP + "/antecipacaoFluxo/etapa/" + vm.etapaViewId)
        .then(function(response)
        {
            vm.registro = response.data;
        });        
    }

    vm.salvar = function() {
        vm.salvarPromise = $http.post(APP_MNP + "/antecipacaoFluxo/etapa", vm.registro).success(function(response){
            toastr.info('Etapa atualizada com sucesso.', 'Alerta');
            vm.consultar();            
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.finalizar = function() {
        if (confirm('Deseja realmente finalizar esta etapa?'))
            {
            vm.salvarPromise = $http.post(APP_MNP + "/antecipacaoFluxo/etapafinalizar", vm.registro).success(function(response){
                toastr.info('Etapa finalizada com sucesso.', 'Alerta');
                vm.voltar();            
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.aprovar = function() {
        if (confirm('Deseja realmente aprovar esta etapa?'))
        {
            vm.salvarPromise = $http.post(APP_MNP + "/antecipacaoFluxo/etapaaprovar", vm.registro).success(function(response){
                toastr.info('Etapa aprovada com sucesso.', 'Alerta');
                vm.voltar();            
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.voltar = function() {
        $window.history.back();
    }

    vm.anexar = function(campo)
    {
        //alert(campo.descricao);

        var file = {};
        file.nome = vm.selectedTempFile[0].name;
        
        //readAsDataURL        

        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {

            // file : evt.target.result
            campo.resposta = file.nome + ';' + evt.target.result;
        };

        vm.selectedTempFile = [];
        //angular.element("input[type='file']").val(null);
    }

    vm.download = function(campo)
    {
        var campos = campo.resposta.split(';')
        vm.downloadFile(campos[2].replace('base64,',''), campos[1], campos[0]);
    }

    vm.removerAnexo = function(campo)
    {
        if (confirm('Deseja realmente remover o anexo?'))
        {
            campo.resposta = '';
        }        
    }

    vm.downloadFile = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        var sliceSize = 512
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
        
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
        
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorCadastroController', ['$scope', '$state', 'toastr', '$http','APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.fornecedor = {
        endereco: {}
    };

    vm.init = function()
    {

    }

    vm.salvar = function()
    {
        if (vm.fornecedor.cnpj == null || vm.fornecedor.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Alerta');
            return;
        }

        if (vm.fornecedor.cnpj.toString().length != 18)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }

        if (vm.fornecedor.razaoSocial == null || vm.fornecedor.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        $http.post(APP_MNP + "/fornecedor/incluir", vm.fornecedor).success(function(response){
            toastr.info('Fornecedor cadastrado com sucesso.', 'Alerta');
            $state.go('index.cadastro_fornecedor_pesquisa');
            return response;
        }).error(function(error){
            return error;
        });

        /*
        vm.salvarPromise = CedenteService.cadastrar(vm.cedente);

        vm.salvarPromise.then(function(result) {  
            if (result.status)
            {
                toastr.info('Cedente cadastrada com sucesso!', 'Cedente');
                $state.go('index.pesquisar_cedente');
            }
            else
            {
                alert('Ocorreu um erro na solicitação.');
            }
        });
        */
    }

    vm.init();

    /*
    function validarCNPJ(s) {
        let cnpj = s.replace(/[^\d]+/g, '')
    
        // Valida a quantidade de caracteres
        if (cnpj.length !== 14)
            return false
    
        // Elimina inválidos com todos os caracteres iguais
        if (/^(\d)\1+$/.test(cnpj))
            return false
    
        // Cáculo de validação
        let t = cnpj.length - 2,
            d = cnpj.substring(t),
            d1 = parseInt(d.charAt(0)),
            d2 = parseInt(d.charAt(1)),
            calc = x => {
                let n = cnpj.substring(0, x),
                    y = x - 7,
                    s = 0,
                    r = 0
    
                    for (let i = x; i >= 1; i--) {
                        s += n.charAt(x - i) * y--;
                        if (y < 2)
                            y = 9
                    }
    
                    r = 11 - s % 11
                    return r > 9 ? 0 : r
            }
    
        return calc(t) === d1 && calc(t + 1) === d2
    }
    */

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseVaduTituloController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$uibModal', '$http', 'APP_MNP', 'registros', 'subtitulo', 'notas','modo',
      function($scope, $state, toastr, $uibModalInstance, $uibModal, $http, APP_MNP, registros, subtitulo, notas,  modo)
  {
    var vm = this;
    vm.subtitulo = subtitulo;
    vm.registros = registros;
    vm.notas = notas;
    vm.modo = modo || 'titulos'; // 'titulos' ou 'nfe'

        // Função ES5 para filtrar NFes únicas (evita arrow functions/const/Map)
    vm.getRegistrosFiltrados = function() {
    // Se não houver registros, retorna array vazio
    if (!vm.registros || !vm.registros.length) {
        return [];
    }

    // Se não houver modo definido ou for um modo inválido, retorna os registros sem filtrar
    if (!vm.modo || (vm.modo !== 'titulos' && vm.modo !== 'nfe')) {
        return vm.registros;
    }

    // Aplica o filtro apenas se estiver no modo 'nfe'
    if (vm.modo === 'nfe') {
        var seen = {};
        var out = [];
        for (var i = 0; i < vm.registros.length; i++) {
            var reg = vm.registros[i];
            var chave = reg && reg.titChaveNfe;
            if (chave && !seen[chave]) {
                seen[chave] = true;
                out.push(reg);
            }
        }
        return out;
    }
    
    // Para modo 'titulos' ou qualquer outro caso, retorna todos os registros
    return vm.registros;
    };

    vm.init = function() {
        console.log('Modo:', vm.modo);
        console.log('Registros:', vm.registros);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.consultarLog = function(item) {
      var subtitulo = item.titDocumento;

      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/analise/vadu/titulolog/index.html',
        controller: 'InvoiceAnaliseVaduTituloLogController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
          subtitulo: function () {
              return subtitulo;
          },
          registro: function () {
            return item;
          },
        }
      }).closed.then(function(){
          //vm.listar();
      });
    }

    vm.consultarLogNota = function(item) {
      var subtitulo = item.titChaveNfe;
      var indexNota = 0;

      for (var i=0; i < vm.notas.length; i++) {
        if (vm.notas[i].borchaChaveNfe == item.titChaveNfe) {
          indexNota = i;
        }
      }

      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/analise/vadu/nota/index.html',
        controller: 'InvoiceAnaliseVaduNotaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
          subtitulo: function () {
              return subtitulo;
          },
          registro: function () {
            return vm.notas[indexNota];
          },
        }
      }).closed.then(function(){
          //vm.listar();
      });
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseVaduTituloLogController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'registro', 'subtitulo',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, registro, subtitulo)
  {
    var vm = this;
    vm.subtitulo = subtitulo;
    vm.registro = registro;
    vm.bloqueios = [];
    vm.alertas = [];
    vm.transferidos = [];
    vm.liberados = [];
    vm.semProblemas = [];

    vm.init = function()
    {
      for (var i=0; i < vm.registro.logs.length; i++) {
        switch (vm.registro.logs[i].titlogAcao) {
          case "B":
            vm.bloqueios.push(vm.registro.logs[i]);
            break;
          case "A":
            vm.alertas.push(vm.registro.logs[i]);
            break;
          case "T":
            vm.transferidos.push(vm.registro.logs[i]);
            break;
          case "L":
            vm.liberados.push(vm.registro.logs[i]);
            break;
          default:
            vm.semProblemas.push(vm.registro.logs[i]);
            break;
        }
      }
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
  };

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseVaduSacadoController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'registro', 'subtitulo',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, registro, subtitulo)
  {
    var vm = this;
    vm.subtitulo = subtitulo;
    vm.registro = registro;
    vm.bloqueios = [];
    vm.alertas = [];
    vm.transferidos = [];
    vm.liberados = [];
    vm.semProblemas = [];

    vm.init = function()
    {
      for (var i=0; i < vm.registro.logs.length; i++) {
        switch (vm.registro.logs[i].saclogAcao) {
          case "B":
            vm.bloqueios.push(vm.registro.logs[i]);
            break;
          case "A":
            vm.alertas.push(vm.registro.logs[i]);
            break;
          case "T":
            vm.transferidos.push(vm.registro.logs[i]);
            break;
          case "L":
            vm.liberados.push(vm.registro.logs[i]);
            break;
          default:
            vm.semProblemas.push(vm.registro.logs[i]);
            break;
        }
      }
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
  };

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseVaduNotaController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'registro', 'subtitulo',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, registro, subtitulo)
  {
    var vm = this;
    vm.subtitulo = subtitulo;
    vm.registro = registro;
    vm.bloqueios = [];
    vm.alertas = [];
    vm.transferidos = [];
    vm.liberados = [];
    vm.semProblemas = [];

    vm.init = function()
    {
      for (var i=0; i < vm.registro.logs.length; i++) {
        switch (vm.registro.logs[i].chalogAcao) {
          case "B":
            vm.bloqueios.push(vm.registro.logs[i]);
            break;
          case "A":
            vm.alertas.push(vm.registro.logs[i]);
            break;
          case "T":
            vm.transferidos.push(vm.registro.logs[i]);
            break;
          case "L":
            vm.liberados.push(vm.registro.logs[i]);
            break;
          default:
            vm.semProblemas.push(vm.registro.logs[i]);
            break;
        }
      }
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
  };

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseVaduCedenteController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'registros', 'subtitulo',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, registros, subtitulo)
  {
    var vm = this;
    vm.subtitulo = subtitulo;
    vm.registros = registros;

    vm.init = function()
    {

    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseTituloController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$uibModal', '$http', 'APP_MNP', 'titulo', 'tituloId', 'antecipacaoId',
      function($scope, $state, toastr, $uibModalInstance, $uibModal, $http, APP_MNP, titulo, tituloId, antecipacaoId)
  {
    var vm = this;
    vm.titulo = titulo || { erros: [] }; // Inicializa o título com erros vazios se não fornecido
    vm.tituloId = tituloId || vm.titulo.tituloId || null; // Garante que o TituloId seja inicializado corretamente
    vm.antecipacaoId = antecipacaoId || null; // Recebe o AntecipacaoId

    //console.log('Título recebido:', vm.titulo); // Verifica o título recebido
    //console.log('Título ID:', vm.tituloId); // Verifica o TituloId recebido

    vm.init = function() {
      // Inicialização adicional, se necessário
    };

    vm.fechar = function() {
      if (vm.titulo.recusado && (!vm.titulo.erros || vm.titulo.erros.length === 0)) {
        // Exibe mensagem de alerta se o título estiver marcado como recusado e não tiver ocorrências
        toastr.warning('Para recusar, é necessário informar uma ocorrência de recusa.', 'Atenção');
        return;
      }
      $uibModalInstance.close();
    };

 
    vm.adicionarOcorrencia = function(titulo) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/analise/detalhe/ocorrencia/index.html',
        controller: 'InvoiceAnaliseOcorrenciaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
          erros: function () {
            return angular.copy(titulo.erros) || []; // Garante que erros seja uma lista
          },
          filtrarPorCategoria: function () {
            return true; // Aplica o filtro de categoria
          },
          categoriaFiltro: function () {
            return 3; // Define a categoria do filtro como 3 - Titulos
          },
          tituloModal: function () {
            return 'Ocorrências do Título'; // Define o título da modal
          },
          tituloIds: function () {
            return [vm.tituloId]; // Passa o ID do título atual
          },
          antecipacaoId: function () {
            return vm.antecipacaoId; // Passa o AntecipacaoId para o modal
          },
          origemTela: function () {
            return 'tela_titulos'; // Define a origem como "tela_titulos"
          },
          titulo: function () {
            return angular.copy(titulo); // Passa o título atual com os erros e origem
          }
        }
      });

      modalInstance.result.then(function(novasOcorrencias) {
        if (novasOcorrencias && novasOcorrencias.length > 0) {
          // Atualiza os erros do título atual
          novasOcorrencias.forEach(function(ocorrencia) {
            var jaExiste = titulo.erros.some(function(erro) {
              return erro.codigoErroVmoney === ocorrencia.codigoErroVmoney;
            });
            if (!jaExiste) {
              titulo.erros.push(ocorrencia);
            }
          });

          // Atualiza o campo descricaolinha
          titulo.descricaolinha = titulo.erros.map(function(erro) {
            return erro.descricao;
          }).join(', ');

          toastr.success('Ocorrências adicionadas com sucesso ao título!', 'Sucesso');
        }
      }, function() {
        console.log('Modal fechado sem salvar.');
      });
    };

    vm.remover = function(item) {
      for (var i = 0; i < vm.titulo.erros.length; i++) {
        if (vm.titulo.erros[i].id == item.id) {
          console.log('Removendo erro:', vm.titulo.erros[i]); // Verifica o erro a ser removido
          vm.titulo.erros.splice(i, 1); 
        }
      }

      // Adiciona os dados para salvar no backend
      var dadosParaSalvar = [{
        AntecipacaoId: vm.antecipacaoId, // Usa o AntecipacaoId recebido
        TituloId: vm.tituloId, // Usa o TituloId recebido
        ErroId: item.id, // Usa o ID do erro removido
        Remover: 'REMOVER' // Define a ação como "REMOVER"
      }];

      // Faz a chamada ao backend para salvar os dados
      $http.post(APP_MNP + "/analiseoperacao/salvarOcorrencias", dadosParaSalvar)
        .then(function(response) {
          toastr.success('Erro removido e alterações salvas com sucesso!', 'Sucesso');
        })
        .catch(function(error) {
          toastr.error('Erro ao salvar as alterações: ' + error.data.message, 'Erro');
        });
    };

    vm.init();
  }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseOcorrenciaController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$uibModal', '$http', 'APP_MNP', 'erros', 'filtrarPorCategoria', 'tituloModal', 'categoriaFiltro', 'tituloIds', 'antecipacaoId', 'origemTela', 'titulo',
      function($scope, $state, toastr, $uibModalInstance, $uibModal, $http, APP_MNP, erros, filtrarPorCategoria, tituloModal, categoriaFiltro, tituloIds, antecipacaoId, origemTela, titulo)
  {
    var vm = this;
    vm.erros = erros || []; // Garante que erros seja uma lista
    vm.tituloModal = tituloModal || ''; // Define o título da modal
    vm.tituloIds = Array.isArray(tituloIds) && tituloIds.length > 0 
      ? tituloIds 
      : (titulo && titulo.tituloId ? [titulo.tituloId] : []); // Garante que TituloIds seja sempre um array
    //console.log('Título IDs recebidos:', vm.tituloIds); // Verifica os TituloIds recebidos
    vm.antecipacaoId = antecipacaoId || null; // Recebe o AntecipacaoId
    vm.origemTela = origemTela || ''; // Recebe a origem da chamada
    vm.titulo = titulo || { erros: [] }; // Inicializa o título com erros vazios se não for fornecido
   // console.log('Títulos com lista de Erros ', vm.titulo); // Verifica o título recebido
   // console.log('Lista de erros Na chamada:', vm.titulo.erros); // Log da lista de erros antes da remoção


    vm.init = function() {
      if (vm.tituloIds.length === 0) {
        console.error('Nenhum TituloId foi recebido. Verifique a chamada do modal.');
      }
    
      if (vm.origemTela === 'tela_titulos') {
        vm.titulo.erros = Array.isArray(titulo && titulo.erros) ? titulo.erros : [];
      } else {
        vm.titulo.erros = Array.isArray(vm.titulo.erros) ? vm.titulo.erros : [];
      }
    
      //console.log('Antes da cópia:', JSON.stringify(vm.titulo.erros)); // 👈 Veja o conteúdo original
    
      vm.errosCopia = angular.copy(vm.titulo.erros);
    
      //console.log('Depois da cópia:', JSON.stringify(vm.errosCopia)); // 👈 Veja o conteúdo copiado
    
      vm.lista = [];
      vm.listarErros(filtrarPorCategoria, categoriaFiltro);
    };
    

    vm.listarErros = function(filtrarPorCategoria, categoriaFiltro) {
      vm.consultarErros = $http.get(APP_MNP + "/invoice/antecipacaoocorrenciaerro/all")
      .success(function(response) { 
        vm.lista = filtrarPorCategoria 
          ? response.filter(function(erro) {
              return erro.categoria === categoriaFiltro; // Aplica o filtro de categoria
            })
          : response;

        vm.lista.forEach(function(erro) {
          erro.selecionado = false;
        });

        if (Array.isArray(vm.erros) && vm.erros.length > 0) {
          vm.erros.forEach(function(erroExistente) {
            vm.lista = vm.lista.filter(function(erro) {
              return erro.id !== erroExistente.id;
            });
          });
        }
      }).error(function(error) {
        toastr.error(error, 'Alerta');
      }); 
    };

    vm.confirmar = function() {
      if (Array.isArray(vm.erros)) {
        var ocorrenciasParaSalvar = [];
        var novasOcorrencias = []; // Inicializa como um array vazio

        if (vm.origemTela === 'tela_titulos') {
          novasOcorrencias = angular.copy(vm.erros); // Copia as ocorrências existentes
        }
        

        vm.lista.forEach(function(erro) {
          if (erro.selecionado) {
            vm.tituloIds.forEach(function(tituloId) {
              ocorrenciasParaSalvar.push({
                AntecipacaoId: vm.antecipacaoId, // Usa o AntecipacaoId recebido
                TituloId: tituloId, // Usa cada TituloId da lista
                ErroId: erro.id, // Usa o ID do erro selecionado
                Origem: 1, // Define a origem como 1 (ou outro valor conforme necessário)
              });
            });

            novasOcorrencias.push({
              id: erro.id,
              codigoErroVmoney: erro.codigoErroVmoney,
              descricao: erro.descricao,
              origem: 1, // Define a origem como 1 (ou outro valor conforme necessário)
              nivel: 0,
              categoria: erro.categoria,
              criticidade: erro.criticidade || 'N' // Define criticidade como 'N' se não estiver definida
            });
          }
        });

        if (ocorrenciasParaSalvar.length > 0) {
          $http.post(APP_MNP + "/analiseoperacao/salvarOcorrencias", ocorrenciasParaSalvar)
            .then(function(response) {
              toastr.success('Ocorrências salvas com sucesso!', 'Sucesso');
              $uibModalInstance.close(novasOcorrencias); // Retorna apenas as ocorrências selecionadas
            })
            .catch(function(error) {
              toastr.error('Erro ao salvar as ocorrências: ' + error.data.message, 'Erro');
            });
        } else {
          $uibModalInstance.close(novasOcorrencias); // Retorna as ocorrências mesmo sem alterações
        }
      }
    };


    vm.remover = function(item) {
      //console.log('Item a ser removido:', item); // Log do item a ser removido
  
      // Cria uma cópia do array para evitar alterações inesperadas
      //console.log('Lista de erros antes da remoção (cópia):', vm.errosCopia); // Log da lista de erros antes da remoção
  
      // Verifica se o item existe no array de erros
      var index = vm.errosCopia.findIndex(function(erro) {
          return erro.codigoErroVmoney === item.codigoErroVmoney && erro.descricao === item.descricao; // Compara propriedades únicas
      });
  
      if (index !== -1) {
          console.log('Removendo erro:', vm.errosCopia[index]); // Log do erro a ser removido
          vm.errosCopia.splice(index, 1); // Remove o erro do array
          vm.titulo.erros = angular.copy(vm.errosCopia); // Atualiza o array original com a cópia modificada
        //  console.log('Lista de erros após a remoção:', vm.titulo.erros); // Log da lista de erros após a remoção
  
          // Atualiza o campo descricaolinha no controlador principal
          $scope.$emit('ocorrenciaRemovida', {
              tituloId: vm.tituloIds[0],
              codigoErroVmoney: item.codigoErroVmoney
          });
      } else {
          console.warn('Erro não encontrado para remoção:', item); // Log de aviso se o erro não for encontrado
          return;
      }
  
      // Adiciona os dados para salvar no backend
      var dadosParaSalvar = [{
          AntecipacaoId: vm.antecipacaoId, // Usa o AntecipacaoId recebido
          TituloId: vm.tituloIds[0], // Usa o primeiro TituloId recebido
          ErroId: item.id, // Usa o ID do erro removido
          Remover: 'REMOVER' // Define a ação como "REMOVER"
      }];

  
      // Faz a chamada ao backend para salvar os dados
      $http.post(APP_MNP + "/analiseoperacao/salvarOcorrencias", dadosParaSalvar)
          .then(function(response) {
              toastr.success('Erro removido e alterações salvas com sucesso!', 'Sucesso');
          })
          .catch(function(error) {
              toastr.error('Erro ao salvar as alterações: ' + error.data.message, 'Erro');
          });
  };    

    
    vm.fechar = function() {
      console.log('Modal fechado COM SUCESSO.');
      $uibModalInstance.dismiss('cancel');
    };

    vm.init();
  }]);
'use strict';

angular.module('inspinia')
  .controller('FluxoAprovacaoEtapaCampoConfigController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'etapa',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, etapa)
{
    var vm = this;
    vm.registro = {
      tipoResposta: '0'
    };

    vm.init = function()
    {
    }

    vm.salvar = function() {
      // CRIAR
      if (!vm.isUpdate) {

          vm.registro.fluxoAprovacaoEtapaModelo = {
              viewId : etapa
          };            
          vm.registro.viewId = '00000000-0000-0000-0000-000000000000';

          vm.salvarPromise = $http.post(APP_MNP + "/fluxoaprovacao/campo", vm.registro).success(function(response){
              toastr.info('Registro cadastrada com sucesso.', 'Alerta');
              vm.fechar();
          }).error(function(error){
              toastr.error(error, 'Alerta');
              return error;
          });
      }
      // ATUALIZAR
      else {

      }
  }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('CarteiraModalBoletoController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'item', '$sce',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, item, $sce)
  {
    var vm = this;
    vm.item = item;

    vm.init = function()
    {
      vm.filePdf = $sce.trustAsResourceUrl('data:application/pdf;base64,' + vm.item);
    }

    vm.visualizarBoleto = function() {
      $uibModalInstance.close(false);
    }

    vm.visualizarBoletoAtualizado = function() {
      $uibModalInstance.close(true);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('BoletoVencidoGerarController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_MNP', '$uibModal', 'AuthService',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_MNP, $uibModal, AuthService)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.usoDeBoleto = AuthService.getUsoDeBoleto();
    
 
    
    

    vm.init = function()
    {
      /*
      vm.consultaPromise = $http.get(APP_MNP + "/ccb/antecipacaodetalhe/" + antecipacao.viewId)
      .then(function(response)
      { 
        vm.registro = response.data;
      });
      */
    }

  

   vm.visualizarBoleto = function() { 
     antecipacao.isGerarAtualizado = false;
     
     vm.consultaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", antecipacao).success(function(response){
         
         //vm.download(response, 'application/pdf', 'boleto.pdf');
         var modalInstance = $uibModal.open({
           templateUrl: 'app/email/carteira/modal/boleto/index.html',
           controller: 'CarteiraModalBoletoController',
           controllerAs: 'controller',
           windowClass: 'inmodal',
           size: 'lg',
           resolve: {
               item: function () {
                   return response;
               },
           }
       }).closed.then(function(){
           //vm.listar();
       });
        return response;
     }).error(function(error){
         toastr.error(error, 'Alerta');
         return error;
     });
   }

    vm.visualizarBoletoAtualizado = function() {
      antecipacao.isGerarAtualizado = true;

      vm.consultaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", antecipacao).success(function(response){
          
          //vm.download(response, 'application/pdf', 'boleto.pdf');
          var modalInstance = $uibModal.open({
            templateUrl: 'app/email/carteira/modal/boleto/index.html',
            controller: 'CarteiraModalBoletoController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                item: function () {
                    return response;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });

          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
    }

    vm.antesBoletoOriginal = function()
    {
      var mensgemBoleto = 1;
      return mensgemBoleto;
    }


    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('BoletoEmailVencidoGerarController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP)
  {
    var vm = this;

    vm.init = function()
    {
    }

    vm.visualizarBoleto = function() {
      $uibModalInstance.close(false);
    }

    vm.visualizarBoletoAtualizado = function() {
      $uibModalInstance.close(true);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ContaGraficaRelatorioExtratoPdfController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', '$sce',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, $sce)
  {
    var vm = this;

    vm.init = function()
    {
      vm.filePdf =  $sce.trustAsResourceUrl(APP_MNP + "/contagrafica/extrato/pdf");
      /*
      vm.consultarPromise = $http.get(APP_MNP + "/invoice/titulo/consultar/" + titulo.viewId)
      .then(function(response)
      { 
          vm.titulo = response.data;
      });
      */
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ContaGraficaRelatorioExtratoDetalheController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'registro',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, registro)
  {
    var vm = this;
    vm.registro = registro;

    vm.init = function() {
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ContaGraficaAcertoHistoricoDetalheController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'registro',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, registro)
  {
    var vm = this;
    vm.registro = registro;

    vm.init = function()
    {
      vm.consultar();
    }

    vm.consultar = function() {
      vm.pesquisarPromise = $http.get(APP_MNP + "/contagrafica/cobrancaacerto/historicodetalhe/" + vm.registro.viewId)
      .then(function(response)
      { 
          vm.registros = response.data;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('OriginadorIncluirSocioController', ['$scope', '$state', 'fornecedor', 'toastr', 'tipopessoa', '$uibModalInstance', '$http', 'pessoa', 'APP_MNP', 'indice',
      function($scope, $state, fornecedor, toastr, tipopessoa, $uibModalInstance, $http, pessoa, APP_MNP, indice)
{
    var vm = this;
    vm.tipoPessoa = tipopessoa;
    vm.fornecedor = fornecedor;

    vm.pessoa = {};

    vm.init = function()
    {
      if (pessoa != null)
      {
        vm.pessoa = pessoa;
      }
    }

    vm.incluir = function()
    {
      vm.pessoa.originadorViewId = vm.fornecedor.viewId;

      vm.incluirPromise = $http.post(APP_MNP + "/empresaoriginador/adicionarsocio", vm.pessoa).success(function(response){
        //$state.go('confirmar_cadastro.finalizar');
        vm.pessoa.viewId = response;

        //vm.fornecedor.socios.push(vm.pessoa);

        //toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        vm.fechar();
        //vm.etapa = 2;

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.atualizar = function()
    {
      vm.pessoa.originadorViewId = vm.fornecedor.viewId;

      vm.incluirPromise = $http.post(APP_MNP + "/empresaoriginador/atualizarsocio", vm.pessoa).success(function(response){
        //$state.go('confirmar_cadastro.finalizar');
        vm.pessoa.viewId = response;

        //vm.fornecedor.socios.splice(indice, 1);
        //vm.fornecedor.socios.push(vm.pessoa);

        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('SacadoSelecionarNovoController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', '$compile', 'AuthService',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, $compile,  AuthService)
  {
    
    var vm = this;
    vm.sacado = {
        endereco: {}
    };

    vm.init = function()
    {

    }

    vm.salvar = function()
    {
        var tipoDocumentoDescricao = AuthService.getTipoDocumentoDescricao();
     

        if (vm.sacado.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.cnpj == null || (vm.sacado.cnpj.toString().length != 18 && vm.sacado.cnpj.toString().length != 14))
        {
            toastr.error('CPF/CNPJ inválido.', 'Cliente');
            return;
        }

        if (tipoDocumentoDescricao !== 'Cheque')
        {
            if (vm.sacado.endereco.cep == null || vm.sacado.endereco.cep == '') 
            {
                toastr.error('CEP é obrigatório, Documento escolhido é ' + tipoDocumentoDescricao, 'Cliente');
                return;
            }
    
            if (vm.sacado.endereco.logradouro == null || vm.sacado.endereco.logradouro == '')
            {
                toastr.error('Logradouro é obrigatório.', 'Cliente');
                return;
            }
    
            if (vm.sacado.endereco.cidade == null || vm.sacado.endereco.cidade == '')
            {
                toastr.error('Cidade é obrigatório.', 'Cliente');
                return;
            }
    
            if (vm.sacado.endereco.uf == null || vm.sacado.endereco.uf == '')
            {
                toastr.error('Estado é obrigatório.', 'Cliente');
                return;
            }

        }

        if (vm.sacado.razaoSocial == null || vm.sacado.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Cliente');
            return;
        }



        vm.salvarPromise = $http.post(APP_MNP + "/sacado/incluir", vm.sacado).success(function(response){
            toastr.info('Sacado cadastrado com sucesso.', 'Alerta');
            $uibModalInstance.close(vm.sacado);
            return response;
        }).error(function(error){
            return error;
        });

        /*
        vm.salvarPromise = CedenteService.cadastrar(vm.cedente);

        vm.salvarPromise.then(function(result) {  
            if (result.status)
            {
                toastr.info('Cedente cadastrada com sucesso!', 'Cedente');
                $state.go('index.pesquisar_cedente');
            }
            else
            {
                alert('Ocorreu um erro na solicitação.');
            }
        });
        */
    }

    vm.init();

    /*
    function validarCNPJ(s) {
        let cnpj = s.replace(/[^\d]+/g, '')
    
        // Valida a quantidade de caracteres
        if (cnpj.length !== 14)
            return false
    
        // Elimina inválidos com todos os caracteres iguais
        if (/^(\d)\1+$/.test(cnpj))
            return false
    
        // Cáculo de validação
        let t = cnpj.length - 2,
            d = cnpj.substring(t),
            d1 = parseInt(d.charAt(0)),
            d2 = parseInt(d.charAt(1)),
            calc = x => {
                let n = cnpj.substring(0, x),
                    y = x - 7,
                    s = 0,
                    r = 0
    
                    for (let i = x; i >= 1; i--) {
                        s += n.charAt(x - i) * y--;
                        if (y < 2)
                            y = 9
                    }
    
                    r = 11 - s % 11
                    return r > 9 ? 0 : r
            }
    
        return calc(t) === d1 && calc(t + 1) === d2
    }
    */

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorIncluirSocioController', ['$scope', '$state', 'fornecedor', 'toastr', 'tipopessoa', '$uibModalInstance', '$http', 'pessoa', 'APP_MNP', 'indice',
      function($scope, $state, fornecedor, toastr, tipopessoa, $uibModalInstance, $http, pessoa, APP_MNP, indice)
{
    var vm = this;
    vm.tipoPessoa = tipopessoa;
    vm.fornecedor = fornecedor;

    vm.pessoa = {
      isSocio: true,
      isAvalista: false,
      isFielDepositario: false,
    };

    vm.arquivos = {
      arq1: '',
      arq2: '',
      arq3: '',
      arq4: '',
      arq5: '',
      arq6: '',
      arq7: '',
    };

    vm.init = function()
    {
      if (pessoa != null)
      {
        vm.pessoa = pessoa;
        vm.loadDocumentos();
      }
    }

    vm.loadDocumentos = function()
    {
      if (vm.pessoa.documentos != null)
      {
        for (var i = 0; i <= vm.pessoa.documentos.length; i++)
        {
          if (vm.pessoa.documentos[i] != null)
          {
            switch (vm.pessoa.documentos[i].tipo)
            {
              case 1:
                vm.arquivos.arq1 = vm.pessoa.documentos[i];
                break;
              case 2:
                vm.arquivos.arq2 = vm.pessoa.documentos[i];
                break;
              case 3:
                vm.arquivos.arq3 = vm.pessoa.documentos[i];
                break;
              case 4:
                vm.arquivos.arq4 = vm.pessoa.documentos[i];
                break;  
              case 5:
                vm.arquivos.arq5 = vm.pessoa.documentos[i];
                break;
              case 6:
                vm.arquivos.arq6 = vm.pessoa.documentos[i];
                break;
              case 7:
                vm.arquivos.arq7 = vm.pessoa.documentos[i];
                break;
            }
          }
        }
      }
    }

    vm.incluir = function()
    {

      var api = 'adicionarsocio';

      if (vm.tipoPessoa == 'Procurador')
      {
        api = 'adicionarprocurador';
      }

      if (api == 'adicionarsocio' && vm.pessoa.isSocio == false && vm.pessoa.isAvalista == false && vm.pessoa.isFielDepositario == false) {
        alert('Selecione o tipo de pessoa (Sócio, Avalista ou Fiel Depositário).');
        return;
      }

      if (vm.pessoa.assinaPelaEmpresaText != null && vm.pessoa.assinaPelaEmpresaText != '')
      {
        vm.pessoa.assinaPelaEmpresa = parseInt(vm.pessoa.assinaPelaEmpresaText);
      }

      vm.pessoa.cedenteViewId = vm.fornecedor.viewId;

      vm.incluirPromise = $http.post(APP_MNP + "/cedente/" + api, vm.pessoa).success(function(response){
        //$state.go('confirmar_cadastro.finalizar');
        vm.pessoa.viewId = response;

        if (vm.tipoPessoa == 'Procurador')
        {
          vm.fornecedor.procuradores.push(vm.pessoa);
        }
        else
        {
          vm.fornecedor.socios.push(vm.pessoa);
        }

        //toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        vm.fechar();
        //vm.etapa = 2;

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.atualizar = function()
    {
      var api = 'atualizarsocio';

      if (vm.tipoPessoa == 'Procurador')
      {
        api = 'atualizarprocurador';
      }

      if (vm.pessoa.assinaPelaEmpresaText != null && vm.pessoa.assinaPelaEmpresaText != '')
      {
        vm.pessoa.assinaPelaEmpresa = parseInt(vm.pessoa.assinaPelaEmpresaText);
      }

      if (api == 'adicionarsocio' && vm.pessoa.isSocio == false && vm.pessoa.isAvalista == false && vm.pessoa.isFielDepositario == false) {
        alert('Selecione o tipo de pessoa (Sócio, Avalista ou Fiel Depositário).');
        return;
      }

      vm.pessoa.cedenteViewId = vm.fornecedor.viewId;

      vm.incluirPromise = $http.post(APP_MNP + "/cedente/" + api, vm.pessoa).success(function(response){
        //$state.go('confirmar_cadastro.finalizar');
        vm.pessoa.viewId = response;

        if (vm.tipoPessoa == 'Procurador')
        {
          vm.fornecedor.procuradores.splice(indice, 1);
          vm.fornecedor.procuradores.push(vm.pessoa);
        }
        else
        {
          vm.fornecedor.socios.splice(indice, 1);
          vm.fornecedor.socios.push(vm.pessoa);
        }

        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.adicionarDocumento = function(tipo)
    {
      var cnab = {};      
      vm.file = {};
      vm.file.nome = vm.selectedTempFile[0].name;
      vm.file.tipo = tipo;
      
      var reader = new FileReader();
      reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
      reader.onload = function (evt) {          
          vm.file.base64 = evt.target.result;          

          var pessoa = {
            nome: vm.file.nome,
            tipo: vm.file.tipo,
            base64: vm.file.base64,
            cedenteViewId: vm.fornecedor.viewId,
          };
          //pessoa.documentos.push(vm.file);
          //pessoa.cedenteViewId = vm.fornecedor.viewId;

          var api = 'adicionardocumentosocio';

          if (vm.tipoPessoa == 'Procurador')
          {
            api = 'adicionardocumentoprocurador';
          }

          vm.uploadPromise = $http.post(APP_MNP + "/cedente/" + api, pessoa).success(function(response){
            toastr.info('Arquivo enviado com sucesso.', 'Alerta');

            if (vm.pessoa.documentos != null)
            {
              for (var i = 0; i < vm.pessoa.documentos.length; i++)
              {
                if (vm.pessoa.documentos[i].tipo == vm.file.tipo)
                {
                  vm.pessoa.documentos.splice(i, 1);
                }
              }
            }
            else {
              vm.pessoa.documentos = [];
            }
            vm.file.viewId = response;
            vm.file.base64 = null;
            vm.pessoa.documentos.push(vm.file);

            vm.loadDocumentos();

            vm.file = {};
            return response;
          }).error(function(error){
            vm.file = {};
            toastr.error(error, 'Alerta');
            return error;
          });
      };
      
      vm.selectedTempFile = [];
      angular.element("input[type='file']").val(null);      
    }

    vm.getDocumento = function(arq)
    {
        var api = 'consultardocumentosocio/';

        if (vm.tipoPessoa == 'Procurador')
        {
          var api = 'consultardocumentoprocurador/';
        }

        return $http.get(APP_MNP + "/cedente/" + api + arq.viewId)
        .then(function(response)
        { 
            vm.download(response.data.base64, response.data.tipoDesc, arq.nome);
        }).catch(function (data) {
            toastr.error(data, 'Alerta');
        });
    }

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
  }

}]);

'use strict';

angular.module('inspinia')
  .controller('FornecedorIncluirEmpresaController', ['$scope', '$state', 'fornecedor', 'toastr', '$uibModalInstance', '$http', 'empresa', 'APP_MNP', 'indice',
      function($scope, $state, fornecedor, toastr, $uibModalInstance, $http, empresa, APP_MNP, indice)
{
    var vm = this;

    vm.empresa = {};
    vm.fornecedor = fornecedor;

    vm.init = function()
    {
      if (empresa != null)
      {
        vm.empresa = empresa;
      }
    }

    vm.incluir = function()
    {
      vm.empresa.cedenteViewId = vm.fornecedor.viewId;
      
      vm.incluirPromise = $http.post(APP_MNP + "/cedente/adicionarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.atualizar = function()
    {
      vm.empresa.cedenteViewId = vm.fornecedor.viewId;

      vm.incluirPromise = $http.post(APP_MNP + "/cedente/atualizarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.splice(indice, 1);
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('CedentePocexpressaTarifaController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'poc', 'tarifa',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, poc, tarifa)
{
    var vm = this;
    vm.poc = poc;
    vm.tarifa = tarifa;
    vm.registro = {
      taxaFator: 0,
    };
    vm.isUpdate = false;

    vm.init = function()
    {
      if (vm.tarifa != null) {
        vm.isUpdate = true;
        if (vm.tarifa.isUpdate == null) {
          vm.tarifa.isUpdate = true;
          vm.registro.taxaFator = vm.tarifa.taxaFator.toFixed(2);
          vm.registro.tipoDocumento = vm.tarifa.tipoDocumento;
          vm.registro.tarifa = vm.tarifa.tarifa.toFixed(2);
          vm.registro.tac = vm.tarifa.tac.toFixed(2);
          vm.registro.ted = vm.tarifa.ted.toFixed(2);
          vm.registro.despesaAdicional = vm.tarifa.despesaAdicional.toFixed(2);
          vm.registro.registro = vm.tarifa.registro.toFixed(2);
          vm.registro.consultaSerpro = vm.tarifa.consultaSerpro.toFixed(2);
        }
        else {
          vm.registro = vm.tarifa;
        }
      }
      else {
        vm.listarTiposDocumento();
      }
    }

    vm.listarTiposDocumento = function()
    {
      vm.consultaTipoDocumentoPromise = $http.get(APP_MNP + "/invoice/tituloTipoDocumento/pesquisar")
      .then(function(response)
      { 
          //vm.tiposDocumento = response.data; 
          var tipos = response.data;

          for (var i=0; i<vm.poc.tarifas.length; i++) {
            for (var j=0; j<tipos.length; j++) {
              if (vm.poc.tarifas[i].tipoDocumento.id == tipos[j].id) {
                tipos.splice(j, 1);
              }
            }
          }

          vm.tiposDocumento = tipos;
          if (vm.tiposDocumento.length > 0)
          {
              vm.registro.tipoDocumento = vm.tiposDocumento[0];
          }
      });
    }

    vm.salvar = function() {
      if (vm.registro.tipoDocumento == null)
      {
        alert('Selecione um tipo de documento.');
        return;
      }

      var tarifa = {
        taxaFator: vm.registro.taxaFator,
        tipoDocumento: vm.registro.tipoDocumento,
        tarifa: vm.toFloat(vm.registro.tarifa),
        tac: vm.toFloat(vm.registro.tac),
        ted: vm.toFloat(vm.registro.ted),
        despesaAdicional: vm.toFloat(vm.registro.despesaAdicional),
        registro: vm.toFloat(vm.registro.registro),
        consultaSerpro: vm.toFloat(vm.registro.consultaSerpro),
      };
      vm.poc.tarifas.push(tarifa);
      $uibModalInstance.close();
    }

    vm.atualizar = function() {
      vm.tarifa.taxaFator = vm.registro.taxaFator,
      vm.tarifa.tarifa = vm.toFloat(vm.registro.tarifa),
      vm.tarifa.tac = vm.toFloat(vm.registro.tac),
      vm.tarifa.ted = vm.toFloat(vm.registro.ted),
      vm.tarifa.despesaAdicional = vm.toFloat(vm.registro.despesaAdicional),
      vm.tarifa.registro = vm.toFloat(vm.registro.registro),
      vm.tarifa.consultaSerpro = vm.toFloat(vm.registro.consultaSerpro),

      $uibModalInstance.close();
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

    vm.toFloat = function(valor) {
        return valor.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.').replaceAll(' ','');
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('CedentePocexpressaListarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', 'modalService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService,  modalService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.novaPoc = function() {
        $state.go('index.cedente_pocexpressa');
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;

        vm.consultarPromise = $http.post(APP_MNP + "/poc/pesquisarimportar")
        .success(function(response){
            var hoje = new Date();
            hoje.setHours(0,0,0,0);

            for (var i=0; i < response.length; i++) {
                var validadeAte = new Date(response[i].validadeAte);
                validadeAte.setHours(0,0,0,0);

                if (validadeAte >= hoje) {
                    response[i].isVencido = false;
                }
                else {
                    response[i].isVencido = true;
                }
            }

            vm.registrosOriginal = response;
            vm.registros = response;
            vm.filtrarPesquisa();
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.consultar = function(item)
    {
        $state.go('index.cedente_pocexpressa', {obj: item.viewId});
    }

    vm.excluir = function(item)
    {
        var confirmacao = prompt('Para confirmar a exclusão da POC de "' + item.cedente.razaoSocial + '", digite: excluir');
        if (confirmacao === null) return;
        if (confirmacao.trim().toLowerCase() !== 'excluir') {
            toastr.error('Palavra incorreta. Exclusão cancelada.', 'Alerta');
            return;
        }
        $http.put(APP_MNP + "/poc/desativar/" + item.viewId)
        .then(function() {
            toastr.info('POC excluída com sucesso.', 'Alerta');
            vm.pesquisar();
        }, function(error) {
            toastr.error(error.data || 'Erro ao excluir POC.', 'Alerta');
        });
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.fantasia != null && vm.filtro.fantasia != '')
            {
                if (!vm.registrosOriginal[i].cedente.nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].cedente.razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].cedente.id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cedente.cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.tipoOriginadorTexto = function(tipo) {
        switch(tipo) {
            case 0: return 'Factoring';
            case 1: return 'Securitizadora';
            case 2: return 'FIDC';
            case 3: return 'ESC';
            default: return '';
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('CedentePocexpressaSalvarController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'poc',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, poc)
{
    var vm = this;

    vm.item = poc;

    vm.init = function()
    {
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('CedentePocexpressaHistoricoController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'item',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, item)
{
    var vm = this;

    vm.item = item;
    vm.registro = item.pocDepoisObjeto;

    vm.init = function()
    {
      if (vm.registro.atualizado != 1) {
        vm.registro.atualizado = 1;
        vm.registro.validadeDe = new Date(vm.registro.validadeDe);
        vm.registro.validadeAte = new Date(vm.registro.validadeAte);
        /*
        vm.registro.tarifa = vm.registro.tarifa.toFixed(2);
        vm.registro.tac = vm.registro.tac.toFixed(2);
        vm.registro.ted = vm.registro.ted.toFixed(2);
        vm.registro.despesaAdicional = vm.registro.despesaAdicional.toFixed(2);
        vm.registro.registro = vm.registro.registro.toFixed(2);
        vm.registro.consultaSerpro = vm.registro.consultaSerpro.toFixed(2);
        */
        vm.registro.limiteConcBordero = vm.registro.limiteConcBordero.toFixed(2);
        vm.registro.limiteConcBorderoPerc = vm.registro.limiteConcBorderoPerc.toFixed(2);
        vm.registro.limiteConcCarteira = vm.registro.limiteConcCarteira.toFixed(2);
        vm.registro.limiteConcCarteiraPerc = vm.registro.limiteConcCarteiraPerc.toFixed(2);
        vm.registro.valorUnitarioConsulta3os = vm.registro.valorUnitarioConsulta3os.toFixed(2);
        vm.registro.valorMinTit = vm.registro.valorMinTit.toFixed(2);
        vm.registro.valorMaxTit = vm.registro.valorMaxTit.toFixed(2);
      }
      
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('CedentePocexpressaImportarController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, $compile)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {
      vm.consultar();
    }

    vm.selecionar = function(registro)
    {
      vm.consultarPromise = $http.get(APP_MNP + "/poc/importarpoc/" + registro.viewId)
      .then(function(response)
      {
        $uibModalInstance.close(response.data);
      });
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.post(APP_MNP + "/poc/pesquisarimportar")
      .success(function(response){
        vm.registrosOriginal = response;
        vm.registros = response;
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
      
      /*
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
      */
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
              if (vm.registrosOriginal[i].cedente.nomeFantasia == null || !vm.registrosOriginal[i].cedente.nomeFantasia.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
              {
                incluir = false;

                if (vm.registrosOriginal[i].cedente.razaoSocial == null || !vm.registrosOriginal[i].cedente.razaoSocial.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                {
                  incluir = false;
                }
                else
                {
                  incluir = true;
                }
              }
              else
              {
                incluir = true;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('CedentePocexpressaCedenteController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, $compile)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {
      vm.consultar();
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_MNP + "/poc/pesquisarcedentes")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
              if (vm.registrosOriginal[i].nomeFantasia == null || !vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
              {
                incluir = false;

                if (vm.registrosOriginal[i].razaoSocial == null || !vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                {
                  incluir = false;

                  if (vm.registrosOriginal[i].cnpj == null || !vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                  {
                      incluir = false;
                      if (vm.registrosOriginal[i].codigoVmoney != null && String(vm.registrosOriginal[i].codigoVmoney).toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                      {
                          incluir = true;
                      }
                  }
                  else
                  {
                    incluir = true;
                  }
                }
                else
                {
                  incluir = true;
                }
              }
              else
              {
                incluir = true;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('ArranjoPagamentoOptInCedenteController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, $compile)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {      
      vm.consultar();
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_MNP + "/cedente/pesquisar")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
              if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
              {
                incluir = false;
                if (vm.registrosOriginal[i].codigoVmoney != null && String(vm.registrosOriginal[i].codigoVmoney).toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                {
                    incluir = true;
                }
              }
              else
              {
                incluir = true;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('ArranjoPagamentoAgendaModalDetalhesURController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'recebivel', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, recebivel, $http, APP_MNP)
  {
    var vm = this;
    vm.recebivel = recebivel;

    vm.init = function()
    {
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ConciliacaoCarteiraDetalhesCedenteController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', '$uibModalInstance',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, $uibModalInstance)
{
    var vm = this;
    vm.registro = {
        data: new Date(2021, 6, 18),
        valorNegociado: (19150.00).toFixed(2),
        valorAtualizado: (18150.00).toFixed(2)
    };

    vm.init = function()
    {
        //vm.pesquisar(); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/conciliacao/carteira/detalhes_ur/index.html',
            controller: 'ConciliacaoCarteiraDetalhesUrController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }
    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('BaixasDetalhesUrController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', '$uibModalInstance',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, $uibModalInstance)
{
    var vm = this;
    vm.registro = {
        data: new Date(2021, 6, 2),
        valorNegociado: (19150.00).toFixed(2),
        valorAtualizado: (18150.00).toFixed(2)
    };

    vm.init = function()
    {
        //vm.pesquisar(); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/fluxour/pesquisar/detalhes_credenciadora/index.html',
            controller: 'FluxoUrDetalhesCredenciadoraController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }
    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('FluxoUrDetalhesCedenteController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', '$uibModalInstance',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, $uibModalInstance)
{
    var vm = this;
    vm.registro = {
        data: new Date(2021, 6, 18),
        valorNegociado: (9850.50).toFixed(2),
        valorAtualizado: (8120.50).toFixed(2)
    };

    vm.init = function()
    {
        //vm.pesquisar(); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/fluxour/pesquisar/detalhes_credenciadora/index.html',
            controller: 'FluxoUrDetalhesCredenciadoraController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }
    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('FluxoUrDetalhesCredenciadoraController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', '$uibModalInstance',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, $uibModalInstance)
{
    var vm = this;
    vm.registro = {
        data: new Date(2021, 6, 18),
        valorNegociado: (9850.50).toFixed(2),
        valorAtualizado: (8120.50).toFixed(2)
    };

    vm.init = function()
    {
        //vm.pesquisar(); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/fluxour/pesquisar/detalhes_cedente/index.html',
            controller: 'ArranjoPagamentoOptInCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }
    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('ConciliacaoBaixaDetalhesCedenteController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', '$uibModalInstance',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, $uibModalInstance)
{
    var vm = this;
    vm.registro = {
        data: new Date(2021, 6, 18),
        valorNegociado: (19150.00).toFixed(2),
        valorAtualizado: (18150.00).toFixed(2)
    };

    vm.init = function()
    {
        //vm.pesquisar(); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/conciliacao/baixa/detalhes_ur/index.html',
            controller: 'ConciliacaoBaixaDetalhesUrController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }
    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('AgendaModalOperacaoController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'unidades', 'cedente',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, unidades, cedente)
  {
    var vm = this;
    vm.registro = {
      regraDivisao: 1,
      modalidade: 1,
      gestaoOnus: 1,
      tipoOperacao: 1
    };    
    //vm.recebivel = recebivel;
    vm.registros = unidades;

    vm.init = function()
    {
      vm.registro.cedente = cedente;
      vm.registro.dataVencimento = new Date();
      
      vm.registro.valorDisponivelTexto = 0;

      for (var i = 0; i < vm.registros.length; i++)
      {
          if (vm.registros[i].selecionado)
          {
            vm.registro.valorDisponivelTexto += vm.registros[i].valorLivre;
          }
      }
    }

    vm.enviar = function()
    {
      vm.registro.valorDisponivel = parseFloat(vm.registro.valorDisponivelTexto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.').replaceAll(' ',''));
      if (vm.registro.regraDivisao == 1)
      {
        vm.registro.valorOnerar = parseFloat(vm.registro.valorOnerarTexto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.').replaceAll(' ',''));
      }      
      else
      {
        vm.registro.valorOnerar = parseFloat(vm.registro.valorOnerarTexto) * 100;
      }
      vm.registro.unidades = vm.registros;

      if (vm.registro.valorOnerar <= 0)
      {
        toastr.error('Valor a onerar deve ser informado.', 'Alerta');
        return;
      }      

      vm.enviarPromise = $http.post(APP_MNP + "/mcard/operacao", vm.registro).success(function(response){
          vm.fechar();
          toastr.info('Operação enviada com sucesso.', 'Alerta');
          $state.go('index.operacao_pesquisar');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ConciliacaoCarteiraDetalhesUrController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', '$uibModalInstance',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, $uibModalInstance)
{
    var vm = this;
    vm.registro = {
        data: new Date(2021, 6, 2),
        valorNegociado: (19150.00).toFixed(2),
        valorAtualizado: (18150.00).toFixed(2)
    };

    vm.init = function()
    {
        //vm.pesquisar(); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/fluxour/pesquisar/detalhes_credenciadora/index.html',
            controller: 'FluxoUrDetalhesCredenciadoraController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }
    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('ConciliacaoBaixaDetalhesUrController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', '$uibModalInstance',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, $uibModalInstance)
{
    var vm = this;
    vm.registro = {
        data: new Date(2021, 6, 2),
        valorNegociado: (19150.00).toFixed(2),
        valorAtualizado: (18150.00).toFixed(2)
    };

    vm.init = function()
    {
        //vm.pesquisar(); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/fluxour/pesquisar/detalhes_credenciadora/index.html',
            controller: 'FluxoUrDetalhesCredenciadoraController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }
    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
    .controller('EsqueciMinhaSenhaController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP',
        function ($scope, $state, toastr, $uibModalInstance, $http, APP_MNP) {
            var vm = this;
            vm.usuario = {};

            vm.init = function () {

            }

            vm.enviar = function () {
                vm.esqueciSenhaPromise = $http.post(APP_MNP + "/token/esquecisenha", vm.usuario).success(function (response) {
                    vm.fechar();
                    toastr.info('Solicitação enviada com sucesso. Verifique seu e-mail.', 'Alerta');
                    return response;
                }).error(function (data, status) {
                    var msg = 'Erro no processamento';
                    if (data) {
                        if (typeof data === 'string') msg = data;
                        else if (data.message) msg = data.message;
                        else if (data.Message) msg = data.Message;
                    }
                    if (status === 404) msg = "Serviço não encontrado (Backend offline ou URL incorreta).";

                    toastr.error(msg, 'Erro');
                    return data;
                });
            }

            vm.fechar = function () {
                $uibModalInstance.close();
            }

            vm.init();

        }]);

'use strict';

angular.module('inspinia')
  .controller('TituloConsultarInstrucaoController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'titulo',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, titulo)
  {
    var vm = this;
    vm.titulo = titulo;

    vm.dataProrrogacao = new Date();
    vm.taxaContaGrafica = 0;
    vm.valor = 0;

    vm.dataPagamento = new Date();
    vm.isEstorno = false;

  vm.onTipoInstrucaoChange = function() {
    if (vm.tipoInstrucao == 10) {
      vm.valor = vm.titulo.valor;
      if (vm.titulo && vm.titulo.dataVencimento) {
          var dateString = vm.titulo.dataVencimento;
          if (typeof dateString === 'string' && dateString.indexOf('T') !== -1) {
              var parts = dateString.split('T')[0].split('-');
              vm.dataPagamento = new Date(parts[0], parts[1] - 1, parts[2]);
          } else {
              vm.dataPagamento = new Date(vm.titulo.dataVencimento);
          }
      }
    }
  };

    vm.isSalarioDemanda = function() {
      return vm.titulo.dadosAdicionaisModel != null && vm.titulo.dadosAdicionaisModel.salarioDemanda != null;
    }

    vm.init = function()
    {
      if (vm.isSalarioDemanda()) {
        vm.tipoInstrucao = '10';
        vm.onTipoInstrucaoChange();
      } else {
        vm.tipoInstrucao = '1';
      }

      if (vm.titulo && vm.titulo.antecipacaoTitulo && vm.titulo.antecipacaoTitulo.originador) {
          vm.taxaContaGrafica = vm.titulo.antecipacaoTitulo.originador.taxaContaGrafica;
      }
      /*
      vm.consultarPromise = $http.get(APP_MNP + "/invoice/titulo/consultar/" + titulo.viewId)
      .then(function(response)
      { 
          vm.titulo = response.data;
      });
      */
    }

    vm.salvar = function()
    {
      if (vm.tipoInstrucao == 10) {
        var isLiquidado = (vm.titulo.statusFinanceiroTexto || '').toLowerCase() === 'liquidado';

        if (!vm.isEstorno && isLiquidado) {
            toastr.warning('Não é permitido lançar uma nova liquidação pois o título já está liquidado.', 'Atenção');
            return;
        }

        if (vm.isEstorno && !isLiquidado) {
            toastr.warning('Não é permitido lançar um estorno de liquidação para um título que está pendente.', 'Atenção');
            return;
        }
      }

      var request = {
        tipoInstrucao: vm.tipoInstrucao,
        data: vm.tipoInstrucao == 10 ? vm.dataPagamento : vm.dataProrrogacao,
        tituloViewId: vm.titulo.viewId,
        taxaContaGrafica: vm.taxaContaGrafica,
        valor: vm.valor,
        isEstorno: vm.isEstorno,
        observacao: vm.observacao
      };

      vm.pesquisarPromise = $http.post(APP_MNP + "/invoice/tituloinstrucao/incluir", request).success(function(response){
        $uibModalInstance.close();        
      }).error(function(error){ 
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.excluir = function() {
      /*
      if (confirm('Deseja realmente excluir este registro?'))
      {
        vm.inserirPessoa = $http.delete(APP_MNP + "/invoice/titulo/delete/" + vm.titulo.viewId).success(function(response){
          $uibModalInstance.close('excluido');
          toastr.info('Registro excluído com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
      }
      */
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('RelatorioTesteController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$sce', 'AuthService',
      function($scope, $state, toastr, $http, APP_MNP, $sce, AuthService)
{
    var vm = this;
    vm.registros = null;
    vm.iFrameUrl = "";
    vm.relatorio = $state.params.report;
    vm.name = $state.params.name;

    vm.init = function()
    {
        vm.pesquisar();
        
        vm.pentahoCodigoCliente = AuthService.getPentahoCodigo();
        
        if (vm.relatorio == '')
        {
            toastr.error('Relatório não encontrado.', 'Alerta');
        }

        if (vm.pentahoCodigoCliente == null || vm.pentahoCodigoCliente == '')
        {
            toastr.error('Código de Integração não cadastrado.', 'Alerta');
        }
        else
        {
            vm.iFrameUrl = $sce.trustAsResourceUrl("https://homolog.moneynow.com.br/pentaho/api/repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=0");
        }        
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        return $http.get(APP_MNP + "/fornecedor/pesquisarpendentes")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.analisar_cadastro_fornecedor', {obj: fornecedor});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_fornecedor');
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].statusCadastro)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.statusCadastro < b.statusCadastro) { return -1; }
                        if(a.statusCadastro > b.statusCadastro) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.statusCadastro < b.statusCadastro) { return -1; }
                        if(a.statusCadastro > b.statusCadastro) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('FinanceiroGestaoContasListarController', ['$scope', '$state', 'toastr', '$http','APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };

    vm.init = function()
    {
        vm.pesquisar();
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        return $http.get(APP_MNP + "/gestaocontas/pendentes")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
        });
    }

    vm.consultar = function(registro)
    {
        $state.go('index.financeiro_gestaocontas_analisar', {obj: registro});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_fornecedor');
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataMovimentoAte = vm.filtro.dataMovimentoAte;

        if (vm.filtro.dataMovimentoDe != null && vm.filtro.dataMovimentoDe != '')
        {
            dataMovimentoAte = addDays(vm.filtro.dataMovimentoAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.dataMovimentoDe != null && vm.filtro.dataMovimentoDe != '')
            {
                if (vm.filtro.dataMovimentoDe > new Date(vm.registrosOriginal[i].dataMovimento))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataMovimentoAte != null && vm.filtro.dataMovimentoAte != '')
            {
                if (dataMovimentoAte < new Date(vm.registrosOriginal[i].dataMovimento))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '')
            {
                if (vm.registrosOriginal[i].fornecedor == null)
                {
                    incluir = false;
                }
                else if (!vm.registrosOriginal[i].fornecedor.razaoSocial.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.sacado != null && vm.filtro.sacado != '')
            {
                if (vm.registrosOriginal[i].sacado == null)
                {
                    incluir = false;
                }
                else if (!vm.registrosOriginal[i].sacado.razaoSocial.toUpperCase().includes(vm.filtro.sacado.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('TitulosImportacaoController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP)
  {
    var vm = this;
    
    vm.selectedTempFile = [];
    vm.filesSelected = [];
    vm.nfe = [];
    vm.duplicatas = [];

    vm.init = function()
    {
        //alert('ok');
    }

    vm.adicionarItem = function()
    {
        var nfe = {};
        nfe.Id = vm.fileId++;
        nfe.Nome = vm.selectedTempFile[0].name;
        
        //readAsDataURL        

        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {

            vm.validarPromise = $http.post(APP_MNP + "/nfe/validar", { file : evt.target.result }).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })

             //= NfeService.validar(evt.target.result);
            vm.validarPromise.then(function(result) {  
                if (result.data != null)
                {
                    var nfeAtual = result.data[0].notaFiscal;
                    nfeAtual.TextoXML = nfe.XMLText; 

                    //var existeNfe = vm.nfe.find(x => x.chaveNfe === nfeAtual.chaveNfe);
                    var existeNfe = vm.nfe.filter(function(item) {
                        return item.chaveNfe === nfeAtual.chaveNfe;
                    });

                    if (existeNfe == 0)
                    {
                        if (vm.nfe.length == 0)
                        {
                            vm.nfeInicial = nfeAtual;
                        }
                        else
                        {
                            if (nfeAtual.cedente.cnpj.substring(0, 8) != vm.emitente.cnpj.substring(0, 8))
                            {
                                alert('As notas devem pertencer ao mesmo cedente/emitente.');
                                return;
                            }
                        }

                        vm.nfe = vm.nfe.concat(nfeAtual);
                        vm.emitente = nfeAtual.cedente;
                        vm.duplicatas = vm.duplicatas.concat(result.data); 
                    }
                    else
                    {
                        alert('Nota Fiscal já enviada.');
                    }
                }
                else
                {
                    toastr.error(result.data.text, 'Nfe');
                }
            });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
    }

    vm.concluir = function()
    {
        if (vm.duplicatas.length == null || vm.duplicatas.length == 0)
        {
            alert('É necessário informar as duplicatas.');
            return;
        }

        vm.concluirPromise = $http.post(APP_MNP + "/titulo/registrar", vm.duplicatas).success(function(response){            
            toastr.info('Títulos enviados com sucesso.', 'Alerta');
            vm.duplicatas = [];
            vm.nfe = [];
            vm.emitente = null;
            //$state.go('index.home');
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
    }

    vm.getTotalDuplicatas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            total += duplicata.valor;
        }
        return total;
    }

    vm.openIncluirDuplicata = function()
    {
        /*
        var modalInstance = $uibModal.open({
            templateUrl: 'app/antecipacao/modal/inserir-duplicata.html',
            controller: 'AntecipacaoInserirDuplicataController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
               nfes: function () {
                 return vm.nfe;
               }
             }
         });

         modalInstance.result.then(function(data) {
            if (data.viewId != null && data.numeroTitulo != null && data.numeroTitulo != '')
            {
                vm.duplicatas.push(data);
            }
        })
        */
    }

    vm.removerNfe = function(nfeParam)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var i = 0; i < vm.nfe.length; i++)
            {
                if (vm.nfe[i].viewId == nfeParam.viewId)
                {
                    vm.nfe.splice(i, 1);
                    break;
                }
            }
            
            var tamanho = vm.duplicatas.length;

            for (var j = 0; j < tamanho; j++)
            {
                if (vm.duplicatas[j] != null && vm.duplicatas[j].notaFiscal.viewId == nfeParam.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                    j = 0;
                }
            }

            if (vm.duplicatas.length > 0 && vm.duplicatas[0] != null && vm.duplicatas[0].notaFiscal.viewId == nfeParam.viewId)
            {
                vm.duplicatas.splice(0, 1);
            }

            if (vm.duplicatas.length == 0)
            {
                vm.emitente = null;
            }
        }
    }

    vm.removerDuplicata = function(dup)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var j = 0; j < vm.duplicatas.length; j++)
            {
                if (vm.duplicatas[j].viewId == dup.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                }
            }
        }
    }

    vm.exibirMotivoTitulo = function(t)
    {
        alert(t.situacaoMotivo);
    }

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('PesquisaFornecedorPendenteController', ['$scope', '$state', 'toastr', '$http','APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.registros = null;

    vm.init = function()
    {
        vm.pesquisar();
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        return $http.get(APP_MNP + "/fornecedor/pesquisarpendentes")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.analisar_cadastro_fornecedor', {obj: fornecedor});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_fornecedor');
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].statusCadastro)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.statusCadastro < b.statusCadastro) { return -1; }
                        if(a.statusCadastro > b.statusCadastro) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.statusCadastro < b.statusCadastro) { return -1; }
                        if(a.statusCadastro > b.statusCadastro) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('AnalisarCadastroFornecedorController', ['$scope', '$state', 'toastr', '$http','APP_MNP','$sce','$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $sce, $uibModal)
{
    var vm = this;    
    vm.fornecedor = $state.params.obj;
    vm.fileFichaCadastralPDF = '';

    vm.init = function()
    {
        if (vm.fornecedor == null)
        {
            $state.go('index.pesquisa_fornecedor_pendente');
        }
        else
        {
            vm.consultar();
        }
    }

    vm.atualizarDadosCadastro = function()
    {
        vm.incluirPromise = $http.post(APP_MNP + "/fornecedor/atualizarcadastro", vm.fornecedor).success(function(response){        
            toastr.info('Dados atualizados com sucesso.', 'Alerta');            
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }
    
    vm.aprovar = function()
    {
        var r = confirm("Confirma a operação?");

        if (!r)
        {
            return;
        }
        
        vm.aprovarAberturaPromise = $http.post(APP_MNP + "/fornecedor/solicitaraberturaconta", vm.fornecedor).success(function(response){
            toastr.info('Registro enviado com sucesso.', 'Alerta');   
            $state.go('index.pesquisa_fornecedor_pendente');          
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.solicitarAssinatura = function()
    {
        var r = confirm("Confirma a operação?");

        if (!r)
        {
            return;
        }

        vm.aprovarPromise = $http.post(APP_MNP + "/fornecedor/solicitarassinaturadigital", vm.fornecedor).success(function(response){
            toastr.info('Registro enviado com sucesso.', 'Alerta');   
            $state.go('index.pesquisa_fornecedor_pendente');          
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.finalizarAberturaConta = function()
    {
        var r = confirm("Confirma a operação?");

        if (!r)
        {
            return;
        }

        vm.aprovarPromise = $http.post(APP_MNP + "/fornecedor/finalizaraberturaconta", vm.fornecedor).success(function(response){
            toastr.info('Registro enviado com sucesso.', 'Alerta');   
            $state.go('index.pesquisa_fornecedor_pendente');          
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.rejeitar = function()
    {
        var r = confirm("Confirma a operação?");

        if (!r)
        {
            return;
        }

        vm.rejeitarPromise = $http.post(APP_MNP + "/fornecedor/rejeitarcadastro", vm.fornecedor).success(function(response){
            toastr.info('Registro rejeitado com sucesso.', 'Alerta');   
            $state.go('index.pesquisa_fornecedor_pendente');          
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.consultar = function()
    {
        return $http.get(APP_MNP + "/fornecedor/consultarfornecedordados/" + vm.fornecedor.viewId)
        .then(function(response)
        { 
            vm.fornecedor = response.data;

            vm.consultarFichaCadastral();

        }).catch(function (data) {
            toastr.error(data, 'Alerta');
        });
    }

    vm.consultarFichaCadastral = function()
    {
        vm.fichaCadastralPromise = $http.post(APP_MNP + "/fornecedor/gerarfichacadastral", vm.fornecedor).success(function(response){
            
            var fileContratoMae = vm.b64toBlob(response, "application/pdf");
            vm.fileFichaCadastralPDF = $sce.trustAsResourceUrl(URL.createObjectURL(fileContratoMae)); 

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.incluirSocio = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_socio/index.html',
        controller: 'FornecedorIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          tipopessoa: function () {
            return 'Sócio';
          },
          pessoa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
          //vm.consultar();
      });
    }

    vm.visualizarSocio = function(pessoa, index)
    {
        var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_socio/index.html',
        controller: 'FornecedorIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
            fornecedor: function () {
                return vm.fornecedor;
            },
            tipopessoa: function () {
                return 'Sócio';
            },
            pessoa: function () {
                return pessoa;
            },
            indice: function () {
                return index;
            },
        }
        }).closed.then(function(){
            //vm.consultar();
        });
    }

    vm.incluirProcurador = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_socio/index.html',
        controller: 'FornecedorIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          tipopessoa: function () {
            return 'Procurador';
          },
          pessoa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }

    vm.visualizarProcurador = function(pessoa, index)
    {
        var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_socio/index.html',
        controller: 'FornecedorIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
            fornecedor: function () {
                return vm.fornecedor;
            },
            tipopessoa: function () {
                return 'Procurador';
            },
            pessoa: function () {
                return pessoa;
            },
            indice: function () {
                return index;
            },
        }
        }).closed.then(function(){
            //vm.consultar();
        });
    }

    vm.incluirEmpresa = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_empresa/index.html',
        controller: 'FornecedorIncluirEmpresaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          empresa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }

    vm.visualizarEmpresa = function(empresa, index)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/fornecedor/modal/cadastrar_empresa/index.html',
        controller: 'FornecedorIncluirEmpresaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          empresa: function () {
            return empresa;
          },
          indice: function () {
            return index;
        },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }

    vm.getDocumento = function(viewId, nome)
    {
        return $http.get(APP_MNP + "/fornecedor/consultardocumento/" + viewId)
        .then(function(response)
        { 
            vm.download(response.data.base64, response.data.tipo, nome);
        }).catch(function (data) {
            toastr.error(data, 'Alerta');
        });
    }

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.adicionarDocumento = function(tipo)
    {
      var cnab = {};      
      vm.file = {};
      vm.file.nome = vm.selectedTempFile[0].name;
      vm.file.tipo = tipo;
      
      var reader = new FileReader();
      reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
      reader.onload = function (evt) {          
          vm.file.base64 = evt.target.result;
          vm.file.viewId = vm.fornecedor.viewId;
          vm.validarPromise = $http.post(APP_MNP + "/fornecedor/adicionardocumento", vm.file).success(function(response){
            toastr.info('Arquivo enviado com sucesso.', 'Alerta');
            vm.consultar();
            return response;
          }).error(function(error){
            vm.file = {};
            toastr.error(error, 'Alerta');
            return error;
          });
      };
      
      vm.selectedTempFile = [];
      angular.element("input[type='file']").val(null);      
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.b64toBlob = function (b64Data, contentType) {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        var sliceSize = 512
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
        
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
        
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('AntecipacaoDisponiveisController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP)
  {
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status : '2'
    }
    vm.lastOrder = '';
    vm.orderSelected = '';

    vm.init = function()
    {        
        vm.listar();
    }

    vm.listar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;

        return $http.get(APP_MNP + "/antecipacao/disponiveis")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });        
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataVencimentoAte = vm.filtro.vencimentoAte;

        if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
        {
            dataVencimentoAte = addDays(vm.filtro.vencimentoAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '')
            {
                if (!vm.registrosOriginal[i].fornecedor.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.numeroAntecipacao != null && vm.filtro.numeroAntecipacao != '')
            {
                if (vm.registrosOriginal[i].numero != vm.filtro.numeroAntecipacao)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
            {
                if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '')
            {
                if (dataVencimentoAte < new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }
            
            if (vm.filtro.valorDe != null && vm.filtro.valorDe != '')
            {
                if (vm.filtro.valorDe > vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorAte != null && vm.filtro.valorAte != '')
            {
                if (vm.filtro.valorAte < vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.proposta = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/agente_financeiro/antecipacoes/modal/proposta.html',
            controller: 'AntecipacaoRealizarPropostaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            vm.listar();
        });
    }

    vm.titulos = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/agente_financeiro/antecipacoes/modal/consultar_titulos.html',
            controller: 'ConsultarTitulosPropostaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            vm.listar();
        });
    }

    vm.liberarTitulos = function(p)
    {
        var r = confirm("Confirma a liberação dos títulos?");

        if (!r)
        {
            return;
        }

        $http.post(APP_MNP + "/antecipacao/liberartitulos", p).success(function(response){            
            toastr.info('Títulos liberados com sucesso.', 'Alerta');
            vm.listar();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.consultarNegociacao = function(p)
    {
        $state.go('index.operacao_negociacao', {obj: p.viewId});
    }

    vm.consultarFormalizacao = function(p)
    {
        $state.go('index.operacao_formalizacao', {obj: p.viewId});
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('CadastroSacadoPesquisaControllerOLD', ['$scope', '$state', 'toastr', 'PagerService', '$http','APP_MNP',
      function($scope, $state, toastr, PagerService, $http, APP_MNP) 
{
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registros = null;

    vm.init = function()
    {
        vm.pesquisar();
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/sacado/pesquisar");

        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;

            vm.pager.totalPages = 1;
            vm.setPage(1);
        });
    }

    vm.consultar = function(sacado)
    {
        $state.go('index.cadastro_sacado_consulta', {obj: sacado});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_sacado');
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('CadastroIntermediadorPesquisaController', ['$scope', '$state', 'toastr', '$http','APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.registros = null;

    vm.init = function()
    {
        vm.pesquisar();
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        return $http.get(APP_MNP + "/intermediador/pesquisar")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
        });
    }

    vm.consultar = function(intermediador)
    {
        $state.go('index.cadastro_intermediador_consulta', {obj: intermediador});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_intermediador');
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('CadastroFornecedorPesquisaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/fornecedor/pesquisar");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.cadastro_fornecedor_consulta', {obj: fornecedor});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceDigitacaoTituloCadastroController', ['$scope', '$state', 'toastr', '$uibModal', '$uibModalInstance', 'APP_MNP', '$http', 'titulos', 'AuthService',
      function($scope, $state, toastr, $uibModal, $uibModalInstance, APP_MNP, $http, titulos, AuthService)
{
    var vm = this;
    vm.titulos = titulos;
    vm.isUpdate = false;
    vm.editCedente = true;
    vm.isOperacaoMoneyNow = 0;

    vm.registro = {
      dataRecebimento: new Date(new Date().setHours(18)),
      dataVencimento: new Date(new Date().setHours(18)),
      boletoEspecial: "N",
      cobrancaExpressa: "N",
      bancoCarteira: "B",
      bancoCheque: null // Aqui você adiciona a propriedade para armazenar o banco selecionado

    };

    vm.init = function()
    {
      vm.isOperacaoMoneyNow = AuthService.getOperacaoMn();

      vm.consultarTipoDocumento();
      vm.consultarBancos(); // Chamar para carregar a lista de bancos

      if (vm.titulos.length > 0)
      {
        vm.editCedente = false;
        vm.registro.cedente = vm.titulos[vm.titulos.length-1].cedente;
        vm.registro.sacado = vm.titulos[vm.titulos.length-1].sacado;
        vm.registro.boletoEspecial = vm.titulos[vm.titulos.length-1].boletoEspecial;
        vm.registro.cobrancaExpressa = vm.titulos[vm.titulos.length-1].cobrancaExpressa;
        vm.registro.bancoCarteira = vm.titulos[vm.titulos.length-1].bancoCarteira;
 
      }

      /*
      if (empresa != null)
      {
        vm.empresa = empresa;
      }
      */
    }
    vm.consultarBancos = function() {

      vm.consultaBancosPromise = $http.get(APP_MNP + "/banco/pesquisar")
          .then(function(response) {
              vm.bancos = response.data;
              
             
          })
          .catch(function(error) {
              toastr.error('Erro ao consultar bancos: ' + error.message);
          });
    };

    vm.bancoChequeEscolhido = function() {
      if (vm.registro.bancoCheque) {
          //var bancoEscolhido = vm.bancos.find(banco => banco.Codigo === vm.registro.bancoCheque);
          //console.log('Banco selecionado:', bancoEscolhido);
          //console.log('Código do banco selecionado:', vm.registro.bancoCheque); // Isso deve mostrar o código do banco

      }
    };

  

    vm.tipoDocumentoEscolhido = function()
    {
      AuthService.setTipoDocumentoDescricao(vm.registro.tipoDocumento.descricao);  
      

    }

    vm.consultarTipoDocumento = function()
    {
      vm.consultaTipoDocumentoPromise = $http.get(APP_MNP + "/invoice/tituloTipoDocumento/pesquisar")
      .then(function(response)
      { 
          vm.tiposDocumento = response.data; 
          
          if (vm.tiposDocumento.length > 0)
          {
            if (vm.titulos.length > 0)
            {
              var viewId = vm.titulos[vm.titulos.length-1].tipoDocumento.viewId;

              for (var i=0;i<vm.tiposDocumento.length;i++)
              {
                if (vm.tiposDocumento[i].viewId == viewId)
                {
                  vm.registro.tipoDocumento = vm.tiposDocumento[i];    
                }
              }
            }
            else
            {
              vm.registro.tipoDocumento = vm.tiposDocumento[0];
            }  
            AuthService.setTipoDocumentoDescricao(vm.registro.tipoDocumento.descricao);  
         
          }
      });
    }

    vm.salvar = function()
    {
      if (!vm.isUpdate)
      {
        // Numero
        if (vm.registro.numero == null || vm.registro.numero == '')
        {
          toastr.error('Favor informar o número do Título.', 'Alerta');
          return;
        }

        // Verificar Numero
        /*
        for (var i=0;i<vm.titulos.length;i++)
        {
          if (vm.registro.numero == vm.titulos[i].numero)
          {
            toastr.error('Número do Título já cadastrado.', 'Alerta');
            return;
          }
        }
        */

        //if (vm.registro.dataVencimento <= new Date(new Date().setHours(0)))
        //{
        //  toastr.error('Data de vencimento deve ser maior que a data atual.', 'Alerta');
        //  return;
        //}
        
        if (new Date(vm.registro.dataVencimento).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)) {
          toastr.error('Data de vencimento deve ser maior que a data atual.', 'Alerta');
          return;
        }
      
        // Cedente
        if (vm.registro.cedente == null)
        {
          toastr.error('Favor selecionar o Cedente.', 'Alerta');
          return;
        }

        // Sacado
        if (vm.registro.sacado == null)
        {
          toastr.error('Favor selecionar o Sacado.', 'Alerta');
          return;
        }

        //console.log("(",vm.registro.sacado.enderecoCep.trim(),")",vm.registro.tipoDocumento.descricao )
        // Sacado - Endereco
        if (
          (vm.registro.sacado.enderecoCep == null || 
          vm.registro.sacado.enderecoCep.trim() == '' || 
          vm.registro.sacado.enderecoLogradouro == null || 
          vm.registro.sacado.enderecoLogradouro.trim() == '' || 
          vm.registro.sacado.enderecoCidade == null || 
          vm.registro.sacado.enderecoCidade.trim() == '' || 
          vm.registro.sacado.enderecoUf == null || 
          vm.registro.sacado.enderecoUf.trim() == '') && vm.registro.tipoDocumento.descricao.toLowerCase() != 'cheque'
          )
        {
          
          toastr.error('Sacado selecionado não possui endereço e Documento não é um Cheque.', 'Alerta');
          return;
        }

        // Valor
        if (vm.registro.valor == null || vm.registro.valor == '')
        {
          toastr.error('Favor informar o Valor.', 'Alerta');
          return;
        }

        // Verificar o tipo de documento
        if (vm.registro.tipoDocumento == null)
        {
          toastr.error('Favor informar o Tipo do Documento.', 'Alerta');
          return;
        }

        // Verificar se e nota fiscal
        if (vm.registro.tipoDocumento.descricao.toLowerCase() == 'duplicata')
        {
          if (vm.registro.notaFiscalNumero == null || vm.registro.notaFiscalNumero == '')
          {
            toastr.error('Favor informar o Número da Nota Fiscal.', 'Alerta');
          return;
          }
          // Verificar se notaFiscalNumero é um número
          if (!/^\d+$/.test(vm.registro.notaFiscalNumero)) {
            toastr.error('Favor informar um Número da Nota Fiscal válido.', 'Alerta');
            return;
          }
        }
        // Verificar se Banco Cheque foi escolhido
        if (vm.registro.tipoDocumento.descricao.toLowerCase() == 'cheque')
          {
            if (vm.registro.bancoCheque == null || vm.registro.bancoCheque == '')
            {
              toastr.error('Favor informar o Banco do Cheque.', 'Alerta');
            return;
            }
          }
        // Verificar se Chave NFe é maior que 44 caracteres
        if (vm.registro.notaFiscalChave && vm.registro.notaFiscalChave.length > 44) {
          toastr.error('A chave NFe não pode ter mais de 44 caracteres.', 'Alerta');
          return;
        }

        // Verificar se Dias contém somente números e se nao ultrapassa 30 dias
        if (vm.registro.dias && (!/^\d+$/.test(vm.registro.dias) || vm.registro.dias > 30)) {
          toastr.error('Favor informar um D+ válido.', 'Alerta');
          return;
        }


        try 
        {
          vm.registro.valor = parseFloat(vm.registro.valor.toString().replaceAll('R$ ','0').replaceAll('.','').replaceAll(',','.'));
        }
        catch (erro) {
          toastr.error('Favor informar corretamente o Valor.', 'Alerta');
          return;
        }

        // Valor
        if (vm.registro.valor <= 0)
        {
          toastr.error('Favor informar o Valor.', 'Alerta');
          return;
        }

        // GUID
        vm.registro.viewId = uuidv4();

        // Cadastro
        vm.titulos.push(vm.registro);

        vm.fechar();
      }

      /*
      vm.incluirPromise = $http.post(APP_API_FRND + "/fornecedor/adicionarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
      */
    }

    function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    /*
    vm.atualizar = function()
    {
      vm.incluirPromise = $http.post(APP_API_FRND + "/fornecedor/atualizarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.splice(indice, 1);
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }
    */

    vm.selecionarCedenteModal = function()
    {    
      if (vm.editCedente)
      {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/cadastro/cedente/selecionar/index.html',
          controller: 'CedenteSelecionarController',
          controllerAs: 'controller',
          windowClass: 'inmodal',
          size: 'lg',
          }).result.then(function(data){
              vm.registro.cedente = null;
              if (data != null)
              {
                  vm.registro.cedente = data;
              }      
          });
      } 
    }

    vm.selecionarSacadoModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/sacado/selecionar/index.html',
        controller: 'SacadoSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.registro.sacado = null;
            if (data != null)
            {
                vm.registro.sacado = data;
            }      
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('InvoiceOperacaoTitulosController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModal', '$http', 'APP_MNP', 'AuthService',
      function($scope, $state, toastr, PagerService, $uibModal, $http, APP_MNP, AuthService)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.total = {
        valorTotal : 0,
        quantidade : 0
    };
    vm.filtro = {};
    vm.registrosOriginal = [];
    vm.lastOrder = '';
    vm.orderSelected = '';
    vm.filtro = {
        status: 1
    };

    vm.init = function()
    {
        vm.horarioLimite = AuthService.getHorarioLimite();
        vm.listar();
    }

    vm.validarHorarioLimite = function() 
    {
        // Verificar a hora atual
        var currentTime = new Date();
        var currentHours = currentTime.getHours();
        var currentMinutes = currentTime.getMinutes();

        var horarioEmpresa = parseFloat(vm.horarioLimite.replace(":", "."));
        var currentHourMinute = parseFloat(currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes));
            
        if ( currentHourMinute > horarioEmpresa ) {
            toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
            return false;
        }
        return true;

    }

    vm.validarEPrevenir = function(event) {
        if (!vm.validarHorarioLimite()) {
            event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
            return false;
        }
        else 
        {
            vm.anteciparRegistros()
        }        
    };     

    vm.listar = function()
    {
        vm.registros = null;
        vm.items = null;

        vm.listarPromise = $http.get(APP_MNP + "/invoice/titulo/disponiveis/" + vm.filtro.status);
        /*
        .then(function(response)
        { 
            return response.data;
        });
        */

        vm.listarPromise.then(function(result) {  
            vm.registrosOriginal = result.data;
            vm.registros = result.data;
            vm.calcularTotal();
            vm.filtrarPesquisa();
        });
    }

    vm.filtrarPesquisaStatus = function() 
    {
        vm.listar();
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nfe != null && vm.filtro.nfe != '')
            {
                if (!vm.registrosOriginal[i].numero.includes(vm.filtro.nfe))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.titulo != null && vm.filtro.titulo != '')
            {
                if (!vm.registrosOriginal[i].titulo.includes(vm.filtro.titulo))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.sacado != null && vm.filtro.sacado != '')
            {
                if (!vm.registrosOriginal[i].sacado.toUpperCase().includes(vm.filtro.sacado.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '')
            {
                if (!vm.registrosOriginal[i].cedente.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
            {
                if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].dataVencimentoDate))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '')
            {
                if (vm.filtro.vencimentoAte < new Date(vm.registrosOriginal[i].dataVencimentoDate))
                {
                    incluir = false;
                }
            }
            if (vm.filtro.dataCadastro != null && vm.filtro.dataCadastro != '')
                {
                    if (vm.filtro.dataCadastro < new Date(vm.registrosOriginal[i].dataCadastro))
                    {
                        incluir = false;
                    }
                }            

            if (vm.filtro.valorDe != null && vm.filtro.valorDe != '')
            {
                if (vm.filtro.valorDe > vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorAte != null && vm.filtro.valorAte != '')
            {
                if (vm.filtro.valorAte < vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.desmarcarTodos();
        vm.pager.totalPages = 1;
        vm.setPage(1);
        vm.calcularTotal();
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'nfe':
                    vm.registros.reverse(function(a, b){
                        if(a.numero < b.numero) { return -1; }
                        if(a.numero > b.numero) { return 1; }
                        return 0;
                    })
                    break;
                case 'titulo':
                    vm.registros.reverse(function(a, b){
                        if(a.titulo < b.titulo) { return -1; }
                        if(a.titulo > b.titulo) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.reverse(function(a, b){
                        if(a.sacado < b.sacado) { return -1; }
                        if(a.sacado > b.sacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'fornecedor':
                    vm.registros.reverse(function(a, b){
                        if(a.fornecedor < b.fornecedor) { return -1; }
                        if(a.fornecedor > b.fornecedor) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimentoDate);
                        var dateB = new Date(b.dataVencimentoDate);
                        return dateA - dateB;
                    });
                    break;
                case 'valor':
                    vm.registros.reverse(function(a, b){
                        if(a.valor < b.valor) { return -1; }
                        if(a.valor > b.valor) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'nfe':
                    vm.registros.sort(function(a, b){
                        if(a.numero < b.numero) { return -1; }
                        if(a.numero > b.numero) { return 1; }
                        return 0;
                    })
                    break;
                case 'titulo':
                    vm.registros.sort(function(a, b){
                        if(a.titulo < b.titulo) { return -1; }
                        if(a.titulo > b.titulo) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.sort(function(a, b){
                        if(a.sacado < b.sacado) { return -1; }
                        if(a.sacado > b.sacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'fornecedor':
                    vm.registros.sort(function(a, b){
                        if(a.fornecedor < b.fornecedor) { return -1; }
                        if(a.fornecedor > b.fornecedor) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataVencimentoDate);
                        var dateB = new Date(b.dataVencimentoDate);
                        return dateA - dateB;
                    });
                    break;
                case 'valor':
                    vm.registros.sort(function(a, b){
                        if(a.valor < b.valor) { return -1; }
                        if(a.valor > b.valor) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }
        
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.anteciparRegistros = function()
    {
        if (vm.registros != null)
        {
            var selecionados = [];
            for (var i = 0; i < vm.registros.length; i++)
            {
                if (vm.registros[i].selecionadoAntecipar)
                {
                    selecionados.push(vm.registros[i]);
                }
            }

            if (selecionados.length == 0)
            {
                alert('Selecione pelo menos um registro.');
                return;
            }

            var modalInstance = $uibModal.open({
                templateUrl: 'app/invoice/operacao/titulos/modal/lote/index.html',
                controller: 'InvoiceOperacaoTitulosLoteController',
                controllerAs: 'controller',
                windowClass: 'inmodal',
                size: 'lg',
                resolve: {
                    registros: function () {
                        return selecionados;
                    },
                }
            }).closed.then(function(){
                vm.listar();
            });
        }
    }

    vm.marcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.filtro.status == vm.registros[i].status)
            {
                if (vm.registros[i].status == 1 && (vm.registros[i].isPendenteSefaz == false && vm.registros[i].statusNfe != '101'))
                {
                    vm.registros[i].selecionadoAntecipar = true;
                }
            }
        }
        vm.calcularTotal();
    }

    vm.desmarcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            vm.registros[i].selecionadoAntecipar = false;
        }
        vm.calcularTotal();
    }

    vm.calcularTotal = function()
    {
        var total = 0;
        var quantidade = 0;

        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.registros[i].selecionadoAntecipar)
            {
                total += vm.registros[i].valor;
                quantidade++;
            }
        }

        vm.total.valorTotal = total;
        vm.total.quantidade = quantidade;
    }

    vm.consultarTitulo = function(p)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/invoice/titulos/modal/detalhar_titulo/index.html',
            controller: 'InvoiceTituloDetalheController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                titulo: function () {
                    return p;
                },
            }
        }).result.then(function(res){
            if (res == 'excluido')
            {
                vm.listar();
            }            
        });
    }
    
    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('OperacaoNegociacaoController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.antecipacaoViewId = $state.params.obj;
    vm.operacao = {};
    vm.formasCredito = [];
    vm.formaCreditoValor = 0;
    vm.formaCreditoSaldo = 0;
    vm.totalDebitosCreditos = 0;

    vm.init = function()
    {
        vm.consultar();
    }

    vm.consultar = function()
    {
      vm.consultaPromise = $http.get(APP_MNP + "/invoice/operacao/negociacao/" + vm.antecipacaoViewId)
      .then(function(response)
      { 
          vm.operacao = response.data;

          vm.operacao.taxaOperacao = vm.operacao.taxaOperacao.toFixed(2);
          vm.operacao.taxaAdValorem = vm.operacao.taxaAdValorem.toFixed(2);
          vm.operacao.tarifaCobranca = vm.operacao.tarifaCobranca.toFixed(2);
          vm.operacao.tarifaAvaliacaoCredito = vm.operacao.tarifaAvaliacaoCredito.toFixed(2);
          vm.operacao.tarifaConsultaCredito = vm.operacao.tarifaConsultaCredito.toFixed(2);          
          vm.operacao.tarifaTED = vm.operacao.tarifaTED.toFixed(2);

          vm.calcularSaldoFormaCredito();

          //vm.registros = response.data;

          vm.operacao.totalLiquidoCalculado = vm.operacao.totalLiquido;
      });
    }

    vm.simularTaxas = function()
    {
        var operacaoUpdate = vm.operacao;

        if (operacaoUpdate.taxaOperacao == null)
        {
            alert('Favor preencher corretamente a taxa da operação.');
            return;
        }

        if (operacaoUpdate.taxaAdValorem == null)
        {
            alert('Favor preencher corretamente a taxa de Ad Valorem.');
            return;
        }

        if (operacaoUpdate.tarifaCobranca == null)
        {
            alert('Favor preencher corretamente a tarifa de cobrança.');
            return;
        }

        if (operacaoUpdate.tarifaAvaliacaoCredito == null)
        {
            alert('Favor preencher corretamente a tarifa de avaliação de crédito.');
            return;
        }

        if (operacaoUpdate.tarifaConsultaCredito == null)
        {
            alert('Favor preencher corretamente a tarifa de consulta de crédito.');
            return;
        }

        if (operacaoUpdate.tarifaTED == null)
        {
            alert('Favor preencher corretamente a tarifa TED.');
            return;
        }

        operacaoUpdate.titulos = [];
        operacaoUpdate.cedente.complemento = null;
        operacaoUpdate.cedente.socios = null;

        vm.consultaPromise = $http.post(APP_MNP + "/invoice/operacao/negociacao/SimularTaxas", operacaoUpdate).success(function(response){            
            vm.operacao = response;

            vm.operacao.taxaOperacao = vm.operacao.taxaOperacao.toFixed(2);
            vm.operacao.taxaAdValorem = vm.operacao.taxaAdValorem.toFixed(2);
            vm.operacao.tarifaCobranca = vm.operacao.tarifaCobranca.toFixed(2);
            vm.operacao.tarifaAvaliacaoCredito = vm.operacao.tarifaAvaliacaoCredito.toFixed(2);
            vm.operacao.tarifaConsultaCredito = vm.operacao.tarifaConsultaCredito.toFixed(2);          
            vm.operacao.tarifaTED = vm.operacao.tarifaTED.toFixed(2);

            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.enviarNegociacao = function()
    {
        var operacaoUpdate = vm.operacao;

        if (operacaoUpdate.taxaOperacao == null)
        {
            alert('Favor preencher corretamente a taxa da operação.');
            return;
        }

        if (operacaoUpdate.taxaAdValorem == null)
        {
            alert('Favor preencher corretamente a taxa de Ad Valorem.');
            return;
        }

        if (operacaoUpdate.tarifaCobranca == null)
        {
            alert('Favor preencher corretamente a tarifa de cobrança.');
            return;
        }

        if (operacaoUpdate.tarifaAvaliacaoCredito == null)
        {
            alert('Favor preencher corretamente a tarifa de avaliação de crédito.');
            return;
        }

        if (operacaoUpdate.tarifaConsultaCredito == null)
        {
            alert('Favor preencher corretamente a tarifa de consulta de crédito.');
            return;
        }

        if (operacaoUpdate.tarifaTED == null)
        {
            alert('Favor preencher corretamente a tarifa TED.');
            return;
        }

        if (vm.formaCreditoSaldo != 0) {
            alert('Formas de Crédito deve possuir o mesmo valor do Valor Líquido.');
            return;
        }

        operacaoUpdate.titulos = [];
        operacaoUpdate.originador = null;
        operacaoUpdate.cedente = null;
        operacaoUpdate.formasCreditoDto = vm.formasCredito;

        operacaoUpdate.debitosCreditos = [];
        if (operacaoUpdate.contaGrafica != null && operacaoUpdate.contaGrafica.length > 0) {
            for(var i=0; i < operacaoUpdate.contaGrafica.length; i++) {
                var item = {
                    viewId : operacaoUpdate.contaGrafica[i].viewId
                };
                operacaoUpdate.debitosCreditos.push(item);
            }
        }

        vm.aprovarPromise = $http.post(APP_MNP + "/invoice/operacao/negociacao/aprovar", operacaoUpdate).success(function(response){
            toastr.info('Operação enviada com sucesso.', 'Alerta');
            $state.go('index.invoice_operacoes');
            //vm.operacao = response;
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
    }

    vm.acertoContaGrafica = function() {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/invoice/operacao/negociacao/modal/contagrafica/index.html',
          controller: 'InvoiceOperacaoNegociacaoContaGraficaController',
          controllerAs: 'controller',
          windowClass: 'inmodal',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            operacao: function () {
                return vm.operacao;
            },
          }
        }).closed.then(function(){
            if (vm.operacao.debitoCreditoTotal != null) {
                vm.totalDebitosCreditos = vm.operacao.debitoCreditoTotal; 
                vm.operacao.totalLiquidoCalculado = vm.operacao.totalLiquido + vm.totalDebitosCreditos;
            }
        });
    }

    vm.adicionarFormaCredito = function() {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/invoice/operacao/negociacao/modal/formacredito/index.html',
          controller: 'InvoiceOperacaoNegociacaoFormaCreditoController',
          controllerAs: 'controller',
          windowClass: 'inmodal',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            operacao: function () {
                return vm.operacao;
            },
            formasCredito: function() {
                return vm.formasCredito;
            }
          }
        }).closed.then(function(){
            vm.calcularSaldoFormaCredito();
        });
    }

    vm.removerFormaCredito = function(item) {
        if (vm.formasCredito != null && vm.formasCredito.length > 0) {
            for(var i=0; i < vm.formasCredito.length; i++) {
                if (vm.formasCredito[i] == item) {
                    vm.formasCredito.splice(i, 1);
                }
            }
        }
        vm.calcularSaldoFormaCredito();
    }

    vm.calcularSaldoFormaCredito = function() {
        vm.formaCreditoValor = 0;
        if (vm.formasCredito != null && vm.formasCredito.length > 0) {
            for(var i=0; i < vm.formasCredito.length; i++) {
                vm.formaCreditoValor = vm.formaCreditoValor + vm.formasCredito[i].valor;
            }
        }
        vm.formaCreditoSaldo = (vm.formaCreditoValor - vm.operacao.totalLiquidoCalculado).toFixed(2);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('OperacaoAnaliseController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.antecipacaoViewId = $state.params.obj;
    vm.operacao = {};

    vm.contasAll = [];
    vm.contas = [];
    vm.conta = {};

    vm.originadores = [];
    vm.originador = {};

    vm.init = function()
    {
        vm.consultar();
        vm.listarContas();
    }

    vm.consultar = function()
    {
      vm.consultaPromise = $http.get(APP_MNP + "/invoice/operacao/analise/" + vm.antecipacaoViewId)
      .then(function(response)
      { 
          vm.operacao = response.data;
      });
    }

    vm.listarContas = function()
    {
        vm.consultarContasPromise = $http.get(APP_MNP + "/domiciliobancario/pesquisar");
        
        vm.consultarContasPromise.then(function(response)
        { 
            vm.contasAll = response.data;

            vm.listarOriginadores();
            /*
            if (vm.contas.length > 0)
            {
                var isPadrao = false;

                for (var i=0;i<vm.contas.length;i++)
                {
                    if (vm.contas[i].isPadraoOperacao)
                    {
                        isPadrao = true;
                        vm.conta = vm.contas[i];
                    }
                }

                if (isPadrao == false)
                {
                    vm.conta = vm.contas[0];
                }
            }
            */
        });
    }

    vm.listarOriginadores = function()
    {
        vm.consultarOriginadoresPromise = $http.get(APP_MNP + "/empresaoriginador/lista");
        
        vm.consultarOriginadoresPromise.then(function(response)
        { 
            vm.originadores = response.data;

            if (vm.originadores.length > 0)
            {
                vm.originador = vm.originadores[0];

                vm.listarContasOriginador();
                /*
                var isPadrao = false;

                for (var i=0;i<vm.originadores.length;i++)
                {
                    if (vm.originadores[i].isPadraoOperacao)
                    {
                        isPadrao = true;
                        vm.originador = vm.originadores[i];
                    }
                }

                if (isPadrao == false)
                {
                    vm.conta = vm.originadores[0];
                }
                */
            }
        });
    }

    vm.listarContasOriginador = function() 
    {        
        vm.conta = null;
        vm.contas = [];
        if (vm.contasAll.length > 0)
        {
            for (var i=0;i<vm.contasAll.length;i++)
            {
                if (vm.contasAll[i].originador.id == vm.originador.id)
                {
                    vm.contas.push(vm.contasAll[i]);

                    if (vm.contasAll[i].isPadraoOperacao)
                    {
                        vm.conta = vm.contasAll[i];
                    }
                }
            }

            if (vm.conta == null && vm.contas.length > 0)
            {
                vm.conta = vm.contas[0];
            }
        }
    }

    vm.enviarNegociacao = function()
    {
        if (vm.originador == null)
        {
            toastr.error('Originador é obrigatório.', 'Alerta');
            return;
        }

        if (vm.conta == null)
        {
            toastr.error('Conta bancária é obrigatório.', 'Alerta');
            return;
        }

        var operacaoUpdate = vm.operacao.antecipacao;

        operacaoUpdate.titulos = [];
        operacaoUpdate.cedente = null;

        operacaoUpdate.domicilioBancario = vm.conta;
        operacaoUpdate.domicilioBancario.originador = null;
        operacaoUpdate.originador = vm.originador;
        operacaoUpdate.originador.socios = null;
        //operacaoUpdate.antecipacaoFluxoAprovacao = null;

        vm.consultaPromise = $http.post(APP_MNP + "/invoice/operacao/analise/aprovar", operacaoUpdate).success(function(response){
            toastr.info('Operação aprovada com sucesso.', 'Alerta');
            $state.go('index.invoice_operacoes');
            //vm.operacao = response;
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('OperacaoFormalizacaoController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal', '$sce',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal, $sce)
{
    var vm = this;
    vm.antecipacaoViewId = $state.params.obj;
    vm.operacao = {};

    vm.init = function()
    {
        vm.consultar();
        //vm.gerarContratoMae();
    }

    vm.consultar = function()
    {
      vm.consultaPromise = $http.get(APP_MNP + "/invoice/operacao/formalizacao/" + vm.antecipacaoViewId)
      .then(function(response)
      { 
            vm.operacao = response.data;

            // Salario sob demanda
            if (vm.operacao.tipo == 8) {
                vm.gerarTermoCessao();
                vm.gerarNotaPromissoria();
            }
            // Normal
            else {
                vm.gerarTermoAditivo();
            }
      });
    }

    vm.gerarContratoMae = function()
    {
        vm.fileContratoMae =  $sce.trustAsResourceUrl(APP_MNP + "/invoice/operacao/formalizacao/contratomae/" + vm.antecipacaoViewId);
    }

    vm.gerarTermoAditivo = function()
    {
        vm.fileTermoAditivo =  $sce.trustAsResourceUrl(APP_MNP + "/invoice/operacao/formalizacao/termoaditivo/" + vm.antecipacaoViewId);
    }

    vm.gerarTermoCessao = function()
    {
        vm.fileTermoCessao =  $sce.trustAsResourceUrl(APP_MNP + "/invoice/operacao/formalizacao/termocessao/" + vm.antecipacaoViewId);
    }

    vm.gerarNotaPromissoria = function()
    {
        vm.fileNotaPromissoria =  $sce.trustAsResourceUrl(APP_MNP + "/invoice/operacao/formalizacao/notapromissoria/" + vm.antecipacaoViewId);
    }

    vm.enviar = function()
    {
        if (confirm('Deseja confirmar a operação?'))
        {
            vm.consultaPromise = $http.post(APP_MNP + "/invoice/operacao/formalizacao/aprovar/" +vm.antecipacaoViewId).success(function(response){
                toastr.info('Formalização enviada com sucesso.', 'Alerta');
                $state.go('index.invoice_operacoes');            
                return response;
            }).error(function(error){
                return error;
            });
        }        
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceFluxoAnaliseController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP)
  {
    var vm = this;
    vm.viewId = $state.params.obj;
    vm.registro = {};

    vm.init = function()
    {        
        vm.listar();
    }

    vm.consultar = function(etapa) 
    {
        $state.go('index.operacao_fluxo_analise_etapa', {obj: etapa.viewId});
    }

    vm.listar = function()
    {
        vm.registro = null;

        return $http.get(APP_MNP + "/antecipacaoFluxo/fluxooperacao/" + vm.viewId)
        .then(function(response)
        {
            vm.registro = response.data;
        });        
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseRelatoController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$uibModal', '$http', 'APP_MNP', '$sce', 'fileparam',
      function($scope, $state, toastr, $uibModalInstance, $uibModal, $http, APP_MNP, $sce, fileparam)
  {
    var vm = this;
    vm.pdfstr = fileparam;

    vm.init = function() {
      vm.carregarPdf(vm.pdfstr);
    }
    
    vm.carregarPdf = function (serasaStr) {
      $http.post(APP_MNP + '/vadu/relatoriocnpj',
          { stringSerasa: serasaStr },
          { responseType: 'arraybuffer' }
      ).then(function (response) {
          if (vm.pdfUrl) {
              URL.revokeObjectURL(vm.pdfUrl);
          }

          var blob = new Blob([response.data], { type: 'application/pdf' });
          vm.pdfUrl = URL.createObjectURL(blob);
          vm.fileDocumento = $sce.trustAsResourceUrl(vm.pdfUrl);
      }, function (error) {
          console.error('Erro ao gerar relatório PDF', error);
      });
    };

    vm.fechar = function() {
      $uibModalInstance.close(vm.pareceres);
    };

    vm.init();
  }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseParecerController', ['$http', 'APP_MNP', '$uibModalInstance', 'toastr', 'antecipacaoId', 'pareceres',
      function($http, APP_MNP, $uibModalInstance, toastr, antecipacaoId, pareceres)
  {
    var vm = this;
    vm.antecipacaoId = antecipacaoId;
    vm.pareceres = pareceres || [];
    vm.novoParecer = '';
    vm.isSaving = false;
    vm.editandoId = null;
    vm.textoEdicao = '';
    vm.isSavingEdicao = false;

    // Regra: enquanto a análise está aberta, o autor pode editar/excluir só o próprio parecer
    // (controller.podeEditar vem calculado do backend). Depois de fechada, ninguém edita/exclui,
    // mas ainda é possível criar um parecer novo (que já nasce travado).

    // Enquanto a análise está aberta, cada usuário só pode ter 1 parecer (edita em vez de criar outro).
    // Se algum parecer da lista tem podeEditar=true, é o meu e a análise ainda está aberta.
    vm.podeCriarNovoParecer = function() {
      return !vm.pareceres.some(function(p) { return p.podeEditar; });
    };

    vm.salvar = function() {
      var texto = (vm.novoParecer || '').trim();
      if (!texto) return;

      vm.isSaving = true;
      $http.post(APP_MNP + "/antecipacaoanalisehistorico/salvar", {
        antecipacaoId: vm.antecipacaoId,
        parecerAnalise: texto
      }).success(function(response) {
        vm.pareceres.unshift(response);
        vm.novoParecer = '';
        vm.isSaving = false;
        toastr.success('Parecer registrado com sucesso.', 'Sucesso');
      }).error(function(error) {
        vm.isSaving = false;
        toastr.error(error, 'Erro ao salvar parecer');
      });
    };

    vm.iniciarEdicao = function(p) {
      vm.editandoId = p.id;
      vm.textoEdicao = p.parecerAnalise;
    };

    vm.cancelarEdicao = function() {
      vm.editandoId = null;
      vm.textoEdicao = '';
    };

    vm.salvarEdicao = function() {
      var texto = (vm.textoEdicao || '').trim();
      if (!texto || !vm.editandoId) return;

      vm.isSavingEdicao = true;
      $http.put(APP_MNP + "/antecipacaoanalisehistorico/editar", {
        id: vm.editandoId,
        parecerAnalise: texto
      }).success(function(response) {
        var idx = vm.pareceres.findIndex(function(p) { return p.id === vm.editandoId; });
        if (idx !== -1) {
          vm.pareceres[idx] = response;
        }
        vm.editandoId = null;
        vm.textoEdicao = '';
        vm.isSavingEdicao = false;
        toastr.success('Parecer atualizado com sucesso.', 'Sucesso');
      }).error(function(error) {
        vm.isSavingEdicao = false;
        toastr.error(error, 'Erro ao editar parecer');
      });
    };

    vm.excluir = function(p) {
      if (!confirm('Deseja realmente excluir este parecer?')) return;

      $http.delete(APP_MNP + "/antecipacaoanalisehistorico/excluir/" + p.id)
        .success(function() {
          vm.pareceres = vm.pareceres.filter(function(item) { return item.id !== p.id; });
          toastr.success('Parecer excluído.', 'Sucesso');
        })
        .error(function(error) {
          toastr.error(error, 'Erro ao excluir parecer');
        });
    };

    vm.fechar = function() {
      $uibModalInstance.close(vm.pareceres);
    };
  }]);

'use strict';

angular.module('inspinia')
  .controller('AntecipacaoRealizarPropostaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_MNP)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.proposta = {
      antecipacaoViewId: antecipacao.viewId
    };

    vm.init = function()
    {

    }

    vm.enviar = function()
    {
      if (vm.proposta.antecipacaoViewId == null)
      {
        alert('Antecipacao não selecionada.');
        return;
      }

      if (vm.proposta.valor == null || vm.proposta.valor == '')
      {
        alert('Valor não informado.');
        return;
      }

      if (vm.proposta.fator == null || vm.proposta.fator == '')
      {
        alert('Fator não informado.');
        return;
      }

      if (vm.proposta.banco == null || vm.proposta.banco == '')
      {
        alert('Banco não informado.');
        return;
      }

      if (vm.proposta.agencia == null || vm.proposta.agencia == '')
      {
        alert('Agência não informada.');
        return;
      }

      if (vm.proposta.conta == null || vm.proposta.conta == '')
      {
        alert('Conta não informada.');
        return;
      }

      $http.post(APP_MNP + "/invoice/proposta/enviar", vm.proposta).success(function(response){
          vm.fechar();
          toastr.info('Proposta enviada com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ConsultarTitulosPropostaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_MNP)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.propostas = [];

    vm.init = function()
    {
      return $http.get(APP_MNP + "/invoice/antecipacao/consultartitulos/" + antecipacao.viewId)
      .then(function(response)
      { 
          vm.titulos = response.data;
          //vm.registros = response.data;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseBorderoController', ['$http', 'APP_MNP', '$uibModalInstance', 'analise',
      function($http, APP_MNP, $uibModalInstance, analise)
  {
    var vm = this;
    vm.analise = analise;
    vm.dataGeracao = new Date();
    vm.logoUrl = null;

    vm.titulosAceitos = (vm.analise && vm.analise.titulos) ? vm.analise.titulos.filter(function(t) { return !t.recusado; }) : [];
    vm.titulosRecusados = (vm.analise && vm.analise.titulos) ? vm.analise.titulos.filter(function(t) { return t.recusado; }) : [];

    vm.totalAceitos = vm.titulosAceitos.reduce(function(soma, t) { return soma + (t.valor || 0); }, 0);
    vm.totalRecusados = vm.titulosRecusados.reduce(function(soma, t) { return soma + (t.valor || 0); }, 0);

    // Réplica de MainController.consultarLogo (app/main/main.controller.js:37-51)
    vm.consultarLogo = function() {
      return $http.get(APP_MNP + "/empresa/consultarlogo", { responseType: 'arraybuffer' })
        .then(function(response) {
          if (response.data) {
            var blob = new Blob([response.data], { type: 'image/png' });
            vm.logoUrl = (window.URL || window.webkitURL).createObjectURL(blob);
          } else {
            vm.logoUrl = null;
          }
        }, function(error) {
          vm.logoUrl = 'assets/images/icons/icon_rb.png';
        });
    };

    vm.imprimir = function() {
      window.print();
    };

    vm.fechar = function() {
      $uibModalInstance.close();
    };

    vm.consultarLogo();
  }]);

'use strict';

angular.module('inspinia')
  .controller('FluxoAprovacaoEtapaConfigController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal', '$window',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal, $window)
{
    var vm = this;
    vm.isUpdate = false;
    vm.obj = $state.params.obj;
    vm.fluxoId = $state.params.fluxoId;
    vm.registro = {

    };

    vm.init = function()
    {        
        if (vm.fluxoId == null)
        {
            vm.voltar();
        }

        if (vm.obj != null)
        {
            vm.isUpdate = true;
            vm.registro = vm.obj;
            vm.consultar();
        }        
    }

    vm.consultar = function()
    {
        vm.pesquisarPromise = $http.get(APP_MNP + "/fluxoaprovacao/etapa/" + vm.obj.viewId)
        .then(function(response)
        { 
            vm.registro = response.data;
        });
    }

    vm.salvar = function() {
        // CRIAR
        if (!vm.isUpdate) {

            vm.registro.fluxoAprovacaoModelo = {
                viewId : vm.fluxoId
            };            
            vm.registro.viewId = '00000000-0000-0000-0000-000000000000';

            vm.salvarPromise = $http.post(APP_MNP + "/fluxoaprovacao/etapa", vm.registro).success(function(response){
                toastr.info('Etapa cadastrada com sucesso.', 'Alerta');
                vm.voltar();
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
        // ATUALIZAR
        else {

        }
    }

    vm.adicionarCampo = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/fluxo_aprovacao/configuracao/etapa/campo/index.html',
        controller: 'FluxoAprovacaoEtapaCampoConfigController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',        
        resolve: {
          etapa: function () {
            return vm.registro.viewId;
          },
        }
      }).closed.then(function(){
        vm.consultar();
      });
    }

    vm.voltar = function() {
        $window.history.back();
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('EmailTemplateListarController', ['$scope', '$state', 'toastr', 'PagerService', '$http','APP_MNP',
      function($scope, $state, toastr, PagerService, $http, APP_MNP) 
{
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registros = null;

    vm.init = function()
    {
        vm.pesquisar();
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/emailTemplate/pesquisar");

        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
        });
    }

    vm.consultar = function(sacado)
    {
        $state.go('index.email_template', {obj: sacado.viewId});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_sacado');
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorIncluirEmpresaControllerOLD', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http',
      function($scope, $state, toastr, $uibModalInstance, $http)
{
    var vm = this;

    vm.init = function()
    {
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('EmailMalaDiretaSacadoController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, $compile)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.registro = {
        enderecoUf: null
    };
       
    vm.init = function()
    {
      vm.consultar();
      $scope.$watch('controller.registro.enderecoUf', function(newValue, oldValue) {
          if (newValue !== oldValue && vm.registrosOriginal && vm.registrosOriginal.length > 0) {
              console.log('Estado mudou:', oldValue, '->', newValue);
              vm.filtrarPesquisa();
          }
      });
    }

    vm.selecionar = function()
    {
      var registros = [];
      for (var i=0;i<vm.registrosOriginal.length;i++) {
        if (vm.registrosOriginal[i].selecionado != null && vm.registrosOriginal[i].selecionado == true) {
          registros.push(vm.registrosOriginal[i]);
        }
      }


      if (registros.length == 0) {
        alert('Não foram selecionados registros.');
      }
      else {
        $uibModalInstance.close(registros);
      }
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_MNP + "/emailmaladireta/pesquisarsacados")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];
    //console.log("Estado selecionado: ", vm.registro.enderecoUf);
    //console.log("Registros original: ", vm.registrosOriginal.length);
        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var registro = vm.registrosOriginal[i];
            var incluir = true;
            
            // Filtro por Estado
            if (vm.registro.enderecoUf && vm.registro.enderecoUf !== '') {
                if (!registro.enderecoUf || registro.enderecoUf !== vm.registro.enderecoUf) {
                    continue; // Pula este registro
                }
            }
            
            // Filtro por pesquisa de texto
            if (vm.filtro.pesquisa && vm.filtro.pesquisa.trim() !== '')
            {
                var termo = vm.filtro.pesquisa.toUpperCase();
                var encontrouEm = (
                    (registro.nomeFantasia && registro.nomeFantasia.toUpperCase().includes(termo)) ||
                    (registro.razaoSocial && registro.razaoSocial.toUpperCase().includes(termo)) ||
                    (registro.cnpj && registro.cnpj.toUpperCase().includes(termo))
                );
                if (!encontrouEm) {
                    continue; // Pula este registro
                }
            }
            
            // Se chegou até aqui, o registro passou por todos os filtros
            vm.registros.push(registro);
        }
        
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.limparFiltroEstado = function() {
        vm.registro.enderecoUf = null;
        vm.filtrarPesquisa();
    };

    vm.limparFiltroPesquisa = function() {
        vm.filtro.pesquisa = null;
        vm.filtrarPesquisa();
    };

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('EmailMalaDiretaDigitarController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'APP_MNP', '$http',
      function($scope, $state, toastr, $uibModalInstance, APP_MNP, $http)
  {
    var vm = this;
    vm.registro = {};

    vm.init = function()
    {
    }

    vm.incluir = function()
    {
        if (vm.registro.nome == null || vm.registro.nome == '')
        {
            alert('Favor informar o Nome.');
            return;
        }

        if (vm.registro.email == null || vm.registro.email == '')
        {
            alert('Favor informar o E-mail.');
            return;
        }

        $uibModalInstance.close(vm.registro);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('EmailMalaDiretaHistoricoController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', 'modalService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService,  modalService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        data: new Date(),
    };
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.novaPoc = function() {
        $state.go('index.cedente_pocexpressa');
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;

        vm.consultarPromise = $http.post(APP_MNP + "/EmailMalaDireta/historico", vm.filtro)
        .success(function(response){
            vm.registrosOriginal = response;
            vm.registros = response;
            vm.filtrarPesquisa();
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.consultar = function(item)
    {
        $state.go('index.cedente_pocexpressa', {obj: item.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.fantasia != null && vm.filtro.fantasia != '')
            {
                if (!vm.registrosOriginal[i].cedente.nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].cedente.razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].cedente.id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cedente.cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
    .controller('EmailMalaDiretaCedenteController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', '$compile',
        function ($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, $compile) {
            var vm = this;
            vm.pager = {};
            vm.setPage = setPage;
            vm.registrosOriginal = [];
            vm.registros = null;
            vm.filtro = {};
            vm.filtroAtivoVmoney = 'ativo';
            vm.selecionarTodos = false;

            // Inicializa Filtros de Email
            vm.filtroEmail = {
                cobranca: true,
                financeiro: true,
                comercial: false
            };

            vm.validarFiltroEmail = function () {
                if (!vm.filtroEmail.cobranca && !vm.filtroEmail.financeiro && !vm.filtroEmail.comercial) {
                    toastr.warning('Selecione pelo menos um tipo de e-mail (Cobrança, Financeiro ou Comercial).');
                    vm.filtroEmail.cobranca = true; // Força um padrão se tudo for desmarcado
                }
                vm.atualizarVisualizacaoEmails();
            };

            vm.atualizarVisualizacaoEmails = function () {
                if (!vm.registrosOriginal) return;

                // Itera sobre os registros originais para atualizar a propriedade .email (exibição)
                for (var i = 0; i < vm.registrosOriginal.length; i++) {
                    var r = vm.registrosOriginal[i];
                    var emailsParaExibir = [];

                    if (vm.filtroEmail.cobranca && r.emailOriginal) {
                        emailsParaExibir.push(r.emailOriginal);
                    }
                    if (vm.filtroEmail.financeiro && r.emailFinanceiro) {
                        emailsParaExibir.push(r.emailFinanceiro);
                    }
                    if (vm.filtroEmail.comercial && r.emailComercial) {
                        emailsParaExibir.push(r.emailComercial);
                    }

                    // Atualiza a propriedade email usada no bind do HTML
                    r.email = emailsParaExibir.join('; ');
                }
            };


            vm.init = function () {
                vm.consultar();
            }

            // vm.selecionar = function()
            // {
            //   var registros = [];
            //   for (var i=0;i<vm.registrosOriginal.length;i++) {
            //     if (vm.registrosOriginal[i].selecionado != null && vm.registrosOriginal[i].selecionado == true) {
            //       registros.push(vm.registrosOriginal[i]);
            //     }
            //   }
            //
            //
            //   if (registros.length == 0) {
            //     alert('Não foram selecionados registros.');
            //   }
            //   else {
            //     $uibModalInstance.close(registros);
            //   }
            // }

            vm.selecionar = function () {
                var registros = [];
                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.registros[i].selecionado === true) {
                        var registroOriginal = vm.registros[i];

                        // Clona o objeto para o retorno, preservando o original na lista
                        var registroParaEnvio = angular.copy(registroOriginal);

                        var emailsParaEnviar = [];

                        // Verifica filtros e existência dos e-mails
                        if (vm.filtroEmail.cobranca && registroOriginal.emailOriginal) {
                            emailsParaEnviar.push(registroOriginal.emailOriginal);
                        }
                        if (vm.filtroEmail.financeiro && registroOriginal.emailFinanceiro) {
                            emailsParaEnviar.push(registroOriginal.emailFinanceiro);
                        }
                        if (vm.filtroEmail.comercial && registroOriginal.emailComercial) {
                            emailsParaEnviar.push(registroOriginal.emailComercial);
                        }

                        // Só adiciona se houver algum e-mail válido para os filtros selecionados
                        if (emailsParaEnviar.length > 0) {
                            registroParaEnvio.email = emailsParaEnviar.join('; ');
                            registros.push(registroParaEnvio);
                        }
                    }
                }

                if (registros.length == 0) {
                    alert('Não foram selecionados registros com e-mails válidos para os filtros aplicados.');
                } else {
                    $uibModalInstance.close(registros);
                }
            }


            vm.toggleSelecionarTodos = function () {
                // Aplica a seleção a TODOS os registros filtrados, não apenas os da página atual
                for (var i = 0; i < vm.registros.length; i++) {
                    var item = vm.registros[i];
                    // Só marca/desmarca se o cedente tem email (não está desabilitado)
                    if (item.email != null && item.email != '') {
                        item.selecionado = vm.selecionarTodos;
                    }
                }

                // Atualiza o estado visual dos checkboxes da página atual
                vm.atualizarEstadoSelecionarTodos();
            };


            vm.consultar = function () {
                vm.consultarPromise = $http.get(APP_MNP + "/emailmaladireta/pesquisarcedentes")
                    .then(function (response) {
                        vm.registrosOriginal = response.data;

                        // Marca todos os cedentes como selecionados inicialmente
                        for (var i = 0; i < vm.registrosOriginal.length; i++) {
                            if (vm.registrosOriginal[i].email != null && vm.registrosOriginal[i].email != '') {
                                vm.registrosOriginal[i].selecionado = true;
                            }
                        }

                        vm.registros = vm.registrosOriginal;
                        vm.atualizarVisualizacaoEmails(); // Aplica filtros iniciais na visualização
                        vm.filtrarPesquisa();
                    });
            }

            vm.filtrarPesquisa = function () {
                vm.registros = [];
                for (var i = 0; i < vm.registrosOriginal.length; i++) {
                    var registro = vm.registrosOriginal[i];


                    var incluir = true;
                    //console.log(registro, vm.filtroAtivoVmoney);

                    // Filtro AtivoVmoney
                    if (vm.filtroAtivoVmoney === 'ativo' && registro.ativoVmoney !== true) {
                        continue;
                    }
                    if (vm.filtroAtivoVmoney === 'inativo' && registro.ativoVmoney !== false) {
                        continue;
                    }

                    // Filtro de pesquisa por texto
                    if (vm.filtro.pesquisa && vm.filtro.pesquisa.trim() !== '') {
                        var termo = vm.filtro.pesquisa.toUpperCase();
                        var encontrouEm = (
                            (registro.nomeFantasia && registro.nomeFantasia.toUpperCase().includes(termo)) ||
                            (registro.razaoSocial && registro.razaoSocial.toUpperCase().includes(termo)) ||
                            (registro.cnpj && registro.cnpj.toUpperCase().includes(termo)) ||
                            (registro.codigoVmoney != null && String(registro.codigoVmoney).toUpperCase().includes(termo))
                        );
                        if (!encontrouEm) {
                            continue;
                        }
                    }

                    // Se chegou até aqui, o registro passou por todos os filtros
                    vm.registros.push(registro);
                }

                vm.pager.totalPages = 1;
                vm.setPage(1);
                // Atualiza o estado do checkbox "selecionar todos" após filtrar
                vm.atualizarEstadoSelecionarTodos();
            }



            vm.fechar = function () {
                $uibModalInstance.close();
            }

            vm.init();


            vm.atualizarEstadoSelecionarTodos = function () {
                // Verifica o estado baseado em TODOS os registros filtrados, não apenas os da página
                if (!vm.registros || vm.registros.length === 0) {
                    vm.selecionarTodos = false;
                    return;
                }

                var itensHabilitados = vm.registros.filter(function (item) {
                    return item.email != null && item.email != '';
                });

                if (itensHabilitados.length === 0) {
                    vm.selecionarTodos = false;
                    return;
                }

                var todosSelecionados = itensHabilitados.every(function (item) {
                    return item.selecionado === true;
                });

                vm.selecionarTodos = todosSelecionados;
            };


            function setPage(page) {
                if (page < 1 || page > vm.pager.totalPages) {
                    return;
                }
                vm.pager = PagerService.GetPager(vm.registros.length, page);
                vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
                // Atualiza o estado do checkbox "selecionar todos" baseado nos itens da página atual
                vm.atualizarEstadoSelecionarTodos();
            }

        }]);
'use strict';

angular.module('inspinia')
  .controller('GestaoCarteiraComuVencidosController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', 'AuthService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, AuthService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        cedente: null,
        sacado: null,
        operacaoInicial: null,
        operacaoFinal: null,
        vencimentoInicial: new Date(),
        vencimentoFinal: new Date(),
        tipoSacado: 0,
        templateText: 'vencidos1dia',
        enviarBoleto: '0',
        atualizarBoleto: '0',
        comunicarCedente: '0',
        carteira: '0',
    };
    vm.pager = {};
    vm.setPage = setPage;
    vm.cedente = null;
    vm.email = '';
    vm.cedenteViewId = '';
    vm.selecionadoTodos = false;
    vm.permiteAtualizarBoleto = true;
    vm.empresaId = AuthService.getEmpresaId();

    var apienvio = APP_MNP;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        // Desabilitar atualizacao de boleto para PERDIZES
        if (vm.empresaId == '836c9e79-3d37-4a9c-a618-9925f1136e3d') {
            vm.permiteAtualizarBoleto = false;

            // 27/04/2026 - Solucao temporaria para o bloqueio de SMTP Perdizes
            //apienvio = 'https://apihmg.moneynow.com.br/api_prod/api';
        }

        //vm.pesquisar(); 
        vm.loadPeriodo();
    }

    vm.selecionarTodos = function() {
        var selecionado = vm.selecionadoTodos;
        for (var i=0; i<vm.registros.length;i++) {
            vm.registros[i].selecionado = selecionado;
        }
    }

    vm.loadPeriodo = function() {
        vm.filtro.cedente = null;
        vm.filtro.cedenteViewId = null;
        vm.cedenteViewId = null;
        vm.registros = null;
        vm.registrosOriginal = null;
        vm.filtro.atualizarBoleto = '0';

        vm.consultarPromise = $http.get(APP_MNP + "/EmailComunicacaoVencidos/vencimento/" + vm.filtro.templateText).success(function(response){
            if (response != null) {
                vm.filtro.vencimentoInicial = new Date(response.dataInicio);
                //vm.filtro.vencimentoFinal = new Date(response.dataInicio);
                vm.filtro.vencimentoFinal = new Date(response.dataFim);
                //vm.filtro.vencimentoFinal = new Date(response.dataFim);

                if (response.email != null && response.email != '' && vm.email == '') {
                    vm.email = response.email;
                }
            }
    }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
    });
    }

    vm.selecionarCedenteModal = function()
    {    
        vm.filtro.cedente = null;
        vm.filtro.cedenteViewId = null;
        vm.cedenteViewId = null;
        
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/cedente/selecionar/index.html',
        controller: 'CedenteSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.registrosOriginal = null;
            vm.registros = null;
            vm.filtro.cedente = null;
            if (data != null)
            {
                vm.filtro.cedente = data;
                vm.filtro.cedenteViewId = data.viewId;
            }      
        });
    }

    vm.selecionarSacadoModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/sacado/selecionar/index.html',
        controller: 'SacadoSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.registrosOriginal = null;
            vm.registros = null;
            vm.filtro.sacado = null;
            if (data != null)
            {
                vm.filtro.sacado = data;
                vm.filtro.sacadoViewId = data.viewId;
            }      
        });
    }

    vm.pesquisar = function()
    {
        if (vm.filtro.cedente == null && vm.filtro.templateText !== 'vencidos5diasComCartorio' 
            && vm.filtro.templateText !== 'vencidos5diasSemCartorio'  
            && vm.filtro.templateText !== 'vencidosComCartorio')
        {
            toastr.error('Selecione um Cedente.', 'Alerta');
            return;
        }
        
        //var dataOperacaoInformado = vm.filtro.operacaoInicial != null && vm.filtro.operacaoFinal != null;
        var dataVencimentoInformado = vm.filtro.vencimentoInicial != null && vm.filtro.vencimentoFinal != null;

        if (dataVencimentoInformado == false)
        {
            toastr.error('Selecione um período.', 'Alerta');
            return;
        }

        // Validar data vencimento
        var datahoje = new Date();
        datahoje.setHours(0, 0, 0, 0);
        if (vm.filtro.templateText == 'vencido' && vm.filtro.templateText !== 'vencidosComCartorio') {
            if (vm.filtro.vencimentoFinal >= datahoje) {
                toastr.error('Data de vencimento não pode ser maior ou igual a hoje.', 'Alerta');
                return;
            }
        }

        vm.registrosOriginal = null;
        vm.registros = null;
        vm.selecionadoTodos = null;

        vm.consultarPromise = $http.post(APP_MNP + "/EmailComunicacaoVencidos/listar", vm.filtro).success(function(response){
            vm.registrosOriginal = response.response;
            vm.registros = response.response;
            //vm.email = response.email;
            //vm.cedenteViewId = vm.filtro.cedente.viewId;

            if (vm.registros == null || vm.registros.length == 0)
            {
                toastr.warning('Não foram encontrados lançamentos.', 'Alerta');
            }
            else
            {
                for (var i=0;i<vm.registros.length;i++)
                {
                    vm.registros[i].selecionado = true;
                }
            }

            vm.filtrarPesquisa();

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.enviarEmail = function() 
    {
        var lancamentos = [];

        for (var i=0;i<vm.registros.length;i++)
        {
            if (vm.registros[i].selecionado)
            {
                lancamentos.push(vm.registros[i]);
            }
        }
        
        for (var i=0;i<lancamentos.length;i++) {
            var cnpj = lancamentos[i].cnpjSacado;
            var quantidade = 0;
            
            for (var j=0;j<lancamentos.length;j++) {
                if (lancamentos[j].cnpjSacado == cnpj) {
                    quantidade++;
                }
            }

            if (quantidade > 10) {
                toastr.error('Não é permitido o envio acima de 10 boletos para um mesmo sacado. Sacado: ' + lancamentos[i].nomeSacado, 'Alerta');
                return;
            }
        }
        /*
        if (lancamentos.length > 10) {
            toastr.error('Não é permitido o envio acima de 10 boletos.', 'Alerta');
            return;
        }
        */

        var sacadoCnpj = '';
        var sacadoGrupo = '';

        if (vm.filtro.tipoSacado == 0) {
            if (vm.filtro.sacado != null) {
                sacadoCnpj = vm.filtro.cnpj;
            }
        }
        else {
            if (vm.filtro.grupoSacado != null) {
                sacadoGrupo = vm.filtro.grupoSacado;
            }
        }

        var request = {
            email: vm.email,
            lancamentos: lancamentos,
            cedenteViewId: vm.cedenteViewId,
            sacadoViewId: vm.sacadoViewId,
            sacadoCnpj: sacadoCnpj,
            sacadoGrupo: sacadoGrupo,
            templateText: vm.filtro.templateText,
            enviarBoleto: vm.filtro.enviarBoleto,
            atualizarBoleto: vm.filtro.atualizarBoleto,
            comunicarCedente: vm.filtro.comunicarCedente,
        };

        vm.consultarPromise = $http.post(apienvio + "/EmailComunicacaoVencidos/enviarEmail", request).success(function(response){
            
            //vm.items = null;
            //vm.registrosOriginal = null;
            //vm.registros = null;

            toastr.info('E-mail enviado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.cedente_consultar', {obj: fornecedor.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.fantasia != null && vm.filtro.fantasia != '')
            {
                if (!vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.desmarcarTodos();
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'lancamento':
                    vm.registros.reverse(function(a, b){
                        if(a.lancamento < b.lancamento) { return -1; }
                        if(a.lancamento > b.lancamento) { return 1; }
                        return 0;
                    })
                    break;
                case 'diasAtraso':
                    vm.registros.reverse(function(a, b){
                        if(a.diasAtraso < b.diasAtraso) { return -1; }
                        if(a.diasAtraso > b.diasAtraso) { return 1; }
                        return 0;
                    })
                    break;
                case 'banco':
                    vm.registros.reverse(function(a, b){
                        if(a.codBanco < b.codBanco) { return -1; }
                        if(a.codBanco > b.codBanco) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.reverse(function(a, b){
                        if(a.nomeSacado < b.nomeSacado) { return -1; }
                        if(a.nomeSacado > b.nomeSacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimento);
                        var dateB = new Date(b.dataVencimento);
                        return dateA - dateB;
                    });
                    break;
                case 'valortitulo':
                    vm.registros.reverse(function(a, b){
                        if(a.valorTitulo < b.valorTitulo) { return -1; }
                        if(a.valorTitulo > b.valorTitulo) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'lancamento':
                    vm.registros.sort(function(a, b){
                        if(a.lancamento < b.lancamento) { return -1; }
                        if(a.lancamento > b.lancamento) { return 1; }
                        return 0;
                    })
                    break;
                case 'diasAtraso':
                    vm.registros.sort(function(a, b){
                        if(a.diasAtraso < b.diasAtraso) { return -1; }
                        if(a.diasAtraso > b.diasAtraso) { return 1; }
                        return 0;
                    })
                    break;
                case 'banco':
                    vm.registros.sort(function(a, b){
                        if(a.codBanco < b.codBanco) { return -1; }
                        if(a.codBanco > b.codBanco) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.sort(function(a, b){
                        if(a.nomeSacado < b.nomeSacado) { return -1; }
                        if(a.nomeSacado > b.nomeSacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimento);
                        var dateB = new Date(b.dataVencimento);
                        return dateA - dateB;
                    });
                    break;
                case 'valortitulo':
                    vm.registros.sort(function(a, b){
                        if(a.valorTitulo < b.valorTitulo) { return -1; }
                        if(a.valorTitulo > b.valorTitulo) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.marcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.filtro.status == vm.registros[i].status)
            {
                vm.registros[i].selecionado = true;
            }
        }
    }

    vm.desmarcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            vm.registros[i].selecionado = false;
        }
    }

    vm.visualizarBoleto = function(item) {
        // verificar boleto vencido itau
        if (item.codBanco == 341 && vm.filtro.atualizarBoleto == '1' && item.isVencido)
        {
            vm.verItauBoletoVencido(item);
        }
        else if (vm.permiteAtualizarBoleto && item.isVencido) {
            vm.verBoletoVencido(item);
        }
        else {
            vm.acaoTabelaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", item).success(function(response){
            
                //vm.download(response, 'application/pdf', 'boleto.pdf');
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/email/carteira/modal/boleto/index.html',
                    controller: 'CarteiraModalBoletoController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                    resolve: {
                        item: function () {
                            return response;
                        },
                    }
                }).closed.then(function(){
                    //vm.listar();
                });
    
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.verBoletoVencido = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/email/carteira/dinamica/vencido/index.html',
            controller: 'BoletoVencidoGerarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'md',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });
    }

    vm.verItauBoletoVencido = function(antecipacao)
    {
        vm.acaoTabelaPromise = $http.post(APP_MNP + "/emailCarteiraDinamica/itauboletovencidotoken", antecipacao)
        .then(function(response)
        { 
            var codigo = response.data;
            var modalInstance = $uibModal.open({
                templateUrl: 'app/email/carteira/dinamica/itau/boletovencido/index.html',
                controller: 'BoletoVencidoItauGerarController',
                controllerAs: 'controller',
                windowClass: 'inmodal',
                size: 'md',
                resolve: {
                    antecipacao: function () {
                        return antecipacao;
                    },
                    codigo: function () {
                        return codigo;
                    },
                }
            }).closed.then(function(){
                //vm.listar();
            });
        });
        
    }

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('EmailCarteiraDinamicaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', 'AuthService', 'modalService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, AuthService, modalService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        cedente: null,
        sacado: null,
        operacaoInicial: null,
        operacaoFinal: null,
        vencimentoInicial: null,
        vencimentoFinal: null,
        tipoSacado: 0,
    };
    vm.pager = {};
    vm.setPage = setPage;
    vm.cedente = null;
    vm.email = '';
    vm.cedenteViewId = '';
    vm.selecionadoTodos = false;
    vm.opcaoAtualizarBoleto = true;
    vm.empresaId = AuthService.getEmpresaId();

    // Adicione a função redirectToURL ao vm
    vm.redirectToURL = function() {
        var url = 'https://venturenegocios.com.br/wp-content/uploads/2024/12/IC-GERAÇÃO-DE-BOLETOS.pdf';
        modalService.openModal(url);
    };



    vm.selecionarTodos = function() {
        var selecionado = vm.selecionadoTodos;
        for (var i=0; i<vm.registros.length;i++) {
            vm.registros[i].selecionado = selecionado;
        }
    }

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        if (vm.empresaId == '836c9e79-3d37-4a9c-a618-9925f1136e3d') {
            // Desabilitar atualizacao de boleto
            vm.opcaoAtualizarBoleto = false;
        }
        //vm.pesquisar(); 
    }

    vm.selecionarCedenteModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/cedente/selecionar/index.html',
        controller: 'CedenteSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.registrosOriginal = null;
            vm.registros = null;
            vm.filtro.cedente = null;
            vm.filtro.cedenteViewId = null;
            if (data != null)
            {
                vm.filtro.cedente = data;
                vm.filtro.cedenteViewId = data.viewId;
            }      
        });
    }

    vm.selecionarSacadoModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/sacado/selecionar/index.html',
        controller: 'SacadoSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.registrosOriginal = null;
            vm.registros = null;
            vm.filtro.sacado = null;
            vm.filtro.sacadoViewId = null;
            if (data != null)
            {
                vm.filtro.sacado = data;
                vm.filtro.sacadoViewId = data.viewId;
            }      
        });
    }

    vm.pesquisar = function()
    {
        if (vm.filtro.cedente == null) 
        {
            toastr.error('Selecione um Cedente.', 'Alerta');
            return;
        }

        var dataOperacaoInformado = vm.filtro.operacaoInicial != null && vm.filtro.operacaoFinal != null;
        var dataVencimentoInformado = vm.filtro.vencimentoInicial != null && vm.filtro.vencimentoFinal != null;

        if (dataOperacaoInformado == false && dataVencimentoInformado == false)
        {
            toastr.error('Selecione um período.', 'Alerta');
            return;
        }

        // sacados
        /*
        if ((vm.filtro.sacado == null) && (vm.filtro.grupoSacado == null || vm.filtro.grupoSacado == '')) {
            toastr.error('Selecione um sacado.', 'Alerta');
            return;
        }
        */

        vm.registrosOriginal = null;
        vm.registros = null;

        vm.consultarPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/listar", vm.filtro).success(function(response){
            vm.registrosOriginal = response.response;
            vm.registros = response.response;
            vm.email = response.emailCopia;
            vm.cedenteViewId = vm.filtro.cedente.viewId;

            if (vm.registros == null || vm.registros.length == 0)
            {
                toastr.warning('Não foram encontrados lançamentos.', 'Alerta');
            }
            else
            {
                for (var i=0;i<vm.registros.length;i++)
                {
                    vm.registros[i].selecionado = true;
                }
            }

            vm.filtrarPesquisa();

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.baixarPdf = function() {
        if (!confirm('Deseja baixar os registros selecionados?')) {
            return;
        }

        var lancamentos = [];

        for (var i=0;i<vm.registros.length;i++)
        {
            if (vm.registros[i].selecionado)
            {
                lancamentos.push(vm.registros[i]);
            }
        }

        if (lancamentos.length == 0) {
            toastr.error('Selecione um lançamento.', 'Alerta');
            return;
        }

        /*
        if (lancamentos.length > 10) {
            toastr.error('Não é permitido o envio acima de 10 boletos.', 'Alerta');
            return;
        }
        */

        for (var i=0;i<lancamentos.length;i++) {
            vm.acaoTabelaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", lancamentos[i]).success(function(response, teste, teste1, req){
                vm.download(response, 'application/pdf', 'boleto_'+ req.data.numeroDocumento + '.pdf');
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
        
        vm.desmarcarTodos();
        vm.selecionadoTodos = false;
    }

    vm.enviarEmail = function() {
        if (!confirm('Deseja enviar o e-mail para os registros selecionados?')) {
            return;
        }

        var lancamentos = [];
        var sacadoCnpj = '';
        var sacadoGrupo = '';

        if (vm.filtro.tipoSacado == 0) {
            if (vm.filtro.sacado != null) {
                sacadoCnpj = vm.filtro.cnpj;
            }
        }
        else {
            if (vm.filtro.grupoSacado != null) {
                sacadoGrupo = vm.filtro.grupoSacado;
            }
        }

        for (var i=0;i<vm.registros.length;i++)
        {
            if (vm.registros[i].selecionado)
            {
                lancamentos.push(vm.registros[i]);
            }
        }

        if (lancamentos.length == 0) {
            toastr.error('Selecione um lançamento.', 'Alerta');
            return;
        }
        if (lancamentos.length > 10) {
            toastr.error('Não é permitido o envio acima de 10 boletos.', 'Alerta');
            return;
        }

        var isVencido = false;
        for (var i=0;i<lancamentos.length;i++) {
            if (lancamentos[i].isVencido) {
                isVencido = true;
                break;
            }
        }
        if (vm.opcaoAtualizarBoleto && isVencido) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/email/carteira/dinamica/email_vencido/index.html',
                controller: 'BoletoEmailVencidoGerarController',
                controllerAs: 'controller',
                windowClass: 'inmodal',
                size: 'md',
            }).result.then(function(data){
                if (data != null) {
                    vm.enviarEmailPost(lancamentos, sacadoCnpj, sacadoGrupo, data);
                }
            });
        } 
        else {
            vm.enviarEmailPost(lancamentos, sacadoCnpj, sacadoGrupo, false);
        }
    }

    vm.enviarEmailPost = function(lancamentos, sacadoCnpj, sacadoGrupo, isGerarAtualizado) 
    {
        var request = {
            email: vm.email,
            lancamentos: lancamentos,
            cedenteViewId: vm.cedenteViewId,
            sacadoViewId: vm.sacadoViewId,
            sacadoCnpj: sacadoCnpj,
            sacadoGrupo: sacadoGrupo,
            atualizarBoleto: isGerarAtualizado ? '1' : '0'
        };

        vm.consultarPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/enviarEmailAgrupamento", request).success(function(response){
            toastr.info('E-mail enviado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.cedente_consultar', {obj: fornecedor.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.fantasia != null && vm.filtro.fantasia != '')
            {
                if (!vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.desmarcarTodos();
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'lancamento':
                    vm.registros.reverse(function(a, b){
                        if(a.lancamento < b.lancamento) { return -1; }
                        if(a.lancamento > b.lancamento) { return 1; }
                        return 0;
                    })
                    break;
                case 'banco':
                    vm.registros.reverse(function(a, b){
                        if(a.codBanco < b.codBanco) { return -1; }
                        if(a.codBanco > b.codBanco) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.reverse(function(a, b){
                        if(a.nomeSacado < b.nomeSacado) { return -1; }
                        if(a.nomeSacado > b.nomeSacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'diasAtraso':
                    vm.registros.reverse(function(a, b){
                        if(a.diasAtraso < b.diasAtraso) { return -1; }
                        if(a.diasAtraso > b.diasAtraso) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimento);
                        var dateB = new Date(b.dataVencimento);
                        return dateA - dateB;
                    });
                    break;
                case 'valortitulo':
                    vm.registros.reverse(function(a, b){
                        if(a.valorTitulo < b.valorTitulo) { return -1; }
                        if(a.valorTitulo > b.valorTitulo) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'lancamento':
                    vm.registros.sort(function(a, b){
                        if(a.lancamento < b.lancamento) { return -1; }
                        if(a.lancamento > b.lancamento) { return 1; }
                        return 0;
                    })
                    break;
                case 'banco':
                    vm.registros.sort(function(a, b){
                        if(a.codBanco < b.codBanco) { return -1; }
                        if(a.codBanco > b.codBanco) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.sort(function(a, b){
                        if(a.nomeSacado < b.nomeSacado) { return -1; }
                        if(a.nomeSacado > b.nomeSacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'diasAtraso':
                    vm.registros.sort(function(a, b){
                        if(a.diasAtraso < b.diasAtraso) { return -1; }
                        if(a.diasAtraso > b.diasAtraso) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimento);
                        var dateB = new Date(b.dataVencimento);
                        return dateA - dateB;
                    });
                    break;
                case 'valortitulo':
                    vm.registros.sort(function(a, b){
                        if(a.valorTitulo < b.valorTitulo) { return -1; }
                        if(a.valorTitulo > b.valorTitulo) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.marcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.filtro.status == vm.registros[i].status)
            {
                vm.registros[i].selecionado = true;
            }
        }
    }

    vm.desmarcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            vm.registros[i].selecionado = false;
        }
    }

    vm.visualizarBoleto = function(item) {
        // verificar boleto vencido itau
        if (vm.opcaoAtualizarBoleto && item.codBanco == 341 && item.isVencido)
        {
            vm.verItauBoletoVencido(item);
        }
        else if (vm.opcaoAtualizarBoleto && item.isVencido) {
            vm.verBoletoVencido(item);
        }
        else {
            item.isGerarAtualizado = false;
            vm.acaoTabelaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", item).success(function(response){
            
                //vm.download(response, 'application/pdf', 'boleto.pdf');
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/email/carteira/modal/boleto/index.html',
                    controller: 'CarteiraModalBoletoController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                    resolve: {
                        item: function () {
                            return response;
                        },
                    }
                }).closed.then(function(){
                    //vm.listar();
                });
    
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.verBoletoVencido = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/email/carteira/dinamica/vencido/index.html',
            controller: 'BoletoVencidoGerarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'md',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });
    }

    vm.verItauBoletoVencido = function(antecipacao)
    {
        vm.acaoTabelaPromise = $http.post(APP_MNP + "/emailCarteiraDinamica/itauboletovencidotoken", antecipacao)
        .then(function(response)
        { 
            var codigo = response.data;
            var modalInstance = $uibModal.open({
                templateUrl: 'app/email/carteira/dinamica/itau/boletovencido/index.html',
                controller: 'BoletoVencidoItauGerarController',
                controllerAs: 'controller',
                windowClass: 'inmodal',
                size: 'md',
                resolve: {
                    antecipacao: function () {
                        return antecipacao;
                    },
                    codigo: function () {
                        return codigo;
                    },
                }
            }).closed.then(function(){
                //vm.listar();
            });
        });
        
    }

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
    .controller('LiquidacaoComissariasController', ['$scope', '$state', 'toastr', '$http', 'APP_MNP', 'PagerService', '$uibModal', 'AuthService',
        function ($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, AuthService) {
            var vm = this;
            vm.registro = null;
            vm.registros = null;
            vm.exibirLancamentos = false; // Esconde inicialmente
            vm.pastaDownloadPadrao = null;
            vm.filtro = {
                cedente: null,
                sacado: null,
                operacaoInicial: null,
                operacaoFinal: null,
                vencimentoInicial: new Date(),
                vencimentoFinal: new Date(),
                dataCorrecao: new Date(),
                dataPagamento: new Date(),
                loteEstorno: '',
                tipoSacado: 0,
                templateText: '9',
                enviarBoleto: '0',
                atualizarBoleto: '0',
                comunicarCedente: '0',
                contaGraficaCompleto: '0',
                contaGraficaCreditos: '0',
                contaGraficaHistorico: '1',
                carteira: '0',

            };
            vm.pager = {};
            vm.setPage = setPage;
            vm.cedente = null;
            vm.email = '';
            vm.cedenteViewId = '';
            vm.selecionadoTodos = false;
            vm.registroContaGrafica = null;
            vm.registroPosicaoAberto = null;
            vm.registroPosicaoGeral = null;
            vm.exibirColunaDiasAtraso = true;
            vm.empresaId = AuthService.getEmpresaId();
            vm.permiteAtualizarBoleto = true;

            function setPage(page) {
                if (page < 1 || page > vm.pager.totalPages) {
                    return;
                }
                vm.pager = PagerService.GetPager(vm.registros.length, page);
                vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
            }

            vm.init = function () {
                // Inicializa APENAS na primeira vez
                if (!vm.filtro.dataCorrecao) {
                    vm.filtro.dataCorrecao = new Date();
                }
                if (!vm.filtro.dataPagamento) {
                    vm.filtro.dataPagamento = new Date();
                }

                vm.loadPeriodo();
            }

            // Função para configurar pasta padrão
            vm.configurarPastaDownload = function () {
                if ('showDirectoryPicker' in window) {
                    window.showDirectoryPicker()
                        .then(function (directoryHandle) {
                            vm.pastaDownloadPadrao = directoryHandle;
                            localStorage.setItem('pastaDownloadProtocolo', JSON.stringify({
                                name: directoryHandle.name,
                                // Salva referência para uso posterior
                            }));
                            toastr.success('Pasta padrão configurada: ' + directoryHandle.name, 'Configuração');
                        })
                        .catch(function (err) {
                            console.log('Usuário cancelou ou erro:', err);
                        });
                } else {
                    toastr.warning('Seu navegador não suporta seleção de pasta. O download será feito normalmente.', 'Aviso');
                }
            };

            vm.loadPeriodo = function () {
                vm.filtro.cedente = null;
                vm.filtro.cedenteViewId = null;
                vm.cedenteViewId = null;
                vm.registros = null;
                vm.registrosOriginal = null;
                vm.registroContaGrafica = null;
                vm.registroPosicaoAberto = null;
                vm.registroPosicaoGeral = null;

                // Inicializa Data de Correção e Data de Pagamento com a data de hoje
                var hoje = new Date();

                // Mantém como objeto Date, não como string
                // vm.filtro.dataCorrecao = new Date(hoje);
                // vm.filtro.dataPagamento = new Date(hoje);
                //console.log('vm.filtro.datacorrecao', vm.filtro.data);

                vm.consultarPromise = $http.get(APP_MNP + "/EmailComunicacaoCedentes/vencimento/" + vm.filtro.templateText).success(function (response) {
                    if (response != null) {
                        vm.filtro.vencimentoInicial = new Date(response.dataInicio);
                        vm.filtro.vencimentoFinal = new Date(response.dataFim);

                        if (response.emailCopia != null && response.emailCopia != '' && vm.email == '') {
                            vm.email = response.emailCopia;
                        }
                    }
                }).error(function (error) {
                    toastr.error(error, 'Alerta');
                    return error;
                });
            }

            vm.filtroAlterado = function () {
                vm.registro = null;
                vm.registros = null;
                vm.registroContaGrafica = null;
                vm.registroPosicaoAberto = null;
                vm.registroPosicaoGeral = null;
            }

            vm.selecionarCedenteModal = function () {
                vm.filtro.cedente = null;
                vm.filtro.cedenteViewId = null;
                vm.cedenteViewId = null;

                var modalInstance = $uibModal.open({
                    templateUrl: 'app/cadastro/cedente/selecionar/index.html',
                    controller: 'CedenteSelecionarController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                }).result.then(function (data) {
                    vm.registrosOriginal = null;
                    vm.registros = null;
                    vm.filtro.cedente = null;
                    if (data != null) {
                        vm.filtro.cedente = data;
                        vm.filtro.cedenteViewId = data.viewId;

                        vm.emailCedente = data.email;
                    }
                });
            }


            vm.pesquisar = function () {
                vm.registro = null;
                vm.registros = [];
                vm.exibirLancamentos = false; // Esconde inicialmente
                vm.registroContaGrafica = null;
                // No controller
                vm.dataHoje = new Date();

                if (vm.filtro.cedente == null) {
                    toastr.error('Selecione um Cedente.', 'Alerta');
                    return;
                }


                // Cria uma nova data para hoje, sem horas
                var today = new Date();
                today.setHours(0, 0, 0, 0);

                // Cria uma nova data para vencimentoFinal, sem horas
                var vencimentoFinal = new Date(vm.filtro.vencimentoFinal);
                vencimentoFinal.setHours(0, 0, 0, 0);

                // console.log('vm.filtro', vm.filtro); 

                if (vm.filtro.templateText == '9') {
                    var dataVencimentoInformado = vm.filtro.vencimentoInicial != null && vm.filtro.vencimentoFinal != null;

                    if (dataVencimentoInformado == false && vm.filtro.loteEstorno == '') {
                        toastr.error('Selecione um período.', 'Alerta');
                        return;
                    }

                    vm.exibirColunaDiasAtraso = true;

                    vm.registrosOriginal = null;
                    vm.registros = null;
                    vm.selecionadoTodos = null;


                    vm.consultarPromise = $http.post(APP_MNP + "/EmailComunicacaoCedentes/listar", vm.filtro).success(function (response) {
                        vm.registro = response;
                        vm.registrosOriginal = response.registros;
                        //vm.registros = response.registros;
                        vm.registros = response.registros.map(function (registro) {
                            // Salva o valor original de valorPresente em valorPresenteOriginal
                            registro.valorPresenteOriginal = registro.valorPresente;
                            // Aqui você já formata valorPresente para exibir no input, que vai ser usdo com valorPago
                            registro.valorPresente = vm.formatarValorBrasileiro(registro.valorPresente);
                            return registro;
                        });

                        //vm.email = response.email;
                        //vm.cedenteViewId = vm.filtro.cedente.viewId;
                        console.log('vm.registros', vm.consultarPromise);

                        // Inicializa dataPagamento com a data do dia se vier como '01/01/1753' ou vazio
                        var today = new Date();
                        today = vm.filtro.dataPagamento
                        var dd = String(today.getDate()).padStart(2, '0');
                        var mm = String(today.getMonth() + 1).padStart(2, '0'); // Mês é baseado em 0 (janeiro é 0)
                        var yyyy = today.getFullYear();
                        var dataHojeFormatada = dd + '/' + mm + '/' + yyyy; // Ex: "17/07/2025"
                        if (vm.registrosOriginal) { // Use vm.registrosOriginal aqui para processar os dados brutos da API
                            for (var i = 0; i < vm.registrosOriginal.length; i++) {
                                var record = vm.registrosOriginal[i]; // Referência direta ao registro

                                // Apenas modifica 'dataPagamento' se for '01/01/1753' ou se estiver vazio/nulo.
                                // Nenhuma outra conversão de formato será feita.
                                if (record.dataPagamento === '01/01/1753' || !record.dataPagamento) {
                                    record.dataPagamento = dataHojeFormatada;
                                }

                                record.valorPresente = vm.formatarValorBrasileiro(record.valorPresente);

                            }
                        }

                        if (vm.registros == null || vm.registros.length == 0) {
                            toastr.warning('Não foram encontrados lançamentos.', 'Alerta');
                            vm.exibirLancamentos = false; // Mantém escondido se não houver dados
                        }
                        else {
                            vm.selecionadoTodos = false;

                            vm.emailCedente = vm.registros[0].emailCedente;

                            for (var i = 0; i < vm.registrosOriginal.length; i++) {
                                vm.registrosOriginal[i].selecionado = true;
                                vm.registros[i].selecionado = true;
                            }

                            vm.calcularTotalSelecionado();
                            vm.exibirLancamentos = true; // Mostra a seção quando há dados
                        }

                        //vm.filtrarPesquisa();

                        return response;
                    }).error(function (error) {
                        toastr.error(error, 'Alerta');
                        vm.exibirLancamentos = false; // Esconde em caso de erro
                        return error;
                    });
                }
            }


            vm.formatarValorBrasileiro = function (valor) {

                if (!valor) return '0,00';

                var valorNumerico = valor;

                // Se é string, converte para número
                if (typeof valor === 'string') {
                    // Remove formatação (pontos de milhares) e converte vírgula para ponto
                    valorNumerico = valor.replace(/\./g, '').replace(',', '.');
                    valorNumerico = parseFloat(valorNumerico);
                }
                // Se é number, usa diretamente
                else if (typeof valor === 'number') {
                    valorNumerico = valor;
                }

                // Se não é um número válido, retorna 0
                if (isNaN(valorNumerico)) {
                    return '0,00';
                }

                // CORREÇÃO: Se o valor original era um número inteiro maior que 100,
                // assume que já está no formato correto (reais, não centavos)
                // Formata para padrão brasileiro mantendo o valor original
                return valorNumerico.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            }



            vm.selecionarTodos = function () {
                var selecionado = vm.selecionadoTodos;

                // Padrao
                if (vm.registros != null) {
                    for (var i = 0; i < vm.registros.length; i++) {
                        vm.registros[i].selecionado = selecionado;
                    }
                }

                vm.calcularTotalSelecionado();
            }


            vm.consultar = function (fornecedor) {
                $state.go('index.cedente_consultar', { obj: fornecedor.viewId });
            }

            vm.filtrarPesquisa = function () {
                vm.registros = [];


                for (var i = 0; i < vm.registrosOriginal.length; i++) {
                    var incluir = true;

                    if (vm.filtro.fantasia != null && vm.filtro.fantasia != '') {
                        if (!vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase())) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.nome != null && vm.filtro.nome != '') {
                        if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase())) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.codigo != null && vm.filtro.codigo != '') {
                        if (vm.registrosOriginal[i].id != vm.filtro.codigo) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.cnpj != null && vm.filtro.cnpj != '') {
                        if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase())) {
                            incluir = false;
                        }
                    }


                    if (incluir) {
                        vm.registros.push(vm.registrosOriginal[i]);
                    }
                }

                vm.desmarcarTodos();
                vm.pager.totalPages = 1;
                vm.setPage(1);
            }

            vm.ordenarResultado = function (coluna) {
                vm.orderSelected = coluna;

                if (vm.lastOrder == coluna) {
                    vm.lastOrder = '';

                    switch (coluna) {
                        case 'lancamento':
                            vm.registros.reverse(function (a, b) {
                                if (a.lancamento < b.lancamento) { return -1; }
                                if (a.lancamento > b.lancamento) { return 1; }
                                return 0;
                            })
                            break; codBanco
                        case 'titulo':
                            vm.registros.reverse(function (a, b) {
                                if (a.numeroDocumento < b.numeroDocumento) { return -1; }
                                if (a.numeroDocumento > b.numeroDocumento) { return 1; }
                                return 0;
                            })
                            break;
                        case 'sacado':
                            vm.registros.reverse(function (a, b) {
                                if (a.nomeSacado < b.nomeSacado) { return -1; }
                                if (a.nomeSacado > b.nomeSacado) { return 1; }
                                return 0;
                            })
                            break;
                        case 'vencimento':
                            vm.registros.reverse(function (a, b) {
                                if (a.vencimento < b.vencimento) { return -1; }
                                if (a.vencimento > b.vencimento) { return 1; }
                                return 0;
                            })
                            break;
                        case 'datacadastro':
                            vm.registros.reverse(function compare(a, b) {
                                var dateA = new Date(a.dataCadastro);
                                var dateB = new Date(b.dataCadastro);
                                return dateA - dateB;
                            });
                            break;
                        case 'valortitulo':
                            vm.registros.reverse(function (a, b) {
                                if (a.valorTitulo < b.valorTitulo) { return -1; }
                                if (a.valorTitulo > b.valorTitulo) { return 1; }
                                return 0;
                            })
                            break;
                    }
                }
                else {
                    vm.lastOrder = coluna;

                    switch (coluna) {
                        case 'lancamento':
                            vm.registros.sort(function (a, b) {
                                if (a.lancamento < b.lancamento) { return -1; }
                                if (a.lancamento > b.lancamento) { return 1; }
                                return 0;
                            })
                            break;
                        case 'titulo':
                            vm.registros.sort(function (a, b) {
                                if (a.numeroDocumento < b.numeroDocumento) { return -1; }
                                if (a.numeroDocumento > b.numeroDocumento) { return 1; }
                                return 0;
                            })
                            break;
                        case 'sacado':
                            vm.registros.sort(function (a, b) {
                                if (a.nomeSacado < b.nomeSacado) { return -1; }
                                if (a.nomeSacado > b.nomeSacado) { return 1; }
                                return 0;
                            })
                            break;
                        case 'vencimento':
                            vm.registros.sort(function (a, b) {
                                if (a.vencimento < b.vencimento) { return -1; }
                                if (a.vencimento > b.vencimento) { return 1; }
                                return 0;
                            })
                            break;
                        case 'datacadastro':
                            vm.registros.sort(function compare(a, b) {
                                var dateA = new Date(a.dataCadastro);
                                var dateB = new Date(b.dataCadastro);
                                return dateA - dateB;
                            });
                            break;
                        case 'valortitulo':
                            vm.registros.sort(function (a, b) {
                                if (a.valorTitulo < b.valorTitulo) { return -1; }
                                if (a.valorTitulo > b.valorTitulo) { return 1; }
                                return 0;
                            })
                            break;
                    }
                }

                vm.pager.totalPages = 1;
                vm.setPage(1);
            }

            vm.init();

            vm.showhide = function (icon, box) {
                var icon = angular.element(document.getElementById(icon));
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                var elm = angular.element(document.getElementById(box));
                elm.slideToggle(200);
            };

            vm.marcarTodos = function () {
                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.filtro.status == vm.registros[i].status) {
                        vm.registros[i].selecionado = true;
                    }
                }
            }

            vm.desmarcarTodos = function () {
                for (var i = 0; i < vm.registros.length; i++) {
                    vm.registros[i].selecionado = false;
                }
            }

            vm.calcularTotalSelecionado = function () {

                if (vm.registros != null && vm.registro != null) {
                    vm.registro.quantidade = 0;
                    vm.registro.valorTotal = 0;
                    for (var i = 0; i < vm.registros.length; i++) {
                        if (vm.registros[i].selecionado) {
                            vm.registro.quantidade++;
                            var valor = vm.registros[i].valorPresente;
                            // Converte para número, tratando vírgula como decimal
                            if (typeof valor === 'string') {
                                valor = valor.replace(/\./g, '').replace(',', '.');
                                valor = parseFloat(valor);
                            }
                            if (!isNaN(valor)) {
                                vm.registro.valorTotal += valor;
                            }
                        }
                    }
                }

            }

            // Função para verificar se tem títulos selecionados
            vm.temTitulosSelecionados = function () {
                if (!vm.registros || vm.registros.length === 0) {
                    return false;
                }

                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.registros[i].selecionado) {
                        return true;
                    }
                }
                return false;
            }

            // Função para verificar se os valores são válidos (maiores que zero)
            vm.temValoresValidos = function () {
                if (!vm.registros || vm.registros.length === 0) {
                    return false;
                }

                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.registros[i].selecionado) {
                        var valorPago = vm.registros[i].valorPresente;

                        // Verifica se o valor está vazio, zero ou inválido
                        if (!valorPago || valorPago === '' || valorPago === '0' || valorPago === '0,00' || valorPago === 'R$ 0,00') {
                            return false;
                        }

                        // Converte string para número
                        var valorNumerico = valorPago;
                        if (typeof valorPago === 'string') {
                            valorNumerico = valorPago.replace(/[R$\s\.]/g, '').replace(',', '.');
                            valorNumerico = parseFloat(valorNumerico);
                        }

                        if (isNaN(valorNumerico) || valorNumerico <= 0) {
                            return false;
                        }
                    }
                }

                return true;
            }


            vm.podeEnviarLote = function () {
                return vm.temTitulosSelecionados() && vm.temValoresValidos() && vm.temDatasValidas();
            }


            // Função para verificar se as datas são válidas
            vm.temDatasValidas = function () {
                if (!vm.registros || vm.registros.length === 0) {
                    return true; // Se não há registros, considera válido
                }

                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.registros[i].selecionado) {
                        var dataPagamento = vm.registros[i].dataPagamento;

                        // Verifica se a data está preenchida
                        if (!dataPagamento || dataPagamento === '') {
                            return false;
                        }

                        // Verifica se a data está no formato correto e é válida
                        if (!vm.validarDataDdMmYyyy(dataPagamento)) {
                            return false;
                        }
                    }
                }

                return true;
            }

            // Função auxiliar para validar data no formato DD/MM/YYYY
            vm.validarDataDdMmYyyy = function (data) {
                if (!data || data.length !== 10) {
                    return false;
                }

                var regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
                var match = data.match(regex);

                if (!match) {
                    return false;
                }

                var dia = parseInt(match[1], 10);
                var mes = parseInt(match[2], 10);
                var ano = parseInt(match[3], 10);

                // Verifica se é uma data válida
                var dataObj = new Date(ano, mes - 1, dia);

                return dataObj.getFullYear() === ano &&
                    dataObj.getMonth() === (mes - 1) &&
                    dataObj.getDate() === dia &&
                    ano >= 1900 && ano <= 2100 && // Limites razoáveis
                    mes >= 1 && mes <= 12 &&
                    dia >= 1 && dia <= 31;
            }


            vm.enviarLote = function () {
                // Validação adicional antes de enviar
                if (!vm.podeEnviarLote()) {
                    var mensagem = 'Verifique os seguintes itens:\n';

                    if (!vm.temTitulosSelecionados()) {
                        mensagem += '• Selecione pelo menos um título\n';
                    }
                    if (!vm.temValoresValidos()) {
                        mensagem += '• Preencha valores de pagamento maiores que zero\n';
                    }
                    if (!vm.temDatasValidas()) {
                        mensagem += '• Corrija as datas de pagamento inválidas\n';
                    }

                    toastr.warning(mensagem, 'Atenção');
                    return;
                }

                var titulos = [];
                if (vm.registros && vm.registros.length > 0) {
                    for (var i = 0; i < vm.registros.length; i++) {
                        var p = vm.registros[i];
                        if (p.selecionado) {
                            // Converte valorPresente para float
                            var valorPago = p.valorPresente;
                            if (typeof valorPago === 'string') {
                                valorPago = valorPago.replace(/\./g, '').replace(',', '.');
                                valorPago = parseFloat(valorPago);
                            }
                            // Monta o objeto do título (adicione/remova campos conforme necessário)
                            titulos.push({
                                lancamento: p.lancamento,
                                dataVencimento: p.dataVencimento,
                                valorPago: valorPago,
                                numeroDocumento: p.numeroDocumento,
                                dataPagamento: p.dataPagamento,
                                razaoSocial: p.razaoSocial, // Adicione este campo para o protocolo
                                valorPrevisto: p.valorPrevisto, // Adicione este campo para o protocolo
                                valorPresente: p.valorPresenteOriginal

                            });
                        }
                    }
                }

                // Gera NomeLote: CodCedente + data/hora/minuto/segundo/milisegundo
                var codCedente = vm.filtro.cedente && vm.filtro.cedente.codigoVmoney ? vm.filtro.cedente.codigoVmoney : '';
                var now = new Date();
                var pad = function (n, l) { return (Array(l).join('0') + n).slice(-l); };
                var nomeLote =
                    pad(now.getFullYear() % 100, 2) + // ano com 2 dígitos
                    pad(now.getMonth() + 1, 2) + // mês
                    pad(now.getDate(), 2) + // dia
                    pad(now.getHours(), 2) + // hora
                    pad(now.getMinutes(), 2) + // minuto
                    pad(now.getSeconds(), 2); // segundo

                var lote = {
                    idVmoneyNow: vm.empresaId,
                    NomeLote: nomeLote,
                    titulos: titulos
                };

                //console.log('Lote a ser enviado:', lote);
                vm.LiquidacaoComissariaPromise = $http.post(APP_MNP + "/LiquidacaoComissaria/liquidar", lote).success(function (response) {
                    toastr.info('Lote enviado com sucesso.', 'Alerta');
                    vm.exibirLancamentos = false; // Esconde a seção após envio bem-sucedido

                    // Aguarda um pouco para o toastr aparecer primeiro
                    setTimeout(function () {
                        var confirmarDownload = confirm('Protocolo gerado!\n\nDeseja fazer o download do protocolo do lote ' + nomeLote + '?');
                        if (confirmarDownload) {
                            vm.gerarProtocolo(nomeLote, titulos, 'LIQUIDACAO');
                            toastr.warning('Download iniciado.', 'Protocolo');
                        }
                    }, 500); // 500ms de delay

                    return response;
                }).error(function (error) {
                    toastr.error(error, 'Erro no processamento', { allowHtml: true });
                    return error;
                });
            }

            vm.estornarLote = function () {
                // Validação adicional antes de enviar
                if (!vm.podeEnviarLote()) {
                    var mensagem = 'Verifique os seguintes itens:\n';

                    if (!vm.temTitulosSelecionados()) {
                        mensagem += '• Selecione pelo menos um título\n';
                    }
                    if (!vm.temValoresValidos()) {
                        mensagem += '• Preencha valores de pagamento maiores que zero\n';
                    }
                    if (!vm.temDatasValidas()) {
                        mensagem += '• Corrija as datas de pagamento inválidas\n';
                    }

                    toastr.warning(mensagem, 'Atenção');
                    return;
                }

                var titulos = [];
                if (vm.registros && vm.registros.length > 0) {
                    for (var i = 0; i < vm.registros.length; i++) {
                        var p = vm.registros[i];
                        if (p.selecionado) {
                            // Converte valorPresente para float
                            var valorPago = p.valorPresente;
                            if (typeof valorPago === 'string') {
                                valorPago = valorPago.replace(/\./g, '').replace(',', '.');
                                valorPago = parseFloat(valorPago);
                            }
                            // Monta o objeto do título (adicione/remova campos conforme necessário)
                            titulos.push({
                                lancamento: p.lancamento,
                                dataVencimento: p.dataVencimento,
                                valorPago: valorPago,
                                numeroDocumento: p.numeroDocumento,
                                dataPagamento: p.dataPagamento,
                                razaoSocial: p.razaoSocial, // Adicione este campo para o protocolo
                                valorPrevisto: p.valorPrevisto, // Adicione este campo para o protocolo
                                valorPresente: p.valorPresenteOriginal

                            });
                        }
                    }
                }

                // Gera NomeLote: CodCedente + data/hora/minuto/segundo/milisegundo
                var codCedente = vm.filtro.cedente && vm.filtro.cedente.codigoVmoney ? vm.filtro.cedente.codigoVmoney : '';
                var now = new Date();
                var pad = function (n, l) { return (Array(l).join('0') + n).slice(-l); };

                var nomeLote = vm.filtro.loteEstorno;

                var lote = {
                    idVmoneyNow: vm.empresaId,
                    NomeLote: nomeLote,
                    titulos: titulos
                };

                console.log('Lote a ser enviado:', lote);
                vm.LiquidacaoComissariaPromise = $http.post(APP_MNP + "/LiquidacaoComissaria/estornar", lote).success(function (response) {
                    toastr.info('Lote enviado com sucesso.', 'Alerta');
                    vm.exibirLancamentos = false; // Esconde a seção após envio bem-sucedido

                    // Aguarda um pouco para o toastr aparecer primeiro
                    setTimeout(function () {
                        var confirmarDownload = confirm('Protocolo gerado!\n\nDeseja fazer o download do protocolo do lote de estorno ' + nomeLote + '?');
                        if (confirmarDownload) {
                            vm.gerarProtocolo(nomeLote, titulos, 'ESTORNO');
                            toastr.warning('Download iniciado.', 'Protocolo');
                        }
                    }, 500); // 500ms de delay

                    return response;
                }).error(function (error) {
                    toastr.error(error, 'Erro no processamento', { allowHtml: true });
                    return error;
                });
            }

            // Adicione esta função no controller
            vm.gerarProtocolo = function (nomeLote, titulos, tipoOperacao) {
                var conteudoProtocolo = '';
                var dataHoraEnvio = new Date();
                var dataFormatada = dataHoraEnvio.toLocaleDateString('pt-BR');
                var horaFormatada = dataHoraEnvio.toLocaleTimeString('pt-BR');

                // Cabeçalho do protocolo
                conteudoProtocolo += '=========================================\n';
                conteudoProtocolo += '        PROTOCOLO DE ENVIO DO LOTE\n';
                conteudoProtocolo += '=========================================\n\n';

                var labelLote = 'LOTE: ';
                if (tipoOperacao === 'LIQUIDACAO') {
                    labelLote = 'LOTE LIQUIDAÇÃO: ';
                } else if (tipoOperacao === 'ESTORNO') {
                    labelLote = 'LOTE ESTORNO: ';
                }

                conteudoProtocolo += labelLote + nomeLote + '\n';
                conteudoProtocolo += 'DATA/HORA ENVIO: ' + dataFormatada + ' às ' + horaFormatada + '\n';
                conteudoProtocolo += 'CEDENTE: ' + (vm.filtro.cedente ? vm.filtro.cedente.razaoSocial : 'N/A') + '\n';
                conteudoProtocolo += 'QUANTIDADE DE TÍTULOS: ' + titulos.length + '\n\n';

                // Calcular valor total
                var valorTotalLote = 0;
                for (var i = 0; i < titulos.length; i++) {
                    valorTotalLote += titulos[i].valorPago || 0;
                }
                conteudoProtocolo += 'VALOR TOTAL DO LOTE: R$ ' + valorTotalLote.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\n\n';

                conteudoProtocolo += '=========================================\n';
                conteudoProtocolo += '           TÍTULOS ENVIADOS\n';
                conteudoProtocolo += '=========================================\n\n';

                // Detalhes de cada título
                for (var i = 0; i < titulos.length; i++) {
                    var titulo = titulos[i];
                    var valorPago = titulo.valorPago || 0;
                    // CORREÇÃO: Função para converter valor original corretamente
                    var valorOriginalFormatado = 'N/A';
                    if (titulo.valorPrevisto) {
                        var valorOriginal = titulo.valorPrevisto;
                        // Se for string, converte para número
                        if (typeof valorOriginal === 'string') {
                            // Remove pontos de milhares e converte vírgula para ponto
                            valorOriginal = valorOriginal.replace(/\./g, '').replace(',', '.');
                            valorOriginal = parseFloat(valorOriginal);
                        }
                        if (!isNaN(valorOriginal)) {
                            valorOriginalFormatado = 'R$ ' + valorOriginal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        }
                    }

                    conteudoProtocolo += '--- TÍTULO ' + (i + 1) + ' ---\n';
                    conteudoProtocolo += 'Razão Social: ' + (titulo.razaoSocial || 'N/A') + '\n';
                    conteudoProtocolo += 'Nº Documento: ' + (titulo.numeroDocumento || 'N/A') + '\n';
                    conteudoProtocolo += 'Data Vencimento: ' + (titulo.dataVencimento || 'N/A') + '\n';
                    conteudoProtocolo += 'Data Pagamento: ' + (titulo.dataPagamento || 'N/A') + '\n';
                    conteudoProtocolo += 'Valor Original: ' + valorOriginalFormatado + '\n';
                    conteudoProtocolo += 'Valor Pago: R$ ' + valorPago.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\n';
                    conteudoProtocolo += 'Lançamento: ' + (titulo.lancamento || 'N/A') + '\n\n';
                }

                conteudoProtocolo += '=========================================\n';
                conteudoProtocolo += 'Arquivo gerado automaticamente em ' + '\n';
                conteudoProtocolo += dataFormatada + ' às ' + horaFormatada + '\n';
                conteudoProtocolo += '=========================================\n';

                toastr.success('Protocolo Gerado com Sucesso', 'Aviso');
                // Fazer download do arquivo
                vm.downloadProtocolo(conteudoProtocolo, nomeLote + '.txt');
            }


            vm.downloadProtocolo = function (conteudo, nomeArquivo) {
                if (vm.pastaDownloadPadrao && 'showDirectoryPicker' in window) {
                    // Tenta salvar na pasta configurada
                    vm.pastaDownloadPadrao.getFileHandle(nomeArquivo, { create: true })
                        .then(function (fileHandle) {
                            return fileHandle.createWritable();
                        })
                        .then(function (writable) {
                            return writable.write(conteudo).then(function () {
                                return writable.close();
                            });
                        })
                        .then(function () {
                            toastr.success('Protocolo salvo na pasta configurada!', 'Download');
                        })
                        .catch(function (err) {
                            console.log('Erro ao salvar na pasta padrão, usando download normal:', err);
                            vm.downloadProtocoloNormal(conteudo, nomeArquivo);
                        });
                } else {
                    // Fallback para download normal
                    vm.downloadProtocoloNormal(conteudo, nomeArquivo);
                }
            };

            // Renomeie a função atual de download
            vm.downloadProtocoloNormal = function (conteudo, nomeArquivo) {
                var blob = new Blob([conteudo], { type: 'text/plain;charset=utf-8' });
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = nomeArquivo;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            };

            // Carregar pasta padrão salva ao inicializar
            vm.carregarPastaDownload = function () {
                var pastaSalva = localStorage.getItem('pastaDownloadProtocolo');
                if (pastaSalva) {
                    try {
                        var pastaInfo = JSON.parse(pastaSalva);
                        // Nota: A referência real da pasta precisa ser reconfigurada pelo usuário
                        // mas podemos mostrar qual pasta estava configurada
                        console.log('Última pasta configurada:', pastaInfo.name);
                    } catch (e) {
                        console.log('Erro ao carregar pasta salva:', e);
                    }
                }
            };


            vm.download = function (dados, tipo, nome) {
                var file = vm.b64toBlob(dados, tipo);

                var fileURL = URL.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = nome;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }

            vm.b64toBlob = function (b64Data, contentType) {
                var byteCharacters = atob(b64Data);
                var byteArrays = [];
                var sliceSize = 512

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, { type: contentType });
                return blob;
            }

            function addDays(date, days) {
                var result = new Date(date);
                result.setDate(result.getDate() + days);
                return result;
            }

        }]);
'use strict';

angular.module('inspinia')
    .controller('GestaoCarteiraComuCedentesController', ['$scope', '$state', 'toastr', '$http', 'APP_MNP', 'PagerService', '$uibModal', 'AuthService', '$q',
        function ($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, AuthService, $q) {
            var vm = this;
            vm.registro = null;
            vm.registros = null;
            vm.filtro = {
                cedente: null,
                sacado: null,
                operacaoInicial: null,
                operacaoFinal: null,
                vencimentoInicial: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
                vencimentoFinal: new Date(),
                pagamentoInicial: new Date(),
                pagamentoFinal: new Date(),
                tipoSacado: 0,
                templateText: '15',
                enviarBoleto: '0',
                atualizarBoleto: '0',
                comunicarCedente: '0',
                contaGraficaCompleto: '0',
                contaGraficaCreditos: '0',
                contaGraficaHistorico: '1',
                carteira: '0',
            };
            vm.pager = {};
            vm.setPage = setPage;
            vm.cedente = null;
            vm.email = '';
            vm.cedenteViewId = '';
            vm.selecionadoTodos = false;
            vm.selecionadoTodosGrupo = { vencidos: false, aVencer: false, liquidados: false, baixados: false };
            vm.registroContaGrafica = null;
            vm.registroPosicaoAberto = null;
            vm.registroPosicaoGeral = null;
            vm.exibirColunaDiasAtraso = true;
            vm.empresaId = AuthService.getEmpresaId();
            vm.permiteAtualizarBoleto = true;

            vm.statusFiltro = {
                vencidos: true,
                liquidados: true,
                baixados: false,
                aVencer: false
            };

            vm.toggleTodosStatusFiltro = function () {
                var todosMarcados = vm.statusFiltro.vencidos && 
                                    vm.statusFiltro.liquidados && 
                                    vm.statusFiltro.baixados && 
                                    vm.statusFiltro.aVencer;
                var novoStatus = !todosMarcados;
                vm.statusFiltro.vencidos = novoStatus;
                vm.statusFiltro.liquidados = novoStatus;
                vm.statusFiltro.baixados = novoStatus;
                vm.statusFiltro.aVencer = novoStatus;
                vm.aplicarFiltrosGeral();
            };

            vm.aplicarFiltrosGeral = function () {
                if (!vm.registroPosicaoGeralOriginal) return;

                vm.gruposGeral = {
                    vencidos: [],
                    aVencer: [],
                    liquidados: [],
                    baixados: []
                };

                vm.grupoTotais = {
                    vencidos: { quantidade: 0, total: 0 },
                    aVencer: { quantidade: 0, total: 0 },
                    liquidados: { quantidade: 0, total: 0 },
                    baixados: { quantidade: 0, total: 0 }
                };

                var registrosFiltrados = [];
                var totalGeral = 0;
                var totalGeralPago = 0;
                var quantidadeGeral = 0;

                var today = new Date();
                today.setHours(0, 0, 0, 0);

                var parseDate = function (dateStr) {
                    if (!dateStr) return null;
                    var parts = dateStr.split('/');
                    return new Date(parts[2], parts[1] - 1, parts[0]);
                };

                var registrosOriginais = vm.registroPosicaoGeralOriginal.registros || [];

                for (var i = 0; i < registrosOriginais.length; i++) {
                    var p = registrosOriginais[i];
                    var isBaixado = p.statusSaldo === 'BX';
                    var isLiquidado = !isBaixado && ((p.statusPago === 'T' && p.valorPago > 0) || p.valorPago > 0 || (p.dataPagamento != null && p.dataPagamento !== '' && !p.dataPagamento.startsWith('01/01/1753')));

                    var vencDate = parseDate(p.dataVencimento);
                    var isVencido = vencDate && vencDate < today;

                    if (isBaixado) {
                        vm.gruposGeral.baixados.push(p);
                        vm.grupoTotais.baixados.quantidade++;
                        vm.grupoTotais.baixados.total += p.valorPrevisto;
                        if (vm.statusFiltro.baixados) {
                            registrosFiltrados.push(p);
                            totalGeral += p.valorPrevisto;
                            totalGeralPago += p.valorPago;
                            quantidadeGeral++;
                        }
                    } else if (isLiquidado) {
                        vm.gruposGeral.liquidados.push(p);
                        vm.grupoTotais.liquidados.quantidade++;
                        vm.grupoTotais.liquidados.total += p.valorPrevisto;
                        if (vm.statusFiltro.liquidados) {
                            registrosFiltrados.push(p);
                            totalGeral += p.valorPrevisto;
                            totalGeralPago += p.valorPago;
                            quantidadeGeral++;
                        }
                    } else if (isVencido) {
                        vm.gruposGeral.vencidos.push(p);
                        vm.grupoTotais.vencidos.quantidade++;
                        vm.grupoTotais.vencidos.total += p.valorPrevisto;
                        if (vm.statusFiltro.vencidos) {
                            registrosFiltrados.push(p);
                            totalGeral += p.valorPrevisto;
                            totalGeralPago += p.valorPago;
                            quantidadeGeral++;
                        }
                    } else {
                        vm.gruposGeral.aVencer.push(p);
                        vm.grupoTotais.aVencer.quantidade++;
                        vm.grupoTotais.aVencer.total += p.valorPrevisto;
                        if (vm.statusFiltro.aVencer) {
                            registrosFiltrados.push(p);
                            totalGeral += p.valorPrevisto;
                            totalGeralPago += p.valorPago;
                            quantidadeGeral++;
                        }
                    }
                }

                vm.registroPosicaoGeral.registros = registrosFiltrados;
                vm.registroPosicaoGeral.quantidade = quantidadeGeral;
                vm.registroPosicaoGeral.valorTotal = totalGeral;
                vm.registroPosicaoGeral.valorTotalPago = totalGeralPago;

                vm.calcularTotalSelecionado();
            };

            var apienvio = APP_MNP;

            function setPage(page) {
                if (page < 1 || page > vm.pager.totalPages) {
                    return;
                }
                vm.pager = PagerService.GetPager(vm.registros.length, page);
                vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
            }

            vm.init = function () {
                // Desabilitar atualizacao de boleto para PERDIZES
                if (vm.empresaId == '836c9e79-3d37-4a9c-a618-9925f1136e3d') {
                    vm.permiteAtualizarBoleto = false;

                    // 27/04/2026 - Solucao temporaria para o bloqueio de SMTP Perdizes
                    //apienvio = 'https://apihmg.moneynow.com.br/api_prod/api';
                    //alert(apienvio);
                }

                //vm.pesquisar(); 
                vm.loadPeriodo();
            }

            vm.selecionarTodosOLD = function () {
                var selecionado = vm.selecionadoTodos;

                // Padrao
                if (vm.registros != null) {
                    for (var i = 0; i < vm.registros.length; i++) {
                        vm.registros[i].selecionado = selecionado;
                    }
                }

                // Conta Grafica
                if (vm.registroContaGrafica.registros != null) {
                    for (var i = 0; i < vm.registroContaGrafica.registros.length; i++) {
                        vm.registroContaGrafica.registros[i].selecionado = selecionado;
                    }
                }
            }

            vm.loadPeriodo = function () {
                vm.filtro.cedente = null;
                vm.filtro.cedenteViewId = null;
                vm.cedenteViewId = null;
                vm.registros = null;
                vm.registrosOriginal = null;
                vm.registroContaGrafica = null;
                vm.registroPosicaoAberto = null;
                vm.registroPosicaoGeral = null;
                vm.registroPosicaoGeralOriginal = null;

                vm.statusFiltro = {
                    vencidos: true,
                    liquidados: true,
                    baixados: false,
                    aVencer: false
                };

                vm.consultarPromise = $http.get(APP_MNP + "/EmailComunicacaoCedentes/vencimento/" + vm.filtro.templateText).success(function (response) {
                    if (response != null) {

                        vm.filtro.vencimentoInicial = new Date(response.dataInicio);
                        vm.filtro.vencimentoFinal = new Date(response.dataFim);

                        if (vm.filtro.templateText == '17') {
                            var umAnoAtras = new Date();
                            umAnoAtras.setFullYear(umAnoAtras.getFullYear() - 1);
                            vm.filtro.vencimentoInicial = umAnoAtras;
                        }

                        if (response.emailCopia != null && response.emailCopia != '' && vm.email == '') {
                            vm.email = response.emailCopia;
                        }
                    }
                }).error(function (error) {
                    toastr.error(error, 'Alerta');
                    return error;
                });
            }

            vm.filtroAlterado = function () {
                vm.registro = null;
                vm.registros = null;
                vm.registroContaGrafica = null;
                vm.registroPosicaoAberto = null;
                vm.registroPosicaoGeral = null;
                vm.registroPosicaoGeralOriginal = null;
            }

            vm.selecionarCedenteModal = function () {
                vm.filtro.cedente = null;
                vm.filtro.cedenteViewId = null;
                vm.cedenteViewId = null;

                var modalInstance = $uibModal.open({
                    templateUrl: 'app/cadastro/cedente/selecionar/index.html',
                    controller: 'CedenteSelecionarController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                }).result.then(function (data) {
                    vm.registrosOriginal = null;
                    vm.registros = null;
                    vm.filtro.cedente = null;
                    if (data != null) {
                        vm.filtro.cedente = data;
                        vm.filtro.cedenteViewId = data.viewId;

                        vm.emailCedente = data.email;
                    }
                });
            }

            vm.selecionarSacadoModal = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/cadastro/sacado/selecionar/index.html',
                    controller: 'SacadoSelecionarController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                }).result.then(function (data) {
                    vm.registrosOriginal = null;
                    vm.registros = null;
                    vm.filtro.sacado = null;
                    if (data != null) {
                        vm.filtro.sacado = data;
                        vm.filtro.sacadoViewId = data.viewId;
                    }
                });
            }

            vm.pesquisar = function () {
                vm.registro = null;
                vm.registros = [];
                vm.registroContaGrafica = null;

                if (vm.filtro.cedente == null) {
                    toastr.error('Selecione um Cedente.', 'Alerta');
                    return;
                }


                // Cria uma nova data para hoje, sem horas
                var today = new Date();
                today.setHours(0, 0, 0, 0);

                // Cria uma nova data para vencimentoFinal, sem horas
                var vencimentoFinal = new Date(vm.filtro.vencimentoFinal);
                vencimentoFinal.setHours(0, 0, 0, 0);


                if (vencimentoFinal >= today && vm.filtro.templateText == '19') {
                    toastr.error('A data não pode ser igual ou superior ao dia de hoje.', 'Alerta');
                    return;
                }
                console.log('vm.filtro', vm.filtro);

                // Conta Grafica
                if (vm.filtro.templateText == '15') {
                    vm.consultarPromise = $http.post(APP_MNP + "/EmailComunicacaoCedentes/pesquisarContaGrafica", vm.filtro).success(function (response) {
                        vm.registroContaGrafica = response;

                        if (vm.registroContaGrafica == null || vm.registroContaGrafica.registros.length == 0) {
                            toastr.warning('Não foram encontrados registros.', 'Alerta');
                        }

                        vm.emailCedente = vm.registroContaGrafica.registros[0].emailCedente;

                        vm.selecionadoTodos = true;
                        for (var i = 0; i < vm.registroContaGrafica.registros.length; i++) {
                            vm.registroContaGrafica.registros[i].selecionado = true;
                        }

                        vm.calcularTotalSelecionado();

                        return response;
                    }).error(function (error) {
                        toastr.error(error, 'Alerta');
                        return error;
                    });
                }
                // Posicao Titulos Aberto / Vencido
                else if (vm.filtro.templateText == '16' || vm.filtro.templateText == '19' || vm.filtro.templateText == '21') {
                    vm.consultarPromise = $http.post(APP_MNP + "/EmailComunicacaoCedentes/pesquisarPosicaoTituloAberto", vm.filtro).success(function (response) {
                        vm.registroPosicaoAberto = response;

                        if (vm.registroPosicaoAberto == null || vm.registroPosicaoAberto.registros.length == 0) {
                            toastr.warning('Não foram encontrados registros.', 'Alerta');

                        }


                        vm.emailCedente = vm.registroPosicaoAberto.registros[0].emailCedente;

                        for (var i = 0; i < vm.registroPosicaoAberto.registros.length; i++) {
                            vm.registroPosicaoAberto.registros[i].selecionado = true;
                        }

                        console.log('vm.registroPosicaoAberto', vm.registroPosicaoAberto);

                        vm.calcularTotalSelecionado();

                        return response;
                    }).error(function (error) {
                        toastr.error(error, 'Alerta');
                        return error;
                    });
                }
                // Posicao Titulos Geral
                else if (vm.filtro.templateText == '17') {
                    vm.consultarPromise = $http.post(APP_MNP + "/EmailComunicacaoCedentes/pesquisarPosicaoTituloGeral", vm.filtro).success(function (response) {
                        vm.registroPosicaoGeral = response;
                        vm.registroPosicaoGeralOriginal = angular.copy(response);

                        if (vm.registroPosicaoGeral == null || vm.registroPosicaoGeral.registros.length == 0) {
                            toastr.warning('Não foram encontrados registros.', 'Alerta');
                            return response;
                        }

                        vm.emailCedente = vm.registroPosicaoGeral.registros[0].emailCedente;

                        if (vm.registroPosicaoGeral.registros != null) {
                            for (var i = 0; i < vm.registroPosicaoGeral.registros.length; i++) {
                                vm.registroPosicaoGeral.registros[i].selecionado = true;
                            }
                            for (var i = 0; i < vm.registroPosicaoGeralOriginal.registros.length; i++) {
                                vm.registroPosicaoGeralOriginal.registros[i].selecionado = true;
                            }
                        }

                        vm.aplicarFiltrosGeral();

                        return response;
                    }).error(function (error) {
                        toastr.error(error, 'Alerta');
                        return error;
                    });
                }
                else {
                    var dataVencimentoInformado = vm.filtro.vencimentoInicial != null && vm.filtro.vencimentoFinal != null;

                    if (dataVencimentoInformado == false) {
                        toastr.error('Selecione um período.', 'Alerta');
                        return;
                    }



                    /*
                    if (vm.filtro.templateText == '9' 
                        || vm.filtro.templateText == '12'
                        || vm.filtro.templateText == '10') 
                    {
                    */
                    if (vm.filtro.templateText == '100') {
                        // Vencidos
                        vm.exibirColunaDiasAtraso = true;

                        // Validar data vencimento
                        var datahoje = new Date();
                        datahoje.setHours(0, 0, 0, 0);
                        if (vm.filtro.vencimentoFinal >= datahoje) {
                            toastr.error('Data de vencimento não pode ser maior ou igual a hoje.', 'Alerta');
                            return;
                        }
                    }
                    else {
                        // A Vencer (Futuro)
                        //vm.exibirColunaDiasAtraso = false;

                        // Validar data vencimento
                        /*
                        if (vm.filtro.templateText == '8'
                            || vm.filtro.templateText == '11'
                            || vm.filtro.templateText == '18') {
                        */
                        if (vm.filtro.templateText == '18') {
                            var datahoje = new Date();
                            datahoje.setHours(0, 0, 0, 0);
                            if (vm.filtro.vencimentoInicial < datahoje) {
                                toastr.error('Data de vencimento não pode ser menor que data de hoje.', 'Alerta');
                                return;
                            }
                        }
                    }

                    vm.exibirColunaDiasAtraso = true;

                    vm.registrosOriginal = null;
                    vm.registros = null;
                    vm.selecionadoTodos = null;

                    vm.consultarPromise = $http.post(APP_MNP + "/EmailComunicacaoCedentes/listar", vm.filtro).success(function (response) {
                        vm.registro = response;
                        vm.registrosOriginal = response.registros;
                        vm.registros = response.registros;
                        //vm.email = response.email;
                        //vm.cedenteViewId = vm.filtro.cedente.viewId;
                        console.log('vm.registros', vm.consultarPromise);

                        if (vm.registros == null || vm.registros.length == 0) {
                            toastr.warning('Não foram encontrados lançamentos.', 'Alerta');
                        }
                        else {
                            vm.selecionadoTodos = false;

                            vm.emailCedente = vm.registros[0].emailCedente;

                            for (var i = 0; i < vm.registrosOriginal.length; i++) {
                                vm.registrosOriginal[i].selecionado = true;
                                vm.registros[i].selecionado = true;
                            }

                            vm.calcularTotalSelecionado();
                        }

                        //vm.filtrarPesquisa();

                        return response;
                    }).error(function (error) {
                        toastr.error(error, 'Alerta');
                        return error;
                    });
                }
            }

            vm.selecionarTodos = function () {
                var selecionado = vm.selecionadoTodos;

                // Padrao
                if (vm.registros != null) {
                    for (var i = 0; i < vm.registros.length; i++) {
                        vm.registros[i].selecionado = selecionado;
                    }
                }

                // Posicao Aberto
                if (vm.registroPosicaoAberto != null && vm.registroPosicaoAberto.registros != null) {
                    for (var i = 0; i < vm.registroPosicaoAberto.registros.length; i++) {
                        vm.registroPosicaoAberto.registros[i].selecionado = selecionado;
                    }
                }

                // Posicao Geral
                if (vm.registroPosicaoGeral != null && vm.registroPosicaoGeral.registros != null) {
                    for (var i = 0; i < vm.registroPosicaoGeral.registros.length; i++) {
                        vm.registroPosicaoGeral.registros[i].selecionado = selecionado;
                    }
                }

                // Conta Grafica
                if (vm.registroContaGrafica != null && vm.registroContaGrafica.registros != null) {
                    for (var i = 0; i < vm.registroContaGrafica.registros.length; i++) {
                        vm.registroContaGrafica.registros[i].selecionado = selecionado;
                    }
                }

                vm.calcularTotalSelecionado();
            }

            vm.selecionarTodosGrupo = function (grupo) {
                var selecionado = vm.selecionadoTodosGrupo[grupo];
                if (vm.gruposGeral != null && vm.gruposGeral[grupo] != null) {
                    for (var i = 0; i < vm.gruposGeral[grupo].length; i++) {
                        vm.gruposGeral[grupo][i].selecionado = selecionado;
                    }
                }
                vm.calcularTotalSelecionado();
            }

            vm.enviarEmail = function () {
                var request = {
                    emailCedente: vm.emailCedente,
                    email: vm.email,
                    registro: vm.registro,
                };

                vm.consultarPromise = $http.post(apienvio + "/EmailComunicacaoCedentes/enviarEmail", request).success(function (response) {
                    toastr.info('E-mail enviado com sucesso.', 'Alerta');
                    return response;
                }).error(function (error) {
                    toastr.error(error, 'Alerta');
                    return error;
                });

                /*
                var lancamentos = [];
        
                for (var i=0;i<vm.registros.length;i++)
                {
                    if (vm.registros[i].selecionado)
                    {
                        lancamentos.push(vm.registros[i]);
                    }
                }
        
                var sacadoCnpj = '';
                var sacadoGrupo = '';
        
                if (vm.filtro.tipoSacado == 0) {
                    if (vm.filtro.sacado != null) {
                        sacadoCnpj = vm.filtro.cnpj;
                    }
                }
                else {
                    if (vm.filtro.grupoSacado != null) {
                        sacadoGrupo = vm.filtro.grupoSacado;
                    }
                }
        
                var request = {
                    emailCedente: vm.emailCedente,
                    email: vm.email,
                    lancamentos: lancamentos,
                    cedenteViewId: vm.cedenteViewId,
                    sacadoViewId: vm.sacadoViewId,
                    sacadoCnpj: sacadoCnpj,
                    sacadoGrupo: sacadoGrupo,
                    templateText: vm.filtro.templateText,
                    enviarBoleto: vm.filtro.enviarBoleto,
                    atualizarBoleto: vm.filtro.atualizarBoleto,
                    comunicarCedente: vm.filtro.comunicarCedente,
                };
        
                vm.consultarPromise = $http.post(APP_MNP + "/EmailComunicacaoCedentes/enviarEmail", request).success(function(response){
                    toastr.info('E-mail enviado com sucesso.', 'Alerta');
                    return response;
                }).error(function(error){
                    toastr.error(error, 'Alerta');
                    return error;
                });
                */
            }

            vm.enviarEmailContaGrafica = function () {
                var request = {
                    emailCedente: vm.emailCedente,
                    email: vm.email,
                    contaGrafica: vm.registroContaGrafica,
                };

                vm.consultarPromise = $http.post(apienvio + "/EmailComunicacaoCedentes/enviarEmailContaGrafica", request).success(function (response) {
                    toastr.info('E-mail enviado com sucesso.', 'Alerta');
                    return response;
                }).error(function (error) {
                    toastr.error(error, 'Alerta');
                    return error;
                });
            }

            vm.enviarEmailPosicaoTitulosAberto = function () {
                var novoRegistro = {
                    cedenteViewId: vm.registroPosicaoAberto.cedenteViewId,
                    registros: vm.registroPosicaoAberto.registros,
                    valorTotal: vm.registroPosicaoAberto.valorTotal,
                    quantidade: vm.registroPosicaoAberto.quantidade,
                    vencimentoInicial: vm.registroPosicaoAberto.vencimentoInicial,
                    vencimentoFinal: vm.registroPosicaoAberto.vencimentoFinal,
                };
                var lancamentos = [];

                if (vm.filtro.enviarBoleto == '1') {
                    var quantidadeBoletos = 0;
                    for (var i = 0; i < novoRegistro.registros.length; i++) {
                        if (novoRegistro.registros[i].selecionado) {
                            lancamentos.push(novoRegistro.registros[i]);

                            if (novoRegistro.registros[i].dadosBoleto != null) {
                                quantidadeBoletos++;
                            }
                        }
                    }

                    if (lancamentos.length == 0) {
                        toastr.error('Selecione um lançamento.', 'Alerta');
                        return;
                    }

                    // Batching logic for boletos (max 20 attachments per email)
                    var batches = [];
                    var currentBatch = [];
                    var currentBoletoCount = 0;

                    for (var i = 0; i < lancamentos.length; i++) {
                        var item = lancamentos[i];
                        var hasBoleto = item.dadosBoleto != null;

                        if (hasBoleto && currentBoletoCount >= 20) {
                            batches.push(currentBatch);
                            currentBatch = [];
                            currentBoletoCount = 0;
                        }

                        currentBatch.push(item);
                        if (hasBoleto) {
                            currentBoletoCount++;
                        }
                    }

                    if (currentBatch.length > 0) {
                        batches.push(currentBatch);
                    }

                    // Create a deferred object to manage the spinner/blocking
                    var deferred = $q.defer();
                    vm.consultarPromise = deferred.promise;

                    var enviarLote = function (index) {
                        if (index >= batches.length) {
                            toastr.info('E-mails enviados com sucesso.', 'Alerta');
                            deferred.resolve();
                            return;
                        }

                        var batchRegistros = batches[index];

                        // Recalculate totals for the batch
                        var batchTotal = 0;
                        var batchQuantidade = 0;

                        for (var j = 0; j < batchRegistros.length; j++) {
                            batchQuantidade++;
                            batchTotal += (batchRegistros[j].valorPrevisto - batchRegistros[j].valorAbatimento);
                        }

                        var registroBatch = angular.copy(novoRegistro);
                        registroBatch.registros = batchRegistros;
                        registroBatch.valorTotal = batchTotal;
                        registroBatch.quantidade = batchQuantidade;

                        var request = {
                            emailCedente: vm.emailCedente,
                            email: vm.email,
                            registro: registroBatch,
                            enviarBoleto: vm.filtro.enviarBoleto,
                            atualizarBoleto: vm.filtro.atualizarBoleto,
                            templateText: vm.filtro.templateText,
                        };

                        // Note: We don't assign to vm.consultarPromise here to avoid overwriting the main promise
                        $http.post(apienvio + "/EmailComunicacaoCedentes/enviarEmailPosicaoTituloAberto", request).success(function (response) {
                            enviarLote(index + 1);
                        }).error(function (error) {
                            toastr.error('Erro ao enviar lote ' + (index + 1) + ': ' + error, 'Alerta');
                            deferred.reject(error);
                        });
                    };

                    enviarLote(0);
                    return;
                }
                else {

                }

                var request = {
                    emailCedente: vm.emailCedente,
                    email: vm.email,
                    registro: novoRegistro,
                    enviarBoleto: vm.filtro.enviarBoleto,
                    atualizarBoleto: vm.filtro.atualizarBoleto,
                    templateText: vm.filtro.templateText,
                };

                vm.consultarPromise = $http.post(apienvio + "/EmailComunicacaoCedentes/enviarEmailPosicaoTituloAberto", request).success(function (response) {
                    toastr.info('E-mail enviado com sucesso.', 'Alerta');
                    return response;
                }).error(function (error) {
                    toastr.error(error, 'Alerta');
                    return error;
                });
            }

            vm.enviarEmailPosicaoTitulosGeral = function () {
                var novoRegistro = {
                    cedenteViewId: vm.registroPosicaoGeral.cedenteViewId,
                    registros: vm.registroPosicaoGeral.registros,
                    valorTotal: vm.registroPosicaoGeral.valorTotal,
                    quantidade: vm.registroPosicaoGeral.quantidade,
                    vencimentoInicial: vm.registroPosicaoGeral.vencimentoInicial,
                    vencimentoFinal: vm.registroPosicaoGeral.vencimentoFinal,
                };
                var lancamentos = [];

                if (vm.filtro.enviarBoleto == '1') {
                    var quantidadeBoletos = 0;
                    for (var i = 0; i < novoRegistro.registros.length; i++) {
                        if (novoRegistro.registros[i].selecionado) {
                            lancamentos.push(novoRegistro.registros[i]);

                            if (novoRegistro.registros[i].dadosBoleto != null) {
                                quantidadeBoletos++;
                            }
                        }
                    }

                    if (lancamentos.length == 0) {
                        toastr.error('Selecione um lançamento.', 'Alerta');
                        return;
                    }

                    // Enviar de 20 em 20 boletos (max 20 attachments per email)
                    var batches = [];
                    var currentBatch = [];
                    var currentBoletoCount = 0;

                    for (var i = 0; i < lancamentos.length; i++) {
                        var item = lancamentos[i];
                        var hasBoleto = item.dadosBoleto != null;

                        if (hasBoleto && currentBoletoCount >= 20) {
                            batches.push(currentBatch);
                            currentBatch = [];
                            currentBoletoCount = 0;
                        }

                        currentBatch.push(item);
                        if (hasBoleto) {
                            currentBoletoCount++;
                        }
                    }

                    if (currentBatch.length > 0) {
                        batches.push(currentBatch);
                    }

                    var deferred = $q.defer();
                    vm.consultarPromise = deferred.promise;

                    var enviarLote = function (index) {
                        if (index >= batches.length) {
                            toastr.info('E-mails enviados com sucesso.', 'Alerta');
                            deferred.resolve();
                            return;
                        }

                        var batchRegistros = batches[index];

                        var batchTotal = 0;
                        var batchQuantidade = 0;

                        for (var j = 0; j < batchRegistros.length; j++) {
                            batchQuantidade++;
                            batchTotal += (batchRegistros[j].valorPrevisto - batchRegistros[j].valorAbatimento);
                        }

                        var registroBatch = angular.copy(novoRegistro);
                        registroBatch.registros = batchRegistros;
                        registroBatch.valorTotal = batchTotal;
                        registroBatch.quantidade = batchQuantidade;

                        var request = {
                            emailCedente: vm.emailCedente,
                            email: vm.email,
                            registro: registroBatch,
                            enviarBoleto: vm.filtro.enviarBoleto,
                            atualizarBoleto: vm.filtro.atualizarBoleto,
                            templateText: vm.filtro.templateText,
                        };

                        $http.post(apienvio + "/EmailComunicacaoCedentes/enviarEmailPosicaoTituloAberto", request).success(function (response) {
                            enviarLote(index + 1);
                        }).error(function (error) {
                            toastr.error('Erro ao enviar lote ' + (index + 1) + ': ' + error, 'Alerta');
                            deferred.reject(error);
                        });
                    };

                    enviarLote(0);
                    return;
                }
                else {
                    var request = {
                        emailCedente: vm.emailCedente,
                        email: vm.email,
                        registro: novoRegistro,
                    };

                    vm.consultarPromise = $http.post(APP_MNP + "/EmailComunicacaoCedentes/enviarEmailPosicaoTituloGeral", request).success(function (response) {
                        toastr.info('E-mail enviado com sucesso.', 'Alerta');
                        return response;
                    }).error(function (error) {
                        toastr.error(error, 'Alerta');
                        return error;
                    });
                }
            }

            vm.consultar = function (fornecedor) {
                $state.go('index.cedente_consultar', { obj: fornecedor.viewId });
            }

            vm.filtrarPesquisa = function () {
                vm.registros = [];

                /*
                var dataCadastroAte = vm.filtro.dataCadastroAte;
        
                if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
                {
                    dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
                }
                */

                for (var i = 0; i < vm.registrosOriginal.length; i++) {
                    var incluir = true;
                    /*
                    if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
                    {
                        if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                        {
                            incluir = false;
                        }
                    }
        
                    if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
                    {
                        if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                        {
                            incluir = false;
                        }
                    }
                    */

                    if (vm.filtro.fantasia != null && vm.filtro.fantasia != '') {
                        if (!vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase())) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.nome != null && vm.filtro.nome != '') {
                        if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase())) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.codigo != null && vm.filtro.codigo != '') {
                        if (vm.registrosOriginal[i].id != vm.filtro.codigo) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.cnpj != null && vm.filtro.cnpj != '') {
                        if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase())) {
                            incluir = false;
                        }
                    }

                    /*
                    if (vm.filtro.status != null && vm.filtro.status != '')
                    {
                        if (vm.filtro.status != vm.registrosOriginal[i].status)
                        {
                            incluir = false;
                        }
                    }
                    */

                    if (incluir) {
                        vm.registros.push(vm.registrosOriginal[i]);
                    }
                }

                vm.desmarcarTodos();
                vm.pager.totalPages = 1;
                vm.setPage(1);
            }

            vm.ordenarResultado = function (coluna) {
                vm.orderSelected = coluna;

                if (vm.lastOrder == coluna) {
                    vm.lastOrder = '';

                    switch (coluna) {
                        case 'lancamento':
                            vm.registros.reverse(function (a, b) {
                                if (a.lancamento < b.lancamento) { return -1; }
                                if (a.lancamento > b.lancamento) { return 1; }
                                return 0;
                            })
                            break; codBanco
                        case 'banco':
                            vm.registros.reverse(function (a, b) {
                                if (a.codBanco < b.codBanco) { return -1; }
                                if (a.codBanco > b.codBanco) { return 1; }
                                return 0;
                            })
                            break;
                        case 'sacado':
                            vm.registros.reverse(function (a, b) {
                                if (a.nomeSacado < b.nomeSacado) { return -1; }
                                if (a.nomeSacado > b.nomeSacado) { return 1; }
                                return 0;
                            })
                            break;
                        case 'cnpj':
                            vm.registros.reverse(function (a, b) {
                                if (a.cnpj < b.cnpj) { return -1; }
                                if (a.cnpj > b.cnpj) { return 1; }
                                return 0;
                            })
                            break;
                        case 'datacadastro':
                            vm.registros.reverse(function compare(a, b) {
                                var dateA = new Date(a.dataCadastro);
                                var dateB = new Date(b.dataCadastro);
                                return dateA - dateB;
                            });
                            break;
                        case 'valortitulo':
                            vm.registros.reverse(function (a, b) {
                                if (a.valorTitulo < b.valorTitulo) { return -1; }
                                if (a.valorTitulo > b.valorTitulo) { return 1; }
                                return 0;
                            })
                            break;
                    }
                }
                else {
                    vm.lastOrder = coluna;

                    switch (coluna) {
                        case 'lancamento':
                            vm.registros.sort(function (a, b) {
                                if (a.lancamento < b.lancamento) { return -1; }
                                if (a.lancamento > b.lancamento) { return 1; }
                                return 0;
                            })
                            break;
                        case 'banco':
                            vm.registros.sort(function (a, b) {
                                if (a.codBanco < b.codBanco) { return -1; }
                                if (a.codBanco > b.codBanco) { return 1; }
                                return 0;
                            })
                            break;
                        case 'sacado':
                            vm.registros.sort(function (a, b) {
                                if (a.nomeSacado < b.nomeSacado) { return -1; }
                                if (a.nomeSacado > b.nomeSacado) { return 1; }
                                return 0;
                            })
                            break;
                        case 'cnpj':
                            vm.registros.sort(function (a, b) {
                                if (a.cnpj < b.cnpj) { return -1; }
                                if (a.cnpj > b.cnpj) { return 1; }
                                return 0;
                            })
                            break;
                        case 'datacadastro':
                            vm.registros.sort(function compare(a, b) {
                                var dateA = new Date(a.dataCadastro);
                                var dateB = new Date(b.dataCadastro);
                                return dateA - dateB;
                            });
                            break;
                        case 'valortitulo':
                            vm.registros.sort(function (a, b) {
                                if (a.valorTitulo < b.valorTitulo) { return -1; }
                                if (a.valorTitulo > b.valorTitulo) { return 1; }
                                return 0;
                            })
                            break;
                    }
                }

                vm.pager.totalPages = 1;
                vm.setPage(1);
            }

            vm.init();

            vm.showhide = function (icon, box) {
                var icon = angular.element(document.getElementById(icon));
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                var elm = angular.element(document.getElementById(box));
                elm.slideToggle(200);
            };

            vm.marcarTodos = function () {
                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.filtro.status == vm.registros[i].status) {
                        vm.registros[i].selecionado = true;
                    }
                }
            }

            vm.desmarcarTodos = function () {
                for (var i = 0; i < vm.registros.length; i++) {
                    vm.registros[i].selecionado = false;
                }
            }

            vm.calcularTotalSelecionado = function () {

                // Padrao
                if (vm.registros != null && vm.registro != null) {
                    vm.registro.quantidade = 0;
                    vm.registro.valorTotal = 0;
                    for (var i = 0; i < vm.registros.length; i++) {
                        if (vm.registros[i].selecionado) {
                            vm.registro.quantidade++;
                            vm.registro.valorTotal += vm.registros[i].valorPresente;
                        }
                    }
                }

                // Em Aberto / Vencidos
                if (vm.registroPosicaoAberto != null && vm.registroPosicaoAberto.registros != null && vm.filtro.enviarBoleto == '1') {
                    vm.registroPosicaoAberto.valorTotal = 0;
                    vm.registroPosicaoAberto.quantidade = 0;

                    for (var i = 0; i < vm.registroPosicaoAberto.registros.length; i++) {
                        if (vm.registroPosicaoAberto.registros[i].selecionado) {
                            vm.registroPosicaoAberto.quantidade++;
                            vm.registroPosicaoAberto.valorTotal += (vm.registroPosicaoAberto.registros[i].valorPrevisto - vm.registroPosicaoAberto.registros[i].valorAbatimento);
                        }
                    }
                }

                // Posicao Geral
                if (vm.registroPosicaoGeral != null && vm.registroPosicaoGeral.registros != null && vm.filtro.enviarBoleto == '1') {
                    vm.registroPosicaoGeral.valorTotal = 0;
                    vm.registroPosicaoGeral.quantidade = 0;

                    for (var i = 0; i < vm.registroPosicaoGeral.registros.length; i++) {
                        if (vm.registroPosicaoGeral.registros[i].selecionado) {
                            vm.registroPosicaoGeral.quantidade++;
                            vm.registroPosicaoGeral.valorTotal += (vm.registroPosicaoGeral.registros[i].valorPrevisto - vm.registroPosicaoGeral.registros[i].valorAbatimento);
                        }
                    }
                }

                // Conta Grafica
                if (vm.registroContaGrafica != null && vm.registroContaGrafica.registros != null) {
                    vm.registroContaGrafica.totalDebitos = 0;
                    vm.registroContaGrafica.totalCreditos = 0;
                    vm.registroContaGrafica.totalValorOriginal = 0;
                    vm.registroContaGrafica.totalValorPartida = 0;

                    for (var i = 0; i < vm.registroContaGrafica.registros.length; i++) {
                        if (vm.registroContaGrafica.registros[i].selecionado) {
                            vm.registroContaGrafica.totalDebitos += vm.registroContaGrafica.registros[i].debitos;
                            vm.registroContaGrafica.totalCreditos += vm.registroContaGrafica.registros[i].creditos;
                            vm.registroContaGrafica.totalValorOriginal += vm.registroContaGrafica.registros[i].valorPrevisto;
                            vm.registroContaGrafica.totalValorPartida += vm.registroContaGrafica.registros[i].valorPartida;
                        }
                    }
                }

            }

            /*
            vm.visualizarBoleto = function(item) {
                // verificar boleto vencido itau
                if (item.codBanco == 341 && item.isVencido)
                {
                    vm.verItauBoletoVencido(item);
                }
                else {
                    vm.acaoTabelaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", item).success(function(response){
                    
                        vm.download(response, 'application/pdf', 'boleto_' + item.numeroDocumento + '.pdf');
            
                        return response;
                    }).error(function(error){
                        toastr.error(error, 'Alerta');
                        return error;
                    });
                }
            }
            */

            vm.visualizarBoleto = function (item) {
                // verificar boleto vencido itau
                if (vm.opcaoAtualizarBoleto && item.codBanco == 341 && item.isVencido) {
                    vm.verItauBoletoVencido(item);
                }
                else if (vm.permiteAtualizarBoleto && item.isVencido) {
                    vm.verBoletoVencido(item);
                }
                else {
                    item.isGerarAtualizado = false;
                    vm.acaoTabelaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", item).success(function (response) {

                        //vm.download(response, 'application/pdf', 'boleto.pdf');
                        var modalInstance = $uibModal.open({
                            templateUrl: 'app/email/carteira/modal/boleto/index.html',
                            controller: 'CarteiraModalBoletoController',
                            controllerAs: 'controller',
                            windowClass: 'inmodal',
                            size: 'lg',
                            resolve: {
                                item: function () {
                                    return response;
                                },
                            }
                        }).closed.then(function () {
                            //vm.listar();
                        });

                        return response;
                    }).error(function (error) {
                        toastr.error(error, 'Alerta');
                        return error;
                    });
                }
            }

            vm.verBoletoVencido = function (antecipacao) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/email/carteira/dinamica/vencido/index.html',
                    controller: 'BoletoVencidoGerarController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'md',
                    resolve: {
                        antecipacao: function () {
                            return antecipacao;
                        },
                    }
                }).closed.then(function () {
                    //vm.listar();
                });
            }

            vm.verItauBoletoVencido = function (antecipacao) {
                vm.acaoTabelaPromise = $http.post(APP_MNP + "/emailCarteiraDinamica/itauboletovencidotoken", antecipacao)
                    .then(function (response) {
                        var codigo = response.data;
                        var modalInstance = $uibModal.open({
                            templateUrl: 'app/email/carteira/dinamica/itau/boletovencido/index.html',
                            controller: 'BoletoVencidoItauGerarController',
                            controllerAs: 'controller',
                            windowClass: 'inmodal',
                            size: 'md',
                            resolve: {
                                antecipacao: function () {
                                    return antecipacao;
                                },
                                codigo: function () {
                                    return codigo;
                                },
                            }
                        }).closed.then(function () {
                            //vm.listar();
                        });
                    });

            }

            vm.download = function (dados, tipo, nome) {
                var file = vm.b64toBlob(dados, tipo);

                var fileURL = URL.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = nome;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }

            vm.b64toBlob = function (b64Data, contentType) {
                var byteCharacters = atob(b64Data);
                var byteArrays = [];
                var sliceSize = 512

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, { type: contentType });
                return blob;
            }

            function addDays(date, days) {
                var result = new Date(date);
                result.setDate(result.getDate() + days);
                return result;
            }

        }]);
angular.module('inspinia')
    .controller('ContaGraficaRelatorioExtratoController', ['$scope', '$state', 'toastr', 'PagerService', '$http', 'APP_MNP', '$uibModal',
        function ($scope, $state, toastr, PagerService, $http, APP_MNP, $uibModal) {
            var vm = this;
            vm.registros = null;
            vm.filtro = {
                codigo: '',
                nome: '',
                cnpj: ''
            }

            vm.indexPage = 1;

            $scope.pagination = {
                current: 1,
                perPage: 15,
                maxSize: 5,
                totalItems: 0,
            };

            vm.init = function () {
                //vm.pesquisar();
                //vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
            }

            vm.pesquisar = function () {
                if (vm.cedenteViewId == null) {
                    toastr.error('Selecione um Cedente.', 'Alerta');
                    return;
                }

                vm.pesquisarPromise = $http.post(APP_MNP + "/contagrafica/extrato/pesquisar/" + vm.cedenteViewId).success(function (response) {
                    vm.registros = response;
                    //vm.items = vm.registros;

                    //$scope.pagination.totalItems = (response.pages * perPage);
                }).error(function (error) {
                    return error;
                });
            }

            vm.detalheItem = function(registro) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/contagrafica/relatorio/extrato/detalhe/index.html',
                    controller: 'ContaGraficaRelatorioExtratoDetalheController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                    resolve: {
                        registro: function () {
                            return registro;
                        },
                    }
                }).result.then(function (res) {
                    /*
                    if (res == 'excluido')
                    {
                        vm.listar();
                    } 
                    */
                });
            }

            vm.gerarPdf = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/contagrafica/relatorio/extrato/pdf/index.html',
                    controller: 'ContaGraficaRelatorioExtratoPdfController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                    /*
                    resolve: {
                        titulo: function () {
                            return p;
                        },
                    }
                    */
                }).result.then(function (res) {
                    /*
                    if (res == 'excluido')
                    {
                        vm.listar();
                    } 
                    */
                });
            }

            vm.selecionarCedenteModal = function () {
                vm.cedente = null;
                vm.cedenteViewId = null;

                var modalInstance = $uibModal.open({
                    templateUrl: 'app/cadastro/cedente/selecionar/index.html',
                    controller: 'CedenteSelecionarController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                }).result.then(function (data) {
                    vm.cedente = null;
                    vm.cedenteViewId = null;
                    if (data != null) {
                        vm.cedente = data;
                        vm.cedenteViewId = data.viewId;
                    }
                });
            }

            vm.pesquisar2 = function (perPage, index, orderBy, filter) {
                vm.registros = null;

                var codigo = "0";

                if (vm.filtro == null) {
                    vm.filtro = {
                        codigo: '',
                        index: index,
                        page: perPage
                    }
                }

                if (vm.filtro.codigo != null && vm.filtro.codigo != '') {
                    codigo = vm.filtro.codigo;
                }

                vm.filtro.page = index;
                vm.filtro.perPage = perPage;

                vm.pesquisarPromise = $http.post(APP_MNP + "/invoice/titulo/pesquisar", vm.filtro).success(function (response) {
                    vm.registros = response.registros;
                    vm.items = vm.registros;

                    $scope.pagination.totalItems = (response.pages * perPage);
                }).error(function (error) {
                    return error;
                });
            }

            $scope.onSearch = function () {
                vm.pesquisar($scope.pagination.perPage, $scope.pagination.current - 1, "", $scope.pagination.search);
            }

            $scope.onPageChange = function (result) {
                vm.pesquisar($scope.pagination.perPage, $scope.pagination.current - 1, "", $scope.pagination.search);
            }

            $scope.onPerPageChange = function (result) {
                vm.pesquisar($scope.pagination.perPage, $scope.pagination.current - 1, "", $scope.pagination.search);
            }

            vm.consultar = function (item) {
                $state.go('index.titulos_consultar', { obj: item.viewId });
            }

            vm.cadastrar = function () {
                //$state.go('index.cadastro_sacado');
            }

            vm.filtrarPesquisa = function () {
                $scope.pagination.perPage, $scope.pagination.current = 1;

                vm.pesquisar($scope.pagination.perPage, $scope.pagination.current - 1, "", $scope.pagination.search);
            }

            vm.init();

            vm.getTotalPages = function () {
                return new Array(7);
            }

            vm.showhide = function (icon, box) {
                var icon = angular.element(document.getElementById(icon));
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                var elm = angular.element(document.getElementById(box));
                elm.slideToggle(200);
            };

        }]);
'use strict';

angular.module('inspinia')
  .controller('ContaGraficaAcertoManualDetalheController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'titulos', 'grupo',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, titulos, grupo)
  {
    var vm = this;
    vm.titulos = titulos;
    vm.grupo = grupo;
    vm.titulosGrupo = [];

    vm.init = function()
    {
      for (var i=0; i < vm.titulos.length; i++) {
        if (vm.titulos[i].grupoTituloContaCorrenteEnum == grupo.grupoId) {
          vm.titulosGrupo.push(vm.titulos[i]);
        }
      }
    }

    vm.selecionarItem = function(item) {
      /*
      if (item.selecionado) {
        item.selecionado = false;
      }
      else {
        item.selecionado = true;
      }
      */

      vm.calcularGrupo();
    }

    vm.calcularGrupo = function() {
      vm.grupo.selecionados = 0;
      vm.grupo.selecionadosTotal = 0;
      for (var i=0; i < vm.titulosGrupo.length; i++) {
        if (vm.titulosGrupo[i].selecionado) {
          vm.grupo.selecionados = vm.grupo.selecionados + 1;
          if (vm.titulosGrupo[i].isCredito) {
            vm.grupo.selecionadosTotal = vm.grupo.selecionadosTotal + vm.titulosGrupo[i].valorPresente;
          }
          else {
            vm.grupo.selecionadosTotal = vm.grupo.selecionadosTotal - vm.titulosGrupo[i].valorPresente;
          }
        }
      }
    }

    vm.selecionarGrupo = function() {
      if (vm.grupo.selecionado) {
        //vm.grupo.selecionado = false;
        for (var i=0; i < vm.titulosGrupo.length; i++) {
          vm.titulosGrupo[i].selecionado = true;
        }
      }
      else {
        //vm.grupo.selecionado = true;
        for (var i=0; i < vm.titulosGrupo.length; i++) {
          vm.titulosGrupo[i].selecionado = false;
        }
      }

      vm.calcularGrupo();
    }

    vm.carregar = function() {
      vm.titulosGrupo = [];
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
angular.module('inspinia')
  .controller('ContaGraficaAcertoHistoricoController', ['$scope', '$state', 'toastr', 'PagerService', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, PagerService, $http, APP_MNP, $uibModal) 
{
    var vm = this;
    vm.registros = [];

    vm.init = function()
    {
    }

    vm.pesquisar = function(cedenteViewId) {
        vm.pesquisarPromise = $http.get(APP_MNP + "/contagrafica/cobrancaacerto/historico/" + cedenteViewId)
        .then(function(response)
        { 
            vm.registros = response.data;
        });
    }

    vm.selecionarCedenteModal = function()
    {    
        vm.cedente = null;
        vm.cedenteViewId = null;
        vm.valorTotal = 0;
        
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/selecionar/index.html',
            controller: 'CedenteSelecionarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            }).result.then(function(data){
                if (data != null)
                {
                    vm.cedente = data;
                    vm.cedenteViewId = data.viewId;

                    vm.pesquisar(vm.cedenteViewId);
                }      
            });
    }

    vm.detalharItem = function(item)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/contagrafica/acerto/historico/detalhe/index.html',
            controller: 'ContaGraficaAcertoHistoricoDetalheController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                registro: function () {
                    return item;
                },
            }
        }).closed.then(function(){
            vm.calcularTotal();
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('CcbPesquisarDetalheController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_MNP)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.registro = null;

    vm.init = function()
    {
      vm.consultaPromise = $http.get(APP_MNP + "/ccb/antecipacaodetalhe/" + antecipacao.viewId)
      .then(function(response)
      { 
        vm.registro = response.data;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.downloadAssinanetXml = function() {
      vm.download(vm.registro.ccbPropostaDTO.assinanetArquivoEnviadoBase64, 'application/xml', 'ccb.xml');
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        var sliceSize = 512
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
        
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
        
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('CcbConsultarValidarController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'id', '$http', 'APP_MNP', '$sce',
      function($scope, $state, toastr, $uibModalInstance, id, $http, APP_MNP, $sce)
  {
    var vm = this;
    vm.id = id;
    vm.registro = null;

    vm.init = function()
    {
      vm.consultaPromise = $http.post(APP_MNP + "/ccb/validarproposta/" + id)
      .then(function(response)
      { 
        if (response.data == '')
        {
          alert('Não existem pendências no cadastro.');
          vm.fechar();
        }
        else {
          vm.fileResultadoPdf = $sce.trustAsResourceUrl('data:application/pdf;base64,' + response.data);
        }        
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('OriginadorConsultaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal', '$sce',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal, $sce)
{
    var vm = this;
    vm.viewId = $state.params.obj;

    vm.init = function()
    {
        if (vm.viewId == null || vm.viewId == '')
        {
            $state.go('index.config_originadores');
        }
        else
        {
            vm.consultar();
        }
    }

    vm.consultar = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/empresaoriginador/consultar/" + vm.viewId);
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registro = response.data;
            vm.listarSocios();
        });
    }

    vm.listarSocios = function() 
    {
        vm.consultarSociosPromise = $http.get(APP_MNP + "/empresaoriginador/listarsocios/" + vm.viewId);
        
        vm.consultarSociosPromise.then(function(response)
        { 
            vm.socios = response.data;
        });
    }

    vm.atualizar = function()
    {
        if (vm.registro.nome == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        vm.registro.socios = null;

        $http.put(APP_MNP + "/empresaoriginador/ic", vm.registro).success(function(response){
            toastr.info('Registro atualizado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.incluirSocio = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/cliente/originadores/consultar/socio/index.html',
        controller: 'OriginadorIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.registro;
          },
          tipopessoa: function () {
            return 'Sócio';
          },
          pessoa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
            vm.listarSocios();
      });
    }
    vm.visualizarSocio = function(pessoa, index)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cliente/originadores/consultar/socio/index.html',
            controller: 'OriginadorIncluirSocioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.registro;
                },
                tipopessoa: function () {
                    return 'Sócio';
                },
                pessoa: function () {
                    return pessoa;
                },
                indice: function () {
                    return index;
                },
            }
            }).closed.then(function(){
                vm.listarSocios();
            });
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        var sliceSize = 512
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
        
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
        
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('ConfigInserirFeriadoController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'APP_MNP', '$http',
      function($scope, $state, toastr, $uibModalInstance, APP_MNP, $http)
  {
    var vm = this;
    vm.registro = {};

    vm.init = function()
    {
    }

    vm.incluir = function()
    {
        if (vm.registro.data == null || vm.registro.data == '')
        {
            alert('Favor informar a Data.');
            return;
        }

        if (vm.registro.descricao == null || vm.registro.descricao == '')
        {
            alert('Favor informar a descrição.');
            return;
        }

        $http.post(APP_MNP + "/feriado/incluir", vm.registro).success(function(response){
            toastr.info('Feriado cadastrado com sucesso.', 'Feriado');
            $uibModalInstance.close();      
            return response;
        }).error(function(error){
            toastr.error(error, 'Feriado');
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('InvestidorCadastroController', ['$scope', '$state', 'toastr', '$http', 'APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.investidor = {
        nome: '',
        cnpjCpf: '',
        email: ''
    };

    vm.init = function()
    {

    }

    vm.salvar = function()
    {
        if (vm.investidor.nome == null || vm.investidor.nome == '')
        {
            toastr.error('Nome é obrigatório.', 'Investidor');
            return;
        }

        if (vm.investidor.cnpjCpf == null || (vm.investidor.cnpjCpf.toString().length != 18 && vm.investidor.cnpjCpf.toString().length != 14))
        {
            toastr.error('CPF/CNPJ inválido.', 'Investidor');
            return;
        }

        if (vm.investidor.email == null || vm.investidor.email == '')
        {
            toastr.error('E-mail é obrigatório.', 'Investidor');
            return;
        }

        $http.post(APP_MNP + "/investidor/cadastrar", vm.investidor).success(function(response){
            toastr.info('Investidor cadastrado com sucesso.', 'Alerta');
            $state.go('index.cadastro_investidor_pesquisa');
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('SacadoSelecionarController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', '$compile', '$uibModal',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, $compile, $uibModal)
  {
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        codigo: '',
        nome: '',
        cnpj: ''
    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.pesquisar = function(perPage, index, orderBy, filter)
    {
        vm.registros = null;

        var codigo = "0";
        var nome = "0";
        var cnpj = "0";

        if (vm.filtro == null)
        {
            vm.filtro = {
                codigo: '',
                nome: '',
                cnpj: '',
                index: index,
                page: perPage
            }
        }

        if (vm.filtro.codigo != null && vm.filtro.codigo != '')
        {
            codigo = vm.filtro.codigo;
        }
        if (vm.filtro.nome != null && vm.filtro.nome != '')
        {
            nome = vm.filtro.nome;
        }
        if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
        {
            cnpj = vm.filtro.cnpj;
        }

        vm.filtro.page = index;
        vm.filtro.perPage = perPage;
        
        vm.pesquisarPromise = $http.post(APP_MNP + "/sacado/pesquisarPage", vm.filtro).success(function(response){
            vm.registros = response.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });
    }

    $scope.onSearch = function() {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPerPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.filtrarPesquisa = function()
    {
      $scope.pagination.perPage,$scope.pagination.current = 1;
      
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.cadastrar = function() {
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/sacado/selecionar/novo/index.html',
        controller: 'SacadoSelecionarNovoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            if (data != null)
            {
                vm.filtro = {
                    nome: data.razaoSocial
                };

                $scope.pagination.perPage,$scope.pagination.current = 1;
      
                vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
            }            
        });
    }

    vm.init();

    vm.getTotalPages = function() {
      return new Array(7);   
    }

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoSelecionar2Controller', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', '$compile', '$uibModal',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, $compile, $uibModal)
  {
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        codigo: '',
        nome: '',
        cnpj: ''
    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.pesquisar = function(perPage, index, orderBy, filter)
    {
        vm.registros = null;

        var codigo = "0";
        var nome = "0";
        var cnpj = "0";

        if (vm.filtro == null)
        {
            vm.filtro = {
                codigo: '',
                nome: '',
                cnpj: '',
                index: index,
                page: perPage
            }
        }

        if (vm.filtro.codigo != null && vm.filtro.codigo != '')
        {
            codigo = vm.filtro.codigo;
        }
        if (vm.filtro.nome != null && vm.filtro.nome != '')
        {
            nome = vm.filtro.nome;
        }
        if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
        {
            cnpj = vm.filtro.cnpj;
        }

        vm.filtro.page = index;
        vm.filtro.perPage = perPage;
        
        vm.pesquisarPromise = $http.post(APP_MNP + "/sacado/pesquisarPage", vm.filtro).success(function(response){
            vm.registros = response.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });
    }

    $scope.onSearch = function() {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPerPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.filtrarPesquisa = function()
    {
      $scope.pagination.perPage,$scope.pagination.current = 1;
      
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.cadastrar = function() {
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/sacado/selecionar/novo/index.html',
        controller: 'SacadoSelecionarNovoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            if (data != null)
            {
                vm.filtro = {
                    nome: data.razaoSocial
                };

                $scope.pagination.perPage,$scope.pagination.current = 1;
      
                vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
            }            
        });
    }

    vm.init();

    vm.getTotalPages = function() {
      return new Array(7);   
    }

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoConsultaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.sacadoParam = $state.params.obj;

    vm.init = function()
    {
        if (vm.sacadoParam == null || vm.sacadoParam == '')
        {
            $state.go('index.cadastro_sacado_pesquisa');
        }
        else
        {
            vm.pesquisar();        
        }
    }

    vm.pesquisar = function()
    {
        return $http.get(APP_MNP + "/sacado/consultar/" + vm.sacadoParam.viewId)
        .then(function(response)
        { 
            vm.sacado = response.data;
            vm.listarUsuarios();
        });
    }

    vm.atualizar = function()
    {
        if (vm.sacado.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Alerta');
            return;
        }

        if (vm.sacado.cnpj.toString().length != 18 && vm.sacado.cnpj.toString().length != 14)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }

        if (vm.sacado.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        $http.post(APP_MNP + "/sacado/alterar", vm.sacado).success(function(response){
            toastr.info('Sacado atualizado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.init();

    vm.adicionarUsuario = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/sacado/consulta/usuario/cadastro/index.html',
            controller: 'SacadoCadastrarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                sacado: function () {
                    return vm.sacadoParam;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }

    vm.editarUsuario = function(usuario)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/sacado/consulta/usuario/consulta/index.html',
            controller: 'SacadoConsultarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                sacado: function () {
                    return vm.sacadoParam;
                },
                usuario: function () {
                    return usuario;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }
    
    vm.listarUsuarios = function()
    {
        return $http.get(APP_MNP + "/sacado/listarUsuarios/" + vm.sacado.viewId)
        .then(function(response)
        { 
            vm.usuarios = response.data;
        });
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('BoletoRelatorioConsumoController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;
    vm.anoFiltro = '2022';
    vm.mesFiltro = (new Date().getMonth() + 1).toString();

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.pesquisar = function()
    {


        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/boletorelatorio/pesquisar/" + vm.anoFiltro + '/' + vm.mesFiltro);
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.cedente_consultar', {obj: fornecedor.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.fantasia != null && vm.filtro.fantasia != '')
            {
                if (!vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoCadastroController', ['$scope', '$state', 'toastr', '$http','APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.sacado = {
        endereco: {}
    };

    vm.init = function()
    {

    }

    vm.salvar = function()
    {
        if (vm.sacado.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.cnpj == null || (vm.sacado.cnpj.toString().length != 18 && vm.sacado.cnpj.toString().length != 14))
        {
            toastr.error('CPF/CNPJ inválido.', 'Cliente');
            return;
        }

        if (vm.sacado.razaoSocial == null || vm.sacado.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.endereco.cep == null || vm.sacado.endereco.cep == '')
        {
            toastr.error('CEP é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.endereco.logradouro == null || vm.sacado.endereco.logradouro == '')
        {
            toastr.error('Logradouro é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.endereco.cidade == null || vm.sacado.endereco.cidade == '')
        {
            toastr.error('Cidade é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.endereco.uf == null || vm.sacado.endereco.uf == '')
        {
            toastr.error('Estado é obrigatório.', 'Cliente');
            return;
        }

        $http.post(APP_MNP + "/sacado/incluir", vm.sacado).success(function(response){
            toastr.info('Sacado cadastrado com sucesso.', 'Alerta');
            $state.go('index.cadastro_sacado_pesquisa');
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });

        /*
        vm.salvarPromise = CedenteService.cadastrar(vm.cedente);

        vm.salvarPromise.then(function(result) {  
            if (result.status)
            {
                toastr.info('Cedente cadastrada com sucesso!', 'Cedente');
                $state.go('index.pesquisar_cedente');
            }
            else
            {
                alert('Ocorreu um erro na solicitação.');
            }
        });
        */
    }

    vm.init();

    /*
    function validarCNPJ(s) {
        let cnpj = s.replace(/[^\d]+/g, '')
    
        // Valida a quantidade de caracteres
        if (cnpj.length !== 14)
            return false
    
        // Elimina inválidos com todos os caracteres iguais
        if (/^(\d)\1+$/.test(cnpj))
            return false
    
        // Cáculo de validação
        let t = cnpj.length - 2,
            d = cnpj.substring(t),
            d1 = parseInt(d.charAt(0)),
            d2 = parseInt(d.charAt(1)),
            calc = x => {
                let n = cnpj.substring(0, x),
                    y = x - 7,
                    s = 0,
                    r = 0
    
                    for (let i = x; i >= 1; i--) {
                        s += n.charAt(x - i) * y--;
                        if (y < 2)
                            y = 9
                    }
    
                    r = 11 - s % 11
                    return r > 9 ? 0 : r
            }
    
        return calc(t) === d1 && calc(t + 1) === d2
    }
    */

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('ArquivoRetornoController', ['$scope', '$state', 'toastr', '$uibModal', 'APP_MNP', '$http',
      function($scope, $state, toastr,  $uibModal, APP_MNP, $http)
  {
    var vm = this;
    vm.selectedTempFile = [];
    vm.filesSelected = [];

    vm.file = {};

    vm.contasAll = [];
    vm.contas = [];
    vm.conta = {};

    vm.originadores = [];
    vm.originador = {};

    vm.init = function()
    {
        vm.listarContas();
    }

    vm.listarContas = function()
    {
        vm.consultarContasPromise = $http.get(APP_MNP + "/domiciliobancario/pesquisar");
        
        vm.consultarContasPromise.then(function(response)
        { 
            vm.contasAll = response.data;

            vm.listarOriginadores();
        });
    }

    vm.listarOriginadores = function()
    {
        vm.consultarOriginadoresPromise = $http.get(APP_MNP + "/empresaoriginador/lista");
        
        vm.consultarOriginadoresPromise.then(function(response)
        { 
            vm.originadores = response.data;

            if (vm.originadores.length > 0)
            {
                vm.originador = vm.originadores[0];

                vm.listarContasOriginador();
            }
        });
    }

    vm.listarContasOriginador = function() 
    {        
        vm.conta = null;
        vm.contas = [];

        if (vm.contasAll.length > 0)
        {
            for (var i=0;i<vm.contasAll.length;i++)
            {
                if (vm.contasAll[i].originador.id == vm.originador.id)
                {
                    vm.contas.push(vm.contasAll[i]);

                    if (vm.contasAll[i].isPadraoOperacao)
                    {
                        vm.conta = vm.contasAll[i];
                    }
                }
            }

            if (vm.conta == null && vm.contas.length > 0)
            {
                vm.conta = vm.contas[0];
            }
        }

        //vm.listarRemessa();
    }

    vm.adicionarItem = function()
    {
        var nfe = {};
        nfe.Id = vm.fileId++;
        nfe.Nome = vm.selectedTempFile[0].name;
        
        //readAsDataURL        

        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {

            vm.validarPromise = $http.post(APP_MNP + "/cnabretorno/validar", 
                { file : evt.target.result, name : nfe.Nome })
                .success(function(response){
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            })

             //= NfeService.validar(evt.target.result);
            vm.validarPromise.then(function(result) {  
                if (result.data != null)
                {
                    vm.resultado = result.data;                    
                }
                else
                {
                    toastr.error(result.data.text, 'Nfe');
                }
            });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
    }

    /*
    vm.adicionarItem = function()
    {
        var cnab = {};
        vm.file.Id = vm.fileId++;
        vm.file.Nome = vm.selectedTempFile[0].name;
        
        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {
            vm.file.base64 = evt.target.result;
            vm.validarPromise = ArquivoService.validarRetorno(evt.target.result);
            vm.validarPromise.then(function(result) {  
                if (result.data.status)
                {
                    vm.cnab = result.data.data;
                }
                else
                {
                    toastr.error(result.data.text, 'CNAB');
                }
            });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
    }
    */

    vm.enviar = function()
    {
        var arquivo = {
            name: vm.file.Nome,
            FileBase64: vm.file.base64,
            Boletos: vm.cnab.boletos
        };

        vm.concluirPromise = ArquivoService.enviarRetorno(arquivo);
            vm.concluirPromise.then(function(result) {  
                if (result.data.status)
                {
                    //vm.file = {};
                    vm.cnab = null;
                    vm.resultado = result.data.data;
                    toastr.info('Retorno enviado com sucesso.', 'CNAB - Retorno');
                }
                else
                {
                    toastr.error(result.data.exception, 'CNAB');
                }
            });
    }

    vm.confirmar = function() {
        vm.confirmarPromise = $http.post(APP_MNP + "/cnabretorno/enviar", vm.resultado).success(function(response){
            
            vm.resultado = null;
            toastr.info('Retorno enviado com sucesso.', 'CNAB - Retorno');

        }).error(function(error){ 
            toastr.error(error, 'Erro no processamento');
            return error;
        });
    }

    vm.detalhes = function(tipo)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arquivo/modal/consultar-retorno.html',
            controller: 'ArquivoRetornoDetalheController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                registros: function () {
                    return vm.cnab.boletos;
                },
                tipo: function () {
                    return tipo;
                }
            }
        }).closed.then(function(){
        });
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('ArquivoGeradosRetornoController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP)
  {
    var vm = this; 
    vm.arquivos = [];

    vm.init = function()
    {
      vm.listarArquivos();
    }

    vm.listarArquivos = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/cnabretorno/retornoarquivos");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.arquivos = response.data;
        });
    }

    vm.downloadArquivo = function(item)
    {
        vm.gerarRemessaPromise = $http.get(APP_MNP + "/cnabretorno/downloadretorno/" + item.viewId).success(function(response){  
            vm.download(response, 'text/plain', 'file.ret');                   
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');            
        });
    }

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('CedentePesquisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', 'modalService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService,  modalService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;
    
    // Variáveis para controle de seleção
    vm.selecionarTodos = false;
    vm.cedentesSelecionados = [];

   // Adicione a função redirectToURL ao vm
   vm.redirectToURL = function() {
    var url = 'https://venturenegocios.com.br/wp-content/uploads/2024/12/MN-001-IF-CADASTRO-DE-USUÁRIOS.pdf';
    modalService.openModal(url);
};

    // Função para marcar/desmarcar todos os cedentes
    vm.toggleSelecionarTodos = function() {
        vm.cedentesSelecionados = [];
        
        if (vm.selecionarTodos) {
            // Selecionar todos os cedentes visíveis na página atual
            for (var i = 0; i < vm.items.length; i++) {
                vm.items[i].selecionado = true;
                vm.cedentesSelecionados.push(vm.items[i]);
            }
        } else {
            // Desmarcar todos os cedentes
            for (var i = 0; i < vm.items.length; i++) {
                vm.items[i].selecionado = false;
            }
        }
    };
    
    // Função para controlar seleção individual
    vm.toggleSelecionarCedente = function(cedente) {
        if (cedente.selecionado) {
            vm.cedentesSelecionados.push(cedente);
        } else {
            var index = vm.cedentesSelecionados.indexOf(cedente);
            if (index > -1) {
                vm.cedentesSelecionados.splice(index, 1);
            }
            vm.selecionarTodos = false;
        }
        
        // Verificar se todos os itens visíveis estão selecionados
        var todosSelecionados = true;
        for (var i = 0; i < vm.items.length; i++) {
            if (!vm.items[i].selecionado) {
                todosSelecionados = false;
                break;
            }
        }
        vm.selecionarTodos = todosSelecionados;
    };
    
    // Função para obter cedentes selecionados
    vm.obterCedentesSelecionados = function() {
        return vm.cedentesSelecionados;
    };

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/cedente/pesquisar");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.cedente_consultar', {obj: fornecedor.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.fantasia != null && vm.filtro.fantasia != '')
            {
                if (!vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('CedenteSelecionarController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, $compile)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {
      vm.consultar();
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_MNP + "/cedente/pesquisar")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
              if (vm.registrosOriginal[i].nomeFantasia == null || !vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
              {
                incluir = false;

                if (vm.registrosOriginal[i].razaoSocial == null || !vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                {
                  incluir = false;

                  if (vm.registrosOriginal[i].cnpj == null || !vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                  {
                      incluir = false;
                      if (vm.registrosOriginal[i].codigoVmoney != null && String(vm.registrosOriginal[i].codigoVmoney).toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                      {
                          incluir = true;
                      }
                  }
                  else
                  {
                    incluir = true;
                  }
                }
                else
                {
                  incluir = true;
                }
              }
              else
              {
                incluir = true;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('CedentePocexpressaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal', 
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.viewId = $state.params.obj;
    vm.cedente = null;
    vm.originador = {};
    vm.originadores = [];
    vm.tipoOperacao = 2;
    vm.tipoOperacaoTipo = 'F';
    vm.tiposOperacao = [];
    vm.registroConsulta = null;
    vm.registro = null;
    vm.isVencido = false;

    vm.verificarValidade = function()
    {
        if (vm.registro && vm.registro.validadeAte) {
            var hoje = new Date();
            hoje.setHours(0,0,0,0);
            var validadeAte = new Date(vm.registro.validadeAte);
            validadeAte.setHours(0,0,0,0);

            if (validadeAte < hoje) {
                vm.isVencido = true;
            } else {
                vm.isVencido = false;
            }
        } else {
            vm.isVencido = false;
        }
    }

    vm.init = function()
    {
        if (vm.viewId != null) {
            vm.carregarPoc();
        }
    }

    vm.carregarPoc = function() {
        vm.consultarPromise = $http.get(APP_MNP + "/poc/consultarid/" + vm.viewId)
        .success(function(response){
            vm.registroConsulta = response;
            vm.registro = vm.registroConsulta;

            // Sincroniza as variáveis de topo (usadas no payload de vm.salvar()) com o registro carregado.
            // Sem isso, salvar uma POC existente reenviava os valores padrão iniciais (ex: tipoOperacaoTipo = 'F').
            vm.cedente = vm.registroConsulta.cedente;
            vm.originador = vm.registroConsulta.originador;
            vm.tipoOperacao = vm.registroConsulta.tipoOperacao;
            vm.tipoOperacaoTipo = vm.registroConsulta.tipoOperacaoTipo;

            vm.registro.validadeDe = new Date(vm.registroConsulta.validadeDe);
            vm.registro.validadeAte = new Date(vm.registroConsulta.validadeAte);
            
            vm.verificarValidade();

            vm.registro.valorLimite = vm.registroConsulta.valorLimite.toFixed(2);
            vm.registro.valorTranche = vm.registroConsulta.valorTranche.toFixed(2);
            vm.registro.taxaFator = vm.registroConsulta.taxaFator.toFixed(2);
            vm.registro.taxaAdvalorem = vm.registroConsulta.taxaAdvalorem.toFixed(2);
            vm.registro.limiteConcBordero = vm.registroConsulta.limiteConcBordero.toFixed(2);
            vm.registro.limiteConcCarteira = vm.registroConsulta.limiteConcCarteira.toFixed(2);
            vm.registro.valorUnitarioConsulta3os = vm.registroConsulta.valorUnitarioConsulta3os.toFixed(2);
            vm.registro.valorMinTit = vm.registroConsulta.valorMinTit.toFixed(2);
            vm.registro.valorMaxTit = vm.registroConsulta.valorMaxTit.toFixed(2);

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.consultar = function()
    {
        if (vm.originadores.length == 0) {
            alert('Selecione um originador.');
            return;
        }

        if (vm.cedente == null) {
            return;
        }
        if (vm.originador == null) {
            return;
        }

        var poc = {
            cedente: vm.cedente,
            originador: vm.originador,
            tipoOperacao: vm.tipoOperacao,
            tipoOperacaoTipo: vm.tipoOperacaoTipo,
        };

        vm.consultarPromise = $http.post(APP_MNP + "/poc/consultar", poc)
        .success(function(response){
            vm.registroConsulta = response;
            vm.registro = vm.registroConsulta;

            vm.registro.validadeDe = new Date(vm.registroConsulta.validadeDe);
            vm.registro.validadeAte = new Date(vm.registroConsulta.validadeAte);
            
            //vm.verificarValidade();

            vm.registro.valorLimite = vm.registroConsulta.valorLimite.toFixed(2);
            vm.registro.valorTranche = vm.registroConsulta.valorTranche.toFixed(2);
            vm.registro.taxaFator = vm.registroConsulta.taxaFator.toFixed(2);
            vm.registro.taxaAdvalorem = vm.registroConsulta.taxaAdvalorem.toFixed(2);
            vm.registro.limiteConcBordero = vm.registroConsulta.limiteConcBordero.toFixed(2);
            vm.registro.limiteConcCarteira = vm.registroConsulta.limiteConcCarteira.toFixed(2);
            vm.registro.valorUnitarioConsulta3os = vm.registroConsulta.valorUnitarioConsulta3os.toFixed(2);
            vm.registro.valorMinTit = vm.registroConsulta.valorMinTit.toFixed(2);
            vm.registro.valorMaxTit = vm.registroConsulta.valorMaxTit.toFixed(2);

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.salvar = function()
    {
        if (vm.viewId == null) {
            if (vm.cedente == null) {
                return;
            }
            if (vm.originador == null) {
                return;
            }
        }

        var poc = {
            id: vm.registro.id,
            cedente: vm.cedente,
            originador: vm.originador,
            tipoOperacao: vm.tipoOperacao,
            tipoOperacaoTipo: vm.tipoOperacaoTipo,
            tarifas: vm.registro.tarifas,

            validadeDe: vm.registro.validadeDe,
            validadeAte: vm.registro.validadeAte,
            tituloTipoDocumento: vm.registro.tituloTipoDocumento,

            valorLimite: vm.toFloat(vm.registro.valorLimite),
            valorTranche: vm.toFloat(vm.registro.valorTranche),
            intervaloDias: vm.registro.intervaloDias,
            taxaFator: vm.registro.taxaFator,
            taxaAdvalorem: vm.registro.taxaAdvalorem,
            limiteConcBordero: vm.toFloat(vm.registro.limiteConcBordero),
            limiteConcBorderoPerc: vm.registro.limiteConcBorderoPerc,
            limiteConcCarteira: vm.toFloat(vm.registro.limiteConcCarteira),
            limiteConcCarteiraPerc: vm.registro.limiteConcCarteiraPerc,
            valorUnitarioConsulta3os: vm.toFloat(vm.registro.valorUnitarioConsulta3os),
            minChecagemPositivo: vm.registro.minChecagemPositivo,
            maxChecagemNegativo: vm.registro.maxChecagemNegativo,
            contratacaoMaxSacado: vm.registro.contratacaoMaxSacado,
            prazoMinTit: vm.registro.prazoMinTit,
            prazoMaxTit: vm.registro.prazoMaxTit,
            valorMinTit: vm.toFloat(vm.registro.valorMinTit),
            valorMaxTit: vm.toFloat(vm.registro.valorMaxTit),
            utilizaPerfilSacado: vm.registro.utilizaPerfilSacado,
            prazoCanhoto: vm.registro.prazoCanhoto,
        };

        vm.salvarPromise = $http.put(APP_MNP + "/poc/atualizar", poc).success(function(response){
            var mensagem = (response && (response.message || response.Message)) ? (response.message || response.Message) : 'POC atualizada com sucesso.';
            toastr.info(mensagem, 'Alerta');
            vm.registro = null;
            vm.registroConsulta = null;

            $state.go('index.cedente_pocexpressa_listar');

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
        
    }

    vm.listarTiposOperacao = function() {
        if (!vm.originador || vm.originador.tipo === undefined) return;
        $http.get(APP_MNP + "/tipooperacao/listarpoc/" + vm.originador.tipo)
        .then(function(response) {
            vm.tiposOperacao = response.data;
            if (vm.tiposOperacao.length > 0) {
                vm.tipoOperacaoTipo = vm.tiposOperacao[0].tipo;
            }
        });
    }

    vm.alterarOriginador = function() {
        vm.listarTiposOperacao();
    }

    vm.listarOriginadores = function() {
        vm.registro = null;

        vm.consultaPromise = $http.get(APP_MNP + "/empresaoriginador/lista")
        .then(function(response)
        {
            vm.originadores = response.data.map(function(o) {
                var tipoTexto = o.tipo === 0 ? 'Factoring' :
                                o.tipo === 1 ? 'Securitizadora' :
                                o.tipo === 2 ? 'FIDC' : 'ESC';
                o.nomeComTipo = o.nome + ' - ' + tipoTexto;
                return o;
            });

            if (vm.originadores.length > 0)
            {
                vm.originador = vm.originadores[0];
                vm.listarTiposOperacao();
            }
            else {
                toastr.error('Não existem Originadores cadastrados.', 'Alerta');
            }
        });
    }

    vm.selecionarCedenteModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/cedente/pocexpressa/cedente/index.html',
        controller: 'CedentePocexpressaCedenteController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.registro = null;
            vm.cedente = null;
            if (data != null)
            {
                vm.cedente = data;
                vm.listarOriginadores();
            }      
        });
    }

    vm.exibirHistorico = function(item)
    {    
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/pocexpressa/historico/index.html',
            controller: 'CedentePocexpressaHistoricoController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                item: function () {
                    return item;
                },
            }
        });
    }

    vm.importar = function() {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/pocexpressa/importar/index.html',
            controller: 'CedentePocexpressaImportarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            var resultado = data;
            vm.registro.validadeDe = new Date(resultado.validadeDe);
            vm.registro.validadeAte = new Date(resultado.validadeAte);
            vm.registro.valorLimite = vm.toDecimalString(resultado.valorLimite);
            vm.registro.valorTranche = vm.toDecimalString(resultado.valorTranche);
            vm.registro.intervaloDias = resultado.intervaloDias;
            vm.registro.taxaFator = resultado.taxaFator;
            vm.registro.taxaAdvalorem = resultado.taxaAdvalorem;
            vm.registro.limiteConcBordero = vm.toDecimalString(resultado.limiteConcBordero);
            vm.registro.limiteConcBorderoPerc = resultado.limiteConcBorderoPerc;
            vm.registro.limiteConcCarteira = vm.toDecimalString(resultado.limiteConcCarteira);
            vm.registro.limiteConcCarteiraPerc = resultado.limiteConcCarteiraPerc;
            vm.registro.valorUnitarioConsulta3os = vm.toDecimalString(resultado.valorUnitarioConsulta3os);
            vm.registro.minChecagemPositivo = resultado.minChecagemPositivo;
            vm.registro.maxChecagemNegativo = resultado.maxChecagemNegativo;
            vm.registro.contratacaoMaxSacado = resultado.contratacaoMaxSacado;
            vm.registro.prazoMinTit = resultado.prazoMinTit;
            vm.registro.prazoMaxTit = resultado.prazoMaxTit;
            vm.registro.valorMinTit = vm.toDecimalString(resultado.valorMinTit);
            vm.registro.valorMaxTit = vm.toDecimalString(resultado.valorMaxTit);
            vm.registro.tarifas = resultado.tarifas;
            vm.registro.prazoCanhoto = resultado.prazoCanhoto;
        }); 
    }

    vm.novaConsulta = function() {
        vm.registro = null;
        vm.registroConsulta = null;
    }

    vm.adicionarTarifaDoc = function() {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/pocexpressa/tarifa/index.html',
            controller: 'CedentePocexpressaTarifaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                poc: function () {
                    return vm.registro;
                },
                tarifa: function () {
                    return null;
                },
            }
        });
    }

    vm.editarTarifaDoc = function(p) {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/pocexpressa/tarifa/index.html',
            controller: 'CedentePocexpressaTarifaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                poc: function () {
                    return vm.registro;
                },
                tarifa: function () {
                    return p;
                },
            }
        });
    }

    vm.removerTarifaDoc = function(item) {
        for (var i=0; i<vm.registro.tarifas.length; i++) {
            if (vm.registro.tarifas[i].tipoDocumento.id == item.tipoDocumento.id) {
                vm.registro.tarifas.splice(i, 1);
            }
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };
    
    vm.toDecimalString = function(valor) {
        return valor.toFixed(2).toString().replaceAll('.',',');
    }

    vm.toFloat = function(valor) {
        return valor.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.').replaceAll(' ','');
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('CedentePesquisarPendentesController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/cedente/pendentes");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.cedente_consultar', {obj: fornecedor.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('FornecedorConsultaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal', '$sce',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal, $sce)
{
    var vm = this;
    vm.viewId = $state.params.obj;

    vm.originador = null;
    vm.originadores = [];

    vm.init = function()
    {
        if (vm.viewId == null || vm.viewId == '')
        {
            $state.go('index.cadastro_fornecedor_pesquisa');
        }
        else
        {
            vm.pesquisar();
            vm.listarOriginadores();
        }
    }

    vm.listarOriginadores = function()
    {
        vm.consultarOriginadoresPromise = $http.get(APP_MNP + "/empresaoriginador/lista");
        
        vm.consultarOriginadoresPromise.then(function(response)
        { 
            vm.originadores = response.data;

            if (vm.originadores.length > 0)
            {
                vm.originador = vm.originadores[0];

                vm.gerarContratoMae();
            }            
        });
    }

    vm.gerarContratoMae = function()
    {
        vm.fileContratoMae =  $sce.trustAsResourceUrl(APP_MNP + "/cedente/contratomae/" + vm.viewId + '/' + vm.originador.viewId);
    }

    vm.pesquisar = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/cedente/" + vm.viewId)
        .then(function(response)
        { 
            vm.fornecedor = response.data;

            vm.fornecedor.codigoVmoney = parseInt(vm.fornecedor.codigoVmoney);

            vm.fornecedor.instituicaoCredoraCCBTexto = vm.fornecedor.instituicaoCredoraCCB ? "1" : "0";

            vm.listarUsuarios();
            vm.listarContas();
            vm.listarDocumentos();

            vm.fornecedor.diasSomaConsidDiaUtilValue = vm.fornecedor.diasSomaConsidDiaUtil == true ? 1 : 0;
            vm.fornecedor.dataVenctoConsidDiaUtilValue = vm.fornecedor.dataVenctoConsidDiaUtil == true ? 1 : 0;
        });
    }

    vm.listarDocumentos = function()
    {
        vm.documentosPromise = $http.get(APP_MNP + "/cedente/documentos/" + vm.fornecedor.viewId)
        .then(function(response)
        { 
            vm.documentos = response.data;
        });
    }

    

    vm.adicionarDocumento = function(doc)
    {
      var cnab = {};      
      vm.file = {};
      vm.file.nome = vm.selectedTempFile[0].name;
      vm.file.tipo = doc.titulo;
      
      var reader = new FileReader();
      reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
      reader.onload = function (evt) {          
          vm.file.base64 = evt.target.result;          

          var documento = {
            nome: vm.file.nome,
            tipo: vm.file.tipo,
            base64: vm.file.base64,
            cedenteViewId: vm.fornecedor.viewId,
          };

          vm.uploadPromise = $http.post(APP_MNP + "/cedente/adicionarDocumento", documento).success(function(response){
            toastr.info('Arquivo enviado com sucesso.', 'Alerta');
            vm.file = {};
            vm.listarDocumentos();
            return response;
          }).error(function(error){
            vm.file = {};
            toastr.error(error, 'Alerta');
            return error;
          });
      };
      
      vm.selectedTempFile = [];
      angular.element("input[type='file']").val(null);      
    }

    vm.atualizar = function()
    {
        if (vm.fornecedor.cnpj == '')
        {
            toastr.error('CPF/CNPJ é obrigatório.', 'Alerta');
            return;
        }

        /*
        if (vm.fornecedor.cnpj.toString().length != 18)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }
        */

        if (vm.fornecedor.razaoSocial == '')
        {
            toastr.error('Nome/Razão Social é obrigatório.', 'Alerta');
            return;
        }

        vm.fornecedor.instituicaoCredoraCCB = vm.fornecedor.instituicaoCredoraCCBTexto == "1" ? true : false;
        vm.fornecedor.diasSomaConsidDiaUtil = vm.fornecedor.diasSomaConsidDiaUtilValue == 1 ? true : false;
        vm.fornecedor.dataVenctoConsidDiaUtil = vm.fornecedor.dataVenctoConsidDiaUtil == 1 ? true : false;

        $http.put(APP_MNP + "/cedente/alterar", vm.fornecedor).success(function(response){
            toastr.info('Cedente atualizado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.adicionarUsuario = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/consultar/usuario/cadastro/index.html',
            controller: 'FornecedorCadastrarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.viewId;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }

    vm.editarUsuario = function(usuario)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/consultar/usuario/consulta/index.html',
            controller: 'FornecedorConsultarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.viewId;
                },
                usuario: function () {
                    return usuario;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }
    
    vm.listarUsuarios = function()
    {
        return $http.get(APP_MNP + "/cedente/listarUsuarios/" + vm.fornecedor.viewId)
        .then(function(response)
        { 
            vm.usuarios = response.data;
        });
    }

    vm.adicionarConta = function()
    {
      var modalInstance = $uibModal.open({
          templateUrl: 'app/cadastro/cedente/consultar/conta/cadastro/index.html',
          controller: 'FornecedorCadastrarContaController',
          controllerAs: 'controller',
          windowClass: 'inmodal',
          size: 'lg',
          resolve: {
            fornecedor: function () {
                return vm.viewId;
            },
            conta: function () {
                return null;
            },
        }
      }).closed.then(function(){
          vm.listarContas();
      });
    }    

    vm.listarContas = function()
    {
        vm.listarContasPromise = $http.get(APP_MNP + "/cedente/listarContas/" + vm.fornecedor.viewId)
        .then(function(response)
        { 
            vm.contas = response.data;
        });
    }

    vm.editarConta = function(conta)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/consultar/conta/cadastro/index.html',
            controller: 'FornecedorCadastrarContaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.viewId;
                },
                conta: function () {
                    return conta;
                },
            }
        }).closed.then(function(){
            vm.listarContas();
        });
    }

    vm.gerarCarta = function(p)
    {
        p.fornecedorRazaoSocial = vm.fornecedor.razaoSocial;

        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/modal/carta_comunicacao_alteracao_conta/index.html',
            controller: 'CartaComunicacaoAlteracaoContaFornecedorController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            //backdrop: 'static',
            size: 'lg',
            resolve: {
                conta: function () {
                    return p;
                },
            }
            }).closed.then(function(){
                vm.listarContas();
            });
    }

    vm.gerarCartaExtrato = function(p)
    {
        p.fornecedorRazaoSocial = vm.fornecedor.razaoSocial;

        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/modal/carta_extrato_seguradora/index.html',
            controller: 'CartaExtratoSeguradoraFornecedorController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            //backdrop: 'static',
            size: 'lg',
            resolve: {
                conta: function () {
                    return p;
                },
            }
            }).closed.then(function(){
                //vm.listarContas();
            });
    }

    vm.incluirSocio = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/cedente/modal/cadastrar_socio/index.html',
        controller: 'FornecedorIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          tipopessoa: function () {
            return 'Sócio';
          },
          pessoa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
          //vm.consultar();
      });
    }

    vm.excluirSocio = function(pessoa, index) {
        if (confirm('Deseja excluir o registro ' + pessoa.nome + '?')) {
            for (var i=0; vm.fornecedor.socios.length; i++) {
                if (vm.fornecedor.socios[i].viewId == pessoa.viewId) {
                    vm.fornecedor.socios.splice(i, 1);
                    break;
                }
            }
        }
    }

    vm.visualizarSocio = function(pessoa, index)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/modal/cadastrar_socio/index.html',
            controller: 'FornecedorIncluirSocioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            //backdrop: 'static',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.fornecedor;
                },
                tipopessoa: function () {
                    return 'Sócio';
                },
                pessoa: function () {
                    return pessoa;
                },
                indice: function () {
                    return index;
                },
            }
            }).closed.then(function(){
                //vm.consultar();
            });
    }

    vm.incluirProcurador = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/cedente/modal/cadastrar_socio/index.html',
        controller: 'FornecedorIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          tipopessoa: function () {
            return 'Procurador';
          },
          pessoa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }
    vm.visualizarProcurador = function(pessoa)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/modal/cadastrar_socio/index.html',
            controller: 'FornecedorIncluirSocioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            //backdrop: 'static',
            size: 'lg',
            resolve: {
                fornecedor: function () {
                    return vm.fornecedor;
                },
                tipopessoa: function () {
                    return 'Procurador';
                },
                pessoa: function () {
                    return pessoa;
                },
            }
            }).closed.then(function(){
                //vm.consultar();
            });
    }

    vm.incluirEmpresa = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/cedente/modal/cadastrar_empresa/index.html',
        controller: 'FornecedorIncluirEmpresaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          empresa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }
    vm.visualizarEmpresa = function(empresa)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/cedente/modal/cadastrar_empresa/index.html',
        controller: 'FornecedorIncluirEmpresaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        //backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          empresa: function () {
            return empresa;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }

    vm.getDocumento = function(viewId, nome)
    {
        return $http.get(APP_MNP + "/cedente/consultardocumento/" + viewId)
        .then(function(response)
        { 
            vm.download(response.data.base64, response.data.tipo, nome);
        }).catch(function (data) {
            toastr.error(data, 'Alerta');
        });
    }

    vm.solicitarAberturaConta = function()
    {
        var r = confirm("Confirma a operação?");

        if (!r)
        {
            return;
        }
        
        vm.aberturaContaPromise = $http.post(APP_MNP + "/cedente/solicitaraberturaconta", vm.fornecedor).success(function(response){
            toastr.info('Solicitação enviada com sucesso.', 'Alerta');   
            $state.go('index.cedente_pendentes');      
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }
    
    vm.aprovarCadastro = function()
    {
        var r = confirm("Confirma a operação?");

        if (!r)
        {
            return;
        }
        
        vm.aberturaContaPromise = $http.post(APP_MNP + "/cedente/aprovarcadastro", vm.fornecedor).success(function(response){
            toastr.info('Cadastro aprovado com sucesso.', 'Alerta');   
            $state.go('index.cedente_pendentes');      
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.rejeitarCadastro = function()
    {
        var r = confirm("Confirma a operação?");

        if (!r)
        {
            return;
        }
        
        vm.aberturaContaPromise = $http.post(APP_MNP + "/cedente/rejeitarcadastro", vm.fornecedor).success(function(response){
            toastr.info('Cadastro rejeitado com sucesso.', 'Alerta');   
            $state.go('index.cedente_pesquisar');      
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.excluir = function() {
        if (confirm('Deseja realmente excluir este registro?')) {
            vm.excluirPromise = $http.delete(APP_MNP + "/cedente/" + vm.fornecedor.viewId).success(function(response){
                toastr.info('Registro excluído com sucesso.', 'Alerta');   
                $state.go('index.cedente_pesquisar');      
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        var sliceSize = 512
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
        
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
        
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('CedenteCadastrarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.registroViewId = $state.params.obj;
    vm.registro = {
        tipoPessoa: 0,
        endereco: {}
    };
    vm.isUpdate = false;

    vm.init = function()
    {
        if (vm.registroViewId != null)
        {
            vm.isUpdate = true;
            vm.carregar();
        }
        else
        {
            vm.isUpdate = false;
        }
    }

    vm.carregar = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/cedente/" + vm.registroViewId)
        .then(function(response)
        {           
            vm.registro = response.data;
        });
    }

    vm.salvar = function()
    {
        if (vm.registro.cnpj == null || vm.registro.cnpj == '')
        {
            toastr.error('CPF/CNPJ é obrigatório.', 'Alerta');
            return;
        }

        /*
        if (vm.registro.cnpj.toString().length != 18)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }
        */

        if (vm.registro.razaoSocial == null || vm.registro.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        if (!vm.isUpdate)
        {
            vm.salvarPromise = $http.post(APP_MNP + "/cedente/enviar", vm.registro).success(function(response){
                toastr.info('Cedente cadastrado com sucesso.', 'Alerta');
                //$state.go('index.cedente_pesquisar');
                $state.go('index.cedente_consultar', {obj: response.viewId});
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
        else
        {
            vm.salvarPromise = $http.put(APP_MNP + "/cedente/" + vm.registroViewId, vm.registro).success(function(response){
                toastr.info('Cedente atualizado com sucesso.', 'Alerta');
                $state.go('index.cedente_pesquisar');
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('CnabRemessaGerarController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP)
  {
    var vm = this; 

    vm.contasAll = [];
    vm.contas = [];
    vm.conta = {};

    vm.originadores = [];
    vm.originador = {};
    
    vm.init = function()
    {
      vm.listarContas();
    }

    vm.listarContas = function()
    {
        vm.consultarContasPromise = $http.get(APP_MNP + "/domiciliobancario/pesquisar");
        
        vm.consultarContasPromise.then(function(response)
        { 
            vm.contasAll = response.data;

            vm.listarOriginadores();
        });
    }

    vm.listarOriginadores = function()
    {
        vm.consultarOriginadoresPromise = $http.get(APP_MNP + "/empresaoriginador/lista");
        
        vm.consultarOriginadoresPromise.then(function(response)
        { 
            vm.originadores = response.data;

            if (vm.originadores.length > 0)
            {
                vm.originador = vm.originadores[0];

                vm.listarContasOriginador();
            }
        });
    }

    vm.listarContasOriginador = function() 
    {        
        vm.conta = null;
        vm.contas = [];

        if (vm.contasAll.length > 0)
        {
            for (var i=0;i<vm.contasAll.length;i++)
            {
                if (vm.contasAll[i].originador.id == vm.originador.id)
                {
                    vm.contas.push(vm.contasAll[i]);

                    if (vm.contasAll[i].isPadraoOperacao)
                    {
                        vm.conta = vm.contasAll[i];
                    }
                }
            }

            if (vm.conta == null && vm.contas.length > 0)
            {
                vm.conta = vm.contas[0];
            }
        }

        vm.listarRemessa();
    }

    vm.listarRemessa = function() {
      vm.registros = [];
      if (vm.conta != null)
      {
        vm.listarRemessaPromise = $http.get(APP_MNP + "/cnab/listarremessa/" + vm.conta.viewId);
        
        vm.listarRemessaPromise.then(function(response)
        { 
            vm.registros = response.data;

            if (vm.registros.length == 0)
            {
              toastr.warning('Não existem remessas para a conta selecionada.', 'Alerta');
              return;      
            }
        });
      }
      else
      {
        toastr.warning('Originador não possui conta bancária.', 'Alerta');
        return;
      }
    }

    vm.gerarRemessa = function()
    {
        var lista = [];

        for (var i=0;i<vm.registros.length;i++)
        {
            if (vm.registros[i].isGerarCNAB)
            {
                lista.push(vm.registros[i]);
            }
        }

        vm.gerarRemessaPromise = $http.post(APP_MNP + "/cnab/gerarremessa", lista).success(function(response){  
            vm.download(response.file, 'text/plain', response.name);
            vm.listarContas();     
            toastr.info('Remessa gerada com sucesso.', 'Alerta');                      
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');            
        });
    }

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('CnabRemessaArquivosController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP)
  {
    var vm = this; 
    vm.arquivos = [];

    vm.init = function()
    {
      vm.listarArquivos();
    }

    vm.listarArquivos = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/cnab/remessaarquivos");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.arquivos = response.data;
        });
    }

    vm.downloadArquivo = function(item)
    {
        vm.gerarRemessaPromise = $http.get(APP_MNP + "/cnab/downloadremessa/" + item.viewId).success(function(response){  
            vm.download(response, 'text/plain', 'remessa.rem');                   
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');            
        });
    }

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('OperacaoPesquisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/mcard/operacao");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.consultar = function(registro)
    {
        $state.go('index.operacao_consultar', {obj: registro.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('ArranjoPagamentoOptInPesquisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.registros = null;

    vm.init = function()
    {
        vm.pesquisar();
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        //return $http.get(APP_MNP + "/arranjopagamento/optin/pesquisar")
        return $http.get(APP_MNP + "/mcard/optin")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
        });
    }

    vm.consultar = function(registro)
    {
        $state.go('index.optin_cadastrar', {obj: registro.viewId});
    }

    vm.cadastrar = function()
    {
        $state.go('index.optin_cadastrar');
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('OperacaoConsultarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.registroViewId = $state.params.obj;
    vm.registro = {
        endereco: {}
    };
    vm.isUpdate = false;

    vm.init = function()
    {
        if (vm.registroViewId != null)
        {
            vm.isUpdate = true;
            vm.carregar();
        }
        else
        {
            vm.isUpdate = false;
        }
    }

    vm.carregar = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/mcard/operacao/consultar/" + vm.registroViewId)
        .then(function(response)
        {           
            vm.registro = response.data;

            vm.registro.valorDisponivelTexto = vm.registro.valorDisponivel.toFixed(2);
            vm.registro.valorOnerarTexto = vm.registro.valorOnerar.toFixed(2);

            vm.registro.dataVencimento = new Date(vm.registro.dataVencimento);

            if (vm.registro.dataAssinatura != null)
            {
                vm.registro.dataAssinatura = new Date(vm.registro.dataAssinatura);
            }
            else
            {
                //vm.registro.dataAssinatura = new Date();
                vm.registro.dataAssinatura = new Date(vm.registro.unidadeRecebivel[vm.registro.unidadeRecebivel.length-1].dataLiquidacao);
            }            

            //vm.registro.taxaAntecipacao = 0.02;            
            vm.registro.taxaAntecipacao = vm.registro.taxaAntecipacao.toFixed(2);
        });
    }

    vm.salvar = function()
    {
        vm.salvarPromise = $http.post(APP_MNP + "/mcard/operacao/aprovar", vm.registro).success(function(response){
            toastr.info('Contrato aprovado com sucesso.', 'Alerta');
            vm.carregar();
            $state.go('index.operacao_consultar', {obj: vm.registroViewId});
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.cancelarOperacao = function()
    {
        vm.salvarPromise = $http.post(APP_MNP + "/mcard/operacao/cancelarOperacao", vm.registro).success(function(response){
            toastr.info('Operação cancelada com sucesso.', 'Alerta');
            vm.carregar();
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.baixarContrato = function()
    {
        vm.salvarPromise = $http.post(APP_MNP + "/mcard/operacao/baixarContrato", vm.registro).success(function(response){
            toastr.info('Baixa do contrato efetuada com sucesso.', 'Alerta');
            vm.carregar();
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.inativarContrato = function()
    {
        vm.salvarPromise = $http.post(APP_MNP + "/mcard/operacao/inativarContrato", vm.registro).success(function(response){
            toastr.info('Contrato inativado efetuada com sucesso.', 'Alerta');
            vm.carregar();
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
    .controller('BaixasPesquisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal',
        function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal)
{
    var vm = this;
    vm.registros = null;
    vm.pager = {};
    vm.setPage = setPage;
    vm.cedenteSelecionado = null;
    vm.filtro = {
        dataInicio: new Date(2021,6,1),
        dataTermino: new Date(2021,6,31)
    }

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.selecionarCedente = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/optin/modal/cedente/index.html',
            controller: 'ArranjoPagamentoOptInCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            vm.cedente = data;
        }); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/baixas/pesquisar/detalhes_ur/index.html',
            controller: 'BaixasDetalhesUrController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/mcard/operacao");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('ArranjoPagamentoOptInCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_MNP','$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
  var vm = this;

  vm.registro = {};
  vm.registroViewId = $state.params.obj;    
  vm.isUpdate = false;
  vm.cedente = null;
  vm.isFormulario = false;

  vm.init = function()
  {
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;      
      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;

      vm.registro.dataAssinatura = new Date();
      vm.registro.dataInicio = new Date();
      vm.registro.dataTermino = new Date();
    }
  }

  vm.selecionarCedente = function()
  {
    if (!vm.isUpdate)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/arranjo_pagamento/optin/modal/cedente/index.html',
        controller: 'ArranjoPagamentoOptInCedenteController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
      }).result.then(function(data){
        vm.cedente = data;
      });
    }    
  }

  vm.salvar = function()
  {
    if (vm.registro.dataInicio < vm.registro.dataAssinatura)
    {
      toastr.error('Data de Início deve ser maior ou igual a Data de Assinatura.', 'Alerta');
      return;
    }

    if (vm.cedente == null || vm.cedente.viewId == null || vm.cedente.viewId == '')
    {
      toastr.error('Cedente é obrigatório.', 'Alerta');
      return;
    }

    vm.registro.cedente = vm.cedente;
    //vm.registro.fornecedorViewId = vm.cedente.viewId;
    //vm.registro.cnpjRecebedor = vm.cedente.cnpj;

    /*
    if (vm.registro.cnpjRecebedor == null || vm.registro.cnpjRecebedor == '')
    {
      toastr.error('Usuário Final Recebedor é obrigatório.', 'Alerta');
      return;
    }
    */

    if (!vm.isUpdate)
    {
      vm.salvarPromise = $http.post(APP_MNP + "/mcard/optin", vm.registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;

        toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        $state.go('index.optin_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_MNP + "/mcard/optin", vm.registro).success(function(response){        
        toastr.info('Registro atualizado com sucesso.', 'Alerta');        
        $state.go('index.optin_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.optout = function()
  {
    if (confirm('Confirma o envio do Opt-Out?'))
    {
      vm.salvarPromise = $http.put(APP_MNP + "/mcard/optin/optout", vm.registro).success(function(response){        
        toastr.info('Registro atualizado com sucesso.', 'Alerta');        
        $state.go('index.optin_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_MNP + "/mcard/optin/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;

      vm.cedente = vm.registro.cedente;

      vm.registro.dataAssinatura = new Date(vm.registro.dataAssinatura);
      vm.registro.dataInicio = new Date(vm.registro.dataInicio);
      vm.registro.dataTermino = new Date(vm.registro.dataTermino);
    });
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_MNP + "/curso/" + vm.registro.viewId).success(function(response){        
        toastr.info('Registro excluído com sucesso.', 'Alerta');      
        $state.go('index.optin_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.gerarFormulario = function()
  {
    vm.isFormulario = true;
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('FluxoUrPesquisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal)
{
    var vm = this;
    vm.registros = null;
    vm.pager = {};
    vm.setPage = setPage;
    vm.cedenteSelecionado = null;
    vm.filtro = {
        dataInicio: new Date(2021,6,1),
        dataTermino: new Date(2021,6,31)
    }

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.selecionarCedente = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/optin/modal/cedente/index.html',
            controller: 'ArranjoPagamentoOptInCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            vm.cedente = data;
        }); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/fluxour/pesquisar/detalhes_cedente/index.html',
            controller: 'FluxoUrDetalhesCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/mcard/operacao");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('ArranjoPagamentoAgendaPesquisarController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, PagerService, $uibModal, $http, APP_MNP)
  {
    var vm = this;
    vm.filtro = {
        cnpj: '',
        dataInicio: new Date(),
        dataTermino: new Date()
    };
    vm.cedente = null;
    vm.pager = {};
    vm.setPage = setPage;
    vm.total = {
        valorTotal : 0,
        quantidade : 0
    };
    vm.cedenteSelecionado = null;

    vm.init = function()
    {
        //vm.listar();
    }

    vm.selecionarCedente = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/optin/modal/cedente/index.html',
            controller: 'ArranjoPagamentoOptInCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            vm.cedente = data;
        }); 
    }

    vm.consultarUR = function(p)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/agenda/modal/detalhes_ur/index.html',
            controller: 'ArranjoPagamentoAgendaModalDetalhesURController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                recebivel: function () {
                    return p;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });
    }

    vm.selecionarRegistros = function()
    {
        var selecionados = [];

        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.registros[i].selecionado)
            {
                selecionados.push(vm.registros[i]);
            }
        }

        if (selecionados.length > 0)
        {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/arranjo_pagamento/agenda/modal/operacao/index.html',
                controller: 'AgendaModalOperacaoController',
                controllerAs: 'controller',
                windowClass: 'inmodal',
                size: 'lg',            
                resolve: {
                    cedente: function() {
                        return vm.cedenteSelecionado;
                    },
                    unidades: function () {
                        return selecionados;
                    },
                }            
            }).closed.then(function(){
                //vm.listar();
                vm.pesquisar();
            });
        }
        else
        {
            toastr.error('Selecione uma unidade de recebível.', 'Alerta');
        }
    }

    vm.calcularTotal = function()
    {
        var total = 0;
        var quantidade = 0;

        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.registros[i].selecionado)
            {
                total += vm.registros[i].valorLivre;
                quantidade++;
            }
        }

        vm.total.valorTotal = total;
        vm.total.quantidade = quantidade;
    }

    vm.pesquisar = function()
    {
        if (vm.cedente == null || vm.cedente.viewId == null || vm.cedente.viewId == '')
        {
            toastr.error('Cedente é obrigatório.', 'Alerta');
            return;
        }

        vm.filtro.cnpj = vm.cedente.cnpj;
        //vm.filtro.dataInicio = vm.filtro.dataTermino;

        vm.registros = null;     
        vm.cedenteSelecionado = null;   

        vm.listarPromise = $http.post(APP_MNP + "/mcard/agenda/consultar", vm.filtro).success(function(response){
            //vm.registros = response.agendas;
            vm.registros = response;
            
            vm.pager.totalPages = 1;
            vm.setPage(1);

            vm.cedenteSelecionado = vm.cedente;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            //return error;
        });
    }

    /*
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nfe != null && vm.filtro.nfe != '')
            {
                if (!vm.registrosOriginal[i].numero.includes(vm.filtro.nfe))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.titulo != null && vm.filtro.titulo != '')
            {
                if (!vm.registrosOriginal[i].titulo.includes(vm.filtro.titulo))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.sacado != null && vm.filtro.sacado != '')
            {
                if (!vm.registrosOriginal[i].sacado.toUpperCase().includes(vm.filtro.sacado.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '')
            {
                if (!vm.registrosOriginal[i].fornecedor.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
            {
                if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].dataVencimentoDate))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '')
            {
                if (vm.filtro.vencimentoAte < new Date(vm.registrosOriginal[i].dataVencimentoDate))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorDe != null && vm.filtro.valorDe != '')
            {
                if (vm.filtro.valorDe > vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorAte != null && vm.filtro.valorAte != '')
            {
                if (vm.filtro.valorAte < vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'nfe':
                    vm.registros.reverse(function(a, b){
                        if(a.numero < b.numero) { return -1; }
                        if(a.numero > b.numero) { return 1; }
                        return 0;
                    })
                    break;
                case 'titulo':
                    vm.registros.reverse(function(a, b){
                        if(a.titulo < b.titulo) { return -1; }
                        if(a.titulo > b.titulo) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.reverse(function(a, b){
                        if(a.sacado < b.sacado) { return -1; }
                        if(a.sacado > b.sacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'fornecedor':
                    vm.registros.reverse(function(a, b){
                        if(a.fornecedor < b.fornecedor) { return -1; }
                        if(a.fornecedor > b.fornecedor) { return 1; }
                        return 0;
                    })
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimentoDate);
                        var dateB = new Date(b.dataVencimentoDate);
                        return dateA - dateB;
                    });
                    break;
                case 'valor':
                    vm.registros.reverse(function(a, b){
                        if(a.valor < b.valor) { return -1; }
                        if(a.valor > b.valor) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'nfe':
                    vm.registros.sort(function(a, b){
                        if(a.numero < b.numero) { return -1; }
                        if(a.numero > b.numero) { return 1; }
                        return 0;
                    })
                    break;
                case 'titulo':
                    vm.registros.sort(function(a, b){
                        if(a.titulo < b.titulo) { return -1; }
                        if(a.titulo > b.titulo) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.sort(function(a, b){
                        if(a.sacado < b.sacado) { return -1; }
                        if(a.sacado > b.sacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'fornecedor':
                    vm.registros.sort(function(a, b){
                        if(a.fornecedor < b.fornecedor) { return -1; }
                        if(a.fornecedor > b.fornecedor) { return 1; }
                        return 0;
                    })
                    break;
                case 'vencimento':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataVencimentoDate);
                        var dateB = new Date(b.dataVencimentoDate);
                        return dateA - dateB;
                    });
                    break;
                case 'valor':
                    vm.registros.sort(function(a, b){
                        if(a.valor < b.valor) { return -1; }
                        if(a.valor > b.valor) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }
        
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }
    */

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
.controller('ConciliacaoCarteiraController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal',
function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal)
{
    var vm = this;
    vm.registros = null;
    vm.pager = {};
    vm.setPage = setPage;
    vm.cedenteSelecionado = null;
    vm.filtro = {
        dataInicio: new Date(2021,6,1),
        dataTermino: new Date(2021,6,31)
    }

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.selecionarCedente = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/optin/modal/cedente/index.html',
            controller: 'ArranjoPagamentoOptInCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            vm.cedente = data;
        }); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/conciliacao/carteira/detalhes_cedente/index.html',
            controller: 'ConciliacaoCarteiraDetalhesCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/mcard/operacao");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
.controller('ConciliacaoBaixaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal',
function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal)
{
    var vm = this;
    vm.registros = null;
    vm.pager = {};
    vm.setPage = setPage;
    vm.cedenteSelecionado = null;
    vm.filtro = {
        dataInicio: new Date(2021,6,1),
        dataTermino: new Date(2021,6,31)
    }

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.selecionarCedente = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/optin/modal/cedente/index.html',
            controller: 'ArranjoPagamentoOptInCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            vm.cedente = data;
        }); 
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/arranjo_pagamento/conciliacao/carteira/detalhes_cedente/index.html',
            controller: 'ConciliacaoBaixaDetalhesCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
        }).result.then(function(data){
            //vm.cedente = data;
        }); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/mcard/operacao");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('UsuariosPesquisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', 'modalService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, modalService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;

     // Adicione a função redirectToURL ao vm
     vm.redirectToURL = function() {
        var url = 'https://venturenegocios.com.br/wp-content/uploads/2024/12/MN-002-IC-CADASTRO-DE-USUÁRIOS.pdf';
        modalService.openModal(url);
    };

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/usuario/pesquisar");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.cadastrar = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/usuarios/cadastrar/index.html',
            controller: 'UsuariosCadastrarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                registro: function () {
                    return null;
                },
            }
        }).closed.then(function(){
            vm.pesquisar();
        });
    }

    vm.excluir = function(p)
    {
        if (confirm('Deseja realmente excluir o usuário ' + p.nome + '?'))
        {
            vm.enviarPromise = $http.delete(APP_MNP + "/usuario/cliente/" + p.viewId).success(function(response){                
                toastr.info('Usuário excluído com sucesso.', 'Alerta');      
                vm.pesquisar();     
                return response;
            }).error(function(error){
                toastr.error(error, 'Erro no processamento');
                return error;
            });
        }        
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/usuarios/cadastrar/index.html',
            controller: 'UsuariosCadastrarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                registro: function () {
                    return registro;
                },
            }
        }).closed.then(function(){
            vm.pesquisar();
        });
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('UsuariosCadastrarController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'registro',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, registro)
  {
    var vm = this;
    vm.registro = {};
    vm.isUpdate = false;

    $scope.options = {        
      toolbar: [
          //['edit',['undo','redo']],
          //['headline', ['style']],
          ['style', ['bold', 'italic', 'underline']],
          //['fontface', ['fontname']],
          //['textsize', ['fontsize']],
          //['fontclr', ['color']],
          ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
          //['height', ['height']],
          //['table', ['table']],
          //['insert', ['picture']],
          ['view', ['codeview']],
          //['help', ['help']]
      ]
    };

    vm.init = function()
    {
      vm.listarGrupos();
      
      if (registro != null)
      {
        vm.isUpdate = true;
        vm.registro = registro;

        if (vm.registro.isAdmin)
        {
          vm.administrador = 1;
        }
        else
        {
          vm.administrador = 0;
        }

        if (vm.registro.restrito)
        {
          vm.restritoText = 1;
        }
        else
        {
          vm.restritoText = 0;
        }
      }
      else
      {        
        vm.administrador = 0;
        vm.restritoText = 0;
        vm.isUpdate = false;
      }
    }

    vm.listarGrupos = function()
    {
        vm.listarGruposPromise = $http.get(APP_MNP + "/grupoUsuario/pesquisar");   
        vm.listarGruposPromise.then(function(response)
        { 
            vm.grupos = response.data;  
            
            if (vm.registro.grupoUsuario == null)
            {
              vm.registro.grupoUsuario = vm.grupos[0];
            }
        });
    }

    vm.enviar = function()
    {
      if (vm.registro.nome == null || vm.registro.nome == '')
      {
        toastr.error('Nome é obrigatório.', 'Alerta');
        return;
      }

      if (vm.registro.email == null || vm.registro.email == '')
      {
        toastr.error('E-mail é obrigatório.', 'Alerta');
        return;
      }

      if (vm.administrador == 1)
      {
        vm.registro.isAdmin = true;
      }
      else
      {
        vm.registro.isAdmin = false;
      }

      if (vm.restritoText == 1)
      {
        vm.registro.restrito = true;
      }
      else
      {
        vm.registro.restrito = false;
      }

      if (!vm.isUpdate)
      {
        if (vm.registro.senha == null || vm.registro.senha == '')
        {
          toastr.error('Senha é obrigatório.', 'Alerta');
          return;
        }

        vm.enviarPromise = $http.post(APP_MNP + "/usuario/cliente", vm.registro).success(function(response){
            vm.fechar();
            toastr.info('Usuário cadastrado com sucesso.', 'Alerta');          
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
      }
      else
      {
        vm.enviarPromise = $http.put(APP_MNP + "/usuario/cliente", vm.registro).success(function(response){
          vm.fechar();
          toastr.info('Registro atualizado com sucesso.', 'Alerta');          
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });
      }
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
    .controller('TituloLiquidacaoLoteController', ['$scope', '$state', 'toastr', '$http', 'APP_MNP', '$uibModal', 'PagerService',
        function ($scope, $state, toastr, $http, APP_MNP, $uibModal, PagerService) {
            var vm = this;
            vm.registros = null;    // lista completa
            vm.items = [];          // página atual
            vm.exibirLancamentos = false;
            vm.nomeLoteGerado = null;
            vm.selecionadoTodos = false;
            vm.totalQtd = 0;
            vm.totalValor = 0;
            vm.pager = {};
            vm.ultimosLotes = [];
            var PAGE_SIZE = 10;

            vm.setPage = function (page) {
                if (!vm.registros || vm.registros.length === 0) return;
                if (page < 1 || page > vm.pager.totalPages) return;
                vm.pager = PagerService.GetPager(vm.registros.length, page, PAGE_SIZE);
                vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
            };

            // Inicializa datas com hoje
            var hoje = new Date();
            var dd = String(hoje.getDate()).padStart(2, '0');
            var mm = String(hoje.getMonth() + 1).padStart(2, '0');
            var yyyy = hoje.getFullYear();
            var hojeISO = yyyy + '-' + mm + '-' + dd;

            vm.filtro = {
                cedente: null,
                cedenteViewId: null,
                vencimentoInicial: hojeISO,
                vencimentoFinal: hojeISO,
                loteEstorno: ''
            };

            // ─── Carregar últimos lotes ────────────────────────────────────
            vm.carregarUltimosLotes = function () {
                $http.get(APP_MNP + '/invoice/tituloliquidacaolote/ultimos-lotes')
                    .success(function (data) { vm.ultimosLotes = data || []; })
                    .error(function () { vm.ultimosLotes = []; });
            };

            vm.selecionarLoteEstorno = function (nomeLote) {
                vm.filtro.loteEstorno = nomeLote;
                vm.mostrarDropLote = false;
            };

            vm.carregarUltimosLotes();

            // ─── Selecionar Cedente ───────────────────────────────────────
            vm.selecionarCedenteModal = function () {
                $uibModal.open({
                    templateUrl: 'app/cadastro/cedente/selecionar/index.html',
                    controller: 'CedenteSelecionarController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                }).result.then(function (data) {
                    vm.registros = null;
                    vm.exibirLancamentos = false;
                    vm.filtro.cedente = null;
                    if (data != null) {
                        vm.filtro.cedente = data;
                        vm.filtro.cedenteViewId = data.viewId;
                    }
                });
            };

            // ─── Pesquisar ────────────────────────────────────────────────
            vm.pesquisar = function () {
                vm.registros = null;
                vm.exibirLancamentos = false;
                vm.nomeLoteGerado = null;

                var isEstorno = vm.filtro.loteEstorno && vm.filtro.loteEstorno.trim() !== '';

                if (!isEstorno && vm.filtro.cedente == null) {
                    toastr.error('Selecione um Cedente.', 'Alerta');
                    return;
                }

                var payload = {
                    cedenteViewId: vm.filtro.cedenteViewId || '00000000-0000-0000-0000-000000000000',
                    vencimentoInicial: vm.filtro.vencimentoInicial || null,
                    vencimentoFinal: vm.filtro.vencimentoFinal || null,
                    nomeLote: isEstorno ? vm.filtro.loteEstorno.trim() : null
                };

                vm.consultarPromise = $http.post(APP_MNP + '/invoice/tituloliquidacaolote/pesquisar', payload)
                    .success(function (response) {
                        if (!response.registros || response.registros.length === 0) {
                            toastr.warning('Nenhum título encontrado.', 'Alerta');
                            return;
                        }

                        // inicializa campos editáveis
                        vm.registros = response.registros.map(function (r) {
                            r.valorPagoEditado = vm.formatarValor(r.valorPago);
                            r.dataPagamentoEditada = r.dataPagamento;
                            r.selecionado = true;
                            return r;
                        });

                        vm.selecionadoTodos = true;
                        vm.calcularTotais();
                        vm.setPage(1);
                        vm.exibirLancamentos = true;
                    })
                    .error(function (error) {
                        toastr.error(error, 'Erro');
                    });
            };

            // ─── Selecionar Todos ─────────────────────────────────────────
            vm.selecionarTodos = function () {
                if (vm.registros) {
                    vm.registros.forEach(function (r) { r.selecionado = vm.selecionadoTodos; });
                    vm.calcularTotais();
                }
            };

            // ─── Calcular Totais (sobre lista completa) ───────────────────
            vm.calcularTotais = function () {
                vm.totalQtd = 0;
                vm.totalValor = 0;
                if (!vm.registros) return;
                vm.registros.forEach(function (r) {
                    if (r.selecionado) {
                        vm.totalQtd++;
                        vm.totalValor += vm.parseValor(r.valorPagoEditado);
                    }
                });
            };

            // ─── Validações ───────────────────────────────────────────────
            vm.podeEnviarLote = function () {
                if (!vm.registros || vm.registros.length === 0) return false;
                return vm.registros.some(function (r) {
                    return r.selecionado && vm.parseValor(r.valorPagoEditado) > 0 && r.dataPagamentoEditada && r.dataPagamentoEditada.length === 10;
                });
            };

            // ─── Enviar Lote ──────────────────────────────────────────────
            vm.enviarLote = function () {
                if (!vm.podeEnviarLote()) {
                    toastr.warning('Selecione ao menos um título com valor e data válidos.', 'Atenção');
                    return;
                }

                // gerar nome do lote: LOTE-YYYYMMDD-HHmmss
                var now = new Date();
                var pad = function (n) { return String(n).padStart(2, '0'); };
                var nomeLote = 'LOTE-' +
                    now.getFullYear() +
                    pad(now.getMonth() + 1) +
                    pad(now.getDate()) + '-' +
                    pad(now.getHours()) +
                    pad(now.getMinutes()) +
                    pad(now.getSeconds());

                var titulos = vm.registros
                    .filter(function (r) { return r.selecionado; })
                    .map(function (r) {
                        // converte dataPagamentoEditada de DD/MM/YYYY para ISO
                        var partes = r.dataPagamentoEditada.split('/');
                        var dataISO = partes[2] + '-' + partes[1] + '-' + partes[0];
                        return {
                            tituloViewId: r.tituloViewId,
                            valorPago: vm.parseValor(r.valorPagoEditado),
                            dataPagamento: dataISO
                        };
                    });

                var payload = { nomeLote: nomeLote, titulos: titulos };

                vm.consultarPromise = $http.post(APP_MNP + '/invoice/tituloliquidacaolote/liquidar', payload)
                    .success(function (response) {
                        vm.nomeLoteGerado = nomeLote;
                        vm.exibirLancamentos = false;
                        vm.registros = null;
                        toastr.success('Lote liquidado com sucesso! Lote: ' + nomeLote, 'Sucesso');
                        if (response.erros && response.erros.length > 0) {
                            toastr.warning('Alguns títulos não foram processados: ' + response.erros.join(', '), 'Avisos');
                        }
                    })
                    .error(function (error) {
                        toastr.error(error, 'Erro');
                    });
            };

            // ─── Estornar Lote ────────────────────────────────────────────
            vm.estornarLote = function () {
                if (!vm.filtro.loteEstorno || vm.filtro.loteEstorno.trim() === '') {
                    toastr.error('Informe o nome do lote para estornar.', 'Alerta');
                    return;
                }

                if (!vm.podeEnviarLote()) {
                    toastr.warning('Selecione ao menos um título.', 'Atenção');
                    return;
                }

                var payload = { nomeLote: vm.filtro.loteEstorno.trim() };

                vm.consultarPromise = $http.post(APP_MNP + '/invoice/tituloliquidacaolote/estornar', payload)
                    .success(function (response) {
                        vm.exibirLancamentos = false;
                        vm.registros = null;
                        vm.filtro.loteEstorno = '';
                        toastr.success('Lote estornado com sucesso!', 'Sucesso');
                    })
                    .error(function (error) {
                        toastr.error(error, 'Erro');
                    });
            };

            // ─── Helpers ──────────────────────────────────────────────────
            vm.formatarValor = function (val) {
                if (!val) return '0,00';
                var num = typeof val === 'string'
                    ? parseFloat(val.replace(/\./g, '').replace(',', '.'))
                    : parseFloat(val);
                if (isNaN(num)) return '0,00';
                return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            };

            vm.parseValor = function (val) {
                if (!val) return 0;
                if (typeof val === 'number') return val;
                return parseFloat(val.replace(/\./g, '').replace(',', '.')) || 0;
            };

            vm.showhide = function (icon, box) {
                var iconEl = angular.element(document.getElementById(icon));
                iconEl.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                angular.element(document.getElementById(box)).slideToggle(200);
            };
        }
    ]);

angular.module('inspinia')
  .controller('TituloPosicaoController', ['$scope', '$state', 'toastr', '$http', 'APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP) 
{
    var vm = this;
    
    vm.filtro = {
        cedenteId: null,
        sacadorAvalistaId: null,
        sacadoId: null,
        dataInicial: null,
        dataFinal: null,
        tipoData: 'Vencimento',
        situacao: 'Todos'
    };

    vm.relatorio = null;
    vm.cedentes = [];
    vm.sacados = [];
    vm.dataGeracao = null;

    vm.init = function() {
        vm.carregarCedentes();
        vm.carregarSacados();
    };

    vm.carregarCedentes = function() {
        $http.get(APP_MNP + "/cedente/pesquisar").success(function(response) {
            vm.cedentes = response;
            vm.cedentes.unshift({ id: 0, razaoSocial: 'TODOS', cnpj: '' });
        }).error(function(error) {
            console.log("Erro ao carregar cedentes", error);
        });
    }

    vm.carregarSacados = function() {
        $http.get(APP_MNP + "/sacado/pesquisar").success(function(response) {
            vm.sacados = response;
            vm.sacados.unshift({ id: 0, razaoSocial: 'TODOS', cnpj: '' });
        }).error(function(error) {
            console.log("Erro ao carregar sacados", error);
        });
    }

    // Verifica se o dropdown foi selecionado (0 = TODOS, >0 = específico, null = não selecionado)
    vm.isSelecionado = function(valor) {
        return valor !== null && valor !== undefined;
    };

    vm.calcularTipoAgrupamento = function() {
        var ced = vm.isSelecionado(vm.filtro.cedenteId);
        var sac = vm.isSelecionado(vm.filtro.sacadorAvalistaId);
        var sad = vm.isSelecionado(vm.filtro.sacadoId);

        if (ced && sac) return 'CedenteSacador';
        if (ced && sad) return 'CedenteSacado';
        if (sac && sad) return 'SacadorSacado';
        if (ced) return 'Cedente';
        if (sac) return 'SacadorAvalista';
        if (sad) return 'Sacado';
        return 'Cedente';
    };

    vm.getLabelGrupo = function() {
        var tipo = vm.relatorio ? vm.relatorio.tipoAgrupamento : '';
        if (tipo === 'Cedente' || tipo === 'CedenteSacador' || tipo === 'CedenteSacado') return 'Cedente';
        if (tipo === 'SacadorAvalista' || tipo === 'SacadorSacado') return 'Sacador Avalista';
        if (tipo === 'Sacado') return 'Sacado';
        return 'Grupo';
    };

    vm.getLabelSubGrupo = function() {
        var tipo = vm.relatorio ? vm.relatorio.tipoAgrupamento : '';
        if (tipo === 'CedenteSacador') return 'Sacador Avalista';
        if (tipo === 'CedenteSacado') return 'Sacado';
        if (tipo === 'SacadorSacado') return 'Sacado';
        return '';
    };

    vm.temSubGrupos = function() {
        var tipo = vm.relatorio ? vm.relatorio.tipoAgrupamento : '';
        return tipo === 'CedenteSacador' || tipo === 'CedenteSacado' || tipo === 'SacadorSacado';
    };

    vm.gerarRelatorio = function() {
        var temFiltro = vm.isSelecionado(vm.filtro.cedenteId) || vm.isSelecionado(vm.filtro.sacadorAvalistaId) || vm.isSelecionado(vm.filtro.sacadoId);
        if (!temFiltro) {
            toastr.warning("Selecione ao menos um Cedente, Sacador Avalista ou Sacado.");
            return;
        }
        if (!vm.filtro.dataInicial || !vm.filtro.dataFinal) {
            toastr.warning("Informe a Data Inicial e a Data Final.");
            return;
        }

        var params = {
            cedenteId: vm.filtro.cedenteId,
            sacadorAvalistaId: vm.filtro.sacadorAvalistaId,
            sacadoId: vm.filtro.sacadoId,
            dataInicial: vm.filtro.dataInicial,
            dataFinal: vm.filtro.dataFinal,
            tipoData: vm.filtro.tipoData,
            situacao: vm.filtro.situacao,
            tipoAgrupamento: vm.calcularTipoAgrupamento()
        };

        vm.promise = $http.post(APP_MNP + "/invoice/TituloPosicaoRelatorio/relatorio", params).success(function(response) {
            vm.relatorio = response;
            vm.dataGeracao = new Date();
            
            if(response.grupos.length === 0) {
                toastr.info("Nenhum título encontrado para este período.");
            }
        }).error(function(error) {
            toastr.error("Erro ao gerar relatório");
        });
    }

    vm.imprimir = function() {
        window.print();
    }

    vm.getCedenteName = function() {
        if (!vm.filtro.cedenteId) {
            return "TODOS";
        }
        for (var i = 0; i < vm.cedentes.length; i++) {
            if (vm.cedentes[i].id === vm.filtro.cedenteId) {
                return vm.cedentes[i].cnpj + ' - ' + vm.cedentes[i].razaoSocial;
            }
        }
        return "TODOS";
    };

    vm.init();
}]); 

angular.module('inspinia')
  .controller('TituloPesquisarController', ['$scope', '$state', 'toastr', 'PagerService', '$http','APP_MNP',
      function($scope, $state, toastr, PagerService, $http, APP_MNP) 
{
    var vm = this;    
    vm.registros = null;
    vm.sortColumn = 'id';
    vm.sortAsc = false;
    vm.filtro = {
        codigo: '',
        nome: '',
        cnpj: '',
        tipoData: 'Vencimento',
        situacao: 'Todos'
    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 10,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.pesquisar = function(perPage, index, orderBy, filter)
    {
        vm.registros = null;

        var codigo = "0";

        if (vm.filtro == null)
        {
            vm.filtro = {
                codigo: '',
                index: index,
                page: perPage,
                tipoData: 'Vencimento',
                situacao: 'Todos'
            }
        }

        if (vm.filtro.codigo != null && vm.filtro.codigo != '')
        {
            codigo = vm.filtro.codigo;
        }

        vm.filtro.page = index;
        vm.filtro.perPage = perPage;
        
        vm.pesquisarPromise = $http.post(APP_MNP + "/contagrafica/titulo/pesquisar", vm.filtro).success(function(response){
            vm.registros = response.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });
    }
    
    $scope.onSearch = function() {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPerPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.consultar = function(item)
    {
        $state.go('index.titulos_consultar', {obj: item.viewId});
    }

    vm.cadastrar = function()
    {
        //$state.go('index.cadastro_sacado');
    }

    vm.filtrarPesquisa = function()
    {
        $scope.pagination.perPage,$scope.pagination.current = 1;
        
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.init();

    vm.getTotalPages = function() {
        return new Array(7);   
    }

    vm.ordenar = function(coluna) {
        if (vm.sortColumn === coluna) {
            vm.sortAsc = !vm.sortAsc;
        } else {
            vm.sortColumn = coluna;
            vm.sortAsc = true;
        }

        var asc = vm.sortAsc ? 1 : -1;

        vm.items.sort(function(a, b) {
            var va, vb;
            switch (coluna) {
                case 'id':           va = a.id;                      vb = b.id;                      break;
                case 'numero':       va = (a.numeroNfe || '') + (a.numero || ''); vb = (b.numeroNfe || '') + (b.numero || ''); break;
                case 'sacado':       va = a.sacado ? a.sacado.razaoSocial : '';  vb = b.sacado ? b.sacado.razaoSocial : '';  break;
                case 'cedente':      va = a.cedente ? a.cedente.razaoSocial : ''; vb = b.cedente ? b.cedente.razaoSocial : ''; break;
                case 'emissao':      va = new Date(a.dataRecebimento);  vb = new Date(b.dataRecebimento);  break;
                case 'vencimento':   va = new Date(a.dataVencimento);   vb = new Date(b.dataVencimento);   break;
                case 'valor':        va = a.valor;                      vb = b.valor;                      break;
                case 'dataPagamento':va = a.dataPagamento ? new Date(a.dataPagamento) : new Date(0); vb = b.dataPagamento ? new Date(b.dataPagamento) : new Date(0); break;
                case 'valorPago':    va = a.valorPago;                  vb = b.valorPago;                  break;
                case 'situacao':     va = a.statusFinanceiroTexto || ''; vb = b.statusFinanceiroTexto || ''; break;
                default:             return 0;
            }
            if (va < vb) return -1 * asc;
            if (va > vb) return  1 * asc;
            return 0;
        });
    };

    vm.sortIcon = function(coluna) {
        if (vm.sortColumn !== coluna) return 'fa fa-sort text-muted';
        return vm.sortAsc ? 'fa fa-sort-asc' : 'fa fa-sort-desc';
    };

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('TituloConsultarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.itemParam = $state.params.obj;

    vm.init = function()
    {
        if (vm.itemParam == null || vm.itemParam == '')
        {
            $state.go('index.titulos_pesquisar');
        }
        else
        {
            vm.pesquisar();        
        }
    }

    vm.pesquisar = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/contagrafica/titulo/detalhe/" + vm.itemParam)
        .then(function(response)
        { 
            vm.registro = response.data;

            vm.pesquisarInstrucoes();
            vm.consultarContaCorrente();
            vm.pesquisarPosicaoBancaria();
        });
    }

    vm.pesquisarInstrucoes = function() 
    {
        vm.consultarInstrucoesPromise = $http.get(APP_MNP + "/invoice/tituloinstrucao/consultar/" + vm.itemParam)
        .then(function(response)
        { 
            vm.instrucoes = response.data;
        });
    }

    vm.consultarContaCorrente = function() 
    {
        vm.consultarContaCorrentePromise = $http.get(APP_MNP + "/tituloContaCorrente/consultar/" + vm.itemParam)
        .then(function(response)
        { 
            vm.contaCorrente = response.data;
        });
    }

    vm.pesquisarPosicaoBancaria = function() 
    {
        vm.consultarPosicaoBancariaPromise = $http.get(APP_MNP + "/invoice/tituloposicaobancaria/consultar/" + vm.itemParam)
        .then(function(response)
        { 
            vm.posicaobancaria = response.data;
        });
    }

    vm.atualizar = function()
    {
        /*
        if (vm.sacado.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Alerta');
            return;
        }

        if (vm.sacado.cnpj.toString().length != 18 && vm.sacado.cnpj.toString().length != 14)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }

        if (vm.sacado.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        $http.post(APP_MNP + "/sacado/alterar", vm.sacado).success(function(response){
            toastr.info('Sacado atualizado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            return error;
        });
        */
    }

    vm.init();

    vm.adicionarInstrucao = function()
    {
        var isSalarioDemanda = vm.registro.dadosAdicionaisModel != null && vm.registro.dadosAdicionaisModel.salarioDemanda != null;

        if (!isSalarioDemanda && vm.registro.antecipacaoTitulo != null && vm.registro.antecipacaoTitulo.statusRemessa != 3)
        {
            toastr.error('Aguardando remessa.', 'Alerta');
            return;
        }

        var modalInstance = $uibModal.open({
            templateUrl: 'app/titulo/consultar/instrucao/index.html',
            controller: 'TituloConsultarInstrucaoController',
            controllerAs: 'controller',
            windowClass: 'inmodal modal-instrucao-bottom',
            size: 'lg',
            resolve: {
                titulo: function () {
                    return vm.registro;
                },
            }
        }).closed.then(function(){
            vm.pesquisar(); 
        });
    }

    vm.excluirInstrucao = function(item)
    {
        if (confirm('Deseja realmente excluir este registro informativo?'))
        {
            $http.delete(APP_MNP + "/invoice/tituloinstrucao/excluir/" + item.viewId)
            .success(function(response){
                toastr.success('Registro informativo excluído com sucesso.', 'Sucesso');
                vm.pesquisarInstrucoes();
            })
            .error(function(error){
                toastr.error(error, 'Erro no processamento');
            });
        }
    }

    vm.editarUsuario = function(usuario)
    {
        /*
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/sacado/consulta/usuario/consulta/index.html',
            controller: 'SacadoConsultarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                sacado: function () {
                    return vm.sacadoParam;
                },
                usuario: function () {
                    return usuario;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
        */
    }
    
    vm.listarUsuarios = function()
    {
        /*
        return $http.get(APP_MNP + "/sacado/listarUsuarios/" + vm.sacado.viewId)
        .then(function(response)
        { 
            vm.usuarios = response.data;
        });
        */
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.downloadCnab = function(item)
    {
        if (item.remessaArquivo != null)
        {
            vm.gerarRemessaPromise = $http.get(APP_MNP + "/cnab/downloadremessa/" + item.remessaArquivo.viewId).success(function(response){  
                vm.download(response, 'text/plain', 'remessa.rem');                   
            }).error(function(error){
                toastr.error(error, 'Erro no processamento');            
            });
        }
        else
        {
            vm.gerarRemessaPromise = $http.get(APP_MNP + "/cnabretorno/downloadretorno/" + item.retornoArquivo.viewId).success(function(response){  
                vm.download(response, 'text/plain', 'retorno.ret');                   
            }).error(function(error){
                toastr.error(error, 'Erro no processamento');            
            });
        }
    }

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('SalarioDemandaEnvioController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP', 'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP, AuthService)
  {
    var vm = this;
    vm.fileName = '';
    vm.selectedTempFile = [];
    vm.filesSelected = [];
    vm.cnab = null;

    vm.init = function()
    {
    }
  
    vm.adicionarItem = function()
    {
        vm.fileName = vm.selectedTempFile[0].name; 

        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {
            vm.validarPromise = $http.post(APP_MNP + "/salarioDemandaEnvio/validar-cnab", 
                { 
                    file : evt.target.result, 
                    name: vm.fileName, 
                }
            ).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })

            vm.validarPromise.then(function(result) {  
                vm.cnab = result.data;
                //alert(result);
            });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
    }

    vm.concluir = function()
    {
        vm.concluirPromise = $http.post(APP_MNP + "/salarioDemandaEnvio/registrar-cnab", vm.cnab).success(function(response){            
            toastr.info('CNAB registrado com sucesso.', 'Alerta');
            vm.cnab = null;
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
    }

    vm.reset = function() {
        vm.cnab = null;
    }

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('RelatorioGeradorController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$sce', 'AuthService',
      function($scope, $state, toastr, $http, APP_MNP, $sce, AuthService)
{
    var vm = this;
    vm.registros = null;
    vm.iFrameUrl = "";
    vm.relatorio = $state.params.report;
    vm.name = $state.params.name;

    vm.init = function()
    {
        vm.pesquisar();
        
        vm.pentahoCodigoCliente = AuthService.getPentahoCodigo();
        vm.pentahoLogo = AuthService.getPentahoLogo();
        vm.userRest = AuthService.getUserRest();
        vm.userName = AuthService.getUser();
        vm.urlPentaho = AuthService.getUrlPentaho();
        
        if (vm.relatorio == '')
        {
            toastr.error('Relatório não encontrado.', 'Alerta');
        }

        if (vm.pentahoCodigoCliente == null || vm.pentahoCodigoCliente == '')
        {
            toastr.error('Código de Integração não cadastrado.', 'Alerta');
        }
        else
        {
            //var urlPentaho = "https://homolog.moneynow.com.br/pentaho/api/repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + "_" + vm.pentahoCodigoCliente + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=0";
            var urlPentaho = vm.urlPentaho + "repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + "_" + vm.pentahoCodigoCliente + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=0";

            // restrito
            if (vm.userRest) {
                urlPentaho = urlPentaho + '&dbFilterGer=' + vm.userName;
            } else {
                urlPentaho = urlPentaho + '&dbFilterGer=T';
            }

            // pentaho logo
            if (vm.pentahoLogo != null && vm.pentahoLogo != '') {
                urlPentaho = urlPentaho + "&logo=" + vm.pentahoLogo;
            }

            vm.iFrameUrl = $sce.trustAsResourceUrl(urlPentaho);

            /*
            if (vm.pentahoLogo != null && vm.pentahoLogo != '') {
                vm.iFrameUrl = $sce.trustAsResourceUrl("https://homolog.moneynow.com.br/pentaho/api/repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + "_" + vm.pentahoCodigoCliente + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=0&logo=" + vm.pentahoLogo);
            }
            else {
                vm.iFrameUrl = $sce.trustAsResourceUrl("https://homolog.moneynow.com.br/pentaho/api/repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + "_" + vm.pentahoCodigoCliente + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=0");
            }
            */
        }        
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        return $http.get(APP_MNP + "/cedente/pendentes")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.analisar_cadastro_fornecedor', {obj: fornecedor});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_fornecedor');
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].statusCadastro)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.statusCadastro < b.statusCadastro) { return -1; }
                        if(a.statusCadastro > b.statusCadastro) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.statusCadastro < b.statusCadastro) { return -1; }
                        if(a.statusCadastro > b.statusCadastro) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
    .controller('InvoiceListarTitulosController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModal', '$http', 'APP_MNP', 'AuthService',
        function ($scope, $state, toastr, PagerService, $uibModal, $http, APP_MNP, AuthService) {
            var vm = this;
            vm.pager = {};
            vm.setPage = setPage;
            vm.total = {
                valorTotal: 0,
                quantidade: 0
            };
            vm.filtro = {};
            vm.registrosOriginal = [];
            vm.lastOrder = '';
            vm.orderSelected = '';
            vm.filtro = {
                status: 1
            };

            vm.init = function () {
                vm.horarioLimite = AuthService.getHorarioLimite();
                vm.listar();
            }

            vm.validarHorarioLimite = function () {
                // Verificar a hora atual
                var currentTime = new Date();
                var currentHours = currentTime.getHours();
                var currentMinutes = currentTime.getMinutes();

                var horarioEmpresa = parseFloat(vm.horarioLimite.replace(":", "."));
                var currentHourMinute = parseFloat(currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes));

                if (currentHourMinute > horarioEmpresa) {
                    toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
                    return false;
                }
                return true;

            }

            vm.validarEPrevenir = function (event) {
                if (!vm.validarHorarioLimite()) {
                    event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
                    return false;
                }
                else {
                    vm.anteciparRegistros()
                }
            };

            vm.listar = function () {
                vm.registros = null;
                vm.items = null;

                vm.listarPromise = $http.get(APP_MNP + "/invoice/titulo/disponiveis/" + vm.filtro.status);
                /*
                .then(function(response)
                { 
                    return response.data;
                });
                */

                vm.listarPromise.then(function (result) {
                    vm.registrosOriginal = result.data;
                    vm.registros = result.data;
                    vm.calcularTotal();
                    vm.filtrarPesquisa();
                });
            }

            vm.filtrarPesquisaStatus = function () {
                vm.listar();
            }

            vm.filtrarPesquisa = function () {
                vm.registros = [];

                for (var i = 0; i < vm.registrosOriginal.length; i++) {
                    var incluir = true;

                    if (vm.filtro.nfe != null && vm.filtro.nfe != '') {
                        if (!vm.registrosOriginal[i].numero.includes(vm.filtro.nfe)) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.titulo != null && vm.filtro.titulo != '') {
                        if (!vm.registrosOriginal[i].titulo.includes(vm.filtro.titulo)) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.sacado != null && vm.filtro.sacado != '') {
                        if (!vm.registrosOriginal[i].sacado.toUpperCase().includes(vm.filtro.sacado.toUpperCase())) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '') {
                        if (!vm.registrosOriginal[i].cedente.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase())) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '') {
                        if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].dataVencimentoDate)) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '') {
                        if (vm.filtro.vencimentoAte < new Date(vm.registrosOriginal[i].dataVencimentoDate)) {
                            incluir = false;
                        }
                    }
                    if (vm.filtro.dataCadastro != null && vm.filtro.dataCadastro != '') {


                        // Converter as datas para o formato YYYY-MM-DD
                        var filtroData = new Date(vm.filtro.dataCadastro).toISOString().split('T')[0];
                        var registroData = new Date(vm.registrosOriginal[i].dataCadastro).toISOString().split('T')[0];
                        console.log("filtro:", filtroData, registroData);

                        if (filtroData != registroData) {
                            incluir = false;
                        }
                    }


                    if (vm.filtro.valorDe != null && vm.filtro.valorDe != '') {
                        if (vm.filtro.valorDe > vm.registrosOriginal[i].valor) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.valorAte != null && vm.filtro.valorAte != '') {
                        if (vm.filtro.valorAte < vm.registrosOriginal[i].valor) {
                            incluir = false;
                        }
                    }

                    /*
                    if (vm.filtro.status != null && vm.filtro.status != '')
                    {
                        if (vm.filtro.status != vm.registrosOriginal[i].status)
                        {
                            incluir = false;
                        }
                    }
                    */

                    if (incluir) {
                        vm.registros.push(vm.registrosOriginal[i]);
                    }
                }

                vm.desmarcarTodos();
                vm.pager.totalPages = 1;
                vm.setPage(1);
                vm.calcularTotal();
            }

            vm.ordenarResultado = function (coluna) {
                vm.orderSelected = coluna;

                if (vm.lastOrder == coluna) {
                    vm.lastOrder = '';

                    switch (coluna) {
                        case 'nfe':
                            vm.registros.reverse(function (a, b) {
                                if (a.numero < b.numero) { return -1; }
                                if (a.numero > b.numero) { return 1; }
                                return 0;
                            })
                            break;
                        case 'titulo':
                            vm.registros.reverse(function (a, b) {
                                if (a.titulo < b.titulo) { return -1; }
                                if (a.titulo > b.titulo) { return 1; }
                                return 0;
                            })
                            break;
                        case 'sacado':
                            vm.registros.reverse(function (a, b) {
                                if (a.sacado < b.sacado) { return -1; }
                                if (a.sacado > b.sacado) { return 1; }
                                return 0;
                            })
                            break;
                        case 'fornecedor':
                            vm.registros.reverse(function (a, b) {
                                if (a.fornecedor < b.fornecedor) { return -1; }
                                if (a.fornecedor > b.fornecedor) { return 1; }
                                return 0;
                            })
                            break;
                        case 'datacadastro':
                            vm.registros.reverse(function compare(a, b) {
                                var dateA = new Date(a.dataCadastro);
                                var dateB = new Date(b.dataCadastro);
                                return dateA - dateB;
                            });
                            break;
                        case 'vencimento':
                            vm.registros.reverse(function compare(a, b) {
                                var dateA = new Date(a.dataVencimentoDate);
                                var dateB = new Date(b.dataVencimentoDate);
                                return dateA - dateB;
                            });
                            break;
                        case 'valor':
                            vm.registros.reverse(function (a, b) {
                                if (a.valor < b.valor) { return -1; }
                                if (a.valor > b.valor) { return 1; }
                                return 0;
                            })
                            break;
                    }
                }
                else {
                    vm.lastOrder = coluna;

                    switch (coluna) {
                        case 'nfe':
                            vm.registros.sort(function (a, b) {
                                if (a.numero < b.numero) { return -1; }
                                if (a.numero > b.numero) { return 1; }
                                return 0;
                            })
                            break;
                        case 'titulo':
                            vm.registros.sort(function (a, b) {
                                if (a.titulo < b.titulo) { return -1; }
                                if (a.titulo > b.titulo) { return 1; }
                                return 0;
                            })
                            break;
                        case 'sacado':
                            vm.registros.sort(function (a, b) {
                                if (a.sacado < b.sacado) { return -1; }
                                if (a.sacado > b.sacado) { return 1; }
                                return 0;
                            })
                            break;
                        case 'fornecedor':
                            vm.registros.sort(function (a, b) {
                                if (a.fornecedor < b.fornecedor) { return -1; }
                                if (a.fornecedor > b.fornecedor) { return 1; }
                                return 0;
                            })
                            break;
                        case 'datacadastro':
                            vm.registros.sort(function compare(a, b) {
                                var dateA = new Date(a.dataCadastro);
                                var dateB = new Date(b.dataCadastro);
                                return dateA - dateB;
                            });
                            break;
                        case 'vencimento':
                            vm.registros.sort(function compare(a, b) {
                                var dateA = new Date(a.dataVencimentoDate);
                                var dateB = new Date(b.dataVencimentoDate);
                                return dateA - dateB;
                            });
                            break;
                        case 'valor':
                            vm.registros.sort(function (a, b) {
                                if (a.valor < b.valor) { return -1; }
                                if (a.valor > b.valor) { return 1; }
                                return 0;
                            })
                            break;
                    }
                }

                vm.pager.totalPages = 1;
                vm.setPage(1);
            }

            vm.anteciparRegistros = function () {
                if (vm.registros != null) {
                    var selecionados = [];
                    for (var i = 0; i < vm.registros.length; i++) {
                        if (vm.registros[i].selecionadoAntecipar) {
                            selecionados.push(vm.registros[i]);
                        }
                    }

                    if (selecionados.length == 0) {
                        alert('Selecione pelo menos um registro.');
                        return;
                    }

                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/invoice/titulos/modal/antecipar/index.html',
                        controller: 'InvoiceTitulosAnteciparController',
                        controllerAs: 'controller',
                        windowClass: 'inmodal',
                        size: 'lg',
                        resolve: {
                            registros: function () {
                                return selecionados;
                            },
                        }
                    }).closed.then(function () {
                        vm.listar();
                    });
                }
            }

            vm.marcarTodos = function () {
                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.filtro.status == vm.registros[i].status) {
                        if (vm.registros[i].status == 1 && (vm.registros[i].isPendenteSefaz == false && vm.registros[i].statusNfe != '101')) {
                            vm.registros[i].selecionadoAntecipar = true;
                        }
                    }
                }
                vm.calcularTotal();
            }

            vm.desmarcarTodos = function () {
                for (var i = 0; i < vm.registros.length; i++) {
                    vm.registros[i].selecionadoAntecipar = false;
                }
                vm.calcularTotal();
            }

            vm.calcularTotal = function () {
                var total = 0;
                var quantidade = 0;

                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.registros[i].selecionadoAntecipar) {
                        total += vm.registros[i].valor;
                        quantidade++;
                    }
                }

                vm.total.valorTotal = total;
                vm.total.quantidade = quantidade;
            }

            vm.consultarTitulo = function (p) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/invoice/titulos/modal/detalhar_titulo/index.html',
                    controller: 'InvoiceTituloDetalheController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                    resolve: {
                        titulo: function () {
                            return p;
                        },
                    }
                }).result.then(function (res) {
                    if (res == 'excluido' || res == 'atualizado') {
                        vm.listar();
                    }
                });
            }

            function setPage(page) {
                if (page < 1 || page > vm.pager.totalPages) {
                    return;
                }
                vm.pager = PagerService.GetPager(vm.registros.length, page);
                vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
            }

            vm.showhide = function (icon, box) {
                var icon = angular.element(document.getElementById(icon));
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                var elm = angular.element(document.getElementById(box));
                elm.slideToggle(200);
            };

            vm.init();

        }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceDigitacaoTituloController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP', 'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP, AuthService)
  {
    var vm = this;
    vm.titulos = [];    
    vm.total = 0;
    

    vm.init = function()
    {
      vm.horarioLimite = AuthService.getHorarioLimite();
      //console.log("hora limite:",vm.horarioLimite)

    }

    vm.validarHorarioLimite = function() 
    {
        // Verificar a hora atual
        var currentTime = new Date();
        var currentHours = currentTime.getHours();
        var currentMinutes = currentTime.getMinutes();

        var horarioEmpresa = parseFloat(vm.horarioLimite.replace(":", "."));
        var currentHourMinute = parseFloat(currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes));
            
        if ( currentHourMinute > horarioEmpresa ) {
            toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
            return false;
        }
        return true;

    }

    vm.validarEPrevenir = function(event) {
        if (!vm.validarHorarioLimite()) {
            event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
            return false;
        }
        else {
          vm.incluirTitulo()
        }
    };     

    vm.incluirTitulo = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/digitacao/cadastro/index.html',
        controller: 'InvoiceDigitacaoTituloCadastroController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          titulos: function () {
            return vm.titulos;
          },
        }
      }).closed.then(function(){
        vm.calcularTotal();
      });
    }

    vm.calcularTotal = function()
    {
      vm.total = 0;

      for (var i=0;i<vm.titulos.length;i++)
      {
        vm.total += vm.titulos[i].valor;
      }
    }

    vm.removerTitulo = function(dup) {
      if (confirm('Deseja realmente excluir?'))
      {
        for (var j = 0; j < vm.titulos.length; j++)
        {
            if (vm.titulos[j].viewId == dup.viewId)
            {
                vm.titulos.splice(j, 1);
            }
        }
        vm.calcularTotal();
      }
    }

    vm.concluir = function() {
      if (vm.titulos.length == null || vm.titulos.length == 0)
      {
          alert('Não existem títulos para o envio.');
          return;
      }

      vm.concluirPromise = $http.post(APP_MNP + "/invoice/tituloManual/registrar", vm.titulos).success(function(response){            
          toastr.info('Títulos cadastrados com sucesso.', 'Alerta');
          vm.titulos = [];
          vm.total = 0;
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceOperacaoController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP)
  {
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status : ''
    }
    vm.lastOrder = '';
    vm.orderSelected = '';

    vm.init = function()
    {        
        vm.listar();
    }

    vm.listar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;

        return $http.get(APP_MNP + "/invoice/operacao/disponiveis")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });        
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataVencimentoAte = vm.filtro.vencimentoAte;

        if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
        {
            dataVencimentoAte = addDays(vm.filtro.vencimentoAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '')
            {
                if (!vm.registrosOriginal[i].fornecedor.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.numeroAntecipacao != null && vm.filtro.numeroAntecipacao != '')
            {
                if (vm.registrosOriginal[i].numero != vm.filtro.numeroAntecipacao)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
            {
                if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '')
            {
                if (dataVencimentoAte < new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }
            
            if (vm.filtro.valorDe != null && vm.filtro.valorDe != '')
            {
                if (vm.filtro.valorDe > vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorAte != null && vm.filtro.valorAte != '')
            {
                if (vm.filtro.valorAte < vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.proposta = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/invoice/antecipacao/modal/proposta.html',
            controller: 'AntecipacaoRealizarPropostaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            vm.listar();
        });
    }

    vm.titulos = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/invoice/antecipacao/modal/consultar_titulos.html',
            controller: 'ConsultarTitulosPropostaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            vm.listar();
        });
    }

    vm.liberarTitulos = function(p)
    {
        var r = confirm("Confirma a liberação dos títulos?");

        if (!r)
        {
            return;
        }

        $http.post(APP_MNP + "/antecipacao/liberartitulos", p).success(function(response){            
            toastr.info('Títulos liberados com sucesso.', 'Alerta');
            vm.listar();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.consultarAnalise = function(p)
    {
        $state.go('index.operacao_analise', {obj: p.viewId});
    }

    vm.consultarNegociacao = function(p)
    {
        $state.go('index.operacao_negociacao', {obj: p.viewId});
    }

    vm.consultarFormalizacao = function(p)
    {
        $state.go('index.operacao_formalizacao', {obj: p.viewId});
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceNfeImportarLoteController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP', 'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP, AuthService)
  {
    var vm = this;
    
    vm.selectedTempFile = [];
    vm.filesSelected = [];
    vm.nfe = [];
    vm.duplicatas = [];

    vm.init = function()
    {
        vm.horarioLimite = AuthService.getHorarioLimite();
        //alert('ok');
    }

    vm.validarHorarioLimite = function() 
    {
        // Verificar a hora atual
        var currentTime = new Date();
        var currentHours = currentTime.getHours();
        var currentMinutes = currentTime.getMinutes();

        var horarioEmpresa = parseFloat(vm.horarioLimite.replace(":", "."));
        var currentHourMinute = parseFloat(currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes));
           
            
        if ( currentHourMinute > horarioEmpresa ) {
            toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
            return false;
        }
        return true;

    }

    vm.validarEPrevenir = function(event) {
        if (!vm.validarHorarioLimite()) {
            event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
            return false;
        }
    };    
        

    vm.adicionarItem = function()
    {
        var nfe = {};
        nfe.Id = vm.fileId++;
        nfe.Nome = vm.selectedTempFile[0].name;
        
        //readAsDataURL        

        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {

            vm.validarPromise = $http.post(APP_MNP + "/invoice/nfe/validarLote", { file : evt.target.result }).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })

        
             //= NfeService.validar(evt.target.result);
            vm.validarPromise.then(function(result) {  
                if (result.data != null)
                {
                    
                    vm.duplicatas = result.data.resultado; 
                    vm.falhas = result.data.falhas;

                    vm.getTotalDuplicatas();

                    /*
                    var nfeAtual = result.data[0].notaFiscal;
                    nfeAtual.TextoXML = nfe.XMLText; 

                    //var existeNfe = vm.nfe.find(x => x.chaveNfe === nfeAtual.chaveNfe);
                    var existeNfe = vm.nfe.filter(function(item) {
                        return item.chaveNfe === nfeAtual.chaveNfe;
                    });

                    if (existeNfe == 0)
                    {
                        if (vm.nfe.length == 0)
                        {
                            vm.nfeInicial = nfeAtual;
                        }
                        else
                        {
                            if (nfeAtual.cedente.cnpj.substring(0, 8) != vm.emitente.cnpj.substring(0, 8))
                            {
                                alert('As notas devem pertencer ao mesmo cedente/emitente.');
                                return;
                            }
                        }

                        vm.nfe = vm.nfe.concat(nfeAtual);
                        vm.emitente = nfeAtual.cedente;
                        vm.duplicatas = vm.duplicatas.concat(result.data); 
                    }
                    else
                    {
                        alert('Nota Fiscal já enviada.');
                    }
                    */
                }
                else
                {
                    toastr.error(result.data.text, 'Nfe');
                }
            });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
    }

    vm.removerTitulo = function(p)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var i = 0; i < vm.duplicatas.length; i++)
            {
                if (vm.duplicatas[i].viewId == p.viewId)
                {
                    vm.duplicatas.splice(i, 1);
                    break;
                }
            }

            vm.getTotalDuplicatas();
        }
    }

    vm.concluir = function()
    {
        if (vm.duplicatas.length == null || vm.duplicatas.length == 0)
        {
            alert('É necessário informar as duplicatas.');
            return;
        }

        var registros = [];

        for (var i = 0; i < vm.duplicatas.length; i++)
        {
            registros.push(vm.duplicatas[i].titulo);
        }

        vm.concluirPromise = $http.post(APP_MNP + "/invoice/titulo/registrar", registros).success(function(response){            
            toastr.info('Títulos válidos enviados para o estoque.', 'Alerta');
            vm.duplicatas = [];
            vm.falhas = [];
            vm.nfe = [];
            vm.emitente = null;
            //$state.go('index.home');
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
    }

    vm.getTotalDuplicatas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            total += duplicata.titulo.valor;
        }
        return total;
    }

    vm.getTotalDuplicatasInvalidas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            if (duplicata.titulo.situacao == 3)
            {
                total++;
            }  
        }
        return total;
    }

    
    vm.openIncluirDuplicata = function()
    {
        /*
        var modalInstance = $uibModal.open({
            templateUrl: 'app/antecipacao/modal/inserir-duplicata.html',
            controller: 'AntecipacaoInserirDuplicataController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
               nfes: function () {
                 return vm.nfe;
               }
             }
         });

         modalInstance.result.then(function(data) {
            if (data.viewId != null && data.numeroTitulo != null && data.numeroTitulo != '')
            {
                vm.duplicatas.push(data);
            }
        })
        */
    }

    vm.removerNfe = function(nfeParam)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var i = 0; i < vm.nfe.length; i++)
            {
                if (vm.nfe[i].viewId == nfeParam.viewId)
                {
                    vm.nfe.splice(i, 1);
                    break;
                }
            }
            
            var tamanho = vm.duplicatas.length;

            for (var j = 0; j < tamanho; j++)
            {
                if (vm.duplicatas[j] != null && vm.duplicatas[j].notaFiscal.viewId == nfeParam.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                    j = 0;
                }
            }

            if (vm.duplicatas.length > 0 && vm.duplicatas[0] != null && vm.duplicatas[0].notaFiscal.viewId == nfeParam.viewId)
            {
                vm.duplicatas.splice(0, 1);
            }

            if (vm.duplicatas.length == 0)
            {
                vm.emitente = null;
            }
        }
    }

    vm.removerDuplicata = function(dup)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var j = 0; j < vm.duplicatas.length; j++)
            {
                if (vm.duplicatas[j].viewId == dup.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                }
            }
        }
    }

    vm.exibirMotivoTitulo = function(t)
    {
        alert(t.titulo.situacaoMotivo);
    }

    vm.novo = function()
    {
        if (confirm('Deseja descartar a importação atual?'))
        {
            vm.duplicatas = [];
            vm.falhas = [];
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceNfeImportarController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP', 'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP, AuthService)
  {
    var vm = this;
    
    vm.selectedTempFile = [];
    vm.filesSelected = [];
    vm.nfe = [];
    vm.duplicatas = [];

    vm.init = function()
    {
        vm.horarioLimite = AuthService.getHorarioLimite();
       
        //alert('ok');
    }

    vm.validarHorarioLimite = function() 
    {
        // Verificar a hora atual
        var currentTime = new Date();
        var currentHours = currentTime.getHours();
        var currentMinutes = currentTime.getMinutes();

        var horarioEmpresa = parseFloat(vm.horarioLimite.replace(":", "."));
        var currentHourMinute = parseFloat(currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes));
            
        if ( currentHourMinute > horarioEmpresa ) {
            toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
            return false;
        }
        return true;

    }

    vm.validarEPrevenir = function(event) {
        if (!vm.validarHorarioLimite()) {
            event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
            return false;
        }
    };    
    
  
    vm.adicionarItem = function()
    {
        var nfe = {};
        nfe.Id = vm.fileId++;
        nfe.Nome = vm.selectedTempFile[0].name;

        vm.validarHorarioLimite()
        
        //readAsDataURL        

        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {

            vm.validarPromise = $http.post(APP_MNP + "/invoice/nfe/validar", { file : evt.target.result }).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })

             //= NfeService.validar(evt.target.result);
            vm.validarPromise.then(function(result) {  
                if (result.data != null)
                {
                    
                    var nfeAtual = result.data[0].notaFiscal;
                    nfeAtual.TextoXML = nfe.XMLText; 

                    //var existeNfe = vm.nfe.find(x => x.chaveNfe === nfeAtual.chaveNfe);
                    var existeNfe = vm.nfe.filter(function(item) {
                        return item.chaveNfe === nfeAtual.chaveNfe;
                    });

                    if (existeNfe == 0)
                    {
                        if (vm.nfe.length == 0)
                        {
                            vm.nfeInicial = nfeAtual;
                        }
                        else
                        {
                            if (nfeAtual.cedente.cnpj.substring(0, 8) != vm.emitente.cnpj.substring(0, 8))
                            {
                                alert('As notas devem pertencer ao mesmo cedente/emitente.');
                                return;
                            }
                        }

                        vm.nfe = vm.nfe.concat(nfeAtual);
                        vm.emitente = nfeAtual.cedente;
                        vm.duplicatas = vm.duplicatas.concat(result.data); 
                    }
                    else
                    {
                        alert('Nota Fiscal já enviada.');
                    }
                }
                else
                {
                    toastr.error(result.data.text, 'Nfe');
                }
            });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
    }

    vm.concluir = function()
    {
        if (vm.duplicatas.length == null || vm.duplicatas.length == 0)
        {
            alert('É necessário informar as duplicatas.');
            return;
        }

        vm.concluirPromise = $http.post(APP_MNP + "/invoice/titulo/registrar", vm.duplicatas).success(function(response){            
            toastr.info('Títulos válidos enviados para o estoque.', 'Alerta');
            vm.duplicatas = [];
            vm.nfe = [];
            vm.emitente = null;
            //$state.go('index.home');
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
    }
    vm.getTotalDuplicatas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            total += duplicata.valor;
        }
        return total;
    }

    vm.getTotalDuplicatasInvalidas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            if (duplicata.situacao == 3)
            {
                total++;
            }  
        }
        return total;
    }

    vm.openIncluirDuplicata = function()
    {
        /*
        var modalInstance = $uibModal.open({
            templateUrl: 'app/antecipacao/modal/inserir-duplicata.html',
            controller: 'AntecipacaoInserirDuplicataController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
               nfes: function () {
                 return vm.nfe;
               }
             }
         });

         modalInstance.result.then(function(data) {
            if (data.viewId != null && data.numeroTitulo != null && data.numeroTitulo != '')
            {
                vm.duplicatas.push(data);
            }
        })
        */
    }

    vm.removerNfe = function(nfeParam)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var i = 0; i < vm.nfe.length; i++)
            {
                if (vm.nfe[i].viewId == nfeParam.viewId)
                {
                    vm.nfe.splice(i, 1);
                    break;
                }
            }
            
            var tamanho = vm.duplicatas.length;

            for (var j = 0; j < tamanho; j++)
            {
                if (vm.duplicatas[j] != null && vm.duplicatas[j].notaFiscal.viewId == nfeParam.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                    j = 0;
                }
            }

            if (vm.duplicatas.length > 0 && vm.duplicatas[0] != null && vm.duplicatas[0].notaFiscal.viewId == nfeParam.viewId)
            {
                vm.duplicatas.splice(0, 1);
            }

            if (vm.duplicatas.length == 0)
            {
                vm.emitente = null;
            }
        }
    }

    vm.removerDuplicata = function(dup)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var j = 0; j < vm.duplicatas.length; j++)
            {
                if (vm.duplicatas[j].viewId == dup.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                }
            }
        }
    }

    vm.exibirMotivoTitulo = function(t)
    {
        alert(t.situacaoMotivo);
    }

    vm.init();

  }]);
'use strict';

// Fluxo real (definido em reunião 2026-08-28/2026-08-31): upload do CNAB original -> enviado à AssinaNet de
// forma ASSÍNCRONA (por enquanto a chamada real ainda é um stub no backend) -> arquivo listado no droplist de
// pendentes (IsNegociado=false) -> botão "Consultar" tenta até 6 vezes / 30s -> ao voltar o arquivo tratado,
// cada registro de linha "L" (NFe após "N" + duplicata após "D") é casado com um título JÁ EXISTENTE no
// estoque do cedente — esses títulos não são criados de novo, só localizados — e podem ser enviados direto
// para antecipação (reaproveitando o mesmo endpoint /invoice/antecipacao/antecipar que a tela de Estoque de
// Títulos já usa), o que já os remove do estoque automaticamente.
angular.module('inspinia')
  .controller('InvoiceCnabSincronizadoController', ['$scope', '$timeout', 'toastr', '$http', 'APP_MNP',
      function($scope, $timeout, toastr, $http, APP_MNP)
  {
    var vm = this;
    vm.isUploading = false;
    vm.isLoading = false;
    vm.selectedTempFile = null;

    vm.pendentes = [];
    vm.arquivoSelecionadoId = null;
    vm.isConsultando = false;
    vm.tentativaAtual = 0;
    vm.maxTentativas = 6;
    vm.intervaloTentativaMs = 30000;
    vm.falhaSincronia = false;
    vm.ASSINANET_LOGIN_URL = 'https://www.assina.net.br/administrativo/Login';

    vm.titulosEncontrados = [];
    vm.titulosNaoEncontrados = [];

    vm.init = function() {
      vm.carregarPendentes();
    };

    vm.carregarPendentes = function() {
      $http.get(APP_MNP + "/cnab/sincronizado/pendentes")
        .success(function(response) {
          vm.pendentes = response || [];
        })
        .error(function() {
          vm.pendentes = [];
        });
    };

    vm.totalValor = function() {
      return vm.titulosEncontrados.reduce(function(acc, t) { return acc + (t.valor || 0); }, 0);
    };

    vm.onArquivoSelecionado = function() {
      if (!vm.selectedTempFile || !vm.selectedTempFile[0]) return;

      var file = vm.selectedTempFile[0];
      var formData = new FormData();
      formData.append('arquivo', file);

      vm.isUploading = true;
      vm.enviarPromise = $http.post(APP_MNP + "/cnab/upload-sincronizado", formData, {
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      }).success(function(response) {
        toastr.info(response.mensagem || 'Arquivo enviado. Aguardando processamento.', 'Cnab Sincronizado');
        vm.isUploading = false;
        vm.selectedTempFile = null;
        vm.carregarPendentes();
        vm.arquivoSelecionadoId = response.id;
        vm.falhaSincronia = false;
      }).error(function(error) {
        toastr.error((error && error.mensagem) || error || 'Erro ao enviar arquivo CNAB.', 'Erro', { allowHtml: true });
        vm.isUploading = false;
        vm.selectedTempFile = null;
      });
    };

    vm.onSelecionarPendente = function() {
      vm.falhaSincronia = false;
    };

    vm.consultar = function() {
      if (!vm.arquivoSelecionadoId) return;

      vm.isConsultando = true;
      vm.falhaSincronia = false;
      vm.tentativaAtual = 0;

      vm.tentarConsulta();
    };

    vm.tentarConsulta = function() {
      vm.tentativaAtual = vm.tentativaAtual + 1;

      $http.post(APP_MNP + "/cnab/sincronizado/consultar/" + vm.arquivoSelecionadoId, {})
        .success(function(status) {
          if (status.status === 'Processado' && status.arquivoProcessadoBase64) {
            vm.processarArquivoRetornado(status.arquivoProcessadoBase64);
            vm.isConsultando = false;
            return;
          }

          if (status.status === 'Erro') {
            toastr.error(status.mensagem || 'Erro ao processar o CNAB na AssinaNet.', 'AssinaNet');
            vm.isConsultando = false;
            vm.falhaSincronia = true;
            return;
          }

          vm.agendarProximaTentativa();
        })
        .error(function() {
          // erro de comunicação com a nossa própria API — trata como mais uma tentativa "aguardando"
          vm.agendarProximaTentativa();
        });
    };

    vm.agendarProximaTentativa = function() {
      if (vm.tentativaAtual >= vm.maxTentativas) {
        vm.isConsultando = false;
        vm.falhaSincronia = true;
        return;
      }

      $timeout(function() {
        vm.tentarConsulta();
      }, vm.intervaloTentativaMs);
    };

    vm.processarArquivoRetornado = function(base64) {
      var dataUrl = 'data:text/plain;base64,' + base64;

      vm.validarPromise = $http.post(APP_MNP + "/cnab/sincronizado/associar", { file: dataUrl })
        .success(function(response) {
          vm.titulosEncontrados = response.encontrados || [];
          vm.titulosNaoEncontrados = response.naoEncontrados || [];

          if (vm.titulosEncontrados.length === 0) {
            toastr.warning('Nenhum título do arquivo foi localizado no estoque.', 'Cnab Sincronizado');
          } else {
            toastr.success(vm.titulosEncontrados.length + ' título(s) localizado(s) no estoque.', 'Cnab Sincronizado');
          }
        })
        .error(function(error) {
          toastr.error((error && error.message) || error || 'Erro ao associar títulos do arquivo tratado.', 'Erro de Processamento', { allowHtml: true });
        });
    };

    vm.limparResultado = function() {
      vm.titulosEncontrados = [];
      vm.titulosNaoEncontrados = [];
    };

    vm.antecipar = function() {
      if (vm.titulosEncontrados.length === 0) return;

      if (vm.titulosEncontrados[0].codigoVmoney === '' || vm.titulosEncontrados[0].codigoVmoney == null) {
        toastr.error('Cedente não possui Código do Vmoney. Solicite ao administrador que o insira antes de continuar.', 'Ação Bloqueada');
        return;
      }

      var idSincronizado = vm.arquivoSelecionadoId;

      // O preview (sincronizado/associar) nunca grava nada — só agora que o usuário aceitou é que os
      // números/valor/vencimento corrigidos pelo CNAB são persistidos no título, antes de seguir para
      // a antecipação propriamente dita.
      var correcoes = vm.titulosEncontrados.map(function(t) {
        return {
          viewId: t.viewId,
          numero: t.titulo,
          numeroNfe: t.numero,
          valor: t.valor,
          dataVencimento: t.dataVencimentoDate
        };
      });

      vm.isLoading = true;
      vm.anteciparPromise = $http.post(APP_MNP + "/cnab/sincronizado/aplicarcorrecoes", correcoes)
        .success(function() {
          $http.post(APP_MNP + "/invoice/antecipacao/antecipar", { itens: vm.titulosEncontrados })
            .success(function() {
              toastr.success(vm.titulosEncontrados.length + ' título(s) enviado(s) para antecipação!', 'Sucesso');
              vm.limparResultado();
              vm.isLoading = false;

              if (idSincronizado) {
                $http.post(APP_MNP + "/cnab/sincronizado/marcarnegociado/" + idSincronizado, {})
                  .success(function() {
                    vm.arquivoSelecionadoId = null;
                    vm.carregarPendentes();
                  })
                  .error(function() {
                    vm.carregarPendentes();
                  });
              }
            })
            .error(function(error) {
              toastr.error(error, 'Erro ao enviar títulos para antecipação.', { allowHtml: true });
              vm.isLoading = false;
            });
        })
        .error(function(error) {
          toastr.error(error, 'Erro ao gravar as correções do CNAB nos títulos.', { allowHtml: true });
          vm.isLoading = false;
        });
    };

    vm.init();
  }]);

'use strict';

angular.module('inspinia')
  .controller('InvoiceFluxoAprovacaoController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP)
  {
    var vm = this;
    vm.registros = null;

    vm.init = function()
    {        
        vm.listar();
    }

    vm.consultar = function(operacao) 
    {
        $state.go('index.operacao_fluxo_analise', {obj: operacao.antecipacaoFluxoAprovacao.viewId});
    }

    vm.listar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;

        return $http.get(APP_MNP + "/antecipacaoFluxo/operacoes")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
        });        
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAnaliseController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP', 'PagerService', '$timeout', '$sce',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP, PagerService, $timeout, $sce)
  {
    var vm = this;
    vm.antecipacaoViewId = $state.params.obj || null;
    vm.analise = null;
    vm.isReadOnly = false;
    vm.pareceres = [];
    vm.pareceresCount = 0;
    vm.novoParecer = '';
    vm.isSavingParecer = false;
    vm.vaduAnalise = null;
    vm.analiseVaduErro = null;
    vm.vaduGruposAnalise = [];
    vm.vaduGrupoAnalise = null;
    vm.vaduPreSacados = [];
    vm.vaduSacadosSelecionado = true;
    vm.exibirVadu = true;
    vm.aprovadoTotal = 0;
    vm.aprovadoQtde = 0;
    vm.sacadoQtde = 0;
    vm.aprovadoSacadoQtde = 0;
    vm.aprovadoNfeQtde = 0;
    vm.aprovadoTituloQtde = 0;

   
    vm.selTodosTitulos = false;
    vm.selTodasOcorrencias = true;
    vm.selTodosSacados = true;    
    vm.categoriasSelecionadas = [];
    vm.ocorrenciasSelecionadas = [];
    vm.categorias = [];
    vm.ocorrencias = [];
    vm.listaSacados = []; // Inicializa listaSacados como um array vazio
    vm.selecionarTodasOcorrencias = [];
    vm.boxTitulosVisible = true; // Inicialmente visível

    vm.itemsPerPage = 10; // Define o número de itens por página
    vm.currentPage = 1; // Página inicial
    vm.paginatedTitulos = []; // Lista de títulos paginados

    // Atualiza a lista de títulos paginados com base nos títulos visíveis
    vm.updatePagination = function() {
        if (!vm.analise || !vm.analise.titulos) {
            vm.paginatedTitulos = [];
            return;
        }
        var titulosVisiveis = vm.analise.titulos.filter(function(titulo) {
            return titulo.visivel !== false;
        });
        var start = (vm.currentPage - 1) * vm.itemsPerPage;
        var end = start + vm.itemsPerPage;
        vm.paginatedTitulos = titulosVisiveis.slice(start, end);
    };

    // Monitora mudanças na página atual para atualizar a paginação
    $scope.$watch('vm.currentPage', function() {
        vm.updatePagination();
    });

    vm.temSacadosSelecionados = function() {
      return vm.listaSacados && vm.listaSacados.some(function(sacado) {
        return sacado.selecionado;
      });
    };

    vm.init = function() {
      vm.consultarOperacao();
      vm.vaduConsultarAnalise();
    };


    vm.consultarOperacao = function() {
      vm.consultaOperacao = $http.get(APP_MNP + "/analiseoperacao/consultar/" + vm.antecipacaoViewId)
      .success(function(response)
      {
        vm.analise = response;
        vm.isReadOnly = response.isReadOnly || false;
        console.log('operação: ', vm.analise);
        console.log('Modo visualização (isReadOnly):', vm.isReadOnly);

        // Certifique-se que o limiteConcBordero está disponível
        console.log('Limite Concentração Borderô:', vm.analise.limiteConcBordero);


        vm.carregarTitulos();
        vm.coletarOcorrencias();
        vm.carregarSacados();
        vm.consultarPareceres();

      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      }); 
    }

   
    // Função para coletar as ocorrências de todos os títulos
    vm.coletarOcorrencias = function() {
      // Iterar sobre os títulos e coletar as ocorrências
      vm.listaOcorrencias = [];
      vm.ocorrenciasPorTitulo = {};

      //Ocorrencias do Painel
      vm.cedenteTotal = 0;
      vm.cedenteInformativos = 0;
      vm.cedenteCriticos = 0;

      vm.sacadoTotal = 0;
      vm.sacadoInformativos = 0;
      vm.sacadoCriticos = 0;

      vm.pocTotal = 0; 
      vm.pocInformativos = 0; 
      vm.pocCriticos = 0;

      vm.titulosTotal = 0;
      vm.titulosInformativos = 0; 
      vm.titulosCriticos = 0;
      // fim das ocorrencias do Painel

      // Cria conjuntos globais para rastrear os códigos de erro únicos
      var errosCedenteContabilizados = new Set();
      var errosSacadosContabilizados = new Set();
      var errosPocContabilizados = new Set();
      var errosTitulosContabilizados = new Set();

      vm.analise.titulos.forEach(function(titulo) {
        titulo.erros.forEach(function(erro) {
          // Verifica se a ocorrência já foi adicionada
          var ocorrenciaAdicionada = false;
          for (var k = 0; k < vm.listaOcorrencias.length; k++) {
            if (vm.listaOcorrencias[k].codigoErroVmoney === erro.codigoErroVmoney) {
              ocorrenciaAdicionada = true;
              break;
            }
          }
          if (!ocorrenciaAdicionada) {
            vm.listaOcorrencias.push({
              codigoErroVmoney: erro.codigoErroVmoney,
              descricao: erro.descricao,
              selecionado: false, // Inicializa como false
              origem: erro.origem || 0, // Garante que o campo origem seja definido
              categoria: erro.categoria || 0, // Garante que o campo categoria seja definido
              quantidadeTitulos: 0, // Contador de títulos relacionados a essa ocorrência
              criticidade: erro.criticidade || 'N'
              
            });
          }
          //console.log('Ocorrências adicionadas:', erro.codigoErroVmoney, erro.descricao, erro.categoria, erro.origem);
          // Contabiliza quantos títulos estão relacionados a cada ocorrência
          var ocorrencia = null;
          for (var k = 0; k < vm.listaOcorrencias.length; k++) {
            if (vm.listaOcorrencias[k].codigoErroVmoney === erro.codigoErroVmoney) {
              ocorrencia = vm.listaOcorrencias[k];
              break;
            }
          }
          if (ocorrencia) {
            ocorrencia.quantidadeTitulos++;
          }

            // Contabiliza os erros do Cedente
            if (erro.categoria === 1) {
              vm.contabilizarErroCedente(erro, titulo, errosCedenteContabilizados);
          }

          // Contabiliza os erros do Sacado
          if (erro.categoria === 2) {
              vm.contabilizarErroSacado(erro, titulo, errosSacadosContabilizados);
          }


          // Soma as ocorrências de POC que pertencem à lista de títulos
          if (erro.categoria === 6 && !errosPocContabilizados.has(erro.codigoErroVmoney)) {
            errosPocContabilizados.add(erro.codigoErroVmoney); // Marca o erro como contabilizado globalmente
            vm.pocTotal++;
            if(erro.criticidade != 'S') { vm.pocInformativos++;} 
            if(erro.criticidade == 'S') { vm.pocCriticos++;}  
          
          }

          // Soma as ocorrências de Títulos que pertencem à lista de títulos
          if (erro.categoria >= 3 &&  erro.categoria <= 5 && !errosTitulosContabilizados.has(erro.codigoErroVmoney)) {
            errosTitulosContabilizados.add(erro.codigoErroVmoney); // Marca o erro como contabilizado globalmente
           // console.log('Ocorrências Titulo:', erro.codigoErroVmoney, erro.descricao, erro.categoria, erro.origem,"critico:", erro.criticidade);
            vm.titulosTotal++;
            if(erro.criticidade != 'S') {vm.titulosInformativos++;} 
            if(erro.criticidade == 'S') {vm.titulosCriticos++;} 

          }
     

          // Armazena as ocorrências de cada título
          if (!vm.ocorrenciasPorTitulo[titulo.numero]) {
            vm.ocorrenciasPorTitulo[titulo.numero] = [];
          }
          vm.ocorrenciasPorTitulo[titulo.numero].push(erro.codigoErroVmoney);
        });
      });

      // Atualiza o estado inicial das ocorrências com base na quantidade
      vm.listaOcorrencias.forEach(function(ocorrencia) {
        ocorrencia.selecionado = ocorrencia.quantidadeTitulos > 0;
      });

      // Adiciona a ocorrência "TÍTULOS SEM OCORRÊNCIA" se houver títulos sem ocorrências
      var titulosSemOcorrencia = vm.analise.titulos.filter(function(titulo) {
        return titulo.erros.length === 0;
      }).length;
      if (titulosSemOcorrencia > 0) {
        vm.listaOcorrencias.push({
          codigoErroVmoney: 'SEM_OCORRENCIA',
          descricao: 'TÍTULOS SEM OCORRÊNCIA',
          selecionado: true,
          origem: 99, // Define a origem como 99 para títulos sem ocorrência
          quantidadeTitulos: titulosSemOcorrencia
        });
      }

      // Adiciona a ocorrência "TÍTULOS LIBERADOS" se houver títulos liberados
      var titulosLiberados = vm.analise.titulos.filter(function(titulo) {
        return !titulo.recusado;
      }).length;
      if (titulosLiberados > 0) {
        vm.listaOcorrencias.push({
          codigoErroVmoney: 'LIBERADOS',
          descricao: 'TÍTULOS LIBERADOS',
          selecionado: true,
          origem: 99, // Define a origem como 99 para títulos sem ocorrência
          quantidadeTitulos: titulosLiberados
        });
      }

      // Adiciona a ocorrência "TÍTULOS RECUSADOS" se houver títulos recusados
      var titulosRecusados = vm.analise.titulos.filter(function(titulo) {
        return titulo.recusado;
      }).length;
      if (titulosRecusados > 0) {
        vm.listaOcorrencias.push({
          codigoErroVmoney: 'RECUSADOS',
          descricao: 'TÍTULOS RECUSADOS',
          selecionado: true,
          origem: 99, // Define a origem como 99 para títulos sem ocorrência
          quantidadeTitulos: titulosRecusados
        });
      }
    };

    // Função para contabilizar erros únicos do Cedente
    vm.contabilizarErroCedente = function(erro, titulo, errosContabilizados) {
      if (!errosContabilizados.has(erro.codigoErroVmoney)) {
          errosContabilizados.add(erro.codigoErroVmoney); // Marca o erro como contabilizado globalmente
          //console.log('Ocorrências Cedente:', erro.codigoErroVmoney, erro.descricao, erro.categoria, erro.origem,"critico:", erro.criticidade);
          vm.cedenteTotal++;
          if (erro.criticidade !== 'S') {
              vm.cedenteInformativos++; // Incrementa os informativos
          }
          if (erro.criticidade === 'S') {
              vm.cedenteCriticos++; // Incrementa os críticos
          }
      }
    };    

    // Função para contabilizar erros únicos de sacados
    vm.contabilizarErroSacado = function(erro, titulo, errosContabilizados) {
      var sacadoRelacionado = vm.listaSacados.find(function(sacado) {
          return sacado.descricao === titulo.nomeSacado;
      });
      

      if (sacadoRelacionado && !errosContabilizados.has(erro.codigoErroVmoney)) {
          errosContabilizados.add(erro.codigoErroVmoney); // Marca o erro como contabilizado globalmente
          vm.sacadoTotal++;
          if(erro.criticidade != 'S') { vm.sacadoInformativos++;} 
          if(erro.criticidade == 'S') { vm.sacadoCriticos++;}  
         
      }
    };


    vm.adicionarOcorrencia = function(isCedente) {
     // console.log('Lista ocorrências.', vm.listaOcorrencias);
     // console.log('Modal Passei adicionarOcorrencia.');

      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/analise/detalhe/ocorrencia/index.html',
        controller: 'InvoiceAnaliseOcorrenciaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
      
        resolve: {
          erros: function () {
            // Passa os erros com o campo origem
            return angular.copy(vm.listaOcorrencias.map(function(erro) {
              return {
                id: erro.id,
                descricao: erro.descricao,
                codigoErroVmoney: erro.codigoErroVmoney,
                origem: erro.origem || 0, // Garante que o campo origem seja definido
                nivel: erro.nivel || 0
              };
            })) || [];
          },
          filtrarPorCategoria: function () {
            return true; // Aplica o filtro de categoria
          },
          categoriaFiltro: function () {
            return isCedente ? 1 : 2; // Define a categoria do filtro: 1 para Cedente, 2 para Sacado
          },
          tituloModal: function () {
            return isCedente ? 'Ocorrências do Cedente' : 'Ocorrências do Sacado'; // Define o título da modal
          },

          tituloIds: function () {
            var tituloIds = [];
            if (isCedente) {
                // Para Cedente, pega todos os títulos relacionados ao Cedente
                if (vm.analise.titulos && vm.analise.titulos.length > 0) {
                    vm.analise.titulos.forEach(function(titulo) {
                        tituloIds.push(titulo.tituloId);
                    });
                }
            } else {
                // Para Sacado, pega os títulos relacionados aos Sacados selecionados
                var sacadosSelecionados = vm.listaSacados.filter(function(sacado) {
                    return sacado.selecionado;
                });
                if (sacadosSelecionados.length > 0) {
                    sacadosSelecionados.forEach(function(sacado) {
                        vm.analise.titulos.forEach(function(titulo) {
                            if (titulo.nomeSacado === sacado.descricao) {
                                tituloIds.push(titulo.tituloId);
                            }
                        });
                    });
                }
            }
            return tituloIds.length > 0 ? tituloIds : null; // Retorna null se não houver títulos
          },
        
          antecipacaoId: function () {
            return vm.analise.antecipacaoId || null; // Passa o AntecipacaoId para o modal
          },
          origemTela: function () {
            return isCedente ? 'tela_cedente' : 'tela_analise'; // Define a origem: "tela_cedente" para Cedente, "tela_analise" para Sacado
          },
          titulo: function () {
            return { erros: angular.copy(vm.listaOcorrencias) }; // Passa os erros como parte do título
          }
        }
      });
    
      modalInstance.result.then(function(novasOcorrencias) {
       // console.log('Modal Passei modalInstance.result.');
        if (novasOcorrencias && novasOcorrencias.length > 0) {
          if (isCedente) {
            // Atualiza os erros de todos os títulos do Cedente
            vm.analise.titulos.forEach(function(titulo) {
              novasOcorrencias.forEach(function(ocorrencia) {
                var jaExiste = titulo.erros.some(function(erro) {
                  return erro.codigoErroVmoney === ocorrencia.codigoErroVmoney;
                });
                if (!jaExiste) {
                  titulo.erros.push(ocorrencia);
                }
              });
    
              // Atualiza o campo descricaolinha
              titulo.descricaolinha = titulo.erros.map(function(erro) {
                return erro.descricao;
              }).join(', ');
            });
    
            toastr.success('Ocorrências adicionadas com sucesso aos títulos do Cedente!', 'Sucesso');
          } else {
            // Atualiza os erros de todos os títulos do Sacado selecionado
            vm.listaSacados.filter(function(sacado) {
              return sacado.selecionado;
            }).forEach(function(sacado) {
              vm.analise.titulos.forEach(function(titulo) {
                if (titulo.nomeSacado === sacado.descricao) {
                  novasOcorrencias.forEach(function(ocorrencia) {
                    var jaExiste = titulo.erros.some(function(erro) {
                      return erro.codigoErroVmoney === ocorrencia.codigoErroVmoney;
                    });
                    if (!jaExiste) {
                      titulo.erros.push(ocorrencia);
                    }
                  });
    
                  // Atualiza o campo descricaolinha
                  titulo.descricaolinha = titulo.erros.map(function(erro) {
                    return erro.descricao;
                  }).join(', ');
                }
              });
            });
    
            toastr.success('Ocorrências adicionadas com sucesso aos títulos do Sacado!', 'Sucesso');
          }
    
          // Atualiza a lista de ocorrências
          vm.coletarOcorrencias();
        }
      }, function() {
        console.log('Modal fechado sem salvar.');
      });
    };
    
    vm.getCriticidadeClass = function(erros) {
      if (erros.some(function(e) { return e.criticidade === 'S'; })) {
          return 'text-danger'; // Classe para criticidade 'S'
      }
      return 'text-brown'; // Classe padrão
   };    

    vm.carregarTitulos = function() {
    vm.aprovadoTotal = 0;
    vm.aprovadoTituloQtde = 0;
    vm.nFeQtde = 0;
    vm.aprovadoNFeQtde = 0;

    var ocorrenciasMap = {};  // Mapeamento para contar ocorrências
    var nfeSet = new Set(); // Conjunto para rastrear NF-es únicas
    var aprovadoNfeSet = new Set(); // Conjunto para rastrear NF-es únicas de títulos selecionados

    for (var i = 0; i < vm.analise.titulos.length; i++) {
        // Atualizando o estado do checkbox com base na situação do título
        vm.analise.titulos[i].selecionado = !vm.analise.titulos[i].recusado;
        vm.sacadoQtde = vm.sacadoQtde + 1;

        var descricaolinha = '';
        for (var j = 0; j < vm.analise.titulos[i].erros.length; j++) {
            // ... lógica para descrever erros ...
        }
        vm.analise.titulos[i].descricaolinha = descricaolinha;
    }

    // Atualizar a lista de ocorrências
    vm.coletarOcorrencias();

    // Após carregar os títulos, popula a lista de sacados
    vm.carregarSacados();

    // Atualiza a paginação
    vm.updatePagination();
}

vm.calcularTotalNFe = function() {
    if (!vm.vaduAnalise || !vm.vaduAnalise.analiseSacados) {
        return 0;
    }
    return vm.vaduAnalise.analiseSacados.reduce(function(total, sacado) {
        return total + (sacado.qtdNfe || 0);
    }, 0);
};


vm.calcularTotalNFeAnalise = function() {
    // Retorna objeto com contagens: total, alerta, bloqueio
    if (!vm.vaduAnalise || !vm.vaduAnalise.analiseTitulos) {
        return { total: 0, alerta: 0, bloqueio: 0 };
    }

    var todas = {};      // todas chaves distintas
    var alertaMap = {};  // chaves com alerta
    var bloqueioMap = {}; // chaves com bloqueio

    vm.vaduAnalise.analiseTitulos.forEach(function(titulo) {
        var chave = titulo.titChaveNfe || titulo.chave_nfe;
        if (!chave) return;
        chave = String(chave).trim();
        if (!chave) return;

        todas[chave] = true;

        // detecta bloqueio / alerta em possíveis campos (ajuste se seus campos forem outros)
        var isBloqueio = !!(titulo.bortitChaveBloqueio || titulo.titNfeBloqueio || titulo.nfeBloqueio || titulo.bortitBloqueio);
        var isAlerta   = !!(titulo.bortitChaveAlerta   || titulo.titNfeAlerta   || titulo.nfeAlerta   || titulo.bortitAlerta);

        // se existir flag de nível por log do título (ex.: erros com criticidade), considere também:
        if (!isBloqueio && titulo.erros && titulo.erros.some(function(e){ return e.codigoErroVmoney && e.criticidade === 'S' && (e.origem===4 || e.origem===5); })) {
            // heurística: erros críticos originados da NFe -> tratar como bloqueio (ajuste conforme sua origem)
            isBloqueio = true;
        }

        if (isBloqueio) {
            bloqueioMap[chave] = true;
            // prioridade: bloqueio > alerta
            delete alertaMap[chave];
        } else if (isAlerta) {
            alertaMap[chave] = true;
        }
    });

    return {
        total: Object.keys(todas).length,
        alerta: Object.keys(alertaMap).length,
        bloqueio: Object.keys(bloqueioMap).length
    };
};




    vm.carregarSacados = function() {
      vm.listaSacados = []; // Inicializa a lista
      vm.sacadoQtde = 0; // Inicializa a soma da quantidade de sacados
  
      angular.forEach(vm.analise.titulos, function(titulo) {
          var sacadoExistente = vm.listaSacados.find(function(s) {
              return s.descricao === titulo.nomeSacado;
          });
  
          if (sacadoExistente) {
              // Se o sacado já está na lista, apenas incrementa os valores
              sacadoExistente.quantidadeTitulos++;
              sacadoExistente.valor += titulo.valor;
          } else {
              // Se o sacado ainda não foi adicionado, cria um novo item na lista
              vm.listaSacados.push({
                  descricao: titulo.nomeSacado,
                  quantidadeTitulos: 1,
                  valor: titulo.valor,
                  dataCadastro: titulo.dataCadastroSacado, // Adiciona a data de cadastro para comparação
                  selecionado: true
              });
          }
      });
  
      // Calcula a soma da quantidade de sacados
      vm.sacadoQtde = vm.listaSacados.length;
  
      // Verifica se há sacados com DataCadastro igual a DataAntecipacao
      var sacadosNovos = vm.listaSacados.filter(function(sacado) {

        if (!sacado.dataCadastro || !vm.analise.dataAntecipacao) return false;
    
        // Formata a dataAntecipacao no formato brasileiro
        var dataAntecipacaoFormatada = formatarDataBrasileira(vm.analise.dataAntecipacao);

        // Compara as datas formatadas
        return sacado.dataCadastro === dataAntecipacaoFormatada;
      });
  
      if (sacadosNovos.length > 0) {
          // Adiciona o registro "SACADO NOVO" na lista de sacados
          vm.listaSacados.push({
              descricao: 'SACADO NOVO',
              quantidadeTitulos: sacadosNovos.length,
              valor: sacadosNovos.reduce(function(total, sacado) {
                  return total + sacado.valor;
              }, 0), // Soma os valores dos sacados novos
              selecionado: true
          });
      }
  
  
      // Ordena a lista por nome do sacado
      vm.listaSacados.sort(function(a, b) {
          return a.descricao.localeCompare(b.descricao);
      });
   };

    
    vm.atualizarListaSacados = function() {
      var sacadosExistentes = vm.vaduPreSacadosOriginais || []; // Usa os dados originais da API
      //console.log('sacadosExistentes:', sacadosExistentes);
      vm.vaduPreSacados = []; // Reinicia a lista de sacados
      vm.aprovadoSacadoQtde = 0; // Reinicia a contagem de sacados aprovados
  
      if (!vm.analise || !vm.analise.titulos) {
          return;
      }
  
      // Filtra os títulos selecionados
      var titulosSelecionados = vm.analise.titulos.filter(function(titulo) {
          return titulo.selecionado;
      });
  
      // Adiciona os sacados relacionados aos títulos selecionados
      titulosSelecionados.forEach(function(titulo) {
          var sacadoExistente = vm.vaduPreSacados.find(function(sacado) {
              return sacado.razaoSocial === titulo.nomeSacado;
          });
  
          if (sacadoExistente) {
              // Se o sacado já existe, soma o valor do título ao total
              sacadoExistente.totalTitulos += titulo.valor;
          } else {
              // Busca o sacado nos dados carregados pela API
              var sacadoDaApi = sacadosExistentes.find(function(sacado) {
                  return sacado.razaoSocial === titulo.nomeSacado;
              });
  
              // Se o sacado existe na API, preserva os dados, incluindo dataUltimaConsultaVadu
              if (sacadoDaApi) {
                  vm.vaduPreSacados.push({
                      
                      viewId: sacadoDaApi.viewId,

                      razaoSocial: sacadoDaApi.razaoSocial,
                      cnpj: sacadoDaApi.cnpj,
                      totalTitulos: titulo.valor,
                      consulta: sacadoDaApi.consulta || '', // Preserva a consulta
                      dataUltimaConsultaVadu: sacadoDaApi.dataUltimaConsultaVadu || null, // Preserva a data
                      selecionado: true
                  });
              } else {
                  // Se o sacado não existe na API, adiciona com os dados do título
                  vm.vaduPreSacados.push({
                      
                      viewId: titulo.sacadoViewId,

                      razaoSocial: titulo.nomeSacado,
                      cnpj: titulo.cnpjSacado,
                      totalTitulos: titulo.valor,
                      consulta: '', // Inicializa a coluna Consulta como vazia
                      dataUltimaConsultaVadu: '', // Sem dados da API
                      selecionado: true
                  });
              }
          }
      });
  
      // Verifica se algum sacado é "SACADO NOVO" e atualiza a coluna Consulta
      vm.vaduPreSacados.forEach(function(sacado) {
          var tituloRelacionado = titulosSelecionados.find(function(titulo) {
              return titulo.nomeSacado === sacado.razaoSocial;
          });
  
          if (tituloRelacionado && tituloRelacionado.dataCadastroSacado && vm.analise.dataAntecipacao) {
              // Formata a data de antecipação no formato brasileiro
              var dataAntecipacaoFormatada = formatarDataBrasileira(vm.analise.dataAntecipacao);
  
              // Compara as datas e atualiza a coluna Consulta
              if (tituloRelacionado.dataCadastroSacado === dataAntecipacaoFormatada) {
                  sacado.consulta = 'NOVO';
              }
          }
      });
  };

    function formatarDataBrasileira(data) {
      if (!data) return null; // Retorna null se a data for inválida
      var dateObj = new Date(data);
      if (isNaN(dateObj)) return null; // Retorna null se a data não for válida
      var dia = String(dateObj.getDate()).padStart(2, '0');
      var mes = String(dateObj.getMonth() + 1).padStart(2, '0'); // Mês começa em 0
      var ano = dateObj.getFullYear();
      return dia + '/' + mes + '/' + ano;
  }

    vm.filtrarTitulos = function() {
      if (vm.categoriasSelecionadas.length === 0) {
        return vm.analise.titulos;
      } else {
        return vm.analise.titulos.filter(function(titulo) {
          return titulo.erros.some(function(erro) {
            return vm.categoriasSelecionadas.includes(erro.categoria);
          });
        });
      }
    }

    vm.aprovarAnalise = function() {
      var operacao = {
        antecipacaoId: vm.analise.antecipacaoId,
        antecipacaoViewId: vm.analise.antecipacaoViewId,
        integracaoId: vm.analise.integracaoId,
        dataAntecipacao: vm.analise.dataAntecipacao,
        valorFace: vm.analise.valorFace,
        cedenteId: vm.analise.cedenteId,
        cedenteNome: vm.analise.cedenteNome,
        cedenteCnpj: vm.analise.cedenteCnpj,
        titulos: vm.analise.titulos,
      };

      vm.aprovarAnalisePromise = $http.post(APP_MNP + "/analiseoperacao/finalizar", operacao).success(function(response){
        toastr.info('Operação enviada com sucesso.', 'Alerta');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento', {allowHtml: true});
        return error;
      });
    }

   // vm.selecionarTodosTitulos = function() {
   //   var selecionar = vm.selTodosTitulos;
//
   // // Itera sobre os títulos para aplicar a lógica de seleção individualmente
   // vm.analise.titulos.forEach(function(titulo) {
   //   var possuiErroCritico = titulo.erros.some(function(erro) {
   //       return erro.criticidade === 'S';
   //   });
//
   //   if (possuiErroCritico) {
   //       // Exibe mensagem de erro para títulos com erros críticos
   //       toastr.error('Títulos com erros críticos não podem ser selecionados.', 'Atenção');
   //       titulo.selecionado = false; // Garante que o título com erro crítico não seja selecionado
   //   } else if (!selecionar && titulo.erros.length === 0) {
   //       // Exibe mensagem de alerta para títulos sem ocorrências
   //       toastr.warning('Para recusar, é necessário informar uma ocorrência de recusa.', 'Atenção');
   //       titulo.selecionado = true; // Mantém o título como selecionado
   //   } else {
   //       // Seleciona ou desmarca o título normalmente
   //       titulo.selecionado = selecionar;
   //       titulo.recusado = !selecionar;
   //   }
   //  });
   //   vm.carregarTitulos();
   // }
   vm.selecionarTodosTitulos = function() {
    var selecionar = vm.selTodosTitulos;
    var temErroCritico = false;
    var temTituloSemOcorrencia = false;

    // Primeiro verifica se há títulos com erros críticos ou sem ocorrências
    vm.analise.titulos.forEach(function(titulo) {
      if (titulo.erros.some(function(erro) { return erro.criticidade === 'S'; })) {
        temErroCritico = true;
      } else if (!selecionar && titulo.erros.length === 0) {
        temTituloSemOcorrencia = true;
      }
    });

    // Exibe as mensagens apenas uma vez, se necessário
    if (temErroCritico) {
      toastr.error('Existem títulos com erros críticos que não podem ser selecionados.', 'Atenção');
    }
    if (temTituloSemOcorrencia) {
      toastr.warning('Para recusar, é necessário informar uma ocorrência de recusa.', 'Atenção');
    }

    // Aplica a seleção nos títulos
    vm.analise.titulos.forEach(function(titulo) {
      var possuiErroCritico = titulo.erros.some(function(erro) { return erro.criticidade === 'S'; });
      
      if (possuiErroCritico) {
        titulo.selecionado = false;
      } else if (!selecionar && titulo.erros.length === 0) {
        titulo.selecionado = true;
      } else {
        titulo.selecionado = selecionar;
        titulo.recusado = !selecionar;
      }
    });

    vm.carregarTitulos();
  }

    vm.selecionarTodasOcorrencias = function() {
      vm.listaOcorrencias.forEach(function(ocorrencia) {
        ocorrencia.selecionado = vm.selTodasOcorrencias;
      });

      // Atualizar a lista de títulos com base nas ocorrências selecionadas
      vm.alterarSituacaoOcorrencia();
    };

    vm.alterarSituacaoOcorrencia = function() {
      // Coleta todas as ocorrências que estão selecionadas
      var ocorrenciasSelecionadas = vm.listaOcorrencias.filter(function(ocorrencia) {
        return ocorrencia.selecionado;
      }).map(function(ocorrencia) {
        return ocorrencia.codigoErroVmoney;
      });

      if (!vm.analise || !vm.analise.titulos) {
        return;
      }

      // Atualiza a visibilidade dos títulos
      vm.analise.titulos.forEach(function(titulo) {
        if (ocorrenciasSelecionadas.includes('SEM_OCORRENCIA') && titulo.erros.length === 0) {
          // Exibe títulos sem ocorrências se "TÍTULOS SEM OCORRÊNCIA" estiver selecionado
          titulo.visivel = true;
        } else if (ocorrenciasSelecionadas.includes('LIBERADOS') && !titulo.recusado) {
          // Exibe títulos liberados se "TÍTULOS LIBERADOS" estiver selecionado
          titulo.visivel = true;
        } else if (ocorrenciasSelecionadas.includes('RECUSADOS') && titulo.recusado) {
          // Exibe títulos recusados se "TÍTULOS RECUSADOS" estiver selecionado
          titulo.visivel = true;
        } else {
          // Exibe títulos com pelo menos uma ocorrência selecionada
          var possuiOcorrenciaValida = titulo.erros.some(function(erro) {
            return ocorrenciasSelecionadas.includes(erro.codigoErroVmoney);
          });
          titulo.visivel = possuiOcorrenciaValida;
        }
      });

      // Atualiza a paginação com base nos títulos visíveis
      vm.updatePagination();
    };

    // Método para selecionar todos os sacados
    vm.selecionarTodosSacados = function() {
    
        // Marca ou desmarca todos os sacados com base no estado do checkbox principal
        vm.listaSacados.forEach(function(sacado) {
            sacado.selecionado = vm.selTodosSacados;
            
        });

        // Atualiza a lista de títulos com base nos sacados selecionados
        vm.alterarSituacaoSacado();
    };

    //vm.alterarSituacaoSacado = function() {
    //    // Coleta os sacados selecionados
    //    var sacadosSelecionados = vm.listaSacados
    //        .filter(function(sacado) {
    //            return sacado.selecionado;
    //        })
    //        .map(function(sacado) {
    //            return sacado.descricao.toLowerCase();
    //        });
//
    //    if (!vm.analise || !vm.analise.titulos) {
    //        return;
    //    }
//
    //    // Atualiza a visibilidade dos títulos com base nos sacados selecionados
    //    vm.analise.titulos.forEach(function(titulo) {
    //        titulo.visivel = sacadosSelecionados.length === 0 || sacadosSelecionados.includes(titulo.nomeSacado.toLowerCase());
    //    });
//
    //    // Se nenhum sacado estiver selecionado, limpa a lista de títulos visíveis
    //    if (sacadosSelecionados.length === 0) {
    //        vm.analise.titulos.forEach(function(titulo) {
    //            titulo.visivel = false;
    //        });
    //    }
//
    //    // Atualiza a paginação com base nos títulos visíveis
    //    vm.updatePagination();
    //};

    vm.alterarSituacaoSacado = function() {
    // Se ainda não existe nenhum dado carregado da consulta externa,
    // não interfira na visibilidade da análise.
    if (!vm.vaduPreSacadosOriginais || vm.vaduPreSacadosOriginais.length === 0) {
        // Garante que todos os títulos permaneçam visíveis
        if (vm.analise && vm.analise.titulos) {
            vm.analise.titulos.forEach(function(titulo) {
                titulo.visivel = true;
            });
            vm.updatePagination();
        }
        return; // Sai da função sem aplicar filtragem
    }

    // Caso exista contexto externo (VADU carregado), aplica a filtragem normal
    var sacadosSelecionados = vm.listaSacados
        .filter(function(sacado) {
            return sacado.selecionado;
        })
        .map(function(sacado) {
            return sacado.descricao.toLowerCase();
        });

    if (!vm.analise || !vm.analise.titulos) {
        return;
    }

    // Atualiza a visibilidade dos títulos com base nos sacados selecionados
    vm.analise.titulos.forEach(function(titulo) {
        titulo.visivel = sacadosSelecionados.length === 0 || 
                         sacadosSelecionados.includes(titulo.nomeSacado.toLowerCase());
    });

    // Se nenhum sacado está selecionado (mas havia dados VADU), aplica comportamento anterior
    if (sacadosSelecionados.length === 0) {
        vm.analise.titulos.forEach(function(titulo) {
            titulo.visivel = false;
        });
    }

    vm.updatePagination();
};


    vm.alterarSituacao = function(item) {
      // Verifica se o título possui erros críticos
      var possuiErroCritico = item.erros.some(function(erro) {
          return erro.criticidade === 'S';
      });
  
      if (possuiErroCritico) {
          // Exibe mensagem de alerta se houver erros críticos
          toastr.error('Este título possui erros críticos e não pode ser selecionado.', 'Atenção');
          $timeout(function() {
              item.selecionado = false; // Reverte o estado do checkbox para false
          });
          return;
      }
  
      if (!item.selecionado && item.erros.length === 0) {
          // Exibe mensagem de alerta se não houver ocorrências
          toastr.warning('Para recusar, é necessário informar uma ocorrência de recusa.', 'Atenção');
          $timeout(function() {
              item.selecionado = true; // Reverte o estado do checkbox para true
          });
          return;
      }
  
      if (item.selecionado) {
          // Lógica para liberar o item
          item.recusado = false;
      } else {
          // Lógica para recusar o item
          item.recusado = true;
      }
  
      // Atualiza a lista de títulos e também a lista de sacados
      vm.carregarTitulos();
      vm.atualizarListaSacados(); // Garantir que a lista de sacados seja atualizada
  };

    vm.CarregarTitulosComFiltro = function() {
      var ocorrenciasSelecionadas = vm.ocorrencias.filter(function(ocorrencia) {
        return ocorrencia.selecionado;
      }).map(function(ocorrencia) {
        return ocorrencia.codigoErroVmoney;
      });

      vm.analise.titulos = vm.analise.titulos.filter(function(titulo) {
        return titulo.erros.some(function(erro) {
          return ocorrenciasSelecionadas.includes(erro.codigoErroVmoney);
        });
      });

      // Atualiza a lista de títulos e também a lista de sacados
      vm.atualizarListaSacados(); // Garantir que a lista de sacados seja atualizada
    };

 
    vm.liberarSelecionados = function() {
      for (var i=0; i < vm.analise.titulos.length; i++) {
        if (vm.analise.titulos[i].selecionado) {
          vm.analise.titulos[i].recusado = false;
        }
        vm.analise.titulos[i].selecionado = false;
      }
      vm.selTodosTitulos = false;
      vm.carregarTitulos();
    }

    vm.consultarAnaliseTitulo = function(item) {
     
      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/analise/detalhe/titulo/index.html',
        controller: 'InvoiceAnaliseTituloController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
          titulo: function () {
            return item; // Passa o objeto título para o modal
          },
          tituloId: function () {
            return item.id; // Passa o ID do título para o modal
          },
          antecipacaoId: function () {
            return vm.analise.antecipacaoId; // Passa o AntecipacaoId para o modal de título
          }
        }
      }).closed.then(function(){
       // alert('PASSEI  Modal fechado.');
        vm.carregarTitulos();
      });
    };

    vm.abrirBordero = function() {
      $uibModal.open({
        templateUrl: 'app/invoice/analise/bordero/index.html',
        controller: 'InvoiceAnaliseBorderoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
          analise: function () {
            return vm.analise;
          }
        }
      });
    };

    // Histórico de pareceres é append-only (auditoria) — só consulta e salva, sem editar/excluir
    vm.consultarPareceres = function() {
      if (!vm.analise || !vm.analise.antecipacaoId) return;
      $http.get(APP_MNP + "/antecipacaoanalisehistorico/consultar/" + vm.analise.antecipacaoId)
        .success(function(response) {
          vm.pareceres = response || [];
          vm.pareceresCount = vm.pareceres.length;
        })
        .error(function() {
          vm.pareceres = [];
          vm.pareceresCount = 0;
        });
    };

    vm.abrirParecer = function() {
      $uibModal.open({
        templateUrl: 'app/invoice/analise/parecer/index.html',
        controller: 'InvoiceAnaliseParecerController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'md',
        resolve: {
          antecipacaoId: function () {
            return vm.analise.antecipacaoId;
          },
          pareceres: function () {
            return vm.pareceres;
          }
        }
      }).result.then(function(pareceresAtualizados) {
        vm.pareceres = pareceresAtualizados || [];
        vm.pareceresCount = vm.pareceres.length;
      }, function() {
        // modal dispensado sem alteração
      });
    };

    vm.vaduPreSolicitacao = function() {
      vm.consultaVadu = $http.get(APP_MNP + "/vadu/presolicitacao/" + vm.antecipacaoViewId)
        .success(function(response)
        { 
            vm.vaduGruposAnalise = response.gruposAnalise;
           

            if (vm.vaduGruposAnalise != null && vm.vaduGruposAnalise.length > 0) {
              vm.vaduGrupoAnalise = vm.vaduGruposAnalise[0];
            }

            // Armazena os dados originais da API
            vm.vaduPreSacadosOriginais = angular.copy(response.sacados);

            vm.vaduPreSacados = response.sacados;
            //console.log('VADU Pre-Solicitação:', vm.vaduPreSacados);

            // Atualizar a lista de sacados na seção de Consultas Externas
            vm.atualizarListaSacados();

            for (var i=0; i < vm.vaduPreSacados.length; i++) {
              vm.vaduPreSacados[i].selecionado = true;
            }
        }).error(function(error){
          if (error == 'error1010') {
            vm.exibirVadu = false;
          }
          else {
            toastr.error(error, 'Alerta');
          }
          return error;
        });  
    }

    vm.vaduSolicitarAnalise = function() {
      // Validar grupo
      if (vm.vaduGrupoAnalise == null) {
        alert('Selecione um grupo de análise.');
        return;
      }
      // Validar sacados
      var sacados = [];
      for (var i=0; i < vm.vaduPreSacados.length; i++) {
        if (vm.vaduPreSacados[i].selecionado) {
          sacados.push(vm.vaduPreSacados[i].viewId);
        }
      }
      if (sacados.length == 0) {
        alert('Selecione um sacado.');
        return;
      }

      var solicitar = {
        antecipacaoViewId: vm.antecipacaoViewId,
        grupoAnaliseId: vm.vaduGrupoAnalise.anagru_id,
        sacadosViewID: sacados,
      };
     
      vm.solicitarAnaliseVadu = $http.post(APP_MNP + "/vadu/solicitaranalise", solicitar)
        .success(function(response)
        { 
          vm.vaduConsultarAnalise();
        }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
        });  
    }

    vm.vaduSelecionarTodosSacadosPre = function() {
      if (vm.vaduSacadosSelecionado) {
        for (var i=0; i < vm.vaduPreSacados.length; i++) {
          vm.vaduPreSacados[i].selecionado = true;
        }
      }
      else {
        for (var i=0; i < vm.vaduPreSacados.length; i++) {
          vm.vaduPreSacados[i].selecionado = false;
        }
      }
    }

    vm.vaduConsultarAnalise = function() {
      vm.consultaVadu = $http.get(APP_MNP + "/vadu/consultaranalise/" + vm.antecipacaoViewId)
        .success(function(response)
        { 
            vm.vaduAnalise = response;
            vm.analiseVaduErro = null;
            // Atualiza o total de NFes
            vm.nFeQtde = vm.calcularTotalNFe();   
            // Atualiza totais distintos, alerta e bloqueio a partir dos títulos do VADU
            var totaisNfe = vm.calcularTotalNFeAnalise();
            vm.vaduAnalise.boranaNumNfe = totaisNfe.total;
            vm.vaduAnalise.boranaNumNfeAlerta = totaisNfe.alerta;
            vm.vaduAnalise.boranaNumNfeBloqueio = totaisNfe.bloqueio;
        

            // CalcularCedente
            vm.vaduAnalise.analiseCedente.bloqueios = 0;
            vm.vaduAnalise.analiseCedente.alertas = 0;
            vm.vaduAnalise.analiseCedente.transferidos = 0;
            vm.vaduAnalise.analiseCedente.liberados = 0;
            vm.vaduAnalise.analiseCedente.semProblemas = 0;


            for (var i=0; i < vm.vaduAnalise.analiseCedente.logs.length; i++) {
              switch (vm.vaduAnalise.analiseCedente.logs[i].cedlogAcao) {
                case "B":
                  vm.vaduAnalise.analiseCedente.bloqueios = vm.vaduAnalise.analiseCedente.bloqueios + 1;
                  break;
                case "A":
                  vm.vaduAnalise.analiseCedente.alertas = vm.vaduAnalise.analiseCedente.alertas + 1;
                  break;
                case "T":
                  vm.vaduAnalise.analiseCedente.transferidos = vm.vaduAnalise.analiseCedente.transferidos + 1;
                  break;
                case "L":
                  vm.vaduAnalise.analiseCedente.liberados = vm.vaduAnalise.analiseCedente.liberados + 1;
                  break;
                default:
                  vm.vaduAnalise.analiseCedente.semProblemas = vm.vaduAnalise.analiseCedente.semProblemas + 1;
                  break;
              }
            }

            // Gerar documento
            //vm.carregarPdf(vm.vaduAnalise.analiseCedente.borcedStringSerasa);

        }).error(function(error){
          if (error == 'VADU_ERROR_001') {
            vm.vaduPreSolicitacao();
          }
          else {
            //toastr.error(error, 'Alerta');
            vm.analiseVaduErro = error;
            return error;
          } 
        });    
    }

    vm.verRelato = function(serasaStr) {
      if (serasaStr == null || serasaStr == '') {
        toastr.error('Dados do Serasa não enviados pelo VADU.', 'Alerta');
        return;
      }

      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/analise/relato/index.html',
        controller: 'InvoiceAnaliseRelatoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
          fileparam: function () {
              return serasaStr;
          },
        }
      }).closed.then(function(){
          //vm.listar();
      });
    }

    vm.carregarPdf = function (serasaStr) {
      $http.post(APP_MNP + '/vadu/relatoriocnpj',
          { stringSerasa: serasaStr },
          { responseType: 'arraybuffer' }
      ).then(function (response) {
          if (vm.pdfUrl) {
              URL.revokeObjectURL(vm.pdfUrl);
          }

          var blob = new Blob([response.data], { type: 'application/pdf' });
          vm.pdfUrl = URL.createObjectURL(blob);
          vm.fileDocumento = $sce.trustAsResourceUrl(vm.pdfUrl);
      }, function (error) {
          console.error('Erro ao gerar relatório PDF', error);
      });
  };

    vm.consultarLogCedente = function(tipo)
    {
      var subtitulo = '';
      switch (tipo) {
        case "B":
          subtitulo = 'Bloqueios';
          break;
        case "A":
          subtitulo = 'Alertas';
          break;
        case "T":
          subtitulo = 'Transferidos';
          break;
        case "L":
          subtitulo = 'Liberados';
          break;
        default:
          subtitulo = 'Sem Problemas';
          break;
      }

      var lista = [];
      for (var i=0; i < vm.vaduAnalise.analiseCedente.logs.length; i++) {
        if (vm.vaduAnalise.analiseCedente.logs[i].cedlogAcao == null && tipo == '') {
          lista.push(vm.vaduAnalise.analiseCedente.logs[i]);
        }
        else if (vm.vaduAnalise.analiseCedente.logs[i].cedlogAcao == tipo) {
          lista.push(vm.vaduAnalise.analiseCedente.logs[i]);
        }
      }

      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/analise/vadu/cedente/index.html',
        controller: 'InvoiceAnaliseVaduCedenteController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
            subtitulo: function () {
                return subtitulo;
            },
            registros: function () {
              return lista;
          },
        }
      }).closed.then(function(){
          //vm.listar();
      });
    }

    vm.consultarLogSacado = function(item) {
      var subtitulo = item.sacNome;

      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/analise/vadu/sacado/index.html',
        controller: 'InvoiceAnaliseVaduSacadoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
            subtitulo: function () {
                return subtitulo;
            },
            registro: function () {
              return item;
          },
        }
      }).closed.then(function(){
          //vm.listar();
      });
    }

    vm.consultarSacadoTitulos = function(item, modo) {
      var subtitulo = item.sacNome;
      var lista = [];

      for (var i=0; i < vm.vaduAnalise.analiseTitulos.length; i++) {
        if (vm.vaduAnalise.analiseTitulos[i].borsac_id == item.borsac_id) {
          lista.push(vm.vaduAnalise.analiseTitulos[i]);
        }
      }
      // Atualiza o total de NFes
      vm.nFeQtde = vm.calcularTotalNFe();      

      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/analise/vadu/titulo/index.html',
        controller: 'InvoiceAnaliseVaduTituloController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
          subtitulo: function () {
            return subtitulo;
          },
          registros: function () {
            return lista;
          },
          notas: function () {
            return vm.vaduAnalise.analiseNotas;
          },
          modo: function () {
            return modo || 'titulos'; // 'titulos' ou 'nfe'
          }
        }
      }).closed.then(function(){
          //vm.listar();
      });
    }



    // Função para alternar a visibilidade dos boxes
    vm.showhide = function(iconId, boxId) {
      console.log('ANTES visibilidade de Títulos para:', vm.boxTitulosVisible, boxId, iconId );
        if (boxId === 'boxTitulos') {
            // Alterna a visibilidade da tabela de títulos
            vm.boxTitulosVisible = !vm.boxTitulosVisible;
            console.log('Alternou visibilidade de Títulos para:', vm.boxTitulosVisible);
        } else {
            // Para outros boxes, mantém o comportamento existente
            var box = angular.element(document.getElementById(boxId));
            box.slideToggle();
            
            var icon = angular.element(document.getElementById(iconId));
            icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        }
    };


    vm.chamarBI = function() {
      var url = 'https://app.powerbi.com/reportEmbed?reportId=64d557fb-2b70-47d8-83e6-a8d2780f712d&autoAuth=true&ctid=19433aab-1885-4fd4-b6dd-4a5e43755bcb&filter=fLotesDQ%2FNUM_LOTE+eq+70369';
      window.open(url, '_blank');
    };

    // Função de-para para tipoOperacao
    vm.getTipoOperacaoDescricao = function(codigo) {
        var map = {
            "C": "COBRANÇA SIMPLES",
            "F": "FACTORING",
            "G": "CESSÃO DE CRÉDITO", 
            "I": "FUNDO",
            "J": "CARTÃO",
            "Q": "AQUISIÇÃO",
            "R": "CONFISSÃO DE DÍVIDA",
            "S": "SECURITIZAÇÃO",
            "T": "TRANSF. TÍTUL.",
            "U": "DIR CREDITÓRIOS FUTUROS",
            "V": "AQUISIÇÃO SEC.",
            "Y": "COBRANÇA SIMPLES SEC."
        };
        return map[codigo] || codigo;
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceAntecipacaoController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP', 'PagerService', 'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP, PagerService, AuthService)
  {
    var vm = this;
    vm.empresaName = AuthService.getEmpresa();
    vm.registros = null;
    vm.filtro = {
        status : ''
    }
    vm.lastOrder = '';
    vm.orderSelected = '';

    vm.pager = {};
    vm.setPage = setPage;

    vm.init = function()
    {        
        vm.listar();
    }

    vm.listar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;

        vm.pesquisarPromise = $http.get(APP_MNP + "/invoice/antecipacao/disponiveis")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });        
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataVencimentoAte = vm.filtro.vencimentoAte;

        if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
        {
            dataVencimentoAte = addDays(vm.filtro.vencimentoAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '')
            {
                if (!vm.registrosOriginal[i].fornecedor.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.numeroAntecipacao != null && vm.filtro.numeroAntecipacao != '')
            {
                if (vm.registrosOriginal[i].numero != vm.filtro.numeroAntecipacao)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
            {
                if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '')
            {
                if (dataVencimentoAte < new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }
            
            if (vm.filtro.valorDe != null && vm.filtro.valorDe != '')
            {
                if (vm.filtro.valorDe > vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorAte != null && vm.filtro.valorAte != '')
            {
                if (vm.filtro.valorAte < vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'fornecedor':
                    vm.registros.reverse(function(a, b){
                        if(a.fornecedor < b.fornecedor) { return -1; }
                        if(a.fornecedor > b.fornecedor) { return 1; }
                        return 0;
                    })
                    break;
                case 'data':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.data);
                        var dateB = new Date(b.data);
                        return dateA - dateB;
                    });
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'fornecedor':
                    vm.registros.sort(function(a, b){
                        if(a.fornecedor < b.fornecedor) { return -1; }
                        if(a.fornecedor > b.fornecedor) { return 1; }
                        return 0;
                    })
                    break;
                case 'data':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.data);
                        var dateB = new Date(b.data);
                        return dateA - dateB;
                    });
                    break;
            } 
        }
        
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.proposta = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/invoice/antecipacao/modal/proposta.html',
            controller: 'AntecipacaoRealizarPropostaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            vm.listar();
        });
    }

    vm.titulos = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/invoice/antecipacao/modal/consultar_titulos.html',
            controller: 'ConsultarTitulosPropostaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            vm.listar();
        });
    }

    vm.liberarTitulos = function(p)
    {
        var r = confirm("Confirma a liberação dos títulos?");

        if (!r)
        {
            return;
        }

        $http.post(APP_MNP + "/antecipacao/liberartitulos", p).success(function(response){            
            toastr.info('Títulos liberados com sucesso.', 'Alerta');
            vm.listar();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.consultarNegociacao = function(p)
    {
        $state.go('index.operacao_negociacao', {obj: p.viewId});
    }

    vm.consultarFormalizacao = function(p)
    {
        $state.go('index.operacao_formalizacao', {obj: p.viewId});
    }

    vm.consultarCcb = function(p)
    {
        $state.go('index.ccb_consultar', {id: p.viewId});
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.analisarLote = function(p) {
        $state.go('index.invoice_antecipacao_analisar', {obj: p.viewId});
    }

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('FluxoAprovacaoConfigController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;

    vm.init = function()
    {
        vm.pesquisar();
    }

    vm.pesquisar = function()
    {
        vm.pesquisarPromise = $http.get(APP_MNP + "/fluxoaprovacao/consultar")
        .then(function(response)
        { 
            vm.registro = response.data;
        });
    }

    vm.cadastrar = function()
    {
        $state.go('index.config_fluxo_aprovacao_etapa', {fluxoId: vm.registro.viewId, obj: null});
    }

    vm.consultar = function(etapa) 
    {
        $state.go('index.config_fluxo_aprovacao_etapa', {fluxoId: vm.registro.viewId, obj: etapa});
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('HomeOperacoesPendentesController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'codigoStatus', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, codigoStatus, $http, APP_MNP)
  {
    var vm = this;
    vm.codigoStatus = codigoStatus;

    vm.init = function()
    {
      vm.registros = [];

      $http.get(APP_MNP + "/invoice/operacao/disponiveis")
      .then(function(response)
      { 
          vm.registros = response.data;          
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.consultarAnalise = function(p)
    {
      vm.fechar();
      $state.go('index.operacao_analise', {obj: p.viewId});
    }

    vm.consultarNegociacao = function(p)
    {
      vm.fechar();
      $state.go('index.operacao_negociacao', {obj: p.viewId});
    }

    vm.consultarFormalizacao = function(p)
    {
      vm.fechar();
      $state.go('index.operacao_formalizacao', {obj: p.viewId});
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('GrupoUsuarioPesquisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/grupousuario/pesquisar");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.cadastrar = function()
    {
        $state.go('index.grupousuario_cadastrar');
    }

    vm.consultar = function(registro)
    {
        $state.go('index.grupousuario_cadastrar', {obj: registro.viewId});
    }

    vm.permissao = function(registro)
    {
        $state.go('index.grupousuario_permissao', {obj: registro.viewId, name: registro.nome});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('GrupoUsuarioAdicionarCedenteController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_MNP', 'registro',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_MNP, registro)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {
      vm.listar();
    }

    vm.selecionar = function(cedente)
    {
      var request = {
        grupoUsuarioViewId: registro.viewId,
        cedenteViewId: cedente.viewId
      };

      vm.salvarPromise = $http.post(APP_MNP + "/grupoUsuario/cedente", request).success(function(response){
        toastr.info('Cedente adicionado.', 'Alerta');
        //$uibModalInstance.close();
    }).error(function(error){
        toastr.error(error, 'Alerta');
        //return error;
    });
      //$uibModalInstance.close(assunto);
    }

    vm.listar = function()
    {
        vm.consultaPromise = $http.get(APP_MNP + "/cedente/pesquisar")
        .then(function(response)
        { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;          
          vm.filtrarPesquisa();
        });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                {
                    incluir = false;

                    if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                    {
                        incluir = false;
                    }
                    else
                    {
                      incluir = true;
                    }
                }
                else
                {
                  incluir = true;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('GrupoUsuarioPermissaoController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.registroViewId = $state.params.obj;
    vm.grupoNome = $state.params.name;

    vm.init = function()
    {
        if (vm.registroViewId != null)
        {
            vm.carregar();
        }
        else
        {
        }
    }

    vm.carregar = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/grupoUsuarioPermissao/listar/" + vm.registroViewId)
        .then(function(response)
        {           
            vm.registros = response.data;
        });
    }

    vm.desabilitarMenu = function(p) {
        p.isAtivo = false;

        vm.salvarPromise = $http.post(APP_MNP + "/grupoUsuarioPermissao/atualizar", p).success(function(response){
            vm.carregar();
        }).error(function(error){
            toastr.error(error, 'Alerta');
        });
    }

    vm.habilitarMenu = function(p) {
        p.isAtivo = true;

        vm.salvarPromise = $http.post(APP_MNP + "/grupoUsuarioPermissao/atualizar", p).success(function(response){
            vm.carregar();
        }).error(function(error){
            toastr.error(error, 'Alerta');
        });
    }

    vm.salvar = function()
    {
        if (vm.registro.nome == null || vm.registro.nome == '')
        {
            toastr.error('Nome é obrigatório.', 'Alerta');
            return;
        }

        if (vm.registro.codigoRestringirCedente == 1)
        {
            vm.registro.restringirCedente = false;
        }
        else
        {
            vm.registro.restringirCedente = true;
        }

        if (!vm.isUpdate)
        {
            vm.salvarPromise = $http.post(APP_MNP + "/grupoUsuario/enviar", vm.registro).success(function(response){
                toastr.info('Grupo cadastrado com sucesso.', 'Alerta');
                vm.registroViewId = response.viewId;                
                vm.isUpdate = true;
                vm.carregar();
                $state.go('index.grupousuario_pesquisar');
                //return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                //return error;
            });
        }
        else
        {
            vm.salvarPromise = $http.put(APP_MNP + "/grupoUsuario/alterar", vm.registro).success(function(response){
                toastr.info('Grupo atualizado com sucesso.', 'Alerta');
                $state.go('index.grupousuario_pesquisar');
                vm.isUpdate = true;
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('GrupoUsuarioCadastrarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.registroViewId = $state.params.obj;
    vm.registro = {
        codigoRestringirCedente: 1
    };
    vm.isUpdate = false;

    vm.init = function()
    {
        if (vm.registroViewId != null)
        {
            vm.isUpdate = true;
            vm.carregar();
            vm.listarCedentes();
        }
        else
        {
            vm.isUpdate = false;
        }
    }

    vm.listarCedentes = function()
    {
        vm.consultarCedentesPromise = $http.get(APP_MNP + "/grupoUsuario/cedentes/" + vm.registroViewId)
        .then(function(response)
        {           
            vm.cedentes = response.data;
        });
    }

    vm.carregar = function()
    {
        vm.consultarPromise = $http.get(APP_MNP + "/grupoUsuario/" + vm.registroViewId)
        .then(function(response)
        {           
            vm.registro = response.data;

            if (vm.registro.restringirCedente)
            {
                vm.registro.codigoRestringirCedente = 2;
            }
            else
            {
                vm.registro.codigoRestringirCedente = 1;
            }
        });
    }

    vm.salvar = function()
    {
        if (vm.registro.nome == null || vm.registro.nome == '')
        {
            toastr.error('Nome é obrigatório.', 'Alerta');
            return;
        }

        if (vm.registro.codigoRestringirCedente == 1)
        {
            vm.registro.restringirCedente = false;
        }
        else
        {
            vm.registro.restringirCedente = true;
        }

        if (!vm.isUpdate)
        {
            vm.salvarPromise = $http.post(APP_MNP + "/grupoUsuario/enviar", vm.registro).success(function(response){
                toastr.info('Grupo cadastrado com sucesso.', 'Alerta');
                vm.registroViewId = response.viewId;                
                vm.isUpdate = true;
                vm.carregar();
                $state.go('index.grupousuario_pesquisar');
                //return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                //return error;
            });
        }
        else
        {
            vm.salvarPromise = $http.put(APP_MNP + "/grupoUsuario/alterar", vm.registro).success(function(response){
                toastr.info('Grupo atualizado com sucesso.', 'Alerta');
                $state.go('index.grupousuario_pesquisar');
                vm.isUpdate = true;
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.adicionarCedente = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/grupousuario/adicionarcedente/index.html',
            controller: 'GrupoUsuarioAdicionarCedenteController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                registro: function () {
                    return vm.registro;
                },
            }
        }).closed.then(function(){
            vm.listarCedentes();
        });
    }

    vm.removerCedente = function(cedente)
    {
        if (confirm('Confirma a remoção do cedente no grupo?'))
        {
            vm.deleteCedentePromise = $http.delete(APP_MNP + "/grupoUsuario/cedente/" + cedente.viewId).success(function(response){
                toastr.info('Cedente removido com sucesso.', 'Alerta');
                vm.listarCedentes();
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('DomicilioBancarioPesquisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/domiciliobancario/pesquisar");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.cadastrar = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/domiciliobancario/cadastrar/index.html',
            controller: 'DomicilioBancarioCadastrarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',    
            backdrop: 'static',        
            size: 'lg',
            resolve: {
                registro: function () {
                    return null;
                },
            }
        }).closed.then(function(){
            vm.pesquisar();
        });
    }

    vm.consultar = function(registro)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/domiciliobancario/cadastrar/index.html',
            controller: 'DomicilioBancarioCadastrarController',
            controllerAs: 'controller',
            backdrop: 'static',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                registro: function () {
                    return registro;
                },
            }
        }).closed.then(function(){
            vm.pesquisar();
        });
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('DomicilioBancarioCadastrarController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'registro',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, registro)
  {
    var vm = this;
    vm.registro = {
      tipoConta: 1,
      codigoBanco: 1
    };
    vm.isUpdate = false;
    vm.contaPadrao = 1;

    vm.originadores = [];
    vm.originador = null;

    vm.init = function()
    {
      vm.listarBancos();
      vm.listarOriginadores();
      
      if (registro != null)
      {
        vm.isUpdate = true;

        vm.registro = registro;

        if (vm.registro.isPadraoOperacao)
        {
          vm.contaPadrao = 2;
        }
        else
        {
          vm.contaPadrao = 1;
        }
      }
      else
      {
        vm.isUpdate = false;
      }
    }

    vm.listarOriginadores = function() {
      vm.consultaPromise = $http.get(APP_MNP + "/empresaoriginador/lista")
      .then(function(response)
      { 
          vm.originadores = response.data;

          if (vm.originadores.length > 0)
          {
              if (vm.isUpdate)
              {
                var encontrado = false;

                for (var i=0;i<vm.originadores.length;i++)
                {
                  if (vm.registro.originador.id == vm.originadores[i].id)
                  {
                    vm.originador = vm.originadores[i];
                    encontrado = true;
                    break;
                  }                  
                }

                if (encontrado == false)
                {
                  vm.originador = vm.originadores[0];
                }
              }
              else
              {
                vm.originador = vm.originadores[0];
              }              
              
              //vm.consultar();
          }
      });
    }

    vm.listarBancos = function()
    {
        vm.listarBancosPromise = $http.get(APP_MNP + "/banco/pesquisar");   
        vm.listarBancosPromise.then(function(response)
        { 
            vm.bancos = response.data;                        
        });
    }

    vm.enviar = function()
    {
      if (vm.registro.agencia == null || vm.registro.agencia == '')
      {
        toastr.error('Agência é obrigatório.', 'Alerta');
        return;
      }

      if (vm.registro.numero == null || vm.registro.numero == '')
      {
        toastr.error('Número da conta é obrigatório.', 'Alerta');
        return;
      }

      if (vm.originador == null)
      {
        toastr.error('Originador é obrigatório.', 'Alerta');
        return;
      }

      vm.registro.originador = vm.originador;

      if (vm.contaPadrao == 2)
      {
        vm.registro.isPadraoOperacao = true;
      }
      else
      {
        vm.registro.isPadraoOperacao = false;
      }

      if (!vm.isUpdate)
      {
        vm.enviarPromise = $http.post(APP_MNP + "/domiciliobancario/enviar", vm.registro).success(function(response){
            vm.fechar();
            toastr.info('Domicílio cadastrado com sucesso.', 'Alerta');          
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
      }
      else
      {
        vm.enviarPromise = $http.put(APP_MNP + "/domiciliobancario/alterar", vm.registro).success(function(response){
          vm.fechar();
          toastr.info('Registro atualizado com sucesso.', 'Alerta');          
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
      }
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('EmailTemplateController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.registroParam = $state.params.obj;
    vm.registro = {

    };
    vm.isUpdate = false;

    vm.init = function()
    {
        if (vm.registroParam != null && vm.registroParam != '')
        {
            vm.isUpdate = true;
            vm.pesquisar();
        }
    }

    $scope.options = {        
        toolbar: [
            //['edit',['undo','redo']],
            //['headline', ['style']],
            ['style', ['bold', 'italic', 'underline']],
            //['fontface', ['fontname']],
            //['textsize', ['fontsize']],
            //['fontclr', ['color']],
            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
            //['height', ['height']],
            //['table', ['table']],
            //['insert', ['picture']],
            ['view', ['codeview']],
            //['help', ['help']]
            /*
            ['edit',['undo','redo']],
            ['headline', ['style']],
            ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
            ['fontface', ['fontname']],
            ['textsize', ['fontsize']],
            ['fontclr', ['color']],
            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
            ['height', ['height']],
            ['table', ['table']],
            ['insert', ['link','picture','hr']],
            ['view', ['codeview']],
            ['help', ['help']]
            */
        ]
    };

    vm.pesquisar = function()
    {
        return $http.get(APP_MNP + "/emailTemplate/consultar/" + vm.registroParam)
        .then(function(response)
        { 
            vm.registro = response.data;
        });
    }

    vm.salvar = function()
    {
        if (vm.registro.nome == null || vm.registro.nome == '')
        {
            toastr.error('Nome é obrigatório.', 'Alerta');
            return;
        }

        if (vm.registro.template == null || vm.registro.template == '')
        {
            toastr.error('Template é obrigatório.', 'Alerta');
            return;
        }

        if (!vm.isUpdate)
        {
            vm.salvarPromise = $http.post(APP_MNP + "/emailtemplate/incluir", vm.registro).success(function(response){
                toastr.info('Template cadastrado com sucesso.', 'Alerta');
                $state.go('index.email_template_listar');
                return response;
            }).error(function(error){
                return error;
            });
        }
        else
        {
            vm.salvarPromise = $http.put(APP_MNP + "/emailtemplate/alterar", vm.registro).success(function(response){
                toastr.info('Template atualizado com sucesso.', 'Alerta');
                $state.go('index.email_template_listar');
                return response;
            }).error(function(error){
                return error;
            });
        }
    }

    vm.testar = function()
    {
        if (vm.registro.nome == null || vm.registro.nome == '')
        {
            toastr.error('Nome é obrigatório.', 'Alerta');
            return;
        }

        if (vm.registro.template == null || vm.registro.template == '')
        {
            toastr.error('Template é obrigatório.', 'Alerta');
            return;
        }

        vm.salvarPromise = $http.post(APP_MNP + "/emailtemplate/test", vm.registro).success(function(response){
            toastr.info('Template enviado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.excluir = function()
    {
        if (confirm('Deseja realmente excluir?'))
        {
            vm.salvarPromise = $http.delete(APP_MNP + "/emailtemplate/delete/" + vm.registroParam).success(function(response){
                toastr.info('Template excluído com sucesso.', 'Alerta');
                $state.go('index.email_template_listar');
                return response;
            }).error(function(error){
                return error;
            });
        }
    }

    vm.campos = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/email/template/campos/index.html',
        controller: 'FornecedorIncluirEmpresaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        //backdrop: 'static',
        size: 'lg',
        /*
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          empresa: function () {
            return empresa;
          },
          indice: function () {
            return 0;
          },
        }
        */
      }).closed.then(function(){
        //vm.consultar();
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('EmailMalaDiretaController', ['$scope', '$state', 'toastr', 'APP_MNP', '$http', '$uibModal', 'PagerService',
      function($scope, $state, toastr, APP_MNP, $http, $uibModal, PagerService)
  {
    var vm = this;

    $scope.Math = Math; 
    vm.registro = {
        destinatario: '',
        destinatarios: [],
        copia: [],
        copiaOculta: [],
        assunto: '',
        mensagem: '',
        anexos: [],
        tipoEnvio: '0',
        assinaturaEmail: '',
    };

    vm.arquivo = {};
    vm.pagerBcc = {};
    vm.copiaOcultaPaginados = [];
    vm.selecionarTodos = false;


    vm.init = function()
    {
        vm.consultarconfig = $http.get(APP_MNP + "/EmailMalaDireta/getconfig")
        .then(function(response)
        { 
            vm.config = response.data;
            vm.registro.assinaturaEmail = vm.config.assinaturaEmail;
        });
    }

    // Função para configurar a paginação do BCC
    vm.setPageBcc = function(page) {
        if (!vm.registro.copiaOculta || vm.registro.copiaOculta.length === 0) {
            vm.pagerBcc = {};
            vm.copiaOcultaPaginados = [];
            return;
        }
        
        if (page < 1 || (vm.pagerBcc.totalPages && page > vm.pagerBcc.totalPages)) {
            return;
        }
        
        vm.pagerBcc = PagerService.GetPager(vm.registro.copiaOculta.length, page, 10); // 10 registros por página
        vm.copiaOcultaPaginados = vm.registro.copiaOculta.slice(vm.pagerBcc.startIndex, vm.pagerBcc.endIndex + 1);
    };
    // Função para atualizar a paginação do BCC
    vm.atualizarPaginacaoBcc = function() {
        if (!vm.registro.copiaOculta || vm.registro.copiaOculta.length === 0) {
            vm.pagerBcc = {};
            vm.copiaOcultaPaginados = [];
            return;
        }
        
        // Se a página atual não existe mais, vai para a última página válida
        var paginaAtual = vm.pagerBcc.currentPage || 1;
        var totalPaginas = Math.ceil(vm.registro.copiaOculta.length / 10);
        
        if (paginaAtual > totalPaginas) {
            paginaAtual = totalPaginas;
        }
        
        vm.setPageBcc(paginaAtual);
    };    

vm.moverEmail = function(email, origem, destino) {
    // Remove o email da lista de origem
    switch(origem) {
        case 'destinatarios':
            vm.removerDestinatario(email);
            break;
        case 'copia':
            vm.removerCopia(email);
            break;
        case 'copiaOculta':
            vm.removerCopiaOculta(email);
            break;
    }
    
    // Adiciona o email na lista de destino
    switch(destino) {
        case 'destinatarios':
            vm.registro.destinatarios.unshift(email);
            break;
        case 'copia':
            vm.registro.copia.unshift(email);
            break;
        case 'copiaOculta':
            vm.registro.copiaOculta.unshift(email);
            break;
    }
    
    // ADICIONE ESTA VERIFICAÇÃO:
    if (origem === 'copiaOculta' || destino === 'copiaOculta') {
        vm.atualizarPaginacaoBcc();
    }
    
    // Feedback visual para o usuário
    var nomeDestino = '';
    switch(destino) {
        case 'destinatarios':
            nomeDestino = 'Destinatarios';
            break;
        case 'copia':
            nomeDestino = 'Copia (CC)';
            break;
        case 'copiaOculta':
            nomeDestino = 'Copia Oculta (BCC)';
            break;
    }
    toastr.success(email.nome + ' movido para ' + nomeDestino, 'Sucesso');
};
    

    vm.adicionarDestinatario = function() {
        if (vm.registro.destinatario == '') {
            return;
        }

        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        var result= reg.test(vm.registro.destinatario);
        if (result && vm.registro.destinatario != '') {
            var existe = false;
            for (var i = 0; i < vm.registro.destinatarios.length; i++)
            {
                if (vm.registro.destinatarios[i] == vm.registro.destinatario)
                {
                    existe = true;
                }
            }
            if (existe == false) {
                vm.registro.destinatarios.push(vm.registro.destinatario);
            }
            vm.registro.destinatario = '';
        }
        else {
            toastr.error('E-mail inválido.', 'Erro');
        }
    }

    vm.removerDestinatario = function(p) {
        for (var i = 0; i < vm.registro.destinatarios.length; i++)
        {
            if (vm.registro.destinatarios[i] == p)
            {
                vm.registro.destinatarios.splice(i, 1);
            }
        }
    }

    vm.removerCopia = function(p) {
        for (var i = 0; i < vm.registro.copia.length; i++)
        {
            if (vm.registro.copia[i] == p)
            {
                vm.registro.copia.splice(i, 1);
            }
        }
    }
    vm.removerCopiaOculta = function(p) {
        for (var i = 0; i < vm.registro.copiaOculta.length; i++)
        {
            if (vm.registro.copiaOculta[i] == p)
            {
                vm.registro.copiaOculta.splice(i, 1);
                break; // Adicione break para sair do loop
            }
        }
        // ADICIONE ESTA LINHA:
        vm.atualizarPaginacaoBcc();
    }

    $scope.adicionarAssinatura = function(element) {
        const file = element.files[0];
        const fileSize = file.size / 1024 / 1024; 
        if (fileSize > 4) {
            toastr.error('Arquivo não pode ultrapassar o tamanho de 4 Megabytes.', 'Erro');
            return;
        }
        vm.arquivo = {
            name: file.name,
            size: file.size,
            type: file.type
        };
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e){
            $scope.$apply(function(){
                vm.registro.assinaturaEmail = reader.result;
            });
        };
    }

    $scope.adicionarAnexo = function(element) {
        const file = element.files[0];
        for (var i = 0; i < vm.registro.anexos.length; i++)
        {
            if (vm.registro.anexos[i].name == file.name)
            {
                toastr.error('Nome de arquivo já adicionado.', 'Erro');
                return;
            }
        }
        const fileSize = file.size / 1024 / 1024; 
        if (fileSize > 4) {
            toastr.error('Arquivo não pode ultrapassar o tamanho de 4 Megabytes.', 'Erro');
            return;
        }
        vm.arquivo = {
            name: file.name,
            size: file.size,
            type: file.type
        };
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e){
            $scope.$apply(function(){
                vm.arquivo.file = reader.result;
                vm.registro.anexos.push(vm.arquivo);
                vm.arquivo = {};
            });
        };
    }

    vm.removerAnexo = function(anexo) {
        for (var i = 0; i < vm.registro.anexos.length; i++)
        {
            if (vm.registro.anexos[i].name == anexo.name)
            {
                vm.registro.anexos.splice(i, 1);
            }
        }
    }

    vm.enviar = function() {
        vm.enviarPromise = $http.post(APP_MNP + "/emailmaladireta/enviar", vm.registro).success(function(response){
            toastr.info('E-mail enviado com sucesso.', 'Alerta');
            $state.go('index.email_maladireta_historico');
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro');
            return error;
        });
    }

    vm.digitarEmail = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/email/maladireta/digitar/index.html',
        controller: 'EmailMalaDiretaDigitarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'md',
        }).result.then(function(data){
            if (data != null)
            {
                var email = data;
                var email = {
                    nome: email.nome,
                    origem: 'Digitado',
                    email: email.email,
                };
                vm.registro.destinatarios.push(email);
            }      
        });
    }

    vm.digitarEmailCopia = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/email/maladireta/digitar/index.html',
        controller: 'EmailMalaDiretaDigitarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'md',
        }).result.then(function(data){
            if (data != null)
            {
                var email = data;
                var email = {
                    nome: email.nome,
                    origem: 'Digitado',
                    email: email.email,
                };
                vm.registro.copia.push(email);
            }      
        });
    }
vm.digitarEmailCopiaOculta = function()
{
    var modalInstance = $uibModal.open({
    templateUrl: 'app/email/maladireta/digitar/index.html',
    controller: 'EmailMalaDiretaDigitarController',
    controllerAs: 'controller',
    windowClass: 'inmodal',
    size: 'md',
    }).result.then(function(data){
        if (data != null)
        {
            var email = data;
            var email = {
                nome: email.nome,
                origem: 'Digitado',
                email: email.email,
            };
            vm.registro.copiaOculta.push(email);
            // ADICIONE ESTA LINHA:
            vm.atualizarPaginacaoBcc();
        }
    });
}

    vm.selecionarCedenteModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/email/maladireta/cedente/index.html',
        controller: 'EmailMalaDiretaCedenteController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',

        }).result.then(function(data){
            if (data != null)
            {
                var cedentes = data;
                for (var i=0;i<cedentes.length;i++) {
                    var email = {
                        nome: cedentes[i].razaoSocial,
                        origem: 'Cedente',
                        email: cedentes[i].email,
                    };
                    vm.registro.copiaOculta.push(email);
                }
                // ADICIONE ESTA LINHA:
                vm.atualizarPaginacaoBcc();
            }      
        });
    }

    vm.selecionarSacadoModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/email/maladireta/sacado/index.html',
        controller: 'EmailMalaDiretaSacadoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            if (data != null)
            {
                var cedentes = data;
                console.log(cedentes);
                for (var i=0;i<cedentes.length;i++) {
                    var email = {
                        nome: cedentes[i].razaoSocial,
                        origem: 'Sacado',
                        email: cedentes[i].email,
                    };
                    vm.registro.copiaOculta.push(email);
                }
                // ADICIONE ESTA LINHA:
                vm.atualizarPaginacaoBcc();
            }      
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    $scope.options = {        
        toolbar: [
            //['insert', ['link','picture','hr']],
            ['style', ['bold', 'italic', 'underline']],
            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
            ['view', ['codeview']],
        ],
        callbacks: {
            onInit: function () {
                // Adiciona um evento de cópia ao pressionar Ctrl+C
                $(document).on('keydown', '#ContentPlaceHolder1_summernote', function (e) {
                    if ((e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'C')) {
                        alert('Copiar não permitido.');
                        e.preventDefault();
                    }
                });

                // Adiciona um evento de colagem ao pressionar Ctrl+V
                $('#ContentPlaceHolder1_summernote').on('paste', function (e) {
                    alert('Colar não permitido.');
                    e.preventDefault();
                });
            },
            onImageUpload: function (files) {
                // Cancela o upload de imagens
                //alert('Carregar imagens não permitido.');
                return false;
            }
        }
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('GestaoCarteiraHistoricoController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        vencimentoInicial: new Date(),
        vencimentoFinal: new Date(),
    };
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        //vm.pesquisar(); 
        vm.loadPeriodo();
    }

    vm.pesquisar = function()
    {
        vm.consultarPromise = $http.post(APP_MNP + "/GestaoEmailLogController/resumo", vm.filtro).success(function(response){
            vm.registrosOriginal = response.response;
            vm.registros = response.response;

            if (vm.registros == null || vm.registros.length == 0)
            {
                toastr.warning('Não foram encontrados registros.', 'Alerta');
            }

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('ConfigEmailController', ['$scope', '$state', 'toastr', 'APP_MNP', '$http',
      function($scope, $state, toastr, APP_MNP, $http)
  {
    var vm = this;

    vm.init = function()
    {
        vm.consultar();
    }

    vm.consultar = function()
    {
        vm.consultaPromise = $http.get(APP_MNP + "/empresaConfigEmail/consultar")
        .then(function(response)
        { 
            vm.registro = response.data;
        });
    }

    vm.testar = function() {
        var resultado = window.prompt('Digite um e-mail para o envio do teste.', '');

        if (resultado == '') {
            toastr.error('E-mail de destino inválido.', 'Erro');
        }
        else {
            vm.registro.emailDestinoTeste = resultado;

            vm.consultaPromise = $http.put(APP_MNP + "/empresaConfigEmail/testar", vm.registro).success(function(response){
                toastr.info('Teste enviado com sucesso.', 'Alerta');
                vm.consultar();
                return response;
            }).error(function(error){
                toastr.error(error, 'Erro');
                return error;
            });
        }
    }

    vm.atualizar = function()
    {
        var resultado = window.prompt('Digite um e-mail para o envio do teste.', '');

        if (resultado == '') {
            toastr.error('E-mail de destino inválido.', 'Erro');
        }
        else {
            vm.registro.emailDestinoTeste = resultado;
            
            vm.consultaPromise = $http.put(APP_MNP + "/empresaConfigEmail/atualizar", vm.registro).success(function(response){
                toastr.info('Registro atualizado com sucesso.', 'Alerta');
                vm.consultar();
                return response;
            }).error(function(error){
                toastr.error(error, 'Erro');
                return error;
            });
        }
    }

    vm.salvarConfigResposta = function() {

        if (vm.registro.replyToEmail == null || vm.registro.replyToEmail == '') {
            toastr.error('E-mail de resposta não informado.', 'Alerta');
            return;
        }
        if (vm.registro.replyToNome == null || vm.registro.replyToNome == '') {
            toastr.info('Nome de exibição não informado.', 'Alerta');
            return;
        }

        vm.consultaPromise = $http.post(APP_MNP + "/empresaConfigEmail/resposta", vm.registro).success(function(response){
            toastr.info('Registro atualizado com sucesso.', 'Alerta');
            vm.consultar();
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro');
            return error;
        });
    }

    vm.init();

    vm.showPassword = false;
    vm.togglePassword = function() {
        vm.showPassword = !vm.showPassword;
    }

  }]);
angular.module('inspinia')
  .controller('ContaGraficaAcertoManualController', ['$scope', '$state', 'toastr', 'PagerService', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, PagerService, $http, APP_MNP, $uibModal) 
{
    var vm = this;    
    vm.registros = null;
    vm.cedente = null;
    vm.cedenteContaGraficaItens = [];
    vm.cedenteContaGraficaGrupos = [];
    vm.totalDebito = 0;
    vm.totalCredito = 0;
    vm.totalSaldo = 0;
    vm.valorPagamento = 0;
    vm.tipoPagamento = 1;
    vm.dataReferenciaProcessamento = new Date();
    vm.dataPagamento = new Date();
    vm.dataProcessamento= new Date();

    vm.init = function()
    {
    }

    vm.listarExtratoGrupo = function() {
        vm.cedenteContaGraficaItens = [];

        var request = {
            cedenteViewId: vm.cedente.viewId,
            data: vm.dataReferenciaProcessamento,
        };

        vm.listarExtratoPromise = $http.post(APP_MNP + "/TituloContaCorrente/extratocedente", request)
        .then(function(response)
        { 
            vm.cedenteContaGraficaItens = response.data;

            vm.cedenteContaGraficaGrupos = [];

            for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
                vm.cedenteContaGraficaItens[i].status = false;

                var grupoId = vm.cedenteContaGraficaItens[i].grupoTituloContaCorrenteEnum;
                var grupoIndex = -1;

                // localizar grupo
                for (var j=0; j < vm.cedenteContaGraficaGrupos.length; j++) {
                    if (vm.cedenteContaGraficaGrupos[j].grupoId == grupoId) {
                        grupoIndex = j;
                    }
                }

                // Criar grupo
                if (grupoIndex == -1) {
                    var novoGrupo = {
                        grupoId: grupoId,
                        descricao: vm.cedenteContaGraficaItens[i].grupoTexto,
                        quantidade: 1,
                        presenteDebito: vm.cedenteContaGraficaItens[i].isCredito ? 0 : vm.cedenteContaGraficaItens[i].valorPresente,
                        presenteCredito: vm.cedenteContaGraficaItens[i].isCredito ? vm.cedenteContaGraficaItens[i].valorPresente : 0,
                        selecionados: 0,
                        selecionadosTotal: 0,
                        selecionado: false
                    };
                    vm.cedenteContaGraficaGrupos.push(novoGrupo);
                }
                else {
                    vm.cedenteContaGraficaGrupos[grupoIndex].quantidade = vm.cedenteContaGraficaGrupos[grupoIndex].quantidade + 1;
                    
                    if (vm.cedenteContaGraficaItens[i].isCredito) {
                        vm.cedenteContaGraficaGrupos[grupoIndex].presenteCredito = vm.cedenteContaGraficaGrupos[grupoIndex].presenteCredito + vm.cedenteContaGraficaItens[i].valorPresente;
                    }
                    else {
                        vm.cedenteContaGraficaGrupos[grupoIndex].presenteDebito = vm.cedenteContaGraficaGrupos[grupoIndex].presenteDebito + vm.cedenteContaGraficaItens[i].valorPresente;
                    }
                    
                }
            }
        });
    } 

    vm.selecionarCedenteModal = function()
    {    
        vm.cedente = null;
        vm.cedenteViewId = null;
        vm.valorTotal = 0;
        
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/selecionar/index.html',
            controller: 'CedenteSelecionarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            }).result.then(function(data){
                vm.cedenteContaGraficaItens = [];
                vm.cedente = null;
                vm.valorTotal = 0;
                if (data != null)
                {
                    vm.cedente = data;
                    vm.cedenteViewId = data.viewId;

                    vm.listarExtratoGrupo();
                }      
            });
    }

    vm.detalharItem = function(grupo)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/contagrafica/acerto/detalhe/index.html',
            controller: 'ContaGraficaAcertoManualDetalheController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                titulos: function () {
                    return vm.cedenteContaGraficaItens;
                },
                grupo: function () {
                    return grupo;
                },
            }
        }).closed.then(function(){
            vm.calcularTotal();
        });
    }

    vm.calcularTotal = function() {
        vm.totalDebito = 0;
        vm.totalCredito = 0;
        vm.totalSaldo = 0;

        // Credito
        for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
            if (vm.cedenteContaGraficaItens[i].selecionado && vm.cedenteContaGraficaItens[i].isCredito) {
                vm.totalCredito = vm.totalCredito + vm.cedenteContaGraficaItens[i].valorPresente;
            }
        }

        // Debito
        for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
            if (vm.cedenteContaGraficaItens[i].selecionado && vm.cedenteContaGraficaItens[i].isCredito == false) {
                vm.totalDebito = vm.totalDebito + vm.cedenteContaGraficaItens[i].valorPresente;
            }
        }

        vm.totalSaldo = vm.totalCredito - vm.totalDebito;
    }

    vm.confirmarAcerto = function() {
        var lista = [];

        for(var i=0; i < vm.cedenteContaGraficaItens.length; i++) {
            if (vm.cedenteContaGraficaItens[i].selecionado) {
                lista.push({
                        tituloContaCorrenteViewId: vm.cedenteContaGraficaItens[i].viewId
                    }
                );
            }
        }

        var request = {
            dataReferenciaProcessamento: vm.dataReferenciaProcessamento,
            dataPagamento: vm.dataPagamento,
            tipoPagamento: 1,
            valorPagamento: vm.valorPagamento.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.').replaceAll(' ',''),
            dataProcessamento: vm.dataProcessamento,
            cedenteViewId: vm.cedente.viewId,
            itens: lista,
        };

        vm.realizarAcertoPromise = $http.post(APP_MNP + "/contagrafica/cobrancaacerto/realizarAcerto", request)
        .success(function(response) {
            toastr.info('Operação realizada com sucesso.', 'Alerta');
            
            vm.listarExtratoGrupo();

            return response;
        }).error(function(error){
            toastr.error(error, 'Falha');
            return error;
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
angular.module('inspinia')
  .controller('ContaGraficaRotinaProcessarController', ['$scope', '$state', 'toastr', 'PagerService', '$http','APP_MNP',
      function($scope, $state, toastr, PagerService, $http, APP_MNP) 
{
    var vm = this;    
    vm.registros = null;
    vm.filtro = {
        codigo: '',
        nome: '',
        cnpj: ''
    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.pesquisar = function(perPage, index, orderBy, filter)
    {
        vm.registros = null;

        var codigo = "0";

        if (vm.filtro == null)
        {
            vm.filtro = {
                codigo: '',
                index: index,
                page: perPage
            }
        }

        if (vm.filtro.codigo != null && vm.filtro.codigo != '')
        {
            codigo = vm.filtro.codigo;
        }

        vm.filtro.page = index;
        vm.filtro.perPage = perPage;
        
        vm.pesquisarPromise = $http.post(APP_MNP + "/contagrafica/titulo/pesquisar", vm.filtro).success(function(response){
            vm.registros = response.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });
    }
    
    $scope.onSearch = function() {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPerPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.consultar = function(item)
    {
        $state.go('index.titulos_consultar', {obj: item.viewId});
    }

    vm.cadastrar = function()
    {
        //$state.go('index.cadastro_sacado');
    }

    vm.filtrarPesquisa = function()
    {
        $scope.pagination.perPage,$scope.pagination.current = 1;
        
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.init();

    vm.getTotalPages = function() {
        return new Array(7);   
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('CcbSimularController', ['$scope', '$state', 'toastr', 'APP_MNP', '$uibModal', '$http', '$sce',
      function($scope, $state, toastr, APP_MNP, $uibModal, $http, $sce)
  {
    var vm = this;
    var primeiroVencimento = new Date();
    vm.cedente = null;
    vm.originadores = [];
    vm.originador = {};
    vm.credoras = [];
    vm.credora = {};

    vm.registro = {
        dataEmprestimoDate: new Date(),
        juros: "5.00",
        numeroParcelas: 1,
        primeiroVencimentoDate: new Date(primeiroVencimento.setMonth(primeiroVencimento.getMonth() + 1)),
        valorRequeridoTexto: 100000,
        outrasDespesas: 0,
        aliquotaIofDia: 0.0041,
        aliquotaIofAdicional: 0.38,
        financiarIofTexto: 1,
    };

    vm.resultado = null;

    vm.init = function()
    {
      vm.listarOriginadores();
      vm.listarCredoras();
    }

    vm.listarOriginadores = function() {
      vm.consultaPromise = $http.get(APP_MNP + "/empresaoriginador/lista")
      .then(function(response)
      { 
          vm.originadores = response.data;

          if (vm.originadores.length > 0)
          {
              vm.originador = vm.originadores[0];
          }
          else {
            toastr.error('Não existem Originadores cadastrados.', 'Alerta');
          }
      });
    }

    vm.listarCredoras = function() {
      vm.consultaPromise = $http.get(APP_MNP + "/ccb/credoras")
      .then(function(response)
      { 
          vm.credoras = response.data;

          if (vm.credoras.length > 0)
          {
              vm.credora = vm.credoras[0];
          }
          else {
            toastr.error('Não existem Insituições Credoras CCB cadastrados.', 'Alerta');
          }
      });
    }    

    vm.selecionarCedenteModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/cedente/selecionar/index.html',
        controller: 'CedenteSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.cedente = null;
            if (data != null)
            {
                vm.cedente = data;

                if (vm.cedente.tipoPessoa == 0)
                {
                  vm.registro.aliquotaIofDia = 0.0041;
                }
                else {
                  vm.registro.aliquotaIofDia = 0.0082;
                }
            }      
        });
    }

    vm.simular = function()
    {
      vm.registro.financiarIof = vm.registro.financiarIofTexto == 2 ? true : false;

      if (vm.cedente == null) {
        toastr.error('Cedente é obrigatório.', 'Alerta');
        return;
      }

      vm.registro.valorRequerido = parseFloat(vm.registro.valorRequeridoTexto.toString().replaceAll('R$ ','0').replaceAll('.','').replaceAll(',','.'));

      if (vm.registro.valorRequerido <= 0) {
        toastr.error('Valor principal é obrigatório.', 'Alerta');
        return;
      }

      vm.registro.valorTac = parseFloat(vm.registro.valorTacTexto.toString().replaceAll('R$ ','0').replaceAll('.','').replaceAll(',','.'));

      if (vm.registro.valorRequerido <= 0) {
        toastr.error('Valor principal é obrigatório.', 'Alerta');
        return;
      }

      // Cedente
      if (vm.cedente == null) {
        toastr.error('Cedente é obrigatório.', 'Alerta');
        return;
      }
      vm.registro.cedenteViewId = vm.cedente.viewId;

      // InstituicaoCredora
      if (vm.credora == null) {
        toastr.error('Instituição Credora é obrigatório.', 'Alerta');
        return;
      }
      vm.registro.cedenteCredoraViewId = vm.credora.viewId;

      // Originador
      if (vm.originador == null) {
        toastr.error('Originador é obrigatório.', 'Alerta');
        return;
      }
      vm.registro.originadorViewId = vm.originador.viewId;

      vm.simularPromise = $http.post(APP_MNP + "/ccb/simularparcelas", vm.registro).success(function(response){
        
        vm.resultado = response;

        vm.filePropostaPdf = $sce.trustAsResourceUrl('data:application/pdf;base64,' + vm.resultado.simulacaoDocBase64);
        //toastr.info('Operação realizada com sucesso!', 'Alerta');
        return response;
      }).error(function(error){
        toastr.error(error, 'Falha');
        return error;
      });
    }

    vm.salvar = function() {

      vm.resultado.financiarIof = vm.registro.financiarIof;
      
      vm.simularPromise = $http.post(APP_MNP + "/ccb/salvarproposta", vm.resultado).success(function(response){
        //vm.resultado = response;
        toastr.info('Operação registrada com sucesso!', 'Alerta');

        vm.resultado = null;

        $state.go('index.ccb_consultar', {id: response.viewId});

        return response;
      }).error(function(error){
        toastr.error(error, 'Falha');
        return error;
      });
    }

    vm.alterarCredora = function() {

    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
  };

  }]);
'use strict';

angular.module('inspinia')
  .controller('CcbPesquisarController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModal, $http, APP_MNP)
  {
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status : ''
    }
    vm.lastOrder = '';
    vm.orderSelected = '';

    vm.init = function()
    {        
        vm.listar();
    }

    vm.listar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;

        vm.pesquisarPromise = $http.get(APP_MNP + "/ccb/pesquisar")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });        
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataVencimentoAte = vm.filtro.vencimentoAte;

        if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
        {
            dataVencimentoAte = addDays(vm.filtro.vencimentoAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '')
            {
                if (!vm.registrosOriginal[i].fornecedor.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.numeroAntecipacao != null && vm.filtro.numeroAntecipacao != '')
            {
                if (vm.registrosOriginal[i].numero != vm.filtro.numeroAntecipacao)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
            {
                if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '')
            {
                if (dataVencimentoAte < new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }
            
            if (vm.filtro.valorDe != null && vm.filtro.valorDe != '')
            {
                if (vm.filtro.valorDe > vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorAte != null && vm.filtro.valorAte != '')
            {
                if (vm.filtro.valorAte < vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.detalhe = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/ccb/pesquisar/detalhe/index.html',
            controller: 'CcbPesquisarDetalheController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            vm.listar();
        });
    }

    vm.consultar = function(p)
    {
        $state.go('index.ccb_consultar', {id: p.viewId});
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('CcbConsultarController', ['$scope', '$state', 'toastr', 'APP_MNP', '$uibModal', '$http', '$sce',
      function($scope, $state, toastr, APP_MNP, $uibModal, $http, $sce)
  {
    var vm = this;
    vm.viewId = $state.params.id;
    vm.registro = null;

    vm.init = function()
    {
      vm.carregar();
    }

    vm.carregar = function() {
      vm.consultaPromise = $http.get(APP_MNP + "/ccb/antecipacaodetalhe/" + vm.viewId)
      .then(function(response)
      { 
        vm.registro = response.data;

        vm.fileSimulacaoPdf = $sce.trustAsResourceUrl('data:application/pdf;base64,' + vm.registro.ccbPropostaDTO.propostaAprovada.simulacaoDocBase64);
        vm.filePropostaPdf = $sce.trustAsResourceUrl('data:application/pdf;base64,' + vm.registro.ccbPropostaDTO.propostaAprovada.propostaBase64);
        vm.fileTermoDeclaracaoPdf = $sce.trustAsResourceUrl('data:application/pdf;base64,' + vm.registro.ccbPropostaDTO.propostaAprovada.termoDeclaracaoBase64);
        vm.fileFichaCadastralPdf = $sce.trustAsResourceUrl('data:application/pdf;base64,' + vm.registro.ccbPropostaDTO.propostaAprovada.fichaCadastralBase64);
      
        vm.listarContas();
      });
    }

    vm.listarContas = function()
    {
        vm.listarContasPromise = $http.get(APP_MNP + "/cedente/listarContas/" + vm.registro.cedenteEmitente.viewId)
        .then(function(response)
        { 
            vm.contasBancarias = response.data;

            if (vm.registro.ccbPropostaDTO.cedenteDomicilioBancarioViewId != null) {
              for (var i=0; i<vm.contasBancarias.length;i++) {
                if (vm.registro.ccbPropostaDTO.cedenteDomicilioBancarioViewId == vm.contasBancarias[i].viewId) {
                  vm.contaBancaria = vm.contasBancarias[i];
                }
              }
            }
        });
    }

    vm.alterarContaBancaria = function() {
      vm.registro.ccbPropostaDTO.cedenteDomicilioBancarioViewId = vm.contaBancaria.viewId;

      vm.atualizar();
    }

    vm.atualizar = function() {
      var request = {
        antecipacaoViewId: vm.registro.viewId,
        cedenteDomicilioBancarioViewId: vm.registro.ccbPropostaDTO.cedenteDomicilioBancarioViewId,
      };

      vm.consultaPromise = $http.post(APP_MNP + "/ccb/atualizarproposta", request).success(function(response){
        
        toastr.info('Dados atualizados com sucesso!', 'Alerta');

        vm.carregar();

        return response;
      }).error(function(error){
        toastr.error(error, 'Falha');
        return error;
      });
    }

    vm.aprovar = function() {
      vm.consultaPromise = $http.post(APP_MNP + "/ccb/aprovarproposta/" + vm.registro.viewId).success(function(response){
        
        toastr.info('Operação aprovada com sucesso!', 'Alerta');

        vm.carregar();

        return response;
      }).error(function(error){
        toastr.error(error, 'Falha');
        return error;
      });
    }

    vm.assinaturaAprovada = function() {
      vm.consultaPromise = $http.post(APP_MNP + "/ccb/assinaturaaprovada/" + vm.registro.viewId).success(function(response){
        
        toastr.info('Operação realizada com sucesso!', 'Alerta');
        
        vm.carregar();

        return response;
      }).error(function(error){
        
        vm.carregar()

        toastr.error(error, 'Falha');
        return error;
      });
    }

    vm.verLogIntegracao = function(p) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/ccb/consultar/log/index.html',
        controller: 'CcbConsultarDetalheLogController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
            id: function () {
                return p.logIntegracaoId;
            },
        }
      }).closed.then(function(){
          //vm.listar();
      });
    }

    vm.excluir = function() {
      if (confirm('Deseja realmente excluir este registro?')) {
          vm.excluirPromise = $http.delete(APP_MNP + "/ccb/excluir/" + vm.registro.viewId).success(function(response){
              toastr.info('Registro excluído com sucesso.', 'Alerta');   
              $state.go('index.invoice_antecipacoes');      
              return response;
          }).error(function(error){
              toastr.error(error, 'Alerta');
              return error;
          });
      }
    }

    vm.downloadAssinanetXml = function() {
      vm.download(vm.registro.ccbPropostaDTO.assinanetArquivoEnviadoBase64, 'application/xml', 'ccb.xml');
    }

    vm.validar = function() {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/ccb/consultar/validar/index.html',
        controller: 'CcbConsultarValidarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
            id: function () {
                return vm.registro.viewId;
            },
        }
      }).closed.then(function(){
          //vm.listar();
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

    vm.download = function(dados, tipo, nome)
    {
        var file = vm.b64toBlob(dados, tipo);

        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        var sliceSize = 512
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
        
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
        
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

  }]);
'use strict';

angular.module('inspinia')
  .controller('ClienteTemplateController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal)
{
    var vm = this;
    vm.templateSelecionado = null;

    vm.init = function()
    {
        vm.pesquisar();
    }

    $scope.options = {        
        toolbar: [
            ['edit',['undo','redo']],
            ['headline', ['style']],
            ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
            ['fontface', ['fontname']],
            ['textsize', ['fontsize']],
            ['fontclr', ['color']],
            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
            ['height', ['height']],
            ['table', ['table']],
            ['insert', ['link','picture','hr']],
            ['view', ['codeview']],
            ['help', ['help']]
        ]
    };

    vm.pesquisar = function()
    {
        vm.pesquisarPromise = $http.get(APP_MNP + "/empresa/templates/get")
        .then(function(response)
        { 
            vm.registros = response.data;

            if (vm.registros != null && vm.registros.length > 0)
            {
                vm.templateSelecionado = vm.registros[0];
            }
        });
    }

    vm.selecionarTemplate = function() {

    }

    vm.salvar = function()
    {
        vm.salvarPromise = $http.put(APP_MNP + "/empresa/templates/update", vm.templateSelecionado).success(function(response){
            toastr.info('Template atualizado com sucesso.', 'Alerta');            
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.campos = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/email/template/campos/index.html',
        controller: 'FornecedorIncluirEmpresaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        //backdrop: 'static',
        size: 'lg',
        /*
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          empresa: function () {
            return empresa;
          },
          indice: function () {
            return 0;
          },
        }
        */
      }).closed.then(function(){
        //vm.consultar();
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('ConfigOriginadoresPesquisarController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        status: '1'
    };
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        vm.pesquisar(); 
    }

    vm.pesquisar = function()
    {
        vm.registrosOriginal = null;
        vm.registros = null;
        
        vm.consultarPromise = $http.get(APP_MNP + "/empresaoriginador/pesquisaric");
        
        vm.consultarPromise.then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.consultar = function(registro)
    {
        $state.go('index.originador_consultar', {obj: registro.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('ConfigTarifasConsultarController', ['$scope', '$state', 'toastr', 'APP_MNP', '$http',
      function($scope, $state, toastr, APP_MNP, $http)
  {
    var vm = this;
    vm.originadores = [];
    vm.originador = {};
    vm.registro = {
        tipoCalculo: 1
    }

    vm.init = function()
    {
        vm.listarOriginadores();
        //vm.consultar();
    }

    vm.listarOriginadores = function() {
        vm.consultaPromise = $http.get(APP_MNP + "/empresaoriginador/lista")
        .then(function(response)
        { 
            vm.originadores = response.data;

            if (vm.originadores.length > 0)
            {
                vm.originador = vm.originadores[0];
                vm.consultar();
            }
        });
    }

    vm.alterarOriginador = function() 
    {
        /*
        vm.consultaPromise = $http.get(APP_MNP + "/empresaoriginador/tarifas/" + vm.originador.viewId)
        .then(function(response)
        { 
            vm.registro = response.data;
        });
        */
        vm.consultar();
    }

    vm.consultar = function()
    {
        vm.consultaPromise = $http.get(APP_MNP + "/empresaoriginador/tarifas/" + vm.originador.viewId)
        .then(function(response)
        { 
            vm.registro = response.data;
            vm.registro.taxaOperacao = vm.registro.taxaOperacao.toFixed(2);
            vm.registro.taxaAdValorem = vm.registro.taxaAdValorem.toFixed(2);
            vm.registro.tarifaAvaliacaoCredito = vm.registro.tarifaAvaliacaoCredito.toFixed(2);
            vm.registro.tarifaCobranca = vm.registro.tarifaCobranca.toFixed(2);
            vm.registro.tarifaConsultaCredito = vm.registro.tarifaConsultaCredito.toFixed(2);
            vm.registro.tarifaTED = vm.registro.tarifaTED.toFixed(2);
            vm.registro.taxaAtrasoPagamento = vm.registro.taxaAtrasoPagamento.toFixed(2);
            vm.registro.taxaCOFINS = vm.registro.taxaCOFINS.toFixed(2);
            vm.registro.taxaCSLL = vm.registro.taxaCSLL.toFixed(2);
            vm.registro.taxaFixoIOF = vm.registro.taxaFixoIOF.toFixed(2);
            vm.registro.taxaIOF = vm.registro.taxaIOF.toFixed(2);
            vm.registro.taxaIRRF = vm.registro.taxaIRRF.toFixed(2);
            vm.registro.taxaISS = vm.registro.taxaISS.toFixed(2);
            vm.registro.taxaPIS = vm.registro.taxaPIS.toFixed(2);
            vm.registro.tipoCalculo = vm.registro.tipoCalculo;

            vm.registro.taxaContaGrafica = vm.registro.taxaContaGrafica.toFixed(2);
            vm.registro.tipoCalculoContaGrafica = vm.registro.tipoCalculoContaGrafica;
            vm.registro.tipoTaxaContaGrafica = vm.registro.tipoTaxaContaGrafica;

            vm.registro.tarifaInstProrrogacao = vm.registro.tarifaInstProrrogacao.toFixed(2);
            vm.registro.tarifaInstBaixa = vm.registro.tarifaInstBaixa.toFixed(2);
            vm.registro.tarifaInstAbatimento = vm.registro.tarifaInstAbatimento.toFixed(2);
            vm.registro.tarifaInstSustarCartorio = vm.registro.tarifaInstSustarCartorio.toFixed(2);
            vm.registro.tarifaInstEnviarCartorio = vm.registro.tarifaInstEnviarCartorio.toFixed(2);
            vm.registro.tarifaInstSustarProtesto = vm.registro.tarifaInstSustarProtesto.toFixed(2);
            //vm.registros = response.data;
        });
        //vm.consultarPromise = ClienteService.get();
    }

    vm.atualizar = function()
    {
        if (vm.registro.taxaOperacao == null)
        {
            alert('Favor preencher corretamente a taxa da operação.');
            return;
        }

        if (vm.registro.taxaAdValorem == null)
        {
            alert('Favor preencher corretamente a taxa de Ad Valorem.');
            return;
        }

        if (vm.registro.tarifaCobranca == null)
        {
            alert('Favor preencher corretamente a tarifa de cobrança.');
            return;
        }

        if (vm.registro.tarifaAvaliacaoCredito == null)
        {
            alert('Favor preencher corretamente a tarifa de avaliação de crédito.');
            return;
        }

        if (vm.registro.tarifaConsultaCredito == null)
        {
            alert('Favor preencher corretamente a tarifa de consulta de crédito.');
            return;
        }

        if (vm.registro.tarifaTED == null)
        {
            alert('Favor preencher corretamente a tarifa TED.');
            return;
        }

        if (vm.registro.taxaContaGrafica == null)
        {
            alert('Favor preencher corretamente a taxa da conta gráfica.');
            return;
        }

        vm.registro.tipoCalculo = parseInt(vm.registro.tipoCalculo);

        vm.registro.socios = null;

        vm.consultaPromise = $http.put(APP_MNP + "/empresaoriginador/tarifas", vm.registro).success(function(response){
            toastr.info('Tarifas atualizadas com sucesso.', 'Alerta');
            vm.consultar();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('ClienteConsultaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', '$uibModal', 'AuthService',
      function($scope, $state, toastr, $http, APP_MNP, $uibModal, AuthService)
{
    var vm = this; 

    vm.init = function()
    {
        vm.empresaId = AuthService.getEmpresaId();

        vm.pesquisar();
    }

    vm.pesquisar = function()
    {
        return $http.get(APP_MNP + "/empresa/consultarPerfil/" + vm.empresaId )
        .then(function(response)
        { 
            vm.cliente = response.data;
             vm.consultarLogo();  // Adiciona a consulta do logo aqui
        });
    }

    //vm.consultarLogo = function() {
    //    return $http.get(APP_MNP + "/empresa/consultarlogo")
    //        .then(function(response) {
//
    //            if (response.data) {
    //                vm.logoUrl = 'data:image/jpg;base64,' + response.data;
    //              // vm.logoUrl = 'data:image/jpeg;base64,<>';
//
    //            } else {
    //                vm.logoUrl = null;
    //            }
    //        }, function(error) {
    //            // Não exibir mensagem de erro se o logo não existir
    //            console.log('Logo não encontrado ou erro ao consultar o logo.');
    //        });
    //};

    vm.consultarLogo = function() {
        return $http.get(APP_MNP + "/empresa/consultarlogo", {responseType: 'arraybuffer'})
            .then(function(response) {

                if (response.data) {
                    var blob = new Blob([response.data], {type: 'image/png'});
                    vm.logoUrl = (window.URL || window.webkitURL).createObjectURL(blob);
                } else {
                    vm.logoUrl = null;
                }
            }, function(error) {
                // Não exibir mensagem de erro se o logo não existir
                console.log('Logo não encontrado ou erro ao consultar o logo.');
            });
    };

    

    vm.uploadLogo = function() {
        if (!vm.logoFile) {
            toastr.error('Por favor, selecione um arquivo.', 'Erro');
            return;
        }

        var reader = new FileReader();
        reader.onload = function(event) {
            var base64String = event.target.result.split(',')[1];
            
            var logoEmpresaDTO = {
                Arquivo: base64String
            };

            $http.post(APP_MNP + '/empresa/atualizarlogo', logoEmpresaDTO)
            .then(function(response) {
                toastr.success('Logo atualizado com sucesso!', 'Sucesso');
                vm.consultarLogo();
            }, function(error) {
                toastr.error('Erro ao fazer upload do logo.', 'Erro');
            });
        };
        
        reader.readAsDataURL(vm.logoFile);
    };


   vm.atualizar = function() {
        // Verifica se o campo de horário foi preenchido corretamente
        if (!validarHorario(vm.cliente.horarioLimite)) {
            return;
        }

        vm.salvarPromise = $http.post(APP_MNP + "/empresa/alterarPerfil/", vm.cliente)
            .success(function(response) {
                toastr.info('Cliente atualizado com sucesso.', 'Alerta');
                return response;
            })
            .error(function(error) {
                return error;
            });
    };

    function validarHorario(horario) {
        
        if (!horario) {
            // Se o campo estiver vazio, consideramos válido
            return true;
        }
    
    
        // Verifica se a hora não é maior que 23 e os minutos não são maiores que 59
        var partes = horario.split(':');
        var hora = parseInt(partes[0]);
        var minuto = parseInt(partes[1]);
        if (hora > 23 || minuto > 59) {
            toastr.error('Hora ou Minuto inválido, formato HH:MM.', 'Erro');
            return false;
        }
    
        return true;
    }
    
  
    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('ConfigFeriadosConsultarController', ['$scope', '$state', 'toastr', 'APP_MNP', '$uibModal', '$http',
      function($scope, $state, toastr, APP_MNP, $uibModal, $http)
  {
    var vm = this;
    vm.ano = '2025';

    vm.init = function()
    {
      vm.consultar();
    }

    vm.consultar = function()
    {
      vm.consultaPromise = $http.get(APP_MNP + "/feriado/listar/" + vm.ano)
      .then(function(response)
      { 
          vm.feriados = response.data;                    
      });
    }

    vm.adicionarFeriado = function()
    {
      var modalInstance = $uibModal.open({
          templateUrl: 'app/cliente/feriado/inserir/index.html',
          controller: 'ConfigInserirFeriadoController',
          controllerAs: 'controller',
          windowClass: 'inmodal',
          size: 'md'
      }).closed.then(function(){
          vm.consultar();
      });
    }

    vm.excluirFeriado = function(feriado)
    {
      vm.consultaPromise = $http.post(APP_MNP + "/feriado/excluir", feriado).success(function(response){
        toastr.info('Exclusão realizada com sucesso!', 'Feriado');
        vm.consultar();     
        return response;
      }).error(function(error){
        toastr.error(error, 'Feriado');
        return error;
      });
    }

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('ConfigCfopRestritoController', ['$scope', '$state', 'toastr', 'APP_MNP', '$uibModal', '$http',
      function($scope, $state, toastr, APP_MNP, $uibModal, $http)
  {
    var vm = this;
    vm.cfop = null;

    vm.init = function()
    {
      vm.listarDisponiveis();
      vm.listarRestritos();
    }

    vm.listarDisponiveis = function()
    {
      vm.consultaPromise = $http.get(APP_MNP + "/cfop/all")
      .then(function(response)
      { 
          vm.disponiveis = response.data;                    
      });
    }

    vm.listarRestritos = function()
    {
      vm.consultaPromise = $http.get(APP_MNP + "/cfop/restritos")
      .then(function(response)
      { 
          vm.restritos = response.data;                    
      });
    }

    vm.adicionar = function()
    {
      if (vm.cfop != null)
      {
        $http.post(APP_MNP + "/cfop/restringir", vm.cfop).success(function(response){
          toastr.info('Operação realizada com sucesso!', 'Alerta');
          vm.cfop = null;
          vm.listarRestritos();     
          return response;
        }).error(function(error){
          toastr.error(error, 'Falha');
          return error;
        });
      }
      else
      {
        toastr.error('Selecione uma CFOP.', 'Falha');
      }
    }

    vm.excluir = function(item)
    {
      $http.post(APP_MNP + "/cfop/remover", item).success(function(response){
        toastr.info('Exclusão realizada com sucesso!', 'Alerta');
        vm.listarRestritos(); 
        return response;
      }).error(function(error){
        toastr.error(error, 'Falha');
        return error;
      });
    }

    vm.init();

  }]);
angular.module('inspinia')
  .controller('CadastroInvestidorPesquisaController', ['$scope', '$state', 'toastr', '$http', 'APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
{
    var vm = this;
    vm.registros = null;
    vm.items = [];
    vm.busca = '';

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
        vm.pesquisar();
    }

    vm.pesquisar = function()
    {
        vm.registros = null;
        $scope.pagination.current = 1;

        vm.consultarPromise = $http.get(APP_MNP + "/investidor/vinculados", { params: { busca: vm.busca || '' } }).success(function(response){
            vm.registros = response || [];
            $scope.pagination.totalItems = vm.registros.length;
            vm.atualizarPagina();
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.atualizarPagina = function()
    {
        var inicio = ($scope.pagination.current - 1) * $scope.pagination.perPage;
        vm.items = (vm.registros || []).slice(inicio, inicio + $scope.pagination.perPage);
    }

    $scope.onPageChange = function() {
        vm.atualizarPagina();
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_investidor');
    }

    vm.remover = function(investidor)
    {
        if (!confirm('Remover o vínculo com "' + investidor.nome + '"? Ele deixará de aparecer para a sua empresa.'))
        {
            return;
        }

        $http.delete(APP_MNP + "/investidor/empresa/" + investidor.viewId).success(function(response){
            toastr.info('Vínculo removido com sucesso.', 'Alerta');
            vm.pesquisar();
        }).error(function(error){
            toastr.error(error, 'Alerta');
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);

angular.module('inspinia')
  .controller('CadastroSacadoPesquisaController', ['$scope', '$state', 'toastr', 'PagerService', '$http','APP_MNP',
      function($scope, $state, toastr, PagerService, $http, APP_MNP) 
{
    var vm = this;    
    vm.registros = null;
    vm.filtro = {
        codigo: '',
        nome: '',
        cnpj: '',
        uf: ''
    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.pesquisar = function(perPage, index, orderBy, filter)
    {
        vm.registros = null;

        var codigo = "0";
        var nome = "0";
        var cnpj = "0";
        var uf = "0";

        if (vm.filtro == null)
        {
            vm.filtro = {
                codigo: '',
                nome: '',
                cnpj: '',
                uf: '',
                index: index,
                page: perPage
            }
        }

        if (vm.filtro.codigo != null && vm.filtro.codigo != '')
        {
            codigo = vm.filtro.codigo;
        }
        if (vm.filtro.nome != null && vm.filtro.nome != '')
        {
            nome = vm.filtro.nome;
        }
        if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
        {
            cnpj = vm.filtro.cnpj;
        }
        if (vm.filtro.uf != null && vm.filtro.uf != '')
        {
            uf = vm.filtro.uf;
        }

        vm.filtro.page = index;
        vm.filtro.perPage = perPage;
        
        //vm.consultarPromise = $http.get(APP_MNP + "/sacado/pesquisarPage/" + index + "/" + perPage + "/" + codigo + "/" + nome + "/" + cnpj);
        
        vm.consultarPromise = $http.post(APP_MNP + "/sacado/pesquisarPage", vm.filtro).success(function(response){
            vm.registros = response.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });

        /*
        vm.consultarPromise = $http.post(APP_MNP + "/sacado/pesquisarPage", vm.filtro);

        vm.consultarPromise.then(function(response)
        {             
            vm.registros = response.data.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = response.data.pages;
        });
        */
    }
    
    $scope.onSearch = function() {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPerPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.consultar = function(sacado)
    {
        $state.go('index.cadastro_sacado_consulta', {obj: sacado});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_sacado');
    }

    vm.filtrarPesquisa = function()
    {
        $scope.pagination.perPage,$scope.pagination.current = 1;
        
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.init();

    vm.getTotalPages = function() {
        return new Array(7);   
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
angular
.module('inspinia').factory("UsuarioService", ['$http', 'APP_MNP', 'AuthService', 
    function ($http, APP_MNP, AuthService) {
    return {
        login: function(login, pwd){
            var data = {
                login: login,
                senha: pwd
            }
            return $http.post(APP_MNP + "/token/user", data).then(
                function(response){
                    AuthService.setToken(response.data.accessToken);
                    AuthService.setUser(response.data.userName);
                    AuthService.setEmpresa(response.data.empresa);
                    AuthService.setRole(response.data.role);
                    return response;
                },
                function (error) {
                    return error;
                }
            )
        },
        insert: function(usuario){
            return $http.post(APP_MNP + "/usuario/enviar", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        update: function(viewId, usuario){
            usuario.ViewId = viewId;
            return $http.post(APP_MNP + "/usuario/alterar", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        updatePassword: function(oldPassword, newPassword){
            usuario = {};
            usuario.oldPassword = oldPassword;
            usuario.newPassword = newPassword;
            return $http.post(APP_MNP + "/usuario/updatePassword", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        delete: function(usuario){
            return $http.post(APP_MNP + "/usuario/remove", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },       
        get: function (viewId) {
            return $http.get(APP_MNP + "/usuario/" + viewId)
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAll: function () {
            return $http.get(APP_MNP + "/usuario/GetAll")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getMenu: function (viewId) {
            return $http.get(APP_MNP + "/menu")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioPesquisaController', ['$scope', '$state', 'UsuarioService', 'toastr', 'PagerService',
      function($scope, $state, UsuarioService, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.usuarios.length, page);
      vm.items = vm.usuarios.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.pesquisar = function()
    {
      var usuariosPromise = UsuarioService.getAll();

      usuariosPromise.then(function(result) {  
        if (result.status)
        {
          vm.usuarios = result.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
        }
      });
    }

    vm.incluir = function()
    {
      $state.go('index.cadastrarusuario');
    }

    vm.visualizar = function(usuario)
    {
      $state.go('index.consultarusuario', {obj: usuario});
    }

    vm.alterar = function(usuario)
    {
      $state.go('index.alterarusuario', {obj: usuario});
    }    

    vm.excluir = function(usuario)
    {
      $state.go('index.excluirUsuario', {obj: usuario});
    }   

    
    vm.pesquisar();

  }]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioLoginController', ['$scope', '$state', 'toastr', 'AuthService', 
      function($scope, $state, toastr, AuthService)
  {
    var vm = this;

    vm.init = function()
    {
        
    }

    vm.init();

  }]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioCadastroController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
{
    var vm = this;

    vm.usuario = {};

    vm.incluir = function()
    {
      var usuarioPromise = UsuarioService.insert(vm.usuario);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário cadastrado com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoSenhaController', ['$scope', '$state', 'toastr', '$http', 'APP_MNP',
      function($scope, $state, toastr, $http, APP_MNP)
  {
    var vm = this;

    vm.atualizar = function()
    {
      var request = {
        senhaAnterior: vm.oldPassword,
        novaSenha: vm.newPassword
      };

      vm.aprovarAberturaPromise = $http.post(APP_MNP + "/usuario/alterarsenha", request).success(function(response){
        toastr.info('Senha atualizada com sucesso.', 'Alerta');   
        $state.go('index.main');          
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
      
      /*
      var usuarioPromise = UsuarioService.updatePassword(vm.oldPassword, vm.newPassword);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário alterado com sucesso!', 'Usuário');
          $state.go('index.main');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
      */
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
  {
    var vm = this;

    vm.usuario = {};
    vm.usuarioParam = $state.params.obj;

    vm.consultar = function()
    {
      var usuarioConsultaPromise = UsuarioService.get(vm.usuarioParam.ViewId);

      usuarioConsultaPromise.then(function(result) {  
        vm.usuario = result;
      });
    }

    vm.alterar = function()
    {
      var usuarioPromise = UsuarioService.update(vm.usuarioParam.ViewId, vm.usuario);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário alterado com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.excluir = function()
    {
      var deleteUsuarioPromise = UsuarioService.delete(vm.usuarioParam);

      deleteUsuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário excluído com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.init = function()
    {
      if (vm.usuarioParam == null)
      {
        $state.go('index.pesquisarusuario');
      }
      else
      {
        vm.consultar();
      }
    }

    vm.init();

}]);

angular.module('inspinia')
    .factory('AuthService', AuthService);

function AuthService ($localStorage, $q) {
    return {
    getToken : function () {
        return $localStorage.tokenCli;
    },
    setToken: function (token) {
        $localStorage.tokenCli = token;
    },
    getUser : function () {
        return $localStorage.user;
    },
    setUser: function (user) {
        $localStorage.user = user;
    },
    getEmpresa : function () {
        return $localStorage.empresa;
    },
    setEmpresa: function (empresa) {
        $localStorage.empresa = empresa;
    },
    getRole : function () {
        return $localStorage.role;
    },
    setRole: function (role) {
        $localStorage.role = role;
    },
    getPentahoCodigo : function () {
        return $localStorage.agfnPentahoCodigo;
    },
    setPentahoCodigo: function (codigo) {
        $localStorage.agfnPentahoCodigo = codigo;
    },
    getPentahoRelatorios : function () {
        return $localStorage.agfnPentahoRelatorios;
    },
    setPentahoRelatorios: function (codigo) {
        $localStorage.agfnPentahoRelatorios = codigo;
    },
    getPentahoLogo : function () {
        return $localStorage.agfnPentahoLogo;
    },
    setPentahoLogo: function (codigo) {
        $localStorage.agfnPentahoLogo = codigo;
    },
    getUrlPentaho : function () {
        return $localStorage.urlPentaho;
    },
    setUrlPentaho: function (codigo) {
        $localStorage.urlPentaho = codigo;
    },
    getUserRest : function () {
        return $localStorage.agfnUserRest;
    },
    setUserRest: function (codigo) {
        $localStorage.agfnUserRest = codigo;
    },
    getCodigoVmoney : function () {
        return $localStorage.codigoVMoneyCedente;
    },
    setCodigoVmoney: function (codigo) {
        $localStorage.codigoVMoneyCedente = codigo;
    },
    getMenu : function () {
        return $localStorage.menu;
    },
    setMenu: function (menu) {
        $localStorage.menu = menu;
    },
    getMnow : function () {
        return $localStorage.perfil;
    },
    setMnow: function (perfil) {
        $localStorage.perfil = perfil;
    },
    getOperacaoMn : function () {
        return $localStorage.isOperacaoMoneyNow;
    },
    setOperacaoMn: function (isOperacaoMoneyNow) {
        $localStorage.isOperacaoMoneyNow = isOperacaoMoneyNow;
    },
    getMenusIds : function () {
        return $localStorage.menusids;
    },
    setMenusIds: function (menusids) {
        $localStorage.menusids = menusids;
    },
    getEmpresaId : function () {
        return $localStorage.empresaId;
    },
    setEmpresaId: function (empresaId) {
        $localStorage.empresaId = empresaId;
    },
    getUsoDeBoleto: function () {
        return $localStorage.usoDeBoleto;
    },    
    setUsoDeBoleto: function (id) {
        $localStorage.usoDeBoleto = id;
    },  
    getHorarioLimite: function () {
        return $localStorage.horarioLimite;
    },    
    setHorarioLimite: function (horarioLimite) {
        $localStorage.horarioLimite = horarioLimite;
    },   
    getComunicadoLiberado: function () {
        return $localStorage.comunicadoLiberado;
    },    
    setComunicadoLiberado: function (comunicadoLiberado) {
        $localStorage.comunicadoLiberado = comunicadoLiberado;
    },   
    getTipoDocumentoDescricao: function() {
        return tipoDocumentoDescricao;
    },
    setTipoDocumentoDescricao: function(value) {
        tipoDocumentoDescricao = value;
    },         
    logout : function (data) {
        delete $localStorage.tokenCli;
        delete $localStorage.token;
        delete $localStorage.user;
        delete $localStorage.role;
        delete $localStorage.agfnPentahoCodigo;
        delete $localStorage.agfnPentahoRelatorios;
        delete $localStorage.menu;
        delete $localStorage.perfil;
        delete $localStorage.isOperacaoMoneyNow;
        delete $localStorage.agfnPentahoLogo;
        delete $localStorage.agfnUserRest;
        delete $localStorage.empresaId;
        delete $localStorage.usoDeBoleto;
        delete $localStorage.horarioLimite;
        delete $localStorage.comunicadoLiberado;
        delete $localStorage.tipoDocumentoDescricao;
        $q.when();
    }
    };
}
angular.module('inspinia')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(function($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
});

function AuthInterceptor ($location, AuthService, $q) {
    return {
    request: function(config) {
        config.headers = config.headers || {};

        if (!config.skipInterceptor && AuthService.getToken()) {
            config.headers['Authorization'] = 'Bearer ' + AuthService.getToken();
        }
        
        return config;
    },

    responseError: function(response) {
        if (response.status === 401 || response.status === 403) {
        $location.path('/login');
        }

        return $q.reject(response);
    }
    }
}
'use strict';

angular.module('inspinia')
    .controller('MainController', ['$state', '$location', 'AuthService', 'toastr', '$cookieStore', '$http', 'APP_MNP', '$uibModal', '$rootScope',
        function ($state, $location, AuthService, toastr, $cookieStore, $http, APP_MNP, $uibModal, $rootScope) {

            var vm = this;
            vm.usuario = {};
            vm.default = '';
            vm.logoempresa = '';

            vm.userName = AuthService.getUser();
            vm.empresaName = AuthService.getEmpresa();
            vm.empresaId = AuthService.getEmpresaId();
            vm.pentahoCodigoCliente = AuthService.getPentahoCodigo();
            vm.pentahoRelatorios = AuthService.getPentahoRelatorios();
            vm.pentahoLogo = AuthService.getPentahoLogo();
            vm.mnow = AuthService.getMnow();
            vm.isOperacaoMoneyNow = AuthService.getOperacaoMn();
            vm.userRest = AuthService.getUserRest();
            vm.urlPentaho = AuthService.getUrlPentaho();
            vm.menusIds = AuthService.getMenusIds();
            vm.usoDeBoleto = AuthService.getUsoDeBoleto();
            vm.horarioLimite = AuthService.getHorarioLimite();
            vm.comunicadoLiberado = AuthService.getComunicadoLiberado();


            vm.init = function () {
                if ($cookieStore.get('lastLoginAgFinanceiro') != null) {
                    vm.usuario.Login = $cookieStore.get('lastLoginAgFinanceiro');
                }

                vm.s_subdomain();
                vm.consultarLogo();
            }

            vm.logoFetchFalhou = false;

            // Mesma lista de empresaMainId usada em web-cliente-modern/layout/sidebar/sidebar.component.ts (CNAB_IDS)
            // para restringir quem vê "Cnab Sincronizado" no menu — mantém a regra idêntica nos dois clientes.
            var CNAB_IDS = [
                '76aff93e-1619-4000-8e0c-71f88a9347e4',
                '894e2ea4-c9fa-47e2-bc7c-f59cd0850536',
                'bb1dc199-3c67-4fff-9aea-11f6055bdace',
                'cfcb6e04-3bd3-4b2f-b319-1346a0c7e9bf'
            ];
            vm.podeVerCnabSincronizado = function () {
                return CNAB_IDS.indexOf((vm.empresaId || '').toLowerCase()) !== -1;
            };

            vm.consultarLogo = function () {
                return $http.get(APP_MNP + "/empresa/consultarlogo", { responseType: 'arraybuffer' })
                    .then(function (response) {
                        vm.logoFetchFalhou = false;

                        if (response.data) {
                            var blob = new Blob([response.data], { type: 'image/png' });
                            vm.logoUrl = (window.URL || window.webkitURL).createObjectURL(blob);
                        } else {
                            vm.logoUrl = null;
                        }
                    }, function (error) {
                        // Falha transitória (rede/timing) — diferente de "cliente sem logo cadastrado".
                        // Mantém o fallback visual, mas marca para tentar de novo na próxima navegação
                        // (ver $rootScope.$on('$stateChangeSuccess') abaixo), em vez de travar como definitivo.
                        vm.logoFetchFalhou = true;
                        vm.logoUrl = 'assets/images/icons/icon_rb.png';
                    });
            };

            // Auto-recuperação: se consultarLogo() falhou por motivo transitório, tenta de novo a cada
            // troca de rota até conseguir uma resposta definitiva do servidor (sucesso ou "sem logo").
            $rootScope.$on('$stateChangeSuccess', function () {
                if (vm.logoFetchFalhou) {
                    vm.consultarLogo();
                }
            });


            vm.s_subdomain = function () {
                var host = $location.host();
                vm.usuario.Host = host;

                if (host.indexOf('.') < 0) {
                    //vm.logoempresa = 'assets/images/icons/logo_mondo_capital.png';
                    vm.logoempresa = 'assets/images/icons/logo.png';
                }
                else {
                    var subdomain = host.split('.')[0];

                    return $http.get(APP_MNP + "/cliente/imagelogo/" + subdomain)
                        .then(function (response) {
                            vm.logoempresa = (APP_MNP + "/cliente/imagelogo/" + subdomain);
                        }).catch(function (data) {
                            vm.logoempresa = 'assets/images/icons/logo.png';
                            //toastr.error(data, 'Alerta');
                        });

                    /*
                    if (subdomain == 'mondocapital')
                    {
                        vm.logoempresa = 'assets/images/icons/logo_mondo_capital.png';
                    }
                    else if (subdomain == 'mansbank')
                    {
                        vm.logoempresa = 'assets/images/icons/mansbank.png';
                    }
                    else
                    {
                        return $http.get(APP_MNP + "/cliente/imagelogo/" + subdomain)
                        .then(function(response)
                        { 
                            vm.logoempresa = (APP_MNP + "/cliente/imagelogo/" + subdomain);
                        }).catch(function (data) {
                            vm.logoempresa = 'assets/images/icons/logo.png';
                            //toastr.error(data, 'Alerta');
                        });            
                    }
                    */
                }
            }

            vm.init();

            vm.login = function () {
                if (vm.usuario.Login == null || vm.usuario.Login == '') {
                    toastr.error('Informe o Login da empresa.', 'Login');
                    return;
                }

                if (vm.usuario.Senha == null || vm.usuario.Senha == '') {
                    toastr.error('Informe a Senha.', 'Login');
                    return;
                }

                $cookieStore.put('lastLoginAgFinanceiro', vm.usuario.Login);

                vm.loginPromise = vm.realizarLogin(vm.usuario.Login, vm.usuario.Senha, vm.usuario.Host);

                vm.loginPromise.then(function (result) {
                    if (result.data.error == null && result.data.authenticated) {
                        vm.default = result.data.default;

                        vm.userName = AuthService.getUser();
                        vm.empresaName = AuthService.getEmpresa();
                        vm.menus = AuthService.getMenu();
                        vm.pentahoCodigoCliente = AuthService.getPentahoCodigo();
                        vm.pentahoRelatorios = AuthService.getPentahoRelatorios();
                        vm.pentahoLogo = AuthService.getPentahoLogo();
                        vm.codigoCedenteVmoney = AuthService.getCodigoVmoney();
                        vm.userRest = AuthService.getUserRest();
                        vm.empresaId = AuthService.getEmpresaId();
                        vm.menusIds = AuthService.getMenusIds();

                        vm.mnow = AuthService.getMnow();
                        vm.isOperacaoMoneyNow = AuthService.getOperacaoMn();
                        vm.urlPentaho = AuthService.getUrlPentaho();
                        vm.usoDeBoleto = AuthService.getUsoDeBoleto();
                        vm.horarioLimite = AuthService.getHorarioLimite();
                        vm.comunicadoLiberado = AuthService.getComunicadoLiberado();
                        //vm.role = AuthService.getRole();

                        $state.go("index.main");
                    }
                    else {
                        toastr.error("Login e/ou senha inválidos.", 'Login');
                    }
                });
            }

            vm.realizarLogin = function (login, pwd, host) {
                var data = {
                    login: login,
                    senha: pwd,
                    host: host
                }
                return $http.post(APP_MNP + "/token/user", data).then(
                    function (response) {
                        AuthService.setToken(response.data.accessToken);
                        AuthService.setUser(response.data.userName);
                        AuthService.setEmpresa(response.data.empresa);
                        AuthService.setPentahoCodigo(response.data.pentahoCodigoCliente);
                        AuthService.setPentahoRelatorios(response.data.pentahoRelatorios);
                        AuthService.setPentahoLogo(response.data.pentahoLogo);
                        AuthService.setCodigoVmoney(response.data.codigoCedenteVmoney);
                        AuthService.setMnow(response.data.perfil);
                        AuthService.setOperacaoMn(response.data.isOperacaoMoneyNow);
                        AuthService.setUserRest(response.data.userRest);
                        AuthService.setEmpresaId(response.data.empresaId);
                        AuthService.setUrlPentaho(response.data.urlPentaho);
                        AuthService.setMenusIds(response.data.menusids);
                        AuthService.setUsoDeBoleto(response.data.usoDeBoleto);
                        AuthService.setHorarioLimite(response.data.horarioLimite);
                        AuthService.setComunicadoLiberado(response.data.comunicadoLiberado);


                        //AuthService.setRole(response.data.role);
                        return response;
                    },
                    function (error) {
                        return error;
                    }
                )
            }

            vm.esqueciSenha = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/usuario/modal/solicitar_reset_senha/index.html',
                    controller: 'EsqueciMinhaSenhaController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'md',
                }).closed.then(function () {

                });
            }

        }]);

'use strict';

angular.module('inspinia')
  .controller('HomeController', ['$state', '$scope', 'toastr', '$uibModal', 'AuthService', '$http', 'APP_MNP',
  function ($state, $scope, toastr, $uibModal, AuthService, $http, APP_MNP) {

    var vm = this;
    vm.painelDados = null;

    vm.init = function()
    {
      vm.userName = AuthService.getUser();
      vm.empresaName = AuthService.getEmpresa();

      /*
      vm.indicadoresPromise = AntecipacaoService.getIndicadoresPrincipal();

      vm.indicadoresPromise.then(function(result) {  
        if (result.status)
        {
          vm.indicadores = result.data;
        }
      });

      vm.operacoesPendentesPromise = AntecipacaoService.listarPendentes();

      vm.operacoesPendentesPromise.then(function(result) {  
        if (result.status)
        {
          vm.operacoesPendentes = result.data;
        }
      });
      */

      vm.consultarPainel();
    }

    vm.modalDetalheSolicitacao = function(status)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/home/modal/operacoesPendentes.html',
        controller: 'HomeOperacoesPendentesController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
          codigoStatus: function () {
              return status;
          },
        }
      });
    }

    vm.consultarPainel = function()
    {
      vm.consultarPainelPromise = $http.get(APP_MNP + "/home/painel");
        
      vm.consultarPainelPromise.then(function(response)
      { 
          vm.painelDados = response.data;
      });

      /*
      vm.pendentesPromise = AntecipacaoService.getPendentes();

      vm.pendentesPromise.then(function(result) {  
        if (result.status)
        {
          vm.pendentes = result.data;
        }
      });
      */
    }

    vm.init();

  }]);

angular
.module('inspinia').factory("HomeService", ['$http', 'APP_MNP', 'AuthService', 
    function ($http, APP_MNP, AuthService) {
    return {
        getQuantidade: function () {
            return $http.get(APP_MNP + "/home/GetQuantidade")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAtendimentosMapa: function () {
            return $http.get(APP_MNP + "/home/GetAtendimentosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getContatosMaps: function () {
            return $http.get(APP_MNP + "/home/GetContatosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
  angular.module('inspinia')
   .factory('modalService', ['$uibModal', '$sce', function($uibModal, $sce) {
       return {
           openModal: function(url) {
               var trustedUrl = $sce.trustAsResourceUrl(url);  // Marca a URL como segura
               
               $uibModal.open({
                   animation: true,
                   templateUrl: 'app/modal-template.html',
                   controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
                       $scope.urlToLoad = trustedUrl;  // Passa a URL segura para o modal

                       $scope.closeModal = function() {
                           $uibModalInstance.dismiss('close');
                       };
                   }],
                   size: 'lg',
                   backdrop: 'static',
                   keyboard: true
               });
           }
       };
   }]);


/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      .state('login', {
        abstract: true,
        url: "/login",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })
      .state('index.main', {
        url: "/main",
        templateUrl: "app/main/main.html",
        controller: 'HomeController',
        controllerAs: 'home',
        data: { pageTitle: 'Dashboard de Projetos' }
      })

      // Login
      .state('login.autenticar', {
        url: "/autenticar",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })

      // INVOICE
      .state('index.invoice_antecipacao_analisar', {
        url: "/invoice_antecipacao_analisar/:obj",
        templateUrl: "app/invoice/analise/index.html",
        controller: 'InvoiceAnaliseController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })

      // INVOICE > IMPORTAR TITULOS
      .state('index.recebiveis_importacao', {
        url: "/recebiveis_importacao",
        templateUrl: "app/invoice/importacao/index.html",
        controller: 'InvoiceNfeImportarController',
        controllerAs: 'controller'
      })
      // INVOICE > IMPORTAR TITULOS LOTE
      .state('index.recebiveis_importacao_lote', {
        url: "/recebiveis_importacao_lote",
        templateUrl: "app/invoice/importarLote/index.html",
        controller: 'InvoiceNfeImportarLoteController',
        controllerAs: 'controller'
      })

      // INVOICE > CNAB SINCRONIZADO
      .state('index.invoice_cnab_sincronizado', {
        url: "/invoice_cnab_sincronizado",
        templateUrl: "app/invoice/cnabsincronizado/index.html",
        controller: 'InvoiceCnabSincronizadoController',
        controllerAs: 'controller'
      })

      // INVOICE > DIGITACAO DE TITULOS
      .state('index.recebiveis_digitacao_titulo', {
        url: "/recebiveis_digitacao_titulo",
        templateUrl: "app/invoice/digitacao/index.html",
        controller: 'InvoiceDigitacaoTituloController',
        controllerAs: 'controller'
      })
      
      // INVOICE > LISTAR TITULOS
      .state('index.invoice_titulos', {
        url: "/invoice_titulos",
        templateUrl: "app/invoice/titulos/index.html",
        controller: 'InvoiceListarTitulosController',
        controllerAs: 'controller'
      })
      // INVOICE > LISTAR ANTECIPACOES (VMONEY)
      .state('index.invoice_antecipacoes', {
        url: "/invoice_antecipacoes",
        templateUrl: "app/invoice/antecipacao/index.html",
        controller: 'InvoiceAntecipacaoController',
        controllerAs: 'controller'
      })
      // INVOICE > LISTAR OPERACOES
      .state('index.invoice_operacoes', {
        url: "/invoice_operacoes",
        templateUrl: "app/invoice/operacao/index.html",
        controller: 'InvoiceOperacaoController',
        controllerAs: 'controller'
      })
      // INVOICE > OPERACAO > TITULOS
      .state('index.invoice_operacao_titulos', {
        url: "/invoice_operacao_titulos",
        templateUrl: "app/invoice/operacao/titulos/index.html",
        controller: 'InvoiceOperacaoTitulosController',
        controllerAs: 'controller'
      })
      // INVOICE > OPERACAO > ANALISE
      .state('index.operacao_analise', {
        url: "/operacao_analise/:obj",
        templateUrl: "app/invoice/operacao/analise/index.html",
        controller: 'OperacaoAnaliseController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      // INVOICE > OPERACAO > NEGOCIACAO
      .state('index.operacao_negociacao', {
        url: "/operacao_negociacao/:obj",
        templateUrl: "app/invoice/operacao/negociacao/index.html",
        controller: 'OperacaoNegociacaoController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      // INVOICE > OPERACAO > FORMALIZACAO
      .state('index.operacao_formalizacao', {
        url: "/operacao_formalizacao/:obj",
        templateUrl: "app/invoice/operacao/formalizacao/index.html",
        controller: 'OperacaoFormalizacaoController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      
      // INVOICE > FLUXO APROVACAO
      .state('index.operacao_fluxo_aprovacao', {
        url: "/operacao_fluxo_aprovacao",
        templateUrl: "app/invoice/fluxo/index.html",
        controller: 'InvoiceFluxoAprovacaoController',
        controllerAs: 'controller',
      })
      // INVOICE > FLUXO APROVACAO > ANALISE
      .state('index.operacao_fluxo_analise', {
        url: "/operacao_fluxo_analise/:obj",
        templateUrl: "app/invoice/fluxo/analise/index.html",
        controller: 'InvoiceFluxoAnaliseController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      // INVOICE > FLUXO APROVACAO > ANALISE > ETAPA
      .state('index.operacao_fluxo_analise_etapa', {
        url: "/operacao_fluxo_analise_etapa/:obj",
        templateUrl: "app/invoice/fluxo/analise/etapa/index.html",
        controller: 'InvoiceFluxoAnaliseEtapaController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })


      // REMESSA > PENDENTES
      .state('index.cnab_remessa_gerar', {
        url: "/cnab_remessa_gerar",
        templateUrl: "app/cnab/remessa/gerar/index.html",
        controller: 'CnabRemessaGerarController',
        controllerAs: 'controller'
      })
      // REMESSA > ARQUIVOS
      .state('index.cnab_remessa_arquivos', {
        url: "/cnab_remessa_arquivos",
        templateUrl: "app/cnab/remessa/arquivos/index.html",
        controller: 'CnabRemessaArquivosController',
        controllerAs: 'controller'
      })

      // RETORNO > ENVIO
      .state('index.cnab_retorno', {
        url: "/cnab_retorno",
        templateUrl: "app/cnab/retorno/enviar/index.html",
        controller: 'ArquivoRetornoController',
        controllerAs: 'controller'
      })
      .state('index.cnab_pesquisar', {
        url: "/cnab_pesquisar",
        templateUrl: "app/cnab/retorno/pesquisar/index.html",
        controller: 'ArquivoGeradosRetornoController',
        controllerAs: 'controller'
      })

      // BOLETO > ENVIO
      .state('index.boleto_relatorio_consumo', {
        url: "/boleto_relatorio_consumo",
        templateUrl: "app/boleto/relatorio/consumo/index.html",
        controller: 'BoletoRelatorioConsumoController',
        controllerAs: 'controller'
      })


      // CADASTRO > SACADO > INDEX
      .state('index.cadastro_sacado', {
        url: "/cadastro_sacado",
        templateUrl: "app/cadastro/sacado/cadastro/index.html",
        controller: 'SacadoCadastroController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_sacado_pesquisa', {
        url: "/cadastro_sacado_pesquisa",
        templateUrl: "app/cadastro/sacado/index.html",
        controller: 'CadastroSacadoPesquisaController',
        controllerAs: 'controller'
      })

      // CADASTRO > INVESTIDOR > INDEX
      .state('index.cadastro_investidor', {
        url: "/cadastro_investidor",
        templateUrl: "app/cadastro/investidor/cadastro/index.html",
        controller: 'InvestidorCadastroController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_investidor_pesquisa', {
        url: "/cadastro_investidor_pesquisa",
        templateUrl: "app/cadastro/investidor/index.html",
        controller: 'CadastroInvestidorPesquisaController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_sacado_consulta', {
        url: "/cadastro_sacado_consulta",
        templateUrl: "app/cadastro/sacado/consulta/index.html",
        controller: 'SacadoConsultaController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.sacado_cadastro_usuario', {
        url: "/sacado_cadastro_usuario",
        templateUrl: "app/cadastro/sacado/consulta/usuario/cadastro/index.html",
        controller: 'SacadoCadastrarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.sacado_consulta_usuario', {
        url: "/sacado_consulta_usuario",
        templateUrl: "app/cadastro/sacado/consulta/usuario/consulta/index.html",
        controller: 'SacadoConsultarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })


      // TITULOS
      .state('index.titulos_pesquisar', {
        url: "/titulos_pesquisar",
        templateUrl: "app/titulo/pesquisar/index.html",
        controller: 'TituloPesquisarController',
        controllerAs: 'controller'
      })
      .state('index.titulos_posicao', {
        url: "/titulos_posicao",
        templateUrl: "app/titulo/posicao/index.html",
        controller: 'TituloPosicaoController',
        controllerAs: 'controller'
      })
      .state('index.titulos_consultar', {
        url: "/titulos_consultar/:obj",
        templateUrl: "app/titulo/consultar/index.html",
        controller: 'TituloConsultarController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      // COBRANÇA > LIQUIDAÇÃO POR LOTE
      .state('index.titulos_liquidacao_lote', {
        url: "/titulos_liquidacao_lote",
        templateUrl: "app/titulo/liquidacao_lote/index.html",
        controller: 'TituloLiquidacaoLoteController',
        controllerAs: 'controller'
      })
      // CONTA GRAFICA
      .state('index.contagrafica_relatorio_extrato', {
        url: "/contagrafica_relatorio_extrato",
        templateUrl: "app/contagrafica/relatorio/extrato/index.html",
        controller: 'ContaGraficaRelatorioExtratoController',
        controllerAs: 'controller'
      })
      // CONTA GRAFICA > ACERTO MANUAL
      .state('index.contagrafica_acertomanual', {
        url: "/contagrafica_acertomanual",
        templateUrl: "app/contagrafica/acerto/index.html",
        controller: 'ContaGraficaAcertoManualController',
        controllerAs: 'controller'
      })
      // CONTA GRAFICA > ACERTO > HISTORICO
      .state('index.contagrafica_acerto_historico', {
        url: "/contagrafica_acerto_historico",
        templateUrl: "app/contagrafica/acerto/historico/index.html",
        controller: 'ContaGraficaAcertoHistoricoController',
        controllerAs: 'controller'
      })

      // CADASTRO > CEDENTE > INDEX
      .state('index.cedente_cadastrar', {
        url: "/cedente_cadastrar",
        templateUrl: "app/cadastro/cedente/cadastrar/index.html",
        controller: 'CedenteCadastrarController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.cedente_pesquisar', {
        url: "/cedente_pesquisar",
        templateUrl: "app/cadastro/cedente/pesquisar/index.html",
        controller: 'CedentePesquisarController',
        controllerAs: 'controller'
      })
      .state('index.cedente_consultar', {
        url: "/cedente_consultar/:obj",
        templateUrl: "app/cadastro/cedente/consultar/index.html",
        controller: 'FornecedorConsultaController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.cedente_pendentes', {
        url: "/cedente_pendentes",
        templateUrl: "app/cadastro/cedente/pendentes/index.html",
        controller: 'CedentePesquisarPendentesController',
        controllerAs: 'controller'
      })
      
      // POC EXPRESSA
      .state('index.cedente_pocexpressa_listar', {
        url: "/cedente_pocexpressa_listar",
        templateUrl: "app/cadastro/cedente/pocexpressa/listar/index.html",
        controller: 'CedentePocexpressaListarController',
        controllerAs: 'controller'
      })
      .state('index.cedente_pocexpressa', {
        url: "/cedente_pocexpressa/:obj",
        templateUrl: "app/cadastro/cedente/pocexpressa/index.html",
        controller: 'CedentePocexpressaController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })

      // CADASTRO > OPERACAO > INDEX
      .state('index.operacao_consultar', {
        url: "/operacao_consultar/:obj",
        templateUrl: "app/arranjo_pagamento/operacao/consultar/index.html",
        controller: 'OperacaoConsultarController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.operacao_pesquisar', {
        url: "/operacao_pesquisar",
        templateUrl: "app/arranjo_pagamento/operacao/pesquisar/index.html",
        controller: 'OperacaoPesquisarController',
        controllerAs: 'controller'
      })

      // ARRANJO DE PAGAMENTOS > OPTIN > PESQUISAR
      .state('index.optin_pesquisar', {
        url: "/optin_pesquisar",
        templateUrl: "app/arranjo_pagamento/optin/pesquisar/index.html",
        controller: 'ArranjoPagamentoOptInPesquisarController',
        controllerAs: 'controller'
      })    
      .state('index.optin_cadastrar', {
        url: "/optin_cadastrar/:obj",
        templateUrl: "app/arranjo_pagamento/optin/cadastrar/index.html",
        controller: 'ArranjoPagamentoOptInCadastrarController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
       // ARRANJO DE PAGAMENTOS > AGENDA > PESQUISAR
       .state('index.arranjopagamentos_agenda_pesquisar', {
        url: "/arranjopagamentos_agenda_pesquisar",
        templateUrl: "app/arranjo_pagamento/agenda/pesquisar/index.html",
        controller: 'ArranjoPagamentoAgendaPesquisarController',
        controllerAs: 'controller'
      })

      // Fluxo UR
      .state('index.fluxour_pesquisar', {
        url: "/fluxour_pesquisar",
        templateUrl: "app/arranjo_pagamento/fluxour/pesquisar/index.html",
        controller: 'FluxoUrPesquisarController',
        controllerAs: 'controller'
      })

      // Baixas
      .state('index.baixas_pesquisar', {
        url: "/baixas_pesquisar",
        templateUrl: "app/arranjo_pagamento/baixas/pesquisar/index.html",
        controller: 'BaixasPesquisarController',
        controllerAs: 'controller'
      })

      // Conciliacao Carteira
      .state('index.conciliacao_carteira', {
        url: "/conciliacao_carteira",
        templateUrl: "app/arranjo_pagamento/conciliacao/carteira/index.html",
        controller: 'ConciliacaoCarteiraController',
        controllerAs: 'controller'
      })
      // Conciliacao Baixa
      .state('index.conciliacao_baixa', {
        url: "/conciliacao_baixa",
        templateUrl: "app/arranjo_pagamento/conciliacao/baixa/index.html",
        controller: 'ConciliacaoBaixaController',
        controllerAs: 'controller'
      })

      // Domicilio Bancario
      .state('index.domiciliobancario_pesquisar', {
        url: "/domiciliobancario_pesquisar",
        templateUrl: "app/domiciliobancario/pesquisar/index.html",
        controller: 'DomicilioBancarioPesquisarController',
        controllerAs: 'controller'
      })

      // Grupo Usuario
      .state('index.grupousuario_pesquisar', {
        url: "/grupousuario_pesquisar",
        templateUrl: "app/grupousuario/pesquisar/index.html",
        controller: 'GrupoUsuarioPesquisarController',
        controllerAs: 'controller'
      })
      .state('index.grupousuario_cadastrar', {
        url: "/grupousuario_cadastrar/:obj",
        templateUrl: "app/grupousuario/cadastrar/index.html",
        controller: 'GrupoUsuarioCadastrarController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.grupousuario_permissao', {
        url: "/grupousuario_permissao/:obj",
        templateUrl: "app/grupousuario/permissao/index.html",
        controller: 'GrupoUsuarioPermissaoController',
        controllerAs: 'controller',
        params: {
          obj: null,
          name: null
        },
      })

      // CFOPs restritos
      .state('index.config_cfop_restrito', {
        url: "/config_cfop_restrito",
        templateUrl: "app/cliente/cfoprestrito/index.html",
        controller: 'ConfigCfopRestritoController',
        controllerAs: 'controller'
      })

      // Perfil do Cliente
      .state('index.config_perfil', {
        url: "/cliente_consultar",
        templateUrl: "app/cliente/perfil/index.html",
        controller: 'ClienteConsultaController',
        controllerAs: 'controller'
      })      

      // Config - Email
      .state('index.config_email', {
        url: "/config_email",
        templateUrl: "app/config/email/index.html",
        controller: 'ConfigEmailController',
        controllerAs: 'controller'
      })

      // Usuarios
      .state('index.usuarios_pesquisar', {
        url: "/usuarios_pesquisar",
        templateUrl: "app/usuarios/pesquisar/index.html",
        controller: 'UsuariosPesquisarController',
        controllerAs: 'controller'
      })

      // RELATORIOS
      .state('index.relatorio_pentaho', {
        url: "/relatorio_pentaho/:report/:name",
        templateUrl: "app/relatorio/gerador/index.html",
        controller: 'RelatorioGeradorController',
        controllerAs: 'controller',
        params: {
          report: null,
          name: null
        },
      })

      // SALARIO DEMANDA
      .state('index.salario_demanda_envio', {
        url: "/salario_demanda_envio",
        templateUrl: "app/salario_demanda/envio/index.html",
        controller: 'SalarioDemandaEnvioController',
        controllerAs: 'controller'
      })

      // CCB
      .state('index.ccb_simular', {
        url: "/ccb_simular",
        templateUrl: "app/ccb/simular/index.html",
        controller: 'CcbSimularController',
        controllerAs: 'controller'
      })
      .state('index.ccb_consultar', {
        url: "/ccb_consultar/:id",
        templateUrl: "app/ccb/consultar/index.html",
        controller: 'CcbConsultarController',
        controllerAs: 'controller',
        params: {
          id: null
        },
      })
      .state('index.ccb_pesquisar', {
        url: "/ccb_pesquisar",
        templateUrl: "app/ccb/pesquisar/index.html",
        controller: 'CcbPesquisarController',
        controllerAs: 'controller'
      })

      // Email Template
      .state('index.email_template', {
        url: "/email_template/:obj",
        templateUrl: "app/email/template/index.html",
        controller: 'EmailTemplateController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.email_template_listar', {
        url: "/email_template_listar",
        templateUrl: "app/email/template/listar/index.html",
        controller: 'EmailTemplateListarController',
        controllerAs: 'controller'
      })

      // GESTAO CARTEIRA > GERACAO BOLETOS
      .state('index.email_carteira_dinamica', {
        url: "/email_carteira_dinamica",
        templateUrl: "app/email/carteira/dinamica/index.html",
        controller: 'EmailCarteiraDinamicaController',
        controllerAs: 'controller'
      })
      // GESTAO CARTEIRA > COMUNICADO SACADOS
      .state('index.email_comunicacao_vencidos', {
        url: "/email_comunicacao_vencidos",
        templateUrl: "app/email/carteira/comunicacao_vencidos/index.html",
        controller: 'GestaoCarteiraComuVencidosController',
        controllerAs: 'controller'
      })
      // GESTAO CARTEIRA > COMUNICADO CEDENTES
      .state('index.comunicado_cedentes', {
        url: "/comunicado_cedentes",
        templateUrl: "app/email/carteira/comunicacao_cedentes/index.html",
        controller: 'GestaoCarteiraComuCedentesController',
        controllerAs: 'controller'
      })
      // GESTAO CARTEIRA > HISTORICO
      .state('index.gestao_email_historico', {
        url: "/gestao_email_historico",
        templateUrl: "app/email/historico/index.html",
        controller: 'GestaoCarteiraHistoricoController',
        controllerAs: 'controller'
      })
      .state('index.liquidacao_comissarias', {
        url: "/liquidacao_comissarias",
        templateUrl: "app/email/carteira/liquidacao_comissarias/index.html",
        controller: 'LiquidacaoComissariasController',
        controllerAs: 'controller'
      })

      // EMAIL > ENVIO (MALA DIRETA)
      .state('index.email_maladireta', {
        url: "/email_maladireta",
        templateUrl: "app/email/maladireta/index.html",
        controller: 'EmailMalaDiretaController',
        controllerAs: 'controller'
      })
      .state('index.email_maladireta_historico', {
        url: "/email_maladireta_historico",
        templateUrl: "app/email/maladireta/historico/index.html",
        controller: 'EmailMalaDiretaHistoricoController',
        controllerAs: 'controller'
      })
      

      // ORIGINADOR > CONSULTA
      .state('index.originador_consultar', {
        url: "/originador_consultar/:obj",
        templateUrl: "app/cliente/originadores/consultar/index.html",
        controller: 'OriginadorConsultaController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      
      // CONFIGURACOES > ORIGINADORES
      .state('index.config_originadores', {
        url: "/config_originadores",
        templateUrl: "app/cliente/originadores/index.html",
        controller: 'ConfigOriginadoresPesquisarController',
        controllerAs: 'controller'
      })
      // CONFIGURACOES > TARIFAS
      .state('index.consultar_tarifas', {
        url: "/consultar_tarifas",
        templateUrl: "app/cliente/tarifa/index.html",
        controller: 'ConfigTarifasConsultarController',
        controllerAs: 'controller'
      })
      // CONFIGURACOES > FERIADOS
      .state('index.consultar_feriados', {
        url: "/consultar_feriados",
        templateUrl: "app/cliente/feriado/index.html",
        controller: 'ConfigFeriadosConsultarController',
        controllerAs: 'controller'
      })
      // CONFIGURACOES > CONTA BANCARIA
      .state('index.config_conta_bancaria', {
        url: "/config_conta_bancaria",
        templateUrl: "app/cliente/contabancaria/index.html",
        controller: 'ConfigContaBancariaConsultarController',
        controllerAs: 'controller'
      })
      // CONFIGURACOES > TEMPLATE
      .state('index.config_template', {
        url: "/config_template",
        templateUrl: "app/cliente/template/index.html",
        controller: 'ClienteTemplateController',
        controllerAs: 'controller',
      })
      // CONFIGURACOES > FLUXO DE APROVACAO
      .state('index.config_fluxo_aprovacao', {
        url: "/config_fluxo_aprovacao",
        templateUrl: "app/fluxo_aprovacao/configuracao/index.html",
        controller: 'FluxoAprovacaoConfigController',
        controllerAs: 'controller',
      })
      // CONFIGURACOES > FLUXO DE APROVACAO > ETAPA
      .state('index.config_fluxo_aprovacao_etapa', {
        url: "/config_fluxo_aprovacao_etapa",
        templateUrl: "app/fluxo_aprovacao/configuracao/etapa/index.html",
        controller: 'FluxoAprovacaoEtapaConfigController',
        controllerAs: 'controller',
        params: {
          fluxoId: null,
          obj: null
        },
      })






      

      

      
      /*
      .state('index.arquivos_pesquisar_remessa', {
        url: "/arquivos_pesquisar_remessa",
        templateUrl: "app/arquivo/pesquisar-remessa.html",
        controller: 'ArquivoGeradosRemessaController',
        controllerAs: 'controller'
      })
      .state('index.arquivos_detalhar_remessa', {
        url: "/arquivos_detalhar_remessa/:viewId",
        templateUrl: "app/arquivo/detalhar-remessa.html",
        controller: 'ArquivoDetalharRemessaController',
        controllerAs: 'controller',
        params: {
          viewId: null
        }
      })
      .state('index.arquivos_pesquisar_retorno', {
        url: "/arquivos_pesquisar_retorno",
        templateUrl: "app/arquivo/pesquisar-retorno.html",
        controller: 'ArquivoGeradosRetornoController',
        controllerAs: 'controller'
      })
      .state('index.arquivos_leitor_remessa', {
        url: "/arquivos_leitor_remessa",
        templateUrl: "app/arquivo/leitor-remessa.html",
        controller: 'ArquivoLeitorRemessaController',
        controllerAs: 'controller'
      })
      */
      /*
      // Agente Financeiro
      // Recebiveis / Faturas
      .state('index.agentefinanc_antecipacoes_disponiveis', {
        url: "/agentefinanc_antecipacoes_disponiveis",
        templateUrl: "app/agente_financeiro/antecipacoes/disponiveis.html",
        controller: 'AntecipacaoDisponiveisController',
        controllerAs: 'controller'
      })      
      // Antecipacoes / Minhas antecipacoes
      .state('index.agentefinanc_propostas', {
        url: "/agentefinanc_propostas",
        templateUrl: "app/agente_financeiro/proposta/minhas_propostas.html",
        controller: 'AntecipacaoPesquisarController',
        controllerAs: 'controller'
      })
      // Portal Sacado
      // Travas bancarias
      .state('index.sacado_travasbancarias_selecao', {
        url: "/sacado_travasbancarias_selecao",
        templateUrl: "app/portal_sacado/travas_bancaria.html",
        controller: 'AntecipacaoPesquisarController',
        controllerAs: 'controller'
      })   


      // FORNECEDOR > PENDENTES > INDEX
      .state('index.pesquisa_fornecedor_pendente', {
        url: "/pesquisa_fornecedor_pendente",
        templateUrl: "app/fornecedor/pendentes/index.html",
        controller: 'PesquisaFornecedorPendenteController',
        controllerAs: 'controller'
      })
      .state('index.analisar_cadastro_fornecedor', {
        url: "/analisar_cadastro_fornecedor",
        templateUrl: "app/fornecedor/analisar_cadastro/index.html",
        controller: 'AnalisarCadastroFornecedorController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })

       // GESTAO DE CONTAS
       .state('index.financeiro_gestaocontas_listar', {
        url: "/financeiro_gestaocontas_listar",
        templateUrl: "app/financeiro/gestao_contas/index.html",
        controller: 'FinanceiroGestaoContasListarController',
        controllerAs: 'controller'
      })
      .state('index.financeiro_gestaocontas_analisar', {
        url: "/financeiro_gestaocontas_analisar",
        templateUrl: "app/financeiro/gestao_contas/analisar/index.html",
        controller: 'FinanceiroGestaoContasAnalisarController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })

      // IMPORTAR TITULOS
      .state('index.recebiveis_importacao', {
        url: "/recebiveis_importacao",
        templateUrl: "app/titulos/importacao/index.html",
        controller: 'TitulosImportacaoController',
        controllerAs: 'controller'
      })
      // LISTAR TITULOS
      .state('index.nfe_recebiveis_faturas', {
        url: "/nfe_recebiveis_faturas",
        templateUrl: "app/nfe/recebiveis/faturas/index.html",
        controller: 'FaturasDisponiveisController',
        controllerAs: 'controller'
      })      

      // RELATORIOS
      .state('index.relatorio_pentaho', {
        url: "/relatorio_pentaho/:report/:name",
        templateUrl: "app/relatorio/teste/index.html",
        controller: 'RelatorioTesteController',
        controllerAs: 'controller',
        params: {
          report: null,
          name: null
        },
      })
      
      // ARRANJO DE PAGAMENTOS > OPTIN > PESQUISAR
      .state('index.arranjopagamentos_optin_pesquisar', {
        url: "/arranjopagamentos_optin_pesquisar",
        templateUrl: "app/arranjo_pagamento/optin/pesquisar/index.html",
        controller: 'ArranjoPagamentoOptInPesquisarController',
        controllerAs: 'controller'
      })    
      .state('index.arranjopagamentos_optin_cadastrar', {
        url: "/arranjopagamentos_optin_cadastrar/:obj",
        templateUrl: "app/arranjo_pagamento/optin/cadastrar/index.html",
        controller: 'ArranjoPagamentoOptInCadastrarController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })    
       // ARRANJO DE PAGAMENTOS > AGENDA > PESQUISAR
       .state('index.arranjopagamentos_agenda_pesquisar', {
        url: "/arranjopagamentos_agenda_pesquisar",
        templateUrl: "app/arranjo_pagamento/agenda/pesquisar/index.html",
        controller: 'ArranjoPagamentoAgendaPesquisarController',
        controllerAs: 'controller'
      })    

      // CADASTRO > FORNECEDOR > INDEX
      .state('index.cadastro_fornecedor', {
        url: "/cadastro_fornecedor",
        templateUrl: "app/cadastro/fornecedor/cadastro/index.html",
        controller: 'FornecedorCadastroController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_fornecedor_pesquisa', {
        url: "/cadastro_fornecedor_pesquisa",
        templateUrl: "app/cadastro/fornecedor/index.html",
        controller: 'CadastroFornecedorPesquisaController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_fornecedor_consulta', {
        url: "/cadastro_fornecedor_consulta",
        templateUrl: "app/cadastro/fornecedor/consulta/index.html",
        controller: 'FornecedorConsultaController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.fornecedor_cadastro_usuario', {
        url: "/fornecedor_cadastro_usuario",
        templateUrl: "app/cadastro/fornecedor/consulta/usuario/cadastro/index.html",
        controller: 'FornecedorCadastrarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.fornecedor_consulta_usuario', {
        url: "/fornecedor_consulta_usuario",
        templateUrl: "app/cadastro/fornecedor/consulta/usuario/consulta/index.html",
        controller: 'FornecedorConsultarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      
      // CADASTRO > SACADO > INDEX
      .state('index.cadastro_sacado', {
        url: "/cadastro_sacado",
        templateUrl: "app/cadastro/sacado/cadastro/index.html",
        controller: 'SacadoCadastroController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_sacado_pesquisa', {
        url: "/cadastro_sacado_pesquisa",
        templateUrl: "app/cadastro/sacado/index.html",
        controller: 'CadastroSacadoPesquisaController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_sacado_consulta', {
        url: "/cadastro_sacado_consulta",
        templateUrl: "app/cadastro/sacado/consulta/index.html",
        controller: 'SacadoConsultaController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.sacado_cadastro_usuario', {
        url: "/sacado_cadastro_usuario",
        templateUrl: "app/cadastro/sacado/consulta/usuario/cadastro/index.html",
        controller: 'SacadoCadastrarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.sacado_consulta_usuario', {
        url: "/sacado_consulta_usuario",
        templateUrl: "app/cadastro/sacado/consulta/usuario/consulta/index.html",
        controller: 'SacadoConsultarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      // CADASTRO > INTERMEDIADOR > INDEX
      .state('index.cadastro_intermediador', {
        url: "/cadastro_intermediador",
        templateUrl: "app/cadastro/intermediador/cadastro/index.html",
        controller: 'IntermediadorCadastroController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_intermediador_pesquisa', {
        url: "/cadastro_intermediador_pesquisa",
        templateUrl: "app/cadastro/intermediador/index.html",
        controller: 'CadastroIntermediadorPesquisaController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_intermediador_consulta', {
        url: "/cadastro_intermediador_consulta",
        templateUrl: "app/cadastro/intermediador/consulta/index.html",
        controller: 'IntermediadorConsultaController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.intermediador_cadastro_usuario', {
        url: "/intermediador_cadastro_usuario",
        templateUrl: "app/cadastro/intermediador/consulta/usuario/cadastro/index.html",
        controller: 'IntermediadorCadastrarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.intermediador_consulta_usuario', {
        url: "/intermediador_consulta_usuario",
        templateUrl: "app/cadastro/intermediador/consulta/usuario/consulta/index.html",
        controller: 'IntermediadorConsultarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      */
      /*
      // Contato
      .state('index.pesquisarcontato', {
        url: "/pesquisarcontato",
        templateUrl: "app/contato/pesquisar.html",
        controller: 'ContatoPesquisaController',
        controllerAs: 'contatoController',
        data: { pageTitle: 'Pesquisar contatos' }
      })
      .state('index.cadastrarcontato', {
        url: "/cadastrarcontato",
        templateUrl: "app/contato/cadastrar.html",
        controller: 'ContatoCadastroController',
        controllerAs: 'contatoController',
        data: { pageTitle: 'Cadastrar contato' }
      })

      // Atendimento
      .state('index.pesquisaratendimento', {
        url: "/pesquisaratendimento",
        templateUrl: "app/atendimento/pesquisar.html",
        controller: 'AtendimentoPesquisaController',
        controllerAs: 'atendimentoController',
        data: { pageTitle: 'Pesquisar atendimentos' }
      })
      .state('index.cadastraratendimento', {
        url: "/cadastraratendimento",
        params: {
          obj: null
        },
        templateUrl: "app/atendimento/cadastrar.html",
        controller: 'AtendimentoCadastroController',
        controllerAs: 'atendimentoController',
        data: { pageTitle: 'Cadastrar atendimento' }
      })
      .state('index.consultaratendimento', {
        url: "/consultaratendimento",
        params: {
          obj: null
        },
        templateUrl: "app/atendimento/consultar.html",
        controller: 'AtendimentoConsultaController',
        controllerAs: 'atendimentoController',
        data: { pageTitle: 'Consultar atendimento' }
      })

      // Mapas
      .state('index.consultarmapacontatos', {
        url: "/consultarmapacontatos",
        templateUrl: "app/mapa/mapa_contatos.html",
        controller: 'MapaContatosController',
        controllerAs: 'mapaController'
      })

      // Usuarios
      .state('index.pesquisarusuario', {
        url: "/pesquisarusuario",
        templateUrl: "app/usuario/pesquisar.html",
        controller: 'UsuarioPesquisaController',
        controllerAs: 'usuarioPesquisa',
        data: { pageTitle: 'Pesquisar usuários' }
      })
      .state('index.cadastrarusuario', {
        url: "/cadastrarusuario",
        templateUrl: "app/usuario/cadastrar.html",
        controller: 'UsuarioCadastroController',
        controllerAs: 'usuarioCadastro',
        data: { pageTitle: 'Cadastrar Usuário' }
      })
      .state('index.alterarusuario', {
        url: "/alterarusuario",
        templateUrl: "app/usuario/alterar.html",
        controller: 'UsuarioAlteracaoController',
        controllerAs: 'usuarioAlteracao',
        params: {
          obj: null
        },
        data: { pageTitle: 'Editar Usuário' }
      })
      */

      .state('index.alterarsenha', {
        url: "/alterarsenha",
        templateUrl: "app/usuario/alterarsenha.html",
        controller: 'UsuarioAlteracaoSenhaController',
        controllerAs: 'controller',
        data: { pageTitle: 'Alterar Senha' }
      })

      // Index
      .state('index', {
        abstract: true,
        url: "/index",
        templateUrl: "app/components/common/content.html"
      })

      // landing
      .state('landing', {
        url: "/landing",
        templateUrl: "app/landing/landing.html",
        data: { pageTitle: 'Landing page', specialClass: 'landing-page' }
      })

      // Tests
      .state('index.minor', {
        url: "/minor",
        templateUrl: "app/minor/minor.html",
        data: { pageTitle: 'Example view' }
      });

      $urlRouterProvider.otherwise('/login/autenticar');
  }

})();

angular
    .module('inspinia')
    .factory('PagerService', PagerService)
    //.constant('APP_MNP', "https://apihmg.moneynow.com.br/api_homolog/api" ) 

    // LOCAL
    //.constant('APP_MNP', "https://localhost:44370/api")

    // PRODUCAO
    .constant('APP_MNP', "https://producao.moneynow.com.br/api")

function PagerService() {
    // service definition
    var service = {};

    service.GetPager = GetPager;

    return service;

    // service implementation
    function GetPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 5
        pageSize = pageSize || 15;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
};

angular.module('inspinia').value('cgBusyDefaults', {
    message: 'Carregando',
    templateUrl: 'app/components/common/loading.html'
});

angular.module('inspinia').directive('icheck', icheck);

angular.module('inspinia')
    .config([
        '$compileProvider',
        function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|data|image):/);
            // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
        }
    ])
    .config(['$provide', function ($provide) {
        $provide.decorator('$locale', ['$delegate', function ($delegate) {
            $delegate.NUMBER_FORMATS.DECIMAL_SEP = ',';
            $delegate.NUMBER_FORMATS.GROUP_SEP = '.';
            return $delegate;
        }]);
    }]);

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, element, $attrs, ngModel) {
            return $timeout(function () {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function (newValue) {
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function (event) {
                    if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                        $scope.$apply(function () {
                            return ngModel.$setViewValue(event.target.checked);
                        });
                    }
                    if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                        return $scope.$apply(function () {
                            return ngModel.$setViewValue(value);
                        });
                    }
                });
            });
        }
    };
}

var angles = angular.module("angles", []);

angles.chart = function (type) {
    return {
        restrict: "A",
        scope: {
            data: "=",
            options: "=",
            id: "@",
            width: "=",
            height: "=",
            resize: "=",
            chart: "@",
            segments: "@",
            responsive: "=",
            tooltip: "=",
            legend: "="
        },
        link: function ($scope, $elem) {
            var ctx = $elem[0].getContext("2d");
            var autosize = false;

            $scope.size = function () {
                if ($scope.width <= 0) {
                    $elem.width($elem.parent().width());
                    ctx.canvas.width = $elem.width();
                } else {
                    ctx.canvas.width = $scope.width || ctx.canvas.width;
                    autosize = true;
                }

                if ($scope.height <= 0) {
                    $elem.height($elem.parent().height());
                    ctx.canvas.height = ctx.canvas.width / 2;
                } else {
                    ctx.canvas.height = $scope.height || ctx.canvas.height;
                    autosize = true;
                }
            }

            $scope.$watch("data", function (newVal, oldVal) {
                if (chartCreated)
                    chartCreated.destroy();

                // if data not defined, exit
                if (!newVal) {
                    return;
                }
                if ($scope.chart) { type = $scope.chart; }

                if (autosize) {
                    $scope.size();
                    chart = new Chart(ctx);
                };

                if ($scope.responsive || $scope.resize)
                    $scope.options.responsive = true;

                if ($scope.responsive !== undefined)
                    $scope.options.responsive = $scope.responsive;

                chartCreated = chart[type]($scope.data, $scope.options);
                chartCreated.update();
                if ($scope.legend)
                    angular.element($elem[0]).parent().after(chartCreated.generateLegend());
            }, true);

            $scope.$watch("tooltip", function (newVal, oldVal) {
                if (chartCreated)
                    chartCreated.draw();
                if (newVal === undefined || !chartCreated.segments)
                    return;
                if (!isFinite(newVal) || newVal >= chartCreated.segments.length || newVal < 0)
                    return;
                var activeSegment = chartCreated.segments[newVal];
                activeSegment.save();
                activeSegment.fillColor = activeSegment.highlightColor;
                chartCreated.showTooltip([activeSegment]);
                activeSegment.restore();
            }, true);

            $scope.size();
            var chart = new Chart(ctx);
            var chartCreated;
        }
    }
}


/* Aliases for various chart types */
angles.directive("chart", function () { return angles.chart(); });
angles.directive("linechart", function () { return angles.chart("Line"); });
angles.directive("barchart", function () { return angles.chart("Bar"); });
angles.directive("radarchart", function () { return angles.chart("Radar"); });
angles.directive("polarchart", function () { return angles.chart("PolarArea"); });
angles.directive("piechart", function () { return angles.chart("Pie"); });
angles.directive("doughnutchart", function () { return angles.chart("Doughnut"); });
angles.directive("donutchart", function () { return angles.chart("Doughnut"); });


'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('icheck', icheck)
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('moneyMask', ['$timeout', 'moneyMaskService', function($timeout, moneyMaskService) {
        return {
          require: 'ngModel',
          link: function(scope, element, attrs, ctrl) {
              var execute = function () {
                  scope.$apply(function () {
                      ctrl.$setViewValue(moneyMaskService.fromStringToMoney(ctrl.$modelValue));
                      ctrl.$render();
                  });
              };
              element.bind('keyup', function () {
                  execute();
              });
              
              $timeout(function () { 
                  execute();
              }, 500);
           }
        };
     }])
     .factory("moneyMaskService", [ "$filter", function ($filter) {
        var _otherCharacters = /[^0-9]/g;
        var _zeros = /^0+/;
        
        var _fromStringToMoney = function (string) {
            //return $filter("currency")((_fromStringToNumber(string)/100).toFixed(2)).replaceAll('R$', 'R$ ');
            return $filter("currency")((_fromStringToNumber(string)/100).toFixed(2), "");
        };
        
        var _fromStringToNumber = function (string) {
            if (!string) return 0;
            return string.toString().replace(_otherCharacters, '').replace(_zeros, '') || 0;
        }
        
        return {
            fromStringToMoney: _fromStringToMoney
        };
    }])
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-success " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
    .directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }])
    .directive('numericOnly', function(){
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
    
                modelCtrl.$parsers.push(function (inputValue) {
                    var transformedInput = inputValue ? inputValue.replace(/[^\d.-]/g,'') : null;
    
                    if (transformedInput!=inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }
    
                    return transformedInput;
                });
            }
        };
    })
    .directive("setModelOnChange", function() {
        return {
            require: "ngModel",
            link: function postLink(scope,elem,attrs,ngModel) {
            elem.on("change", function(e) {
                console.log("on change (from directive)", e);  
                var files = elem[0].files;
                ngModel.$setViewValue(files);
            })
            }
        }
    })
    .directive('fileModel', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;
                
                element.bind('change', function(){
                    scope.$apply(function(){
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }])
    .directive('estadoSelect', function() {
        return {
            restrict: 'E',
            templateUrl: 'app/estado-select-template.html',
            scope: {
                model: '='
            }
        };
    })
    .directive('validarDataDdMmYyyy', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                ngModel.$validators.validarDataDdMmYyyy = function(modelValue) {
                    if (!modelValue) {
                        return true; // Let required handle empty values
                    }
                    
                    // Check format DD/MM/YYYY
                    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(modelValue)) {
                        return false;
                    }
                    
                    // Parse date parts
                    var parts = modelValue.split('/');
                    var day = parseInt(parts[0], 10);
                    var month = parseInt(parts[1], 10);
                    var year = parseInt(parts[2], 10);
                    
                    // Check month
                    if (month < 1 || month > 12) {
                        return false;
                    }
                    
                    // Check day range based on month
                    var daysInMonth = new Date(year, month, 0).getDate();
                    if (day < 1 || day > daysInMonth) {
                        return false;
                    }
                    
                    // Check valid date (avoid invalid dates like 31/04/2023)
                    var date = new Date(year, month - 1, day);
                    return date.getDate() === day &&
                           date.getMonth() === month - 1 &&
                           date.getFullYear() === year;
                };
            }
        };
    })
;

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}
angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/estado-select-template.html","<div class=\"form-group\"><label class=\"col-form-label\">Estado</label><select ng-model=\"model\" class=\"form-control\"><option value=\"AC\">ACRE</option><option value=\"AL\">ALAGOAS</option><option value=\"AP\">AMAPÁ</option><option value=\"AM\">AMAZONAS</option><option value=\"BA\">BAHIA</option><option value=\"CE\">CEARÁ</option><option value=\"DF\">DISTRITO FEDERAL</option><option value=\"ES\">ESPÍRITO SANTO</option><option value=\"GO\">GOIÁS</option><option value=\"MA\">MARANHÃO</option><option value=\"MT\">MATO GROSSO</option><option value=\"MS\">MATO GROSSO DO SUL</option><option value=\"MG\">MINAS GERAIS</option><option value=\"PA\">PARÁ</option><option value=\"PB\">PARAÍBA</option><option value=\"PR\">PARANÁ</option><option value=\"PE\">PERNAMBUCO</option><option value=\"PI\">PIAUÍ</option><option value=\"RJ\">RIO DE JANEIRO</option><option value=\"RN\">RIO GRANDE DO NORTE</option><option value=\"RS\">RIO GRANDE DO SUL</option><option value=\"RO\">RONDÔNIA</option><option value=\"RR\">RORAIMA</option><option value=\"SC\">SANTA CATARINA</option><option value=\"SP\">SÃO PAULO</option><option value=\"SE\">SERGIPE</option><option value=\"TO\">TOCANTINS</option><option value=\"EX\">ESTRANGEIRO</option></select></div>");
$templateCache.put("app/modal-template.html","<div class=\"modal-dialog\" style=\"width: 90%; margin: 2vh auto; height: 90vh;\"><div class=\"modal-content\" style=\"height: 100%; display: flex; flex-direction: column;\"><div class=\"modal-header\"><h3 class=\"modal-title\">Visualização do Documento</h3></div><div class=\"modal-body\" style=\"flex: 1; padding: 0;\"><iframe ng-src=\"{{urlToLoad}}\" style=\"width: 100%; height: 100%; border: none;\"></iframe></div><div class=\"modal-footer\"><button class=\"btn btn-success\" style=\"width: 100px\" ng-click=\"closeModal()\">Fechar</button></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"wrapper wrapper-content ng-scope\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\" style=\"display: none;\"><div class=\"row\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.consultarPainelPromise\" ng-click=\"home.modalDetalheSolicitacao(14)\"><div class=\"ibox-title\"><span class=\"label label-success pull-right\">antecipação</span><h5>Em Análise</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.painelDados != null ? home.painelDados.emAnalise : \'-\'}}</h1><small>operações</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.consultarPainelPromise\" ng-click=\"home.modalDetalheSolicitacao(2)\"><div class=\"ibox-title\"><span class=\"label label-warning pull-right\">antecipação</span><h5>Negociação</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.painelDados != null ? home.painelDados.emNegociacao : \'-\'}}</h1><small>operações</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.consultarPainelPromise\" ng-click=\"home.modalDetalheSolicitacao(4)\"><div class=\"ibox-title\"><span class=\"label label-primary pull-right\">antecipação</span><h5>Formalização</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.painelDados != null ? home.painelDados.emFormalizacao : \'-\'}}</h1><small>operações</small></div></div></div></div></div>");
$templateCache.put("app/minor/minor.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Simple example of second view</h1><small>Configure in app.js as index.minor state.</small></div></div></div></div>");
$templateCache.put("app/usuario/alterar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Alterar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Alterar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Informações</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Login\" placeholder=\"Login para acesso\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Email\" placeholder=\"E-mail\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telegram</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.TelegramUser\" placeholder=\"Usuário do Telegram\" class=\"form-control normal-text\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioAlteracao.alterar()\">ATUALIZAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/alterarsenha.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Alterar Senha</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Alterar Senha</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Alteração de Senha</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha antiga</label><div class=\"col-lg-10\"><input type=\"password\" maxlength=\"12\" ng-model=\"controller.oldPassword\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nova senha</label><div class=\"col-lg-10\"><input type=\"password\" maxlength=\"12\" ng-model=\"controller.newPassword\" class=\"form-control normal-text\"></div></div><div class=\"form-group\" style=\"margin-bottom: 0px;\"><div class=\"col-lg-12\" style=\"text-align: right\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\">ATUALIZAR</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/usuario/autenticar.html","<style>\r\n    body {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"middle-box text-center animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px; margin-top: 100px;\"><div style=\"padding-right: 35px; padding-left: 35px;\"><div style=\"margin-top: 30px;\"><img width=\"270px\" style=\"margin-bottom: 0px\" src=\"{{main.logoempresa}}\"></div><br><br><h3>INSTITUIÇÃO CREDORA</h3><p>Informe seu login e senha para autenticar</p><form class=\"m-t\" role=\"form\" cg-busy=\"main.loginPromise\"><div class=\"form-group\"><input ng-model=\"main.usuario.Login\" type=\"text\" class=\"form-control normal-text\" placeholder=\"Usuário\" required=\"\"></div><div class=\"form-group\" style=\"text-align: right;\"><input ng-model=\"main.usuario.Senha\" type=\"password\" class=\"form-control normal-text\" placeholder=\"Senha\" required=\"\"> <a style=\"padding-top: 2px; font-size: 11px;\" ng-click=\"main.esqueciSenha()\">Esqueci minha senha</a></div><button type=\"submit\" ng-click=\"main.login()\" class=\"btn btn-success block full-width m-b\">Acessar</button></form><p class=\"m-t\"><small>Money Now &copy; 2024</small></p></div></div></div></div></div></div>");
$templateCache.put("app/usuario/cadastrar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Informações</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Login\" placeholder=\"Login para acesso\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Email\" placeholder=\"E-mail\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Password\" placeholder=\"Senha\" class=\"form-control normal-text\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioCadastro.incluir()\">SALVAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/pesquisar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"><a class=\"btn btn-sm btn-success\" ng-click=\"usuarioPesquisa.incluir()\">NOVO USUÁRIO</a></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Resultado</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 40%\">Nome</th><th style=\"width: 30%\">Login</th><th style=\"width: 30%\">E-mail</th></tr></thead><tbody><tr ng:repeat=\"p in usuarioPesquisa.items\"><td>{{p.nome}}</td><td>{{p.login}}</td><td>{{p.Email}}</td><td style=\"text-align: center;\"><a ng-click=\"usuarioPesquisa.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"usuarioPesquisa.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in usuarioPesquisa.pager.pages\" ng-class=\"{active:usuarioPesquisa.pager.currentPage === page}\"><a ng-click=\"usuarioPesquisa.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cadastro/investidor/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Investidor</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Investidor</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button ng-click=\"controller.cadastrar()\" class=\"btn btn-success\"><i class=\"fa fa-plus\"></i> Cadastrar Investidor</button></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome / CPF-CNPJ / E-mail</label> <input type=\"text\" ng-model=\"controller.busca\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.pesquisar()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-university\"></i> Investidores</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>CPF/CNPJ</th><th>E-mail</th><th>Data Vínculo</th><th style=\"width: 1%; white-space: nowrap;\">Ações</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.cnpjCpf}}</td><td>{{p.email}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.remover(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div></div>");
$templateCache.put("app/cadastro/sacado/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button ng-click=\"controller.cadastrar()\" class=\"btn btn-success\"><i class=\"fa fa-plus\"></i> Cadastrar Sacado</button></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"number\" ng-model=\"controller.filtro.codigo\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Nome/Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CPF/CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Estado (UF)</label><select ng-model=\"controller.filtro.uf\" class=\"form-control\"><option value=\"\">TODOS</option><option value=\"AC\">ACRE</option><option value=\"AL\">ALAGOAS</option><option value=\"AP\">AMAPÁ</option><option value=\"AM\">AMAZONAS</option><option value=\"BA\">BAHIA</option><option value=\"CE\">CEARÁ</option><option value=\"DF\">DISTRITO FEDERAL</option><option value=\"ES\">ESPÍRITO SANTO</option><option value=\"GO\">GOIÁS</option><option value=\"MA\">MARANHÃO</option><option value=\"MT\">MATO GROSSO</option><option value=\"MS\">MATO GROSSO DO SUL</option><option value=\"MG\">MINAS GERAIS</option><option value=\"PA\">PARÁ</option><option value=\"PB\">PARAÍBA</option><option value=\"PR\">PARANÁ</option><option value=\"PE\">PERNAMBUCO</option><option value=\"PI\">PIAUÍ</option><option value=\"RJ\">RIO DE JANEIRO</option><option value=\"RN\">RIO GRANDE DO NORTE</option><option value=\"RS\">RIO GRANDE DO SUL</option><option value=\"RO\">RONDÔNIA</option><option value=\"RR\">RORAIMA</option><option value=\"SC\">SANTA CATARINA</option><option value=\"SP\">SÃO PAULO</option><option value=\"SE\">SERGIPE</option><option value=\"TO\">TOCANTINS</option><option value=\"EX\">ESTRANGEIRO</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Sacados</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px;\">#</th><th>Nome/Razão Social</th><th>CPF/CNPJ</th><th>Data de cadastro</th><th>Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td>Ativo</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">MoneyNow 1.0</div><div><strong>Copyright</strong> MoneyNow &copy; 2021</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/loading.html","<div style=\"background-image:url(\'assets/images/icons/loading.gif\');background-size: 50px 50px;margin: 0 auto;background-position:50% 20px;background-repeat:no-repeat\"></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><div style=\"text-align: center;\"><img alt=\"image\" width=\"100px\" class=\"img-circle\" ng-src=\"{{main.logoUrl}}\"> <span class=\"block m-t-md\"><strong class=\"font-bold\" style=\"color: white;\">{{main.userName}}</strong></span> <span class=\"text-muted text-xs block\">{{main.empresaName}}</span></div></div><div class=\"logo-element\">MN</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.main\" href=\"#/index/main\"><i class=\"fa fa-home\"></i> <span class=\"nav-label\">Home - IC</span></a></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"!main.userRest && (main.menusIds.indexOf(\';1;\') != -1 || main.menusIds.indexOf(\';2;\') != -1 || main.menusIds.indexOf(\';3;\') != -1 || main.menusIds.indexOf(\';4;\') != -1)\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-tags\"></i> <span class=\"nav-label\">NFe\'s</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';1;\') != -1\"><a ui-sref=\"index.recebiveis_importacao\">Importação de NFe\'s</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';2;\') != -1\"><a ui-sref=\"index.recebiveis_importacao_lote\">Importação em Lote</a></li><li ui-sref-active=\"active\" ng-if=\"main.podeVerCnabSincronizado()\"><a ui-sref=\"index.invoice_cnab_sincronizado\">Cnab Sincronizado</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';3;\') != -1\"><a ui-sref=\"index.recebiveis_digitacao_titulo\">Digitação de Títulos</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';4;\') != -1 && main.isOperacaoMoneyNow != \'1\'\"><a ui-sref=\"index.invoice_titulos\">Estoque de Títulos</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';4;\') != -1 && main.isOperacaoMoneyNow == \'1\'\"><a ui-sref=\"index.invoice_operacao_titulos\">Estoque de Títulos</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.isOperacaoMoneyNow == \'1\' && (main.empresaName == \'MoneyNow Homolog\' || main.empresaName == \'Venture\')\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-money\"></i> <span class=\"nav-label\">Salário Demanda</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.salario_demanda_envio\">Enviar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"!main.userRest && (main.menusIds.indexOf(\';5;\') != -1)\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-tasks\"></i> <span class=\"nav-label\">Antecipações</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';5;\') != -1\"><a ui-sref=\"index.invoice_antecipacoes\" ng-if=\"main.isOperacaoMoneyNow == \'0\'\">Disponíveis</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.invoice_operacoes\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\">Operações</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-money\"></i> <span class=\"nav-label\">Cobrança</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\"><a href=\"#\" aria-expanded=\"true\"><span class=\"nav-label\">Títulos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.titulos_pesquisar\">&nbsp;&nbsp;Pesquisar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.titulos_posicao\">&nbsp;&nbsp;Posição de Títulos</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\"><a href=\"#\" aria-expanded=\"true\"><span class=\"nav-label\">Acertos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.contagrafica_acertomanual\">&nbsp;&nbsp;Gerar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.contagrafica_acerto_historico\">&nbsp;&nbsp;Histórico</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><span class=\"nav-label\">Conta Gráfica</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.contagrafica_relatorio_extrato\">&nbsp;&nbsp;Extrato</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"index.titulos_liquidacao_lote\">Liquidação por Lote</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-files-o\"></i> <span class=\"nav-label\">Arquivos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><span class=\"nav-label\">Remessa</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.cnab_remessa_gerar\">&nbsp;&nbsp;Pendentes</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cnab_remessa_arquivos\">&nbsp;&nbsp;Arquivos</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><span class=\"nav-label\">Retorno</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.cnab_retorno\">&nbsp;&nbsp;Enviar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cnab_pesquisar\">&nbsp;&nbsp;Arquivos</a></li></ul></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.empresaName == \'MoneyNow Homolog\' || main.empresaName == \'JPA\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-calculator\"></i> <span class=\"nav-label\">CCB</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.ccb_simular\">Proposta</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.ccb_pesquisar\">Pesquisar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"!main.userRest && (main.menusIds.indexOf(\';6;\') != -1 || main.menusIds.indexOf(\';7;\') != -1 || main.menusIds.indexOf(\';8;\') != -1)\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-address-book\"></i> <span class=\"nav-label\">Cedentes</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';6;\') != -1\"><a ui-sref=\"index.cedente_pendentes\">Pendentes Aprovação</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';7;\') != -1\"><a ui-sref=\"index.cedente_pesquisar\">Pesquisar</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';8;\') != -1\"><a ui-sref=\"index.cedente_cadastrar\">Cadastrar</a></li><li ui-sref-active=\"active\" ng-if=\"main.empresaName == \'MoneyNow Homolog\' || main.empresaName == \'Homolog\' || main.empresaName == \'Venture\' || main.empresaName == \'Perdizes\' || main.empresaName == \'Perdizes Homolog\'\"><a ui-sref=\"index.cedente_pocexpressa_listar\">POC Expressa</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"!main.userRest && (main.menusIds.indexOf(\';9;\') != -1 || main.menusIds.indexOf(\';10;\') != -1)\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-address-book\"></i> <span class=\"nav-label\">Sacados</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';9;\') != -1\"><a ui-sref=\"index.cadastro_sacado_pesquisa\">Pesquisar</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';10;\') != -1\"><a ui-sref=\"index.cadastro_sacado\">Cadastrar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"!main.userRest\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-university\"></i> <span class=\"nav-label\">Investidor</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastro_investidor_pesquisa\">Pesquisar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastro_investidor\">Cadastrar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.empresaName == \'MoneyNow Homolog\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-files-o\"></i> <span class=\"nav-label\">Boleto</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><span class=\"nav-label\">Relatórios</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.boleto_relatorio_consumo\">&nbsp;&nbsp;Utilização</a></li></ul></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.isOperacaoMoneyNow == \'0\' && main.menusIds.indexOf(\';11;\') != -1\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-area-chart\"></i> <span class=\"nav-label\">Relatórios</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li><a href=\"#\" id=\"damian\" ng-if=\"main.pentahoRelatorios.includes(\'[17]\') || main.pentahoRelatorios.includes(\'[18]\') || main.pentahoRelatorios.includes(\'[19]\')\">Cadastrais <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';22;\') != -1 && (main.pentahoRelatorios.includes(\'[17]\'))\"><a ui-sref=\"index.relatorio_pentaho({report: \'RelatorioCedentes\', name: \'Cadastral Cedentes\'})\">Cadastral Cedentes</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';22;\') != -1 && (main.pentahoRelatorios.includes(\'[18]\'))\"><a ui-sref=\"index.relatorio_pentaho({report: \'RelatorioCadastralSacado\', name: \'Cadastral Sacados\'})\">Cadastral Sacados</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';23;\') != -1 && (main.pentahoRelatorios.includes(\'[19]\'))\"><a ui-sref=\"index.relatorio_pentaho({report: \'RelatorioContaCedentes\', name: \'Contas dos Cedentes\'})\">Contas dos Cedentes</a></li></ul></li><li><a href=\"#\" id=\"damian\" ng-if=\"main.pentahoRelatorios.includes(\'[2]\') || main.pentahoRelatorios.includes(\'[3]\') || main.pentahoRelatorios.includes(\'[4]\')\">Operacionais <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';24;\') != -1 && main.pentahoRelatorios.includes(\'[2]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'ResumoOperacaoOper\', name: \'Resumo de Operações por Operador\'})\">Resumo de Operações Operador</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';25;\') != -1 && main.pentahoRelatorios.includes(\'[3]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'ResumoOperacaoCed\', name: \'Resumo de Operações por Cedente\'})\">Resumo de Operações Cedente</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';26;\') != -1 && main.pentahoRelatorios.includes(\'[4]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RelatorioIof\', name: \'Relatório de IOF\'})\">Relatório de IOF</a></li></ul></li><li><a href=\"#\" id=\"damian\" ng-if=\"main.pentahoRelatorios.includes(\'[20]\') || main.pentahoRelatorios.includes(\'[6]\') || main.pentahoRelatorios.includes(\'[7]\') || main.pentahoRelatorios.includes(\'[8]\') || main.pentahoRelatorios.includes(\'[9]\') || main.pentahoRelatorios.includes(\'[10]\') || main.pentahoRelatorios.includes(\'[11]\') || main.pentahoRelatorios.includes(\'[12]\') || main.pentahoRelatorios.includes(\'[13]\') || main.pentahoRelatorios.includes(\'[21]\')\">Carteira de Títulos <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ng-if=\"main.menusIds.indexOf(\';27;\') != -1 && main.pentahoRelatorios.includes(\'[20]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'Boleto\', name: \'Boleto\'})\">Boleto</a></li><li ng-if=\"main.menusIds.indexOf(\';27;\') != -1 && main.pentahoRelatorios.includes(\'[6]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraCedenteAVencer\', name: \'Posição de Carteira Por Cedente a Vencer\'})\">Por Cedente a Vencer</a></li><li ng-if=\"main.menusIds.indexOf(\';28;\') != -1 && main.pentahoRelatorios.includes(\'[7]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraCedenteVencido\', name: \'Posição de Carteira Por Cedente Vencido\'})\">Por Cedente Vencido</a></li><li ng-if=\"main.menusIds.indexOf(\';29;\') != -1 && main.pentahoRelatorios.includes(\'[8]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraCedenteLiquidado\', name: \'Posição de Carteira Por Cedente Liquidado\'})\">Por Cedente Liquidado</a></li><li ng-if=\"main.menusIds.indexOf(\';29;\') != -1 && main.pentahoRelatorios.includes(\'[9]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraSacadoAVencer\', name: \'Posição de Carteira Por Sacado a Vencer\'})\">Por Sacado a Vencer</a></li><li ng-if=\"main.menusIds.indexOf(\';30;\') != -1 && main.pentahoRelatorios.includes(\'[10]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraSacadoVencido\', name: \'Posição de Carteira Por Sacado Vencido\'})\">Por Sacado Vencido</a></li><li ng-if=\"main.menusIds.indexOf(\';30;\') != -1 && main.pentahoRelatorios.includes(\'[11]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraSacadoLiquidado\', name: \'Posição de Carteira Por Sacado Liquidado\'})\">Por Sacado Liquidado</a></li><li ng-if=\"main.menusIds.indexOf(\';31;\') != -1 && main.pentahoRelatorios.includes(\'[12]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'LiquidadosAlfaPag\', name: \'Títulos Liquidados Por Data de Pagamento\'})\">Liquidados - Data Pagamento</a></li><li ng-if=\"main.menusIds.indexOf(\';32;\') != -1 && main.pentahoRelatorios.includes(\'[13]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'LiquidadosAlfaProc\', name: \'Títulos Liquidados Por Data de Processamento\'})\">Liquidados - Data Processamento</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';33;\') != -1 && main.pentahoRelatorios.includes(\'[21]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'BoletimAnaliseCanhotos\', name: \'Relatório de Canhotos\'})\">Relatório de Canhotos</a></li></ul></li><li><a href=\"#\" id=\"damian\" ng-if=\"main.pentahoRelatorios.includes(\'[1]\') || main.pentahoRelatorios.includes(\'[5]\')\">Conta Gráfica <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';34;\') != -1 && main.pentahoRelatorios.includes(\'[1]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'ExtratoContaGrafica\', name: \'Extrato Conta Gráfica\'})\">Extrato</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';35;\') != -1 && main.pentahoRelatorios.includes(\'[5]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'ExtratoRealizado\', name: \'Conta Gráfica Realizado\'})\">Extrato Realizado</a></li></ul></li><li><a href=\"#\" id=\"damian\" ng-if=\"main.pentahoRelatorios.includes(\'[14]\') || main.pentahoRelatorios.includes(\'[15]\') || main.pentahoRelatorios.includes(\'[16]\') || main.pentahoRelatorios.includes(\'[22]\')\">Gerenciais <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';36;\') != -1 && main.pentahoRelatorios.includes(\'[14]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RiscoSinteticoCedente\', name: \'Risco Sintético Cedente\'})\">Risco Sintético Cedente</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';37;\') != -1 && main.pentahoRelatorios.includes(\'[15]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RiscoSinteticoCedenteCtaGrafica\', name: \'Risco Sintético Cedente Cta Gráfica\'})\">Risco Sintético Cedente Cta Gráfica</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';38;\') != -1 && main.pentahoRelatorios.includes(\'[16]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RiscoSinteticoOperador\', name: \'Risco Sintético Operador\'})\">Risco Sintético Operador</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';39;\') != -1 && main.pentahoRelatorios.includes(\'[22]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RelatorioComissao\', name: \'Relatório de Comissão\'})\">Relatório de Comissão</a></li></ul></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"!main.userRest && (main.menusIds.indexOf(\';12;\') != -1 || main.menusIds.indexOf(\';13;\') != -1 || main.menusIds.indexOf(\';14;\') != -1 || main.menusIds.indexOf(\';15;\') != -1 || main.menusIds.indexOf(\';16;\') != -1)\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-inbox\"></i> <span class=\"nav-label\">Gestão de Carteira</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';12;\') != -1\"><a ui-sref=\"index.email_carteira_dinamica\">Geração de Boletos</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';13;\') != -1 && main.comunicadoLiberado\"><a ui-sref=\"index.email_comunicacao_vencidos\">Comunicado para Sacados</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';14;\') != -1 && main.comunicadoLiberado\"><a ui-sref=\"index.comunicado_cedentes\">Comunicado para Cedentes</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';12;\') != -1 && (main.empresaName == \'Perdizes\' || main.empresaName == \'Perdizes Homolog\' || main.empresaName == \'Venture\' || main.empresaName == \'Venture Homolog\' )\"><a ui-sref=\"index.liquidacao_comissarias\">Liquidação de Comissárias</a></li><li ng-if=\"main.empresaName == \'MoneyNow Homolog\' || main.empresaName == \'MoneyNow\' || main.empresaName == \'Perdizes\' || main.empresaName == \'Perdizes Homolog\' || main.empresaName == \'Venture\' || main.empresaName == \'Venture Homolog\'\"><a href=\"#\" id=\"damian\">Mala Direta <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\"><a ui-sref=\"index.email_maladireta\">Enviar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.email_maladireta_historico\">Histórico</a></li></ul></li><li><a href=\"#\" id=\"damian\">Configuração <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';15;\') != -1\"><a ui-sref=\"index.email_template_listar\">Templates</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';16;\') != -1\"><a ui-sref=\"index.config_email\">E-mail (SMTP)</a></li></ul></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.isOperacaoMoneyNow == \'1\' && (!main.userRest)\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-credit-card-alt\"></i> <span class=\"nav-label\">Arranjo Pagamentos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-arrow-right\"></i> <span class=\"nav-label\">Opt In/Out</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.optin_cadastrar\">Solicitar Opt-In</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.optin_pesquisar\">Consultar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-arrow-right\"></i> <span class=\"nav-label\">Agenda</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.arranjopagamentos_agenda_pesquisar\">Consultar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-arrow-right\"></i> <span class=\"nav-label\">Operações</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.operacao_pesquisar\">Consultar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-arrow-right\"></i> <span class=\"nav-label\">Fluxo de UR\'s</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.fluxour_pesquisar\">Consultar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-arrow-right\"></i> <span class=\"nav-label\">Baixas</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.baixas_pesquisar\">Consultar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-arrow-right\"></i> <span class=\"nav-label\">Conciliação</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.conciliacao_carteira\">Carteira</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.conciliacao_baixa\">Baixas</a></li></ul></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-hide=\"!main.mnow.includes(\'101\')\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-wrench\"></i> <span class=\"nav-label\">Configurações</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';17;\') != -1\"><a ui-sref=\"index.usuarios_pesquisar\">Usuários</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';18;\') != -1\"><a ui-sref=\"index.config_originadores\">Originadores</a></li><li ui-sref-active=\"active\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\"><a ui-sref=\"index.consultar_tarifas\">Tarifas</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.domiciliobancario_pesquisar\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\">Contas Bancárias</a></li><li ui-sref-active=\"active\" ng-if=\"main.empresaName == \'MoneyNow Homolog\' || main.empresaName == \'JPA\'\"><a ui-sref=\"index.config_template\">Documentos</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';19;\') != -1\"><a ui-sref=\"index.config_cfop_restrito\">CFOP\'s restritos</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';20;\') != -1\"><a ui-sref=\"index.grupousuario_pesquisar\">Grupos de Usuário</a></li><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';21;\') != -1\"><a ui-sref=\"index.config_perfil\">Perfil do Cliente</a></li><li ui-sref-active=\"active\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\"><a ui-sref=\"index.config_fluxo_aprovacao\">Fluxo de Aprovação</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.consultar_feriados\">Feriados</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Meu Perfil</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\" ng-if=\"main.menusIds.indexOf(\';21;\') != -1\"><a ui-sref=\"index.alterarsenha\">Alterar Senha</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"\"><div class=\"form-group\"><input type=\"text\" placeholder=\"Gestão de Talentos\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a ui-sref=\"login.autenticar\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></nav></div>");
$templateCache.put("app/cliente/cfoprestrito/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>CFOP\'s Restritos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Configurações</a></li><li class=\"active\"><strong>CFOP\'s Restritos</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> CFOP\'s</h5></div><div class=\"ibox-content\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"form-group\"><label class=\"col-form-label\">Restringir CFOP</label><select class=\"form-control\" ng-model=\"controller.cfop\" ng-options=\'item as (item.codigo + \" - \" + item.descricao) for item in controller.disponiveis\'></select></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><label class=\"col-form-label\"><br></label> <button class=\"btn btn-block btn-success\" ng-click=\"controller.adicionar()\">Adicionar Restrição</button></div></div></div><div class=\"row\"><div class=\"col-lg-8\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Código</th><th class=\"white-bg\">Descrição</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.restritos\"><td class=\"ng-binding\">{{ p.cfop.codigo }}</td><td class=\"ng-binding\">{{ p.cfop.descricao }}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.excluir(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/cliente/feriado/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Consultar Feriados</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Configurações</a></li><li><a>Feriados</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultaPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Feriados</h5></div><div class=\"ibox-content\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-2\"><div class=\"form-group\"><label class=\"col-form-label\">Período</label><select class=\"form-control\" ng-model=\"controller.ano\" ng-change=\"controller.consultar()\"><option value=\"2025\">2025</option><option value=\"2026\">2026</option></select></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><div><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"width: 100px;\">Data</th><th class=\"white-bg\">Descrição</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.feriados\"><td class=\"ng-binding\">{{ p.data | date:\'dd/MM/yyyy\' }}</td><td class=\"ng-binding\">{{ p.descricao }}</td><td ng-if=\"p.empresa.id != 0\" style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.excluirFeriado(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarFeriado()\"><span><i class=\"fa fa-plus\"></i> Adicionar feriado</span></button></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.cliente != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/cliente/perfil/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Perfil do Cliente</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cliente</a></li><li class=\"active\"><strong>Perfil</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Perfil do Cliente</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">(Hora:Minuto) Limite de Operação</label><div class=\"col-lg-2\"><input type=\"text\" maxlength=\"5\" inputmode=\"numeric\" ng-model=\"controller.cliente.horarioLimite\" class=\"form-control\" mask=\"99:99\"></div><div class=\"col-lg-2\"><p style=\"color: brown; margin-top: 7px;\"><b>ATENÇÃO: É necessário fazer novo login após alterar esse controle!</b></p></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\" style=\"padding-top: 5px;\">Checar Carta de Correção</label><div class=\"col-lg-8\"><label class=\"switch\"><input type=\"checkbox\" ng-model=\"controller.cliente.checarCartaCorrecao\"> <span class=\"slider round\"></span></label></div></div><hr><div class=\"row\"><div class=\"col-sm-4\"><form ng-submit=\"controller.uploadLogo()\"><div class=\"form-group\" style=\"margin-left: 2px;\"><label for=\"logoFile\">Carregar Logo:</label> <input type=\"file\" id=\"logoFile\" file-model=\"controller.logoFile\" class=\"form-control\"></div></form></div><div class=\"col-sm-2\" style=\"margin-top: 24px;\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"controller.uploadLogo()\">Upload Logo</button></div><div class=\"col-sm-4\" style=\"margin-top: -40px;\"><div ng-if=\"controller.logoUrl\"><label>Logo Atual:</label> <img ng-src=\"{{controller.logoUrl}}\" alt=\"Logo da Empresa\" style=\"max-width: 200px;\"></div></div></div><div class=\"form-group\" style=\"margin-bottom: 25px;\"><div class=\"col-lg-12\" style=\"text-align: right\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\">ATUALIZAR</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/cliente/originadores/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-12\"><h2>Originadores</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Originadores</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Pesquisar</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>CNPJ</th><th>Tipo</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.cnpj}}</td><td>{{p.tipoText}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cliente/tarifa/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Consultar Tarifas</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Configurações</a></li><li><a>Tarifas</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultaPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-dollar\"></i> Taxas e Tarifas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Originador</label><select class=\"form-control\" ng-model=\"controller.originador\" ng-change=\"controller.alterarOriginador()\" ng-options=\"item as item.nome for item in controller.originadores\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de cálculo</label><select class=\"form-control\" ng-model=\"controller.registro.tipoCalculo\"><option ng-value=\"1\">Tipo 1</option><option ng-value=\"2\">Tipo 2</option><option ng-value=\"3\">Tipo 3</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Taxa de operação</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaOperacao\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Ad Valorem</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaAdValorem\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa de cobrança</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaCobranca\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa avaliação de crédito (TAC)</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaAvaliacaoCredito\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa consulta de crédito</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaConsultaCredito\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa transferência/depósito (TED)</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaTED\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">ISS</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaISS\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">IOF (aa)</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaIOF\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">IOF Fixo</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaFixoIOF\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">PIS</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaPIS\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">COFINS</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaCOFINS\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CSLL</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaCSLL\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">IRRF</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaIRRF\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">D+</label><div class=\"input-group\"><input type=\"number\" ng-model=\"controller.registro.diasSomaOperacao\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">Dias</span></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultaPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-dollar\"></i> Instruções</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prorrogação</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaInstProrrogacao\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Baixa</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaInstBaixa\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Abatimento</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaInstAbatimento\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Sustar Cartório</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaInstSustarCartorio\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Enviar para Cartório</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaInstEnviarCartorio\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Sustar Protesto</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.tarifaInstSustarProtesto\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultaPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-dollar\"></i> Conta Gráfica</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Cálculo (Vencida)</label><select class=\"form-control\" ng-model=\"controller.registro.tipoCalculoContaGrafica\"><option ng-value=\"0\">Linear</option><option ng-value=\"1\">Capitalizado</option></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Taxa (Vencida)</label><select class=\"form-control\" ng-model=\"controller.registro.tipoTaxaContaGrafica\"><option ng-value=\"0\">Taxa de Desconto</option><option ng-value=\"1\">Taxa de Efetiva</option></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Taxa (Vencida)</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaContaGrafica\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/config/email/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Configurar E-mail</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Configurações</a></li><li class=\"active\"><a>E-mail</a></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultaPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Configuração SMTP</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Servidor SMTP</label> <input type=\"text\" ng-model=\"controller.registro.smtp\" class=\"form-control normal-text\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Porta</label> <input type=\"text\" ng-model=\"controller.registro.porta\" class=\"form-control normal-text\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Usuário</label> <input type=\"text\" ng-model=\"controller.registro.usuario\" class=\"form-control normal-text\" autocomplete=\"new-user\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Senha</label><div class=\"input-group\"><input ng-attr-type=\"{{ controller.showPassword ? \'text\' : \'password\' }}\" ng-model=\"controller.registro.senha\" class=\"form-control normal-text\" autocomplete=\"new-password\"> <span class=\"input-group-addon\" ng-click=\"controller.togglePassword()\"><i class=\"fa fa-eye\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.registro.email\" class=\"form-control normal-text\" autocomplete=\"new-email\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome da conta</label> <input type=\"text\" ng-model=\"controller.registro.nomeExibicao\" class=\"form-control normal-text\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"form-control\" style=\"font-size: 13px;\"><input type=\"checkbox\" ng-model=\"controller.registro.enableSsl\"> Conexão Segura</label></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"form-control\" style=\"font-size: 13px;\"><input type=\"checkbox\" ng-model=\"controller.registro.useAuthentication\"> Usar Autenticação</label></div></div></div><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right;\"><button style=\"width: 160px;\" class=\"btn btn-md btn-warning\" type=\"button\" ng-click=\"controller.testar()\"><i class=\"fa fa-check\"></i> Testar</button> <button style=\"width: 160px;\" class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Salvar</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultaPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Configuração de Resposta</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail de Resposta</label> <input type=\"text\" ng-model=\"controller.registro.replyToEmail\" class=\"form-control normal-text\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome de Exibição</label> <input type=\"text\" ng-model=\"controller.registro.replyToNome\" class=\"form-control normal-text\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right;\"><button style=\"width: 160px;\" class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvarConfigResposta()\"><i class=\"fa fa-arrow-right\"></i> Salvar</button></div></div></div></div></div></div></div>");
$templateCache.put("app/cliente/template/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Configurações</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>Documentos</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.pesquisarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-edit\"></i> Template</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Template</label><select class=\"form-control\" ng-model=\"controller.templateSelecionado\" ng-change=\"controller.selecionarTemplate()\" ng-options=\"item as (item.identificador) for item in controller.registros\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Modelo</label><summernote height=\"280\" config=\"options\" ng-model=\"controller.templateSelecionado.template\"></summernote></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 120px\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Salvar</button></div></div></div></div></div>");
$templateCache.put("app/contagrafica/acerto/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-12\"><h2>Acertos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cobrança</a></li><li><a>Acertos</a></li><li class=\"active\"><strong>Gerar</strong></li></ol></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\" cg-busy=\"controller.listarExtratoPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Extrato</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><label class=\"col-form-label\">Cedente</label> <button ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.cedente == null ? \'Selecionar Cedente\' : (controller.cedente.razaoSocial) }}</button></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"date\" ng-model=\"controller.dataReferenciaProcessamento\" class=\"form-control\" ng-change=\"controller.listarExtratoGrupo()\"></div></div></div><div class=\"row\" style=\"padding-top: 10px;\" ng-if=\"controller.cedenteContaGraficaItens.length > 0\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th class=\"white-bg\">Descrição</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Presente Débito</th><th class=\"white-bg\">Presente Crédito</th><th class=\"white-bg\">Selecionados</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.cedenteContaGraficaGrupos\"><td class=\"ng-binding\">{{p.descricao}}</td><td class=\"ng-binding\">{{p.quantidade}}</td><td class=\"ng-binding\" style=\"color: red;\">{{p.presenteDebito | currency:\'R$ \' }}</td><td class=\"ng-binding\" style=\"color: blue;\">{{p.presenteCredito | currency:\'R$ \' }}</td><td class=\"ng-binding\" ng-style=\"p.selecionadosTotal < 0 && {\'color\':\'red\'} || p.selecionadosTotal > 0 && {\'color\':\'blue\'}\">{{p.selecionadosTotal | currency:\'R$ \' }} ({{p.selecionados}})</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-click=\"controller.detalharItem(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table></div></div></div><div class=\"row\" ng-if=\"controller.cedenteContaGraficaItens.length > 0\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Total Débito</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.totalDebito | currency:\'R$ \' }}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Total Crédito</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.totalCredito | currency:\'R$ \' }}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Saldo</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.totalSaldo | currency:\'R$ \' }}\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.cedenteContaGraficaItens.length > 0\" cg-busy=\"controller.realizarAcertoPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Pagamento</label> <input type=\"date\" ng-model=\"controller.dataPagamento\" class=\"form-control\"></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo</label><select class=\"form-control\" ng-model=\"controller.tipoPagamento\"><option ng-value=\"1\">TED</option><option ng-value=\"2\">Cheque</option><option ng-value=\"3\">Dinheiro</option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor do Pagamento</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.valorPagamento\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Processamento</label> <input type=\"date\" ng-model=\"controller.dataProcessamento\" disabled=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right; vertical-align: bottom;\"><button style=\"width: 200px\" ng-click=\"controller.confirmarAcerto()\" class=\"btn btn-md btn-success\" type=\"button\"><i class=\"fa fa-check\"></i> Confirmar Pagamento</button></div></div></div></div></div></div></div>");
$templateCache.put("app/contagrafica/rotina/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-12\"><h2>Consultar Documento</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Documentos</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Nº NFe</label> <input type=\"number\" ng-model=\"controller.filtro.nfe\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Título</label> <input type=\"text\" ng-model=\"controller.filtro.numero\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <input type=\"text\" ng-model=\"controller.filtro.sacado\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <input type=\"text\" ng-model=\"controller.filtro.cedente\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.pesquisarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Documentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px;\">#</th><th style=\"white-space: nowrap;\">Nº Documento</th><th>Sacado</th><th>Cedente</th><th style=\"white-space: nowrap;\">Vencimento</th><th>Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.numeroNfe}} {{p.numero}}</td><td>{{p.sacado.razaoSocial}}</td><td>{{p.cedente.razaoSocial}}</td><td>{{p.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td>{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\" style=\"margin: 0\"></ul></div></div></footer></div></div></div></div></div>");
$templateCache.put("app/ccb/consultar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>CCB</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>CCB</a></li><li class=\"active\"><strong>Consulta</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultaPromise\"><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxResultado\', \'boxResultado\')\"><h5><i class=\"fa fa-arrow-right\"></i> Proposta</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxResultado\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxResultado\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.id}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Financiado</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.valor_financiado | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Total</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.total | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CET % a.m.</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.cet_m}} %\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CET % a.a.</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.cet_a}} %\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Total IOF</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.tot_iof | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor da Parcela</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.valor_parcela | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Último Vencimento</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.ultimo_vencimento | date: \'dd/MM/yyyy\'}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa TAC</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.valor_tac | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px; white-space: nowrap;\">Parcela</th><th>Valor da Parcela</th><th>Vencimento</th><th>Amortização</th><th>Saldo Devedor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registro.ccbPropostaDTO.propostaAprovada.titulos\"><td>{{p.numero_titulo}}</td><td>{{p.valor_prestacao | currency:\'R$ \'}}</td><td>{{p.vencimentoDate | date: \'dd/MM/yyyy\'}}</td><td>{{p.amortizacao | currency:\'R$ \'}}</td><td>{{p.saldo_devedor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxCedente\', \'boxCedente\')\"><h5><i class=\"fa fa-arrow-right\"></i> Cedente</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxCedente\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxCedente\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\" ng-if=\"controller.registro.ccbPropostaDTO.propostaAprovada.baruCredBancarizacao.cadastrarcliente.tipo_pessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.baruCredBancarizacao.cadastrarcliente.nome_cliente}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" disabled=\"\" mask=\"99.999.999/9999-99\" ng-model=\"controller.registro.ccbPropostaDTO.propostaAprovada.baruCredBancarizacao.cadastrarcliente.cpfcnpj_cliente\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.registro.ccbPropostaDTO.propostaAprovada.baruCredBancarizacao.cadastrarcliente.tipo_pessoa == 1\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.baruCredBancarizacao.cadastrarcliente.nome_cliente}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" disabled=\"\" mask=\"999.999.999-99\" ng-model=\"controller.registro.ccbPropostaDTO.propostaAprovada.baruCredBancarizacao.cadastrarcliente.cpfcnpj_cliente\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFormaCredito\', \'boxFormaCredito\')\"><h5><i class=\"fa fa-arrow-right\"></i> Forma de Crédito</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFormaCredito\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxFormaCredito\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\" ng-if=\"controller.registro.status != 3\"><div class=\"col-sm-8\"><div class=\"form-group\"><select class=\"form-control\" disabled=\"\" ng-model=\"controller.contaBancaria\" ng-options=\"item as (item.contaTexto) for item in controller.contasBancarias\"></select></div></div></div><div class=\"row\" ng-if=\"controller.registro.status == 3\"><div class=\"col-sm-8\"><div class=\"form-group\"><select class=\"form-control\" ng-model=\"controller.contaBancaria\" ng-change=\"controller.alterarContaBancaria()\" ng-options=\"item as (item.contaTexto) for item in controller.contasBancarias\"></select></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSimulacao\', \'boxSimulacao\')\"><h5><i class=\"fa fa-arrow-right\"></i> Simulação</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxSimulacao\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxSimulacao\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.fileSimulacaoPdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxProposta\', \'boxProposta\')\"><h5><i class=\"fa fa-arrow-right\"></i> CCB</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxProposta\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxProposta\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.filePropostaPdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTermoDeclaracao\', \'boxTermoDeclaracao\')\"><h5><i class=\"fa fa-arrow-right\"></i> Termo Declaração</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTermoDeclaracao\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxTermoDeclaracao\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.fileTermoDeclaracaoPdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFichaCadastral\', \'boxFichaCadastral\')\"><h5><i class=\"fa fa-arrow-right\"></i> Ficha Cadastral</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFichaCadastral\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxFichaCadastral\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.fileFichaCadastralPdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro.status == 2\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxBaruIntegracao\', \'boxBaruIntegracao\')\"><h5><i class=\"fa fa-arrow-right\"></i> Baru - Integração</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxBaruIntegracao\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxBaruIntegracao\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.baruStatus.cod_status}} - {{controller.registro.ccbPropostaDTO.baruStatus.status}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da consulta</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.baruStatus.dataConsulta | date: \'dd/MM/yyyy HH:mm\'}}\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxHistorico\', \'boxHistorico\')\"><h5><i class=\"fa fa-arrow-right\"></i> Histórico</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxHistorico\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxHistorico\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\">Data</th><th>Descrição</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registro.ccbPropostaDTO.historico\"><td style=\"white-space: nowrap;\">{{p.data | date: \'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{p.titulo}}<br><button ng-if=\"p.titulo == \'Proposta enviada ao Assinanet.\'\" class=\"btn btn-xs btn-default\" ng-click=\"controller.downloadAssinanetXml(p)\"><i class=\"fa fa-download\"></i> Download xml</button> <button ng-if=\"p.logIntegracaoId != \'\' && p.logIntegracaoId > 0\" class=\"btn btn-xs btn-default\" ng-click=\"controller.verLogIntegracao(p)\"><i class=\"fa fa-search\"></i> Log</button></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button ng-if=\"controller.registro.status == 3\" class=\"btn btn-md btn-danger\" type=\"button\" ng-click=\"controller.excluir()\"><i class=\"fa fa-trash\"></i> Excluir</button> <button ng-if=\"controller.registro.status == 43\" class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.assinaturaAprovada()\"><i class=\"fa fa-check\"></i> Enviar Vmoney</button> <button ng-if=\"controller.registro.status == 8\" class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.assinaturaAprovada()\"><i class=\"fa fa-check\"></i> Confirmar Assinatura</button> <button ng-if=\"controller.registro.status == 3\" class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.aprovar()\"><i class=\"fa fa-send\"></i> Aprovar CCB</button> <button ng-if=\"controller.registro.status == 3\" class=\"btn btn-md btn-primary\" type=\"button\" ng-click=\"controller.validar()\"><i class=\"fa fa-check\"></i> Validar Dados</button></div></div></div></div></div>");
$templateCache.put("app/ccb/pesquisar/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Operações</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">CCB</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.pesquisarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <input type=\"text\" ng-model=\"controller.filtro.fornecedor\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Operação</label> <input type=\"number\" ng-model=\"controller.filtro.numeroAntecipacao\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Solicitação</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" ng-model=\"controller.filtro.valorDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"number\" ng-model=\"controller.filtro.valorAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Disponíveis</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 570px;\"><table class=\"table table-bordered\"><thead><tr><th>#</th><th style=\"white-space: nowrap\">Data da Solicitação</th><th>Cedente</th><th style=\"width: 1px;\">Status</th><th>Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.numero}}</td><td>{{p.data | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.fornecedor}}</td><td ng-if=\"p.status == 1\"><button class=\"btn btn-success btn-xs\">Aguardando Envio para IC</button></td><td ng-if=\"p.status == 2\"><button class=\"btn btn-success btn-xs\">Aguardando Proposta IC</button></td><td ng-if=\"p.status == 3\"><button class=\"btn btn-blueviolet btn-xs\">Aguardando Aprovação do Cedente</button></td><td ng-if=\"p.status == 6\"><button class=\"btn btn-blueviolet btn-xs\">Aguardando Aprovação do Cedente</button></td><td ng-if=\"p.status == 4\"><button class=\"btn btn-primary btn-xs\">Aguardando Formalização</button></td><td ng-if=\"p.status == 8\"><button class=\"btn btn-primary btn-xs\">Aguardando Assinatura</button></td><td ng-if=\"p.status == 5\"><button class=\"btn btn-danger btn-xs\">Recusada pela IC</button></td><td ng-if=\"p.status == 7\"><button class=\"btn btn-danger btn-xs\">Recusada pelo Cedente</button></td><td ng-if=\"p.status == 9\"><button class=\"btn btn-primary btn-xs\">Concluído</button></td><td ng-if=\"p.status == 42\"><button class=\"btn btn-primary btn-xs btn-block\">Enviado ao VMoney</button></td><td ng-if=\"p.status == 43\"><button class=\"btn btn-warning btn-xs btn-block\">Aguardando envio VMoney</button></td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/ccb/simular/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Proposta de Empréstimo</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>CCB</a></li><li class=\"active\"><strong>Proposta</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.simularPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSimulacao\', \'boxSimulacao\')\"><h5><i class=\"fa fa-calculator\"></i> Simulação</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxSimulacao\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxSimulacao\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <button ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.cedente == null ? \'Selecionar Cedente\' : controller.cedente.razaoSocial }}</button></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Originador</label><select class=\"form-control\" ng-model=\"controller.originador\" ng-change=\"controller.alterarOriginador()\" ng-options=\"item as item.nome for item in controller.originadores\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Instituição Credora</label><select class=\"form-control\" ng-model=\"controller.credora\" ng-change=\"controller.alterarCredora()\" ng-options=\"item as item.razaoSocial for item in controller.credoras\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Empréstimo</label> <input type=\"date\" ng-model=\"controller.registro.dataEmprestimoDate\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Taxa %</label> <input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.juros\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Parcelas</label> <input type=\"number\" ng-model=\"controller.registro.numeroParcelas\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Primeiro Vencimento</label> <input type=\"date\" ng-model=\"controller.registro.primeiroVencimentoDate\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Principal</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.valorRequeridoTexto\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa TAC</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.valorTacTexto\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">% IOF Dia</label> <input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.aliquotaIofDia\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">% IOF Adicional</label> <input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.aliquotaIofAdicional\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Financiar IOF</label><select class=\"form-control\" ng-model=\"controller.registro.financiarIofTexto\"><option ng-value=\"1\">Não</option><option ng-value=\"2\">Sim</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.simular()\"><i class=\"fa fa-arrow-right\"></i> Simular CCB</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.resultado != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxResultado\', \'boxResultado\')\"><h5><i class=\"fa fa-arrow-right\"></i> Registros</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxResultado\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxResultado\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Financiado</label> <input type=\"text\" disabled=\"\" value=\"{{controller.resultado.valor_financiado | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Total</label> <input type=\"text\" disabled=\"\" value=\"{{controller.resultado.total | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CET % a.m.</label> <input type=\"text\" disabled=\"\" value=\"{{controller.resultado.cet_m}} %\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CET % a.a.</label> <input type=\"text\" disabled=\"\" value=\"{{controller.resultado.cet_a}} %\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Total IOF</label> <input type=\"text\" disabled=\"\" value=\"{{controller.resultado.tot_iof | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor da Parcela</label> <input type=\"text\" disabled=\"\" value=\"{{controller.resultado.valor_parcela | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Último Vencimento</label> <input type=\"text\" disabled=\"\" value=\"{{controller.resultado.ultimo_vencimento | date: \'dd/MM/yyyy\'}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa TAC</label> <input type=\"text\" disabled=\"\" value=\"{{controller.resultado.valor_tac | currency:\'R$ \'}}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px; white-space: nowrap;\">Parcela</th><th>Valor da Parcela</th><th>Vencimento</th><th>Amortização</th><th>Saldo Devedor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.resultado.titulos\"><td>{{p.numero_titulo}}</td><td>{{p.valor_prestacao | currency:\'R$ \'}}</td><td>{{p.vencimentoDate | date: \'dd/MM/yyyy\'}}</td><td>{{p.amortizacao | currency:\'R$ \'}}</td><td>{{p.saldo_devedor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.resultado != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumento\', \'boxDocumento\')\"><h5><i class=\"fa fa-arrow-right\"></i> Documento</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumento\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxDocumento\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.filePropostaPdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.resultado != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-primary\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-check\"></i> Salvar Proposta</button></div></div></div></div></div>");
$templateCache.put("app/email/maladireta/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>E-mail</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">E-mail</a></li><li class=\"active\"><a>Envio</a></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarconfig\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDestinatarios\', \'boxDestinatarios\')\"><h5><i class=\"fa fa-arrow-right\"></i> Destinatários</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDestinatarios\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxDestinatarios\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-12\"><h5><strong>Destinatários Principais (Para:)</strong></h5><button class=\"btn btn-success\" ng-click=\"controller.digitarEmail()\"><i class=\"fa fa-plus\" style=\"font-size: 10px;\"></i> Digitar E-mail (DST)</button> <button class=\"btn btn-md btn-warning\" ng-disabled=\"controller.registro.destinatarios.length === 0\" ng-click=\"controller.selecionarCedenteModal()\" title=\"{{controller.registro.destinatarios.length === 0 ? \'Adicione pelo menos um destinatário principal primeiro\' : \'Selecionar Cedentes\'}}\"><i class=\"fa fa-plus\" style=\"font-size: 10px;\"></i> Selecionar Cedentes (BCC)</button> <button class=\"btn btn-md btn-warning\" ng-disabled=\"controller.registro.destinatarios.length === 0\" ng-click=\"controller.selecionarSacadoModal()\" title=\"{{controller.registro.destinatarios.length === 0 ? \'Adicione pelo menos um destinatário principal primeiro\' : \'Selecionar Sacados\'}}\"><i class=\"fa fa-plus\" style=\"font-size: 10px;\"></i> Selecionar Sacados (BCC)</button> <button class=\"btn btn-md btn-info\" ng-disabled=\"controller.registro.destinatarios.length === 0\" ng-click=\"controller.digitarEmailCopia()\" style=\"margin-left:10px;\" title=\"{{controller.registro.destinatarios.length === 0 ? \'Adicione pelo menos um destinatário principal primeiro\' : \'Digitar E-mail para Cópia\'}}\"><i class=\"fa fa-plus\" style=\"font-size: 10px;\"></i> Digitar E-mail para Cópia (CC)</button> <button class=\"btn btn-md btn-warning\" ng-disabled=\"controller.registro.destinatarios.length === 0\" ng-click=\"controller.digitarEmailCopiaOculta()\" style=\"margin-left:5px;\" title=\"{{controller.registro.destinatarios.length === 0 ? \'Adicione pelo menos um destinatário principal primeiro\' : \'Digitar E-mail para Cópia Oculta\'}}\"><i class=\"fa fa-plus\" style=\"font-size: 10px;\"></i> Digitar E-mail para Cópia Oculta (BCC)</button></div></div><div class=\"row\"><div class=\"col-sm-12\"><div ng-if=\"controller.registro.destinatarios.length > 0\"><br><button type=\"button\" class=\"btn btn-xs btn-success\">DST</button> <b>Destinatários Principais (Para):</b><table class=\"table table-bordered\" style=\"table-layout:fixed; width:100%; margin-top:4px;\"><thead><tr><th style=\"width:25%\">Nome</th><th style=\"width:10%\">Origem</th><th style=\"width:55%\">E-mail</th><th style=\"width:15%; text-align:center;\">Ações</th></tr></thead><tbody><tr ng-repeat=\"p in controller.registro.destinatarios\"><td>{{p.nome}}</td><td>{{p.origem}}</td><td style=\"word-break: break-all;\">{{p.email}}</td><td style=\"text-align:center; vertical-align:middle; white-space: nowrap;\"><button type=\"button\" class=\"btn btn-xs btn-info\" ng-click=\"controller.moverEmail(p, \'destinatarios\', \'copia\')\" title=\"Mover para Cópia (CC)\">CC</button> <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"controller.moverEmail(p, \'destinatarios\', \'copiaOculta\')\" title=\"Mover para Cópia Oculta (BCC)\" style=\"margin-left: 2px;\">BCC</button> <button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"controller.removerDestinatario(p)\" title=\"Remover\" style=\"margin-left: 2px;\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div><div ng-if=\"controller.registro.copia.length > 0\"><button type=\"button\" class=\"btn btn-xs btn-info\">CC</button> <b>Cópia (CC):</b><table class=\"table table-bordered\" style=\"table-layout:fixed; width:100%; margin-top:4px;\"><thead><tr><th style=\"width:25%\">Nome</th><th style=\"width:10%\">Origem</th><th style=\"width:55%\">E-mail</th><th style=\"width:15%; text-align:center;\">Ações</th></tr></thead><tbody><tr ng-repeat=\"p in controller.registro.copia\"><td>{{p.nome}}</td><td>{{p.origem}}</td><td style=\"word-break: break-all;\">{{p.email}}</td><td style=\"text-align:center; vertical-align:middle; white-space: nowrap;\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"controller.moverEmail(p, \'copia\', \'destinatarios\')\" title=\"Mover para Destinatários\">DST</button> <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"controller.moverEmail(p, \'copia\', \'copiaOculta\')\" title=\"Mover para Cópia Oculta (BCC)\" style=\"margin-left: 2px;\">BCC</button> <button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"controller.removerCopia(p)\" title=\"Remover\" style=\"margin-left: 2px;\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div><div ng-if=\"controller.registro.copiaOculta.length > 0\"><button type=\"button\" class=\"btn btn-xs btn-warning\">BCC</button> <b>Cópia Oculta (BCC):</b><small class=\"text-muted\" style=\"margin-left: 10px;\" ng-if=\"controller.registro.copiaOculta.length > 10\">({{controller.registro.copiaOculta.length}} registros no total)</small><table class=\"table table-bordered\" style=\"table-layout:fixed; width:100%; margin-top:4px;\"><thead><tr><th style=\"width:25%\">Nome</th><th style=\"width:10%\">Origem</th><th style=\"width:55%\">E-mail</th><th style=\"width:15%; text-align:center;\">Ações</th></tr></thead><tbody><tr ng-repeat=\"p in controller.copiaOcultaPaginados\"><td>{{p.nome}}</td><td>{{p.origem}}</td><td style=\"word-break: break-all;\">{{p.email}}</td><td style=\"text-align:center; vertical-align:middle; white-space: nowrap;\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"controller.moverEmail(p, \'copiaOculta\', \'destinatarios\')\" title=\"Mover para Destinatários\">DST</button> <button type=\"button\" class=\"btn btn-xs btn-info\" ng-click=\"controller.moverEmail(p, \'copiaOculta\', \'copia\')\" title=\"Mover para Cópia (CC)\" style=\"margin-left: 2px;\">CC</button> <button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"controller.removerCopiaOculta(p)\" title=\"Remover\" style=\"margin-left: 2px;\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table><div ng-if=\"controller.pagerBcc.pages && controller.pagerBcc.pages.length > 1\"><ul class=\"pagination pagination-sm\" style=\"margin: 10px 0;\"><li ng-class=\"{disabled: controller.pagerBcc.currentPage === 1}\"><a ng-click=\"controller.setPageBcc(1)\" style=\"cursor: pointer;\">Primeira</a></li><li ng-class=\"{disabled: controller.pagerBcc.currentPage === 1}\"><a ng-click=\"controller.setPageBcc(controller.pagerBcc.currentPage - 1)\" style=\"cursor: pointer;\">Anterior</a></li><li ng-repeat=\"page in controller.pagerBcc.pages\" ng-class=\"{active: controller.pagerBcc.currentPage === page}\"><a ng-click=\"controller.setPageBcc(page)\" style=\"cursor: pointer;\">{{page}}</a></li><li ng-class=\"{disabled: controller.pagerBcc.currentPage === controller.pagerBcc.totalPages}\"><a ng-click=\"controller.setPageBcc(controller.pagerBcc.currentPage + 1)\" style=\"cursor: pointer;\">Próxima</a></li><li ng-class=\"{disabled: controller.pagerBcc.currentPage === controller.pagerBcc.totalPages}\"><a ng-click=\"controller.setPageBcc(controller.pagerBcc.totalPages)\" style=\"cursor: pointer;\">Última</a></li></ul><small class=\"text-muted\">Página {{controller.pagerBcc.currentPage}} de {{controller.pagerBcc.totalPages}} - Mostrando {{controller.pagerBcc.startIndex + 1}} a {{Math.min(controller.pagerBcc.endIndex + 1, controller.registro.copiaOculta.length)}} de {{controller.registro.copiaOculta.length}} registros</small></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxMensagem\', \'boxMensagem\')\"><h5><i class=\"fa fa-arrow-right\"></i> Mensagem</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxMensagem\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxMensagem\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-12\"><b>Assunto:</b> <input type=\"text\" class=\"form-control\" ng-model=\"controller.registro.assunto\" style=\"text-transform: none;\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><br><b>Mensagem:</b><summernote height=\"280\" config=\"options\" ng-model=\"controller.registro.mensagem\"></summernote></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAnexos\', \'boxAnexos\')\"><h5><i class=\"fa fa-arrow-right\"></i> Anexos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAnexos\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxAnexos\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><input type=\"file\" class=\"form-control\" onchange=\"angular.element(this).scope().adicionarAnexo(this)\"></div></div><div class=\"row\"><br><div class=\"col-sm-4\"><table class=\"table table-bordered\"><tbody><tr ng:repeat=\"p in controller.registro.anexos\"><td>{{p.name}}</td><td style=\"width: 1px;\"><i class=\"fa fa-close\" ng-click=\"controller.removerAnexo(p)\"></i></td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.enviarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 220px;\" ng-disabled=\"controller.registro.destinatarios.length === 0\" ng-click=\"controller.enviar()\" title=\"{{controller.registro.destinatarios.length === 0 ? \'ADICIONE PELO MENOS UM DESTINATÁRIO PRINCIPAL\' : \'ENVIAR EMAIL\'}}\"><i class=\"fa fa-arrow-right\"></i> Enviar</button></div></div></div></div></div>");
$templateCache.put("app/email/historico/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Histórico</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>Histórico</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><label class=\"col-form-label\">Escolha a opção</label><select class=\"form-control\" ng-model=\"controller.filtro.templateText\" ng-change=\"controller.loadPeriodo()\"><option value=\"vencidos1dia\">Vencidos a 1 dia útil</option><option value=\"vencidos5diasSemCartorio\">Vencidos a 5 dias Sem Cartório</option><option value=\"vencidos5diasComCartorio\">Vencidos a 5 dias Com Cartório</option><option value=\"avencer\">A Vencer</option><option value=\"vencido\">Vencido</option></select></div><div class=\"col-sm-2\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success btn-block\" ng-click=\"controller.pesquisar()\">Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.acaoTabelaPromise\" ng-if=\"controller.registros != null && controller.registros.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Histórico</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'lancamento\')\" style=\"width: 10px;\">Lançamento</th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"width: 10px;\">Título</th><th ng-click=\"controller.ordenarResultado(\'cedente\')\">Cedente</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado</th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\">Vencimento</th><th ng-click=\"controller.ordenarResultado(\'diasAtraso\')\" style=\"width: 60px;\">DA</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Banco</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\">Valor Título</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\"></td><td style=\"white-space: nowrap; width: 1px;\">{{p.lancamento}}</td><td style=\"white-space: nowrap; width: 1px;\">{{p.numeroDocumento}}</td><td>{{p.sacadorAvalista}}<br>E-mail: {{p.emailCedente}}</td><td>{{p.nomeSacado}}<br>E-mail: {{p.emailDestinatario}}</td><td ng-if=\"p.isVencido\" style=\"color: red;\">{{p.dataVencimento}}</td><td ng-if=\"p.isVencido == false\">{{p.dataVencimento}}</td><td>{{p.diasAtraso}}</td><td style=\"white-space: nowrap;\">{{p.codBanco}} - {{p.nomeBanco}}<br>Ag.: {{p.agencia}}<br>Conta: {{p.numeroContaComDigito}}</td><td style=\"white-space: nowrap;\">{{p.valorTitulo | currency:\'R$ \'}}</td><td><button ng-click=\"controller.visualizarBoleto(p)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div><div style=\"text-align: right; margin-top: 10px;\"><table width=\"100%\"><tr><td style=\"width: 90%;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>E-mail Cópia:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.email\" class=\"form-control\" style=\"width: 400px;\"></td><td style=\"width: 10px;\">&nbsp;&nbsp;</td><td style=\"width: 1px;\"><button ng-click=\"controller.enviarEmail()\" class=\"btn btn-success\" style=\"width: 200px\">Enviar E-mail</button></td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/email/template/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Template</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Template</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-edit\"></i> Template</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Template</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.nome\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Assunto</label> <input type=\"text\" class=\"form-control normal-text\" ng-model=\"controller.registro.assunto\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Modelo</label><summernote height=\"280\" config=\"options\" ng-model=\"controller.registro.template\"></summernote></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"form-control\"><input type=\"checkbox\" ng-model=\"controller.registro.agruparSacados\"> Agrupar Sacados</label></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 120px\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Salvar</button></div></div></div></div></div>");
$templateCache.put("app/domiciliobancario/cadastrar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Conta Bancária</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Originador</label><select class=\"form-control\" ng-if=\"!controller.isUpdate\" ng-model=\"controller.originador\" ng-change=\"controller.alterarOriginador()\" ng-options=\"item as item.nome for item in controller.originadores\"></select><input type=\"text\" ng-if=\"controller.isUpdate\" disabled=\"\" maxlength=\"100\" class=\"form-control\" ng-model=\"controller.originador.nome\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Conta</label><select class=\"form-control\" ng-model=\"controller.registro.tipoConta\"><option ng-value=\"1\">Conta Corrente</option><option ng-value=\"2\">Conta Poupança</option><option ng-value=\"3\">Conta Pagamento</option><option ng-value=\"4\">Conta Depósito</option><option ng-value=\"5\">Conta Investimento</option><option ng-value=\"7\">Conta Carteira</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Banco</label><select class=\"form-control\" ng-model=\"controller.registro.codigoBanco\" ng-options=\"item.codigo as item.nome for item in controller.bancos\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Agência</label> <input type=\"text\" maxlength=\"10\" class=\"form-control\" ng-model=\"controller.registro.agencia\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Dígito</label> <input type=\"text\" maxlength=\"4\" class=\"form-control\" ng-model=\"controller.registro.digitoAgencia\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Conta</label> <input type=\"text\" maxlength=\"50\" class=\"form-control\" ng-model=\"controller.registro.numero\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Dígito</label> <input type=\"text\" maxlength=\"4\" class=\"form-control\" ng-model=\"controller.registro.digitoConta\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Carteira</label> <input type=\"text\" maxlength=\"10\" class=\"form-control\" ng-model=\"controller.registro.numeroCarteira\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Conta Padrão?</label><select class=\"form-control\" ng-model=\"controller.contaPadrao\"><option ng-value=\"1\">Não</option><option ng-value=\"2\">Sim</option></select></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.enviar()\" style=\"width: 160px;\"><i class=\"fa fa-arrow-right\"></i> Salvar</button></div>");
$templateCache.put("app/domiciliobancario/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-6\"><h2>Contas Bancárias</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Contas Bancárias</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-6\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button ng-click=\"controller.cadastrar()\" class=\"btn btn-success\" style=\"width: 150px;\"><i class=\"fa fa-plus\"></i> Novo Registro</button></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px;\">#</th><th>Originador</th><th>Tipo Conta</th><th>Banco</th><th>Agência</th><th>Nº Conta</th><th>Carteira</th><th>Padrão</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.originador.nome}}</td><td>{{p.tipoContaTexto}}</td><td>{{p.banco}}</td><td>{{p.agencia}}</td><td>{{p.numero}}</td><td>{{p.numeroCarteira}}</td><td style=\"width: 100px;\"><button ng-if=\"p.isPadraoOperacao\" class=\"btn btn-success btn-xs btn-block\">Sim</button> <button ng-if=\"!p.isPadraoOperacao\" class=\"btn btn-danger btn-xs btn-block\">Não</button></td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/home/modal/detalhesSolicitacao.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">×</span><span class=\"sr-only\">Fechar</span></button><h4 class=\"modal-title\">Empresa ABCD Ltda.</h4><small class=\"font-bold\">Detalhes da solicitação de antecipação de recebíveis.</small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" value=\"Empresa ABCD Ltda.\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" value=\"01.203.423/0001-45\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" value=\"010002-100\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Endereço</label> <input type=\"text\" value=\"Rua Boa Vista, 230\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" value=\"São Paulo\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">UF</label> <input type=\"text\" value=\"SP\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" value=\"R$ 50.000,00\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo</label> <input type=\"text\" value=\"90 dias\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição da proposta</label> <input type=\"text\" value=\"\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\">Enviar Proposta</button></div></div>");
$templateCache.put("app/home/modal/operacoesPendentes.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Operações</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>#</th><th style=\"white-space: nowrap\">Data da Solicitação</th><th>Fornecedor</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registros\" ng-if=\"p.status == controller.codigoStatus\"><td>{{p.numero}}</td><td>{{p.data | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.fornecedor}}</td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-click=\"controller.consultarAnalise(p)\" ng-if=\"p.status == 14\" class=\"btn btn-primary btn-xs\" style=\"width: 110px;\"><i class=\"fa fa-edit\"></i> Análise</button> <button ng-click=\"controller.consultarNegociacao(p)\" ng-if=\"p.status == 2\" class=\"btn btn-primary btn-xs\" style=\"width: 110px;\"><i class=\"fa fa-dollar\"></i> Negociação</button> <button ng-click=\"controller.consultarFormalizacao(p)\" ng-if=\"p.status == 4\" class=\"btn btn-primary btn-xs\" style=\"width: 110px;\"><i class=\"fa fa-edit\"></i> Formalização</button></td></tr></tbody></table></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/fluxo_aprovacao/configuracao/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Fluxo de Aprovação</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>Fluxo de Aprovação</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.pesquisarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-edit\"></i> Etapas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 40%\">Descrição</th><th style=\"width: 20px\">Sequência</th><th>Grupo Análise</th><th>Grupo Aprovação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.etapas\"><td>{{p.descricao}}</td><td>{{p.sequencial}}</td><td style=\"width: 140px;\">Admin</td><td style=\"width: 140px;\">Admin</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a style=\"width: 100px\" ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 200px\" ng-click=\"controller.cadastrar()\"><i class=\"fa fa-plus\"></i> Adicionar Etapa</button></div></div></div></div></div>");
$templateCache.put("app/grupousuario/adicionarcedente/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Adicionar Cedente</h5><small class=\"font-bold\">Selecione o cedente para adicionar no grupo.</small></div><div class=\"modal-body\" style=\"padding: 15px; padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pesquisar cedente:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Razão Social ou CNPJ...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultaPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Cedentes</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{ p.cnpj }} - {{ p.razaoSocial }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/grupousuario/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Grupo de Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Grupo de Usuário</a></li><li class=\"active\"><strong>Cadastrar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Informações</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.registro.nome\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-10\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <textarea class=\"form-control\" maxlength=\"1000\" ng-model=\"controller.registro.descricao\" rows=\"3\"></textarea></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro.codigoRestringirCedente == 2\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-users\"></i> Restrição de Cedentes</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContaBancaria\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.listarContasPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Cedente</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.cedentes\"><td class=\"ng-binding\">{{ p.cedente.cnpj }} - {{ p.cedente.razaoSocial }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerCedente(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarCedente()\"><span><i class=\"fa fa-plus\"></i> Adicionar Cedente</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 180px;\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Salvar</button></div></div></div></div></div>");
$templateCache.put("app/grupousuario/permissao/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Grupo de Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Grupo de Usuário</a></li><li><a>Permissões</a></li><li class=\"active\"><strong>{{controller.grupoNome}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-arrow-right\"></i> Módulos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContaBancaria\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.listarContasPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Menu</th><th class=\"white-bg\">Item</th><th class=\"white-bg\">Permissão</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registros\"><td class=\"ng-binding\">{{ p.moduloMenu.menuPai }}</td><td class=\"ng-binding\">{{ p.moduloMenu.nome }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-if=\"!p.isAtivo\" ng-click=\"controller.habilitarMenu(p)\" class=\"btn btn-danger btn-xs\">Desabilitado</button> <button ng-if=\"p.isAtivo\" ng-click=\"controller.desabilitarMenu(p)\" class=\"btn btn-primary btn-xs\">Habilitado</button></td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/analise/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n    .center {\r\n        text-align: center !important;;\r\n    } \r\n    .right {\r\n        text-align: right !important;;\r\n    }  \r\n    \r\n    .text-brown {\r\n    color: #f57c00;\r\n    }\r\n\r\n    .text-danger {\r\n        color: red;\r\n    }    \r\n    .special-occurrence {\r\n        color: #1c84c6; /* Define a cor azul para as ocorrências especiais */\r\n\r\n    }\r\n    .tabela-compacta th,\r\n    .tabela-compacta td {\r\n        padding: 4px 8px !important;     /* menos espaço interno */\r\n        line-height: 1.6 !important; ;     /* altura da linha reduzida */\r\n        font-size: 12px !important; ;      /* opcional, para reduzir o texto também */\r\n        height: 22px !important;\r\n        vertical-align: middle !important;\r\n         border-width: 1px !important;        \r\n    }    \r\n    .tabela-ultra-compacta th,\r\n    .tabela-ultra-compacta td {\r\n    padding: 1px 4px !important;\r\n    line-height: 1 !important;\r\n    font-size: 11px !important;\r\n    height: 22px !important;\r\n    vertical-align: middle !important;\r\n    border-width: 1px !important;\r\n    }\r\n    .tabela-ultra-compacta th {\r\n        font-size: 12px !important;\r\n    }\r\n    .ibox-content {\r\n        position: relative; /* para o badge se posicionar dentro do conteúdo */\r\n        padding-left: 12px; /* espaço para não sobrepor a faixa */\r\n    }    \r\n    .left-badge {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 5px;\r\n        height: 100%;\r\n        background-color: #f57c00;\r\n        border-top-left-radius: 5px;\r\n        border-bottom-left-radius: 5px;\r\n    }   \r\n    .checkbox-small {\r\n        transform: scale(1.4); /* ou o tamanho que quiser */\r\n        cursor: pointer;\r\n        accent-color: rgb(46, 141, 122); /* verde personalizado */\r\n\r\n    }\r\n\r\n    .icheckbox_minimal {\r\n    width: 18px !important;\r\n    height: 18px !important;\r\n    background-color: #fff !important;\r\n    border: 1px solid #ccc !important; /* borda fina e cinza claro */\r\n    border-radius: 4px;\r\n    background-size: 18px 18px !important;\r\n    display: inline-block;\r\n    position: relative;\r\n    cursor: pointer;\r\n    accent-color: rgb(46, 141, 122); /* verde personalizado */\r\n\r\n}\r\n.sombra-barra {\r\n    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);\r\n    border-radius: 3px;\r\n}\r\n.ibox.card-hover {\r\n    transition: transform 0.4s ease-in-out, box-shadow 0.4s ease-in-out;\r\n}\r\n\r\n.ibox.card-hover:hover {\r\n    transform: scale(1.02);\r\n    box-shadow: 0 10px 24px rgba(28,132,198,0.3), 0 4px 8px rgba(0,0,0,0.15);\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>{{ controller.isReadOnly ? \'Lote Analisado\' : \'Análise\' }}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>{{ controller.isReadOnly ? \'Lote Analisado\' : \'Análise\' }}</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div ng-if=\"controller.isReadOnly\" style=\"background-color: #d9edf7; border: 1px solid #bce8f1; border-radius: 4px; padding: 15px; margin: 15px; color: #31708f;\"><i class=\"fa fa-eye\" style=\"margin-right: 10px;\"></i> <strong>Modo Visualização</strong> - Análise já foi concluída. Os dados são exibidos em modo somente leitura.</div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.aprovarAnalisePromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultaOperacao\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAnalise\', \'boxAnalise\')\"><h5><i class=\"fa fa-arrow-right\"></i> Operação</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAnalise\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAnalise\" class=\"ibox-content\" style=\"padding-bottom: 1px;\"><div class=\"row\" style=\"padding-bottom: 2px;\"><div class=\"col-lg-6\"><div class=\"ibox float-e-margins card-hover\"><div class=\"ibox-content\" style=\"padding-bottom: 13px;\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-6\"><span style=\"font-size: 20px; font-weight: 500; color:#1c84c6\">Operação</span></div><div class=\"col-lg-6\" style=\"text-align: right;\"><i class=\"fa fa-file-text\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\"><div class=\"col-lg-2\"><div style=\"font-weight: 500;\">Número</div><span style=\"color: orange;\">{{controller.analise.antecipacaoId}}</span></div><div class=\"col-lg-2\"><div style=\"font-weight: 500;\">Lote</div><span style=\"color: green;\">{{controller.analise.integracaoId}}</span></div><div class=\"col-lg-3\"><div style=\"font-weight: 500;\">Data</div><span style=\"color: orange;\">{{controller.analise.dataAntecipacao | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"col-lg-5\"><div style=\"font-weight: 500;\">Tipo</div><span style=\"color: orange;\">{{controller.getTipoOperacaoDescricao(controller.analise.tipoOperacao)}}</span></div></div><hr style=\"margin: 10px 0; border-top: 1px solid #ccc;\"><div class=\"row\"><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Cedente</div><span style=\"color: orange;\">{{controller.analise.cedenteNome | limitTo:20}}</span></div><div class=\"col-lg-3\"><div style=\"font-weight: 500;\">CNPJ</div><span style=\"color: orange;\">{{controller.analise.cedenteCnpj}}</span></div><div class=\"col-lg-3\"><div style=\"font-weight: 500;\">Originador</div><span style=\"color: orange;\">{{controller.analise.descricaoOriginador | limitTo:20}}</span></div><div class=\"col-lg-2\" style=\"text-align: center;\"><button class=\"btn btn-success btn-xs\" ng-click=\"controller.adicionarOcorrencia(true)\" ng-disabled=\"controller.isReadOnly\"><i class=\"fa fa-plus\"></i> Ocorrência</button><br><br></div></div></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins card-hover\"><div class=\"ibox-content\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-6\"><span style=\"font-size: 20px; font-weight: 500; color:#1c84c6\">Ocorrências</span></div><div class=\"col-lg-6\" style=\"text-align: right;\"><i class=\"fa fa-cogs\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\"><div class=\"col-lg-3\"><div style=\"font-weight: 500;\"></div></div><div class=\"col-lg-3\"><div style=\"font-weight: 500;\">Total</div></div><div class=\"col-lg-3\"><div style=\"font-weight: 500;\">Informativo</div></div><div class=\"col-lg-3\"><div style=\"font-weight: 500;\">Crítico</div></div></div><div class=\"row\"><div class=\"col-lg-3\"><span style=\"font-weight: 500;\">Cedente</span></div><div class=\"col-lg-3\"><span style=\"color: orange;\" ng-if=\"controller.cedenteTotal !== 0\">{{controller.cedenteTotal}}</span></div><div class=\"col-lg-3\"><span style=\"color: orange;\" ng-if=\"controller.cedenteInformativos !== 0\">{{controller.cedenteInformativos}}</span></div><div class=\"col-lg-3\"><span style=\"color: red;\" ng-if=\"controller.cedenteCriticos !== 0\">{{controller.cedenteCriticos}}</span></div></div><div class=\"row\"><div class=\"col-lg-3\"><span style=\"font-weight: 500;\">Sacados</span></div><div class=\"col-lg-3\"><span style=\"color: orange;\" ng-if=\"controller.sacadoTotal !== 0\">{{controller.sacadoTotal}}</span></div><div class=\"col-lg-3\"><span style=\"color: orange;\" ng-if=\"controller.sacadoInformativos !== 0\">{{controller.sacadoInformativos}}</span></div><div class=\"col-lg-3\"><span style=\"color: red;\" ng-if=\"controller.sacadoCriticos !== 0\">{{controller.sacadoCriticos}}</span></div></div><div class=\"row\"><div class=\"col-lg-3\"><div style=\"font-weight: 500;\">Poc</div></div><div class=\"col-lg-3\"><span style=\"color: orange;\" ng-if=\"controller.pocTotal !== 0\">{{controller.pocTotal}}</span></div><div class=\"col-lg-3\"><span style=\"color: orange;\" ng-if=\"controller.pocInformativos !== 0\">{{controller.pocInformativos}}</span></div><div class=\"col-lg-3\"><span style=\"color: red;\" ng-if=\"controller.pocCriticos !== 0\">{{controller.pocCriticos}}</span></div></div><div class=\"row\"><div class=\"col-lg-3\"><div style=\"font-weight: 500;\">Títulos</div></div><div class=\"col-lg-3\"><span style=\"color: orange;\" ng-if=\"controller.titulosTotal !== 0\">{{controller.titulosTotal}}</span></div><div class=\"col-lg-3\"><span style=\"color: orange;\" ng-if=\"controller.titulosInformativos !== 0\">{{controller.titulosInformativos}}</span></div><div class=\"col-lg-3\"><span style=\"color: red;\" ng-if=\"controller.titulosCriticos !== 0\">{{controller.titulosCriticos}}</span></div></div></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins card-hover\"><div class=\"ibox-content\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-6\"><span style=\"font-size: 20px; font-weight: 500; color:#1c84c6\">Fechamento</span></div><div class=\"col-lg-6\" style=\"text-align: right;\"><i class=\"fa fa-university\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\"><div class=\"col-lg-5\"><div style=\"font-weight: 500;\">Valor</div><span style=\"color: orange;\" ng-if=\"controller.analise.valorFace !== 0\">{{controller.analise.valorFace | currency:\'R$ \'}}</span></div><div class=\"col-lg-2\"><div style=\"font-weight: 500;\">Sacado</div><span style=\"color: orange;\" ng-if=\"controller.sacadoQtde !== 0\">{{controller.sacadoQtde}}</span></div><div class=\"col-lg-2\"><div style=\"font-weight: 500;\">Nfe</div><span style=\"color: orange;\" ng-if=\"controller.analise.titulos.length !== 0\">{{controller.nFeQtde}}</span></div><div class=\"col-lg-2\"><div style=\"font-weight: 500;\">Título</div><span style=\"color: orange;\" ng-if=\"controller.analise.titulos.length !== 0\">{{controller.analise.titulos.length}}</span></div></div><hr style=\"margin: 10px 0; border-top: 1px solid #ccc;\"><div class=\"row\"><div class=\"col-lg-5\"><div style=\"font-weight: 500;\">Aprovado</div><span style=\"color: green;\">{{controller.aprovadoTotal | currency:\'R$ \'}}</span></div><div class=\"col-lg-2\"><div style=\"font-weight: 500;\">Sacado</div><span style=\"color: green;\" ng-if=\"controller.aprovadoSacadoQtde !== 0\">{{controller.aprovadoSacadoQtde}}</span></div><div class=\"col-lg-2\"><div style=\"font-weight: 500;\">NFe</div><span style=\"color: green;\" ng-if=\"controller.aprovadoNFeQtde !== 0\">{{controller.aprovadoNFeQtde}}</span></div><div class=\"col-lg-2\"><div style=\"font-weight: 500;\">Título</div><span style=\"color: green;\" ng-if=\"controller.aprovadoTituloQtde !== 0\">{{controller.aprovadoTituloQtde}}</span></div></div></div></div></div></div><div class=\"col-form-label title-with-line\" style=\"color:#1c84c6; cursor: pointer; font-size: 15px; font-weight: 500; display: flex; align-items: center;\" ng-click=\"controller.showhide(\'iconBoxTitulos\', \'boxTitulos\')\"><span style=\"white-space: nowrap; margin-right: 10px;\">Títulos</span> <i id=\"iconBoxTitulos\" class=\"fa\" style=\"margin-right: 10px;\" ng-class=\"{\'fa-chevron-circle-down\': !controller.boxTitulosVisible, \'fa-chevron-circle-up\': controller.boxTitulosVisible}\"></i><div class=\"line\" style=\"flex: 1; height: 0.4px; background-color: #cccccc; box-shadow: 0 0.5px 1px rgba(0,0,0,0.1);\"></div></div><div class=\"col-form-label\" style=\"color:#1c84c6; cursor: pointer; margin-top: -5px;\" ng-click=\"controller.showhide(\'iconBoxTitulos\', \'boxTitulos\')\"><i id=\"iconBoxTitulos\" class=\"fa\" ng-class=\"{\'fa-chevron-downxx\': !controller.boxTitulosVisible, \'fa-chevron-upxx\': controller.boxTitulosVisible}\"></i></div><div class=\"ibox float-e-margins\" ng-show=\"controller.boxTitulosVisible\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltros\', \'boxFiltros\')\"><h5 style=\"margin: 0; font-size: 14px;\"><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\" style=\"margin: 0;\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltros\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltros\" class=\"ibox-content\" style=\"display: none; padding-bottom: 1px;\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 195px;\"><table class=\"table table-bordered tabela-ultra-compacta\"><thead><tr><th style=\"width: 1px;\"><input type=\"checkbox\" class=\"icheckbox_minimal\" ng-change=\"controller.selecionarTodasOcorrencias()\" ng-model=\"controller.selTodasOcorrencias\"></th><th>Ocorrências do lote</th><th>De</th><th>Qtde</th></tr></thead><tbody style=\"background-color: white;\"><tr ng-repeat=\"p in controller.listaOcorrencias | orderBy: [\'categoria\', \'descricao\']\"><td style=\"width: 1px;\"><input type=\"checkbox\" class=\"icheckbox_minimal\" ng-model=\"p.selecionado\" ng-change=\"controller.alterarSituacaoOcorrencia()\"></td><td class=\"ng-binding\" ng-class=\"{\'special-occurrence\': p.codigoErroVmoney === \'SEM_OCORRENCIA\' || p.codigoErroVmoney === \'LIBERADOS\' || p.codigoErroVmoney === \'RECUSADOS\'}\">{{p.descricao}}</td><td class=\"ng-binding\">{{ !p.categoria ? \'\' : (p.categoria == 1 ? \'Cedente\' : (p.categoria == 2 ? \'Sacado\' : \'Título\')) }}</td><td class=\"ng-binding right\">{{p.quantidadeTitulos}}</td></tr></tbody></table></div></div></div><div class=\"col-sm-5\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 195px;\"><table class=\"table table-bordered tabela-ultra-compacta\"><thead><tr><th style=\"width: 1px;\"><input type=\"checkbox\" class=\"icheckbox_minimal\" ng-change=\"controller.selecionarTodosSacados()\" ng-model=\"controller.selTodosSacados\"></th><th>Sacados do lote</th><th>Qtde</th><th>Total</th></tr></thead><tbody style=\"background-color: white;\"><tr ng-repeat=\"p in controller.listaSacados | orderBy:[\'descricao !== \\\'SACADO NOVO\\\'\', \'descricao\']\"><td style=\"width: 1px;\"><input type=\"checkbox\" class=\"icheckbox_minimal\" ng-model=\"p.selecionado\" ng-change=\"controller.alterarSituacaoSacado()\"></td><td class=\"ng-binding\" ng-class=\"{\'special-occurrence\': p.descricao === \'SACADO NOVO\'}\">{{p.descricao}}</td><td class=\"ng-binding\" style=\"text-align: right;\">{{p.quantidadeTitulos}}</td><td class=\"ng-binding\" style=\"text-align: right;\">{{p.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div><div class=\"col-lg-2\" style=\"text-align: left;\"><button class=\"btn btn-success btn-sm\" ng-click=\"controller.adicionarOcorrencia(false)\" ng-disabled=\"!controller.temSacadosSelecionados() || controller.isReadOnly\"><i class=\"fa fa-plus\"></i> Ocorrência para Sacado</button><br><br></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div ng-show=\"controller.boxTitulosVisible\"><div class=\"table-responsive\"><table class=\"table table-bordered tabela-compacta\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-change=\"controller.selecionarTodosTitulos()\" ng-model=\"controller.selTodosTitulos\" ng-disabled=\"controller.isReadOnly\"></th><th style=\"white-space: nowrap;\">Documento</th><th style=\"white-space: nowrap;\">Nome do Sacado</th><th style=\"white-space: nowrap;\">Data Vencimento</th><th style=\"white-space: nowrap; text-align: right;\">Valor</th><th style=\"white-space: nowrap; text-align: right;\">Qtde</th><th style=\"white-space: nowrap;\">Ocorrências</th><th style=\"white-space: nowrap; text-align: center;\">Aceite</th><th style=\"white-space: nowrap; text-align: center;\">Editar</th></tr></thead><tbody><tr ng-repeat=\"p in controller.paginatedTitulos\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.alterarSituacao(p)\" ng-disabled=\"controller.isReadOnly\"></td><td><i class=\"fa fa-exclamation-triangle\" ng-class=\"controller.getCriticidadeClass(p.erros)\" ng-if=\"p.erros.length > 0\"></i> {{p.numero}}</td><td>{{p.nomeSacado}}</td><td>{{p.dataVencimentoOriginal | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td style=\"text-align: right;\">{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: right;\">{{p.erros.length}}</td><td style=\"font-size: 9px !important; font-family: Helvetica, sans-serif; word-break: break-word; white-space: normal; max-width: 300px;\">{{p.descricaolinha}}<button class=\"btn btn-link btn-sm\" ng-click=\"p.showCriticidades = !p.showCriticidades\" style=\"margin-top: -3px;\"><i class=\"fa\" ng-class=\"{\'fa-chevron-down\': !p.showCriticidades, \'fa-chevron-up\': p.showCriticidades}\"></i></button><ul ng-show=\"p.showCriticidades\"><li ng-repeat=\"e in p.erros\" ng-class=\"{\'text-danger\': e.criticidade === \'S\', \'text-brown\': e.criticidade !== \'S\'}\">{{e.descricao}}</li></ul></td><td ng-if=\"p.recusado\" style=\"color: red; text-align: center; vertical-align: middle;\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></td><td ng-if=\"!p.recusado\" style=\"color: #1c84c6; text-align: center; vertical-align: middle;\"><i class=\"fa fa-check-square fa-1.5x\" aria-hidden=\"true\"></i></td><td style=\"width: 1px; text-align: center;\" ng-click=\"!controller.isReadOnly && controller.consultarAnaliseTitulo(p)\" ng-class=\"{\'disabled\': controller.isReadOnly}\"><i class=\"fa fa-pencil-square-o\" style=\"color:#f57c00; font-size: 1.5em;\" ng-style=\"controller.isReadOnly && {\'opacity\': \'0.5\', \'cursor\': \'not-allowed\'}\"></i></td></tr></tbody></table></div><div class=\"row\" style=\"align-items: center;\"><div class=\"col-sm-12\" style=\"margin-top: -20px;\"><uib-pagination total-items=\"controller.analise.titulos.length\" ng-model=\"controller.currentPage\" max-size=\"5\" boundary-links=\"true\" items-per-page=\"controller.itemsPerPage\" ng-change=\"controller.updatePagination()\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\"></uib-pagination></div></div><div class=\"row\" style=\"margin-top: 10px;\"><div class=\"col-sm-12 text-right\"><button class=\"btn btn-md\" type=\"button\" style=\"width: 140px; margin-right: 8px; margin-bottom: 8px; background-color: #6f42c1; color: #fff;\" ng-click=\"controller.abrirParecer()\"><i class=\"fa fa-comment-o\"></i> Parecer <span ng-if=\"controller.pareceresCount > 0\" class=\"badge\" style=\"background-color: rgba(255,255,255,0.25);\">{{controller.pareceresCount}}</span></button> <button class=\"btn btn-md btn-primary\" type=\"button\" style=\"width: 160px; margin-right: 8px; margin-bottom: 8px;\" ng-click=\"controller.abrirBordero()\"><i class=\"fa fa-file-text-o\"></i> Ver Borderô</button> <button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 220px; margin-bottom: 8px;\" ng-click=\"controller.aprovarAnalise()\" ng-disabled=\"controller.isReadOnly\" title=\"{{ controller.isReadOnly ? \'Modo visualização - não é possível alterar\' : \'\' }}\"><i class=\"fa fa-arrow-right\"></i> Aprovar</button></div></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.vaduAnalise == null && controller.analiseVaduErro == null && controller.exibirVadu\" cg-busy=\"controller.solicitarAnaliseVadu\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.consultaVadu\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxVaduPendente\', \'boxVaduPendente\')\"><h5><i class=\"fa fa-arrow-right\"></i> Consultas Externas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxVaduPendente\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxVaduPendente\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Grupo de Análise</label><select class=\"form-control\" ng-model=\"controller.vaduGrupoAnalise\" ng-options=\"item as item.anagruDescricao for item in controller.vaduGruposAnalise\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered tabela-compacta\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.vaduSacadosSelecionado\" ng-change=\"controller.vaduSelecionarTodosSacadosPre()\"></th><th>Sacado</th><th>CPF/CNPJ</th><th>Última Consulta</th><th>Total Títulos Liberados</th><th>Limite Concentração</th></tr></thead><tbody style=\"background-color: white;\"><tr ng-repeat=\"p in controller.vaduPreSacados\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\"></td><td class=\"ng-binding\">{{p.razaoSocial}}</td><td class=\"ng-binding\">{{p.cnpj}}</td><td class=\"ng-binding\" ng-class=\"{\'text-brown\': p.consulta === \'NOVO\'}\">{{p.consulta}} <span ng-if=\"p.consulta !== \'NOVO\' && p.dataUltimaConsultaVadu\">{{p.dataUltimaConsultaVadu}}</span></td><td class=\"ng-binding\">{{p.totalTitulos | currency:\'R$ \'}}</td><td ng-if=\"p.totalTitulos < controller.analise.limiteConcBordero\" style=\"color: red; text-align: left; vertical-align: middle;\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>&nbsp;&nbsp; {{controller.analise.limiteConcBordero | currency:\'R$ \'}}</td><td ng-if=\"p.totalTitulos >= controller.analise.limiteConcBordero\" style=\"color: green; text-align: left; vertical-align: middle;\"><i class=\"fa fa-check-square fa-1.5x\" aria-hidden=\"true\"></i>&nbsp;&nbsp; {{controller.analise.limiteConcBordero | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 220px;\" ng-click=\"controller.vaduSolicitarAnalise()\"><i class=\"fa fa-arrow-right\"></i> Solicitar</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.vaduAnalise != null || controller.analiseVaduErro != null && controller.exibirVadu\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultaVadu\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxVadu\', \'boxVadu\')\"><h5><i class=\"fa fa-arrow-right\"></i> Consultas Externas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxVadu\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxVadu\" class=\"ibox-content\" ng-if=\"controller.analiseVaduErro != null\"><span style=\"color: red;\">{{controller.analiseVaduErro}}</span><br><br><button class=\"btn btn-sm btn-success\" type=\"button\" ng-click=\"controller.vaduConsultarAnalise()\"><i class=\"fa fa-refresh\"></i> Atualizar</button></div><div id=\"boxVadu\" class=\"ibox-content\" ng-if=\"controller.analiseVaduErro == null\"><div class=\"row\" style=\"padding-bottom: 2px; padding-left: 1px; padding-right: 5px;\"><div class=\"col-lg-6\"><div class=\"ibox float-e-margins card-hover\"><div class=\"ibox-content\" style=\"padding-bottom: 13px;\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-6\"><span style=\"font-size: 20px; font-weight: 500; color:#1c84c6\">Borderô</span></div><div class=\"col-lg-6\" style=\"text-align: right;\"><i class=\"fa fa-file-text\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\"><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Número</div><span style=\"color: orange;\">{{controller.vaduAnalise.borana_id}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Data</div><span style=\"color: orange;\">{{controller.vaduAnalise.boranaData | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Valor</div><span style=\"color: orange;\">{{controller.vaduAnalise.boranaValorTotal | currency:\'R$ \'}}</span></div></div><hr style=\"margin: 10px 0; border-top: 1px solid #ccc;\"><div class=\"row\"><div class=\"col-lg-8\"><div style=\"font-weight: 500;\">Cedente</div><span style=\"color: orange;\">{{controller.vaduAnalise.analiseCedente.cedNomeXX}}Cedente 121</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">CPF/CNPJ</div><span style=\"color: orange;\">{{controller.vaduAnalise.analiseCedente.cedCNPJCPF}}</span></div></div></div></div></div><div class=\"col-lg-6\"><div class=\"ibox-title bg-primary center sombra-barra\" style=\"margin-bottom: 10px; padding: 15px 18px;\"><h5 style=\"margin: 0; font-size: 15px; color: white; display: inline-block;\"><i class=\"fa fa-info-circle\"></i> Ocorrências</h5></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"ibox float-e-margins card-hover\"><div class=\"ibox-content\" style=\"padding-bottom: 13px;\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-6\"><span style=\"font-size: 20px; font-weight: 500; color:#1c84c6\">Sacados</span></div><div class=\"col-lg-6\" style=\"text-align: right;\"><i class=\"fa fa-users\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\"><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Total</div><span style=\"color: orange;\">{{controller.vaduAnalise.boranaNumSacados}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Alerta</div><span style=\"color: orange;\">{{controller.vaduAnalise.boranaNumSacadosAlerta}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Bloqueio</div><span style=\"color: red;\">{{controller.vaduAnalise.boranaNumSacadosBloqueio}}</span></div></div></div></div></div><div class=\"col-lg-4\"><div class=\"ibox float-e-margins card-hover\"><div class=\"ibox-content\" style=\"padding-bottom: 13px;\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-6\"><span style=\"font-size: 20px; font-weight: 500;color:#1c84c6\">Títulos</span></div><div class=\"col-lg-6\" style=\"text-align: right;\"><i class=\"fa fa-file\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\"><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Total</div><span style=\"color: orange;\">{{controller.vaduAnalise.boranaNumTitulos}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Alerta</div><span style=\"color: orange;\">{{controller.vaduAnalise.boranaNumTitulosAlerta}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Bloqueio</div><span style=\"color: red;\">{{controller.vaduAnalise.boranaNumTitulosBloqueio}}</span></div></div></div></div></div><div class=\"col-lg-4\"><div class=\"ibox float-e-margins card-hover\"><div class=\"ibox-content\" style=\"padding-bottom: 13px;\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-6\"><span style=\"font-size: 20px; font-weight: 500; color:#1c84c6\">NF-e</span></div><div class=\"col-lg-6\" style=\"text-align: right;\"><i class=\"fa fa-certificate\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\"><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Total</div><span style=\"color: orange;\">{{controller.vaduAnalise.boranaNumNfe || 0}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Alerta</div><span style=\"color: orange;\">{{controller.vaduAnalise.boranaNumNfeAlerta}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Bloqueio</div><span style=\"color: red;\">{{controller.vaduAnalise.boranaNumNfeBloqueio}}</span></div></div></div></div></div></div></div></div><div class=\"row\" style=\"padding-bottom: 2px; padding-left: 2px; padding-right: 1px;\"><div class=\"col-sm-4\"><div class=\"table table-responsive tabela-compacta\"><label class=\"col-form-label\" style=\"color:#1c84c6\">Cedentes</label><table class=\"table table-bordered\"><thead><tr><th style=\"white-space: nowrap;\">Bloqueios</th><th style=\"white-space: nowrap;\">Alertas</th><th style=\"white-space: nowrap;\">Transferidos</th><th style=\"white-space: nowrap;\">Liberados</th><th style=\"white-space: nowrap;\">Sem Problemas</th></tr></thead><tbody><tr><td ng-click=\"controller.consultarLogCedente(\'B\')\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\" ng-if=\"controller.vaduAnalise.analiseCedente.bloqueios > 0\"></i> {{controller.vaduAnalise.analiseCedente.bloqueios}}</td><td ng-click=\"controller.consultarLogCedente(\'A\')\"><i class=\"fa fa-exclamation-triangle\" style=\"color: orange;\" ng-if=\"controller.vaduAnalise.analiseCedente.alertas > 0\"></i> {{controller.vaduAnalise.analiseCedente.alertas}}</td><td ng-click=\"controller.consultarLogCedente(\'T\')\">{{controller.vaduAnalise.analiseCedente.transferidos}}</td><td ng-click=\"controller.consultarLogCedente(\'L\')\">{{controller.vaduAnalise.analiseCedente.liberados}}</td><td ng-click=\"controller.consultarLogCedente(\'\')\">{{controller.vaduAnalise.analiseCedente.semProblemas}}</td></tr></tbody></table></div></div><div class=\"col-sm-8\"><div class=\"table table-responsive tabela-compacta\"><label class=\"col-form-label\" style=\"color:#1c84c6\">Sacados</label><table class=\"table table-bordered\"><thead><tr><th style=\"white-space: nowrap;\">Nome</th><th style=\"white-space: nowrap;\">CPF/CNPJ</th><th style=\"white-space: nowrap;\">Títulos</th><th style=\"white-space: nowrap;\">Total</th><th style=\"white-space: nowrap;\">Nfe/XML</th></tr></thead><tbody><tr ng-repeat=\"p in controller.vaduAnalise.analiseSacados\"><td ng-click=\"controller.consultarLogSacado(p)\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\" ng-if=\"p.borsacBloqueio\"></i> {{p.sacNome}} {{p.borsacBloqueio}}</td><td>{{p.sacCNPJCPF}}</td><td ng-click=\"controller.consultarSacadoTitulos(p, \'titulos\')\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\" ng-if=\"p.qtdTitBloqueio\"></i> {{p.sacQtdTitulos}}</td><td>{{p.sacValorTitulos | currency:\'R$ \'}}</td><td ng-click=\"controller.consultarSacadoTitulos(p, \'nfe\')\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\" ng-if=\"p.qtdNfeBloqueio > 0\"></i> {{p.qtdNfe}}</td><td><button class=\"btn btn-primary btn-xs\" ng-click=\"controller.verRelato(p.borsacStringSerasa)\"><i class=\"fa fa-file-text-o\"></i> Relato</button></td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/antecipacao/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n    .btn-fixed-size {\r\n        width: 200px; /* Defina a largura fixa */\r\n        height: 25px; /* Defina a altura fixa */\r\n        white-space: normal; /* Permite quebra de linha, caso o texto seja longo */\r\n        text-align: center; /* Centraliza o texto */\r\n    }    \r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Antecipações</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Antecipações</a></li><li class=\"active\"><strong>Disponíveis</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.pesquisarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" ng-model=\"controller.filtro.fornecedor\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número da Antecipação</label> <input type=\"number\" ng-model=\"controller.filtro.numeroAntecipacao\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Status</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisa()\"><option value=\"\">Todos</option><option value=\"2\">Aguardando Proposta IC (Instituição Credora)</option><option value=\"3\">Aguardando Aprovação do Fornecedor (100%)</option><option value=\"6\">Aguardando Aprovação do Fornecedor (Parcial)</option><option value=\"4\">Aguardando Formalização</option><option value=\"8\">Aguardando Assinatura</option><option value=\"10\">Em Processo de Assinatura</option><option value=\"15\">Assinatura Finalizada</option><option value=\"5\">Recusada pela IC</option><option value=\"7\">Recusada pelo Fornecedor</option><option value=\"9\">Assinado e Concluído</option><option value=\"14\">Em Analise</option><option value=\"18\">Análise finalizada</option><option value=\"23\">Concluído</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Solicitação</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" ng-model=\"controller.filtro.valorDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"number\" ng-model=\"controller.filtro.valorAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Disponíveis</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 570px;\"><table class=\"table table-bordered\"><thead><tr><th>#</th><th ng-click=\"controller.ordenarResultado(\'data\')\">Data da Solicitação<i ng-if=\"controller.orderSelected == \'data\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'fornecedor\')\">Fornecedor<i ng-if=\"controller.orderSelected == \'fornecedor\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th style=\"width: 1px;\">Status</th><th>Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.numero}}</td><td>{{p.data | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.fornecedor}}</td><td ng-if=\"p.status == 1\"><button class=\"btn btn-success btn-xs btn-fixed-size\">Aguardando Envio para IC</button></td><td ng-if=\"p.status == 2\"><button class=\"btn btn-success btn-xs btn-fixed-size\">Aguardando Proposta IC</button></td><td ng-if=\"p.status == 3\"><button class=\"btn btn-blueviolet btn-xs btn-fixed-size\">Aguardando Aprovação do Fornecedor</button></td><td ng-if=\"p.status == 6\"><button class=\"btn btn-blueviolet btn-xs btn-fixed-size\">Aguardando Aprovação do Fornecedor</button></td><td ng-if=\"p.status == 4\"><button class=\"btn btn-brown btn-xs btn-fixed-size\">Aguardando Formalização</button></td><td ng-if=\"p.status == 8\"><button class=\"btn btn-primary btn-xs btn-fixed-size\">Aguardando Assinatura</button></td><td ng-if=\"p.status == 10\"><button class=\"btn btn-olivedrab btn-xs btn-fixed-size\">Em Processo de Assinatura</button></td><td ng-if=\"p.status == 15\"><button class=\"btn btn-seagreen btn-xs btn-fixed-size\">Assinatura Finalizada</button></td><td ng-if=\"p.status == 5\"><button class=\"btn btn-danger btn-xs btn-fixed-size\">Recusada pela IC</button></td><td ng-if=\"p.status == 7\"><button class=\"btn btn-danger btn-xs btn-fixed-size\">Recusada pelo Fornecedor</button></td><td ng-if=\"p.status == 14\"><button class=\"btn btn-warning btn-xs btn-fixed-size\">Operação em Analise</button></td><td ng-if=\"p.status == 21\"><button class=\"btn btn-warning btn-xs btn-fixed-size\">Operação em Analise</button></td><td ng-if=\"p.status == 22\"><button class=\"btn btn-chocolate btn-xs btn-fixed-size\">Análise finalizada</button></td><td ng-if=\"p.status == 18\"><button class=\"btn btn-chocolate btn-xs btn-fixed-size\">Análise finalizada</button></td><td ng-if=\"p.status == 9\"><button class=\"btn btn-cadetblue btn-xs btn-fixed-size\">Assinado e Concluído</button></td><td ng-if=\"p.status == 23\"><button class=\"btn btn-cadetblue btn-xs btn-fixed-size\">Operação Concluída</button></td><td>{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-if=\"p.tipo == 0\" ng-click=\"controller.titulos(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Títulos</button><button ng-if=\"p.tipo == 1\" ng-click=\"controller.consultarCcb(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button> <button ng-if=\"p.status == 14 || p.status == 21\" ng-click=\"controller.analisarLote(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Analisar Lote</button> <button ng-if=\"p.status == 22 || p.status == 18 || p.status == 4 || p.status == 8 || p.status == 9 || p.status == 10 || p.status == 11 || p.status == 12 || p.status == 15 || p.status == 23\" ng-click=\"controller.analisarLote(p)\" class=\"btn btn-info btn-xs\"><i class=\"fa fa-eye\"></i> Lote Analisado</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/grupousuario/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-8\"><h2>Grupo de Usuários</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Grupo de Usuários</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-4\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button ng-click=\"controller.cadastrar()\" class=\"btn btn-success\" style=\"width: 150px;\"><i class=\"fa fa-plus\"></i> Novo Registro</button></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th ng-click=\"controller.ordenarResultado(\'numero\')\" style=\"width: 10px;\">#</th><th ng-click=\"controller.ordenarResultado(\'razaosocial\')\">Nome</th><th ng-click=\"controller.ordenarResultado(\'cnpj\')\">Descrição</th><th ng-click=\"controller.ordenarResultado(\'datacadastro\')\">Data de cadastro</th><th ng-click=\"controller.ordenarResultado(\'status\')\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.nome}}</td><td>{{p.descricao}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy\'}}</td><td>Ativo</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i> Editar</a> <a ng-click=\"controller.permissao(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-lock\"></i> Permissões</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/invoice/cnabsincronizado/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cnab Sincronizado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>NFe\'s</a></li><li class=\"active\"><strong>Cnab Sincronizado</strong></li></ol></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.anteciparPromise\"><div class=\"row\" cg-busy=\"controller.enviarPromise\"><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Enviar CNAB original</h5></div><div class=\"ibox-content\"><p class=\"text-muted\" style=\"margin-bottom: 15px;\">O arquivo original é enviado para tratamento na AssinaNet. Assim que o retorno estiver disponível, use \"Consultar\" para localizar os títulos no seu estoque.</p><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Clique aqui para enviar seu arquivo CNAB (.txt ou .rem)</span> <input type=\"file\" accept=\".txt,.rem\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.onArquivoSelecionado()\" name=\"arquivoCnab\"></span></div></div></div></div><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\"><h5><i class=\"fa fa-refresh\"></i> Arquivos Enviados</h5></div><div class=\"ibox-content\"><select class=\"form-control\" ng-model=\"controller.arquivoSelecionadoId\" ng-change=\"controller.onSelecionarPendente()\" ng-disabled=\"controller.isConsultando || controller.pendentes.length === 0\" style=\"margin-bottom: 10px;\"><option value=\"\" ng-if=\"controller.pendentes.length === 0\">Nenhum arquivo pendente</option><option ng-repeat=\"p in controller.pendentes\" value=\"{{p.id}}\">{{p.nomeArquivo}} — {{p.data | date:\'dd/MM/yyyy HH:mm\'}}</option></select><button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"controller.consultar()\" ng-disabled=\"!controller.arquivoSelecionadoId || controller.isConsultando\"><i class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': controller.isConsultando}\"></i> {{controller.isConsultando ? (\'Consultando... (\' + controller.tentativaAtual + \'/\' + controller.maxTentativas + \')\') : \'Consultar\'}}</button><div ng-if=\"controller.falhaSincronia\" class=\"alert alert-danger\" style=\"margin-top: 15px;\"><p style=\"margin-bottom: 10px;\">Não foi possível obter o retorno do arquivo tratado após {{controller.maxTentativas}} tentativas. Pode haver um problema na sincronia do CNAB.</p><a href=\"{{controller.ASSINANET_LOGIN_URL}}\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-external-link\"></i> Acessar o AssinaNet</a></div></div></div></div></div><div class=\"row\" ng-if=\"controller.titulosEncontrados.length > 0 || controller.titulosNaoEncontrados.length > 0\"><div class=\"col-sm-6\"><div class=\"ibox-content\" style=\"border-left: 4px solid #1ab394;\"><span class=\"text-muted small\">Localizados no Estoque</span><h4>{{controller.titulosEncontrados.length}} — {{controller.totalValor() | currency:\'R$ \'}}</h4></div></div><div class=\"col-sm-6\"><div class=\"ibox-content\" style=\"border-left: 4px solid #ed5565;\"><span class=\"text-muted small\">Não Localizados</span><h4>{{controller.titulosNaoEncontrados.length}}</h4></div></div></div><div class=\"row\" cg-busy=\"controller.validarPromise\"><div class=\"col-lg-12\"><div ng-if=\"controller.titulosEncontrados.length === 0 && controller.titulosNaoEncontrados.length === 0\" class=\"text-center text-muted\" style=\"padding: 40px 0;\"><i class=\"fa fa-bank fa-3x\"></i><h4 style=\"margin-top: 15px;\">Envie um arquivo e consulte o retorno...</h4></div><div class=\"ibox float-e-margins\" ng-if=\"controller.titulosEncontrados.length > 0\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-check-circle\"></i> Títulos Localizados no Estoque</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>Nº NFe</th><th>Nº Título</th><th>Sacado</th><th>Vencimento</th><th class=\"text-right\">Valor</th></tr></thead><tbody><tr ng-repeat=\"t in controller.titulosEncontrados\"><td>{{t.numero}}</td><td>{{t.titulo}}</td><td>{{t.sacado}}</td><td>{{t.dataVencimento}}</td><td class=\"text-right\">{{t.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"controller.titulosNaoEncontrados.length > 0\"><div class=\"ibox-title bg-danger\"><h5><i class=\"fa fa-times-circle\"></i> Não Localizados no Estoque</h5></div><div class=\"ibox-content\"><div class=\"alert alert-warning\">Esses registros vieram no CNAB tratado, mas não foram encontrados disponíveis no seu estoque (podem já ter sido antecipados, ou não pertencerem a este cedente).</div><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>Nº NFe</th><th>Nº Título</th></tr></thead><tbody><tr ng-repeat=\"t in controller.titulosNaoEncontrados\"><td>{{t.numeroNfe}}</td><td>{{t.numeroDuplicata}}</td></tr></tbody></table></div></div></div></div></div><div class=\"row\" ng-if=\"controller.titulosEncontrados.length > 0\"><div class=\"col-lg-12 text-right\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"controller.limparResultado()\"><i class=\"fa fa-trash\"></i> Limpar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.antecipar()\" ng-disabled=\"controller.isLoading\"><i class=\"fa fa-line-chart\"></i> {{controller.isLoading ? \'Enviando...\' : \'Antecipar\'}}</button></div></div></div>");
$templateCache.put("app/invoice/digitacao/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Digitação de Título</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>NFe\'s</a></li><li class=\"active\"><strong>Inclusão Manual</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDuplicatas\', \'boxDuplicatas\')\"><h5><i class=\"fa fa-tags\"></i> Títulos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDuplicatas\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDuplicatas\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12 m-b\" style=\"text-align: right;\"><button class=\"btn btn-success\" ng-click=\"controller.validarEPrevenir($event)\" style=\"width: 200px;\"><i class=\"fa fa-plus\"></i> Adicionar Título</button></div></div><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Título</th><th class=\"white-bg\">Cedente</th><th class=\"white-bg\">Sacado</th><th class=\"white-bg\">Vencimento *</th><th class=\"white-bg\">Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.titulos\"><td>{{p.numero}}</td><td>{{p.cedente.cnpj}} - {{p.cedente.razaoSocial}}</td><td>{{p.sacado.cnpj}} - {{p.sacado.razaoSocial}}</td><td>{{ p.dataVencimento | date:\'dd/MM/yyyy\' : \'UTC\' }}</td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: center; width: 1px;\"><a ng-click=\"controller.removerTitulo(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody><tfoot><tr style=\"background-color: white\"><td><b>{{controller.titulos.length}} título(s)</b></td><td colspan=\"3\"></td><td style=\"white-space: nowrap;\"><b class=\"ng-binding\">R$ {{ (controller.total | number:2) }}</b></td></tr></tfoot></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.titulos.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\" style=\"text-align: left;\"></div><div class=\"col-lg-6\"><button class=\"btn btn-md btn-primary\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.concluir()\"><i class=\"fa fa-save\"></i> Concluir</button></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/importacao/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Importação de Recebíveis</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Recebíveis</a></li><li class=\"active\"><strong>Importação</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\" cg-busy=\"controller.validarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Envio de Notas Fiscais (NF-e)</h5><div ibox-tools=\"\" class=\"ng-scope\"></div></div><div class=\"ibox-content\"><form action=\"#\" class=\"dropzone dz-clickable ng-pristine ng-valid\" dropzone=\"\" id=\"dropzone\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Clique aqui para enviar sua NFE no formato XML</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" accept=\"text/xml\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-click=\"controller.validarEPrevenir($event)\" ng-change=\"controller.adicionarItem()\" name=\"...\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\">×</a></div></div><div><div class=\"table-responsive\"><table ng-if=\"controller.nfe.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Número Nfe/Série</th><th class=\"white-bg\">Destinatario</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Chave</th></tr></thead><tbody><tr ng:repeat=\"p in controller.nfe\"><td>{{p.numeroNfe + \'/\' + p.serieNfe}}</td><td>{{p.sacado.razaoSocial}}</td><td>{{p.valorNfe}}</td><td>{{p.chaveNfe}}</td><td style=\"text-align: center; width: 1px;\"><a ng-click=\"controller.removerNfe(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody><tfoot></tfoot></table></div></div></form><div style=\"text-align: right; padding-top: 15px;\" ng-if=\"controller.emitente != null\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.concluir()\"><i class=\"fa fa-save\"></i> Enviar Títulos</button></div></div></div></div></div><div class=\"row\" ng-if=\"controller.emitente != null\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-tags\"></i> Duplicatas</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Número Nfe/Série</th><th class=\"white-bg\">Destinatario</th><th class=\"white-bg\">Duplicata</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.duplicatas\" ng-style=\"p.statusCadastro == 1 && {\'background-color\':\'yellow\'}\"><td>{{p.notaFiscal.numeroNfe + \'/\' + p.notaFiscal.serieNfe}}</td><td>{{p.notaFiscal.sacado.razaoSocial}}</td><td>{{p.numeroTitulo}}</td><td>{{p.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td>{{p.valorTexto}}</td><td>{{p.situacaoMotivo}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 1\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-check\"></i> Normal</a> <a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 2\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-info\"></i> Informativo</a> <a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 3\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-bell\"></i> Inválido</a></td></tr></tbody><tfoot><tr style=\"background-color: white\"><td ng-if=\"(controller.getTotalDuplicatasInvalidas()) == 1\" style=\"color: brown\"><b>ATENÇÃO: {{ (controller.getTotalDuplicatasInvalidas()) }} Título está inválido e não irá para o estoque!</b></td><td ng-if=\"(controller.getTotalDuplicatasInvalidas()) > 1\" style=\"color: brown\"><b>ATENÇÃO: {{ (controller.getTotalDuplicatasInvalidas()) }} Títulos estão inválidos e não irão para o estoque!</b></td><td ng-if=\"!(controller.getTotalDuplicatasInvalidas())\"></td><td colspan=\"3\"></td><td><b class=\"ng-binding\">R$ {{ (controller.getTotalDuplicatas() | number:2) }}</b></td></tr></tfoot></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.emitente != null\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Cedente</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.emitente.razaoSocial\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia</label> <input type=\"text\" ng-model=\"controller.emitente.nomeFantasia\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" ng-model=\"controller.emitente.cnpj\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Inscrição Estadual</label> <input type=\"text\" ng-model=\"controller.emitente.inscricaoEstadual\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Inscrição Municipal</label> <input type=\"text\" ng-model=\"controller.emitente.inscricaoMunicipal\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.emitente.email\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">CNAE</label> <input type=\"text\" ng-model=\"controller.emitente.cnaeDescricao\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CRT</label> <input type=\"text\" ng-model=\"controller.emitente.crtDescricao\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/fluxo/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Fluxo de Aprovação</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Operações</a></li><li class=\"active\"><strong>Fluxo de Aprovação</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Operações</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 570px;\"><table class=\"table table-bordered\"><thead><tr><th>#</th><th style=\"white-space: nowrap\">Data da Solicitação</th><th>Fornecedor</th><th>Etapa</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.id}}</td><td>{{p.dataCadastro | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.cedente.razaoSocial}}</td><td style=\"white-space: nowrap;\">Departamento de Cadastro</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Consultar</button></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/importarLote/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Importação em Lote</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>NFe\'s</a></li><li class=\"active\"><strong>Importação em Lote</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\" cg-busy=\"controller.validarPromise\" ng-if=\"controller.duplicatas.length == 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Notas Fiscais (NF-e)</h5><div ibox-tools=\"\" class=\"ng-scope\"></div></div><div class=\"ibox-content\"><form action=\"#\" class=\"dropzone dz-clickable ng-pristine ng-valid\" dropzone=\"\" id=\"dropzone\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-file-archive-o\"></i> Selecione o arquivo no formato .ZIP contendo as NFe\'s</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" accept=\".zip\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-click=\"controller.validarEPrevenir($event)\" ng-change=\"controller.adicionarItem()\" name=\"...\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\">×</a></div></div></form></div></div></div></div><div class=\"row\" ng-if=\"controller.duplicatas.length > 0\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDuplicatas\', \'boxDuplicatas\')\"><h5><i class=\"fa fa-tags\"></i> Duplicatas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDuplicatas\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDuplicatas\" class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Nfe</th><th class=\"white-bg\">Cedente</th><th class=\"white-bg\">Sacado</th><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Título</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.duplicatas\" ng-style=\"p.statusCadastro == 1 && {\'background-color\':\'yellow\'}\"><td>{{p.numeroNfe}}</td><td>{{p.titulo.notaFiscal.cedente.cnpj}} - {{p.titulo.notaFiscal.cedente.razaoSocial}}</td><td>{{p.titulo.notaFiscal.sacado.razaoSocial}}</td><td>{{p.titulo.numeroTitulo}}</td><td>{{p.titulo.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{p.titulo.valorTexto}}</td><td>{{p.titulo.situacaoMotivo}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.titulo.situacao == 3\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-bell\"></i> Inválido</a> <a ng-click=\"controller.removerTitulo(p)\" ng-if=\"p.titulo.situacao != 3\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody><tfoot><tr style=\"background-color: white\"><td colspan=\"1\"></td><td ng-if=\"(controller.getTotalDuplicatasInvalidas()) == 1\" style=\"color: brown\"><b>ATENÇÃO: {{ (controller.getTotalDuplicatasInvalidas()) }} Título está inválido e não irá para o estoque!</b></td><td ng-if=\"(controller.getTotalDuplicatasInvalidas()) > 1\" style=\"color: brown\"><b>ATENÇÃO: {{ (controller.getTotalDuplicatasInvalidas()) }} Títulos estão inválidos e não irão para o estoque!</b></td><td ng-if=\"!(controller.getTotalDuplicatasInvalidas())\"></td><td colspan=\"3\"></td><td style=\"white-space: nowrap;\"><b class=\"ng-binding\">R$ {{ (controller.getTotalDuplicatas() | number:2) }}</b></td></tr></tfoot></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.falhas.length > 0\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-danger\" ng-click=\"controller.showhide(\'iconBoxFalhas\', \'boxFalhas\')\"><h5><i class=\"fa fa-tags\"></i> Falhas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFalhas\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFalhas\" class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Nfe</th><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Título</th><th class=\"white-bg\">Mensagem</th><th class=\"white-bg\">Cedente</th></tr></thead><tbody><tr ng:repeat=\"p in controller.falhas\" ng-style=\"p.statusCadastro == 1 && {\'background-color\':\'yellow\'}\"><td>{{p.numeroNfe}}</td><td>{{p.titulo.numeroTitulo}}</td><td>{{p.mensagem}}</td><td>{{p.titulo.notaFiscal.cedente.cnpj}} - {{p.titulo.notaFiscal.cedente.razaoSocial}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.duplicatas.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\" style=\"text-align: left;\"><button class=\"btn btn-md btn-danger\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.novo()\"><i class=\"fa fa-retweet\"></i> Nova Importação</button></div><div class=\"col-lg-6\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.concluir()\"><i class=\"fa fa-save\"></i> Enviar Títulos</button></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/operacao/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Operações</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Antecipações</a></li><li class=\"active\"><strong>Operações</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" ng-model=\"controller.filtro.fornecedor\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Operação</label> <input type=\"number\" ng-model=\"controller.filtro.numeroAntecipacao\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Status</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisa()\"><option value=\"\">Todos</option><option value=\"14\">Aguardando Análise da IC</option><option value=\"2\">Aguardando Proposta da IC</option><option value=\"3\">Aguardando Aprovação do Cedente/Fornecedor (100%)</option><option value=\"6\">Aguardando Aprovação do Cedente/Fornecedor (Parcial)</option><option value=\"4\">Aguardando Formalização</option><option value=\"8\">Aguardando Assinatura</option><option value=\"5\">Recusada pela IC</option><option value=\"7\">Recusada pelo Cedente/Fornecedor</option><option value=\"9\">Concluído</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Solicitação</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" ng-model=\"controller.filtro.valorDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"number\" ng-model=\"controller.filtro.valorAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Disponíveis</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 570px;\"><table class=\"table table-bordered\"><thead><tr><th>#</th><th style=\"white-space: nowrap\">Data da Solicitação</th><th>Fornecedor</th><th style=\"width: 1px;\">Status</th><th>Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.numero}}</td><td>{{p.data | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.fornecedor}}</td><td ng-if=\"p.status == 14\"><button class=\"btn btn-success btn-xs btn-block\">Aguardando Análise da IC</button></td><td ng-if=\"p.status == 1\"><button class=\"btn btn-success btn-xs btn-block\">Aguardando Envio para IC</button></td><td ng-if=\"p.status == 2\"><button class=\"btn btn-success btn-xs btn-block\">Aguardando Proposta IC</button></td><td ng-if=\"p.status == 3\"><button class=\"btn btn-blueviolet btn-xs btn-block\">Aguardando Aprovação do Cedente/Fornecedor</button></td><td ng-if=\"p.status == 6\"><button class=\"btn btn-blueviolet btn-xs btn-block\">Aguardando Aprovação do Cedente/Fornecedor (Parcial)</button></td><td ng-if=\"p.status == 4\"><button class=\"btn btn-warning btn-xs btn-block\">Aguardando Formalização</button></td><td ng-if=\"p.status == 8\"><button class=\"btn btn-warning btn-xs btn-block\">Aguardando Assinatura</button></td><td ng-if=\"p.status == 5\"><button class=\"btn btn-danger btn-xs btn-block\">Recusada pela IC</button></td><td ng-if=\"p.status == 7\"><button class=\"btn btn-danger btn-xs btn-block\">Recusada pelo Cedente/Fornecedor</button></td><td ng-if=\"p.status == 9\"><button class=\"btn btn-primary btn-xs btn-block\">Concluído</button></td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-click=\"controller.titulos(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Títulos</button><button ng-click=\"controller.consultarAnalise(p)\" ng-if=\"p.status == 14\" class=\"btn btn-primary btn-xs\" style=\"width: 110px;\"><i class=\"fa fa-edit\"></i> Análise</button> <button ng-click=\"controller.consultarNegociacao(p)\" ng-if=\"p.status == 2\" class=\"btn btn-primary btn-xs\" style=\"width: 110px;\"><i class=\"fa fa-dollar\"></i> Negociação</button> <button ng-click=\"controller.consultarFormalizacao(p)\" ng-if=\"p.status == 4\" class=\"btn btn-primary btn-xs\" style=\"width: 110px;\"><i class=\"fa fa-edit\"></i> Formalização</button></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/titulos/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n\r\n    .text-warning {\r\n        color: #f8ac59 !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Títulos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">NFe\'s</a></li><li class=\"active\"><strong>Estoque de Títulos</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.listarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">N° NFe</label> <input type=\"text\" ng-model=\"controller.filtro.nfe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Título</label> <input type=\"text\" ng-model=\"controller.filtro.titulo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" ng-model=\"controller.filtro.fornecedor\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <input type=\"text\" ng-model=\"controller.filtro.sacado\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Vencimento</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data Inclusão</label> <input type=\"date\" ng-model=\"controller.filtro.dataCadastro\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" ng-model=\"controller.filtro.valorDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"number\" ng-model=\"controller.filtro.valorAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Status</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisaStatus()\"><option ng-value=\"6\">Consultando SEFAZ</option><option ng-value=\"1\">Disponíveis</option><option ng-value=\"4\">CFOP Bloqueado</option><option ng-value=\"5\">Nfe Cancelada</option><option ng-value=\"2\">Em negociação</option><option ng-value=\"3\">Já negociados</option></select></div></div></div><div class=\"row\" style=\"display: none;\"><div class=\"col-sm-12\"><button class=\"btn btn-success pull-right\" ng-click=\"controller.pesquisar()\"><span class=\"fa fa-search\"></span> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Títulos</h5><div class=\"ibox-tools\"><a ng-click=\"controller.listar()\"><i class=\"fa fa-refresh\" style=\"color: white; font-size: 22px;\"></i></a></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div><table class=\"table table-bordered\" style=\"margin-bottom: 0px;\"><thead><tr><th style=\"width: 1px;\"></th><th ng-click=\"controller.ordenarResultado(\'nfe\')\" style=\"white-space: nowrap;\">Nº NFe<i ng-if=\"controller.orderSelected == \'nfe\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"white-space: nowrap;\">Nº Título<i ng-if=\"controller.orderSelected == \'titulo\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th>Origem</th><th style=\"white-space: nowrap;\">NFe</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado<i ng-if=\"controller.orderSelected == \'sacado\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'fornecedor\')\">Fornecedor<i ng-if=\"controller.orderSelected == \'fornecedor\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'datacadastro\')\" style=\"white-space: nowrap;\">Dt. Inclusão<i ng-if=\"controller.orderSelected == \'datacadastro\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\" style=\"white-space: nowrap;\">Dt. Vencimento<i ng-if=\"controller.orderSelected == \'vencimento\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'valor\')\">Valor<i ng-if=\"controller.orderSelected == \'valor\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th>Status</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"width: 1px;\"><input ng-if=\"p.status == 1 && (p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null)\" icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"p.selecionadoAntecipar\"> <input ng-if=\"p.status != 1\" disabled=\"\" icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"p.selecionadoAntecipar\"></td><td ng-class=\"{\'text-warning font-bold\': p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\" title=\"{{ (p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'3\') !== -1) ? \'Carta de Correção\' : \'\' }}\">{{p.numero}}</td><td ng-class=\"{\'text-warning font-bold\': p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\" title=\"{{ (p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'3\') !== -1) ? \'Carta de Correção\' : \'\' }}\">{{p.titulo}}</td><td style=\"text-align: center;\"><i ng-if=\"p.tipoOrigem == 0\" class=\"fa fa-certificate\" title=\"Nfe\"></i> <i ng-if=\"p.tipoOrigem == 1\" class=\"fa fa-file-zip-o\" title=\"Lote Nfe\"></i> <i ng-if=\"p.tipoOrigem == 2\" class=\"fa fa-user\" title=\"Digitado\"></i> <i ng-if=\"p.tipoOrigem == 3\" class=\"fa fa-cog\" title=\"CNAB\"></i></td><td style=\"text-align: center;\"><i ng-if=\"p.tipoDocumento == null\" class=\"fa fa-check\" style=\"color: green;\"></i> <i ng-if=\"p.tipoDocumento != null\" class=\"fa fa-times\" style=\"color: red;\"></i></td><td title=\"{{p.sacado}}\">{{p.sacado | limitTo: 30 }}{{p.sacado.length > 30 ? \'...\' : \'\'}}</td><td title=\"{{p.cedente}}\">{{p.cedente | limitTo: 35 }}{{p.cedente.length > 35 ? \'...\' : \'\'}}</td><td>{{p.dataCadastro | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-class=\"{\'text-warning font-bold\': p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'1\') !== -1}\" title=\"{{ (p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'1\') !== -1) ? \'Carta de Correção\' : \'\' }}\">{{p.dataVencimento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td style=\"white-space: nowrap;\" ng-class=\"{\'text-warning font-bold\': p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'2\') !== -1}\" title=\"{{ (p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'2\') !== -1) ? \'Carta de Correção\' : \'\' }}\">{{p.valor | currency:\'R$ \'}}</td><td ng-if=\"p.status == 1\" style=\"width: 1px;\"><button class=\"btn btn-danger btn-xs btn-block\" ng-if=\"p.isPendenteSefaz\">Consultando SEFAZ</button> <button class=\"btn btn-danger btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe == \'101\'\">Nfe Cancelada</button> <button class=\"btn btn-danger btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.cfopBloqueado != null\" title=\"{{p.cfopBloqueado}}\">CFOP Bloqueado</button> <button class=\"btn btn-success btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null && p.isPossuiCartaoCorrecao == false\">Disponível</button> <button class=\"btn btn-primary btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null && p.isPossuiCartaoCorrecao == true\">Disponível C/C</button></td><td ng-if=\"p.status == 2\" style=\"width: 1px;\"><button class=\"btn btn-warning btn-xs\">EM NEGOCIAÇÃO</button></td><td ng-if=\"p.status == 3\" style=\"width: 1px;\"><button class=\"btn btn-primary btn-xs\">JÁ NEGOCIADO</button></td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><button class=\"btn btn-warning btn-xs\" ng-click=\"controller.consultarTitulo(p)\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div><div><span style=\"font-weight: bold;\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}} <span ng-if=\"controller.total.valorTotal > 0\">em {{controller.total.quantidade}} título{{(controller.total.quantidade > 1 ? \'s \' : \'\')}} selecionado{{(controller.total.quantidade > 1 ? \'s \' : \'\')}}</span></span></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\"><button ng-click=\"controller.marcarTodos()\" class=\"btn btn-md btn-primary\" type=\"button\"><i class=\"fa fa-check-square\"></i> MARCAR TODOS</button> <button ng-click=\"controller.desmarcarTodos()\" class=\"btn btn-md btn-warning\" type=\"button\"><i class=\"fa fa-minus-square\"></i> DESMARCAR TODOS</button></div><div class=\"col-lg-6\" style=\"text-align: right;\"><button ng-click=\"controller.validarEPrevenir($event)\" class=\"btn btn-md btn-success\" type=\"button\"><i class=\"fa fa-arrow-right\"></i> ANTECIPAR SELECIONADOS</button></div></div></div></div></div></div></div>");
$templateCache.put("app/titulo/consultar/index.html","<style>\r\n    .ibox-content {\r\n        position: relative;\r\n        padding-left: 12px;\r\n    }    \r\n    .left-badge {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 5px;\r\n        height: 100%;\r\n        background-color: #f57c00;\r\n        border-top-left-radius: 5px;\r\n        border-bottom-left-radius: 5px;\r\n    }   \r\n    .ibox.card-hover {\r\n        transition: transform 0.4s ease-in-out, box-shadow 0.4s ease-in-out;\r\n    }\r\n    .ibox.card-hover:hover {\r\n        transform: scale(1.02);\r\n        box-shadow: 0 10px 24px rgba(28,132,198,0.3), 0 4px 8px rgba(0,0,0,0.15);\r\n        cursor: pointer;\r\n    }\r\n    .status-badge {\r\n        padding: 4px 12px;\r\n        border-radius: 4px;\r\n        font-weight: 600;\r\n        font-size: 11.5px;\r\n        display: inline-block;\r\n    }\r\n    .status-badge-blue {\r\n        background-color: #e0f2fe;\r\n        color: #0284c7;\r\n    }\r\n    .status-badge-green {\r\n        background-color: #dcfce7;\r\n        color: #16a34a;\r\n    }\r\n    .status-badge-orange {\r\n        background-color: #ffedd5;\r\n        color: #ea580c;\r\n    }\r\n    .status-badge-red {\r\n        background-color: #fee2e2;\r\n        color: #dc2626;\r\n    }\r\n    .status-badge-cyan {\r\n        background-color: #cffafe;\r\n        color: #0891b2;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Instruir Documento</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Documentos</a></li><li><a ui-sref=\"index.titulos_pesquisar\">Pesquisar</a></li><li class=\"active\"><strong>Instruir</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Dados do Documento</h5></div><div class=\"ibox-content\"><div class=\"row\" style=\"padding-bottom: 2px; display: flex; flex-wrap: wrap;\"><div class=\"col-lg-4\" style=\"display: flex;\"><div class=\"ibox float-e-margins card-hover\" style=\"width: 100%; display: flex; flex-direction: column;\"><div class=\"ibox-content\" style=\"padding-bottom: 13px; flex-grow: 1;\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-8\"><span style=\"font-size: 20px; font-weight: 500; color:#1c84c6\">Documento</span></div><div class=\"col-lg-4\" style=\"text-align: right;\"><i class=\"fa fa-file-text\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\" style=\"margin-top: 10px;\"><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Nº Documento</div><span style=\"color: orange;\">{{controller.registro.numeroNfe}} {{controller.registro.numero}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Nº Operação</div><span style=\"color: orange;\">{{controller.registro.antecipacaoTitulo.antecipacao.id}}</span></div><div class=\"col-lg-4\"><div style=\"font-weight: 500;\">Situação</div><span style=\"color: green;\">{{controller.registro.statusFinanceiroTexto}}</span></div></div><hr style=\"margin: 10px 0; border-top: 1px solid #ccc;\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"font-weight: 500;\">Cedente</div><span style=\"color: orange;\">{{controller.registro.cedente.cnpj}} - {{controller.registro.cedente.razaoSocial}}</span></div></div><div class=\"row\" style=\"margin-top: 10px;\"><div class=\"col-lg-12\"><div style=\"font-weight: 500;\">Sacado</div><span style=\"color: orange;\">{{controller.registro.sacado.cnpj}} - {{controller.registro.sacado.razaoSocial}}</span></div></div></div></div></div><div class=\"col-lg-4\" style=\"display: flex;\"><div class=\"ibox float-e-margins card-hover\" style=\"width: 100%; display: flex; flex-direction: column;\"><div class=\"ibox-content\" style=\"padding-bottom: 13px; flex-grow: 1;\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-8\"><span style=\"font-size: 20px; font-weight: 500; color:#1c84c6\">Datas</span></div><div class=\"col-lg-4\" style=\"text-align: right;\"><i class=\"fa fa-calendar\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\" style=\"margin-top: 10px;\"><div class=\"col-lg-6\"><div style=\"font-weight: 500;\">Data de Emissão</div><span style=\"color: orange;\">{{controller.registro.dataRecebimento | date:\'dd/MM/yyyy\'}}</span></div><div class=\"col-lg-6\"><div style=\"font-weight: 500;\">Data de Vencimento</div><span style=\"color: green;\">{{controller.registro.dataVencimento | date:\'dd/MM/yyyy\'}}</span></div></div><div class=\"row\" style=\"margin-top: 10px;\"><div class=\"col-lg-6\"><div style=\"font-weight: 500;\">Data da Operação</div><span style=\"color: orange;\">{{controller.registro.antecipacaoTitulo.antecipacao.dataCadastro | date:\'dd/MM/yyyy\'}}</span></div><div class=\"col-lg-6\"><div style=\"font-weight: 500;\">Previsão do Pagamento</div><span style=\"color: green;\">{{controller.registro.dataVencimento | date:\'dd/MM/yyyy\'}}</span></div></div><div class=\"row\" style=\"margin-top: 10px;\"><div class=\"col-lg-6\"></div><div class=\"col-lg-6\"><div style=\"font-weight: 500;\">Data do Pagamento</div><span style=\"color: green;\">{{controller.registro.dataPagamento | date:\'dd/MM/yyyy\'}}</span></div></div></div></div></div><div class=\"col-lg-4\" style=\"display: flex;\"><div class=\"ibox float-e-margins card-hover\" style=\"width: 100%; display: flex; flex-direction: column;\"><div class=\"ibox-content\" style=\"padding-bottom: 13px; flex-grow: 1;\"><span class=\"left-badge\"></span><div class=\"row\"><div class=\"col-lg-8\"><span style=\"font-size: 20px; font-weight: 500; color:#1c84c6\">Valores</span></div><div class=\"col-lg-4\" style=\"text-align: right;\"><i class=\"fa fa-money\" style=\"font-size: 22px;\"></i></div></div><div class=\"row\" style=\"margin-top: 10px;\"><div class=\"col-lg-6\"><div style=\"font-weight: 500;\">Valor do Documento</div><span style=\"color: orange;\">{{controller.registro.valor | currency:\'R$ \'}}</span></div><div class=\"col-lg-6\"><div style=\"font-weight: 500;\">Abatimento</div><span style=\"color: green;\">{{controller.registro.valorAbatimento | currency:\'R$ \'}}</span></div></div><div class=\"row\" style=\"margin-top: 10px;\"><div class=\"col-lg-6\"><div style=\"font-weight: 500;\">Valor Pago</div><span style=\"color: orange;\">{{controller.registro.valorPago | currency:\'R$ \'}}</span></div><div class=\"col-lg-6\"><div style=\"font-weight: 500;\">Desconto</div><span style=\"color: green;\">{{0 | currency:\'R$ \'}}</span></div></div></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxInstrucao\', \'boxInstrucao\')\"><h5><i class=\"fa fa-arrow-right\"></i> Instruções/Ocorrências</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxInstrucao\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxInstrucao\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Data Cadastro</th><th class=\"white-bg\">Descrição</th><th class=\"white-bg\">Lançamento</th><th class=\"white-bg\">Situação</th><th class=\"white-bg\">Observações</th><th class=\"white-bg\">Arquivo</th><th class=\"white-bg\" style=\"width: 1px;\"></th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.instrucoes\"><td class=\"ng-binding\" style=\"width: 150px;\">{{ p.dataCadastro | date:\'dd/MM/yyyy HH:mm:yy\'}}</td><td class=\"ng-binding\" ng-style=\"p.status == \'Estorno de Liquidação\' || p.status == \'Estorno\' ? {\'text-decoration\': \'line-through\', \'color\': \'#999\'} : {}\">{{ p.descricao }}</td><td class=\"ng-binding\">Manual</td><td class=\"ng-binding\"><span class=\"status-badge\" ng-class=\"{ \'status-badge-orange\': p.status == \'Aguardando Remessa\', \'status-badge-cyan\': p.status == \'Aguardando Retorno\', \'status-badge-blue\': p.status == \'Concluído\' || p.status == \'Informativo\', \'status-badge-green\': p.status == \'Liquidação\', \'status-badge-red\': p.status == \'Rejeitado\' || p.status == \'Estorno de Liquidação\' }\">{{ p.status }}</span></td><td style=\"font-size: 11px; word-break: break-word; white-space: normal; max-width: 250px;\"><div ng-if=\"p.observacao && p.observacao.length > 0\"><span ng-show=\"!p.showObs\" style=\"color: orange;\" title=\"{{ p.observacao }}\">{{ p.observacao | limitTo: 30 }}{{ p.observacao.length > 30 ? \'...\' : \'\' }}</span> <button class=\"btn btn-link btn-sm\" ng-click=\"p.showObs = !p.showObs\" style=\"margin-top: -3px; padding: 0; margin-left: 5px;\"><i class=\"fa\" ng-class=\"{\'fa-chevron-down\': !p.showObs, \'fa-chevron-up\': p.showObs}\"></i></button><div ng-show=\"p.showObs\" style=\"margin-top: 5px; color: orange;\">{{ p.observacao }}</div></div></td><td class=\"ng-binding\">{{ p.remessaArquivo != null ? p.remessaArquivo.nomeArquivo : (p.retornoArquivo != null ? p.retornoArquivo.nomeArquivo : \'\') }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.excluirInstrucao(p)\" class=\"btn btn-danger btn-xs\" ng-if=\"p.tipoInstrucao == 11\" title=\"Excluir informativo\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarInstrucao()\"><span><i class=\"fa fa-plus\"></i> Nova Instrução</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaCorrente\', \'boxContaCorrente\')\"><h5><i class=\"fa fa-arrow-right\"></i> Conta Corrente</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContaCorrente\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxContaCorrente\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Data</th><th class=\"white-bg\">Descrição</th><th class=\"white-bg\">Seq.</th><th class=\"white-bg\">Data Partida</th><th class=\"white-bg\">Valor Partida</th><th class=\"white-bg\">Data Pagto</th><th class=\"white-bg\">Valor Pagto</th><th class=\"white-bg\">Valor Presente</th><th class=\"white-bg\">Taxa</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.contaCorrente\"><td class=\"ng-binding\">{{ p.dataCadastro | date:\'dd/MM/yyyy\'}}</td><td class=\"ng-binding\">{{ p.tipoTexto }}</td><td class=\"ng-binding\">1</td><td class=\"ng-binding\">{{ p.dataPartida | date:\'dd/MM/yyyy\'}}</td><td>{{p.valorPartida | currency:\'R$ \'}}</td><td class=\"ng-binding\">{{ p.dataPagamento == null ? \'-\' : (p.dataPagamento | date:\'dd/MM/yyyy\')}}</td><td>{{ p.dataPagamento == null ? \'-\' : (p.valorPagamento | currency:\'R$ \')}}</td><td>{{p.valorPresente | currency:\'R$ \'}}</td><td class=\"ng-binding\">{{ p.taxaContaGrafica }}%</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\" style=\"display: none;\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxPosicaoBancaria\', \'boxPosicaoBancaria\')\"><h5><i class=\"fa fa-arrow-right\"></i> Posição Bancária</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxPosicaoBancaria\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxPosicaoBancaria\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Data / Hora</th><th class=\"white-bg\">Descrição</th><th class=\"white-bg\">Arquivo</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.posicaobancaria\"><td class=\"ng-binding\">{{ p.dataCadastro | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td class=\"ng-binding\">{{ p.ocorrenciaTexto }}</td><td class=\"ng-binding\">{{ p.nomeArquivo}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.downloadCnab(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-download\"></i> Download</button></td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/titulo/liquidacao_lote/index.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-12\"><h2>Liquidação por Lote</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cobrança</a></li><li class=\"active\"><strong>Liquidação por Lote</strong></li></ol></div></div><div class=\"wrapper wrapper-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Pesquisar</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><label class=\"col-form-label\">Cedente</label> <button ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.filtro.cedente == null ? \'Selecionar Cedente\' : (controller.filtro.cedente.codigoVmoney + \' - \' + controller.filtro.cedente.nomeFantasia + \' - \' + controller.filtro.cedente.razaoSocial) }}</button></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Vencimento De</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoFinal\" class=\"form-control\"></div></div><br><div class=\"row\"><div class=\"col-sm-4\" style=\"position: relative;\"><label class=\"col-form-label\">Estornar Lote <small class=\"text-muted\">(informe ou selecione o lote para estornar)</small></label><div class=\"input-group\"><input type=\"text\" ng-model=\"controller.filtro.loteEstorno\" class=\"form-control\" placeholder=\"Ex: LOTE-20260406-153000\" ng-focus=\"controller.mostrarDropLote = controller.ultimosLotes.length > 0\" autocomplete=\"off\"> <span class=\"input-group-btn\" ng-if=\"controller.ultimosLotes.length > 0\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"controller.mostrarDropLote = !controller.mostrarDropLote\" title=\"Ver últimos lotes\"><i class=\"fa fa-history\"></i></button></span></div><div ng-if=\"controller.mostrarDropLote && controller.ultimosLotes.length > 0\" style=\"position: absolute; z-index: 9999; background: #fff; border: 1px solid #ccc; border-radius: 4px; box-shadow: 0 4px 12px rgba(0,0,0,.15); min-width: 100%; left: 15px; top: 100%; margin-top: 2px;\"><div style=\"padding: 6px 10px; font-size: 11px; color: #888; border-bottom: 1px solid #eee; font-weight: bold; text-transform: uppercase; letter-spacing: .5px;\">Últimos 10 lotes criados</div><ul style=\"list-style: none; margin: 0; padding: 0; max-height: 260px; overflow-y: auto;\"><li ng-repeat=\"lote in controller.ultimosLotes\" ng-click=\"controller.selecionarLoteEstorno(lote)\" style=\"padding: 8px 14px; cursor: pointer; font-size: 13px; border-bottom: 1px solid #f0f0f0;\" ng-style=\"{\'background\': controller.filtro.loteEstorno === lote ? \'#e8f5e9\' : \'#fff\'}\" onmouseover=\"this.style.background=\'#f5f5f5\'\" onmouseout=\"this.style.background=(this.getAttribute(\'ng-style\') || \'\')\"><i class=\"fa fa-tag text-success\" style=\"margin-right: 6px;\"></i> <strong>{{lote}}</strong></li></ul></div></div><div class=\"col-sm-2\" style=\"padding-top: 28px;\"><button class=\"btn btn-success btn-block\" ng-click=\"controller.pesquisar()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div><div class=\"row\" ng-if=\"controller.nomeLoteGerado\"><div class=\"col-sm-12\" style=\"margin-top: 10px;\"><div class=\"alert alert-success\"><i class=\"fa fa-check-circle\"></i> Lote gerado com sucesso: <strong>{{controller.nomeLoteGerado}}</strong> &nbsp; — Guarde este código para consultar ou estornar o lote futuramente.</div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.exibirLancamentos && controller.registros != null && controller.registros.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Lançamentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><form name=\"formLancamentos\"><table class=\"table table-bordered table-hover\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th style=\"white-space: nowrap;\">Nº Documento</th><th>Sacado</th><th>Cedente</th><th style=\"white-space: nowrap; text-align: center;\">Vencimento</th><th style=\"white-space: nowrap; text-align: right;\">Valor Original</th><th style=\"white-space: nowrap; text-align: center; width: 150px;\">Valor Pago</th><th style=\"white-space: nowrap; text-align: center; width: 160px;\">Data Pagamento</th><th style=\"white-space: nowrap;\">Situação</th></tr></thead><tbody><tr ng-repeat=\"p in controller.items\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.calcularTotais()\"></td><td style=\"white-space: nowrap;\">{{p.numeroDocumento}}</td><td>{{p.razaoSocial}}</td><td>{{p.cedente}}</td><td style=\"white-space: nowrap; text-align: center;\">{{p.dataVencimento}}</td><td style=\"white-space: nowrap; text-align: right;\">{{p.valorOriginal | currency:\'R$ \'}}</td><td style=\"white-space: nowrap; text-align: center;\"><input type=\"text\" class=\"form-control\" ng-model=\"p.valorPagoEditado\" money-mask=\"\" ng-change=\"controller.calcularTotais()\" style=\"text-align: right; font-size: 13px; height: 24px; padding: 2px 4px;\" ng-disabled=\"!p.selecionado\"></td><td style=\"white-space: nowrap; text-align: center; position: relative;\"><input type=\"text\" class=\"form-control\" name=\"dataPagamento{{$index}}\" ng-model=\"p.dataPagamentoEditada\" ui-mask=\"99/99/9999\" placeholder=\"DD/MM/YYYY\" validar-data-dd-mm-yyyy=\"\" required=\"\" ng-disabled=\"!p.selecionado\" style=\"display: inline-block; font-size: 13px; height: 24px; padding: 2px 4px;\"><div class=\"text-danger\" style=\"position: absolute; left: 10px; top: 28px; font-size: 11px; white-space: nowrap;\" ng-if=\"formLancamentos[\'dataPagamento\'+$index].$error.validarDataDdMmYyyy && formLancamentos[\'dataPagamento\'+$index].$touched\">Data inválida</div></td><td style=\"white-space: nowrap;\">{{p.statusFinanceiroTexto}}</td></tr><tr><td colspan=\"4\"></td><td style=\"white-space: nowrap; text-align: center;\"><b>Qtde: {{controller.totalQtd}}</b></td><td style=\"white-space: nowrap; text-align: right;\"><b>TOTAL</b></td><td style=\"white-space: nowrap; text-align: right;\"><b>{{controller.totalValor | currency:\'R$ \'}}</b></td><td colspan=\"2\"></td></tr></tbody></table></form></div><div class=\"row\" style=\"margin-top: 10px;\" ng-if=\"controller.pager.totalPages > 1\"><div class=\"col-md-12\" style=\"text-align: center;\"><ul class=\"pagination pagination-sm\" style=\"margin: 0;\"><li ng-class=\"{disabled: controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">&laquo;</a></li><li ng-class=\"{disabled: controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active: controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled: controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próximo</a></li><li ng-class=\"{disabled: controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">&raquo;</a></li></ul><small class=\"text-muted\">Exibindo {{controller.pager.startIndex + 1}} a {{controller.pager.endIndex + 1}} de {{controller.registros.length}} registros</small></div></div><div style=\"text-align: right; margin-top: 10px;\"><button ng-click=\"controller.filtro.loteEstorno ? controller.estornarLote() : controller.enviarLote()\" class=\"btn\" ng-class=\"{ \'btn-success\': !controller.filtro.loteEstorno && controller.podeEnviarLote(), \'btn-warning\': controller.filtro.loteEstorno && controller.podeEnviarLote(), \'btn-danger\': !controller.podeEnviarLote() }\" style=\"width: 200px;\" ng-disabled=\"formLancamentos.$invalid || !controller.podeEnviarLote()\" title=\"{{!controller.podeEnviarLote() ? \'Selecione títulos com valores e datas válidas\' : (controller.filtro.loteEstorno ? \'Clique para estornar o lote\' : \'Clique para liquidar o lote\')}}\"><i class=\"fa\" ng-class=\"controller.filtro.loteEstorno ? \'fa-undo\' : \'fa-check\'\"></i> <span ng-if=\"controller.filtro.loteEstorno\">Estornar Lote</span> <span ng-if=\"!controller.filtro.loteEstorno\">Liquidar Lote</span></button></div></div></div></div></div></div>");
$templateCache.put("app/titulo/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-12\"><h2>Consultar Documento</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Documentos</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Título</label><div class=\"input-group\"><input type=\"text\" ng-model=\"controller.filtro.numero\" class=\"form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"controller.filtro.numero = null\" title=\"Limpar Nº Título\"><i class=\"fa fa-times\"></i></button></span></div></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label><div class=\"input-group\"><input type=\"text\" ng-model=\"controller.filtro.sacado\" class=\"form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"controller.filtro.sacado = null\" title=\"Limpar Sacado\"><i class=\"fa fa-times\"></i></button></span></div></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label><div class=\"input-group\"><input type=\"text\" ng-model=\"controller.filtro.cedente\" class=\"form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"controller.filtro.cedente = null\" title=\"Limpar Cedente\"><i class=\"fa fa-times\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label><div class=\"input-group\"><input type=\"date\" ng-model=\"controller.filtro.data\" class=\"form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"controller.filtro.data = null\" title=\"Limpar Data\"><i class=\"fa fa-times\"></i></button></span></div></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo Data</label><div><div class=\"radio\" style=\"margin-top: 5px;\"><label><input type=\"radio\" ng-model=\"controller.filtro.tipoData\" value=\"Emissao\"> Emissão</label></div><div class=\"radio\"><label><input type=\"radio\" ng-model=\"controller.filtro.tipoData\" value=\"Vencimento\"> Vencimento</label></div></div></div></div><div class=\"col-sm-5 col-sm-offset-2\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><div style=\"margin-top: 5px;\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"controller.filtro.situacao\" value=\"Pendente\"> Pendente</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"controller.filtro.situacao\" value=\"Liquidado\"> Liquidado</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"controller.filtro.situacao\" value=\"Baixado\"> Baixado</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"controller.filtro.situacao\" value=\"Todos\"> Todos</label></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.pesquisarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Documentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px; cursor: pointer; white-space: nowrap;\" ng-click=\"controller.ordenar(\'id\')\"># <i ng-class=\"controller.sortIcon(\'id\')\"></i></th><th style=\"white-space: nowrap; cursor: pointer;\" ng-click=\"controller.ordenar(\'numero\')\">Nº Documento <i ng-class=\"controller.sortIcon(\'numero\')\"></i></th><th style=\"cursor: pointer;\" ng-click=\"controller.ordenar(\'sacado\')\">Sacado <i ng-class=\"controller.sortIcon(\'sacado\')\"></i></th><th style=\"cursor: pointer;\" ng-click=\"controller.ordenar(\'cedente\')\">Cedente <i ng-class=\"controller.sortIcon(\'cedente\')\"></i></th><th style=\"white-space: nowrap; cursor: pointer;\" ng-click=\"controller.ordenar(\'emissao\')\">Emissão <i ng-class=\"controller.sortIcon(\'emissao\')\"></i></th><th style=\"white-space: nowrap; cursor: pointer;\" ng-click=\"controller.ordenar(\'vencimento\')\">Vencimento <i ng-class=\"controller.sortIcon(\'vencimento\')\"></i></th><th style=\"cursor: pointer;\" ng-click=\"controller.ordenar(\'valor\')\">Valor <i ng-class=\"controller.sortIcon(\'valor\')\"></i></th><th style=\"white-space: nowrap; cursor: pointer;\" ng-click=\"controller.ordenar(\'dataPagamento\')\">Data Pagamento <i ng-class=\"controller.sortIcon(\'dataPagamento\')\"></i></th><th style=\"white-space: nowrap; cursor: pointer;\" ng-click=\"controller.ordenar(\'valorPago\')\">Valor Pago <i ng-class=\"controller.sortIcon(\'valorPago\')\"></i></th><th style=\"cursor: pointer;\" ng-click=\"controller.ordenar(\'situacao\')\">Situação <i ng-class=\"controller.sortIcon(\'situacao\')\"></i></th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.numeroNfe}} {{p.numero}}</td><td>{{p.sacado.razaoSocial}}</td><td>{{p.cedente.razaoSocial}}</td><td>{{p.dataRecebimento | date:\'dd/MM/yyyy\'}}</td><td>{{p.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td><td>{{p.dataPagamento | date:\'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{p.valorPago | currency:\'R$ \'}}</td><td>{{p.statusFinanceiroTexto}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\" style=\"margin: 0\"></ul></div></div></footer></div></div></div></div></div>");
$templateCache.put("app/relatorio/gerador/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>{{controller.name}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Relatórios</a></li><li class=\"active\"><strong>{{controller.name}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><iframe id=\"frameID\" width=\"100%\" height=\"1000\" frameborder=\"0\" ng-src=\"{{controller.iFrameUrl}}\"></iframe></div></div></div>");
$templateCache.put("app/titulo/posicao/index.html","<style>\r\n    @media print {\r\n        @page { margin: 0; }\r\n        body { font-size: 10px; background-color: #fff; margin: 0 !important; padding: 0 1cm !important; }\r\n        .wrapper-content { padding-top: 0 !important; padding-bottom: 0 !important; margin: 0 !important; }\r\n        .print-only-tr th { padding-top: 1cm !important; }\r\n        .no-print { display: none !important; }\r\n        .col-md-12, .col-lg-12 { width: 100%; float: left; }\r\n        .table { width: 100%; border-collapse: collapse; }\r\n        .table th, .table td { border: none !important; padding: 4px; }\r\n        .table th { border-bottom: 2px solid red !important; }\r\n        .navbar-static-side, .page-heading, .navbar-static-top, #page-wrapper > .row.border-bottom { display: none !important; }\r\n        #page-wrapper { margin: 0 !important; padding: 0 !important; background: white; }\r\n        .ibox { border: none; margin: 0; }\r\n        .ibox-title, .ibox-content { border: none; padding: 0; }\r\n        .print-header { text-align: center; margin-bottom: 20px; }\r\n        .print-total-row { border-top: 1px solid #000 !important; font-weight: bold; }\r\n        .table tbody tr td { border-bottom: none !important; }\r\n        .table-scroll { max-height: none !important; overflow-y: visible !important; }\r\n        .label { border: none !important; background: transparent !important; padding: 0 !important; font-size: 11px !important; }\r\n        .label-warning { color: #1ab394 !important; }\r\n        .label-primary { color: #1c84c6 !important; }\r\n        .label-default { color: #ed5565 !important; }\r\n        .text-blue-print { color: #1a5276 !important; }\r\n    }\r\n    .print-header { display: none; }\r\n    .print-only-tr { display: none; }\r\n    @media print { \r\n        .print-header { display: block; } \r\n        .print-only-tr { display: table-row; }\r\n    }\r\n    \r\n    @media screen {\r\n        .table-scroll th {\r\n            position: sticky;\r\n            top: 0;\r\n            background-color: #ffffff;\r\n            z-index: 10;\r\n            /* box-shadow replaces border-bottom to avoid disappearing during scroll on collapsed tables */\r\n            box-shadow: inset 0 -2px 0 red, inset 0 2px 0 white; /* optional if needed, but inset 0 -2px 0 red should be fine */\r\n            border-bottom: none !important;\r\n        }\r\n    }\r\n    \r\n    .table-scroll {\r\n        max-height: 500px;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .row-striped {\r\n        background-color: #e8e8e8 !important;\r\n    }\r\n\r\n    .text-blue-print { color: #1a5276 !important; }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading no-print\"><div class=\"col-lg-10\"><h2>Posição de Carteira de Títulos</h2><ol class=\"breadcrumb\"><li><a href=\"#/index/main\">Home</a></li><li><a>Cobrança</a></li><li class=\"active\"><strong>Posição de Títulos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeInRight no-padding-print\" cg-busy=\"controller.promise\"><div class=\"row no-print\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\"><h5><i class=\"fa fa-filter\"></i> Filtros para Consulta</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label>Escolha o Cedente:</label><ui-select ng-model=\"controller.filtro.cedenteId\" theme=\"bootstrap\" allow-clear=\"true\"><ui-select-match allow-clear=\"true\" placeholder=\"Escolha o Cedente...\">{{$select.selected.razaoSocial}}</ui-select-match><ui-select-choices repeat=\"c.id as c in controller.cedentes | filter: $select.search\"><div ng-bind-html=\"(c.cnpj ? c.cnpj + \' - \' : \'\') + c.razaoSocial | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group\"><label>Escolha o Sacador Avalista:</label><ui-select ng-model=\"controller.filtro.sacadorAvalistaId\" theme=\"bootstrap\" allow-clear=\"true\"><ui-select-match allow-clear=\"true\" placeholder=\"Escolha o Sacador Avalista...\">{{$select.selected.razaoSocial}}</ui-select-match><ui-select-choices repeat=\"c.id as c in controller.cedentes | filter: $select.search\"><div ng-bind-html=\"(c.cnpj ? c.cnpj + \' - \' : \'\') + c.razaoSocial | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group\"><label>Escolha o Sacado:</label><ui-select ng-model=\"controller.filtro.sacadoId\" theme=\"bootstrap\" allow-clear=\"true\"><ui-select-match allow-clear=\"true\" placeholder=\"Escolha o Sacado...\">{{$select.selected.razaoSocial}}</ui-select-match><ui-select-choices repeat=\"s.id as s in controller.sacados | filter: $select.search\"><div ng-bind-html=\"(s.cnpj ? s.cnpj + \' - \' : \'\') + s.razaoSocial | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label>Tipo Data:</label><select class=\"form-control\" ng-model=\"controller.filtro.tipoData\"><option value=\"Emissao\">Emissão</option><option value=\"Vencimento\">Vencimento</option><option value=\"Pagamento\">Pagamento</option></select></div><div class=\"form-group\"><label>Data Inicial:</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.filtro.dataInicial\"></div><div class=\"form-group\"><label>Data Final:</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.filtro.dataFinal\"></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label>Situação:</label><select class=\"form-control\" ng-model=\"controller.filtro.situacao\"><option value=\"Pendente\">Pendente</option><option value=\"Liquidado\">Liquidado</option><option value=\"Baixado\">Baixado</option><option value=\"Todos\">Todos</option></select></div></div><div class=\"col-md-3 text-right\"><div class=\"form-group\" style=\"margin-top: 22px;\"><button class=\"btn btn-primary\" style=\"width: 100%; border-radius: 3px;\" ng-click=\"controller.gerarRelatorio()\"><i class=\"fa fa-search\"></i> Gerar Relatório</button></div><div class=\"form-group\" style=\"margin-top: 15px;\"><button class=\"btn btn-default\" style=\"width: 100%; border-radius: 3px;\" ng-click=\"controller.imprimir()\" ng-disabled=\"!controller.relatorio\"><i class=\"fa fa-print\"></i> Exportar / Imprimir</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.relatorio\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"background-color: white;\"><div class=\"table-responsive table-scroll\" style=\"overflow-x: visible;\"><table class=\"table\" style=\"font-size: 11px;\"><thead><tr class=\"print-only-tr\"><th colspan=\"8\" style=\"border: none !important; border-bottom: none !important; box-shadow: none !important; padding: 0; background-color: white !important; font-weight: normal;\"><div class=\"print-header\" style=\"text-align: center; margin-bottom: 5px; position: relative;\"><div ng-if=\"main.logoUrl\" style=\"position: absolute; left: 0; top: 0;\"><img ng-src=\"{{main.logoUrl}}\" style=\"max-height: 40px; max-width: 150px;\" alt=\"Logo Cliente\"></div><h2 style=\"color: #1a5276 !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; margin-top: 0; font-weight: bold;\">Posição de Carteira de Títulos</h2><div style=\"position: relative;\"><h4 style=\"color: #1a5276 !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; font-weight: bold;\">Cedente: {{controller.getCedenteName()}} | Por {{controller.filtro.tipoData}} | Situação: {{controller.filtro.situacao}}</h4><div style=\"position: absolute; right: 0; bottom: 0; font-size: 10px;\">{{controller.dataGeracao | date:\'dd/MM/yyyy HH:mm:ss\'}}</div></div></div></th></tr><tr><th>Razão Social</th><th>Duplicata</th><th class=\"text-center\">Emissão</th><th class=\"text-center\">Vencto</th><th class=\"text-right\">Valor</th><th class=\"text-center\">Pagamento</th><th class=\"text-right\">VlrPago</th><th class=\"text-center\">Situação</th></tr></thead><tbody ng-if=\"!controller.temSubGrupos()\" ng-repeat=\"grupo in controller.relatorio.grupos\"><tr><td colspan=\"8\" style=\"padding-top: 15px; color: #1a5276 !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; font-weight: bold;\">{{controller.getLabelGrupo()}}: {{grupo.grupoId}} - {{grupo.razaoSocial}}</td></tr><tr ng-repeat=\"titulo in grupo.titulos\" ng-class=\"{\'row-striped\': $odd}\" style=\"border-bottom: none !important;\"><td style=\"border-top: none;\">{{titulo.razaoSocialSacado}}</td><td style=\"border-top: none;\">{{titulo.duplicata}}</td><td style=\"border-top: none;\" class=\"text-center\">{{titulo.emissao}}</td><td style=\"border-top: none;\" class=\"text-center\">{{titulo.vencimento}}</td><td style=\"border-top: none;\" class=\"text-right\">{{titulo.valor | number:2}}</td><td style=\"border-top: none;\" class=\"text-center\">{{titulo.pagamento}}</td><td style=\"border-top: none;\" class=\"text-right\">{{titulo.valorPago | number:2}}</td><td style=\"border-top: none;\" class=\"text-center\"><span class=\"label\" ng-class=\"{\'label-warning\': titulo.situacao == \'Pendente\', \'label-primary\': titulo.situacao == \'Liquidado\', \'label-default\': titulo.situacao == \'Baixado\'}\">{{titulo.situacao}}</span></td></tr><tr class=\"print-total-row\"><td colspan=\"4\" class=\"text-right\"><strong>Total {{controller.getLabelGrupo()}}:</strong></td><td class=\"text-right\"><strong>{{grupo.totalGrupo | number:2}}</strong></td><td colspan=\"2\"></td><td class=\"text-center\" style=\"white-space: nowrap;\"><strong>Qtde Títulos: {{grupo.quantidadeGrupo}}</strong></td></tr></tbody><tbody ng-if=\"controller.temSubGrupos()\" ng-repeat-start=\"grupo in controller.relatorio.grupos\"><tr><td colspan=\"8\" style=\"padding-top: 15px; color: #1a5276 !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; font-weight: bold;\">{{controller.getLabelGrupo()}}: {{grupo.grupoId}} - {{grupo.razaoSocial}}</td></tr></tbody><tbody ng-if=\"controller.temSubGrupos()\" ng-repeat=\"sub in grupo.subGrupos\"><tr><td colspan=\"8\" style=\"padding-left: 15px; font-weight: bold; color: #2874a6; border-top: none !important;\">{{controller.getLabelSubGrupo()}}: {{sub.razaoSocial}} {{sub.cnpj ? \'(\' + sub.cnpj + \')\' : \'\'}}</td></tr><tr ng-repeat=\"titulo in sub.titulos\" ng-class=\"{\'row-striped\': $odd}\" style=\"border-bottom: none !important;\"><td style=\"border-top: none; padding-left: 20px;\">{{titulo.razaoSocialSacado}}</td><td style=\"border-top: none;\">{{titulo.duplicata}}</td><td style=\"border-top: none;\" class=\"text-center\">{{titulo.emissao}}</td><td style=\"border-top: none;\" class=\"text-center\">{{titulo.vencimento}}</td><td style=\"border-top: none;\" class=\"text-right\">{{titulo.valor | number:2}}</td><td style=\"border-top: none;\" class=\"text-center\">{{titulo.pagamento}}</td><td style=\"border-top: none;\" class=\"text-right\">{{titulo.valorPago | number:2}}</td><td style=\"border-top: none;\" class=\"text-center\"><span class=\"label\" ng-class=\"{\'label-warning\': titulo.situacao == \'Pendente\', \'label-primary\': titulo.situacao == \'Liquidado\', \'label-default\': titulo.situacao == \'Baixado\'}\">{{titulo.situacao}}</span></td></tr><tr style=\"border-bottom: 1px solid #efefef;\"><td colspan=\"4\" class=\"text-right\" style=\"color: #555;\">Subtotal {{controller.getLabelSubGrupo()}}:</td><td class=\"text-right\" style=\"color: #555; font-weight: bold;\">{{sub.totalSubGrupo | number:2}}</td><td colspan=\"2\"></td><td class=\"text-center\" style=\"color: #555; white-space: nowrap;\">Qtde: {{sub.quantidadeSubGrupo}}</td></tr></tbody><tbody ng-if=\"controller.temSubGrupos()\" ng-repeat-end=\"\"><tr class=\"print-total-row\"><td colspan=\"4\" class=\"text-right\"><strong>Total {{controller.getLabelGrupo()}}:</strong></td><td class=\"text-right\"><strong>{{grupo.totalGrupo | number:2}}</strong></td><td colspan=\"2\"></td><td class=\"text-center\" style=\"white-space: nowrap;\"><strong>Qtde Títulos: {{grupo.quantidadeGrupo}}</strong></td></tr></tbody><tfoot ng-if=\"controller.relatorio.quantidadeTotal > 0\"><tr><td colspan=\"8\" style=\"border-top: none;\">&nbsp;</td></tr><tr style=\"border-top: 2px solid red;\"><td colspan=\"4\" class=\"text-right\"><h4><strong>TOTAL GERAL:</strong></h4></td><td class=\"text-right\"><h4><strong>{{controller.relatorio.totalGeral | number:2}}</strong></h4></td><td colspan=\"2\"></td><td class=\"text-center\" style=\"white-space: nowrap;\"><h4><strong>Qtde Títulos: {{controller.relatorio.quantidadeTotal}}</strong></h4></td></tr></tfoot></table><div ng-if=\"controller.relatorio.grupos.length === 0\" class=\"text-center\" style=\"padding: 20px;\">Nenhum título encontrado para este período.</div></div></div></div></div></div></div>");
$templateCache.put("app/usuarios/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-8\"><h2>Usuários</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuários</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-4\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button ng-click=\"controller.cadastrar()\" class=\"btn btn-success\" style=\"width: 150px;\"><i class=\"fa fa-plus\"></i> Novo Usuário</button></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Pesquisar</h5><div class=\"ibox-tools\"><a ng-click=\"controller.redirectToURL(); $event.stopPropagation()\" title=\"Manual: Cadastro de Usuários\"><i class=\"fa fa-book\" style=\"color: white; font-size: 22px;\"></i></a></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th ng-click=\"controller.ordenarResultado(\'razaosocial\')\">Nome</th><th ng-click=\"controller.ordenarResultado(\'cnpj\')\">E-mail</th><th>Restrito</th><th>Administrador</th><th ng-click=\"controller.ordenarResultado(\'status\')\" style=\"width: 140px;\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.email}}</td><td style=\"width: 140px;\">{{p.restrito ? \'Sim\' : \'Não\'}}</td><td style=\"width: 140px;\">{{p.isAdmin ? \'Sim\' : \'Não\'}}</td><td style=\"width: 140px;\">Ativo</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a> <a ng-click=\"controller.excluir(p)\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-trash\"></i> Excluir</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/salario_demanda/envio/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Salário sob Demanda</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Salário Demanda</a></li><li class=\"active\"><strong>Envio</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\" cg-busy=\"controller.validarPromise\" ng-if=\"controller.cnab == null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>CNAB</h5><div ibox-tools=\"\" class=\"ng-scope\"></div></div><div class=\"ibox-content\"><form action=\"#\" class=\"dropzone dz-clickable ng-pristine ng-valid\" dropzone=\"\" id=\"dropzone\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Clique aqui para enviar o arquivo CNAB</span> <input type=\"file\" accept=\".rem\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-click=\"controller.validarEPrevenir($event)\" ng-change=\"controller.adicionarItem()\" name=\"...\"></span> <span class=\"fileinput-filename\"></span></div></div></form></div></div></div></div><div class=\"row\" ng-if=\"controller.cnab != null && controller.cnab.erros.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-danger\"><h5><i class=\"fa fa-exclamation-triangle\"></i> Erros</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><option ng-repeat=\"item in controller.cnab.erros\" value=\"{{item}}\">- {{item}}</option></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.cnab != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> CNAB</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Arquivo</label> <input type=\"text\" ng-model=\"controller.cnab.arquivoNome\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data Geração</label> <input type=\"text\" disabled=\"\" value=\"{{controller.cnab.header.dataGeracao | date:\'dd/MM/yyyy\'}}\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Documentos</label> <input type=\"text\" value=\"{{controller.cnab.detalhes.length}}\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.cnab != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Cedente</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" ng-model=\"controller.cnab.cedente.cnpj\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.cnab.cedente.razaoSocial\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia</label> <input type=\"text\" ng-model=\"controller.cnab.cedente.nomeFantasia\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.cnab != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Documentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Empresa</th><th class=\"white-bg\">Sacado</th><th class=\"white-bg\">CPF</th><th class=\"white-bg\">Documento</th><th class=\"white-bg\">Emissão</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Vl. Tarifa</th><th class=\"white-bg\">Vl. PIX</th></tr></thead><tbody><tr ng:repeat=\"p in controller.cnab.detalhes\" ng-style=\"p.statusCadastro == 1 && {\'background-color\':\'yellow\'}\"><td>{{p.documentoClienteFormatado}}</td><td>{{p.nomeSacado}}</td><td>{{p.documentoSacadoFormatado}}</td><td>{{p.numeroDocumento}}</td><td>{{p.dataEmissao | date:\'dd/MM/yyyy\'}}</td><td>{{p.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td>{{p.valorTitulo | currency:\'R$ \'}}</td><td>{{p.tarifa | currency:\'R$ \'}}</td><td>{{p.valorPix | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div></div></div><div class=\"row\" ng-if=\"controller.cnab != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-danger\" type=\"button\" style=\"width: 220px;\" ng-click=\"controller.reset()\"><i class=\"fa fa-retweet\"></i> Novo Arquivo</button> <button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 220px;\" ng-disabled=\"controller.cnab.erros.length > 0\" ng-click=\"controller.concluir()\"><i class=\"fa fa-check\"></i> Registrar Lote</button></div></div></div></div></div>");
$templateCache.put("app/usuarios/cadastrar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Usuário</h5><small class=\"font-bold\">Informações do registro de Usuário.</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"100\" class=\"form-control\" ng-model=\"controller.registro.nome\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" maxlength=\"100\" class=\"form-control normal-text\" ng-model=\"controller.registro.email\" autocomplete=\"new-email\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Senha</label> <input type=\"password\" ng-if=\"!controller.isUpdate\" maxlength=\"20\" class=\"form-control normal-text\" ng-model=\"controller.registro.senha\" autocomplete=\"new-password\"> <input type=\"password\" ng-if=\"controller.isUpdate\" disabled=\"\" maxlength=\"20\" class=\"form-control\" value=\"*******\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Administrador</label><select class=\"form-control\" ng-model=\"controller.administrador\"><option ng-value=\"0\">Não</option><option ng-value=\"1\">Sim</option></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Restrito</label><select class=\"form-control\" ng-model=\"controller.restritoText\"><option ng-value=\"0\">Não</option><option ng-value=\"1\">Sim</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Grupo de Usuário</label><select class=\"form-control\" ng-model=\"controller.registro.grupoUsuario.id\" ng-options=\"item.id as item.nome for item in controller.grupos\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Assinatura</label><summernote height=\"100\" config=\"options\" ng-model=\"controller.registro.assinaturaHtml\"></summernote></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.enviar()\" style=\"width: 160px;\"><i class=\"fa fa-arrow-right\"></i> Salvar</button></div>");
$templateCache.put("app/cadastro/cedente/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Cedente</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cedente</a></li><li class=\"active\"><strong>Cadastrar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Dados do Cedente</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo</label><select class=\"form-control\" ng-model=\"controller.registro.tipoPessoa\"><option ng-value=\"0\">Pessoa Jurídica</option><option ng-value=\"1\">Pessoa Física</option></select></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.registro.razaoSocial\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.registro.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia</label> <input type=\"text\" ng-model=\"controller.registro.nomeFantasia\" class=\"form-control\"></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoPessoa == 1\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.registro.razaoSocial\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.registro.cnpj\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-arrow-right\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.registro.enderecoCep\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.registro.enderecoLogradouro\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.registro.enderecoNumero\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.registro.enderecoComplemento\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.registro.enderecoBairro\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.registro.enderecoCidade\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.registro.enderecoUf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxIntegracao\', \'boxIntegracao\')\"><h5><i class=\"fa fa-arrow-right\"></i> Integração</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxIntegracao\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxIntegracao\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Código VMoney</label> <input type=\"number\" ng-model=\"controller.registro.codigoVmoney\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Concluir</button></div></div></div></div></div>");
$templateCache.put("app/cadastro/cedente/consultar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Consultar Cedente</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cedente</a></li><li><a>Consultar</a></li><li class=\"active\"><strong>{{controller.fornecedor.razaoSocial}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-arrow-right\"></i> Dados do Cedente</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo</label><select disabled=\"\" class=\"form-control\" ng-model=\"controller.fornecedor.tipoPessoa\"><option ng-value=\"0\">Pessoa Jurídica</option><option ng-value=\"1\">Pessoa Física</option></select></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 1\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.fornecedor.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.fornecedor.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 1\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">RG</label> <input type=\"text\" ng-model=\"controller.fornecedor.rg\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">RG Orgão</label> <input type=\"text\" ng-model=\"controller.fornecedor.rgorgao\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">RG UF</label> <input type=\"text\" maxlength=\"2\" ng-model=\"controller.fornecedor.rguf\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">RG Data Exp.</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.fornecedor.dtexprg\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 1\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Nascimento</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.fornecedor.dataNascimento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nacionalidade</label> <input type=\"text\" maxlength=\"2\" ng-model=\"controller.fornecedor.nacionalidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Sexo</label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.fornecedor.sexo\"><option ng-value=\"M\">Masculino</option><option ng-value=\"F\">Feminino</option></select></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 1\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Estado Civil</label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.fornecedor.sexo\"><option ng-value=\"S\">Solteiro</option><option ng-value=\"C\">Casado</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome da Mãe</label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.fornecedor.nomeMae\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Pai</label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.fornecedor.nomePai\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.fornecedor.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" disabled=\"\" mask=\"99.999.999/9999-99\" ng-model=\"controller.fornecedor.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia</label> <input type=\"text\" ng-model=\"controller.fornecedor.nomeFantasia\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.fornecedor.email\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Fundação</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.fornecedor.complemento.dataFundacao\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Capital Social</label> <input type=\"text\" ui-number-mask=\"\" ng-model=\"controller.fornecedor.complemento.capitalSocial\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Contato Secundário</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.nomeContatoSecundario\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail do Contato Secundário</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.emailContatoSecundario\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Ramo de Atividade</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.ramoAtividade\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Faturamento/Médio/Mês (Brasil)</label> <input type=\"number\" ng-model=\"controller.fornecedor.complemento.faturamentoMedioBrasil\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Faturamento/Médio/Mês (Exterior)</label> <input type=\"number\" ng-model=\"controller.fornecedor.complemento.faturamentoMedioExterior\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Imóvel Próprio (Informar valor/metragem)</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosImovelProprio\" class=\"form-control inputDisabledModal\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Bancos</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosReferenciaBancos\" class=\"form-control inputDisabledModal\"></textarea></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência - Comerciais/Fornecedores (Informar % Participação)</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosReferenciaComercial\" class=\"form-control inputDisabledModal\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Principais Clientes (Informar % Faturamento)</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosPrincipaisClientes\" class=\"form-control inputDisabledModal\"></textarea></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Instituição Credora CCB</label><select class=\"form-control\" ng-model=\"controller.fornecedor.instituicaoCredoraCCBTexto\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Situação do Cadastro</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.fornecedor.statusTexto\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-arrow-right\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.fornecedor.enderecoCep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.fornecedor.enderecoLogradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.fornecedor.enderecoNumero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.fornecedor.enderecoComplemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.fornecedor.enderecoBairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.fornecedor.enderecoCidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.fornecedor.enderecoUf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSocios\', \'boxSocios\')\"><h5><i class=\"fa fa-arrow-right\"></i> Controle Acionário/Societário/Avalistas/Fiel Depositário</h5></div><div class=\"ibox-content\" id=\"boxSocios\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Nome</th><th class=\"white-bg\">CPF</th><th class=\"white-bg\">Data Nascimento</th><th class=\"white-bg\">% Participação</th><th class=\"white-bg\">Tipo</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.socios\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.cpf }}</td><td class=\"ng-binding\">{{ p.dataNascimento }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao }}%</td><td class=\"ng-binding\">{{ p.isSocio ? \'Sócio, \' : \'\' }} {{ p.isAvalista ? \'Avalista, \' : \'\' }} {{ p.isFielDepositario ? \'Fiel Depositário\' : \'\' }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.visualizarSocio(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button> <button ng-click=\"controller.excluirSocio(p, $index)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Excluir</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirSocio()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEmpresas\', \'boxEmpresas\')\"><h5><i class=\"fa fa-arrow-right\"></i> Empresas Coligadas/Controladas</h5></div><div class=\"ibox-content\" id=\"boxEmpresas\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.empresas.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Razão Social</th><th class=\"white-bg\">CNPJ</th><th class=\"white-bg\">Sócios</th><th class=\"white-bg\">Fundação</th><th class=\"white-bg\">% Participação</th><th class=\"white-bg\">Data Entrada</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.empresas\"><td class=\"ng-binding\">{{ p.razaoSocial }}</td><td class=\"ng-binding\">{{ p.cnpj }}</td><td class=\"ng-binding\">{{ p.socios == null ? \'não informado\' : p.socios }}</td><td class=\"ng-binding\">{{ p.dataFundacao == null ? \'não informado\' : p.dataFundacao }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao == null ? 0 : p.percentualParticipacao }}%</td><td class=\"ng-binding\">{{ p.dataEntrada == null ? \'não informado\' : p.dataEntrada }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.visualizarEmpresa(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirEmpresa()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button> <span ng-if=\"controller.fornecedor.empresas.length == 0\">Não foram informados empresas coligadas/controladas.</span></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-arrow-right\"></i> Contas Bancárias</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContaBancaria\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.listarContasPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Banco</th><th class=\"white-bg\">Agência</th><th class=\"white-bg\">Conta</th><th class=\"white-bg\">Padrão</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.contas\"><td class=\"ng-binding\">{{ p.bancoTexto }}</td><td class=\"ng-binding\">{{ p.agencia }}-{{ p.digitoAgencia != \'\' ? p.digitoAgencia : \'0\' }}</td><td class=\"ng-binding\">{{ p.numero }}-{{ p.digitoConta }}</td><td class=\"ng-binding\">{{ p.isPadraoOperacao ? \'Sim\' : \'Não\' }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarConta(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button> <button ng-click=\"controller.gerarCarta(p)\" class=\"btn btn-success btn-xs\" ng-if=\"main.pentahoCodigoCliente == null\"><i class=\"fa fa-edit\"></i> Gerar Carta</button> <button ng-click=\"controller.gerarCartaExtrato(p)\" class=\"btn btn-warning btn-xs\" ng-if=\"main.pentahoCodigoCliente == null\"><i class=\"fa fa-edit\"></i> Carta Extrato</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarConta()\"><span><i class=\"fa fa-plus\"></i> Adicionar nova conta</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumentos\', \'boxDocumentos\')\"><h5><i class=\"fa fa-arrow-right\"></i> Documentos</h5></div><div class=\"ibox-content\" id=\"boxDocumentos\" cg-busy=\"controller.documentosPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.documentos.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Documento</th><th class=\"white-bg\" colspan=\"2\"></th></tr></thead><tbody><tr class=\"ng-scope\" ng:repeat=\"p in controller.documentos\"><td ng-if=\"p.titulo == 1\" class=\"ng-binding\">Cadastro Pessoa Jurídica</td><td ng-if=\"p.titulo == 2\" class=\"ng-binding\">Contrato/Estatuto Social</td><td ng-if=\"p.titulo == 3\" class=\"ng-binding\">Atas de eleição/nomeação do(s) representante(s)</td><td ng-if=\"p.titulo == 4\" class=\"ng-binding\">Procurações dos representantes da empresa</td><td ng-if=\"p.titulo == 5\" class=\"ng-binding\">Balanço Patrimonial + DRE (últimos 2 exercícios), assinado pelo(s) representante(s) e contador responsável</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-if=\"p.viewId != \'00000000-0000-0000-0000-000000000000\'\" ng-click=\"controller.getDocumento(p.viewId, p.nome)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td><td style=\"width: 1px; white-space: nowrap;\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Anexar Arquivo</span><input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(p)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td></tr></tbody></table><div style=\"margin-bottom: 10px;\" ng-if=\"controller.documentos.length == 0\">Não foram informados documentos.</div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.tipoPessoa == 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContratoMae\', \'boxContratoMae\')\"><h5><i class=\"fa fa-arrow-right\"></i> Contrato Mãe</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContratoMae\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxContratoMae\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\"><label class=\"col-form-label\">Originador</label><select class=\"form-control\" ng-change=\"controller.gerarContratoMae()\" ng-model=\"controller.originador\" ng-options=\'item as (item.cnpj + \" - \" + item.nome + \" (\" + item.tipoText + \")\") for item in controller.originadores\'></select></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.fileContratoMae}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxIntegracao\', \'boxIntegracao\')\"><h5><i class=\"fa fa-arrow-right\"></i> Integração</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxIntegracao\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxIntegracao\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Código Cedente VMoney</label> <input type=\"number\" ng-model=\"controller.fornecedor.codigoVmoney\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Duplicata</label> <input type=\"text\" ng-model=\"controller.fornecedor.flagDuplicata\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Cheque</label> <input type=\"text\" ng-model=\"controller.fornecedor.flagCheque\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Nota Promissória</label> <input type=\"text\" ng-model=\"controller.fornecedor.flagNotaPromissoria\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Comissária</label> <input type=\"text\" ng-model=\"controller.fornecedor.flagComissaria\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">CCB</label> <input type=\"text\" ng-model=\"controller.fornecedor.flagCcb\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">D+</label> <input type=\"text\" ng-model=\"controller.fornecedor.diasSomaOperacao\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">D+ - Considerar dia útil</label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.fornecedor.diasSomaConsidDiaUtilValue\"><option ng-value=\"1\">Sim</option><option ng-value=\"0\">Não</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Vencimento - Considerar dia útil</label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.fornecedor.dataVenctoConsidDiaUtilValue\"><option ng-value=\"1\">Sim</option><option ng-value=\"0\">Não</option></select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxPerfil\', \'boxPerfil\')\"><h5><i class=\"fa fa-arrow-right\"></i> Perfil</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxPerfil\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxPerfil\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><input type=\"checkbox\" name=\"liberaDigitar\" ng-model=\"controller.fornecedor.digitarLiberado\"> <label for=\"liberaDigitar\">PERMITE DIGITAR TÍTULO</label>&nbsp;&nbsp; <input type=\"checkbox\" name=\"liberaCnab\" ng-model=\"controller.fornecedor.cnabLiberado\"> <label for=\"liberaCnab\">PERMITE IMPORTAR CNAB</label>&nbsp;&nbsp;</div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxUsuarios\', \'boxUsuarios\')\"><h5><i class=\"fa fa-arrow-right\"></i> Usuários</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxUsuarios\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxUsuarios\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Nome</th><th class=\"white-bg\">E-mail</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.usuarios\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.email }}</td><td class=\"ng-binding\">Ativo</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarUsuario(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarUsuario()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo usuário</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-danger\" type=\"button\" ng-click=\"controller.excluir()\"><i class=\"fa fa-trash\"></i> Excluir</button> <button ng-if=\"controller.fornecedor.status == 2\" class=\"btn btn-md btn-danger\" type=\"button\" ng-click=\"controller.rejeitarCadastro()\"><i class=\"fa fa-arrow-left\"></i> REJEITAR CADASTRO</button> <button ng-if=\"controller.fornecedor.status == 0 || controller.fornecedor.status == 1 || controller.fornecedor.status == 2\" class=\"btn btn-md btn-primary\" type=\"button\" ng-click=\"controller.aprovarCadastro()\"><i class=\"fa fa-arrow-right\"></i> APROVAR CADASTRO</button> <button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 160px;\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/cadastro/cedente/pendentes/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Cedentes Pendentes</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cedente</a></li><li class=\"active\"><strong>Pendentes</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"text\" ng-model=\"controller.filtro.codigo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Cedentes</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th ng-click=\"controller.ordenarResultado(\'numero\')\" style=\"width: 10px;\">#</th><th ng-click=\"controller.ordenarResultado(\'razaosocial\')\">Razão Social</th><th ng-click=\"controller.ordenarResultado(\'cnpj\')\">CNPJ</th><th ng-click=\"controller.ordenarResultado(\'datacadastro\')\">Data de cadastro</th><th ng-click=\"controller.ordenarResultado(\'status\')\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy\'}}</td><td style=\"width: 140px;\"><button ng-if=\"p.status == 0 || p.status == 1\" class=\"btn btn-warning btn-xs btn-block\">Preenchimento do Cadastro</button> <button ng-if=\"p.status == 2\" class=\"btn btn-success btn-xs btn-block\">Análise do Cadastro</button> <button ng-if=\"p.status == 3\" class=\"btn btn-primary btn-xs btn-block\">Assinatura Digital</button> <button ng-if=\"p.status == 4\" class=\"btn btn-brown btn-xs btn-block\">Abertura de Conta</button></td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cadastro/cedente/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Cedente</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cedente</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"text\" ng-model=\"controller.filtro.codigo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia</label> <input type=\"text\" ng-model=\"controller.filtro.fantasia\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Cedentes</h5><div class=\"ibox-tools\"><a ng-click=\"controller.redirectToURL(); $event.stopPropagation()\" title=\"Manual: Cadastro de Usuários\"><i class=\"fa fa-book\" style=\"color: white; font-size: 22px;\"></i></a></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 3%; text-align: center;\"><input type=\"checkbox\" ng-model=\"controller.selecionarTodos\" ng-change=\"controller.toggleSelecionarTodos()\" title=\"Selecionar/Desselecionar todos\"></th><th ng-click=\"controller.ordenarResultado(\'numero\')\" style=\"width: 5%; white-space: nowrap;\">#</th><th ng-click=\"controller.ordenarResultado(\'razaosocial\')\" style=\"width: 30%; white-space: nowrap;\">Razão Social</th><th ng-click=\"controller.ordenarResultado(\'nomefantasia\')\" style=\"width: 30%; white-space: nowrap;\">Nome Fantasia</th><th ng-click=\"controller.ordenarResultado(\'cnpj\')\" style=\"width: 15%; white-space: nowrap;\">CNPJ</th><th ng-click=\"controller.ordenarResultado(\'datacadastro\')\" style=\"width: 10%; white-space: nowrap;\">Data de cadastro</th><th ng-click=\"controller.ordenarResultado(\'status\')\" style=\"width: 10%; white-space: nowrap;\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"text-align: center;\"><input type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.toggleSelecionarCedente(p)\"></td><td>{{p.id}}</td><td>{{p.razaoSocial}}</td><td>{{p.nomeFantasia}}</td><td>{{p.cnpj}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy\'}}</td><td>Ativo</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cadastro/cedente/selecionar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Cedente</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pesquisar:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>Nome Fantasia</th><th>Cod. Vmoney</th><th style=\"width: 180px;\">CPF/CNPJ</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.razaoSocial}}</td><td>{{p.nomeFantasia}}</td><td>{{p.codigoVmoney}}</td><td>{{p.cnpj}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/cadastro/investidor/cadastro/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Investidor</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Investidor</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-university\"></i> Dados do Investidor</h5></div><div class=\"ibox-content\"><p class=\"text-muted\">Se o e-mail informado já pertencer a um investidor cadastrado em outro cliente, apenas vinculamos esse investidor à sua empresa.</p><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome (idêntico ao cadastrado no Vmoney)</label> <input type=\"text\" ng-model=\"controller.investidor.nome\" class=\"form-control inputDisabledModal\"> <span class=\"help-block text-warning\">Digite exatamente igual ao nome do investidor no Vmoney. Se estiver diferente, os relatórios do investidor não serão localizados automaticamente.</span></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF / CNPJ</label> <input type=\"text\" mask=\"{{ controller.investidor.cnpjCpf.length > 14 ? \'99.999.999/9999-99\' : \'999.999.999-999999999\' }}\" ng-model=\"controller.investidor.cnpjCpf\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.investidor.email\" class=\"form-control inputDisabledModal\"> <span class=\"help-block\">O investidor recebe um e-mail neste endereço para definir a própria senha de acesso.</span></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Concluir</button></div></div></div></div></div>");
$templateCache.put("app/cadastro/cedente/pocexpressa/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>POC Expressa</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cedente</a></li><li class=\"active\"><strong>POC Expressa</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultaPromise\"><div class=\"row\" ng-if=\"controller.viewId == null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <button ng-disabled=\"controller.registroConsulta != null\" ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.cedente == null ? \'Selecionar Cedente\' : (controller.cedente.codigoVmoney + \' - \' + controller.cedente.nomeFantasia + \' - \' + controller.cedente.razaoSocial) }}</button></div></div></div><div class=\"row\" ng-if=\"controller.cedente != null\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Originador</label><select class=\"form-control\" ng-disabled=\"controller.registroConsulta != null\" ng-model=\"controller.originador\" ng-change=\"controller.alterarOriginador()\" ng-options=\"item as item.nomeComTipo for item in controller.originadores\"></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Operação</label><select class=\"form-control\" ng-disabled=\"controller.registroConsulta != null\" ng-model=\"controller.tipoOperacaoTipo\" ng-options=\"item.tipo as item.descricao for item in controller.tiposOperacao\"></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success btn-block\" ng-if=\"controller.registroConsulta == null\" ng-click=\"controller.consultar()\"><i class=\"fa fa-search\"></i> Consultar</button> <button class=\"btn btn-warning btn-block\" ng-if=\"controller.registroConsulta != null\" ng-click=\"controller.novaConsulta()\"><i class=\"fa fa-retweet\"></i> Nova Consulta</button></div></div><div class=\"col-sm-2\" ng-if=\"controller.registroConsulta != null\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-default btn-block\" ng-click=\"controller.importar()\"><i class=\"fa fa-clipboard\"></i> Replicar</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.viewId != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <input class=\"form-control\" disabled=\"\" type=\"text\" value=\"{{controller.registro.cedente.razaoSocial}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Originador</label> <input class=\"form-control\" disabled=\"\" type=\"text\" value=\"{{controller.registro.originador.nome}}\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Operação</label> <input class=\"form-control\" disabled=\"\" type=\"text\" value=\"{{controller.registro.tipoOperacaoTexto}}\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registroConsulta != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxValores\', \'boxValores\')\"><h5><i class=\"fa fa-arrow-right\"></i> Limites e Prazo de Validade</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxValores\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxValores\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Validade Inicial</label> <input type=\"date\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.validadeDe\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Validade Final</label> <input type=\"date\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.validadeAte\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Limite</label> <input type=\"text\" money-mask=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.valorLimite\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tranche</label> <input type=\"text\" money-mask=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.valorTranche\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Intervalo em dias</label> <input type=\"text\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.intervaloDias\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registroConsulta != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTaxas\', \'boxTaxas\')\"><h5><i class=\"fa fa-arrow-right\"></i> Taxas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTaxas\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxTaxas\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fator</label> <input type=\"text\" numeric-only=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.taxaFator\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">AD Valorem</label> <input type=\"text\" numeric-only=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.taxaAdvalorem\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registroConsulta != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTarifas2\', \'boxTarifas2\')\"><h5><i class=\"fa fa-arrow-right\"></i> Tarifas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTarifas2\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxTarifas2\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-3\"><button class=\"btn btn-sm btn-block btn-success\" ng-disabled=\"controller.isVencido\" ng-click=\"controller.adicionarTarifaDoc()\"><i class=\"fa fa-plus\"></i> Adicionar Tarifa</button></div></div><div class=\"row\"><br><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Doc Padrão</th><th>Fator</th><th>Tarifa</th><th>TAC</th><th>TED/PIX</th><th>Despesa</th><th>Registro</th><th>Cons. SERPRO</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.tarifas\"><td>{{p.tipoDocumento.descricao}}</td><td>{{p.taxaFator}}</td><td>{{p.tarifa | currency:\'R$ \'}}</td><td>{{p.tac | currency:\'R$ \'}}</td><td>{{p.ted | currency:\'R$ \'}}</td><td>{{p.despesaAdicional | currency:\'R$ \'}}</td><td>{{p.registro | currency:\'R$ \'}}</td><td>{{p.consultaSerpro | currency:\'R$ \'}}</td><td style=\"width: 1px; white-space: nowrap;\"><button class=\"btn btn-xs btn-success\" ng-disabled=\"controller.isVencido\" ng-click=\"controller.editarTarifaDoc(p)\">Editar</button> <button class=\"btn btn-xs btn-danger\" ng-disabled=\"controller.isVencido\" ng-click=\"controller.removerTarifaDoc(p)\">Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registroConsulta != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxConsultas3\', \'boxConsultas3\')\"><h5><i class=\"fa fa-arrow-right\"></i> Consultas de 3os</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxConsultas3\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxConsultas3\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Limite Concentração no Borderô:</label> <input type=\"text\" money-mask=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.limiteConcBordero\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Percentual:</label> <input type=\"text\" numeric-only=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.limiteConcBorderoPerc\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Limite Concentração na Carteira:</label> <input type=\"text\" money-mask=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.limiteConcCarteira\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Percentual:</label> <input type=\"text\" numeric-only=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.limiteConcCarteiraPerc\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vlr Unitário Consulta:</label> <input type=\"text\" money-mask=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.valorUnitarioConsulta3os\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registroConsulta != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxPoliticas\', \'boxPoliticas\')\"><h5><i class=\"fa fa-arrow-right\"></i> Políticas de Crédito</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxPoliticas\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxPoliticas\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Min Checagem +</label> <input type=\"text\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.minChecagemPositivo\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Max Checagem -</label> <input type=\"text\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.maxChecagemNegativo\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Contração Máx Sacado</label> <input type=\"text\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.contratacaoMaxSacado\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo Mínimo p/ Tit</label> <input type=\"text\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.prazoMinTit\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo Máximo p/ Tit</label> <input type=\"text\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.prazoMaxTit\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo Entrega Canhoto</label> <input type=\"text\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.prazoCanhoto\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Mínimo p/ Tit</label> <input type=\"text\" money-mask=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.valorMinTit\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Máximo p/ Tit</label> <input type=\"text\" money-mask=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.valorMaxTit\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Perfil Sacado</label><div class=\"checkbox checkbox-success\" style=\"margin-top: 5px;\"><input type=\"checkbox\" id=\"utilizaPerfilSacado\" icheck=\"\" ng-disabled=\"controller.isVencido\" ng-model=\"controller.registro.utilizaPerfilSacado\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\"> <label for=\"utilizaPerfilSacado\">Utiliza Perfil Sacado</label></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registroConsulta != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxHistorico\', \'boxHistorico\')\"><h5><i class=\"fa fa-arrow-right\"></i> Histórico</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxHistorico\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxHistorico\"><div class=\"row\"><div class=\"col-sm-8\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px; white-space: nowrap;\">Data</th><th>Usuário</th><th style=\"width: 1px;\"></th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.historico\"><td style=\"width: 1px; white-space: nowrap;\">{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{p.empresaUsuario.nome}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"controller.exibirHistorico(p)\">Detalhes</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registroConsulta != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right;\"><button ng-if=\"!controller.isVencido\" class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 220px;\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar</button></div></div></div></div></div></div></div>");
$templateCache.put("app/cadastro/sacado/cadastro/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Sacado</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome / Razão Social</label> <input type=\"text\" ng-model=\"controller.sacado.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF / CNPJ</label> <input type=\"text\" mask=\"{{ controller.sacado.cnpj.length > 14 ? \'99.999.999/9999-99\' : \'999.999.999-999999999\' }}\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.sacado.email\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.sacado.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.sacado.endereco.uf\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Concluir</button></div></div></div></div></div>");
$templateCache.put("app/cadastro/sacado/consulta/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Consultar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Dados do Sacado</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome / Razão Social</label> <input type=\"text\" ng-model=\"controller.sacado.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF / CNPJ</label> <input type=\"text\" mask=\"{{ controller.sacado.cnpj.length > 14 ? \'99.999.999/9999-99\' : \'999.999.999-999999999\' }}\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.sacado.email\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-arrow-right\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.sacado.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.sacado.endereco.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/cadastro/sacado/selecionar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Sacado</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"number\" ng-model=\"controller.filtro.codigo\" class=\"form-control\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF/CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-primary\" style=\"width: 140px;\" ng-click=\"controller.cadastrar()\"><i class=\"fa fa-plus\"></i> Novo</button> <button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.pesquisarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>CNPJ</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/cadastro/sacado/selecionar2/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Sacado</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"number\" ng-model=\"controller.filtro.codigo\" class=\"form-control\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF/CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.pesquisarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>CNPJ</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/arranjo_pagamento/conciliacao/baixa/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Conciliação - Baixa</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Conciliação</a></li><li class=\"active\"><strong>Baixa</strong></li></ol></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarCedente()\"><i class=\"fa fa-user\"></i> {{controller.cedente != null && controller.cedente.cnpj != null? controller.cedente.cnpj : \'Selecionar Cedente\'}}</button></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Período</label> <input type=\"date\" ng-model=\"controller.filtro.dataInicio\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.dataTermino\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success\" style=\"width: 180px;\" ng-click=\"controller.pesquisar()\"><span class=\"fa fa-search\"></span> Consultar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Data</th><th style=\"width: 180px;\">Valor Negociado</th><th style=\"width: 180px;\">Valor Recebido</th><th style=\"width: 180px;\">Divergência</th></tr></thead><tbody><tr><td>01/07/2021</td><td>R$ 5.220,00</td><td>R$ 5.220,00</td><td>R$ 0,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr style=\"background-color: #ff4d4d; color: white;\"><td>02/07/2021</td><td>R$ 19.150,00</td><td>R$ 18.150,00</td><td>-R$ 1.000,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr><td>03/07/2021</td><td>R$ 8.240,00</td><td>R$ 8.240,00</td><td>R$ 0,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr><td>04/07/2021</td><td>R$ 7.050,50</td><td>R$ 7.050,50</td><td>R$ 0,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/arranjo_pagamento/agenda/pesquisar/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Agenda</h2><ol class=\"breadcrumb\"><li><a>Agenda</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Consultar Agenda</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" cg-busy=\"controller.listarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarCedente()\"><i class=\"fa fa-user\"></i> {{controller.cedente != null && controller.cedente.cnpj != null? controller.cedente.cnpj : \'Selecionar Cedente\'}}</button></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Liquidação</label> <input type=\"date\" ng-model=\"controller.filtro.dataInicio\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.dataTermino\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Credenciadora/Subcredenciadora</label><select class=\"form-control\"><option ng-value=\"0\" selected=\"\">Todos</option><option ng-value=\"1\">REDECARD</option><option ng-value=\"2\">GETNET</option><option ng-value=\"3\">CIELO</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bandeira</label><select class=\"form-control\"><option ng-value=\"0\" selected=\"\">Todos</option><option ng-value=\"1\">MasterCard Crédito</option><option ng-value=\"2\">Visa Crédito</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Presencial/Não Presencial</label><select class=\"form-control\"><option ng-value=\"0\" selected=\"\">Todos</option><option ng-value=\"1\">Presencial</option><option ng-value=\"2\">Não Presencial</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo</label><select class=\"form-control\"><option ng-value=\"0\" selected=\"\">Todos</option><option ng-value=\"1\">Pré-Contratado</option><option ng-value=\"2\">Pós-Contratado</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bloqueio</label><select class=\"form-control\"><option ng-value=\"0\" selected=\"\">Todos</option><option ng-value=\"1\">Com Bloqueio, Ônus e/ou Troca de Titularidade</option><option ng-value=\"2\">Sem Bloqueio, Ônus e/ou Troca de Titularidade</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success\" style=\"width: 180px;\" ng-click=\"controller.pesquisar()\"><span class=\"fa fa-search\"></span> Consultar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-tags\"></i> Unidade Recebíveis (UR)</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div><table class=\"table table-bordered\" style=\"margin-bottom: 0px;\"><thead><tr><th style=\"width: 1px;\"></th><th>Credenciadora</th><th>Arranjo Pagamento</th><th>Liquidação</th><th>Valor Livre</th><th>Valor Onerado</th><th>Valor da UR</th></tr></thead><tbody><tr ng-repeat=\"r in controller.items\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"r.selecionado\"></td><td>{{ r.instituicaoCredenciadoraDoc }}</td><td>{{ r.descricaoArranjoPagamento}}</td><td>{{ r.dataLiquidacaoDate | date:\'dd/MM/yyyy\' }}</td><td>{{ r.valorLivre | currency:\'R$ \' }}</td><td>{{ r.valorOnerado | currency:\'R$ \' }}</td><td>{{ r.valorTotalUr | currency:\'R$ \' }}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><button class=\"btn btn-warning btn-xs\" ng-click=\"controller.consultarUR(r)\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div><div><span style=\"font-weight: bold;\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}} <span ng-if=\"controller.total.valorTotal > 0\">em {{controller.total.quantidade}} unidade{{(controller.total.quantidade > 1 ? \'s \' : \'\')}} selecionado{{(controller.total.quantidade > 1 ? \'s \' : \'\')}}</span></span></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right;\"><button ng-click=\"controller.selecionarRegistros()\" class=\"btn btn-md btn-primary\" type=\"button\"><i class=\"fa fa-arrow-right\"></i> SELECIONAR UNIDADES</button></div></div></div></div></div></div></div>");
$templateCache.put("app/arranjo_pagamento/conciliacao/carteira/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Conciliação - Carteira</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Conciliação</a></li><li class=\"active\"><strong>Carteira</strong></li></ol></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarCedente()\"><i class=\"fa fa-user\"></i> {{controller.cedente != null && controller.cedente.cnpj != null? controller.cedente.cnpj : \'Selecionar Cedente\'}}</button></div></div><div class=\"col-sm-8\" style=\"text-align: right;\"><label class=\"col-form-label\">&nbsp;</label><br><button class=\"btn btn-success\" style=\"width: 180px;\" ng-click=\"controller.pesquisar()\"><span class=\"fa fa-search\"></span> Consultar</button></div></div><div class=\"row\"></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Última Atualização</th><th style=\"width: 140px;\">Quantidade UR\'s</th><th style=\"width: 140px;\">UR\'s alteradas</th><th style=\"width: 180px;\">Valor Previsto</th><th style=\"width: 180px;\">Valor Atualizado</th></tr></thead><tbody><tr><td>14/07/2021 05:50</td><td>55</td><td>2</td><td>R$ 19.150,00</td><td>R$ 18.150,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/arranjo_pagamento/baixas/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Baixas</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Baixas</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarCedente()\"><i class=\"fa fa-user\"></i> {{controller.cedente != null && controller.cedente.cnpj != null? controller.cedente.cnpj : \'Selecionar Cedente\'}}</button></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Período</label> <input type=\"date\" ng-model=\"controller.filtro.dataInicio\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.dataTermino\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success\" style=\"width: 180px;\" ng-click=\"controller.pesquisar()\"><span class=\"fa fa-search\"></span> Consultar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Data</th><th style=\"width: 180px;\">Valor Previsto</th><th style=\"width: 180px;\">Valor Liquidado</th></tr></thead><tbody><tr><td>01/07/2021</td><td>R$ 5.220,00</td><td>R$ 5.220,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr style=\"background-color: #ff4d4d; color: white;\"><td>02/07/2021</td><td>R$ 19.150,00</td><td>R$ 18.150,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr><td>03/07/2021</td><td>R$ 8.240,00</td><td>R$ 8.240,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr><td>04/07/2021</td><td>R$ 7.050,50</td><td>R$ 7.050,50</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/arranjo_pagamento/operacao/consultar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Operação</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Operação</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Operação</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Titular</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.cedente.cnpj\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Disponível</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorDisponivelTexto\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label> <input type=\"text\" class=\"form-control inputDisabledModal\" disabled=\"\" ng-model=\"controller.registro.statusTexto\" maxlength=\"50\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Operação</label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.tipoOperacao\" disabled=\"\"><option ng-value=\"1\">Troca de titularidade</option><option ng-value=\"2\">Ônus - Cessão fiduciária</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Regra de Divisão</label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.regraDivisao\" disabled=\"\"><option ng-value=\"1\">Valor Fixo</option><option ng-value=\"2\">Percentual</option></select></div></div><div class=\"col-sm-4\" ng-if=\"controller.registro.regraDivisao == 1\"><div class=\"form-group\"><label class=\"col-form-label\">Valor a Onerar</label> <input type=\"text\" disabled=\"\" money-mask=\"\" maxlength=\"50\" ng-model=\"controller.registro.valorOnerarTexto\" placeholder=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\" ng-if=\"controller.registro.regraDivisao == 2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor a Onerar</label> <input type=\"text\" class=\"form-control inputDisabledModal\" disabled=\"\" maxlength=\"50\" value=\"{{controller.registro.valorOnerarTexto}} %\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Gestão do Ônus</label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.gestaoOnus\" disabled=\"\"><option ng-value=\"1\">Gestão de entidade registradora</option><option ng-value=\"2\">Gestão do financiador ou não financeira</option><option ng-value=\"3\">Gestão do financiador ou não financeira com monitoramento da registradora</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Modalidade</label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.modalidade\" disabled=\"\"><option ng-value=\"1\">Rotativo</option><option ng-value=\"2\">Parcelado</option><option ng-value=\"3\">Cessão</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Domicílio Bancário</label><select class=\"form-control\" ng-if=\"controller.registro.status == 1\"><option>254 Banco XPTO - 1554 - 0100254</option><option>044 Banco XPTO 2 - 1114 - 0220211</option></select><select class=\"form-control inputDisabledModal\" ng-if=\"controller.registro.status != 1\" disabled=\"\"><option>254 Banco XPTO - 1554 - 0100254</option><option>044 Banco XPTO 2 - 1114 - 0220211</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Vencimento</label> <input type=\"date\" disabled=\"\" class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.dataVencimento\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Assinatura</label> <input ng-if=\"controller.registro.status == 1\" type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataAssinatura\"> <input ng-if=\"controller.registro.status != 1\" disabled=\"\" type=\"date\" class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.dataAssinatura\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\" ng-if=\"controller.registro.tipoOperacao == 1\"><div class=\"form-group\"><label class=\"col-form-label\">Taxa de Antecipação</label> <input type=\"text\" class=\"form-control inputDisabledModal\" disabled=\"\" maxlength=\"50\" value=\"{{controller.registro.taxaAntecipacao}} %\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoOperacao == 1\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-tags\"></i> Unidades de Recebíveis</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContaBancaria\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.listarContasPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th>Credenciadora</th><th>Arranjo Pagamento</th><th>Liquidação</th><th>Valor Livre</th><th>Valor A Onerar</th><th>Deságio</th><th>Valor Líquido</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"r in controller.registro.unidadeRecebivel\"><td>{{ r.credenciadora }}</td><td>{{ r.arranjoPagamento}}</td><td>{{ r.dataLiquidacao | date:\'dd/MM/yyyy\' }}</td><td>{{ r.valorLivre | currency:\'R$ \' }}</td><td>{{ r.valorOnerarOperacao | currency:\'R$ \' }}</td><td>{{ r.valorDesagioOperacao | currency:\'R$ \' }}</td><td>{{ r.valorLiquidoOperacao | currency:\'R$ \' }}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoOperacao == 2\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-tags\"></i> Unidades de Recebíveis</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContaBancaria\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.listarContasPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th>Credenciadora</th><th>Arranjo Pagamento</th><th>Liquidação</th><th>Valor Livre</th><th>Valor A Onerar</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"r in controller.registro.unidadeRecebivel\"><td>{{ r.credenciadora }}</td><td>{{ r.arranjoPagamento}}</td><td>{{ r.dataLiquidacao | date:\'dd/MM/yyyy\' }}</td><td>{{ r.valorLivre | currency:\'R$ \' }}</td><td>{{ r.valorOnerarOperacao | currency:\'R$ \' }}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\" style=\"text-align: left;\"><button ng-if=\"controller.registro.status == 1\" class=\"btn btn-md btn-danger\" type=\"button\" style=\"min-width: 180px;\" ng-click=\"controller.cancelarOperacao()\"><i class=\"fa fa-trash\"></i> Cancelar Operação</button> <button ng-if=\"controller.registro.status == 2\" class=\"btn btn-md btn-warning\" type=\"button\" style=\"min-width: 200px;\" ng-click=\"controller.inativarContrato()\"><i class=\"fa fa-close\"></i> Inativar Contrato</button></div><div class=\"col-lg-6\" style=\"text-align: right;\"><button ng-if=\"controller.registro.status == 1\" class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 200px;\" ng-click=\"controller.salvar()\"><i class=\"fa fa-check\"></i> Aprovar Contrato</button></div></div></div></div></div></div></div>");
$templateCache.put("app/arranjo_pagamento/fluxour/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Fluxo de UR\'s</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Fluxo de UR\'s</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarCedente()\"><i class=\"fa fa-user\"></i> {{controller.cedente != null && controller.cedente.cnpj != null? controller.cedente.cnpj : \'Selecionar Cedente\'}}</button></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Período</label> <input type=\"date\" ng-model=\"controller.filtro.dataInicio\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.dataTermino\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success\" style=\"width: 180px;\" ng-click=\"controller.pesquisar()\"><span class=\"fa fa-search\"></span> Consultar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Data</th><th style=\"width: 180px;\">Valor Negociado</th><th style=\"width: 180px;\">Valor Atualizado</th></tr></thead><tbody><tr><td>15/07/2021</td><td>R$ 45.480,22</td><td>R$ 45.480,22</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr><td>16/07/2021</td><td>R$ 22.850,00</td><td>R$ 22.850,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr><td>17/07/2021</td><td>R$ 12.740,00</td><td>R$ 12.740,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr style=\"background-color: #ff4d4d; color: white;\"><td>18/07/2021</td><td>R$ 9.850,50</td><td>R$ 8.120,50</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr><td>19/07/2021</td><td>R$ 35.180,00</td><td>R$ 35.180,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr><tr><td>20/07/2021</td><td>R$ 24.240,00</td><td>R$ 24.240,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/boleto/relatorio/consumo/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Boleto - Consumo</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Boleto</a></li><li><a>Relatórios</a></li><li class=\"active\"><strong>Consumo</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Ano</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.anoFiltro\"><option value=\"2022\">2022</option><option value=\"2023\">2023</option><option value=\"2023\">2024</option></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Mês</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.mesFiltro\"><option value=\"1\">Janeiro</option><option value=\"2\">Fevereiro</option><option value=\"3\">Março</option><option value=\"4\">Abril</option><option value=\"5\">Maio</option><option value=\"6\">Junho</option><option value=\"7\">Julho</option><option value=\"8\">Agosto</option><option value=\"9\">Setembro</option><option value=\"10\">Outubro</option><option value=\"11\">Novembro</option><option value=\"12\">Dezembro</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Total: {{controller.registros.length}} boletos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"white-space: nowrap;\">Data</th><th style=\"white-space: nowrap;\">Cedente</th><th style=\"white-space: nowrap;\">Sacado</th><th style=\"white-space: nowrap;\">Boleto</th><th style=\"white-space: nowrap;\">Destinatário</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"white-space: nowrap;\">{{p.data | date:\'dd/MM/yyyy HH:mm:ss\' }}</td><td>{{p.requestObjectMap.cedente.razaoSocial}}</td><td>{{p.requestObjectMap.sacado.razaoSocial}}</td><td>{{p.requestObjectMap.boleto.linhaDigitavel}}</td><td>{{p.requestObjectMap.controle.emailDestinatario}}</td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/arranjo_pagamento/operacao/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Operações</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Operação</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <input type=\"text\" ng-model=\"controller.filtro.cedente\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Usuário</label> <input type=\"text\" ng-model=\"controller.filtro.usuario\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select class=\"form-control\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Presencial/Não Presencial</label><select class=\"form-control\"><option ng-value=\"0\" selected=\"\">Todos</option><option ng-value=\"1\">Presencial</option><option ng-value=\"2\">Não Presencial</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo</label><select class=\"form-control\"><option ng-value=\"0\" selected=\"\">Todos</option><option ng-value=\"1\">Pré-Contratado</option><option ng-value=\"2\">Pós-Contratado</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bloqueio</label><select class=\"form-control\"><option ng-value=\"0\" selected=\"\">Todos</option><option ng-value=\"1\">Com Bloqueio, Ônus e/ou Troca de Titularidade</option><option ng-value=\"2\">Sem Bloqueio, Ônus e/ou Troca de Titularidade</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th ng-click=\"controller.ordenarResultado(\'numero\')\" style=\"width: 10px;\">#</th><th ng-click=\"controller.ordenarResultado(\'razaosocial\')\">Cedente</th><th ng-click=\"controller.ordenarResultado(\'cnpj\')\">Criado em</th><th ng-click=\"controller.ordenarResultado(\'datacadastro\')\">Usuário</th><th ng-click=\"controller.ordenarResultado(\'status\')\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.cedente.cnpj}} - {{p.cedente.razaoSocial}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{p.empresaUsuario.nome}}</td><td style=\"width: 170px;\"><button ng-if=\"p.status == 1\" class=\"btn btn-xs btn-warning btn-block\">{{p.statusTexto}}</button> <button ng-if=\"p.status == 2\" class=\"btn btn-xs btn-success btn-block\">{{p.statusTexto}}</button> <button ng-if=\"p.status == 3\" class=\"btn btn-xs btn-primary btn-block\">{{p.statusTexto}}</button> <button ng-if=\"p.status == 4\" class=\"btn btn-xs btn-danger btn-block\">{{p.statusTexto}}</button> <button ng-if=\"p.status == 9\" class=\"btn btn-xs btn-danger btn-block\">{{p.statusTexto}}</button></td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/arranjo_pagamento/optin/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Opt-In</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Opt-In</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-bank\"></i> Dados do Opt-In</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarCedente()\"><i class=\"fa fa-user\"></i> {{controller.cedente != null && controller.cedente.cnpj != null? controller.cedente.cnpj : \'Selecionar Cedente\'}}</button></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Assinatura</label> <input type=\"date\" maxlength=\"250\" ng-model=\"controller.registro.dataAssinatura\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Início</label> <input type=\"date\" maxlength=\"250\" ng-model=\"controller.registro.dataInicio\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Término</label> <input type=\"date\" maxlength=\"250\" ng-model=\"controller.registro.dataTermino\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Protocolo - Registradora</label> <input type=\"text\" maxlength=\"250\" disabled=\"\" ng-model=\"controller.registro.protocoloRegistradora\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Observação</label> <textarea class=\"form-control\" ng-model=\"controller.registro.observacao\" rows=\"2\" maxlength=\"1000\"></textarea></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isFormulario\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFormulario\', \'boxFormulario\')\"><h5><i class=\"fa fa-bank\"></i> Formulário</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFormulario\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFormulario\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><iframe ng-src=\"https://homolog.moneynow.com.br/mnp_api/api/optin/formulario\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-primary\" type=\"button\" style=\"width: 160px;\" ng-click=\"controller.gerarFormulario()\"><i class=\"fa fa-file\"></i> Gerar Formulário</button> <button ng-if=\"controller.isUpdate && controller.registro.status == 2\" class=\"btn btn-md btn-danger\" type=\"button\" style=\"width: 160px;\" ng-click=\"controller.optout()\"><i class=\"fa fa-close\"></i> Solicitar Opt-Out</button> <button ng-if=\"!controller.isUpdate\" class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 160px;\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Enviar Opt-In</button></div></div></div></div></div>");
$templateCache.put("app/arranjo_pagamento/optin/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-12\"><h2>Opt In/Out</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Opt-In</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\" style=\"display: none;\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"text\" ng-model=\"controller.filtro.codigo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px;\">#</th><th>Cedente</th><th>Data da Assinatura</th><th>Data de Início</th><th>Data de Término</th><th>Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.id}}</td><td>{{p.cnpjRecebedor}}</td><td>{{p.dataAssinatura | date:\'dd/MM/yyyy\'}}</td><td>{{p.dataInicio | date:\'dd/MM/yyyy\'}}</td><td>{{p.dataTermino | date:\'dd/MM/yyyy\'}}</td><td style=\"width: 120px;\"><button ng-if=\"p.status != 3\" class=\"btn btn-primary btn-xs btn-block\">{{p.statusTexto}}</button> <button ng-if=\"p.status == 3\" class=\"btn btn-danger btn-xs btn-block\">{{p.statusTexto}}</button></td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"atendimentoController.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:atendimentoController.pager.currentPage === 1}\"><a ng-click=\"atendimentoController.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === 1}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in atendimentoController.pager.pages\" ng-class=\"{active:atendimentoController.pager.currentPage === page}\"><a ng-click=\"atendimentoController.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === atendimentoController.pager.totalPages}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === atendimentoController.pager.totalPages}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cnab/remessa/gerar/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Gerar Arquivo CNAB</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>CNAB</a></li><li class=\"active\"><strong>Remessa</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" ng-busy=\"controller.gerarPromise\"><div class=\"row\" cg-busy=\"controller.listarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-money\"></i> Conta</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Originador</label><select class=\"form-control\" ng-change=\"controller.listarContasOriginador()\" ng-model=\"controller.originador\" ng-options=\'item as (item.cnpj + \" - \" + item.nome + \" (\" + item.tipoText + \")\") for item in controller.originadores\'></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Conta Bancária</label><select class=\"form-control\" ng-change=\"controller.listarRemessa()\" ng-model=\"controller.conta\" ng-options=\'item as (item.banco + \" - \" + \"Ag: \" + item.agencia + \" Conta: \" + item.numero + \" - Carteira: \" + item.numeroCarteira) for item in controller.contas\'></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarRemessaPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-tags\"></i> Instruções</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1%\"></th><th style=\"width: 10%\">Nº Documento</th><th style=\"width: 25%\">Cedente</th><th style=\"width: 25%\">Sacado</th><th style=\"width: 15%\">Descrição</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"p.isGerarCNAB\"></td><td>{{p.numeroNfe}} {{p.numeroTitulo}}</td><td>{{p.cedenteNome}}</td><td>{{p.sacadoNome}}</td><td>{{p.descricao}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.gerarRemessaPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button ng-click=\"controller.gerarRemessa()\" class=\"btn btn-md btn-success\" type=\"button\"><i class=\"fa fa-arrow-right\"></i> Gerar CNAB</button></div></div></div></div></div>");
$templateCache.put("app/cnab/remessa/arquivos/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Remessa - Gerados</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Remessa</a></li><li class=\"active\"><strong>Gerados</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" ng-busy=\"controller.gerarPromise\"><div class=\"row\" cg-busy=\"controller.listarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-tags\"></i> Arquivos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-bordered\"><thead><tr><th>Data Geração</th><th>Usuário</th><th>Arquivo</th></tr></thead><tbody><tr ng:repeat=\"p in controller.arquivos\"><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{p.empresaUsuario.nome}}</td><td>{{p.nomeArquivo}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.downloadArquivo(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-download\"></i> Download</a></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/cnab/retorno/enviar/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Processar Retorno</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Retorno</a></li><li class=\"active\"><strong>Enviar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\" cg-busy=\"controller.validarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEnvio\', \'boxEnvio\')\"><h5><i class=\"fa fa-arrow-right\"></i> Enviar arquivo de Retorno - CNAB 400</h5><div ibox-tools=\"\" class=\"ng-scope\"><div class=\"ibox-tools dropdown\" uib-dropdown=\"\"><a ng-click=\"showhide()\" style=\"color: white;\"><i class=\"fa fa-chevron-up\"></i></a></div></div></div><div id=\"boxEnvio\" class=\"ibox-content\"><form action=\"#\" class=\"dropzone dz-clickable ng-pristine ng-valid\" dropzone=\"\" id=\"dropzone\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Clique aqui para enviar o arquivo de retorno (CNAB)</span> <span class=\"fileinput-exists\"></span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarItem()\" name=\"...\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\">×</a></div></div></form></div></div></div></div><div class=\"row\" ng-if=\"controller.resultado != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxResumo\', \'boxResumo\')\"><h5><i class=\"fa fa-list\"></i> Registros</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxResumo\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxResumo\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"col-form-label\">Banco</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.resultado.banco}}\"></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"col-form-label\">Arquivo</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.resultado.nomeArquivo}}\"></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data Gravação Arquivo</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.resultado.dataGravacaoArquivo}}\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 300px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"width: 140px;\">Nº Controle</th><th class=\"white-bg\" style=\"width: 140px;\">Documento</th><th class=\"white-bg\">Ocorrência</th><th class=\"white-bg\">Descrição</th></tr></thead><tbody><tr ng:repeat=\"p in controller.resultado.itens\"><td>{{p.numeroControleParticipante}}</td><td>{{p.documento}}</td><td>{{p.identificacaoOcorrenciaTexto}}</td><td>{{p.descricao}}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.resultado != null\" cg-busy=\"controller.confirmarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button style=\"width: 180px\" ng-click=\"controller.confirmar()\" class=\"btn btn-md btn-success\" type=\"button\"><i class=\"fa fa-arrow-right\"></i> Confirmar</button></div></div></div></div></div>");
$templateCache.put("app/cnab/retorno/pesquisar/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Remessa - Gerados</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Remessa</a></li><li class=\"active\"><strong>Gerados</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" ng-busy=\"controller.gerarPromise\"><div class=\"row\" cg-busy=\"controller.listarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-tags\"></i> Arquivos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-bordered\"><thead><tr><th>Data Geração</th><th>Usuário</th><th>Arquivo</th></tr></thead><tbody><tr ng:repeat=\"p in controller.arquivos\"><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{p.empresaUsuario.nome}}</td><td>{{p.nomeArquivo}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.downloadArquivo(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-download\"></i> Download</a></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/cliente/originadores/consultar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Originador</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Originador</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-arrow-right\"></i> Dados Cadastrais</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.registro.nome\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" disabled=\"\" mask=\"99.999.999/9999-99\" ng-model=\"controller.registro.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Inscrição Estadual</label> <input type=\"text\" ng-model=\"controller.registro.inscricaoEstadual\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.tipoText\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label> <input type=\"text\" ng-model=\"controller.registro.telefone\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.registro.email\" class=\"form-control normal-text\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-arrow-right\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.registro.enderecoCep\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.registro.enderecoLogradouro\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.registro.enderecoNumero\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.registro.enderecoComplemento\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.registro.enderecoBairro\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.registro.enderecoCidade\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.registro.enderecoUf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSocios\', \'boxSocios\')\"><h5><i class=\"fa fa-arrow-right\"></i> Controle Acionário/Societário</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxSocios\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxSocios\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Nome</th><th class=\"white-bg\">CPF</th><th class=\"white-bg\">Data Nascimento</th></tr></thead><tbody><tr class=\"ng-scope\" ng:repeat=\"p in controller.socios\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.cpf }}</td><td class=\"ng-binding\">{{ p.dataNascimento }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.visualizarSocio(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirSocio()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/cliente/feriado/inserir/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Feriado</h5><small class=\"font-bold\">Informe a data e a descrição do Feriado.</small></div><div class=\"modal-body\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Data</label><div class=\"col-lg-10\"><input type=\"date\" ng-model=\"controller.registro.data\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Descrição</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.registro.descricao\" class=\"form-control\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-send\"></i> Incluir Feriado</button></div>");
$templateCache.put("app/contagrafica/acerto/detalhe/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Detalhe</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.grupo.selecionado\" ng-change=\"controller.selecionarGrupo()\"></th><th>Descrição</th><th>Documento</th><th>Data Partida</th><th>Presente Débito</th><th>Presente Crédito</th><th>Sequencial</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.titulosGrupo\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.selecionarItem(p)\"></td><td class=\"ng-binding\">{{p.tipoTexto}}</td><td class=\"ng-binding\">{{p.titulo.numeroNfe}} {{p.titulo.numero}}</td><td class=\"ng-binding\">{{p.dataPartida | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td class=\"ng-binding\" style=\"color: red;\">{{(p.isCredito == false ? p.valorPresente : 0) | currency:\'R$ \' }}</td><td class=\"ng-binding\" style=\"color: blue;\">{{(p.isCredito ? p.valorPresente : 0) | currency:\'R$ \' }}</td><td class=\"ng-binding\">{{p.sequencial}}</td></tr></tbody></table></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/contagrafica/acerto/historico/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-12\"><h2>Acertos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cobrança</a></li><li><a>Acertos</a></li><li class=\"active\"><strong>Histórico</strong></li></ol></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\" cg-busy=\"controller.listarExtratoPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Histórico</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><label class=\"col-form-label\">Cedente</label> <button ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.cedente == null ? \'Selecionar Cedente\' : (controller.cedente.razaoSocial) }}</button></div></div><div class=\"row\" style=\"padding-top: 10px;\" ng-if=\"controller.registros.length > 0\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th class=\"white-bg\" style=\"width: 40px;\">#</th><th class=\"white-bg\">Data Processamento</th><th class=\"white-bg\">Data Pagamento</th><th class=\"white-bg\">Débitos</th><th class=\"white-bg\">Créditos</th><th class=\"white-bg\">Pagamento</th><th class=\"white-bg\">Tipo</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registros\"><td class=\"ng-binding\">{{p.id }}</td><td class=\"ng-binding\">{{p.dataCadastro | date: \'dd/MM/yyyy HH:mm\' : \'UTC\'}}</td><td class=\"ng-binding\">{{p.dataPagamento | date: \'dd/MM/yyyy HH:mm\' : \'UTC\'}}</td><td class=\"ng-binding\" style=\"color: red;\">{{(p.totalDebito * -1) | currency:\'R$ \' }}</td><td class=\"ng-binding\" style=\"color: blue;\">{{p.totalCredito | currency:\'R$ \' }}</td><td class=\"ng-binding\">{{p.valorPagamento | currency:\'R$ \' }}</td><td class=\"ng-binding\" ng-if=\"p.antecipacao == null\">Acerto Direto</td><td class=\"ng-binding\" ng-if=\"p.antecipacao != null\">Operação</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-click=\"controller.detalharItem(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/ccb/consultar/validar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Validar Dados</h5></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.fileResultadoPdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/contagrafica/relatorio/extrato/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-12\"><h2>Extrato</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Conta Gráfica</a></li><li class=\"active\"><strong>Extrato</strong></li></ol></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.pesquisarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-7\"><label class=\"col-form-label\">Cedente</label> <button ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.cedente == null ? \'Selecionar Cedente\' : (controller.cedente.razaoSocial) }}</button></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Consultar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.pesquisarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Relatório</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"white-space: nowrap;\">Tipo de Movimento</th><th style=\"white-space: nowrap;\">Documento</th><th style=\"white-space: nowrap;\">Sacado</th><th style=\"white-space: nowrap;\">Presente Débito</th><th style=\"white-space: nowrap;\">Presente Crédito</th><th style=\"white-space: nowrap;\">Valor Original</th><th style=\"white-space: nowrap;\">Data Vencimento</th><th style=\"white-space: nowrap;\">Valor Partida</th><th style=\"white-space: nowrap;\">Data Partida</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{ p.tipoTexto }}</td><td style=\"white-space: nowrap;\">{{p.titulo.numeroNfe}} {{p.titulo.numero}}</td><td>{{p.titulo.sacado.razaoSocial}}</td><td style=\"white-space: nowrap;\"><span style=\"color: red\">{{(p.isCredito == false ? p.valorPresente : 0) | currency:\'R$ \'}}</span></td><td style=\"white-space: nowrap;\"><span style=\"color: blue\">{{(p.isCredito ? p.valorPresente : 0) | currency:\'R$ \'}}</span></td><td style=\"white-space: nowrap;\">{{p.valorPartida | currency:\'R$ \'}}</td><td>{{p.dataPartida | date:\'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{p.valorPartida | currency:\'R$ \'}}</td><td>{{p.dataPartida | date:\'dd/MM/yyyy\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.detalheItem(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Detalhe</a></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" style=\"margin-top: 0px !important;\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div><div class=\"row\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right;\"><button style=\"width: 200px\" ng-click=\"controller.gerarPdf()\" class=\"btn btn-md btn-success\" type=\"button\"><i class=\"fa fa-file-pdf-o\"></i> Gerar PDF</button></div></div></div></div></div></div></div>");
$templateCache.put("app/ccb/pesquisar/detalhe/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Detalhes da Operação</h5></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Financiado</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.valor_financiado | currency:\'R$ \'}}\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Total</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.total | currency:\'R$ \'}}\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CET % a.m.</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.cet_m}} %\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CET % a.a.</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.cet_a}} %\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Total IOF</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.tot_iof | currency:\'R$ \'}}\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor da Parcela</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.valor_parcela | currency:\'R$ \'}}\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Último Vencimento</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.ultimo_vencimento | date: \'dd/MM/yyyy\'}}\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa TAC</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.ccbPropostaDTO.propostaAprovada.valor_tac | currency:\'R$ \'}}\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><b>Parcelas</b><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"white-space: nowrap; width: 10px;\">Parcela</th><th>Vencimento</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registro.titulos\"><td>{{p.titulo.numero}}</td><td>{{p.titulo.dataVencimento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td style=\"white-space: nowrap;\">{{p.titulo.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><b style=\"margin-top: 5px;\">Histórico</b><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\">Data</th><th>Descrição</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registro.ccbPropostaDTO.historico\"><td style=\"white-space: nowrap;\">{{p.data | date: \'dd/MM/yyyy HH:mm\' : \'UTC\'}}</td><td>{{p.titulo}}<br><button class=\"btn btn-xs btn-success\" ng-click=\"controller.downloadAssinanetXml(p)\"><i class=\"fa fa-download\"></i> Download xml</button></td></tr></tbody></table></div></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/email/carteira/comunicacao_cedentes/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Comunicado para Cedentes</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Gestão de Carteira</a></li><li class=\"active\"><strong>Comunicado para Cedentes</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Pesquisar</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><label class=\"col-form-label\">Escolha a opção</label><select class=\"form-control\" ng-model=\"controller.filtro.templateText\" ng-change=\"controller.loadPeriodo()\"><option value=\"9\">Comissária</option><option value=\"10\">Confissão de Dívida</option><option value=\"15\">Conta Gráfica</option><option value=\"12\">Fluxo Futuro</option><option value=\"16\">Posição em Aberto</option><option value=\"17\">Posição Geral</option><option value=\"20\">Recuperação Judicial</option><option value=\"19\">Vencido</option><option value=\"21\">Vencido Com Cartório</option></select></div><div class=\"col-sm-7\"><label class=\"col-form-label\">Cedente</label> <button ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.filtro.cedente == null ? \'Selecionar Cedente\' : (controller.filtro.cedente.codigoVmoney + \' - \' + controller.filtro.cedente.nomeFantasia + \' - \' + controller.filtro.cedente.razaoSocial) }}</button></div></div><br><div class=\"row\" ng-if=\"controller.filtro.templateText == 15\"><div class=\"col-sm-2\"><label class=\"col-form-label\">Completo</label><select class=\"form-control\" ng-model=\"controller.filtro.contaGraficaCompleto\" ng-change=\"controller.filtroAlterado\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Créditos</label><select class=\"form-control\" ng-model=\"controller.filtro.contaGraficaCreditos\" ng-change=\"controller.filtroAlterado()\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Histórico</label><select class=\"form-control\" ng-model=\"controller.filtro.contaGraficaHistorico\" ng-change=\"controller.filtroAlterado()\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div></div><br><div class=\"row\" ng-if=\"controller.filtro.templateText != 15 && controller.filtro.templateText != 17\"><div class=\"col-sm-2\"><label class=\"col-form-label\">Data de Vencimento</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoFinal\" ng-disabled=\"controller.filtro.templateText == \'19X\'\" class=\"form-control\"></div><div class=\"col-sm-2\" ng-if=\"controller.filtro.templateText == 16 || controller.filtro.templateText == 19\"><label class=\"col-form-label\">Enviar Boleto <small ng-if=\"controller.filtro.enviarBoleto == 1\" style=\"color:grey;font-size:11px;\">*20 por vez</small></label><select class=\"form-control\" ng-model=\"controller.filtro.enviarBoleto\" ng-change=\"controller.filtroAlterado()\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div class=\"col-sm-2\" ng-if=\"controller.filtro.enviarBoleto == \'1\' && (controller.filtro.templateText == 16 || controller.filtro.templateText == 19) && controller.permiteAtualizarBoleto\"><label class=\"col-form-label\">Atualizar Boleto</label><select class=\"form-control\" ng-model=\"controller.filtro.atualizarBoleto\" ng-change=\"controller.filtroAlterado()\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div class=\"col-sm-2\" ng-if=\"controller.filtro.templateText == 16 || controller.filtro.templateText == 19\"><label class=\"col-form-label\">Carteira</label><select class=\"form-control\" ng-model=\"controller.filtro.carteira\" ng-change=\"controller.filtroAlterado()\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div></div><div ng-if=\"controller.filtro.templateText == 17\"><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-sm-4\"><fieldset style=\"border:1px solid #c8d3df;border-radius:5px;padding:8px 14px 12px;\"><legend style=\"font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#676a6c;width:auto;padding:0 8px;margin-bottom:6px;\">Vencimento</legend><div class=\"row\"><div class=\"col-sm-6\"><label class=\"col-form-label\" style=\"font-size:11px;\">De</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoInicial\" class=\"form-control input-sm\"></div><div class=\"col-sm-6\"><label class=\"col-form-label\" style=\"font-size:11px;\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoFinal\" class=\"form-control input-sm\"></div></div></fieldset></div><div class=\"col-sm-6\" style=\"display:flex;align-items:flex-start;gap:15px;padding-top:5px;\"><div style=\"min-width:140px;\"><label class=\"col-form-label\">Enviar Boleto <small ng-if=\"controller.filtro.enviarBoleto == 1\" style=\"color:grey;font-size:11px;\">*20 por vez</small></label><select class=\"form-control\" ng-model=\"controller.filtro.enviarBoleto\" ng-change=\"controller.filtroAlterado()\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div style=\"min-width:140px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\' && controller.permiteAtualizarBoleto\"><label class=\"col-form-label\">Atualizar Boleto</label><select class=\"form-control\" ng-model=\"controller.filtro.atualizarBoleto\" ng-change=\"controller.filtroAlterado()\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div style=\"min-width:140px;\"><label class=\"col-form-label\">Carteira</label><select class=\"form-control\" ng-model=\"controller.filtro.carteira\" ng-change=\"controller.filtroAlterado()\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div></div></div><div class=\"row\" style=\"margin-bottom: 15px;\"><div class=\"col-sm-4\"><fieldset style=\"border:1px solid #c8d3df;border-radius:5px;padding:8px 14px 12px;\"><legend style=\"font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#676a6c;width:auto;padding:0 8px;margin-bottom:6px;\">Pagamento</legend><div class=\"row\"><div class=\"col-sm-6\"><label class=\"col-form-label\" style=\"font-size:11px;\">De</label> <input type=\"date\" ng-model=\"controller.filtro.pagamentoInicial\" class=\"form-control input-sm\"></div><div class=\"col-sm-6\"><label class=\"col-form-label\" style=\"font-size:11px;\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.pagamentoFinal\" class=\"form-control input-sm\"></div></div></fieldset></div><div class=\"col-sm-7\" style=\"display:flex;align-items:center;\"><div><label class=\"col-form-label\" style=\"font-weight:bold;display:block;margin-bottom:8px;\">Situações a exibir:</label><div style=\"display:flex;gap:20px;align-items:center;flex-wrap:wrap;\"><label style=\"font-weight:normal;cursor:pointer;margin-bottom:0;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.statusFiltro.vencidos\" ng-change=\"controller.aplicarFiltrosGeral()\"> Vencido</label> <label style=\"font-weight:normal;cursor:pointer;margin-bottom:0;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.statusFiltro.liquidados\" ng-change=\"controller.aplicarFiltrosGeral()\"> Liquidado</label> <label style=\"font-weight:normal;cursor:pointer;margin-bottom:0;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.statusFiltro.baixados\" ng-change=\"controller.aplicarFiltrosGeral()\"> Baixado</label> <label style=\"font-weight:normal;cursor:pointer;margin-bottom:0;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.statusFiltro.aVencer\" ng-change=\"controller.aplicarFiltrosGeral()\"> A Vencer</label> <button class=\"btn btn-info btn-xs\" ng-click=\"controller.toggleTodosStatusFiltro()\">{{ (controller.statusFiltro.vencidos && controller.statusFiltro.liquidados && controller.statusFiltro.baixados && controller.statusFiltro.aVencer) ? \'Desmarcar Todos\' : \'Marcar Todos\' }}</button></div></div></div></div></div><div class=\"row\" style=\"text-align: right;\"><div class=\"col-sm-12\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success\" style=\"width: 200px;\" ng-click=\"controller.pesquisar()\">Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.acaoTabelaPromise\" ng-if=\"controller.registros != null && controller.registros.length > 0 && controller.filtro.templateText != 15\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Lançamentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'lancamento\')\" style=\"white-space: nowrap;\">Razão Social</th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"white-space: nowrap;\">Duplicata</th><th ng-click=\"controller.ordenarResultado(\'cedente\')\">Vencimento</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\" ng-if=\"controller.exibirColunaDiasAtraso\">DA</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Valor Original</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\">Dt Oper.</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Valor Presente</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.calcularTotalSelecionado()\"></td><td style=\"white-space: nowrap;\">{{p.razaoSocial}}</td><td style=\"white-space: nowrap;\">{{p.numeroDocumento}}</td><td style=\"white-space: nowrap;\">{{p.dataVencimento}}</td><td style=\"white-space: nowrap; color: red;\" ng-if=\"controller.exibirColunaDiasAtraso\">{{p.diasAtraso > 0 ? p.diasAtraso : \'\'}}</td><td style=\"white-space: nowrap;\">{{p.valorPrevisto | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{p.dataLancamento}}</td><td style=\"white-space: nowrap;\">{{p.valorPresente | currency:\'R$ \'}}</td></tr><tr><td colspan=\"2\"></td><td style=\"white-space: nowrap;\"><b>Qtde:</b> {{controller.registro.quantidade}}</td><td colspan=\"3\"></td><td><b>TOTAL</b></td><td style=\"white-space: nowrap;\">{{controller.registro.valorTotal | currency:\'R$ \'}}</td></tr></tbody></table></div><div style=\"text-align: right; margin-top: 10px;\"><table width=\"100%\"><tr><td style=\"width: 90%;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>E-mail Cedente:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.emailCedente\" class=\"form-control normal-text\" style=\"width: 320px;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>&nbsp;&nbsp;&nbsp;&nbsp;E-mail Cópia:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.email\" class=\"form-control normal-text\" style=\"width: 320px;\"></td><td style=\"width: 10px;\">&nbsp;&nbsp;</td><td style=\"width: 1px;\"><button ng-click=\"controller.enviarEmail()\" class=\"btn btn-success\" style=\"width: 180px\">Enviar E-mail</button></td></tr></table></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.acaoTabelaPromise\" ng-if=\"controller.registroContaGrafica != null && controller.registroContaGrafica.registros.length > 0 && controller.filtro.templateText == 15\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Lançamentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'lancamento\')\" style=\"white-space: nowrap;\">Tipo Movimento</th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"white-space: nowrap;\">Documento</th><th ng-click=\"controller.ordenarResultado(\'cedente\')\">Sacado</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Débitos</th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\" ng-if=\"controller.filtro.contaGraficaCreditos == \'1\'\">Créditos</th><th ng-click=\"controller.ordenarResultado(\'diasAtraso\')\">Vlr Original</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Dt Vencto</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\">Vlr Partida</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\">Dt Partida</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registroContaGrafica.registros\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.calcularTotalSelecionado()\"></td><td style=\"white-space: nowrap;\">{{p.descricaoMovimentacao}}</td><td style=\"white-space: nowrap;\">{{p.numeroDocumento}}</td><td style=\"white-space: nowrap;\">{{p.nomeRazao}} <small ng-if=\"controller.filtro.contaGraficaHistorico == \'1\'\" style=\"color: #1bc71b;\"><i><br>{{p.textoMotivo}}</i></small></td><td style=\"white-space: nowrap; color: red;\">{{p.debitos | currency:\'R$ \'}}</td><td style=\"white-space: nowrap; color: blue;\" ng-if=\"controller.filtro.contaGraficaCreditos == \'1\'\">{{p.creditos | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{p.valorPrevisto | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{p.dataVencimento}}</td><td style=\"white-space: nowrap;\">{{p.valorPartida | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{p.dataPartida}}</td></tr><tr><td style=\"white-space: nowrap;\" colspan=\"3\"></td><td style=\"white-space: nowrap;\"><b>TOTAL</b></td><td style=\"white-space: nowrap; color: red;\">{{controller.registroContaGrafica.totalDebitos | currency:\'R$ \'}}</td><td style=\"white-space: nowrap; color: blue;\" ng-if=\"controller.filtro.contaGraficaCreditos == \'1\'\">{{controller.registroContaGrafica.totalCreditos | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{controller.registroContaGrafica.totalValorOriginal | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\"></td><td style=\"white-space: nowrap;\">{{controller.registroContaGrafica.totalValorPartida | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\"></td></tr></tbody></table></div><div style=\"text-align: right; margin-top: 10px;\"><table width=\"100%\"><tr><td style=\"width: 90%;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>E-mail Cedente:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.emailCedente\" class=\"form-control normal-text\" style=\"width: 320px;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>&nbsp;&nbsp;&nbsp;&nbsp;E-mail Cópia:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.email\" class=\"form-control normal-text\" style=\"width: 320px;\"></td><td style=\"width: 10px;\">&nbsp;&nbsp;</td><td style=\"width: 1px;\"><button ng-click=\"controller.enviarEmailContaGrafica()\" class=\"btn btn-success\" style=\"width: 180px\">Enviar E-mail</button></td></tr></table></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.acaoTabelaPromise\" ng-if=\"controller.registroPosicaoAberto != null && controller.registroPosicaoAberto.registros.length > 0 && (controller.filtro.templateText == 16 || controller.filtro.templateText == 19 || controller.filtro.templateText == 21)\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Lançamentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'lancamento\')\" style=\"white-space: nowrap;\">Razão Social</th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"white-space: nowrap;\">Duplicata</th><th ng-click=\"controller.ordenarResultado(\'cedente\')\">Vencimento</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">DA</th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\">BCO</th><th ng-click=\"controller.ordenarResultado(\'diasAtraso\')\">Cobrança</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Sigla</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Tipo</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Valor</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\">Dt Oper.</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registroPosicaoAberto.registros\"><td style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.calcularTotalSelecionado()\"></td><td style=\"white-space: nowrap;\">{{p.razaoSocial}}</td><td style=\"white-space: nowrap;\">{{p.numeroDocumento}}</td><td style=\"white-space: nowrap;\">{{p.dataVencimento}}</td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.diasAtraso <= 0\"></td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.diasAtraso > 0\">{{p.diasAtraso}}</td><td style=\"white-space: nowrap;\">{{p.banco}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.statusCobranca != \'M\'\">{{p.statusCobrancaTexto}}</td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.statusCobranca == \'M\'\">Instrução em Andamento</td><td style=\"white-space: nowrap;\">{{p.siglaDoc}}</td><td style=\"white-space: nowrap;\">{{p.tipoDocTexto}}</td><td style=\"white-space: nowrap;\">{{p.valorPrevisto - p.valorAbatimento | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{p.dataLancamento}}</td><td ng-if=\"p.dadosBoleto != null\"><button ng-click=\"controller.visualizarBoleto(p.dadosBoleto)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr><tr><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"></td><td></td><td style=\"white-space: nowrap;\"><b>Qtde:</b> {{controller.registroPosicaoAberto.quantidade}}</td><td colspan=\"5\"></td><td style=\"white-space: nowrap;\"><b>TOTAL</b></td><td style=\"white-space: nowrap;\">{{controller.registroPosicaoAberto.valorTotal | currency:\'R$ \'}}</td></tr></tbody></table></div><div style=\"text-align: right; margin-top: 10px;\"><table width=\"100%\"><tr><td style=\"width: 90%;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>E-mail Cedente:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.emailCedente\" class=\"form-control normal-text\" style=\"width: 320px;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>&nbsp;&nbsp;&nbsp;&nbsp;E-mail Cópia:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.email\" class=\"form-control normal-text\" style=\"width: 320px;\"></td><td style=\"width: 10px;\">&nbsp;&nbsp;</td><td style=\"width: 1px;\"><button ng-click=\"controller.enviarEmailPosicaoTitulosAberto()\" class=\"btn btn-success\" style=\"width: 180px\">Enviar E-mail</button></td></tr></table></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.acaoTabelaPromise\" ng-if=\"controller.registroPosicaoGeral != null && controller.registroPosicaoGeral.registros.length > 0 && controller.filtro.templateText == 17\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" ng-if=\"controller.statusFiltro.vencidos && controller.gruposGeral.vencidos.length > 0\"><div class=\"ibox-title\" style=\"background-color: #ef4444; color: white; border-radius: 4px 4px 0 0;\"><h5><i class=\"fa fa-exclamation-triangle\"></i> Lançamentos - Vencidos</h5></div><div class=\"ibox-content\" style=\"border-radius: 0 0 4px 4px; border-top: none;\"><div class=\"table-responsive\"><table class=\"table table-bordered table-striped table-hover\" style=\"margin-bottom: 0;\"><thead><tr><th style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodosGrupo.vencidos\" ng-change=\"controller.selecionarTodosGrupo(\'vencidos\')\"></th><th>Razão Social</th><th>Duplicata</th><th>Vencimento</th><th>DA</th><th>BCO</th><th>Cobrança</th><th>Sigla</th><th>Tipo</th><th>TO</th><th>Valor</th><th>Dt Oper.</th><th>Valor Pago</th><th>Dt Pagto.</th><th ng-if=\"controller.filtro.enviarBoleto == \'1\'\" style=\"width: 100px;\">Boleto</th></tr></thead><tbody><tr ng:repeat=\"p in controller.gruposGeral.vencidos\" ng-style=\"(p.tipoOperacao === \'R\' || p.tipoOperacao === \'C\') ? {\'background-color\': \'#d4edda\', \'color\': \'#155724\'} : {}\"><td style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.calcularTotalSelecionado()\"></td><td style=\"white-space: nowrap;\">{{p.razaoSocial}}</td><td style=\"white-space: nowrap;\">{{p.numeroDocumento}}</td><td style=\"white-space: nowrap;\">{{p.dataVencimento}}</td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.diasAtraso <= 0\"></td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.diasAtraso > 0\">{{p.diasAtraso}}</td><td style=\"white-space: nowrap;\">{{p.banco}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.statusCobranca != \'M\'\">{{p.statusCobrancaTexto}}</td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.statusCobranca == \'M\'\">Instrução em Andamento</td><td style=\"white-space: nowrap;\">{{p.tipoDocumento}}</td><td style=\"white-space: nowrap;\">{{p.tipoDocTexto}}</td><td style=\"white-space: nowrap;\">{{p.tipoOperacao}}</td><td style=\"white-space: nowrap;\">{{p.valorPrevisto | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{p.dataLancamento}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago <= 0\"></td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago > 0\">{{p.valorPago | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago <= 0\"></td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago > 0\">{{p.dataPagamento}}</td><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><button ng-if=\"p.dadosBoleto != null\" ng-click=\"controller.visualizarBoleto(p.dadosBoleto)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr><tr style=\"background-color: #f9fafb; font-weight: bold;\"><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"></td><td>Subtotal</td><td style=\"white-space: nowrap;\"><b>Qtde:</b> {{controller.gruposGeral.vencidos.length}}</td><td colspan=\"7\"></td><td style=\"white-space: nowrap;\">{{controller.grupoTotais.vencidos.total | currency:\'R$ \'}}</td><td></td><td></td><td></td><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"></td></tr></tbody></table></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"controller.statusFiltro.aVencer && controller.gruposGeral.aVencer.length > 0\"><div class=\"ibox-title\" style=\"background-color: #f59e0b; color: white; border-radius: 4px 4px 0 0;\"><h5><i class=\"fa fa-clock-o\"></i> Lançamentos - A Vencer</h5></div><div class=\"ibox-content\" style=\"border-radius: 0 0 4px 4px; border-top: none;\"><div class=\"table-responsive\"><table class=\"table table-bordered table-striped table-hover\" style=\"margin-bottom: 0;\"><thead><tr><th style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodosGrupo.aVencer\" ng-change=\"controller.selecionarTodosGrupo(\'aVencer\')\"></th><th>Razão Social</th><th>Duplicata</th><th>Vencimento</th><th>DA</th><th>BCO</th><th>Cobrança</th><th>Sigla</th><th>Tipo</th><th>TO</th><th>Valor</th><th>Dt Oper.</th><th>Valor Pago</th><th>Dt Pagto.</th><th ng-if=\"controller.filtro.enviarBoleto == \'1\'\" style=\"width: 100px;\">Boleto</th></tr></thead><tbody><tr ng:repeat=\"p in controller.gruposGeral.aVencer\"><td style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.calcularTotalSelecionado()\"></td><td style=\"white-space: nowrap;\">{{p.razaoSocial}}</td><td style=\"white-space: nowrap;\">{{p.numeroDocumento}}</td><td style=\"white-space: nowrap;\">{{p.dataVencimento}}</td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.diasAtraso <= 0\"></td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.diasAtraso > 0\">{{p.diasAtraso}}</td><td style=\"white-space: nowrap;\">{{p.banco}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.statusCobranca != \'M\'\">{{p.statusCobrancaTexto}}</td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.statusCobranca == \'M\'\">Instrução em Andamento</td><td style=\"white-space: nowrap;\">{{p.tipoDocumento}}</td><td style=\"white-space: nowrap;\">{{p.tipoDocTexto}}</td><td style=\"white-space: nowrap;\">{{p.tipoOperacao}}</td><td style=\"white-space: nowrap;\">{{p.valorPrevisto | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{p.dataLancamento}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago <= 0\"></td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago > 0\">{{p.valorPago | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago <= 0\"></td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago > 0\">{{p.dataPagamento}}</td><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><button ng-if=\"p.dadosBoleto != null\" ng-click=\"controller.visualizarBoleto(p.dadosBoleto)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr><tr style=\"background-color: #f9fafb; font-weight: bold;\"><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"></td><td>Subtotal</td><td style=\"white-space: nowrap;\"><b>Qtde:</b> {{controller.gruposGeral.aVencer.length}}</td><td colspan=\"7\"></td><td style=\"white-space: nowrap;\">{{controller.grupoTotais.aVencer.total | currency:\'R$ \'}}</td><td></td><td></td><td></td><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"></td></tr></tbody></table></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"controller.statusFiltro.liquidados && controller.gruposGeral.liquidados.length > 0\"><div class=\"ibox-title\" style=\"background-color: #10b981; color: white; border-radius: 4px 4px 0 0;\"><h5><i class=\"fa fa-check-circle\"></i> Lançamentos - Liquidados</h5></div><div class=\"ibox-content\" style=\"border-radius: 0 0 4px 4px; border-top: none;\"><div class=\"table-responsive\"><table class=\"table table-bordered table-striped table-hover\" style=\"margin-bottom: 0;\"><thead><tr><th style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodosGrupo.liquidados\" ng-change=\"controller.selecionarTodosGrupo(\'liquidados\')\"></th><th>Razão Social</th><th>Duplicata</th><th>Vencimento</th><th>DA</th><th>BCO</th><th>Cobrança</th><th>Sigla</th><th>Tipo</th><th>TO</th><th>Valor</th><th>Dt Oper.</th><th>Valor Pago</th><th>Dt Pagto.</th><th ng-if=\"controller.filtro.enviarBoleto == \'1\'\" style=\"width: 100px;\">Boleto</th></tr></thead><tbody><tr ng:repeat=\"p in controller.gruposGeral.liquidados\"><td style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.calcularTotalSelecionado()\"></td><td style=\"white-space: nowrap;\">{{p.razaoSocial}}</td><td style=\"white-space: nowrap;\">{{p.numeroDocumento}}</td><td style=\"white-space: nowrap;\">{{p.dataVencimento}}</td><td style=\"white-space: nowrap;\"></td><td style=\"white-space: nowrap;\">{{p.banco}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.statusCobranca != \'M\'\">{{p.statusCobrancaTexto}}</td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.statusCobranca == \'M\'\">Instrução em Andamento</td><td style=\"white-space: nowrap;\">{{p.tipoDocumento}}</td><td style=\"white-space: nowrap;\">{{p.tipoDocTexto}}</td><td style=\"white-space: nowrap;\">{{p.tipoOperacao}}</td><td style=\"white-space: nowrap;\">{{p.valorPrevisto | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{p.dataLancamento}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago <= 0\"></td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago > 0\">{{p.valorPago | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago <= 0\"></td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago > 0\">{{p.dataPagamento}}</td><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><button ng-if=\"p.dadosBoleto != null\" ng-click=\"controller.visualizarBoleto(p.dadosBoleto)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr><tr style=\"background-color: #f9fafb; font-weight: bold;\"><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"></td><td>Subtotal</td><td style=\"white-space: nowrap;\"><b>Qtde:</b> {{controller.gruposGeral.liquidados.length}}</td><td colspan=\"7\"></td><td style=\"white-space: nowrap;\">{{controller.grupoTotais.liquidados.total | currency:\'R$ \'}}</td><td></td><td></td><td></td><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"></td></tr></tbody></table></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"controller.statusFiltro.baixados && controller.gruposGeral.baixados.length > 0\"><div class=\"ibox-title\" style=\"background-color: #6b7280; color: white; border-radius: 4px 4px 0 0;\"><h5><i class=\"fa fa-times-circle\"></i> Lançamentos - Baixados</h5></div><div class=\"ibox-content\" style=\"border-radius: 0 0 4px 4px; border-top: none;\"><div class=\"table-responsive\"><table class=\"table table-bordered table-striped table-hover\" style=\"margin-bottom: 0;\"><thead><tr><th style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodosGrupo.baixados\" ng-change=\"controller.selecionarTodosGrupo(\'baixados\')\"></th><th>Razão Social</th><th>Duplicata</th><th>Vencimento</th><th>DA</th><th>BCO</th><th>Cobrança</th><th>Sigla</th><th>Tipo</th><th>TO</th><th>Valor</th><th>Dt Oper.</th><th>Valor Pago</th><th>Dt Pagto.</th><th ng-if=\"controller.filtro.enviarBoleto == \'1\'\" style=\"width: 100px;\">Boleto</th></tr></thead><tbody><tr ng:repeat=\"p in controller.gruposGeral.baixados\"><td style=\"width: 1px;\" ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.calcularTotalSelecionado()\"></td><td style=\"white-space: nowrap;\">{{p.razaoSocial}}</td><td style=\"white-space: nowrap;\">{{p.numeroDocumento}}</td><td style=\"white-space: nowrap;\">{{p.dataVencimento}}</td><td style=\"white-space: nowrap;\"></td><td style=\"white-space: nowrap;\">{{p.banco}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.statusCobranca != \'M\'\">{{p.statusCobrancaTexto}}</td><td style=\"white-space: nowrap; color: red;\" ng-if=\"p.statusCobranca == \'M\'\">Instrução em Andamento</td><td style=\"white-space: nowrap;\">{{p.tipoDocumento}}</td><td style=\"white-space: nowrap;\">{{p.tipoDocTexto}}</td><td style=\"white-space: nowrap;\">{{p.tipoOperacao}}</td><td style=\"white-space: nowrap;\">{{p.valorPrevisto | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\">{{p.dataLancamento}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago <= 0\"></td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago > 0\">{{p.valorPago | currency:\'R$ \'}}</td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago <= 0\"></td><td style=\"white-space: nowrap;\" ng-if=\"p.valorPago > 0\">{{p.dataPagamento}}</td><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"><button ng-if=\"p.dadosBoleto != null\" ng-click=\"controller.visualizarBoleto(p.dadosBoleto)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr><tr style=\"background-color: #f9fafb; font-weight: bold;\"><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"></td><td>Subtotal</td><td style=\"white-space: nowrap;\"><b>Qtde:</b> {{controller.gruposGeral.baixados.length}}</td><td colspan=\"7\"></td><td style=\"white-space: nowrap;\">{{controller.grupoTotais.baixados.total | currency:\'R$ \'}}</td><td></td><td></td><td></td><td ng-if=\"controller.filtro.enviarBoleto == \'1\'\"></td></tr></tbody></table></div></div></div><div class=\"ibox float-e-margins\" style=\"margin-top: 25px;\"><div class=\"ibox-content\" style=\"border-radius: 4px; border: 1px solid #e7eaec;\"><div class=\"row\" style=\"font-size: 13px; font-weight: bold; margin-bottom: 15px; border-bottom: 1px solid #e7eaec; padding-bottom: 10px;\"><div class=\"col-sm-3 text-danger\"><i class=\"fa fa-exclamation-triangle\"></i> Total Vencidos: {{controller.grupoTotais.vencidos.total | currency:\'R$ \'}} ({{controller.grupoTotais.vencidos.quantidade}})</div><div class=\"col-sm-3 text-warning\"><i class=\"fa fa-clock-o\"></i> Total A Vencer: {{controller.grupoTotais.aVencer.total | currency:\'R$ \'}} ({{controller.grupoTotais.aVencer.quantidade}})</div><div class=\"col-sm-3\" style=\"color: #10b981;\"><i class=\"fa fa-check-circle\"></i> Total Liquidados: {{controller.grupoTotais.liquidados.total | currency:\'R$ \'}} ({{controller.grupoTotais.liquidados.quantidade}})</div><div class=\"col-sm-3 text-muted\"><i class=\"fa fa-times-circle\"></i> Total Baixados: {{controller.grupoTotais.baixados.total | currency:\'R$ \'}} ({{controller.grupoTotais.baixados.quantidade}})</div></div><div class=\"row\"><div class=\"col-md-4\" style=\"padding-top: 8px;\"><span style=\"font-size: 15px; font-weight: bold;\">TOTAL CONSOLIDADO: {{controller.registroPosicaoGeral.valorTotal | currency:\'R$ \'}} | Qtde: {{controller.registroPosicaoGeral.quantidade}}</span></div><div class=\"col-md-8 text-right\"><div class=\"form-inline\" style=\"display: inline-flex; gap: 10px; justify-content: flex-end; width: 100%;\"><div class=\"form-group\"><label><b>E-mail Cedente: &nbsp;</b></label> <input type=\"text\" ng-model=\"controller.emailCedente\" class=\"form-control normal-text\" style=\"width: 200px;\"></div><div class=\"form-group\"><label><b>E-mail Cópia: &nbsp;</b></label> <input type=\"text\" ng-model=\"controller.email\" class=\"form-control normal-text\" style=\"width: 200px;\"></div><button ng-click=\"controller.enviarEmailPosicaoTitulosGeral()\" class=\"btn btn-success\" style=\"width: 140px\">Enviar E-mail</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/email/carteira/dinamica/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Geração de Boletos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Gestão de Carteira</a></li><li class=\"active\"><strong>Geração de Boletos</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Selecionar Lançamentos</h5><div class=\"ibox-tools\"><a ng-click=\"controller.redirectToURL(); $event.stopPropagation()\" title=\"Manual: Geração de Boleto\"><i class=\"fa fa-book\" style=\"color: white; font-size: 22px;\"></i></a> <a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-7\"><label class=\"col-form-label\">Cedente</label> <button ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.filtro.cedente == null ? \'Selecionar Cedente\' : (controller.filtro.cedente.codigoVmoney + \' - \' + controller.filtro.cedente.nomeFantasia + \' - \' + controller.filtro.cedente.razaoSocial) }}</button></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Data de Vencimento</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">&nbsp;</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoFinal\" class=\"form-control\"></div></div><br><div class=\"row\"><div class=\"col-sm-2\"><label class=\"col-form-label\">Sacado</label><select class=\"form-control\" ng-model=\"controller.filtro.tipoSacado\"><option ng-value=\"0\">Por CNPJ</option><option ng-value=\"1\">Por Grupo</option></select></div><div class=\"col-sm-5\" ng-if=\"controller.filtro.tipoSacado == 0\"><label class=\"col-form-label\">&nbsp;</label> <button ng-click=\"controller.selecionarSacadoModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.filtro.sacado == null ? \'Selecionar Sacado\' : ((controller.filtro.sacado.razaoSocial | limitTo: 25) + \' - \' + controller.filtro.sacado.cnpj) }}</button></div><div class=\"col-sm-4\" ng-if=\"controller.filtro.tipoSacado == 1\"><label class=\"col-form-label\">&nbsp;</label> <input type=\"text\" ng-model=\"controller.filtro.grupoSacado\" class=\"form-control\" mask=\"99.999.999\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Data da Operação</label> <input type=\"date\" ng-model=\"controller.filtro.operacaoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">&nbsp;</label> <input type=\"date\" ng-model=\"controller.filtro.operacaoFinal\" class=\"form-control\"></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><br><button class=\"btn btn-success\" style=\"width: 200px\" ng-click=\"controller.pesquisar()\">Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.acaoTabelaPromise\" ng-if=\"controller.registros != null && controller.registros.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Lançamentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'lancamento\')\" style=\"width: 10px;\">Lançamento</th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"width: 10px;\">Título</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado</th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\">Vencimento</th><th ng-click=\"controller.ordenarResultado(\'diasAtraso\')\" style=\"width: 60px;\">Dias em Atraso</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Banco</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\">Valor Título</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\"></td><td style=\"white-space: nowrap; width: 1px;\">{{p.lancamento}}</td><td style=\"white-space: nowrap; width: 1px;\">{{p.numeroDocumento}}</td><td>{{p.nomeSacado}}<br>E-mail: {{p.emailDestinatario}}</td><td ng-if=\"p.isVencido\" style=\"color: red;\">{{p.dataVencimento}}</td><td ng-if=\"p.isVencido == false\">{{p.dataVencimento}}</td><td>{{p.diasAtraso}}</td><td>{{p.codBanco}} - {{p.nomeBanco}}</td><td>{{p.valorTitulo | currency:\'R$ \'}}</td><td><button ng-click=\"controller.visualizarBoleto(p)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div><div style=\"text-align: right; margin-top: 10px;\"><table width=\"100%\"><tr><td style=\"width: 99%;\" colspan=\"4\"></td><td style=\"width: 1px;\"><button ng-click=\"controller.baixarPdf()\" style=\"margin-bottom: 2px; width: 200px\" class=\"btn btn-success\">Baixar PDF</button></td></tr><tr><td colspan=\"5\"></td></tr><tr ng-if=\"controller.filtro.sacado != null\"><td style=\"width: 90%;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>E-mail Cópia:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.email\" class=\"form-control\" style=\"width: 400px;\"></td><td style=\"width: 10px;\">&nbsp;&nbsp;</td><td style=\"width: 1px;\"><button ng-click=\"controller.enviarEmail()\" class=\"btn btn-success\" style=\"width: 200px\">Enviar E-mail</button></td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/email/carteira/comunicacao_vencidos/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Comunicado para Sacados</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Gestão de Carteira</a></li><li class=\"active\"><strong>Comunicado para Sacados</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Pesquisar</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><label class=\"col-form-label\">Escolha a opção</label><select class=\"form-control\" ng-model=\"controller.filtro.templateText\" ng-change=\"controller.loadPeriodo()\"><option value=\"avencer\">A Vencer</option><option value=\"vencidos1dia\">Vencidos a 1 dia útil</option><option value=\"vencidos5diasComCartorio\">Vencidos a 5 dias Com Cartório</option><option value=\"vencidos5diasSemCartorio\">Vencidos a 5 dias Sem Cartório</option><option value=\"vencido\">Vencido</option><option value=\"vencidosComCartorio\">Vencido Com Cartório</option></select></div><div class=\"col-sm-5\"><label class=\"col-form-label\">Cedente</label> <button ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.filtro.cedente == null ? \'Selecionar Cedente\' : (controller.filtro.cedente.codigoVmoney + \' - \' + controller.filtro.cedente.nomeFantasia + \' - \' + controller.filtro.cedente.razaoSocial) }}</button></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Data de Vencimento</label> <input type=\"date\" ng-disabled=\"controller.filtro.templateText != \'vencido\' && controller.filtro.templateText != \'vencidosComCartorio\' && controller.filtro.templateText != \'avencer\'\" ng-model=\"controller.filtro.vencimentoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\" ng-if=\"controller.filtro.templateText == \'avencer\' || controller.filtro.templateText == \'vencido\' || controller.filtro.templateText == \'vencidosComCartorio\'\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-disabled=\"controller.filtro.templateText != \'avencer\' && (controller.filtro.templateText == \'vencido\' )\" ng-model=\"controller.filtro.vencimentoFinal\" class=\"form-control\"></div></div><br><div class=\"row\"><div class=\"col-sm-2\" ng-if=\"controller.filtro.templateText != \'vencidosComCartorio\'\"><label class=\"col-form-label\">Enviar Boleto</label><select class=\"form-control\" ng-model=\"controller.filtro.enviarBoleto\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div class=\"col-sm-2\" ng-if=\"controller.filtro.templateText != \'avencer\' && controller.filtro.enviarBoleto == \'1\' && controller.permiteAtualizarBoleto\"><label class=\"col-form-label\">Atualizar Boleto</label><select class=\"form-control\" ng-model=\"controller.filtro.atualizarBoleto\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Cópia para Cedente</label><select class=\"form-control\" ng-model=\"controller.filtro.comunicarCedente\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div class=\"col-sm-2\" ng-if=\"controller.filtro.templateText == \'avencer\' || controller.filtro.templateText == \'vencido\'\"><label class=\"col-form-label\">Carteira</label><select class=\"form-control\" ng-model=\"controller.filtro.carteira\" ng-change=\"controller.filtroAlterado()\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div><div class=\"col-sm-2\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success btn-block\" ng-click=\"controller.pesquisar()\">Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.acaoTabelaPromise\" ng-if=\"controller.registros != null && controller.registros.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Lançamentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'lancamento\')\" style=\"width: 10px;\">Lançamento</th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"width: 10px;\">Título</th><th ng-click=\"controller.ordenarResultado(\'cedente\')\">Cedente</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado</th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\">Vencimento</th><th ng-click=\"controller.ordenarResultado(\'diasAtraso\')\" style=\"width: 60px;\">DA</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Banco</th><th ng-click=\"controller.ordenarResultado(\'banco\')\" ng-if=\"controller.filtro.templateText == \'avencer\' || controller.filtro.templateText == \'vencido\'\">Sigla</th><th ng-click=\"controller.ordenarResultado(\'banco\')\" ng-if=\"controller.filtro.templateText == \'avencer\' || controller.filtro.templateText == \'vencido\'\">Tipo</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\">Valor Título</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\"></td><td style=\"white-space: nowrap; width: 1px;\">{{p.lancamento}}</td><td style=\"white-space: nowrap; width: 1px;\">{{p.numeroDocumento}}</td><td>{{p.sacadorAvalista}}<br>E-mail: {{p.emailCedente}}</td><td>{{p.nomeSacado}}<br>E-mail: {{p.emailDestinatario}}</td><td ng-if=\"p.isVencido\" style=\"color: red;\">{{p.dataVencimento}}</td><td ng-if=\"p.isVencido == false\">{{p.dataVencimento}}</td><td>{{p.diasAtraso}}</td><td style=\"white-space: nowrap;\">{{p.codBanco}} - {{p.nomeBanco}}<br>Ag.: {{p.agencia}}<br>Conta: {{p.numeroContaComDigito}}</td><td style=\"white-space: nowrap;\" ng-if=\"controller.filtro.templateText == \'avencer\' || controller.filtro.templateText == \'vencido\'\">{{p.siglaDoc}}</td><td style=\"white-space: nowrap;\" ng-if=\"controller.filtro.templateText == \'avencer\' || controller.filtro.templateText == \'vencido\'\">{{p.tipoDocTexto}}</td><td style=\"white-space: nowrap;\">{{p.valorTitulo | currency:\'R$ \'}}</td><td><button ng-if=\"controller.filtro.templateText != \'vencidosComCartorio\'\" ng-click=\"controller.visualizarBoleto(p)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div><div style=\"text-align: right; margin-top: 10px;\"><table width=\"100%\"><tr><td style=\"width: 90%;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>E-mail Cópia:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.email\" class=\"form-control normal-text\" style=\"width: 400px;\"></td><td style=\"width: 10px;\">&nbsp;&nbsp;</td><td style=\"width: 1px;\"><button ng-click=\"controller.enviarEmail()\" class=\"btn btn-success\" style=\"width: 200px\">Enviar E-mail</button></td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/email/carteira/liquidacao_comissarias/index.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Liquidação de Comissárias</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Gestão de Carteira</a></li><li class=\"active\"><strong>Liquidação de Comissárias</strong></li></ol></div></div><div class=\"wrapper wrapper-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Pesquisar</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-7\"><label class=\"col-form-label\">Cedente</label> <button ng-click=\"controller.selecionarCedenteModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.filtro.cedente == null ? \'Selecionar Cedente\' : (controller.filtro.cedente.codigoVmoney + \' - \' + controller.filtro.cedente.nomeFantasia + \' - \' + controller.filtro.cedente.razaoSocial) }}</button></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Data de Vencimento</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoFinal\" class=\"form-control\"></div></div><br><div class=\"row\" style=\"text-align: left;\"><div class=\"col-sm-3\"><label class=\"col-form-label\">Estornar lote</label> <input type=\"text\" ng-model=\"controller.filtro.loteEstorno\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Data de Correção.</label> <input type=\"date\" ng-model=\"controller.filtro.dataCorrecao\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Data de Pagamento</label> <input type=\"date\" ng-model=\"controller.filtro.dataPagamento\" class=\"form-control\"></div><div class=\"col-sm-4\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success\" style=\"width: 200px; margin-top: 24px;\" ng-click=\"controller.pesquisar()\">Pesquisar</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registros != null && controller.registros.length > 0 && controller.exibirLancamentos\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Lançamentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><form name=\"formLancamentos\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'sacado\')\" style=\"white-space: nowrap;\">Razão Social</th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"white-space: nowrap;\">Duplicata</th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\" style=\"white-space: nowrap; text-align: center;\">Vencimento</th><th ng-click=\"controller.ordenarResultado(\'\')\" style=\"white-space: nowrap; text-align: center;\">Cobrança</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\" style=\"white-space: nowrap; text-align: center;\">Valor Original</th><th ng-click=\"controller.ordenarResultado(\'\')\" style=\"white-space: nowrap; text-align: center;\">Data Operação</th><th ng-click=\"controller.ordenarResultado(\'\')\" style=\"white-space: nowrap; text-align: center;\">Valor Pagamento</th><th ng-click=\"controller.ordenarResultado(\'\')\" style=\"white-space: nowrap; text-align: left;\">Data Pagamento</th></tr></thead><tbody><tr ng-repeat=\"p in controller.registros\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-change=\"controller.calcularTotalSelecionado()\"></td><td style=\"white-space: nowrap;\">{{p.razaoSocial}}</td><td style=\"white-space: nowrap; text-align: left;\">{{p.numeroDocumento}}</td><td style=\"white-space: nowrap; text-align: center;\">{{p.dataVencimento}}</td><td style=\"white-space: nowrap; text-align: center;\">{{p.statusCobrancaTexto}}</td><td style=\"white-space: nowrap; text-align: right;\">{{p.valorPrevisto | currency:\'R$ \'}}</td><td style=\"white-space: nowrap; text-align: center;\">{{p.dataLancamento}}</td><td style=\"white-space: nowrap; text-align: center; width: 150px;\"><input type=\"text\" class=\"form-control w-100\" ng-model=\"p.valorPresente\" money-mask=\"\" ng-change=\"controller.calcularTotalSelecionado()\" style=\"text-align: right; font-size: 13px; height: 24px; padding: 2px 4px;\"></td><td style=\"white-space: nowrap; position: relative; text-align: left; width: 200px;\"><input type=\"text\" class=\"form-control w-100\" name=\"dataPagamento{{$index}}\" ng-model=\"p.dataPagamento\" ui-mask=\"99/99/9999\" placeholder=\"DD/MM/YYYY\" validar-data-dd-mm-yyyy=\"\" required=\"\" style=\"display: inline-block; font-size: 13px; height: 24px; padding: 2px 4px;\"><div class=\"text-danger\" style=\"position: absolute; left: 100px; top: 13px; font-size: 12px; white-space: nowrap;\" ng-if=\"formLancamentos[\'dataPagamento\'+$index].$error.validarDataDdMmYyyy && formLancamentos[\'dataPagamento\'+$index].$touched\">Data inválida</div></td></tr><tr><td colspan=\"2\"></td><td style=\"white-space: nowrap;\"><b>Qtde:</b> {{controller.registro.quantidade}}</td><td colspan=\"3\"></td><td style=\"white-space: nowrap; text-align: right\"><b>TOTAL</b></td><td style=\"white-space: nowrap; text-align: right\">{{controller.registro.valorTotal | currency:\'R$ \'}}</td></tr></tbody></table></form></div><div style=\"text-align: right; margin-top: 10px;\"><table width=\"100%\"><tr><td style=\"width: 10px;\">&nbsp;&nbsp;</td><td style=\"width: 1px;\"><button ng-click=\"controller.filtro.loteEstorno ? controller.estornarLote() : controller.enviarLote()\" class=\"btn\" ng-class=\"{ \'btn-success\': !controller.filtro.loteEstorno && controller.podeEnviarLote(), \'btn-warning\': controller.filtro.loteEstorno && controller.podeEnviarLote(), \'btn-danger\': !controller.podeEnviarLote() }\" style=\"width: 180px\" ng-disabled=\"formLancamentos.$invalid || !controller.podeEnviarLote()\" title=\"{{!controller.podeEnviarLote() ? \'Verifique: títulos selecionados, valores maiores que zero e datas válidas\' : (controller.filtro.loteEstorno ? \'Clique para estornar o lote\' : \'Clique para enviar o lote\')}}\"><span ng-if=\"controller.filtro.loteEstorno\">Estornar Lote</span> <span ng-if=\"!controller.filtro.loteEstorno\">Enviar Lote</span></button></td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/email/maladireta/cedente/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Cedente</h5><small class=\"font-bold\"><span ng-if=\"controller.filtroAtivoVmoney === \'ativo\'\">Filtro: Somente Cedentes Ativos</span> <span ng-if=\"controller.filtroAtivoVmoney === \'inativo\'\">Filtro: Somente Cedentes Inativos</span> <span ng-if=\"controller.filtroAtivoVmoney === \'ambos\'\">Filtro: Todos os Cedentes</span></small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-md-4\"><label class=\"col-form-label\">Pesquisar:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div><div class=\"col-md-3\"><label class=\"col-form-label\">Filtro Cedentes:</label><select class=\"form-control\" ng-model=\"controller.filtroAtivoVmoney\" ng-change=\"controller.filtrarPesquisa()\"><option value=\"ativo\">Ativo</option><option value=\"inativo\">Inativo</option><option value=\"ambos\">Ambos</option></select></div><div class=\"col-md-5\"><label class=\"col-form-label\">Filtro E-mail:</label><div style=\"margin-top: 5px;\"><label class=\"checkbox-inline i-checks\" style=\"padding-left: 0;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.filtroEmail.cobranca\" ng-change=\"controller.validarFiltroEmail()\"> Cobrança</label> <label class=\"checkbox-inline i-checks\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.filtroEmail.financeiro\" ng-change=\"controller.validarFiltroEmail()\"> Financeiro</label> <label class=\"checkbox-inline i-checks\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.filtroEmail.comercial\" ng-change=\"controller.validarFiltroEmail()\"> Comercial</label></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\" style=\"table-layout: fixed;\"><thead><tr><th style=\"width: 5%; text-align: center;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionarTodos\" ng-change=\"controller.toggleSelecionarTodos()\"></th><th style=\"width: 25%;\">Nome</th><th style=\"width: 20%;\">Nome Fantasia</th><th style=\"width: 10%;\">Cod.Vmoney</th><th style=\"width: 15%;\">CNPJ</th><th style=\"width: 17%;\">E-mail</th><th style=\"width: 8%;\">Status</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><th style=\"width: 5%; text-align: center;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-disabled=\"!p.email\"></th><td style=\"overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\">{{p.razaoSocial}}</td><td>{{p.nomeFantasia}}</td><td>{{p.codigoVmoney}}</td><td style=\"white-space: nowrap;\">{{p.cnpj}}</td><td style=\"word-break: break-all; font-size: 11px;\"><span ng-if=\"p.email\">{{p.email}}</span> <span ng-if=\"!p.email\" style=\"color: red;\">E-mail não cadastrado.</span></td><td><span ng-if=\"p.ativoVmoney\" class=\"label label-primary\">Ativo</span> <span ng-if=\"!p.ativoVmoney\" class=\"label label-danger\">Inativo</span></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.selecionar()\"><i class=\"fa fa-check\"></i> Selecionar</button></div>");
$templateCache.put("app/email/maladireta/digitar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Digitar E-mail</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"col-lg-12\"><form name=\"formDigitar\" class=\"form-horizontal ng-pristine ng-valid\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.registro.nome\" class=\"form-control\" style=\"text-transform: none;\" autocapitalize=\"on\" name=\"nome\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"email\" ng-model=\"controller.registro.email\" class=\"form-control\" name=\"email\" required=\"\" ng-pattern=\"/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/\"> <span class=\"text-danger\" ng-show=\"formDigitar.email.$error.required && formDigitar.email.$touched\">E-mail é obrigatório</span> <span class=\"text-danger\" ng-show=\"(formDigitar.email.$error.pattern || formDigitar.email.$error.email) && formDigitar.email.$touched\">Formato de e-mail inválido</span></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"formDigitar.$valid && controller.incluir()\" ng-disabled=\"formDigitar.$invalid\" title=\"{{formDigitar.$invalid ? \'Preencha corretamente o formulário\' : \'Incluir E-mail\'}}\"><i class=\"fa fa-plus\"></i> Incluir E-mail</button></div>");
$templateCache.put("app/email/maladireta/sacado/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Sacado</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-8\"><label class=\"col-form-label\">Pesquisar:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.registro.enderecoUf\" style=\"border: 0px solid red;\"></estado-select></div></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th></th><th>Nome</th><th>CNPJ</th><th>E-mail</th><th>Estado</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" ng-if=\"p.email != null && p.email != \'\'\"> <input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\" disabled=\"\" ng-if=\"p.email == null || p.email == \'\'\"></th><td>{{p.razaoSocial}}</td><td style=\"white-space: nowrap;\">{{p.cnpj}}</td><td ng-if=\"p.email != null && p.email != \'\'\">{{p.email}}</td><td ng-if=\"p.email == null || p.email == \'\'\" style=\"font-size: 11px; color: red;\">E-mail não cadastrado.</td><td style=\"white-space: nowrap;\">{{p.enderecoUf}}</td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.selecionar()\"><i class=\"fa fa-check\"></i> Selecionar</button></div>");
$templateCache.put("app/email/maladireta/historico/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Mala Direta</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>E-mail</a></li><li class=\"active\"><strong>Mala Direta</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Histórico</h5><div class=\"ibox-tools\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-2\"><div class=\"form-group\"><label class=\"col-form-label\">Período</label> <input type=\"date\" ng-model=\"controller.filtro.data\" class=\"form-control\"></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-success\" ng-click=\"controller.pesquisar()\">Consultar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px;\">Data</th><th>Usuário</th><th>Assunto</th><th>Destinatários</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td style=\"white-space: nowrap;\">{{p.data | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{p.userName}}</td><td>{{p.assunto}}</td><td>{{p.destinatarios}}</td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/email/template/campos/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Campos</h5><small class=\"font-bold\">Campos disponíveis para inclusão no template de e-mail.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">[@DATA]</label>: Data atual.<br><label class=\"col-form-label\">[@EMPRESA_NOME]</label>: Nome fantasia da empresa.<br><label class=\"col-form-label\">[@EMPRESA_CNPJ]</label>: CNPJ da empresa.<br><label class=\"col-form-label\">[@CEDENTE_NOME]</label>: Nome fantasia do cedente.<br><label class=\"col-form-label\">[@CEDENTE_CNPJ]</label>: CNPJ do cedente.<br></div></div><div class=\"col-sm-6\"><label class=\"col-form-label\">[@TABELA_REGISTROS]</label>: Tabela de registros.<br></div></div></div><div style=\"clear: both\"></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/email/template/listar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Templates</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Template</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 25%;\">Módulo</th><th style=\"width: 30%;\">Template</th><th>Assunto</th><th style=\"width: 15%;\">Agrupar Sacado</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.moduloId == \'3\' ? \'Comunicado para Cedentes\' : (p.moduloId == \'2\' ? \'Comunicado para Sacados\' : \'Gerador de Boletos\')}}</td><td>{{p.nome}}</td><td>{{p.assunto}}</td><td>{{p.agruparSacados ? \'Sim\' : \'Não\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/fluxo_aprovacao/configuracao/etapa/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Etapa</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li>Fluxo de Aprovação</li><li class=\"active\"><strong>Etapa</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.pesquisarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-arrow-right\"></i> Etapa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <input type=\"text\" ng-model=\"controller.registro.descricao\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.pesquisarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxCampos\', \'boxCampos\')\"><h5><i class=\"fa fa-arrow-right\"></i> Campos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxCampos\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxCampos\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 40%\">Descrição</th><th>Tipo</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.campos\"><td>{{p.descricao}}</td><td>{{p.tipoRespostaTexto}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i> Editar</a> <a ng-click=\"controller.excluir(p)\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-trash\"></i> Excluir</a></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarCampo()\"><span><i class=\"fa fa-plus\"></i> Adicionar campo</span></button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\" cg-busy=\"controller.salvarPromise\"><div class=\"row\"><div class=\"col-lg-6\"><button class=\"btn btn-md btn-warning\" type=\"button\" style=\"width: 180px\" ng-click=\"controller.voltar()\"><i class=\"fa fa-arrow-left\"></i> Voltar</button></div><div class=\"col-lg-6\" style=\"text-align: right\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 180px\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> {{ controller.isUpdate ? \'Atualizar\' : \'Salvar\' }}</button></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/analise/bordero/index.html","<style>\r\n    @media print {\r\n        body * { visibility: hidden; }\r\n        .bordero-print-area, .bordero-print-area * { visibility: visible; }\r\n        .bordero-print-area { position: absolute; left: 0; top: 0; width: 100%; padding: 1cm; }\r\n        .no-print { display: none !important; }\r\n    }\r\n    .bordero-total-row td { border-top: 2px solid #ccc !important; font-weight: bold; }\r\n</style><div class=\"modal-header no-print\"><h5 class=\"modal-title\">Posição de Títulos do Lote</h5><small class=\"font-bold\">Borderô detalhado dos títulos</small></div><div class=\"modal-body\" style=\"padding: 20px;\"><div class=\"bordero-print-area\"><div style=\"text-align: center; margin-bottom: 20px;\"><img ng-if=\"controller.logoUrl\" ng-src=\"{{controller.logoUrl}}\" style=\"max-height: 50px; max-width: 180px;\" alt=\"Logo Cliente\"><br><h2 style=\"color: #1a5276; font-weight: bold; margin-top: 10px;\">Posição de Títulos do Lote</h2></div><div class=\"row\" style=\"margin-bottom: 20px; text-align: center;\"><div class=\"col-sm-4\"><strong style=\"color: #888;\">CLIENTE</strong><br><span>{{controller.analise.cedenteNome}}</span></div><div class=\"col-sm-4\"><strong style=\"color: #888;\">LOTE</strong><br><span>{{controller.analise.integracaoId}}</span></div><div class=\"col-sm-4\"><strong style=\"color: #888;\">DATA</strong><br><span>{{controller.dataGeracao | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></div></div><h4 style=\"color: #1ab394; font-weight: bold;\">Títulos Aceitos ({{controller.titulosAceitos.length}})</h4><table class=\"table table-bordered\"><thead><tr><th>Documento</th><th>Sacado</th><th class=\"text-center\">Vencimento</th><th class=\"text-right\">Valor</th></tr></thead><tbody><tr ng-repeat=\"t in controller.titulosAceitos\"><td>{{t.numero}}</td><td>{{t.nomeSacado}}</td><td class=\"text-center\">{{t.dataVencimentoOriginal | date:\'dd/MM/yyyy\'}}</td><td class=\"text-right\">{{t.valor | currency:\'R$ \'}}</td></tr><tr ng-if=\"controller.titulosAceitos.length === 0\"><td colspan=\"4\" class=\"text-center\" style=\"color: #999;\">Nenhum título aceito</td></tr></tbody><tfoot><tr class=\"bordero-total-row\"><td colspan=\"3\" class=\"text-right\">Total Aceitos</td><td class=\"text-right\">{{controller.totalAceitos | currency:\'R$ \'}}</td></tr></tfoot></table><h4 style=\"color: #ed5565; font-weight: bold; margin-top: 25px;\">Títulos Recusados ({{controller.titulosRecusados.length}})</h4><table class=\"table table-bordered\"><thead><tr><th>Documento</th><th>Sacado</th><th class=\"text-center\">Vencimento</th><th class=\"text-right\">Valor</th></tr></thead><tbody><tr ng-repeat=\"t in controller.titulosRecusados\"><td>{{t.numero}}</td><td>{{t.nomeSacado}}</td><td class=\"text-center\">{{t.dataVencimentoOriginal | date:\'dd/MM/yyyy\'}}</td><td class=\"text-right\">{{t.valor | currency:\'R$ \'}}</td></tr><tr ng-if=\"controller.titulosRecusados.length === 0\"><td colspan=\"4\" class=\"text-center\" style=\"color: #999;\">Nenhum título recusado</td></tr></tbody><tfoot><tr class=\"bordero-total-row\"><td colspan=\"3\" class=\"text-right\">Total Recusados</td><td class=\"text-right\">{{controller.totalRecusados | currency:\'R$ \'}}</td></tr></tfoot></table><div style=\"border-top: 1px solid #ccc; margin-top: 15px; padding-top: 10px; font-weight: bold; text-align: right;\">Total de Títulos: {{controller.analise.titulos.length}} &nbsp;&nbsp;|&nbsp;&nbsp; Valor Total: {{(controller.totalAceitos + controller.totalRecusados) | currency:\'R$ \'}}</div></div></div><div class=\"modal-footer no-print\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"controller.fechar()\"><i class=\"fa fa-times\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.imprimir()\"><i class=\"fa fa-print\"></i> Exportar / Imprimir</button></div>");
$templateCache.put("app/invoice/analise/parecer/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Parecer da Análise</h5><small class=\"font-bold\">Registre observações sobre esta análise. O nome do usuário fica salvo junto com cada parecer.</small></div><div class=\"modal-body\" style=\"padding: 20px;\"><div class=\"form-group\" ng-if=\"controller.podeCriarNovoParecer()\"><label>Novo parecer</label> <textarea class=\"form-control\" rows=\"6\" ng-model=\"controller.novoParecer\" placeholder=\"Digite seu parecer sobre esta análise...\"></textarea><div class=\"text-right\" style=\"margin-top: 8px;\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.salvar()\" ng-disabled=\"!controller.novoParecer || !controller.novoParecer.trim() || controller.isSaving\"><i class=\"fa fa-check\"></i> {{controller.isSaving ? \'Salvando...\' : \'Salvar Parecer\'}}</button></div></div><div ng-if=\"!controller.podeCriarNovoParecer()\" class=\"alert alert-warning\" style=\"font-size: 12px;\">Você já tem um parecer registrado nesta análise em aberto — edite-o abaixo em vez de criar um novo.</div><hr><label>Histórico ({{controller.pareceres.length}})</label><div class=\"table-responsive\" style=\"max-height: 320px; overflow-y: auto;\"><table class=\"table table-bordered\" ng-if=\"controller.pareceres.length > 0\"><tbody><tr ng-repeat=\"p in controller.pareceres\"><td><div style=\"display: flex; justify-content: space-between; margin-bottom: 4px;\"><strong style=\"color: #6f42c1;\">{{p.nomeUsuario}}</strong> <span><span style=\"color: #999; font-size: 11px;\">{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</span> <a href=\"\" ng-if=\"p.podeEditar && controller.editandoId !== p.id\" ng-click=\"controller.iniciarEdicao(p)\" title=\"Editar\" style=\"margin-left: 8px;\"><i class=\"fa fa-pencil\"></i></a> <a href=\"\" ng-if=\"p.podeEditar && controller.editandoId !== p.id\" ng-click=\"controller.excluir(p)\" title=\"Excluir\" style=\"margin-left: 6px; color: #d9534f;\"><i class=\"fa fa-trash\"></i></a></span></div><div ng-if=\"controller.editandoId !== p.id\" style=\"white-space: pre-wrap;\">{{p.parecerAnalise}}</div><div ng-if=\"controller.editandoId === p.id\"><textarea class=\"form-control\" rows=\"6\" ng-model=\"controller.textoEdicao\"></textarea><div class=\"text-right\" style=\"margin-top: 6px;\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"controller.cancelarEdicao()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"controller.salvarEdicao()\" ng-disabled=\"!controller.textoEdicao || !controller.textoEdicao.trim() || controller.isSavingEdicao\">{{controller.isSavingEdicao ? \'Salvando...\' : \'Salvar\'}}</button></div></div></td></tr></tbody></table><div ng-if=\"controller.pareceres.length === 0\" class=\"text-center\" style=\"padding: 20px; color: #999;\">Nenhum parecer registrado ainda.</div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"controller.fechar()\"><i class=\"fa fa-times\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/analise/relato/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Relato</h5><small class=\"font-bold\">{{controller.subtitulo}}</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-12\"><iframe ng-src=\"{{controller.fileDocumento}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-check\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/antecipacao/modal/consultar_titulos.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Títulos</h5><small class=\"font-bold\">Lista de títulos da proposta selecionada.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nº NFe</th><th style=\"white-space: nowrap;\">Nº Título</th><th>Origem</th><th>Sacado</th><th>Vencimento</th><th style=\"white-space: nowrap;\">Importação XML</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.titulos\"><td>{{p.numero}}</td><td>{{p.titulo}}</td><td style=\"text-align: center;\"><i ng-if=\"p.tipoOrigem == 0\" class=\"fa fa-certificate\" title=\"Nfe\"></i> <i ng-if=\"p.tipoOrigem == 1\" class=\"fa fa-file-zip-o\" title=\"Lote Nfe\"></i> <i ng-if=\"p.tipoOrigem == 2\" class=\"fa fa-user\" title=\"Digitado\"></i> <i ng-if=\"p.tipoOrigem == 3\" class=\"fa fa-cog\" title=\"CNAB\"></i></td><td>{{p.sacado}}</td><td>{{p.dataVencimento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{p.dataImportacaoTitulo | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/antecipacao/modal/proposta.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Enviar Proposta</h5><small class=\"font-bold\">Faça o envio da sua proposta para a antecipação selecionada.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px; background-color: white;\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" min=\"0\" max=\"99999\" ng-model=\"controller.proposta.valor\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Fator %</label> <input type=\"number\" min=\"0\" max=\"99\" ng-model=\"controller.proposta.fator\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Banco</label> <input type=\"text\" maxlength=\"10\" ng-model=\"controller.proposta.banco\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Agência</label> <input type=\"text\" maxlength=\"5\" ng-model=\"controller.proposta.agencia\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Conta</label> <input type=\"text\" maxlength=\"8\" ng-model=\"controller.proposta.conta\" class=\"form-control inputDisabledModal\"></div></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.enviar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/invoice/fluxo/analise/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Fluxo de Aprovação</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Operações</a></li><li class=\"active\"><strong>Fluxo de Aprovação</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\" cg-busy=\"controller.listarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Etapas</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 570px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 40px\">#</th><th>Etapa</th><th>Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.etapas\"><td>{{p.sequencial}}</td><td>{{p.descricao}}</td><td style=\"width: 200px\"><button class=\"btn btn-xs btn-block\" ng-class=\"p.situacaoAtual == 0 || p.situacaoAtual == 1 || p.situacaoAtual == 2 ? \'btn-warning\' : (p.situacaoAtual == 3 ? \'btn-success\' : \'btn-primary\')\">{{p.situacaoAtualTexto}}</button></td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-if=\"p.situacaoAtual == 4\" style=\"width: 100px\" ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button> <button ng-if=\"p.situacaoAtual == 1\" style=\"width: 100px\" ng-click=\"controller.consultar(p)\" class=\"btn btn-warning btn-xs\"><i class=\"fa fa-edit\"></i> Preencher</button> <button ng-if=\"p.situacaoAtual == 2\" style=\"width: 100px\" ng-click=\"controller.consultar(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-check\"></i> Aprovar</button></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/digitacao/cadastro/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Título</h5></div><div class=\"modal-body\" cg-busy=\"controller.consultaTipoDocumentoPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <button class=\"btn btn-block btn-default\" style=\"font-size: 12px;\" ng-click=\"controller.selecionarCedenteModal()\">{{ controller.registro.cedente == null ? \'Selecionar Cedente\' : controller.registro.cedente.razaoSocial }}</button></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nº do Título</label> <input type=\"text\" maxlength=\"10\" ng-model=\"controller.registro.numero\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <button class=\"btn btn-block btn-default\" style=\"font-size: 12px;\" ng-click=\"controller.selecionarSacadoModal()\">{{ controller.registro.sacado == null ? \'Selecionar Sacado\' : controller.registro.sacado.razaoSocial }}</button></div></div><div class=\"col-sm-6\" ng-if=\"controller.tiposDocumento != null\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Documento {{controller.registro.tipoDocumento.descricao}}</label><select class=\"form-control\" ng-model=\"controller.registro.tipoDocumento\" ng-change=\"controller.tipoDocumentoEscolhido()\" ng-options=\"item as item.descricao for item in controller.tiposDocumento track by item.id\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Emissão</label> <input type=\"date\" ng-model=\"controller.registro.dataRecebimento\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vencimento</label> <input type=\"date\" ng-model=\"controller.registro.dataVencimento\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor do Título</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.valor\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\" ng-if=\"controller.registro.tipoDocumento.descricao.toLowerCase() == \'cheque\'\"><div class=\"form-group\"><label class=\"col-form-label\">Banco do Cheque</label><select class=\"form-control\" ng-model=\"controller.registro.bancoCheque\" ng-options=\"banco.codigo as banco.nome for banco in controller.bancos\" ng-change=\"controller.bancoChequeEscolhido()\"></select></div></div><div class=\"col-sm-6\" ng-if=\"controller.registro.tipoDocumento.descricao.toLowerCase() == \'cheque\'\"><div class=\"form-group\"><label class=\"col-form-label\">Crc-7</label> <input type=\"text\" ng-model=\"controller.registro.crc7\" class=\"form-control\"></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoDocumento.descricao.toLowerCase() == \'duplicata\'\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Nota Fiscal</label> <input type=\"text\" ng-model=\"controller.registro.notaFiscalNumero\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Série</label> <input type=\"text\" maxlength=\"2\" ng-model=\"controller.registro.notaFiscalSerie\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Chave Nfe</label> <input type=\"text\" ng-model=\"controller.registro.notaFiscalChave\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">D+</label> <input type=\"text\" ng-model=\"controller.registro.dias\" class=\"form-control\"></div></div><div class=\"col-sm-3\" ng-if=\"controller.isOperacaoMoneyNow == 0\"><div class=\"form-group\"><label class=\"col-form-label\">Cobrança</label><select class=\"form-control\" ng-model=\"controller.registro.bancoCarteira\"><option value=\"B\">Banco</option><option value=\"C\">Carteira</option></select></div></div><div class=\"col-sm-3\" ng-if=\"controller.isOperacaoMoneyNow == 1\"><div class=\"form-group\"><label class=\"col-form-label\">C/C Resumida</label> <input type=\"text\" ng-model=\"controller.registro.ccresumida\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Boleto Especial</label><select class=\"form-control\" ng-model=\"controller.registro.boletoEspecial\"><option value=\"N\">Não</option><option value=\"S\">Sim</option></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Cobrança Expressa</label><select class=\"form-control\" ng-model=\"controller.registro.cobrancaExpressa\"><option value=\"N\">Não</option><option value=\"S\">Sim</option></select></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" style=\"width: 200px;\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Incluir Título</button></div>");
$templateCache.put("app/invoice/operacao/analise/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Análise da Operação</h2><ol class=\"breadcrumb\"><li class=\"active\"><strong>Operação Nº {{controller.operacao.antecipacao.id}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultaPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxCedente\', \'boxCedente\')\"><h5><i class=\"fa fa-arrow-right\"></i> Borderô</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxCedente\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxCedente\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Cedente</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.operacao.antecipacao.cedente.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" disabled=\"\" mask=\"99.999.999/9999-99\" ng-model=\"controller.operacao.antecipacao.cedente.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Operação</label><select class=\"form-control\" ng-model=\"controller.operacao.antecipacao.tipo\"><option ng-value=\"0\">Normal</option><option ng-value=\"8\">Salário Sob Demanda</option></select></div></div><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Originador</label><select class=\"form-control\" ng-change=\"controller.listarContasOriginador()\" ng-model=\"controller.originador\" ng-options=\'item as (item.cnpj + \" - \" + item.nome + \" (\" + item.tipoText + \")\") for item in controller.originadores\'></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Conta Bancária</label><select class=\"form-control\" ng-model=\"controller.conta\" ng-options=\'item as (item.banco + \" - \" + \"Ag: \" + item.agencia + \" Conta: \" + item.numero + \" - Carteira: \" + item.numeroCarteira) for item in controller.contas\'></select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSacados\', \'boxSacados\')\"><h5><i class=\"fa fa-arrow-right\"></i> Sacados</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxSacados\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><div style=\"overflow: auto;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"width: 10px;\">#</th><th class=\"white-bg\">Nome/Razão Social</th><th class=\"white-bg\">CPF/CNPJ</th></tr></thead><tbody><tr ng-repeat=\"data in controller.operacao.sacados\"><td class=\"ng-binding\">{{ data.id }}</td><td class=\"ng-binding\">{{ data.razaoSocial }}</td><td class=\"ng-binding\">{{ data.cnpj }}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-arrow-right\"></i> Títulos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><div style=\"overflow: auto;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Sacado</th><th class=\"white-bg\">CPF/CNPJ</th><th class=\"white-bg\">Nº Título</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th></tr></thead><tbody><tr ng-repeat=\"data in controller.operacao.antecipacao.titulos\"><td class=\"ng-binding\">{{ data.titulo.sacado.razaoSocial }}</td><td class=\"ng-binding\">{{ data.titulo.sacado.cnpj }}</td><td class=\"ng-binding\">{{ data.titulo.numero }}</td><td class=\"ng-binding\">{{ data.titulo.dataVencimento | date:\'dd/MM/yyyy\' }}</td><td class=\"ng-binding\">{{ data.titulo.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.enviarNegociacao()\"><i class=\"fa fa-arrow-right\"></i> Finalizar Análise</button></div></div></div></div></div>");
$templateCache.put("app/invoice/operacao/titulos/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Títulos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">NFe\'s</a></li><li class=\"active\"><strong>Estoque de Títulos</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.listarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">N° NFe</label> <input type=\"text\" ng-model=\"controller.filtro.nfe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Título</label> <input type=\"text\" ng-model=\"controller.filtro.titulo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" ng-model=\"controller.filtro.fornecedor\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <input type=\"text\" ng-model=\"controller.filtro.sacado\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Vencimento</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data Inclusão</label> <input type=\"date\" ng-model=\"controller.filtro.dataCadastro\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" ng-model=\"controller.filtro.valorDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"number\" ng-model=\"controller.filtro.valorAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Status</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisaStatus()\"><option ng-value=\"6\">Consultando SEFAZ</option><option ng-value=\"1\">Disponíveis</option><option ng-value=\"4\">CFOP Bloqueado</option><option ng-value=\"5\">Nfe Cancelada</option><option ng-value=\"2\">Em negociação</option><option ng-value=\"3\">Já negociados</option></select></div></div></div><div class=\"row\" style=\"display: none;\"><div class=\"col-sm-12\"><button class=\"btn btn-success pull-right\" ng-click=\"controller.pesquisar()\"><span class=\"fa fa-search\"></span> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Títulos</h5><div class=\"ibox-tools\"><a ng-click=\"controller.listar()\"><i class=\"fa fa-refresh\" style=\"color: white; font-size: 22px;\"></i></a></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div><table class=\"table table-bordered\" style=\"margin-bottom: 0px;\"><thead><tr><th style=\"width: 1px;\"></th><th ng-click=\"controller.ordenarResultado(\'nfe\')\" style=\"white-space: nowrap;\">Nº NFe<i ng-if=\"controller.orderSelected == \'nfe\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"white-space: nowrap;\">Nº Título<i ng-if=\"controller.orderSelected == \'titulo\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th style=\"white-space: nowrap;\">NFe</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado<i ng-if=\"controller.orderSelected == \'sacado\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'fornecedor\')\">Fornecedor<i ng-if=\"controller.orderSelected == \'fornecedor\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'datacadastro\')\" style=\"white-space: nowrap;\">Dt. Inclusão<i ng-if=\"controller.orderSelected == \'datacadastro\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\" style=\"white-space: nowrap;\">Dt. Vencimento<i ng-if=\"controller.orderSelected == \'vencimento\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'valor\')\">Valor<i ng-if=\"controller.orderSelected == \'valor\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th>Status</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"width: 1px;\"><input ng-if=\"p.status == 1 && (p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null)\" icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"p.selecionadoAntecipar\"> <input ng-if=\"p.status != 1\" disabled=\"\" icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"p.selecionadoAntecipar\"></td><td>{{p.numero}}</td><td>{{p.titulo}}</td><td style=\"text-align: center;\"><i ng-if=\"p.tipoDocumento == null\" class=\"fa fa-check\" style=\"color: green;\"></i> <i ng-if=\"p.tipoDocumento != null\" class=\"fa fa-times\" style=\"color: red;\"></i></td><td title=\"{{p.sacado}}\">{{p.sacado | limitTo: 30 }}{{p.sacado.length > 30 ? \'...\' : \'\'}}</td><td title=\"{{p.cedente}}\">{{p.cedente | limitTo: 35 }}{{p.cedente.length > 35 ? \'...\' : \'\'}}</td><td>{{p.dataCadastro | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{p.dataVencimentoDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td><td ng-if=\"p.status == 1\" style=\"width: 1px;\"><button class=\"btn btn-danger btn-xs btn-block\" ng-if=\"p.isPendenteSefaz\">Consultando SEFAZ</button> <button class=\"btn btn-danger btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe == \'101\'\">Nfe Cancelada</button> <button class=\"btn btn-danger btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.cfopBloqueado != null\" title=\"{{p.cfopBloqueado}}\">CFOP Bloqueado</button> <button class=\"btn btn-success btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null && p.isPossuiCartaoCorrecao == false\">Disponível</button> <button class=\"btn btn-primary btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null && p.isPossuiCartaoCorrecao == true\">Disponível C/C</button></td><td ng-if=\"p.status == 2\" style=\"width: 1px;\"><button class=\"btn btn-warning btn-xs\">EM NEGOCIAÇÃO</button></td><td ng-if=\"p.status == 3\" style=\"width: 1px;\"><button class=\"btn btn-primary btn-xs\">JÁ NEGOCIADO</button></td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><button class=\"btn btn-warning btn-xs\" ng-click=\"controller.consultarTitulo(p)\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div><div><span style=\"font-weight: bold;\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}} <span ng-if=\"controller.total.valorTotal > 0\">em {{controller.total.quantidade}} título{{(controller.total.quantidade > 1 ? \'s \' : \'\')}} selecionado{{(controller.total.quantidade > 1 ? \'s \' : \'\')}}</span></span></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\"><button ng-click=\"controller.marcarTodos()\" class=\"btn btn-md btn-primary\" type=\"button\"><i class=\"fa fa-check-square\"></i> MARCAR TODOS</button> <button ng-click=\"controller.desmarcarTodos()\" class=\"btn btn-md btn-warning\" type=\"button\"><i class=\"fa fa-minus-square\"></i> DESMARCAR TODOS</button></div><div class=\"col-lg-6\" style=\"text-align: right;\"><button ng-click=\"controller.validarEPrevenir($event)\" class=\"btn btn-md btn-success\" type=\"button\"><i class=\"fa fa-arrow-right\"></i> ANTECIPAR SELECIONADOS</button></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/operacao/negociacao/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Negociação</h2><ol class=\"breadcrumb\"><li class=\"active\"><strong>Operação Nº {{controller.operacao.id}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-6\"><div><div class=\"ibox float-e-margins\" cg-busy=\"controller.simularTaxasPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Taxas e Tarifas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Taxa de operação</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.operacao.taxaOperacao\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Ad Valorem</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.operacao.taxaAdValorem\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">%</span></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa de cobrança</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.operacao.tarifaCobranca\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa aval. crédito (TAC)</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.operacao.tarifaAvaliacaoCredito\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa consulta de crédito</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.operacao.tarifaConsultaCredito\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa TED</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.operacao.tarifaTED\" class=\"form-control inputDisabledModal\"> <span class=\"input-group-addon\">$</span></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><button class=\"btn btn-success full-width\" ng-click=\"controller.simularTaxas()\"><i class=\"fa fa-refresh\"></i> Atualizar</button></div></div></div></div></div></div><div class=\"col-lg-6\"><div><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultaPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Negociação para Fechamento</h5></div><div class=\"ibox-content\"><div class=\"row\"></div><div class=\"row\"><div class=\"col-sm-12\"><div style=\"overflow: auto;\"><label class=\"col-form-label\">Resumo</label><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Tipo</th><th class=\"white-bg\">Valor</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\">Face</td><td class=\"ng-binding\" style=\"text-align: right\">{{ controller.operacao.totalFace | currency:\'R$ \' }}</td></tr><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\">Deságio</td><td class=\"ng-binding\" style=\"text-align: right\">{{ controller.operacao.totalDesagio | currency:\'R$ \' }}</td></tr><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\">Compra</td><td class=\"ng-binding\" style=\"text-align: right\">{{ controller.operacao.totalCompra | currency:\'R$ \' }}</td></tr><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\">Ad Valorem</td><td class=\"ng-binding\" style=\"text-align: right\">{{ controller.operacao.totalAdValorem | currency:\'R$ \' }}</td></tr><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\">IOF</td><td class=\"ng-binding\" style=\"text-align: right\">{{ controller.operacao.totalIOF | currency:\'R$ \' }}</td></tr><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\">ISS</td><td class=\"ng-binding\" style=\"text-align: right\">{{ controller.operacao.totalISS | currency:\'R$ \' }}</td></tr><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\">Despesas</td><td class=\"ng-binding\" style=\"text-align: right\">{{ controller.operacao.totalDespesas | currency:\'R$ \' }}</td></tr><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\">Valor Líquido</td><td class=\"ng-binding\" style=\"text-align: right\">{{ controller.operacao.totalLiquido | currency:\'R$ \' }}</td></tr><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\"><a ng-click=\"controller.acertoContaGrafica()\">Débitos e Créditos</a></td><td class=\"ng-binding\" style=\"text-align: right\" ng-style=\"controller.totalDebitosCreditos < 0 && {\'color\':\'red\'}\">{{ controller.totalDebitosCreditos | currency:\'R$ \' }}</td></tr><tr class=\"ng-scope\" style=\"\"><td class=\"ng-binding\">Líquido Liberado</td><td class=\"ng-binding\" style=\"text-align: right\">{{ controller.operacao.totalLiquidoCalculado | currency:\'R$ \' }}</td></tr></tbody></table>Prazo Médio Ponderado: {{controller.operacao.prazoMedioPonderado | number:2}} dias</div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFormaCredito\', \'boxFormaCredito\')\"><h5><i class=\"fa fa-dollar\"></i> Formas de Crédito</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFormaCredito\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFormaCredito\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><div style=\"overflow: auto;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"width: 200px;\">Tipo</th><th class=\"white-bg\">Detalhe</th><th class=\"white-bg\">Valor</th></tr></thead><tbody><tr ng-repeat=\"p in controller.formasCredito\"><td class=\"ng-binding\">{{ p.tipoTexto }}</td><td class=\"ng-binding\">{{ p.detalhe }}</td><td class=\"ng-binding\">{{ p.valor | currency:\'R$ \' }}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.removerFormaCredito(p)\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><button class=\"btn btn-sm btn-success\" type=\"button\" ng-click=\"controller.adicionarFormaCredito()\"><i class=\"fa fa-plus\"></i> Adicionar Forma</button></div></div><div class=\"row\" style=\"padding-top: 10px;\" ng-if=\"controller.formasCredito.length > 0\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.formaCreditoValor | currency:\'R$ \' }}\" class=\"form-control\"> <span class=\"input-group-addon\">$</span></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Saldo</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.formaCreditoSaldo | currency:\'R$ \' }}\" class=\"form-control\"> <span class=\"input-group-addon\">$</span></div></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-tags\"></i> Títulos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><div style=\"overflow: auto;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Sacado</th><th class=\"white-bg\">CNPJ</th><th class=\"white-bg\">Título</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th></tr></thead><tbody><tr ng-repeat=\"data in controller.operacao.titulos\"><td class=\"ng-binding\">{{ data.titulo.sacado.razaoSocial }}</td><td class=\"ng-binding\">{{ data.titulo.sacado.cnpj }}</td><td class=\"ng-binding\">{{ data.titulo.numero }}</td><td class=\"ng-binding\">{{ data.titulo.dataVencimento | date:\'dd/MM/yyyy\' }}</td><td class=\"ng-binding\">{{ data.titulo.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.aprovarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.enviarNegociacao()\"><i class=\"fa fa-arrow-right\"></i> Finalizar Negociação</button></div></div></div></div></div>");
$templateCache.put("app/invoice/operacao/formalizacao/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Formalização</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Operação</a></li><li class=\"active\"><strong>Formalização</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div><div class=\"row\" ng-if=\"controller.fileTermoAditivo != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTermoAditivo\', \'boxTermoAditivo\')\"><h5><i class=\"fa fa-file\"></i> Termo Aditivo</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTermoAditivo\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxTermoAditivo\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.fileTermoAditivo}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fileTermoCessao != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTermoCessao\', \'boxTermoCessao\')\"><h5><i class=\"fa fa-file\"></i> Termo de Cessão</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTermoCessao\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxTermoCessao\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.fileTermoCessao}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fileNotaPromissoria != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxNotaPromissoria\', \'boxNotaPromissoria\')\"><h5><i class=\"fa fa-file\"></i> Nota Promissória</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxNotaPromissoria\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxNotaPromissoria\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.fileNotaPromissoria}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><a ng-click=\"controller.enviar()\" class=\"btn btn-md btn-success\" type=\"button\"><i class=\"fa fa-arrow-right\"></i> Finalizar Formalização</a></div></div></div></div></div></div></div></div>");
$templateCache.put("app/old/agente_financeiro/antecipacoes/disponiveis.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Antecipações Disponíveis</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Agente Financeiro</a></li><li><a>Antecipações</a></li><li class=\"active\"><strong>Disponíveis</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" ng-model=\"controller.filtro.fornecedor\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número da Antecipação</label> <input type=\"number\" ng-model=\"controller.filtro.numeroAntecipacao\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Status</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisa()\"><option value=\"\">Todos</option><option value=\"2\">Aguardando Proposta IC (Instituição Credora)</option><option value=\"3\">Aguardando Aprovação do Fornecedor (100%)</option><option value=\"6\">Aguardando Aprovação do Fornecedor (Parcial)</option><option value=\"4\">Aguardando Formalização</option><option value=\"8\">Aguardando Assinatura</option><option value=\"5\">Recusada pela IC</option><option value=\"7\">Recusada pelo Fornecedor</option><option value=\"9\">Concluído</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Solicitação</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" ng-model=\"controller.filtro.valorDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"number\" ng-model=\"controller.filtro.valorAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Disponíveis</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 570px;\"><table class=\"table table-bordered\"><thead><tr><th>#</th><th>Data da Solicitação</th><th>Fornecedor</th><th style=\"width: 1px;\">Status</th><th>Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.numero}}</td><td>{{p.data | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.fornecedor}}</td><td ng-if=\"p.status == 1\"><button class=\"btn btn-success btn-xs\">Aguardando Envio para IC</button></td><td ng-if=\"p.status == 2\"><button class=\"btn btn-success btn-xs\">Aguardando Proposta IC</button></td><td ng-if=\"p.status == 3\"><button class=\"btn btn-blueviolet btn-xs\">Aguardando Aprovação do Fornecedor</button></td><td ng-if=\"p.status == 6\"><button class=\"btn btn-blueviolet btn-xs\">Aguardando Aprovação do Fornecedor</button></td><td ng-if=\"p.status == 4\"><button class=\"btn btn-primary btn-xs\">Aguardando Formalização</button></td><td ng-if=\"p.status == 8\"><button class=\"btn btn-primary btn-xs\">Aguardando Assinatura</button></td><td ng-if=\"p.status == 5\"><button class=\"btn btn-danger btn-xs\">Recusada pela IC</button></td><td ng-if=\"p.status == 7\"><button class=\"btn btn-danger btn-xs\">Recusada pelo Fornecedor</button></td><td ng-if=\"p.status == 9\"><button class=\"btn btn-primary btn-xs\">Concluído</button></td><td>{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-click=\"controller.titulos(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Títulos</button> <button ng-click=\"controller.liberarTitulos(p)\" ng-if=\"p.status == 7 || p.status == 5\" class=\"btn btn-warning btn-xs\"><i class=\"fa fa-retweet\"></i> Liberar Títulos</button></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/old/agente_financeiro/proposta/minhas_propostas.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Minhas Propostas</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Agente Financeiro</a></li><li><a>Proposta</a></li><li class=\"active\"><strong>Minhas Propostas</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Recebíveis</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 570px;\"><table class=\"table table-bordered\"><thead><tr><th>Status</th><th>Fornecedor</th><th>Nº Antecipação</th><th>Valor</th><th>Fator</th><th>Banco</th><th>Conta</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td style=\"width: 1px;\"><a href=\"#/index/consultar_titulo/{{ p.viewId }}\" class=\"btn btn-warning btn-xs\">EM ANÁLISE</a></td><td>SACADO TESTE 01</td><td>10025001</td><td>R$ 20.500,00</td><td>0,02%</td><td>2134</td><td>234512</td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/old/cadastro/fornecedor/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Fornecedor</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Fornecedor</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"text\" ng-model=\"controller.filtro.codigo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Cadastro</label> <input type=\"date\" ng-model=\"controller.filtro.dataCadastroDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.dataCadastroAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisa()\"><option value=\"1\">Ativo</option><option value=\"0\">Inativo</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Fornecedores</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th ng-click=\"controller.ordenarResultado(\'numero\')\" style=\"width: 10px;\">#</th><th ng-click=\"controller.ordenarResultado(\'razaosocial\')\">Razão Social</th><th ng-click=\"controller.ordenarResultado(\'cnpj\')\">CNPJ</th><th ng-click=\"controller.ordenarResultado(\'datacadastro\')\">Data de cadastro</th><th ng-click=\"controller.ordenarResultado(\'status\')\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td>Ativo</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/old/cadastro/sacado/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button ng-click=\"controller.cadastrar()\" class=\"btn btn-primary\"><i class=\"fa fa-plus\"></i> Cadastrar Novo Sacado</button></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"text\" ng-model=\"controller.filtro.codigo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Sacados</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px;\">#</th><th>Razão Social</th><th>CNPJ</th><th>Data de cadastro</th><th>Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td>Ativo</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/old/financeiro/gestao_contas/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Gestão de Contas</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Gestão de Contas</a></li><li class=\"active\"><strong>Analisar</strong></li></ol></div><div class=\"col-lg-3\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" ng-model=\"controller.filtro.fornecedor\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <input type=\"text\" ng-model=\"controller.filtro.sacado\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Movimento</label> <input type=\"date\" ng-model=\"controller.filtro.dataMovimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.dataMovimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisa()\"><option value=\"1\">Pendente</option><option value=\"2\">Confirmado</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Créditos Recebidos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th ng-click=\"controller.ordenarResultado(\'numero\')\" style=\"width: 10px;\">#</th><th ng-click=\"controller.ordenarResultado(\'datacredito\')\" style=\"white-space: nowrap; width: 140px\">Data do Movimento</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado</th><th ng-click=\"controller.ordenarResultado(\'fornecedor\')\">Fornecedor</th><th ng-click=\"controller.ordenarResultado(\'conta\')\">Agência / Conta</th><th ng-click=\"controller.ordenarResultado(\'valor\')\">Valor</th><th ng-click=\"controller.ordenarResultado(\'status\')\" style=\"white-space: nowrap; width: 160px\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.id}}</td><td>{{p.dataMovimento | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{p.sacado == null ? \'Sacado não cadastrado (\' + p.remetenteDocumento + \')\' : p.sacado.razaoSocial}}</td><td>{{p.fornecedor == null ? \'Fornecedor não cadastrado (\' + p.contaCnpj + \')\' : p.fornecedor.razaoSocial}}</td><td>{{\'Ag.: \' + p.contaAgencia + \' C/C: \' + p.contaPagamento}}</td><td>{{p.valorMovimento | currency:\'R$ \'}}</td><td>{{p.status == 1 ? \'Pendente\' : \'Confirmado\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-if=\"p.status == 1\" ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"atendimentoController.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:atendimentoController.pager.currentPage === 1}\"><a ng-click=\"atendimentoController.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === 1}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in atendimentoController.pager.pages\" ng-class=\"{active:atendimentoController.pager.currentPage === page}\"><a ng-click=\"atendimentoController.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === atendimentoController.pager.totalPages}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === atendimentoController.pager.totalPages}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/old/cadastro/intermediador/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Intermediador</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Intermediador</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button ng-click=\"controller.cadastrar()\" class=\"btn btn-primary\"><i class=\"fa fa-plus\"></i> Cadastrar Novo Intermediador</button></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"text\" ng-model=\"controller.filtro.codigo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Intermediadores</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px;\">#</th><th>Razão Social</th><th>CNPJ</th><th>Data de cadastro</th><th>Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.id}}</td><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td>Ativo</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"atendimentoController.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:atendimentoController.pager.currentPage === 1}\"><a ng-click=\"atendimentoController.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === 1}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in atendimentoController.pager.pages\" ng-class=\"{active:atendimentoController.pager.currentPage === page}\"><a ng-click=\"atendimentoController.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === atendimentoController.pager.totalPages}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === atendimentoController.pager.totalPages}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/old/fornecedor/analisar_cadastro/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Análise do Cadastro do Fornecedor</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Fornecedor</a></li><li class=\"active\"><strong>Análise</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row m-b\"><div class=\"col-lg-2\"><button class=\"btn btn-block\" ng-class=\"controller.fornecedor.statusCadastro <= 1 ? \'btn-warning\' : (controller.fornecedor.statusCadastro > 1 ? \'btn-primary\' : \'btn-default\')\">PREENCH. DO CADASTRO<br><small>Fornecedor</small></button></div><div class=\"col-lg-2\"><button class=\"btn btn-block\" ng-class=\"controller.fornecedor.statusCadastro == 2 ? \'btn-warning\' : (controller.fornecedor.statusCadastro > 2 ? \'btn-primary\' : \'btn-default\')\">ANÁLISE DO CADASTRO<br><small>Instituição Credora</small></button></div><div class=\"col-lg-2\"><button class=\"btn btn-block\" ng-class=\"controller.fornecedor.statusCadastro == 3 ? \'btn-warning\' : (controller.fornecedor.statusCadastro > 3 ? \'btn-primary\' : \'btn-default\')\">ASSINATURA DIGITAL<br><small>Fornecedor</small></button></div><div class=\"col-lg-2\"><button class=\"btn btn-block\" ng-class=\"controller.fornecedor.statusCadastro == 4 ? \'btn-warning\' : (controller.fornecedor.statusCadastro > 4 ? \'btn-primary\' : \'btn-default\')\">ABERTURA DE CONTA<br><small>Instituição Bancária</small></button></div><div class=\"col-lg-2\"><button class=\"btn btn-block btn-default\">CADASTRO APROVADO<br><small>Fornecedor</small></button></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-bank\"></i> Dados do Fornecedor</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.fornecedor.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.nomeFantasia\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" disabled=\"\" mask=\"99.999.999/9999-99\" ng-model=\"controller.fornecedor.cnpj\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.fornecedor.complemento.emailCadastro\" class=\"form-control normal-text inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Fundação</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.dataFundacao\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Capital Social</label> <input type=\"text\" ui-number-mask=\"\" ng-model=\"controller.fornecedor.complemento.capitalSocial\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Contato Secundário</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.nomeContatoSecundario\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail do Contato Secundário</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.emailContatoSecundario\" class=\"form-control normal-text inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Ramo de Atividade</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.ramoAtividade\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Faturamento/Médio/Mês (Brasil)</label> <input type=\"number\" ng-model=\"controller.fornecedor.complemento.faturamentoMedioBrasil\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Faturamento/Médio/Mês (Exterior)</label> <input type=\"number\" ng-model=\"controller.fornecedor.complemento.faturamentoMedioExterior\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Imóvel Próprio (Informar valor/metragem)</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosImovelProprio\" class=\"form-control inputDisabledModal\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Bancos</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosReferenciaBancos\" class=\"form-control inputDisabledModal\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência - Comerciais/Fornecedores (Informar % Participação)</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosReferenciaComercial\" class=\"form-control inputDisabledModal\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Principais Clientes (Informar % Faturamento)</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosPrincipaisClientes\" class=\"form-control inputDisabledModal\"></textarea></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.fornecedor.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.fornecedor.endereco.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxSocios\', \'boxSocios\')\"><h5><i class=\"fa fa-users\"></i> Controle Acionário/Societário</h5></div><div class=\"ibox-content\" id=\"boxSocios\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Nome</th><th class=\"white-bg\">CPF</th><th class=\"white-bg\">Data Nascimento</th><th class=\"white-bg\">RG</th><th class=\"white-bg\">% Participação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.socios\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.cpf }}</td><td class=\"ng-binding\">{{ p.dataNascimento }}</td><td class=\"ng-binding\">{{ p.rg == null || p.rg == \'\' ? \'não informado\' : p.rg }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao }}%</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.visualizarSocio(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirSocio()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxProcurador\', \'boxProcurador\')\"><h5><i class=\"fa fa-users\"></i> Procurador (ES)</h5></div><div class=\"ibox-content\" id=\"boxProcurador\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.procuradores.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Nome</th><th class=\"white-bg\">CPF</th><th class=\"white-bg\">Data Nascimento</th><th class=\"white-bg\">RG</th><th class=\"white-bg\">% Participação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.procuradores\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.cpf }}</td><td class=\"ng-binding\">{{ p.dataNascimento }}</td><td class=\"ng-binding\">{{ p.rg == null || p.rg == \'\' ? \'não informado\' : p.rg }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao }}%</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.visualizarProcurador(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirProcurador()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button> <span ng-if=\"controller.fornecedor.procuradores.length == 0\">Não foram informados procuradores.</span></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxEmpresas\', \'boxEmpresas\')\"><h5><i class=\"fa fa-users\"></i> Empresas Coligadas/Controladas</h5></div><div class=\"ibox-content\" id=\"boxEmpresas\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.empresas.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Razão Social</th><th class=\"white-bg\">CNPJ</th><th class=\"white-bg\">Sócios</th><th class=\"white-bg\">Fundação</th><th class=\"white-bg\">% Participação</th><th class=\"white-bg\">Data Entrada</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.empresas\"><td class=\"ng-binding\">{{ p.razaoSocial }}</td><td class=\"ng-binding\">{{ p.cnpj }}</td><td class=\"ng-binding\">{{ p.socios == null ? \'não informado\' : p.socios }}</td><td class=\"ng-binding\">{{ p.dataFundacao == null ? \'não informado\' : p.dataFundacao }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao == null ? 0 : p.percentualParticipacao }}%</td><td class=\"ng-binding\">{{ p.dataEntrada == null ? \'não informado\' : p.dataEntrada }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.visualizarEmpresa(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirEmpresa()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button> <span ng-if=\"controller.fornecedor.empresas.length == 0\">Não foram informados empresas coligadas/controladas.</span></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumentos\', \'boxDocumentos\')\"><h5><i class=\"fa fa-users\"></i> Documentos</h5></div><div class=\"ibox-content\" id=\"boxDocumentos\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.documentos.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Documento</th><th class=\"white-bg\">Arquivo</th></tr></thead><tbody><tr class=\"ng-scope\" ng:repeat=\"p in controller.fornecedor.documentos\"><td ng-if=\"p.tipo == 1\" class=\"ng-binding\">Cadastro Pessoa Jurídica</td><td ng-if=\"p.tipo == 2\" class=\"ng-binding\">Contrato/Estatuto Social</td><td ng-if=\"p.tipo == 3\" class=\"ng-binding\">Atas de eleição/nomeação do(s) representante(s)</td><td ng-if=\"p.tipo == 4\" class=\"ng-binding\">Procurações dos representantes da empresa</td><td ng-if=\"p.tipo == 5\" class=\"ng-binding\">Balanço Patrimonial + DRE (últimos 2 exercícios), assinado pelo(s) representante(s) e contador responsável</td><td ng-if=\"p.tipo == 6\" class=\"ng-binding\">Relação de Faturamento dos últimos 12 meses, assinado pelo(s) representante(s) e contador responsável</td><td ng-if=\"p.tipo == 7\" class=\"ng-binding\">Endividamento bancário / Fundos</td><td ng-if=\"p.tipo == 8\" class=\"ng-binding\">Faturamento dos últimos 12 meses com Seguradoras</td><td ng-if=\"p.tipo == 9\" class=\"ng-binding\">Solicitação de Alteração de Conta-Corrente</td><td style=\"width: 200px;\"><button ng-if=\"p.viewId != \'00000000-0000-0000-0000-000000000000\'\" ng-click=\"controller.getDocumento(p.viewId, p.nome)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button><div ng-if=\"p.viewId == \'00000000-0000-0000-0000-000000000000\'\" class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Anexar Arquivo</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(p.tipo)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td></tr></tbody></table><span ng-if=\"controller.fornecedor.documentos.length == 0\">Não foram informados documentos.</span></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-users\"></i> DECLARAÇÃO DE PESSOA POLITICAMENTE EXPOSTA</h5></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><b>DECLARAÇÃO DE PESSOA POLITICAMENTE EXPOSTA, NOS TERMOS DA CIRCULAR Nº 3.461/2009 DO BANCO CENTRAL DO BRASIL</b><br><br>Desempenha ou já desempenhou nos últimos 05 (cinco) anos, no Brasil ou em países, territórios e dependências estrangeiros, cargos, empregos ou funções públicas relevantes, assim como seus representantes, familiares e outras pessoas de seu relacionamento próximo?<br><select class=\"form-control inputDisabledModal\" ng-model=\"controller.fornecedor.complemento.pessoaPoliticamenteExposta\"><option value=\"0\">NÃO</option><option value=\"1\">SIM</option></select><br>Em caso positivo informar: a pessoa, o cargo ou função que exerce ou desempenhou, o período e, qual esfera do Poder: <input type=\"text\" ng-model=\"controller.fornecedor.complemento.politicamenteExpostaFuncao\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.statusCadastro == 3\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFichaCadastral\', \'boxFichaCadastral\')\"><h5><i class=\"fa fa-edit\"></i> Ficha Cadastral</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFichaCadastral\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxFichaCadastral\" ng-if=\"controller.fileFichaCadastralPDF != null\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><iframe src=\"{{controller.fileFichaCadastralPDF}}\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.statusCadastro == 2\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\"><button class=\"btn btn-md btn-danger\" type=\"button\" ng-click=\"controller.rejeitar()\"><i class=\"fa fa-arrow-left\"></i> REJEITAR CADASTRO</button></div><div class=\"col-lg-6\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizarDadosCadastro()\"><i class=\"fa fa-refresh\"></i> SALVAR DADOS</button> <button class=\"btn btn-md btn-primary\" type=\"button\" ng-click=\"controller.solicitarAssinatura()\"><i class=\"fa fa-arrow-right\"></i> SOLICITAR ASSINATURA DIGITAL</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.statusCadastro == 3\" cg-busy=\"controller.aprovarAberturaPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right;\"><button class=\"btn btn-md btn-warning\" type=\"button\" ng-click=\"controller.finalizarAberturaConta()\"><i class=\"fa fa-clock-o\"></i> PULAR ETAPA</button> <button class=\"btn btn-md btn-primary\" type=\"button\" ng-click=\"controller.aprovar()\"><i class=\"fa fa-arrow-right\"></i> SOLICITAR ABERTURA DE CONTA</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.statusCadastro == 4\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right;\"><button class=\"btn btn-md btn-primary\" type=\"button\" ng-click=\"controller.finalizarAberturaConta()\"><i class=\"fa fa-arrow-right\"></i> APROVAR ABERTURA DE CONTA</button></div></div></div></div></div></div></div>");
$templateCache.put("app/old/fornecedor/pendentes/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Fornecedores Pendentes de Aprovação</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Fornecedor</a></li><li class=\"active\"><strong>Pendentes de Aprovação</strong></li></ol></div><div class=\"col-lg-3\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"text\" ng-model=\"controller.filtro.codigo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Cadastro</label> <input type=\"date\" ng-model=\"controller.filtro.dataCadastroDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.dataCadastroAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisa()\"><option ng-value=\"0\">PREENCHIMENTO DO CADASTRO</option><option ng-value=\"2\">ANÁLISE DO CADASTRO</option><option ng-value=\"3\">ASSINATURA DIGITAL</option><option ng-value=\"4\">ABERTURA DE CONTA</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Fornecedores</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th ng-click=\"controller.ordenarResultado(\'numero\')\" style=\"width: 10px;\">#</th><th ng-click=\"controller.ordenarResultado(\'razaosocial\')\">Razão Social</th><th ng-click=\"controller.ordenarResultado(\'status\')\" style=\"width: 100px;\">Situação</th><th ng-click=\"controller.ordenarResultado(\'cnpj\')\">CNPJ</th><th ng-click=\"controller.ordenarResultado(\'datacadastro\')\">Data de cadastro</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.id}}</td><td>{{p.razaoSocial}}</td><td><button ng-if=\"p.statusCadastro == 0\" class=\"btn btn-warning btn-xs btn-block\">PREENCHIMENTO DO CADASTRO</button> <button ng-if=\"p.statusCadastro == 2\" class=\"btn btn-success btn-xs btn-block\">ANÁLISE DO CADASTRO</button> <button ng-if=\"p.statusCadastro == 3\" class=\"btn btn-primary btn-xs btn-block\">ASSINATURA DIGITAL</button> <button ng-if=\"p.statusCadastro == 4\" class=\"btn btn-brown btn-xs btn-block\">ABERTURA DE CONTA</button></td><td>{{p.cnpj}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"atendimentoController.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:atendimentoController.pager.currentPage === 1}\"><a ng-click=\"atendimentoController.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === 1}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in atendimentoController.pager.pages\" ng-class=\"{active:atendimentoController.pager.currentPage === page}\"><a ng-click=\"atendimentoController.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === atendimentoController.pager.totalPages}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:atendimentoController.pager.currentPage === atendimentoController.pager.totalPages}\"><a ng-click=\"atendimentoController.setPage(atendimentoController.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/old/titulos/importacao/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Importação de Recebíveis</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Recebíveis</a></li><li class=\"active\"><strong>Importação</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\" cg-busy=\"controller.validarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Envio de Notas Fiscais (NF-e)</h5><div ibox-tools=\"\" class=\"ng-scope\"></div></div><div class=\"ibox-content\"><form action=\"#\" class=\"dropzone dz-clickable ng-pristine ng-valid\" dropzone=\"\" id=\"dropzone\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Clique aqui para enviar sua NFE no formato XML</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" accept=\"text/xml\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarItem()\" name=\"...\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\">×</a></div></div><div><div class=\"table-responsive\"><table ng-if=\"controller.nfe.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Número Nfe/Série</th><th class=\"white-bg\">Destinatario</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Chave</th></tr></thead><tbody><tr ng:repeat=\"p in controller.nfe\"><td>{{p.numeroNfe + \'/\' + p.serieNfe}}</td><td>{{p.sacado.razaoSocial}}</td><td>{{p.valorNfe}}</td><td>{{p.chaveNfe}}</td><td style=\"text-align: center; width: 1px;\"><a ng-click=\"controller.removerNfe(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody><tfoot></tfoot></table></div></div></form></div></div></div></div><div class=\"row\" ng-if=\"controller.emitente != null\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-user\"></i> Cedente</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.emitente.razaoSocial\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia</label> <input type=\"text\" ng-model=\"controller.emitente.nomeFantasia\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" ng-model=\"controller.emitente.cnpj\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Inscrição Estadual</label> <input type=\"text\" ng-model=\"controller.emitente.inscricaoEstadual\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Inscrição Municipal</label> <input type=\"text\" ng-model=\"controller.emitente.inscricaoMunicipal\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.emitente.email\" disabled=\"\" class=\"form-control normal-text inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">CNAE</label> <input type=\"text\" ng-model=\"controller.emitente.cnaeDescricao\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CRT</label> <input type=\"text\" ng-model=\"controller.emitente.crtDescricao\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.emitente != null\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-user\"></i> Duplicatas</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Número Nfe/Série</th><th class=\"white-bg\">Destinatario</th><th class=\"white-bg\">Duplicata</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.duplicatas\" ng-style=\"p.statusCadastro == 1 && {\'background-color\':\'yellow\'}\"><td>{{p.notaFiscal.numeroNfe + \'/\' + p.notaFiscal.serieNfe}}</td><td>{{p.notaFiscal.sacado.razaoSocial}}</td><td>{{p.numeroTitulo}}</td><td>{{p.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td>{{p.valorTexto}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 1\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-check\"></i> Normal</a> <a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 2\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-info\"></i> Informativo</a> <a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 3\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-bell\"></i> Inválido</a></td></tr></tbody><tfoot><tr style=\"background-color: white\"><td colspan=\"4\"></td><td><b class=\"ng-binding\">R$ {{ (controller.getTotalDuplicatas() | number:2) }}</b></td></tr></tfoot></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.emitente != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.concluir()\"><i class=\"fa fa-save\"></i> Enviar Títulos</button></div></div></div></div></div>");
$templateCache.put("app/titulo/consultar/instrucao/index.html","<style>\r\n    .modal-instrucao-bottom {\r\n        display: flex !important;\r\n        align-items: flex-end;\r\n    }\r\n    .modal-instrucao-bottom .modal-dialog {\r\n        margin: 0 auto 30px auto !important;\r\n    }\r\n</style><div class=\"modal-header\" style=\"padding: 10px 15px;\"><h5 class=\"modal-title\" style=\"margin: 0;\">Instrução</h5></div><div class=\"modal-body\" style=\"padding-top: 15px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Instrução</label><select class=\"form-control\" ng-model=\"controller.tipoInstrucao\" ng-change=\"controller.onTipoInstrucaoChange()\"><option value=\"1\" ng-if=\"!controller.isSalarioDemanda()\">Prorrogação</option><option value=\"5\">Baixa</option><option value=\"6\" ng-if=\"!controller.isSalarioDemanda()\">Abatimento</option><option value=\"7\" ng-if=\"!controller.isSalarioDemanda()\">Enviar Cartório</option><option value=\"8\" ng-if=\"!controller.isSalarioDemanda()\">Sustar Cartório</option><option value=\"9\" ng-if=\"!controller.isSalarioDemanda()\">Sustar Protesto</option><option value=\"10\" ng-if=\"controller.isSalarioDemanda()\">Liquidação Interna</option><option value=\"11\">Informativo</option></select></div></div><div class=\"col-sm-4\" ng-if=\"controller.tipoInstrucao == 1\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Prorrogação</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.dataProrrogacao\"></div></div><div class=\"col-sm-4\" ng-if=\"controller.tipoInstrucao == 1\"><div class=\"form-group\"><label class=\"col-form-label\">Taxa</label><div class=\"input-group\"><input type=\"text\" numeric-only=\"\" ng-model=\"controller.taxaContaGrafica\" class=\"form-control\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-sm-4\" ng-if=\"controller.tipoInstrucao == 6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor do Abatimento</label><div class=\"input-group\"><input type=\"text\" ui-money-mask=\"2\" ng-model=\"controller.valor\" class=\"form-control\"> <span class=\"input-group-addon\">$</span></div></div></div><div class=\"col-sm-4\" ng-if=\"controller.tipoInstrucao == 10\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Pagamento</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.dataPagamento\" ng-disabled=\"controller.isEstorno\"></div></div><div class=\"col-sm-4\" ng-if=\"controller.tipoInstrucao == 10\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Pago</label><div class=\"input-group\"><input type=\"text\" ui-money-mask=\"2\" ng-model=\"controller.valor\" class=\"form-control\" ng-disabled=\"controller.isEstorno\"> <span class=\"input-group-addon\">$</span></div></div></div></div><div class=\"row\" ng-if=\"controller.tipoInstrucao == 10\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"controller.isEstorno\"> Esta instrução é um ESTORNO?</label></div></div></div></div><div class=\"row\" ng-if=\"controller.tipoInstrucao != 10 && controller.tipoInstrucao != 11\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Enviar instrução para Banco?</label><select class=\"form-control\"><option ng-value=\"1\" selected=\"\">Sim</option><option ng-value=\"2\">Não</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Observação</label> <textarea class=\"form-control\" rows=\"2\" ng-model=\"controller.observacao\"></textarea></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" style=\"width: 200px;\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Salvar</button></div>");
$templateCache.put("app/old/relatorio/teste/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>{{controller.name}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Relatórios</a></li><li class=\"active\"><strong>{{controller.name}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><iframe id=\"frameID\" width=\"100%\" height=\"600\" frameborder=\"0\" ng-src=\"{{controller.iFrameUrl}}\"></iframe></div></div></div>");
$templateCache.put("app/usuario/modal/solicitar_reset_senha/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Esqueci minha senha</h5><small class=\"font-bold\">Informe o e-mail cadastrado para receber uma nova senha.</small></div><div class=\"modal-body\" style=\"background-color: white;\" cg-busy=\"controller.esqueciSenhaPromise\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Informe o E-mail Cadastrado</label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.esqueciSenhaPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.enviar()\"><i class=\"fa fa-check\"></i> Solicitar</button></div>");
$templateCache.put("app/cadastro/cedente/modal/cadastrar_empresa/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Empresa Coligada/Controlada</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.empresa.razaoSocial\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.empresa.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Sócios</label> <input type=\"text\" ng-model=\"controller.empresa.socios\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data Fundação</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.empresa.dataFundacao\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">% Participação</label> <input type=\"number\" ng-model=\"controller.empresa.percentualParticipacao\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Entrada</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.empresa.dataEntrada\" class=\"form-control\"></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\" ng-if=\"controller.empresa.viewId == null\"><i class=\"fa fa-send\"></i> Incluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\" ng-if=\"controller.empresa.viewId != null\"><i class=\"fa fa-send\"></i> Atualizar</button></div>");
$templateCache.put("app/cadastro/cedente/modal/cadastrar_socio/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\" style=\"padding-top: 10px; padding-bottom: 10px;\"><h5 class=\"modal-title\">Pessoa</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.incluirPromise\" style=\"padding-bottom: 5px;\"><div class=\"row\"><div class=\"col-sm-12\"><input type=\"checkbox\" name=\"socio\" ng-model=\"controller.pessoa.isSocio\"> <label for=\"socio\">Sócio</label>&nbsp;&nbsp; <input type=\"checkbox\" name=\"avalista\" ng-model=\"controller.pessoa.isAvalista\"> <label for=\"avalista\">Avalista</label>&nbsp;&nbsp; <input type=\"checkbox\" name=\"fieldepositario\" ng-model=\"controller.pessoa.isFielDepositario\"> <label for=\"fieldepositario\">Fiel Depositário</label></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.pessoa.nome\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Nascimento</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.dataNascimento\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Entrada</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.dataEntrada\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.pessoa.cpf\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">RG/Emissor/UF ou RNE</label> <input type=\"text\" ng-model=\"controller.pessoa.rg\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.pessoa.email\" class=\"form-control normal-text\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">% Participação</label> <input type=\"number\" ng-model=\"controller.pessoa.percentualParticipacao\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Assina pela empresa?</label><select class=\"form-control\" ng-model=\"controller.pessoa.assinaPelaEmpresaText\"><option value=\"1\" selected=\"\">Sim</option><option value=\"2\">Não</option></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.pessoa.telefone1\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Celular</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.pessoa.celular\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Banco/Agência/Contato/Fone</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.referenciaBanco1\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Pessoais Contato/Fone/Parentesco</label> <textarea ng-model=\"controller.pessoa.referenciaPessoal1\" class=\"form-control\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-change=\"controller.consultarCep()\" ng-model=\"controller.pessoa.enderecoDados.cep\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.logradouro\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.numero\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.complemento\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.bairro\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.cidade\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><estado-select model=\"controller.pessoa.enderecoDados.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Pai</label> <input type=\"text\" ng-model=\"controller.pessoa.nomePai\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome da Mãe</label> <input type=\"text\" ng-model=\"controller.pessoa.nomeMae\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Conjugê</label> <input type=\"text\" ng-model=\"controller.pessoa.conjugeNome\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.pessoa.conjugeCpf\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Regime</label> <input type=\"text\" ng-model=\"controller.pessoa.conjugeRegime\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">RG/Emissor/UF ou RNE</label> <input type=\"text\" ng-model=\"controller.pessoa.conjugeRg\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.conjugeData\" class=\"form-control unstyled\"></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Patrimônio Imóveis (Descrição/Valor/Metragem)</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.patrimonioImoveis\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Patrimônio Móveis (Descrição/Valor)</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.patrimonioMoveis\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Faixa de Renda Mensal</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.faixaRendaMensal\" class=\"form-control\"></textarea></div></div></div><div class=\"row\" ng-if=\"controller.pessoa.viewId != null\" cg-busy=\"controller.uploadPromise\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Documentos</th><th class=\"white-bg\" style=\"width: 50px;\">Arquivo</th></tr></thead><tbody><tr class=\"ng-scope\"><td class=\"ng-binding\">Cadastro Pessoa Física</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(1)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq1 != \'\'\" style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq1)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Documento de Identificação (RG e CPF)</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span><input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(2)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq2 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq2)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Comprovante de Residência até 90 dias</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(3)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq3 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq3)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Certidão de Casamento (separação total de bens)</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(4)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq4 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq4)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Certidão de Casamento com Averbação (divorciado)</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(5)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq5 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq5)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Certidão de Óbito (viúvo)</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(6)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq6 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq6)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Declaração PPE - Pessoa Politicamente Exposta</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(7)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq7 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq7)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr></tbody></table></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\" ng-if=\"controller.pessoa.viewId == null\"><i class=\"fa fa-send\"></i> Incluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\" ng-if=\"controller.pessoa.viewId != null\"><i class=\"fa fa-check\"></i> Atualizar</button></div>");
$templateCache.put("app/cadastro/cedente/pocexpressa/cedente/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Cedente</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pesquisar:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>Nome Fantasia</th><th>Cod. Vmoney</th><th style=\"width: 180px;\">CPF/CNPJ</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.razaoSocial}}</td><td>{{p.nomeFantasia}}</td><td>{{p.codigoVmoney}}</td><td>{{p.cnpj}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/cadastro/cedente/pocexpressa/importar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Replicar POC</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Filtrar Cedente:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Cedente</th><th>Originador</th><th>Tipo Operação</th><th>Data Alteração</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registros\"><td>{{p.cedente.razaoSocial}}</td><td>{{p.originador.nome}}</td><td>{{p.tipoOperacaoTexto}}</td><td>{{p.dataAlteracao | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/cadastro/cedente/pocexpressa/salvar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Salvar POC</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\">Tipo de Operação</th></tr></thead><tbody><tr><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado1\"></td><td>Antecipação Normal</td></tr><tr><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado2\"></td><td>Cobrança Expressa</td></tr><tr><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado3\"></td><td>Comissária</td></tr></tbody></table></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/cadastro/cedente/pocexpressa/historico/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">{{controller.item.dataCadastro | date:\'dd/MM/yyyy HH:mm:ss\'}}</h5><small class=\"font-bold\">Histórico</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxValores\', \'boxValores\')\"><h5><i class=\"fa fa-arrow-right\"></i> Limites e Prazo de Validade</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxValores\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxValores\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Validade Inicial</label> <input type=\"date\" disabled=\"\" ng-model=\"controller.registro.validadeDe\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Validade Final</label> <input type=\"date\" disabled=\"\" ng-model=\"controller.registro.validadeAte\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Limite</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorLimite\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tranche</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorTranche\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Intervalo em dias</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.intervaloDias\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTaxas\', \'boxTaxas\')\"><h5><i class=\"fa fa-arrow-right\"></i> Taxas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTaxas\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxTaxas\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fator</label> <input type=\"text\" disabled=\"\" numeric-only=\"\" ng-model=\"controller.registro.taxaFator\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">AD Valorem</label> <input type=\"text\" disabled=\"\" numeric-only=\"\" ng-model=\"controller.registro.taxaAdvalorem\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTarifas\', \'boxTarifas\')\"><h5><i class=\"fa fa-arrow-right\"></i> Tarifas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTarifas\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxTarifas\"><div class=\"row\"><br><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Doc Padrão</th><th>Fator</th><th>Tarifa</th><th>TAC</th><th>TED/PIX</th><th>Despesa</th><th>Registro</th><th>Cons. SERPRO</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.tarifas\"><td>{{p.tipoDocumento.descricao}}</td><td>{{p.taxaFator}}</td><td>{{p.tarifa | currency:\'R$ \'}}</td><td>{{p.tac | currency:\'R$ \'}}</td><td>{{p.ted | currency:\'R$ \'}}</td><td>{{p.despesaAdicional | currency:\'R$ \'}}</td><td>{{p.registro | currency:\'R$ \'}}</td><td>{{p.consultaSerpro | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxConsultas3\', \'boxConsultas3\')\"><h5><i class=\"fa fa-arrow-right\"></i> Consultas de 3os</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxConsultas3\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxConsultas3\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Limite Concentração no Borderô:</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.limiteConcBordero\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Percentual:</label> <input type=\"text\" disabled=\"\" numeric-only=\"\" ng-model=\"controller.registro.limiteConcBorderoPerc\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Limite Concentração na Carteira:</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.limiteConcCarteira\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Percentual:</label> <input type=\"text\" disabled=\"\" numeric-only=\"\" ng-model=\"controller.registro.limiteConcCarteiraPerc\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vlr Unitário Consulta:</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorUnitarioConsulta3os\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxPoliticas\', \'boxPoliticas\')\"><h5><i class=\"fa fa-arrow-right\"></i> Políticas de Crédito</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxPoliticas\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxPoliticas\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Min Checagem +</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.minChecagemPositivo\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Max Checagem -</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.maxChecagemNegativo\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Contração Máx Sacado</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.contratacaoMaxSacado\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo Mínimo p/ Tit</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.prazoMinTit\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo Máximo p/ Tit</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.prazoMaxTit\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo Entrega Canhoto</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.prazoCanhoto\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Mínimo p/ Tit</label> <input type=\"text\" money-mask=\"\" disabled=\"\" ng-model=\"controller.registro.valorMinTit\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Máximo p/ Tit</label> <input type=\"text\" money-mask=\"\" disabled=\"\" ng-model=\"controller.registro.valorMaxTit\" class=\"form-control\"></div></div></div></div></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/cadastro/cedente/pocexpressa/listar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>POC Expressa</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cedente</a></li><li class=\"active\"><strong>POC Expressa</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Filtrar Cedente</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-success btn-block\" ng-click=\"controller.novaPoc()\"><i class=\"fa fa-plus\"></i> Nova POC</button></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> POC`s</h5><div class=\"ibox-tools\"></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Cedente</th><th>Originador</th><th>Tipo Originador</th><th>Tipo Operação</th><th>Validade</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.cedente.razaoSocial}}</td><td>{{p.originador.nome}}</td><td>{{controller.tipoOriginadorTexto(p.originador.tipo)}}</td><td>{{p.tipoOperacaoTexto}}</td><td ng-style=\"p.isVencido && {\'color\':\'red\'}\">{{p.validadeAte | date:\'dd/MM/yyyy\'}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button> <button ng-click=\"controller.excluir(p)\" class=\"btn btn-danger btn-xs\" style=\"margin-left: 4px;\"><i class=\"fa fa-trash\"></i> Excluir</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cadastro/cedente/pocexpressa/tarifa/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Adicionar Tarifa</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" id=\"boxTarifas\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\" ng-if=\"controller.isUpdate != true\"><div class=\"form-group\"><label class=\"col-form-label\">Doc. Padrão</label><select class=\"form-control\" ng-model=\"controller.registro.tipoDocumento\" ng-change=\"controller.tipoDocumentoEscolhido()\" ng-options=\"item as item.descricao for item in controller.tiposDocumento track by item.id\"></select></div></div><div class=\"col-sm-4\" ng-if=\"controller.isUpdate == true\"><div class=\"form-group\"><label class=\"col-form-label\">Doc. Padrão</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.registro.tipoDocumento.descricao\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fator</label> <input type=\"text\" numeric-only=\"\" ng-model=\"controller.registro.taxaFator\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tarifa</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.tarifa\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">TAC</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.tac\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">TED/PIX</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.ted\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Despesa Adicional</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.despesaAdicional\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Registro</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.registro\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Consultas SERPRO</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.consultaSerpro\" class=\"form-control\"></div></div></div></div></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\" ng-if=\"controller.isUpdate != true\"><i class=\"fa fa-plus\"></i> Adicionar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\" ng-if=\"controller.isUpdate == true\"><i class=\"fa fa-save\"></i> Atualizar</button></div>");
$templateCache.put("app/cadastro/sacado/selecionar/novo/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Novo Sacado</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 15px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Sacado</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome / Razão Social</label> <input type=\"text\" ng-model=\"controller.sacado.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF / CNPJ</label> <input type=\"text\" mask=\"{{ controller.sacado.cnpj.length > 14 ? \'99.999.999/9999-99\' : \'999.999.999-999999999\' }}\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.sacado.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.sacado.endereco.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.salvarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" style=\"width: 190px;\" class=\"btn btn-primary\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar</button></div>");
$templateCache.put("app/arranjo_pagamento/agenda/modal/operacao/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Operação</h5><small class=\"font-bold\">Preencha as informações abaixo para cadastrar uma nova operação.</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Titular</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.cedente.cnpj\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Disponível</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorDisponivelTexto\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Operação</label><select class=\"form-control\" ng-model=\"controller.registro.tipoOperacao\"><option ng-value=\"1\">Troca de titularidade</option><option ng-value=\"2\">Ônus - Cessão fiduciária</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Regra de Divisão</label><select class=\"form-control\" ng-model=\"controller.registro.regraDivisao\"><option ng-value=\"1\">Valor Fixo</option><option ng-value=\"2\">Percentual</option></select></div></div><div class=\"col-sm-4\" ng-if=\"controller.registro.regraDivisao == 1\"><div class=\"form-group\"><label class=\"col-form-label\">Valor a Onerar</label> <input type=\"text\" money-mask=\"\" maxlength=\"50\" ng-model=\"controller.registro.valorOnerarTexto\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-4\" ng-if=\"controller.registro.regraDivisao == 2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor a Onerar</label> <input type=\"text\" class=\"form-control\" maxlength=\"50\" ng-model=\"controller.registro.valorOnerarTexto\" ui-percentage-mask=\"2\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Gestão do Ônus</label><select class=\"form-control\" ng-model=\"controller.registro.gestaoOnus\"><option ng-value=\"1\">Gestão de entidade registradora</option><option ng-value=\"2\">Gestão do financiador ou não financeira</option><option ng-value=\"3\">Gestão do financiador ou não financeira com monitoramento da registradora</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vencimento do Contrato</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataVencimento\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Domicílio Bancário</label><select class=\"form-control\"><option>254 Banco XPTO - 1554 - 0100254</option><option>044 Banco XPTO 2 - 1114 - 0220211</option></select></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Unidades</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Credenciadora</th><th>Arranjo Pagamento</th><th>Liquidação</th><th>Valor Livre</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"r in controller.registros\"><td>{{ r.instituicaoCredenciadoraDoc }}</td><td>{{ r.descricaoArranjoPagamento}}</td><td>{{ r.dataLiquidacaoDate | date:\'dd/MM/yyyy\' }}</td><td>{{ r.valorLivre | currency:\'R$ \' }}</td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.enviar()\" style=\"width: 160px;\"><i class=\"fa fa-arrow-right\"></i> Criar Operação</button></div>");
$templateCache.put("app/arranjo_pagamento/conciliacao/baixa/detalhes_ur/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Unidades de Recebíveis (UR\'s)</h5><small class=\"font-bold\">Detalhamento do período selecionado</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.registro.data | date:\'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Previsto</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorNegociado\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Liquidado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorAtualizado\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Unidades</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Credenciadora</th><th>Arranjo Pagto</th><th>Valor da UR</th><th>Valor Previsto</th><th>Valor Liquidado</th></tr></thead><tbody style=\"background-color: white;\"><tr style=\"background-color: #ff4d4d; color: white;\"><td>01.425.787/0001-04 - REDECARD</td><td>Mastercard Cartão de Crédito</td><td>R$ 18.150,00</td><td>R$ 18.150,00</td><td>R$ 17.150,00</td></tr><tr><td>10.440.482/0001-54 - GETNET</td><td>Visa Cartão de Crédito</td><td>R$ 1.000,00</td><td>R$ 1.000,00</td><td>R$ 1.000,00</td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\" style=\"width: 160px;\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/arranjo_pagamento/agenda/modal/detalhes_ur/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Detalhes da Unidade de Recebível</h5><small class=\"font-bold\">Informações detalhadas da UR selecionada.</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Liquidação</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.recebivel.dataLiquidacaoDate | date:\'dd/MM/yyyy\' }}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Constituído</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.recebivel.valorConstituidoTotal | currency:\'R$ \' }}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Onerado</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.recebivel.valorOnerado | currency:\'R$ \' }}\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Livre</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.recebivel.valorLivre | currency:\'R$ \' }}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Total UR</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.recebivel.valorTotalUr | currency:\'R$ \' }}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Bloqueado</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.recebivel.valorBloqueado | currency:\'R$ \' }}\"></div></div></div><div class=\"row\" ng-if=\"controller.recebivel.pagamentos != null && controller.recebivel.pagamentos.length > 0\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pagamentos</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Benefíciario</th><th>Agência</th><th>Conta</th><th>Tipo Conta</th><th>Valor a Pagar</th><th>Tipo de Efeito</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.recebivel.pagamentos\" ng-if=\"p.valorAPagar > 0\"><td>{{p.beneficiario}}</td><td>{{p.domicilioPagamento.agencia}}</td><td>{{p.domicilioPagamento.numeroConta}}</td><td>{{p.domicilioPagamento.tipoConta}}</td><td>{{p.valorAPagar | currency:\'R$ \'}}</td><td>{{p.tipoInformacaoPagamentoTexto}}</td></tr></tbody></table></div></div></div></div><div class=\"row\" ng-if=\"controller.recebivel.titulares != null && controller.recebivel.titulares.length > 0\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Titulares</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Titular</th><th>Valor Bloqueado</th><th>Valor Antec. Pré</th><th>Valor Const. Total</th><th>Valor Livre</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.recebivel.titulares\"><td>{{p.documentoTitular}}</td><td>{{p.valorBloqueado | currency:\'R$ \'}}</td><td>{{p.valorConstituidoAntecipacaoPre | currency:\'R$ \'}}</td><td>{{p.valorConstituidoTotal | currency:\'R$ \'}}</td><td>{{p.valorLivre | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/arranjo_pagamento/conciliacao/baixa/detalhes_cedente/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consolidação por Cedente</h5><small class=\"font-bold\">Detalhamento do registro</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.registro.data | date:\'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Negociado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorNegociado\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Atualizado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorAtualizado\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Cedentes</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Cedente</th><th>Valor Negociado</th><th>Valor Atualizado</th></tr></thead><tbody style=\"background-color: white;\"><tr style=\"background-color: #ff4d4d; color: white;\"><td>85.482.900/0001-75 - Cedente CERC Homolog 001</td><td>R$ 19.150,00</td><td>R$ 18.150,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\" style=\"width: 160px;\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/arranjo_pagamento/conciliacao/carteira/detalhes_cedente/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consolidação por Cedente</h5><small class=\"font-bold\">Detalhamento do registro</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.registro.data | date:\'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Negociado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorNegociado\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Atualizado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorAtualizado\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Cedentes</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Cedente</th><th>Valor Negociado</th><th>Valor Atualizado</th></tr></thead><tbody style=\"background-color: white;\"><tr style=\"background-color: #ff4d4d; color: white;\"><td>85.482.900/0001-75 - Cedente CERC Homolog 001</td><td>R$ 19.150,00</td><td>R$ 18.150,00</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\" style=\"width: 160px;\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/arranjo_pagamento/baixas/pesquisar/detalhes_ur/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Unidades de Recebíveis (UR\'s)</h5><small class=\"font-bold\">Detalhamento do período selecionado</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.registro.data | date:\'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Previsto</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorNegociado\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Liquidado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorAtualizado\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Unidades</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Credenciadora</th><th>Arranjo Pagto</th><th>Valor da UR</th><th>Valor Previsto</th><th>Valor Liquidado</th></tr></thead><tbody style=\"background-color: white;\"><tr style=\"background-color: #ff4d4d; color: white;\"><td>01.425.787/0001-04 - REDECARD</td><td>Mastercard Cartão de Crédito</td><td>R$ 18.150,00</td><td>R$ 18.150,00</td><td>R$ 17.150,00</td></tr><tr><td>10.440.482/0001-54 - GETNET</td><td>Mastercard Cartão de Crédito</td><td>R$ 1.000,00</td><td>R$ 1.000,00</td><td>R$ 1.000,00</td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\" style=\"width: 160px;\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/arranjo_pagamento/fluxour/pesquisar/detalhes_cedente/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Fluxo de UR\'s</h5><small class=\"font-bold\">Detalhamento do período selecionado</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.registro.data | date:\'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Negociado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorNegociado\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Atualizado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorAtualizado\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Cedentes</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Cedente</th><th>Valor Negociado</th><th>Valor Atualizado</th></tr></thead><tbody style=\"background-color: white;\"><tr style=\"background-color: #ff4d4d; color: white;\"><td>85.482.900/0001-75 - Cedente CERC Homolog 001</td><td>R$ 9.850,50</td><td>R$ 8.120,50</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i> Detalhes</a></td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\" style=\"width: 160px;\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/arranjo_pagamento/conciliacao/carteira/detalhes_ur/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Unidades de Recebíveis (UR\'s)</h5><small class=\"font-bold\">Detalhamento do período selecionado</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.registro.data | date:\'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Previsto</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorNegociado\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Liquidado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorAtualizado\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Unidades</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Credenciadora</th><th>Arranjo Pagto</th><th>Valor da UR</th><th>Valor Previsto</th><th>Valor Liquidado</th></tr></thead><tbody style=\"background-color: white;\"><tr style=\"background-color: #ff4d4d; color: white;\"><td>01.425.787/0001-04 - REDECARD</td><td>Mastercard Cartão de Crédito</td><td>R$ 18.150,00</td><td>R$ 18.150,00</td><td>R$ 17.150,00</td></tr><tr><td>10.440.482/0001-54 - GETNET</td><td>Visa Cartão de Crédito</td><td>R$ 1.000,00</td><td>R$ 1.000,00</td><td>R$ 1.000,00</td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\" style=\"width: 160px;\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/arranjo_pagamento/optin/modal/cedente/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Cedente</h5><small class=\"font-bold\">Selecione o Cedente para inclusão do OPT-IN.</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pesquisar cedente:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Razão Social</th><th>Nome Fantasia</th><th>Cod. Vmoney</th><th>CNPJ</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.razaoSocial}}</td><td>{{p.nomeFantasia}}</td><td>{{p.codigoVmoney}}</td><td>{{p.cnpj}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/arranjo_pagamento/fluxour/pesquisar/detalhes_credenciadora/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Detalhes do Cedente</h5><small class=\"font-bold\">85.482.900/0001-75 - Cedente CERC Homolog 001</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.registro.data | date:\'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Negociado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorNegociado\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Atualizado</label> <input type=\"text\" disabled=\"\" money-mask=\"\" ng-model=\"controller.registro.valorAtualizado\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Credenciadoras</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Credenciadora</th><th>Valor Negociado</th><th>Valor Atualizado</th></tr></thead><tbody style=\"background-color: white;\"><tr><td>10.440.482/0001-54 - GETNET</td><td>R$ 1.100,00</td><td>R$ 1.100,00</td></tr><tr style=\"background-color: #ff4d4d; color: white;\"><td>01.027.058/0001-91 - CIELO</td><td>R$ 8.750,50</td><td>R$ 7.020,50</td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\" style=\"width: 160px;\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/cliente/originadores/consultar/socio/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\" style=\"padding-top: 10px; padding-bottom: 10px;\"><h5 class=\"modal-title\">{{ controller.tipoPessoa }}</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\" style=\"padding-bottom: 5px;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.pessoa.nome\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Nascimento</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.dataNascimento\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.pessoa.email\" class=\"form-control normal-text\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.pessoa.cpf\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">RG/Emissor/UF ou RNE</label> <input type=\"text\" ng-model=\"controller.pessoa.rg\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.pessoa.telefone1\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Celular</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.pessoa.celular\" class=\"form-control\"></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\" ng-if=\"controller.pessoa.viewId == null\"><i class=\"fa fa-send\"></i> Incluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\" ng-if=\"controller.pessoa.viewId != null\"><i class=\"fa fa-check\"></i> Atualizar</button></div>");
$templateCache.put("app/contagrafica/relatorio/extrato/detalhe/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Detalhe</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 10px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Partida</label> <input type=\"text\" disabled=\"\" value=\"{{ controller.registro.dataPartida | date:\'dd/MM/yyyy\' }}\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Original</label> <input type=\"text\" disabled=\"\" value=\"{{ controller.registro.valorPartida | currency:\'R$ \' }}\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cálculo</label> <input type=\"text\" disabled=\"\" value=\"Linear\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Taxa</label> <input type=\"text\" disabled=\"\" value=\"Taxa de Desconto\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Taxa Conta Gráfica</label> <input type=\"text\" disabled=\"\" value=\"{{ controller.registro.taxaContaGrafica }}%\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Presente (Débito)</label> <input type=\"text\" disabled=\"\" value=\"{{ controller.registro.valorPresente | currency:\'R$ \' }}\" class=\"form-control\"></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\">Fechar</button></div>");
$templateCache.put("app/contagrafica/acerto/historico/detalhe/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Registro #{{controller.registro.id}}</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.pesquisarPromise\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data Proc.</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.registro.dataCadastro | date: \'dd/MM/yyyy HH:mm\' : \'UTC\' }}\" class=\"form-control inputDisabledModal\" style=\"background-color: white !important;\"></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data Pag.</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.registro.dataPagamento | date: \'dd/MM/yyyy\' : \'UTC\' }}\" class=\"form-control inputDisabledModal\" style=\"background-color: white !important;\"></div></div></div><div class=\"col-sm-3\" ng-if=\"controller.registro.antecipacao != null\"><div class=\"form-group\"><label class=\"col-form-label\">Operação</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.registro.antecipacao.id }}\" class=\"form-control inputDisabledModal\" style=\"background-color: white !important;\"></div></div></div><div class=\"col-sm-3\" ng-if=\"controller.registro.antecipacao == null\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo Pag.</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.registro.tipoPagamentoTexto }}\" class=\"form-control inputDisabledModal\" style=\"background-color: white !important;\"></div></div></div><div class=\"col-sm-3\" ng-if=\"controller.registro.antecipacao == null\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Pag.</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.registro.valorPagamento | currency:\'R$ \' }}\" class=\"form-control inputDisabledModal\" style=\"background-color: white !important;\"></div></div></div></div></div><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Documento</th><th>Tipo</th><th>Data Partida</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registros\"><td class=\"ng-binding\">{{p.titulo.numeroNfe}} {{p.titulo.numero}}</td><td class=\"ng-binding\">{{p.tipoTexto}}</td><td class=\"ng-binding\">{{p.dataPartida | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td class=\"ng-binding\">{{p.valorPresente | currency:\'R$ \' }}</td></tr></tbody></table></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/email/carteira/dinamica/email_vencido/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Atualizar Boleto</h5><small class=\"font-bold\">Identificamos que existem boletos vencidos na lista, selecione uma das opções abaixo.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div class=\"col-sm-6\"><button class=\"btn btn-primary btn-block\" ng-click=\"controller.visualizarBoleto()\">Boleto Original</button></div><div class=\"col-sm-6\"><button class=\"btn btn-success btn-block\" ng-click=\"controller.visualizarBoletoAtualizado()\">Boleto Atualizado</button></div></div><br></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/email/carteira/dinamica/vencido/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Boleto</h5></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div ng-if=\"controller.usoDeBoleto === 1 || controller.usoDeBoleto === 0\" ng-class=\"{ \'col-sm-12\': controller.usoDeBoleto === 1 , \'col-sm-6\': controller.usoDeBoleto === 0 }\"><button class=\"btn btn-primary btn-block\" ng-mouseenter=\"controller.mostrarParagrafo = true\" ng-mouseleave=\"controller.mostrarParagrafo = false\" ng-click=\"controller.visualizarBoleto()\" ng-style=\"{\'margin\': controller.usoDeBoleto === 1 ? \'0 auto\' : \'\', \'width\': controller.usoDeBoleto === 1 ? \'50%\' : \'\'}\">Boleto Original</button></div><div ng-if=\"controller.usoDeBoleto === 2 || controller.usoDeBoleto === 0\" ng-class=\"{ \'col-sm-12\': controller.usoDeBoleto === 2, \'col-sm-6\': controller.usoDeBoleto === 0 }\"><button class=\"btn btn-success btn-block\" ng-click=\"controller.visualizarBoletoAtualizado()\" ng-style=\"{\'margin\': controller.usoDeBoleto === 2 ? \'0 auto\' : \'\', \'width\': controller.usoDeBoleto === 2 ? \'50%\' : \'\'}\">Boleto Atualizado</button></div></div><div class=\"row\" style=\"text-align: center;\"><br><p ng-show=\"controller.mostrarParagrafo\" style=\"color: brown; padding: 5px; padding-top: 5px;\"><b>Atenção! Desde 10/11/2018, a NPC (Nova Plataforma de Cobrança) desenvolvida pela FEBRAN (Federação Brasileira de Bancos) passou a exigir o registro de todos os boletos, permitindo que o recebimento dos boletos vencidos possam ser pagos respeitando todas as instruções que contenham encargos, independente do banco emissor e/ou do banco de pagamento. Portanto, mesmo que a segunda via do boleto que já está vencido, seja gerada com os dados originais, no momento do pagamento a NPC irá realizar a atualização dos valores de forma automática.</b></p></div><br></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/contagrafica/relatorio/extrato/pdf/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Extrato</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-12\"><iframe ng-src=\"{{controller.filePdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"540px\" style=\"overflow: auto;\"></iframe></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" style=\"width: 200px;\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-arrow-right\"></i> Fechar</button></div>");
$templateCache.put("app/email/carteira/modal/boleto/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Visualizar Boleto</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.filePdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/analise/detalhe/titulo/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Título</h5><small class=\"font-bold\">{{controller.subtitulo}}</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Documento</label> <input type=\"text\" readonly=\"\" value=\"{{controller.titulo.numero}}\" class=\"form-control backwhite\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data Vencimento</label> <input type=\"text\" readonly=\"\" value=\"{{controller.titulo.dataVencimentoOriginal | date: \'dd/MM/yyyy\' : \'UTC\'}}\" class=\"form-control backwhite\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" readonly=\"\" value=\"{{controller.titulo.valor | currency:\'R$ \'}}\" class=\"form-control backwhite\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select class=\"form-control\" ng-model=\"controller.titulo.recusado\" ng-options=\"opt.val as opt.name for opt in [{val:false,name:\'Liberado\'},{val:true,name:\'Recusado\'}]\"></select></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Ocorrências</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Descrição</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.titulo.erros\"><td>{{p.descricao}}</td><td width=\"1px\"><button class=\"btn btn-danger btn-xs btn-block\" ng-click=\"controller.remover(p)\" ng-if=\"p.origem !== 0\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><button class=\"btn btn-success btn-sm\" ng-click=\"controller.adicionarOcorrencia(controller.titulo)\"><i class=\"fa fa-plus\"></i> Adicionar Ocorrência</button><br><br></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-check\"></i> Fechar</button></div>");
$templateCache.put("app/fluxo_aprovacao/configuracao/etapa/campo/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Definição do Campo</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome do Campo</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.registro.descricao\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Tipo</label><div class=\"col-lg-10\"><select class=\"form-control\" ng-model=\"controller.registro.tipoResposta\"><option value=\"0\">Texto</option><option value=\"1\">Sim / Não</option><option value=\"2\">Arquivo (Anexo)</option></select></div></div></form></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button style=\"width: 120px\" type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Adicionar</button></div>");
$templateCache.put("app/invoice/analise/detalhe/ocorrencia/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">{{controller.tituloModal}}</h5><small class=\"font-bold\">{{controller.subtitulo}}</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultarErros\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th></th><th>Descrição</th><th>Criticidade</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.lista\" ng-class=\"{\'text-danger\': p.criticidade === \'S\'}\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-disabled=\"p.desabilitado\" ng-model=\"p.selecionado\"></td><td>{{p.descricao}}</td><td>{{p.criticidade === \'S\' ? \'Crítico\' : \'Informativo\'}}</td></tr></tbody></table></div></div></div></div><div class=\"row\" ng-if=\"controller.origem !== \'tela_titulos\'\" style=\"margin-top: 20px;\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Remover Ocorrências</label><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Descrição</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.titulo.erros | filter: { origem: \'!99\' } | filter: { categoria: controller.origemTela === \'tela_cedente\' ? 1 : 2 }\" ng-class=\"{\'text-danger\': p.criticidade === \'S\'}\"><td>{{p.descricao}}</td><td width=\"1px\"><button class=\"btn btn-danger btn-xs btn-block\" ng-click=\"controller.remover(p)\" ng-if=\"p.origem !== 0\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.atualizar\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.confirmar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/invoice/analise/vadu/cedente/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Ocorrências</h5><small class=\"font-bold\">{{controller.subtitulo}}</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registros\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.cedlogRating}}</td></tr></tbody></table></div></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-check\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/analise/vadu/nota/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Nota</h5><small class=\"font-bold\">{{controller.subtitulo}}</small></div><div class=\"modal-body\" style=\"padding: 10px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\" ng-if=\"controller.bloqueios.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxBloqueios\', \'boxBloqueios\')\"><h5><i class=\"fa fa-arrow-right\"></i> Bloqueios</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxBloqueios\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxBloqueios\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.bloqueios\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.chalogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.alertas.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAlertas\', \'boxAlertas\')\"><h5><i class=\"fa fa-arrow-right\"></i> Alertas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAlertas\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxAlertas\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.alertas\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.chalogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.transferidos.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTransf\', \'boxTransf\')\"><h5><i class=\"fa fa-arrow-right\"></i> Transferidos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTransf\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxTransf\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.transferidos\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.chalogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.liberados.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxLiberados\', \'boxLiberados\')\"><h5><i class=\"fa fa-arrow-right\"></i> Liberados</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxLiberados\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxLiberados\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.liberados\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.chalogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.semProblemas.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSemProb\', \'boxSemProb\')\"><h5><i class=\"fa fa-arrow-right\"></i> Sem Problemas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxSemProb\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxSemProb\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.semProblemas\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.chalogRating}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-check\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/analise/vadu/sacado/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Sacado</h5><small class=\"font-bold\">{{controller.subtitulo}}</small></div><div class=\"modal-body\" style=\"padding: 10px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\" ng-if=\"controller.bloqueios.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxBloqueios\', \'boxBloqueios\')\"><h5><i class=\"fa fa-arrow-right\"></i> Bloqueios</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxBloqueios\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxBloqueios\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.bloqueios\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.saclogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.alertas.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAlertas\', \'boxAlertas\')\"><h5><i class=\"fa fa-arrow-right\"></i> Alertas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAlertas\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxAlertas\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.alertas\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.saclogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.transferidos.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTransf\', \'boxTransf\')\"><h5><i class=\"fa fa-arrow-right\"></i> Transferidos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTransf\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxTransf\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.transferidos\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.saclogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.liberados.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxLiberados\', \'boxLiberados\')\"><h5><i class=\"fa fa-arrow-right\"></i> Liberados</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxLiberados\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxLiberados\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.liberados\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.saclogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.semProblemas.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSemProb\', \'boxSemProb\')\"><h5><i class=\"fa fa-arrow-right\"></i> Sem Problemas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxSemProb\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxSemProb\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.semProblemas\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.saclogRating}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-check\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/analise/vadu/titulolog/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Título</h5><small class=\"font-bold\">{{controller.subtitulo}}</small></div><div class=\"modal-body\" style=\"padding: 10px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\" ng-if=\"controller.bloqueios.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxBloqueios\', \'boxBloqueios\')\"><h5><i class=\"fa fa-arrow-right\"></i> Bloqueios</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxBloqueios\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxBloqueios\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.bloqueios\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.titlogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.alertas.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAlertas\', \'boxAlertas\')\"><h5><i class=\"fa fa-arrow-right\"></i> Alertas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAlertas\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxAlertas\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.alertas\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.titlogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.transferidos.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTransf\', \'boxTransf\')\"><h5><i class=\"fa fa-arrow-right\"></i> Transferidos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTransf\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxTransf\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.transferidos\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.titlogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.liberados.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxLiberados\', \'boxLiberados\')\"><h5><i class=\"fa fa-arrow-right\"></i> Liberados</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxLiberados\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxLiberados\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.liberados\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.titlogRating}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.semProblemas.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSemProb\', \'boxSemProb\')\"><h5><i class=\"fa fa-arrow-right\"></i> Sem Problemas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxSemProb\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxSemProb\" class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Análise</th><th>Regra</th><th>Rating</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.semProblemas\"><td>{{p.anaDescricao}}</td><td>{{p.regDescricao}}</td><td>{{p.titlogRating}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-check\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/analise/vadu/titulo/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Ocorrências</h5><small class=\"font-bold\">{{controller.subtitulo}}</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th ng-if=\"controller.modo !== \'nfe\'\">Documento</th><th ng-if=\"controller.modo !== \'nfe\'\">Vencimento</th><th ng-if=\"controller.modo !== \'nfe\'\">Valor</th><th ng-if=\"controller.modo === \'nfe\'\">NF-e</th></tr></thead><tbody style=\"background-color: white;\"><tr ng-repeat=\"p in controller.getRegistrosFiltrados()\"><td ng-if=\"controller.modo !== \'nfe\'\" ng-click=\"controller.consultarLog(p)\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\" ng-if=\"p.bortitBloqueio\"></i> {{p.titDocumento}}</td><td ng-if=\"controller.modo !== \'nfe\'\">{{p.titVencimento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-if=\"controller.modo !== \'nfe\'\">{{p.titValor | currency:\'R$ \'}}</td><td ng-if=\"controller.modo === \'nfe\'\" ng-click=\"controller.consultarLogNota(p)\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\" ng-if=\"p.bortitChaveBloqueio\"></i> {{p.titChaveNfe}}</td></tr></tbody></table></div></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-check\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/fluxo/analise/etapa/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Etapa</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Operações</a></li><li class=\"active\"><strong>Fluxo de Aprovação</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.pesquisarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-arrow-right\"></i> Etapa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <input type=\"text\" ng-model=\"controller.registro.descricao\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.pesquisarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFormulario\', \'boxFormulario\')\"><h5><i class=\"fa fa-arrow-right\"></i> Formulário</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFormulario\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxFormulario\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\" ng:repeat=\"p in controller.registro.campos\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">{{p.descricao}}</label> <input type=\"text\" ng-if=\"p.tipoResposta == 0\" ng-model=\"p.resposta\" class=\"form-control\"><select ng-if=\"p.tipoResposta == 1\" class=\"form-control\" ng-model=\"p.resposta\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select><div><button style=\"width: 120px\" ng-if=\"p.tipoResposta == 2 && p.resposta != \'\'\" class=\"btn btn-md btn-success\" ng-click=\"controller.download(p)\"><i class=\"fa fa-download\"></i> Download</button> <button style=\"width: 40px\" ng-if=\"p.tipoResposta == 2 && p.resposta != \'\' && controller.registro.isAprovado == false\" class=\"btn btn-md btn-danger\" ng-click=\"controller.removerAnexo(p)\"><i class=\"fa fa-trash\"></i></button></div><input type=\"file\" ng-if=\"p.tipoResposta == 2 && p.resposta == \'\'\" class=\"form-control\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.anexar(p)\"></div></div><div class=\"col-sm-6\"></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registro.isAprovado == false\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button ng-if=\"controller.registro.isAprovado == false\" class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 150px\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar</button> <button ng-if=\"controller.registro.isPreenchido == false\" class=\"btn btn-md btn-primary\" type=\"button\" style=\"width: 150px\" ng-click=\"controller.finalizar()\"><i class=\"fa fa-arrow-right\"></i> Finalizar</button> <button ng-if=\"controller.registro.isPreenchido == true && controller.registro.isAprovado == false\" class=\"btn btn-md btn-primary\" type=\"button\" style=\"width: 150px\" ng-click=\"controller.aprovar()\"><i class=\"fa fa-arrow-right\"></i> Aprovar</button></div></div></div></div></div>");
$templateCache.put("app/invoice/titulos/modal/antecipar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Solicitar Nova Antecipação</h5><small class=\"font-bold\">Revise os dados para iniciar a operação de antecipação.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nº NFe</th><th>Título</th><th>Sacado</th><th>Vencimento</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registros\"><td>{{p.numero}}</td><td>{{p.titulo}}</td><td>{{p.sacado}}</td><td>{{p.dataVencimento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{p.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div><div><span style=\"font-weight: bold\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}} <span ng-if=\"controller.total.valorTotal > 0\">em {{controller.total.quantidade}} título{{(controller.total.quantidade > 1 ? \'s \' : \'\')}} selecionado{{(controller.total.quantidade > 1 ? \'s \' : \'\')}}</span></span><br><br></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.enviar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/invoice/titulos/modal/detalhar_titulo/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Detalhes do Título</h5><small class=\"font-bold\">Informações detalhadas do título selecionado.</small></div><style>\r\n    .text-warning.form-control {\r\n        color: #f8ac59 !important;\r\n    }\r\n</style><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\">N° Nfe</label> <input type=\"text\" ng-disabled=\"!controller.podeAlterarCartaCorrecao || controller.liberarSemAlteracoes\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\" ng-model=\"controller.titulo.numeroNfe\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\">N° Título</label> <input type=\"text\" ng-disabled=\"!controller.podeAlterarCartaCorrecao || controller.liberarSemAlteracoes\" class=\"form-control inputDisabledModal\" ng-model=\"controller.titulo.numero\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.cedente.razaoSocial}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ do Fornecedor</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.cedente.cnpj}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.sacado.razaoSocial}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ do Sacado</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.sacado.cnpj}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Emissão</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.notaFiscalDto.dataRecebimento | date: \'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Fatura</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.notaFiscalDto.dataRecebimento | date: \'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'1\') !== -1}\">Data de Vencimento</label> <input type=\"date\" ng-disabled=\"!controller.podeAlterarCartaCorrecao || controller.liberarSemAlteracoes\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'1\') !== -1}\" class=\"form-control inputDisabledModal\" ng-model=\"controller.titulo.dataVencimentoDate\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Chave de Acesso da NF-e</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.notaFiscalDto.chaveNfe }}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'2\') !== -1}\">Valor</label> <input type=\"text\" ui-money-mask=\"2\" ng-disabled=\"!controller.podeAlterarCartaCorrecao || controller.liberarSemAlteracoes\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'2\') !== -1}\" class=\"form-control inputDisabledModal\" ng-model=\"controller.titulo.valor\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Banco Cheque</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.bancoCheque }}\"></div></div><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">CMC-7 {{}}</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.cmc7 }}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.nfeValidacao.documentoDTO.documentos[0].ultimoStatus}} - {{controller.titulo.nfeValidacao.documentoDTO.documentos[0].nfeStatusSefaz.descricao}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data Atualização</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.nfeValidacao.documentoDTO.documentos[0].dataUltimoStatus}}\"></div></div></div><div class=\"row\" ng-if=\"controller.titulo.cfopsBloqueado.length > 0\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 150px; white-space: nowrap;\">CFOPs Bloqueados</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.titulo.cfopsBloqueado\"><td>{{p}}</td></tr></tbody></table></div></div></div></div><div class=\"row\" ng-if=\"controller.titulo.nfeValidacao.documentoDTO.documentos[0].eventos.length > 0\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 150px; white-space: nowrap;\">Data Evento</th><th style=\"width: 100px\">Código</th><th>Evento</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.titulo.nfeValidacao.documentoDTO.documentos[0].eventos\"><td>{{p.dataEvento}}</td><td>{{p.tipoEvento}}</td><td ng-if=\"p.descrEvento == null\">{{p.nfeEventoStatusSefaz.nome}}</td><td ng-if=\"p.descrEvento != null\">{{p.nfeEventoStatusSefaz.nome}}:<br>{{p.descrEvento}}</td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><div style=\"float: left;\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.excluir()\" ng-if=\"controller.titulo.status == 1\"><i class=\"fa fa-trash\"></i> Excluir</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.gravar()\" ng-if=\"controller.verificarAlteracoesCustom()\"><i class=\"fa fa-save\"></i> Gravar</button> <button type=\"button\" style=\"width: 200px;\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-arrow-right\"></i> Fechar</button></div><div style=\"float: right; margin-top: 8px; margin-right: 10px;\" ng-if=\"controller.titulo.statusCartaCorrecao === 0 && controller.podeAlterarCartaCorrecao\"><label style=\"color: red; font-weight: bold; cursor: pointer;\"><input type=\"checkbox\" ng-model=\"controller.liberarSemAlteracoes\" style=\"margin-right: 5px;\"> Liberar sem alterações</label></div><div style=\"float: right; margin-top: 8px; margin-right: 10px;\" ng-if=\"controller.titulo.statusCartaCorrecao !== 0 && controller.podeAlterarCartaCorrecao\"><span style=\"color: green; font-weight: bold;\">Liberado pela IC</span></div></div>");
$templateCache.put("app/old/cadastro/fornecedor/cadastro/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Fornecedor</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Fornecedor</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Fornecedor</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.fornecedor.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.fornecedor.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-warning\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.fornecedor.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.fornecedor.endereco.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Concluir</button></div></div></div></div></div>");
$templateCache.put("app/old/agente_financeiro/antecipacoes/modal/consultar_titulos.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Títulos</h5><small class=\"font-bold\">Lista de títulos da proposta selecionada.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nº NFe</th><th>Nº Título</th><th>Sacado</th><th>Vencimento</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.titulos\"><td>{{p.numero}}</td><td>{{p.titulo}}</td><td>{{p.sacado}}</td><td>{{p.dataVencimento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{p.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/old/agente_financeiro/antecipacoes/modal/proposta.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Enviar Proposta</h5><small class=\"font-bold\">Faça o envio da sua proposta para a antecipação selecionada.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px; background-color: white;\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" min=\"0\" max=\"99999\" ng-model=\"controller.proposta.valor\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Fator %</label> <input type=\"number\" min=\"0\" max=\"99\" ng-model=\"controller.proposta.fator\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Banco</label> <input type=\"text\" maxlength=\"10\" ng-model=\"controller.proposta.banco\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Agência</label> <input type=\"text\" maxlength=\"5\" ng-model=\"controller.proposta.agencia\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Conta</label> <input type=\"text\" maxlength=\"8\" ng-model=\"controller.proposta.conta\" class=\"form-control inputDisabledModal\"></div></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.enviar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/old/cadastro/fornecedor/consulta/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Consultar Fornecedor</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Fornecedor</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-bank\"></i> Dados do Fornecedor</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.fornecedor.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.nomeFantasia\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" disabled=\"\" mask=\"99.999.999/9999-99\" ng-model=\"controller.fornecedor.cnpj\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.fornecedor.complemento.emailCadastro\" class=\"form-control normal-text inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Fundação</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.dataFundacao\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Capital Social</label> <input type=\"text\" ui-number-mask=\"\" ng-model=\"controller.fornecedor.complemento.capitalSocial\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Contato Secundário</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.nomeContatoSecundario\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail do Contato Secundário</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.emailContatoSecundario\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Ramo de Atividade</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.ramoAtividade\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Faturamento/Médio/Mês (Brasil)</label> <input type=\"number\" ng-model=\"controller.fornecedor.complemento.faturamentoMedioBrasil\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Faturamento/Médio/Mês (Exterior)</label> <input type=\"number\" ng-model=\"controller.fornecedor.complemento.faturamentoMedioExterior\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Imóvel Próprio (Informar valor/metragem)</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosImovelProprio\" class=\"form-control inputDisabledModal\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Bancos</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosReferenciaBancos\" class=\"form-control inputDisabledModal\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência - Comerciais/Fornecedores (Informar % Participação)</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosReferenciaComercial\" class=\"form-control inputDisabledModal\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Principais Clientes (Informar % Faturamento)</label> <textarea rows=\"3\" ng-model=\"controller.fornecedor.complemento.dadosPrincipaisClientes\" class=\"form-control inputDisabledModal\"></textarea></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.fornecedor.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.fornecedor.endereco.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSocios\', \'boxSocios\')\"><h5><i class=\"fa fa-users\"></i> Controle Acionário/Societário</h5></div><div class=\"ibox-content\" id=\"boxSocios\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Nome</th><th class=\"white-bg\">CPF</th><th class=\"white-bg\">Data Nascimento</th><th class=\"white-bg\">RG</th><th class=\"white-bg\">% Participação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.socios\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.cpf }}</td><td class=\"ng-binding\">{{ p.dataNascimento }}</td><td class=\"ng-binding\">{{ p.rg == null || p.rg == \'\' ? \'não informado\' : p.rg }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao }}%</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.visualizarSocio(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirSocio()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxProcurador\', \'boxProcurador\')\"><h5><i class=\"fa fa-users\"></i> Procurador (ES)</h5></div><div class=\"ibox-content\" id=\"boxProcurador\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.procuradores.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Nome</th><th class=\"white-bg\">CPF</th><th class=\"white-bg\">Data Nascimento</th><th class=\"white-bg\">RG</th><th class=\"white-bg\">% Participação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.procuradores\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.cpf }}</td><td class=\"ng-binding\">{{ p.dataNascimento }}</td><td class=\"ng-binding\">{{ p.rg == null || p.rg == \'\' ? \'não informado\' : p.rg }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao }}%</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.visualizarProcurador(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirProcurador()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button> <span ng-if=\"controller.fornecedor.procuradores.length == 0\">Não foram informados procuradores.</span></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEmpresas\', \'boxEmpresas\')\"><h5><i class=\"fa fa-users\"></i> Empresas Coligadas/Controladas</h5></div><div class=\"ibox-content\" id=\"boxEmpresas\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.empresas.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Razão Social</th><th class=\"white-bg\">CNPJ</th><th class=\"white-bg\">Sócios</th><th class=\"white-bg\">Fundação</th><th class=\"white-bg\">% Participação</th><th class=\"white-bg\">Data Entrada</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.empresas\"><td class=\"ng-binding\">{{ p.razaoSocial }}</td><td class=\"ng-binding\">{{ p.cnpj }}</td><td class=\"ng-binding\">{{ p.socios == null ? \'não informado\' : p.socios }}</td><td class=\"ng-binding\">{{ p.dataFundacao == null ? \'não informado\' : p.dataFundacao }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao == null ? 0 : p.percentualParticipacao }}%</td><td class=\"ng-binding\">{{ p.dataEntrada == null ? \'não informado\' : p.dataEntrada }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.visualizarEmpresa(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirEmpresa()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button> <span ng-if=\"controller.fornecedor.empresas.length == 0\">Não foram informados empresas coligadas/controladas.</span></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumentos\', \'boxDocumentos\')\"><h5><i class=\"fa fa-book\"></i> Documentos</h5></div><div class=\"ibox-content\" id=\"boxDocumentos\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.documentos.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Documento</th><th class=\"white-bg\">Arquivo</th></tr></thead><tbody><tr class=\"ng-scope\" ng:repeat=\"p in controller.fornecedor.documentos\"><td ng-if=\"p.tipo == 1\" class=\"ng-binding\">Cadastro Pessoa Jurídica</td><td ng-if=\"p.tipo == 2\" class=\"ng-binding\">Contrato/Estatuto Social</td><td ng-if=\"p.tipo == 3\" class=\"ng-binding\">Atas de eleição/nomeação do(s) representante(s)</td><td ng-if=\"p.tipo == 4\" class=\"ng-binding\">Procurações dos representantes da empresa</td><td ng-if=\"p.tipo == 5\" class=\"ng-binding\">Balanço Patrimonial + DRE (últimos 2 exercícios), assinado pelo(s) representante(s) e contador responsável</td><td ng-if=\"p.tipo == 6\" class=\"ng-binding\">Relação de Faturamento dos últimos 12 meses, assinado pelo(s) representante(s) e contador responsável</td><td ng-if=\"p.tipo == 7\" class=\"ng-binding\">Endividamento bancário / Fundos</td><td ng-if=\"p.tipo == 8\" class=\"ng-binding\">Faturamento dos últimos 12 meses com Seguradoras</td><td ng-if=\"p.tipo == 9\" class=\"ng-binding\">Solicitação de Alteração de Conta-Corrente</td><td style=\"width: 200px;\"><button ng-if=\"p.viewId != \'00000000-0000-0000-0000-000000000000\'\" ng-click=\"controller.getDocumento(p.viewId, p.nome)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button><div ng-if=\"p.viewId == \'00000000-0000-0000-0000-000000000000\'\" class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Anexar Arquivo</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(p.tipo)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td></tr></tbody></table><span ng-if=\"controller.fornecedor.documentos.length == 0\">Não foram informados documentos.</span></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins collapsed\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-bank\"></i> Contas Bancárias</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContaBancaria\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.listarContasPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Banco</th><th class=\"white-bg\">Agência</th><th class=\"white-bg\">Conta</th><th class=\"white-bg\">Tipo</th><th class=\"white-bg\">Sacado</th><th class=\"white-bg\">Conta Escrow</th><th class=\"white-bg\">Domicílio Bancário</th><th class=\"white-bg\">Status Cadastral</th><th class=\"white-bg\">Status Operacional</th><th class=\"white-bg\">Envio da Carta</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.contas\"><td class=\"ng-binding\">{{ p.bancoDesc }}</td><td class=\"ng-binding\">{{ p.agencia }}-{{ p.agenciaDigito != \'\' ? p.agenciaDigito : \'0\' }}</td><td class=\"ng-binding\">{{ p.conta }}-{{ p.contaDigito }}</td><td class=\"ng-binding\">{{ p.tipoDesc }}</td><td class=\"ng-binding\">{{ p.sacadoRazaoSocial != \'\' ? p.sacadoRazaoSocial : \'Não se aplica\' }}</td><td class=\"ng-binding\">{{ p.isContaEscrow ? \'Sim\' : \'Não\' }}</td><td class=\"ng-binding\">{{ p.isDomicilioBancario ? \'Sim\' : \'Não\' }}</td><td class=\"ng-binding\">{{ p.statusCadastralDesc }}</td><td class=\"ng-binding\">{{ p.statusOperacionalDesc }}</td><td class=\"ng-binding\">{{ p.complemento.dataCartaAlterConta | date: \'dd/MM/yyyy HH:mm\' }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarConta(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button> <button ng-click=\"controller.gerarCarta(p)\" class=\"btn btn-success btn-xs\" ng-if=\"main.pentahoCodigoCliente == null\"><i class=\"fa fa-edit\"></i> Gerar Carta</button> <button ng-click=\"controller.gerarCartaExtrato(p)\" class=\"btn btn-warning btn-xs\" ng-if=\"main.pentahoCodigoCliente == null\"><i class=\"fa fa-edit\"></i> Carta Extrato</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarConta()\"><span><i class=\"fa fa-plus\"></i> Adicionar nova conta</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxIntegracao\', \'boxIntegracao\')\"><h5><i class=\"fa fa-send\"></i> Integração</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxIntegracao\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxIntegracao\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Código Cedente VMoney</label> <input type=\"number\" ng-model=\"controller.fornecedor.integracaoCodigoCedenteVMoney\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxUsuarios\', \'boxUsuarios\')\"><h5><i class=\"fa fa-users\"></i> Usuários</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxUsuarios\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxUsuarios\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Nome</th><th class=\"white-bg\">Usuário</th><th class=\"white-bg\">E-mail</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.usuarios\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.login }}</td><td class=\"ng-binding\">{{ p.email }}</td><td class=\"ng-binding\">Ativo</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarUsuario(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarUsuario()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo usuário</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button cg-busy=\"controller.aberturaContaPromise\" ng-if=\"controller.contas != null && controller.contas.length == 0\" class=\"btn btn-md btn-warning\" type=\"button\" ng-click=\"controller.solicitarAberturaConta()\"><i class=\"fa fa-clock-o\"></i> Solicitar Abertura de Conta</button> <button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/old/cadastro/sacado/cadastro/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Sacado</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.sacado.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-warning\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.sacado.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.sacado.endereco.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Concluir</button></div></div></div></div></div>");
$templateCache.put("app/old/cadastro/sacado/consulta/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Consultar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Sacado</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.sacado.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-warning\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.sacado.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.sacado.endereco.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-users\"></i> Usuários</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContaBancaria\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Nome</th><th class=\"white-bg\">Usuário</th><th class=\"white-bg\">E-mail</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.usuarios\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.login }}</td><td class=\"ng-binding\">{{ p.email }}</td><td class=\"ng-binding\">Ativo</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarUsuario(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarUsuario()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo usuário</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/old/cadastro/intermediador/consulta/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Consultar Intermediador</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Intermediador</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Intermediador</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.intermediador.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.intermediador.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-warning\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.intermediador.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.intermediador.endereco.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox collapsed float-e-margins\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-users\"></i> Usuários</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxContaBancaria\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Nome</th><th class=\"white-bg\">Usuário</th><th class=\"white-bg\">E-mail</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.usuarios\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.login }}</td><td class=\"ng-binding\">{{ p.email }}</td><td class=\"ng-binding\">Ativo</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarUsuario(p)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.adicionarUsuario()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo usuário</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/old/cadastro/intermediador/cadastro/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Intermediador</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Intermediador</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Intermediador</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.intermediador.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.intermediador.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-warning\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.intermediador.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.intermediador.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><estado-select model=\"controller.intermediador.endereco.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Concluir</button></div></div></div></div></div>");
$templateCache.put("app/old/financeiro/gestao_contas/analisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Analisar Lançamento</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Gestão de Contas</a></li><li class=\"active\"><strong>Analisar</strong></li></ol></div><div class=\"col-lg-3\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\" cg-busy=\"controller.listarPromise\"><div class=\"col-lg-5\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-tags\"></i> Previsão de Créditos</h5></div><div class=\"ibox-content\"><p><b>Fornecedor:</b> {{controller.registro.fornecedor.cnpj}} - {{controller.registro.fornecedor.razaoSocial}}<br><b>Sacado:</b> {{controller.registro.sacado.cnpj}} - {{controller.registro.sacado.razaoSocial}}<br><b>Data Referência:</b> {{controller.registro.dataMovimento | date:\'dd/MM/yyyy\'}}<br><b>Lançamentos Previstos:</b> {{controller.totalTitulos | currency:\'R$ \'}}</p><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Título</th><th>NFe</th><th>Vencimento</th><th>Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.titulos\"><td><input icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"p.selecionado\"></td><td>{{p.number}}</td><td>{{p.invoiceNumber}}</td><td>{{p.maturityDate}}</td><td>{{p.amount | currency:\'R$ \'}}</td></tr></tbody></table><div><span style=\"font-weight: bold;\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}}</span></div></div></div></div></div><div class=\"col-lg-7\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\"><h5><i class=\"fa fa-bank\"></i> Conta Corrente</h5></div><div class=\"ibox-content\"><p><b>Banco:</b> {{controller.registro.contaFebraban}}<br><b>Conta:</b> Ag. {{controller.registro.contaAgencia}} - C/C: {{controller.registro.contaPagamento}}<br><b>Saldo Disponível:</b> {{controller.saldoDisponivel | currency:\'R$ \'}}<br><b>Saldo Bloqueado:</b> {{controller.saldoBloqueado | currency:\'R$ \'}}</p><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Data do Movimento</th><th>Tipo</th><th>Remetente</th><th>Valor</th></tr></thead><tbody><tr><td>{{controller.registro.dataMovimento | date:\'dd/MM/yyyy HH:mm\'}}</td><td>Crédito</td><td>{{controller.registro.sacado.razaoSocial}}</td><td>{{controller.registro.valorMovimento | currency:\'R$ \'}}</td><td style=\"width: 1px;\"><a class=\"btn btn-xs btn-success\" ng-click=\"controller.confirmar(controller.registro)\">Confirmar</a></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Extrato da Conta Corrente</label> <input type=\"date\" ng-model=\"controller.filtro.dataExtratoDe\" class=\"form-control\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.dataExtratoAte\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><br><br><button ng-click=\"controller.pesquisarExtrato()\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-search\"></i> Consultar</button></div></div></div><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Data do Movimento</th><th>Tipo</th><th>Descrição</th><th>Origem</th><th>Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.extrato.movimentos\" ng-if=\"p.dtMovimento != null\"><td>{{p.dtMovimento | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{p.tipoLancamento == \'C\' ? \'Crédito\' : p.tipoLancamento }}</td><td>{{p.descricaoOperacao}}</td><td>{{p.descCliente}}</td><td>{{p.vlrMovimento | currency:\'R$ \' }}</td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/old/fornecedor/modal/cadastrar_empresa/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Empresa Coligada/Controlada</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.empresa.razaoSocial\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.empresa.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Sócios</label> <input type=\"text\" ng-model=\"controller.empresa.socios\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data Fundação</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.empresa.dataFundacao\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">% Participação</label> <input type=\"number\" ng-model=\"controller.empresa.percentualParticipacao\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Entrada</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.empresa.dataEntrada\" class=\"form-control\"></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\" ng-if=\"controller.empresa.viewId == null\"><i class=\"fa fa-send\"></i> Incluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\" ng-if=\"controller.empresa.viewId != null\"><i class=\"fa fa-send\"></i> Atualizar</button></div>");
$templateCache.put("app/old/fornecedor/modal/cadastrar_socio/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\" style=\"padding-top: 10px; padding-bottom: 10px;\"><h5 class=\"modal-title\">{{ controller.tipoPessoa }}</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\" style=\"padding-bottom: 5px;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.pessoa.nome\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Nascimento</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.dataNascimento\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Entrada</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.dataEntrada\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.pessoa.cpf\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">RG/Emissor/UF ou RNE</label> <input type=\"text\" ng-model=\"controller.pessoa.rg\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.pessoa.email\" class=\"form-control normal-text\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">% Participação</label> <input type=\"number\" ng-model=\"controller.pessoa.percentualParticipacao\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Assina pela empresa?</label><select class=\"form-control\" ng-model=\"controller.pessoa.assinaPelaEmpresaText\"><option value=\"1\" selected=\"\">Sim</option><option value=\"2\">Não</option></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.pessoa.telefone1\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Celular</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.pessoa.celular\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Banco/Agência/Contato/Fone</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.referenciaBanco1\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Pessoais Contato/Fone/Parentesco</label> <textarea ng-model=\"controller.pessoa.referenciaPessoal1\" class=\"form-control\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-change=\"controller.consultarCep()\" ng-model=\"controller.pessoa.enderecoDados.cep\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.logradouro\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.numero\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.complemento\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.bairro\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.cidade\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><estado-select model=\"controller.pessoa.enderecoDados.uf\" style=\"border: 0px solid red;\"></estado-select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Pai</label> <input type=\"text\" ng-model=\"controller.pessoa.nomePai\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome da Mãe</label> <input type=\"text\" ng-model=\"controller.pessoa.nomeMae\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Conjugê</label> <input type=\"text\" ng-model=\"controller.pessoa.conjugeNome\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.pessoa.conjugeCpf\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Regime</label> <input type=\"text\" ng-model=\"controller.pessoa.conjugeRegime\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">RG/Emissor/UF ou RNE</label> <input type=\"text\" ng-model=\"controller.pessoa.conjugeRg\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.conjugeData\" class=\"form-control unstyled\"></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Patrimônio Imóveis (Descrição/Valor/Metragem)</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.patrimonioImoveis\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Patrimônio Móveis (Descrição/Valor)</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.patrimonioMoveis\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Faixa de Renda Mensal</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.faixaRendaMensal\" class=\"form-control\"></textarea></div></div></div><div class=\"row\" ng-if=\"controller.pessoa.viewId != null\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Documentos</th><th class=\"white-bg\" style=\"width: 50px;\">Arquivo</th></tr></thead><tbody><tr class=\"ng-scope\"><td class=\"ng-binding\">Cadastro Pessoa Física</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(1)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq1 != \'\'\" style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq1)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Documento de Identificação (RG e CPF)</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(2)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq2 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq2)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Comprovante de Residência até 90 dias</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(3)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq3 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq3)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Certidão de Casamento (separação total de bens)</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(4)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq4 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq4)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Certidão de Casamento com Averbação (divorciado)</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(5)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq5 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq5)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Certidão de Óbito (viúvo)</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(6)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq6 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq6)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Declaração PPE - Pessoa Politicamente Exposta</td><td><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" style=\"margin-bottom: 0px;\"><span class=\"btn btn-xs btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Selecionar Arquivo</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(7)\" name=\"...\"></span> <span class=\"fileinput-filename\" style=\"display: none;\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none; display: none\">×</a></div></div></td><td ng-if=\"controller.arquivos.arq7 != \'\'\"><button ng-click=\"controller.getDocumento(controller.arquivos.arq7)\" class=\"btn btn-primary btn-xs btn-block\"><i class=\"fa fa-download\"></i> Download</button></td></tr></tbody></table></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\" ng-if=\"controller.pessoa.viewId == null\"><i class=\"fa fa-send\"></i> Incluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\" ng-if=\"controller.pessoa.viewId != null\"><i class=\"fa fa-check\"></i> Atualizar</button></div>");
$templateCache.put("app/old/nfe/recebiveis/faturas/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Títulos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Fornecedor</a></li><li><a>NFe\'s</a></li><li class=\"active\"><strong>Títulos</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">N° NFe</label> <input type=\"text\" ng-model=\"controller.filtro.nfe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Título</label> <input type=\"text\" ng-model=\"controller.filtro.titulo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" ng-model=\"controller.filtro.fornecedor\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <input type=\"text\" ng-model=\"controller.filtro.sacado\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Vencimento</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" ng-model=\"controller.filtro.valorDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"number\" ng-model=\"controller.filtro.valorAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Status</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisa()\"><option ng-value=\"1\">Disponíveis</option><option ng-value=\"2\">Em negociação</option><option ng-value=\"3\">Já negociados</option></select></div></div></div><div class=\"row\" style=\"display: none;\"><div class=\"col-sm-12\"><button class=\"btn btn-success pull-right\" ng-click=\"controller.pesquisar()\"><span class=\"fa fa-search\"></span> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Títulos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div><table class=\"table table-bordered\" style=\"margin-bottom: 0px;\"><thead><tr><th style=\"width: 1px;\"></th><th ng-click=\"controller.ordenarResultado(\'nfe\')\" style=\"white-space: nowrap;\">Nº NFe<i ng-if=\"controller.orderSelected == \'nfe\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"white-space: nowrap;\">Nº Título<i ng-if=\"controller.orderSelected == \'titulo\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado<i ng-if=\"controller.orderSelected == \'sacado\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'fornecedor\')\">Fornecedor<i ng-if=\"controller.orderSelected == \'fornecedor\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\">Vencimento<i ng-if=\"controller.orderSelected == \'vencimento\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'valor\')\">Valor<i ng-if=\"controller.orderSelected == \'valor\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th>Status</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"width: 1px;\"><input ng-if=\"p.status == 1\" icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"p.selecionadoAntecipar\"> <input ng-if=\"p.status != 1\" disabled=\"\" icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"p.selecionadoAntecipar\"></td><td>{{p.numero}}</td><td>{{p.titulo}}</td><td title=\"{{p.sacado}}\">{{p.sacado | limitTo: 30 }}{{p.sacado.length > 30 ? \'...\' : \'\'}}</td><td title=\"{{p.fornecedor}}\">{{p.fornecedor | limitTo: 35 }}{{p.fornecedor.length > 35 ? \'...\' : \'\'}}</td><td>{{p.dataVencimentoDate | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td><td ng-if=\"p.status == 1\" style=\"width: 1px;\"><btn class=\"btn btn-success btn-xs\">DISPONÍVEL</btn></td><td ng-if=\"p.status == 2\" style=\"width: 1px;\"><btn class=\"btn btn-warning btn-xs\">EM NEGOCIAÇÃO</btn></td><td ng-if=\"p.status == 3\" style=\"width: 1px;\"><btn class=\"btn btn-primary btn-xs\">JÁ NEGOCIADO</btn></td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><button class=\"btn btn-warning btn-xs\" ng-click=\"controller.consultarTitulo(p)\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div><div><span style=\"font-weight: bold;\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}} <span ng-if=\"controller.total.valorTotal > 0\">em {{controller.total.quantidade}} título{{(controller.total.quantidade > 1 ? \'s \' : \'\')}} selecionado{{(controller.total.quantidade > 1 ? \'s \' : \'\')}}</span></span></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\"><button ng-click=\"controller.marcarTodos()\" class=\"btn btn-md btn-success\" type=\"button\"><i class=\"fa fa-check-square\"></i> MARCAR TODOS</button> <button ng-click=\"controller.desmarcarTodos()\" class=\"btn btn-md btn-warning\" type=\"button\"><i class=\"fa fa-minus-square\"></i> DESMARCAR TODOS</button></div><div class=\"col-lg-6\" style=\"text-align: right;\"><button ng-click=\"controller.anteciparRegistros()\" class=\"btn btn-md btn-primary\" type=\"button\"><i class=\"fa fa-arrow-right\"></i> ANTECIPAR SELECIONADOS</button></div></div></div></div></div></div></div>");
$templateCache.put("app/cadastro/cedente/consultar/usuario/consulta/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Usuário</h5><small class=\"font-bold\">Detalhes do usuário selecionado.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"password\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-send\"></i> Atualizar</button> <button type=\"button\" class=\"btn btn-md btn-danger\" ng-click=\"controller.excluir()\"><i class=\"fa fa-trash\"></i> Excluir</button></div>");
$templateCache.put("app/cadastro/cedente/consultar/usuario/cadastro/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Novo Usuário</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"password\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-send\"></i> Incluir</button></div>");
$templateCache.put("app/cadastro/cedente/consultar/conta/cadastro/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Conta Bancária</h5><small class=\"font-bold\">Informe os dados para cadastro de uma nova conta.</small></div><div class=\"modal-body\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Banco</label><div class=\"col-lg-10\"><select class=\"form-control\" ng-model=\"controller.conta.bancoCodigo\"><option label=\"237 - Banco Bradesco S.A.\" value=\"237\">237 - Banco Bradesco S.A.</option><option label=\"341 - Banco Itaú S.A.\" value=\"341\">341 - Banco Itaú S.A.</option><option label=\"001 - Banco do Brasil S.A.\" value=\"1\">001 - Banco do Brasil S.A.</option><option label=\"033 - Banco Santander S.A.\" value=\"33\">033 - Banco Santander S.A.</option></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Agência</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"4\" ng-model=\"controller.conta.agencia\" class=\"form-control\"></div><label class=\"col-lg-2 control-label\">Dígito Ag.</label><div class=\"col-lg-3\"><input type=\"text\" maxlength=\"1\" ng-model=\"controller.conta.agenciaDigito\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">C/C</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"9\" ng-model=\"controller.conta.conta\" class=\"form-control\"></div><label class=\"col-lg-2 control-label\">Dígito C/C</label><div class=\"col-lg-3\"><input type=\"text\" maxlength=\"1\" ng-model=\"controller.conta.contaDigito\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Padrão</label><div class=\"col-lg-3\"><select class=\"form-control\" ng-model=\"controller.conta.isPadraoOperacaoNum\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.excluir()\" ng-if=\"!controller.isNovo\"><i class=\"fa fa-trash\"></i> Excluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\" ng-if=\"controller.isNovo\"><i class=\"fa fa-plus\"></i> Incluir conta</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.alterar()\" ng-if=\"!controller.isNovo\"><i class=\"fa fa-plus\"></i> Atualizar conta</button></div>");
$templateCache.put("app/cadastro/cedente/consultar/conta/consulta/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Conta Bancária</h5><small class=\"font-bold\">Informe os dados para cadastro de uma nova conta.</small></div><div class=\"modal-body\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Sacado</label><div class=\"col-lg-10\"><input type=\"text\" class=\"form-control\" disabled=\"\" ng-model=\"controller.conta.sacadoDesc\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Banco</label><div class=\"col-lg-10\"><select class=\"form-control\" ng-model=\"controller.conta.bancoCodigo\"><option label=\"237 - Banco Bradesco S.A.\" value=\"237\">237 - Banco Bradesco S.A.</option><option label=\"341 - Banco Itaú S.A.\" value=\"341\">341 - Banco Itaú S.A.</option><option label=\"001 - Banco do Brasil S.A.\" value=\"1\">001 - Banco do Brasil S.A.</option><option label=\"033 - Banco Santander S.A.\" value=\"33\">033 - Banco Santander S.A.</option><option label=\"274 - Banco Money Plus\" value=\"274\">274 - Banco Money Plus</option></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Agência</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"4\" ng-model=\"controller.conta.agencia\" class=\"form-control\"></div><label class=\"col-lg-2 control-label\">Dígito Ag.</label><div class=\"col-lg-3\"><input type=\"text\" maxlength=\"1\" ng-model=\"controller.conta.agenciaDigito\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">C/C</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"9\" ng-model=\"controller.conta.conta\" class=\"form-control\"></div><label class=\"col-lg-2 control-label\">Dígito C/C</label><div class=\"col-lg-3\"><input type=\"text\" maxlength=\"1\" ng-model=\"controller.conta.contaDigito\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Status Cadastral</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.conta.statusCadastralCodigo\"><option value=\"1\">Conta Corrente - Não Informada</option><option value=\"2\">Conta Corrente - Em Abertura</option><option value=\"3\">Conta Corrente - Aberta</option></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Status Operacional</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.conta.statusOperacionalCodigo\"><option value=\"1\">Aguardando Aprovação</option><option value=\"2\">Aprovado</option><option value=\"3\">Reprovado</option><option value=\"4\">Cancelado</option><option value=\"5\">Aguardando Cedente Retornar a Carta</option></select></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-plus\"></i> Atualizar conta</button></div>");
$templateCache.put("app/cadastro/sacado/consulta/usuario/cadastro/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Novo Usuário</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-send\"></i> Incluir</button></div>");
$templateCache.put("app/cadastro/sacado/consulta/usuario/consulta/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Usuário</h5><small class=\"font-bold\">Detalhes do usuário selecionado.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-4\"><input type=\"text\" ng-model=\"controller.usuario.login\" class=\"form-control normal-text\"></div><label class=\"col-lg-1 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-send\"></i> Atualizar</button></div>");
$templateCache.put("app/email/carteira/dinamica/itau/boletovencido/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Boleto</h5></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div class=\"col-sm-6\"><button class=\"btn btn-primary btn-block\" ng-click=\"controller.visualizarBoleto()\">Boleto Original</button></div><div class=\"col-sm-6\"><form method=\"POST\" action=\"https://ww2.itau.com.br/2viabloq/pesquisa.asp\" name=\"form\" target=\"novajanela\"><input type=\"hidden\" name=\"DC\" value=\"{{controller.codigo}}\"> <input type=\"submit\" class=\"btn btn-success btn-block\" name=\"2via\" value=\"Boleto Atualizado\"></form></div></div><br></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/invoice/operacao/titulos/modal/lote/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Criar Operação</h5><small class=\"font-bold\">Revise os dados para iniciar a operação de antecipação.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Operação</label><select class=\"form-control\"><option value=\"0\">Normal</option></select></div></div><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Originador</label><select class=\"form-control\" ng-change=\"controller.listarContasOriginador()\" ng-model=\"controller.originador\" ng-options=\'item as (item.cnpj + \" - \" + item.nome + \" (\" + item.tipoText + \")\") for item in controller.originadores\'></select></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nº NFe</th><th>Título</th><th>Sacado</th><th>Vencimento</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registros\"><td>{{p.numero}}</td><td>{{p.titulo}}</td><td>{{p.sacado}}</td><td>{{p.dataVencimento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{p.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div><div><span style=\"font-weight: bold\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}} <span ng-if=\"controller.total.valorTotal > 0\">em {{controller.total.quantidade}} título{{(controller.total.quantidade > 1 ? \'s \' : \'\')}} selecionado{{(controller.total.quantidade > 1 ? \'s \' : \'\')}}</span></span><br><br></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.enviar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/invoice/operacao/negociacao/modal/formacredito/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Adicionar Forma de Crédito</h5><small class=\"font-bold\">Informe os dados da forma de crédito da operação.</small></div><div class=\"modal-body\" style=\"padding: 10px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo</label><select class=\"form-control\" ng-model=\"controller.tipoFormaCredito\"><option ng-value=\"1\">TED</option><option ng-value=\"4\">Cheque</option><option ng-value=\"5\">Dinheiro</option></select></div></div><div class=\"col-sm-8\" ng-if=\"controller.tipoFormaCredito == 1 || controller.tipoFormaCredito == 2\"><div class=\"form-group\"><label class=\"col-form-label\">Conta</label><select class=\"form-control\" ng-model=\"controller.contaSelecionada\" ng-options=\'item as (item.bancoTexto + \" - \" + \"Ag: \" + item.agencia + \" Conta: \" + item.numero) for item in controller.contas\'></select></div></div><div class=\"col-sm-8\" ng-if=\"controller.tipoFormaCredito == 4\"><div class=\"form-group\"><label class=\"col-form-label\">Favorecido</label> <input type=\"text\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label><div class=\"input-group\"><input type=\"text\" money-mask=\"\" ng-model=\"controller.valorTotal\" class=\"form-control\"> <span class=\"input-group-addon\">$</span></div></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.adicionar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/invoice/operacao/negociacao/modal/contagrafica/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Débitos e Créditos</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 10px; padding-top: 20px;\" cg-busy=\"controller.listarExtratoPromise\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th class=\"white-bg\">Descrição</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Presente Débito</th><th class=\"white-bg\">Presente Crédito</th><th class=\"white-bg\">Selecionados</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.cedenteContaGraficaGrupos\"><td class=\"ng-binding\">{{p.descricao}}</td><td class=\"ng-binding\">{{p.quantidade}}</td><td class=\"ng-binding\" style=\"color: red;\">{{p.presenteDebito | currency:\'R$ \' }}</td><td class=\"ng-binding\" style=\"color: blue;\">{{p.presenteCredito | currency:\'R$ \' }}</td><td class=\"ng-binding\" ng-style=\"p.selecionadosTotal < 0 && {\'color\':\'red\'} || p.selecionadosTotal > 0 && {\'color\':\'blue\'}\">{{p.selecionadosTotal | currency:\'R$ \' }} ({{p.selecionados}})</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-click=\"controller.detalharItem(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Total Débito</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.totalDebito | currency:\'R$ \' }}\" class=\"form-control inputDisabledModal\" style=\"background-color: white !important;\"></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Total Crédito</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.totalCredito | currency:\'R$ \' }}\" class=\"form-control inputDisabledModal\" style=\"background-color: white !important;\"></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Saldo</label><div class=\"input-group\"><input type=\"text\" disabled=\"\" value=\"{{ controller.totalSaldo | currency:\'R$ \' }}\" class=\"form-control inputDisabledModal\" style=\"background-color: white !important;\"></div></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.adicionar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/old/cadastro/fornecedor/modal/carta_comunicacao_alteracao_conta/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Comunicação de Alteração de Conta</h5><small class=\"font-bold\">Geração do formulário de comunicação de alteração de conta do fornecedor.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-12\" ng-if=\"controller.fileFichaCadastralPDF != null\"><iframe src=\"{{controller.fileFichaCadastralPDF}}\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/old/cadastro/fornecedor/modal/carta_extrato_seguradora/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Carta Extrato</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-12\" ng-if=\"controller.fileFichaCadastralPDF != null\"><iframe src=\"{{controller.fileFichaCadastralPDF}}\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/old/cadastro/fornecedor/consulta/conta/consulta/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Conta Bancária</h5><small class=\"font-bold\">Informe os dados para cadastro de uma nova conta.</small></div><div class=\"modal-body\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Sacado</label><div class=\"col-lg-10\"><input type=\"text\" class=\"form-control\" disabled=\"\" ng-model=\"controller.conta.sacadoDesc\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Banco</label><div class=\"col-lg-10\"><select class=\"form-control\" ng-model=\"controller.conta.bancoCodigo\"><option label=\"237 - Banco Bradesco S.A.\" value=\"237\">237 - Banco Bradesco S.A.</option><option label=\"341 - Banco Itaú S.A.\" value=\"341\">341 - Banco Itaú S.A.</option><option label=\"001 - Banco do Brasil S.A.\" value=\"1\">001 - Banco do Brasil S.A.</option><option label=\"033 - Banco Santander S.A.\" value=\"33\">033 - Banco Santander S.A.</option><option label=\"274 - Banco Money Plus\" value=\"274\">274 - Banco Money Plus</option></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Agência</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"4\" ng-model=\"controller.conta.agencia\" class=\"form-control\"></div><label class=\"col-lg-2 control-label\">Dígito Ag.</label><div class=\"col-lg-3\"><input type=\"text\" maxlength=\"1\" ng-model=\"controller.conta.agenciaDigito\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">C/C</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"9\" ng-model=\"controller.conta.conta\" class=\"form-control\"></div><label class=\"col-lg-2 control-label\">Dígito C/C</label><div class=\"col-lg-3\"><input type=\"text\" maxlength=\"1\" ng-model=\"controller.conta.contaDigito\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Status Cadastral</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.conta.statusCadastralCodigo\"><option value=\"1\">Conta Corrente - Não Informada</option><option value=\"2\">Conta Corrente - Em Abertura</option><option value=\"3\">Conta Corrente - Aberta</option></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Status Operacional</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.conta.statusOperacionalCodigo\"><option value=\"1\">Aguardando Aprovação</option><option value=\"2\">Aprovado</option><option value=\"3\">Reprovado</option><option value=\"4\">Cancelado</option><option value=\"5\">Aguardando Cedente Retornar a Carta</option></select></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-plus\"></i> Atualizar conta</button></div>");
$templateCache.put("app/old/cadastro/fornecedor/consulta/conta/cadastro/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Conta Bancária</h5><small class=\"font-bold\">Informe os dados para cadastro de uma nova conta.</small></div><div class=\"modal-body\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Tipo de Conta</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.conta.tipoConta\"><option value=\"1\">Conta Corrente do Cedente</option><option value=\"2\">Conta Corrente de Terceiros</option></select></div><label class=\"col-lg-2 control-label\">Conta Escrow</label><div class=\"col-lg-3\"><select class=\"form-control\" ng-model=\"controller.conta.isContaEscrow\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div></div><div class=\"form-group\" ng-if=\"controller.conta.tipoConta == 2\"><label class=\"col-lg-2 control-label\">Titular</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"200\" ng-model=\"controller.conta.titularNome\" class=\"form-control\"></div><label class=\"col-lg-2 control-label\">CNPJ do Titular</label><div class=\"col-lg-3\"><input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.conta.titularCnpj\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Sacado</label><div class=\"col-lg-10\"><select class=\"form-control\" ng-model=\"controller.conta.sacado\" ng-options=\'item.viewId as (item.razaoSocial + \" - \" + item.cnpj) for item in controller.sacados\'></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Banco</label><div class=\"col-lg-10\"><select class=\"form-control\" ng-model=\"controller.conta.bancoCodigo\"><option label=\"237 - Banco Bradesco S.A.\" value=\"237\">237 - Banco Bradesco S.A.</option><option label=\"341 - Banco Itaú S.A.\" value=\"341\">341 - Banco Itaú S.A.</option><option label=\"001 - Banco do Brasil S.A.\" value=\"1\">001 - Banco do Brasil S.A.</option><option label=\"033 - Banco Santander S.A.\" value=\"33\">033 - Banco Santander S.A.</option><option label=\"274 - Banco Money Plus\" value=\"274\">274 - Banco Money Plus</option></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Agência</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"4\" ng-model=\"controller.conta.agencia\" class=\"form-control\"></div><label class=\"col-lg-2 control-label\">Dígito Ag.</label><div class=\"col-lg-3\"><input type=\"text\" maxlength=\"1\" ng-model=\"controller.conta.agenciaDigito\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">C/C</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"9\" ng-model=\"controller.conta.conta\" class=\"form-control\"></div><label class=\"col-lg-2 control-label\">Dígito C/C</label><div class=\"col-lg-3\"><input type=\"text\" maxlength=\"1\" ng-model=\"controller.conta.contaDigito\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Status Cadastral</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.conta.statusCadastralCodigo\"><option value=\"1\">Conta Corrente - Não Informada</option><option value=\"2\">Conta Corrente - Em Abertura</option><option value=\"3\">Conta Corrente - Aberta</option></select></div><label class=\"col-lg-2 control-label\">Domic. Bancário</label><div class=\"col-lg-3\"><select class=\"form-control\" ng-model=\"controller.conta.isDomicilioBancario\"><option value=\"0\">Não</option><option value=\"1\">Sim</option></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Status Operacional</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.conta.statusOperacionalCodigo\"><option value=\"1\">Aguardando Aprovação</option><option value=\"2\">Aprovado</option><option value=\"3\">Reprovado</option><option value=\"4\">Cancelado</option><option value=\"5\">Aguardando Cedente Retornar a Carta</option></select></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\" ng-if=\"controller.isNovo\"><i class=\"fa fa-plus\"></i> Incluir conta</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.alterar()\" ng-if=\"!controller.isNovo\"><i class=\"fa fa-plus\"></i> Atualizar conta</button></div>");
$templateCache.put("app/old/cadastro/fornecedor/consulta/usuario/cadastro/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Novo Usuário</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-4\"><input type=\"text\" ng-model=\"controller.usuario.login\" class=\"form-control normal-text\"></div><label class=\"col-lg-1 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-send\"></i> Incluir</button></div>");
$templateCache.put("app/old/cadastro/fornecedor/consulta/usuario/consulta/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Usuário</h5><small class=\"font-bold\">Detalhes do usuário selecionado.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-4\"><input type=\"text\" ng-model=\"controller.usuario.login\" class=\"form-control normal-text\"></div><label class=\"col-lg-1 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-send\"></i> Atualizar</button></div>");
$templateCache.put("app/old/cadastro/intermediador/consulta/usuario/consulta/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Usuário</h5><small class=\"font-bold\">Detalhes do usuário selecionado.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-4\"><input type=\"text\" ng-model=\"controller.usuario.login\" class=\"form-control normal-text\"></div><label class=\"col-lg-1 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-send\"></i> Atualizar</button></div>");
$templateCache.put("app/old/cadastro/sacado/consulta/usuario/consulta/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Usuário</h5><small class=\"font-bold\">Detalhes do usuário selecionado.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-4\"><input type=\"text\" ng-model=\"controller.usuario.login\" class=\"form-control normal-text\"></div><label class=\"col-lg-1 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-send\"></i> Atualizar</button></div>");
$templateCache.put("app/old/cadastro/sacado/consulta/usuario/cadastro/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Novo Usuário</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-4\"><input type=\"text\" ng-model=\"controller.usuario.login\" class=\"form-control normal-text\"></div><label class=\"col-lg-1 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-send\"></i> Incluir</button></div>");
$templateCache.put("app/old/nfe/recebiveis/faturas/modal/antecipar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Solicitar Nova Antecipação</h5><small class=\"font-bold\">Revise os dados para iniciar a operação de antecipação.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nº NFe</th><th>Título</th><th>Sacado</th><th>Vencimento</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registros\"><td>{{p.numero}}</td><td>{{p.titulo}}</td><td>{{p.sacado}}</td><td>{{p.dataVencimento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{p.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div><div><span style=\"font-weight: bold\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}} <span ng-if=\"controller.total.valorTotal > 0\">em {{controller.total.quantidade}} título{{(controller.total.quantidade > 1 ? \'s \' : \'\')}} selecionado{{(controller.total.quantidade > 1 ? \'s \' : \'\')}}</span></span><br><br></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.enviar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/old/cadastro/intermediador/consulta/usuario/cadastro/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Novo Usuário</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-4\"><input type=\"text\" ng-model=\"controller.usuario.login\" class=\"form-control normal-text\"></div><label class=\"col-lg-1 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control normal-text\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-send\"></i> Incluir</button></div>");
$templateCache.put("app/old/nfe/recebiveis/faturas/modal/detalhar_titulo/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Detalhes do Título</h5><small class=\"font-bold\">Informações detalhadas do título selecionado.</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">N° Nfe</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.titulo.invoiceNumber\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">N° Título</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.number}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.supplier.name}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ do Fornecedor</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.supplier.identification}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.payer.name}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ do Sacado</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.payer.identification}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Emissão</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.dataIssueDate | date: \'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Fatura</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.invoiceDate | date: \'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Vencimento</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.dataMaturityDate | date: \'dd/MM/yyyy\'}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Chave de Acesso da NF-e</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.invoiceKey }}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.amount | currency:\'R$ \'}}\"></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");}]);